var Wh = Object.defineProperty;
var sc = (t) => {
  throw TypeError(t);
};
var Gh = (t, e, n) => e in t ? Wh(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var bn = (t, e, n) => Gh(t, typeof e != "symbol" ? e + "" : e, n), Zh = (t, e, n) => e.has(t) || sc("Cannot " + n);
var oc = (t, e, n) => e.has(t) ? sc("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(t) : e.set(t, n);
var ac = (t, e, n) => (Zh(t, e, "access private method"), n);
import { FontAwesomeIcon as is } from "@fortawesome/vue-fontawesome";
import { computed as A, toValue as an, getCurrentInstance as En, withCtx as C, hasInjectionContext as Kh, ref as N, readonly as Tn, toRef as _t, watchEffect as re, markRaw as ds, nextTick as ol, defineComponent as J, renderSlot as St, createCommentVNode as Q, unref as l, createRenderer as Xh, camelize as sd, provide as ps, h as Qh, watch as it, onMounted as od, onUnmounted as al, warn as ad, toRefs as we, createBlock as q, openBlock as $, createElementBlock as I, createElementVNode as x, normalizeStyle as Kt, createVNode as b, Fragment as me, inject as id, shallowRef as Jh, mergeModels as Ae, useModel as Ne, resolveComponent as xe, withModifiers as rs, Transition as De, mergeProps as Na, createTextVNode as he, toDisplayString as L, reactive as rd, renderList as Se, normalizeClass as ke, isRef as Lt, createStaticVNode as ld, withDirectives as mt, withKeys as la, vModelText as vn, createSlots as Er, useTemplateRef as Ds, resolveDynamicComponent as il, vModelRadio as po, TransitionGroup as Yh, vShow as ef, defineCustomElement as tf } from "vue";
import { useIdle as cd, useDevicePixelRatio as nf, useDebounceFn as sf, useTimeoutFn as ic, useConfirmDialog as of, toRef as af, useStorage as rf, useMousePressed as ud, useMouseInElement as dd, clamp as Or, toRefs as lf, useFocus as pd, useEyeDropper as cf, useScroll as md, useDropZone as uf, useFileDialog as df, watchDebounced as pf, useMediaQuery as mf, useTimeout as hf, useResizeObserver as rc } from "@vueuse/core";
import { defineStore as st, storeToRefs as D, createPinia as ff } from "pinia";
import { useMutation as yt, useQueryClient as lt, useQuery as bt, useInfiniteQuery as js, VueQueryPlugin as _f } from "@tanstack/vue-query";
import * as vf from "pixi.js";
import { Ticker as gf, Container as hd, Rectangle as ca, Point as $t, ExtensionType as fd, LoaderParserPriority as kf, Text as _d, TilingSprite as yf, Sprite as vd, RenderLayer as bf, RenderContainer as wf, PerspectiveMesh as xf, ParticleContainer as $f, NineSliceSprite as zf, NineSlicePlane as Sf, MeshSimple as Af, MeshRope as Cf, MeshPlane as Pf, Mesh as Mf, HTMLText as Tf, Graphics as If, BitmapText as Ef, AnimatedSprite as Of, extensions as Rf, Application as Lf, AbstractText as Df, Texture as gd, WorkerManager as lc, loadImageBitmap as jf, ImageSource as Nf, getResolutionOfUrl as Vf, createTexture as Uf, GraphicsContext as fa, Assets as cc, WebGPURenderer as Ff, WebGLRenderer as Bf } from "pixi.js";
import { useI18n as ct, I18nT as uc, createI18n as qf, I18nInjectionKey as Hf } from "vue-i18n";
import { setTag as kd, startSpan as Wf, setUser as Gf } from "@sentry/vue";
import { ToastRoot as Zf, DialogTitle as At, DialogRoot as Ct, DialogTrigger as yd, DialogPortal as Pt, DialogOverlay as Mt, DialogContent as Tt, Primitive as Kf, DialogClose as zt, SelectItem as bd, SelectItemText as wd, SelectRoot as xd, SelectTrigger as $d, SelectValue as zd, SelectIcon as Xf, SelectPortal as Sd, SelectContent as Ad, SelectViewport as Cd, TabsTrigger as Pd, TooltipProvider as Qf, TooltipRoot as Jf, TooltipTrigger as Yf, TooltipPortal as e_, TooltipContent as t_, TooltipArrow as n_, SelectScrollDownButton as s_, PopoverRoot as Md, PopoverTrigger as Td, PopoverPortal as Id, PopoverContent as Ed, PopoverClose as Od, PopoverArrow as o_, TabsRoot as rl, TabsList as ll, TabsContent as mo, VisuallyHidden as a_, AccordionRoot as i_, AccordionItem as r_, AccordionHeader as l_, AccordionTrigger as c_, AccordionContent as u_, DialogDescription as d_, CollapsibleRoot as p_, CollapsibleContent as m_, CollapsibleTrigger as h_, RadioGroupItem as f_, RadioGroupIndicator as __, RadioGroupRoot as v_, TabsIndicator as g_, SliderRoot as k_, SliderTrack as y_, SliderThumb as b_, ToastProvider as w_, ToastViewport as x_ } from "radix-vue";
import { klona as Wn } from "klona";
import { extendTailwindMerge as $_ } from "tailwind-merge";
import { vInfiniteScroll as $o } from "@vueuse/components";
import { findIconDefinition as z_, config as S_, library as A_ } from "@fortawesome/fontawesome-svg-core";
class Hn extends Error {
  constructor(n, s, o) {
    const a = n.status || n.status === 0 ? n.status : "", i = n.statusText || "", r = `${a} ${i}`.trim(), c = r ? `status code ${r}` : "an unknown error";
    super(`Request failed with ${c}: ${s.method} ${s.url}`);
    bn(this, "response");
    bn(this, "request");
    bn(this, "options");
    this.name = "HTTPError", this.response = n, this.request = s, this.options = o;
  }
}
class Rd extends Error {
  constructor(n) {
    super(`Request timed out: ${n.method} ${n.url}`);
    bn(this, "request");
    this.name = "TimeoutError", this.request = n;
  }
}
const dc = (() => {
  let t = !1, e = !1;
  const n = typeof globalThis.ReadableStream == "function", s = typeof globalThis.Request == "function";
  if (n && s)
    try {
      e = new globalThis.Request("https://empty.invalid", {
        body: new globalThis.ReadableStream(),
        method: "POST",
        // @ts-expect-error - Types are outdated.
        get duplex() {
          return t = !0, "half";
        }
      }).headers.has("Content-Type");
    } catch (o) {
      if (o instanceof Error && o.message === "unsupported BodyInit type")
        return !1;
      throw o;
    }
  return t && !e;
})(), C_ = typeof globalThis.AbortController == "function", P_ = typeof globalThis.AbortSignal == "function" && typeof globalThis.AbortSignal.any == "function", M_ = typeof globalThis.ReadableStream == "function", T_ = typeof globalThis.FormData == "function", Ld = ["get", "post", "put", "patch", "head", "delete"], I_ = {
  json: "application/json",
  text: "text/*",
  formData: "multipart/form-data",
  arrayBuffer: "*/*",
  blob: "*/*",
  // Supported in modern Fetch implementations (for example, browsers and recent Node.js/undici).
  // We still feature-check at runtime before exposing the shortcut.
  bytes: "*/*"
}, yi = 2147483647, E_ = new TextEncoder().encode("------WebKitFormBoundaryaxpyiPgbbPti10Rw").length, Dd = Symbol("stop"), O_ = {
  json: !0,
  parseJson: !0,
  stringifyJson: !0,
  searchParams: !0,
  prefixUrl: !0,
  retry: !0,
  timeout: !0,
  hooks: !0,
  throwHttpErrors: !0,
  onDownloadProgress: !0,
  onUploadProgress: !0,
  fetch: !0
}, R_ = {
  method: !0,
  headers: !0,
  body: !0,
  mode: !0,
  credentials: !0,
  cache: !0,
  redirect: !0,
  referrer: !0,
  referrerPolicy: !0,
  integrity: !0,
  keepalive: !0,
  signal: !0,
  window: !0,
  dispatcher: !0,
  duplex: !0,
  priority: !0
}, L_ = (t) => {
  if (!t)
    return 0;
  if (t instanceof FormData) {
    let e = 0;
    for (const [n, s] of t)
      e += E_, e += new TextEncoder().encode(`Content-Disposition: form-data; name="${n}"`).length, e += typeof s == "string" ? new TextEncoder().encode(s).length : s.size;
    return e;
  }
  if (t instanceof Blob)
    return t.size;
  if (t instanceof ArrayBuffer)
    return t.byteLength;
  if (typeof t == "string")
    return new TextEncoder().encode(t).length;
  if (t instanceof URLSearchParams)
    return new TextEncoder().encode(t.toString()).length;
  if ("byteLength" in t)
    return t.byteLength;
  if (typeof t == "object" && t !== null)
    try {
      const e = JSON.stringify(t);
      return new TextEncoder().encode(e).length;
    } catch {
      return 0;
    }
  return 0;
}, D_ = (t, e) => {
  const n = Number(t.headers.get("content-length")) || 0;
  let s = 0;
  return t.status === 204 ? (e && e({ percent: 1, totalBytes: n, transferredBytes: s }, new Uint8Array()), new Response(null, {
    status: t.status,
    statusText: t.statusText,
    headers: t.headers
  })) : new Response(new ReadableStream({
    async start(o) {
      const a = t.body.getReader();
      e && e({ percent: 0, transferredBytes: 0, totalBytes: n }, new Uint8Array());
      async function i() {
        const { done: r, value: c } = await a.read();
        if (r) {
          o.close();
          return;
        }
        if (e) {
          s += c.byteLength;
          const u = n === 0 ? 0 : s / n;
          e({ percent: u, transferredBytes: s, totalBytes: n }, c);
        }
        o.enqueue(c), await i();
      }
      await i();
    }
  }), {
    status: t.status,
    statusText: t.statusText,
    headers: t.headers
  });
}, j_ = (t, e, n) => {
  const s = L_(n ?? t.body);
  let o = 0;
  return new Request(t, {
    // @ts-expect-error - Types are outdated.
    duplex: "half",
    body: new ReadableStream({
      async start(a) {
        const i = t.body instanceof ReadableStream ? t.body.getReader() : new Response("").body.getReader();
        async function r() {
          const { done: c, value: u } = await i.read();
          if (c) {
            e && e({ percent: 1, transferredBytes: o, totalBytes: Math.max(s, o) }, new Uint8Array()), a.close();
            return;
          }
          o += u.byteLength;
          let d = s === 0 ? 0 : o / s;
          (s < o || d === 1) && (d = 0.99), e && e({ percent: Number(d.toFixed(2)), transferredBytes: o, totalBytes: s }, u), a.enqueue(u), await r();
        }
        await r();
      }
    })
  });
}, lo = (t) => t !== null && typeof t == "object", Yo = (...t) => {
  for (const e of t)
    if ((!lo(e) || Array.isArray(e)) && e !== void 0)
      throw new TypeError("The `options` argument must be an object");
  return cl({}, ...t);
}, jd = (t = {}, e = {}) => {
  const n = new globalThis.Headers(t), s = e instanceof globalThis.Headers, o = new globalThis.Headers(e);
  for (const [a, i] of o.entries())
    s && i === "undefined" || i === void 0 ? n.delete(a) : n.set(a, i);
  return n;
};
function ea(t, e, n) {
  return Object.hasOwn(e, n) && e[n] === void 0 ? [] : cl(t[n] ?? [], e[n] ?? []);
}
const Nd = (t = {}, e = {}) => ({
  beforeRequest: ea(t, e, "beforeRequest"),
  beforeRetry: ea(t, e, "beforeRetry"),
  afterResponse: ea(t, e, "afterResponse"),
  beforeError: ea(t, e, "beforeError")
}), cl = (...t) => {
  let e = {}, n = {}, s = {};
  for (const o of t)
    if (Array.isArray(o))
      Array.isArray(e) || (e = []), e = [...e, ...o];
    else if (lo(o)) {
      for (let [a, i] of Object.entries(o))
        lo(i) && a in e && (i = cl(e[a], i)), e = { ...e, [a]: i };
      lo(o.hooks) && (s = Nd(s, o.hooks), e.hooks = s), lo(o.headers) && (n = jd(n, o.headers), e.headers = n);
    }
  return e;
}, N_ = (t) => Ld.includes(t) ? t.toUpperCase() : t, V_ = ["get", "put", "head", "delete", "options", "trace"], U_ = [408, 413, 429, 500, 502, 503, 504], F_ = [413, 429, 503], pc = {
  limit: 2,
  methods: V_,
  statusCodes: U_,
  afterStatusCodes: F_,
  maxRetryAfter: Number.POSITIVE_INFINITY,
  backoffLimit: Number.POSITIVE_INFINITY,
  delay: (t) => 0.3 * 2 ** (t - 1) * 1e3
}, B_ = (t = {}) => {
  if (typeof t == "number")
    return {
      ...pc,
      limit: t
    };
  if (t.methods && !Array.isArray(t.methods))
    throw new Error("retry.methods must be an array");
  if (t.statusCodes && !Array.isArray(t.statusCodes))
    throw new Error("retry.statusCodes must be an array");
  return {
    ...pc,
    ...t
  };
};
async function q_(t, e, n, s) {
  return new Promise((o, a) => {
    const i = setTimeout(() => {
      n && n.abort(), a(new Rd(t));
    }, s.timeout);
    s.fetch(t, e).then(o).catch(a).then(() => {
      clearTimeout(i);
    });
  });
}
async function H_(t, { signal: e }) {
  return new Promise((n, s) => {
    e && (e.throwIfAborted(), e.addEventListener("abort", o, { once: !0 }));
    function o() {
      clearTimeout(a), s(e.reason);
    }
    const a = setTimeout(() => {
      e == null || e.removeEventListener("abort", o), n();
    }, t);
  });
}
const W_ = (t, e) => {
  const n = {};
  for (const s in e)
    !(s in R_) && !(s in O_) && !(s in t) && (n[s] = e[s]);
  return n;
}, G_ = (t) => t === void 0 ? !1 : Array.isArray(t) ? t.length > 0 : t instanceof URLSearchParams ? t.size > 0 : typeof t == "object" ? Object.keys(t).length > 0 : typeof t == "string" ? t.trim().length > 0 : !!t;
var ja, Vd;
const _o = class _o {
  // eslint-disable-next-line complexity
  constructor(e, n = {}) {
    bn(this, "request");
    bn(this, "abortController");
    bn(this, "_retryCount", 0);
    bn(this, "_input");
    bn(this, "_options");
    var s, o, a;
    if (this._input = e, this._options = {
      ...n,
      headers: jd(this._input.headers, n.headers),
      hooks: Nd({
        beforeRequest: [],
        beforeRetry: [],
        beforeError: [],
        afterResponse: []
      }, n.hooks),
      method: N_(n.method ?? this._input.method ?? "GET"),
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      prefixUrl: String(n.prefixUrl || ""),
      retry: B_(n.retry),
      throwHttpErrors: n.throwHttpErrors !== !1,
      timeout: n.timeout ?? 1e4,
      fetch: n.fetch ?? globalThis.fetch.bind(globalThis)
    }, typeof this._input != "string" && !(this._input instanceof URL || this._input instanceof globalThis.Request))
      throw new TypeError("`input` must be a string, URL, or Request");
    if (this._options.prefixUrl && typeof this._input == "string") {
      if (this._input.startsWith("/"))
        throw new Error("`input` must not begin with a slash when using `prefixUrl`");
      this._options.prefixUrl.endsWith("/") || (this._options.prefixUrl += "/"), this._input = this._options.prefixUrl + this._input;
    }
    if (C_ && P_) {
      const i = this._options.signal ?? this._input.signal;
      this.abortController = new globalThis.AbortController(), this._options.signal = i ? AbortSignal.any([i, this.abortController.signal]) : this.abortController.signal;
    }
    if (dc && (this._options.duplex = "half"), this._options.json !== void 0 && (this._options.body = ((o = (s = this._options).stringifyJson) == null ? void 0 : o.call(s, this._options.json)) ?? JSON.stringify(this._options.json), this._options.headers.set("content-type", this._options.headers.get("content-type") ?? "application/json")), this.request = new globalThis.Request(this._input, this._options), G_(this._options.searchParams)) {
      const r = "?" + (typeof this._options.searchParams == "string" ? this._options.searchParams.replace(/^\?/, "") : new URLSearchParams(ac(a = _o, ja, Vd).call(a, this._options.searchParams)).toString()), c = this.request.url.replace(/(?:\?.*?)?(?=#|$)/, r);
      (T_ && this._options.body instanceof globalThis.FormData || this._options.body instanceof URLSearchParams) && !(this._options.headers && this._options.headers["content-type"]) && this.request.headers.delete("content-type"), this.request = new globalThis.Request(new globalThis.Request(c, { ...this.request }), this._options);
    }
    if (this._options.onUploadProgress) {
      if (typeof this._options.onUploadProgress != "function")
        throw new TypeError("The `onUploadProgress` option must be a function");
      if (!dc)
        throw new Error("Request streams are not supported in your environment. The `duplex` option for `Request` is not available.");
      this.request.body && (this.request = j_(this.request, this._options.onUploadProgress, this._options.body));
    }
  }
  static create(e, n) {
    var r, c;
    const s = new _o(e, n), o = async () => {
      if (typeof s._options.timeout == "number" && s._options.timeout > yi)
        throw new RangeError(`The \`timeout\` option cannot be greater than ${yi}`);
      await Promise.resolve();
      let u = await s._fetch();
      for (const d of s._options.hooks.afterResponse) {
        const m = await d(s.request, s._options, s._decorateResponse(u.clone()));
        m instanceof globalThis.Response && (u = m);
      }
      if (s._decorateResponse(u), !u.ok && s._options.throwHttpErrors) {
        let d = new Hn(u, s.request, s._options);
        for (const m of s._options.hooks.beforeError)
          d = await m(d);
        throw d;
      }
      if (s._options.onDownloadProgress) {
        if (typeof s._options.onDownloadProgress != "function")
          throw new TypeError("The `onDownloadProgress` option must be a function");
        if (!M_)
          throw new Error("Streams are not supported in your environment. `ReadableStream` is missing.");
        return D_(u.clone(), s._options.onDownloadProgress);
      }
      return u;
    }, i = (s._options.retry.methods.includes(s.request.method.toLowerCase()) ? s._retry(o) : o()).finally(async () => {
      var u;
      s.request.bodyUsed || await ((u = s.request.body) == null ? void 0 : u.cancel());
    });
    for (const [u, d] of Object.entries(I_))
      u === "bytes" && typeof ((c = (r = globalThis.Response) == null ? void 0 : r.prototype) == null ? void 0 : c.bytes) != "function" || (i[u] = async () => {
        s.request.headers.set("accept", s.request.headers.get("accept") || d);
        const m = await i;
        if (u === "json") {
          if (m.status === 204)
            return "";
          const _ = await m.text();
          return _ === "" ? "" : n.parseJson ? n.parseJson(_) : JSON.parse(_);
        }
        return m[u]();
      });
    return i;
  }
  _calculateRetryDelay(e) {
    if (this._retryCount++, this._retryCount > this._options.retry.limit || e instanceof Rd)
      throw e;
    if (e instanceof Hn) {
      if (!this._options.retry.statusCodes.includes(e.response.status))
        throw e;
      const s = e.response.headers.get("Retry-After") ?? e.response.headers.get("RateLimit-Reset") ?? e.response.headers.get("X-RateLimit-Reset") ?? e.response.headers.get("X-Rate-Limit-Reset");
      if (s && this._options.retry.afterStatusCodes.includes(e.response.status)) {
        let o = Number(s) * 1e3;
        Number.isNaN(o) ? o = Date.parse(s) - Date.now() : o >= Date.parse("2024-01-01") && (o -= Date.now());
        const a = this._options.retry.maxRetryAfter ?? o;
        return o < a ? o : a;
      }
      if (e.response.status === 413)
        throw e;
    }
    const n = this._options.retry.delay(this._retryCount);
    return Math.min(this._options.retry.backoffLimit, n);
  }
  _decorateResponse(e) {
    return this._options.parseJson && (e.json = async () => this._options.parseJson(await e.text())), e;
  }
  async _retry(e) {
    try {
      return await e();
    } catch (n) {
      const s = Math.min(this._calculateRetryDelay(n), yi);
      if (this._retryCount < 1)
        throw n;
      await H_(s, { signal: this._options.signal });
      for (const o of this._options.hooks.beforeRetry)
        if (await o({
          request: this.request,
          options: this._options,
          error: n,
          retryCount: this._retryCount
        }) === Dd)
          return;
      return this._retry(e);
    }
  }
  async _fetch() {
    for (const s of this._options.hooks.beforeRequest) {
      const o = await s(this.request, this._options);
      if (o instanceof Request) {
        this.request = o;
        break;
      }
      if (o instanceof Response)
        return o;
    }
    const e = W_(this.request, this._options), n = this.request;
    return this.request = n.clone(), this._options.timeout === !1 ? this._options.fetch(n, e) : q_(n, e, this.abortController, this._options);
  }
};
ja = new WeakSet(), Vd = function(e) {
  return e && typeof e == "object" && !Array.isArray(e) && !(e instanceof URLSearchParams) ? Object.fromEntries(Object.entries(e).filter(([, n]) => n !== void 0)) : e;
}, oc(_o, ja);
let _a = _o;
/*! MIT License © Sindre Sorhus */
const Rr = (t) => {
  const e = (n, s) => _a.create(n, Yo(t, s));
  for (const n of Ld)
    e[n] = (s, o) => _a.create(s, Yo(t, o, { method: n }));
  return e.create = (n) => Rr(Yo(n)), e.extend = (n) => (typeof n == "function" && (n = n(t ?? {})), Rr(Yo(t, n))), e.stop = Dd, e;
}, Ud = Rr();
var mc = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Fd(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function Z_(t) {
  if (Object.prototype.hasOwnProperty.call(t, "__esModule")) return t;
  var e = t.default;
  if (typeof e == "function") {
    var n = function s() {
      return this instanceof s ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    n.prototype = e.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(t).forEach(function(s) {
    var o = Object.getOwnPropertyDescriptor(t, s);
    Object.defineProperty(n, s, o.get ? o : {
      enumerable: !0,
      get: function() {
        return t[s];
      }
    });
  }), n;
}
var bi, hc;
function Ns() {
  return hc || (hc = 1, bi = TypeError), bi;
}
const K_ = {}, X_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: K_
}, Symbol.toStringTag, { value: "Module" })), Q_ = /* @__PURE__ */ Z_(X_);
var wi, fc;
function Va() {
  if (fc) return wi;
  fc = 1;
  var t = typeof Map == "function" && Map.prototype, e = Object.getOwnPropertyDescriptor && t ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, n = t && e && typeof e.get == "function" ? e.get : null, s = t && Map.prototype.forEach, o = typeof Set == "function" && Set.prototype, a = Object.getOwnPropertyDescriptor && o ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, i = o && a && typeof a.get == "function" ? a.get : null, r = o && Set.prototype.forEach, c = typeof WeakMap == "function" && WeakMap.prototype, u = c ? WeakMap.prototype.has : null, d = typeof WeakSet == "function" && WeakSet.prototype, m = d ? WeakSet.prototype.has : null, _ = typeof WeakRef == "function" && WeakRef.prototype, g = _ ? WeakRef.prototype.deref : null, v = Boolean.prototype.valueOf, z = Object.prototype.toString, h = Function.prototype.toString, y = String.prototype.match, w = String.prototype.slice, P = String.prototype.replace, M = String.prototype.toUpperCase, E = String.prototype.toLowerCase, R = RegExp.prototype.test, j = Array.prototype.concat, V = Array.prototype.join, X = Array.prototype.slice, Z = Math.floor, ae = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, K = Object.getOwnPropertySymbols, te = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, ue = typeof Symbol == "function" && typeof Symbol.iterator == "object", Ce = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === ue || !0) ? Symbol.toStringTag : null, ne = Object.prototype.propertyIsEnumerable, ee = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(F) {
    return F.__proto__;
  } : null);
  function G(F, H) {
    if (F === 1 / 0 || F === -1 / 0 || F !== F || F && F > -1e3 && F < 1e3 || R.call(/e/, H))
      return H;
    var qe = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof F == "number") {
      var Ke = F < 0 ? -Z(-F) : Z(F);
      if (Ke !== F) {
        var Fe = String(Ke), Le = w.call(H, Fe.length + 1);
        return P.call(Fe, qe, "$&_") + "." + P.call(P.call(Le, /([0-9]{3})/g, "$&_"), /_$/, "");
      }
    }
    return P.call(H, qe, "$&_");
  }
  var oe = Q_, _e = oe.custom, de = dt(_e) ? _e : null, $e = {
    __proto__: null,
    double: '"',
    single: "'"
  }, Ze = {
    __proto__: null,
    double: /(["\\])/g,
    single: /(['\\])/g
  };
  wi = function F(H, qe, Ke, Fe) {
    var Le = qe || {};
    if (Nt(Le, "quoteStyle") && !Nt($e, Le.quoteStyle))
      throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if (Nt(Le, "maxStringLength") && (typeof Le.maxStringLength == "number" ? Le.maxStringLength < 0 && Le.maxStringLength !== 1 / 0 : Le.maxStringLength !== null))
      throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var qt = Nt(Le, "customInspect") ? Le.customInspect : !0;
    if (typeof qt != "boolean" && qt !== "symbol")
      throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if (Nt(Le, "indent") && Le.indent !== null && Le.indent !== "	" && !(parseInt(Le.indent, 10) === Le.indent && Le.indent > 0))
      throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if (Nt(Le, "numericSeparator") && typeof Le.numericSeparator != "boolean")
      throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var An = Le.numericSeparator;
    if (typeof H > "u")
      return "undefined";
    if (H === null)
      return "null";
    if (typeof H == "boolean")
      return H ? "true" : "false";
    if (typeof H == "string")
      return Fo(H, Le);
    if (typeof H == "number") {
      if (H === 0)
        return 1 / 0 / H > 0 ? "0" : "-0";
      var Vt = String(H);
      return An ? G(H, Vt) : Vt;
    }
    if (typeof H == "bigint") {
      var hn = String(H) + "n";
      return An ? G(H, hn) : hn;
    }
    var $s = typeof Le.depth > "u" ? 5 : Le.depth;
    if (typeof Ke > "u" && (Ke = 0), Ke >= $s && $s > 0 && typeof H == "object")
      return ut(H) ? "[Array]" : "[Object]";
    var Cn = Qs(Le, Ke);
    if (typeof Fe > "u")
      Fe = [];
    else if (kn(Fe, H) >= 0)
      return "[Circular]";
    function Yt(yn, Nn, di) {
      if (Nn && (Fe = X.call(Fe), Fe.push(Nn)), di) {
        var Ko = {
          depth: Le.depth
        };
        return Nt(Le, "quoteStyle") && (Ko.quoteStyle = Le.quoteStyle), F(yn, Ko, Ke + 1, Fe);
      }
      return F(yn, Le, Ke + 1, Fe);
    }
    if (typeof H == "function" && !Ve(H)) {
      var qo = Ln(H), Ho = xs(H, Yt);
      return "[Function" + (qo ? ": " + qo : " (anonymous)") + "]" + (Ho.length > 0 ? " { " + V.call(Ho, ", ") + " }" : "");
    }
    if (dt(H)) {
      var Yn = ue ? P.call(String(H), /^(Symbol\(.*\))_[^)]*$/, "$1") : te.call(H);
      return typeof H == "object" && !ue ? Qn(Yn) : Yn;
    }
    if (ri(H)) {
      for (var es = "<" + E.call(String(H.nodeName)), zs = H.attributes || [], Ss = 0; Ss < zs.length; Ss++)
        es += " " + zs[Ss].name + "=" + Pe(ie(zs[Ss].value), "double", Le);
      return es += ">", H.childNodes && H.childNodes.length && (es += "..."), es += "</" + E.call(String(H.nodeName)) + ">", es;
    }
    if (ut(H)) {
      if (H.length === 0)
        return "[]";
      var Js = xs(H, Yt);
      return Cn && !ci(Js) ? "[" + Jn(Js, Cn) + "]" : "[ " + V.call(Js, ", ") + " ]";
    }
    if (fe(H)) {
      var Ys = xs(H, Yt);
      return !("cause" in Error.prototype) && "cause" in H && !ne.call(H, "cause") ? "{ [" + String(H) + "] " + V.call(j.call("[cause]: " + Yt(H.cause), Ys), ", ") + " }" : Ys.length === 0 ? "[" + String(H) + "]" : "{ [" + String(H) + "] " + V.call(Ys, ", ") + " }";
    }
    if (typeof H == "object" && qt) {
      if (de && typeof H[de] == "function" && oe)
        return oe(H, { depth: $s - Ke });
      if (qt !== "symbol" && typeof H.inspect == "function")
        return H.inspect();
    }
    if (Jt(H)) {
      var Wo = [];
      return s && s.call(H, function(yn, Nn) {
        Wo.push(Yt(Nn, H, !0) + " => " + Yt(yn, H));
      }), Bo("Map", n.call(H), Wo, Cn);
    }
    if (jn(H)) {
      var Go = [];
      return r && r.call(H, function(yn) {
        Go.push(Yt(yn, H));
      }), Bo("Set", i.call(H), Go, Cn);
    }
    if (Dn(H))
      return Xs("WeakMap");
    if (nt(H))
      return Xs("WeakSet");
    if (mn(H))
      return Xs("WeakRef");
    if (Ue(H))
      return Qn(Yt(Number(H)));
    if (wt(H))
      return Qn(Yt(ae.call(H)));
    if (Ye(H))
      return Qn(v.call(H));
    if (Xe(H))
      return Qn(Yt(String(H)));
    if (typeof window < "u" && H === window)
      return "{ [object Window] }";
    if (typeof globalThis < "u" && H === globalThis || typeof mc < "u" && H === mc)
      return "{ [object globalThis] }";
    if (!ot(H) && !Ve(H)) {
      var eo = xs(H, Yt), to = ee ? ee(H) === Object.prototype : H instanceof Object || H.constructor === Object, fn = H instanceof Object ? "" : "null prototype", Zo = !to && Ce && Object(H) === H && Ce in H ? w.call(Bt(H), 8, -1) : fn ? "Object" : "", ui = to || typeof H.constructor != "function" ? "" : H.constructor.name ? H.constructor.name + " " : "", no = ui + (Zo || fn ? "[" + V.call(j.call([], Zo || [], fn || []), ": ") + "] " : "");
      return eo.length === 0 ? no + "{}" : Cn ? no + "{" + Jn(eo, Cn) + "}" : no + "{ " + V.call(eo, ", ") + " }";
    }
    return String(H);
  };
  function Pe(F, H, qe) {
    var Ke = qe.quoteStyle || H, Fe = $e[Ke];
    return Fe + F + Fe;
  }
  function ie(F) {
    return P.call(String(F), /"/g, "&quot;");
  }
  function ve(F) {
    return !Ce || !(typeof F == "object" && (Ce in F || typeof F[Ce] < "u"));
  }
  function ut(F) {
    return Bt(F) === "[object Array]" && ve(F);
  }
  function ot(F) {
    return Bt(F) === "[object Date]" && ve(F);
  }
  function Ve(F) {
    return Bt(F) === "[object RegExp]" && ve(F);
  }
  function fe(F) {
    return Bt(F) === "[object Error]" && ve(F);
  }
  function Xe(F) {
    return Bt(F) === "[object String]" && ve(F);
  }
  function Ue(F) {
    return Bt(F) === "[object Number]" && ve(F);
  }
  function Ye(F) {
    return Bt(F) === "[object Boolean]" && ve(F);
  }
  function dt(F) {
    if (ue)
      return F && typeof F == "object" && F instanceof Symbol;
    if (typeof F == "symbol")
      return !0;
    if (!F || typeof F != "object" || !te)
      return !1;
    try {
      return te.call(F), !0;
    } catch {
    }
    return !1;
  }
  function wt(F) {
    if (!F || typeof F != "object" || !ae)
      return !1;
    try {
      return ae.call(F), !0;
    } catch {
    }
    return !1;
  }
  var pt = Object.prototype.hasOwnProperty || function(F) {
    return F in this;
  };
  function Nt(F, H) {
    return pt.call(F, H);
  }
  function Bt(F) {
    return z.call(F);
  }
  function Ln(F) {
    if (F.name)
      return F.name;
    var H = y.call(h.call(F), /^function\s*([\w$]+)/);
    return H ? H[1] : null;
  }
  function kn(F, H) {
    if (F.indexOf)
      return F.indexOf(H);
    for (var qe = 0, Ke = F.length; qe < Ke; qe++)
      if (F[qe] === H)
        return qe;
    return -1;
  }
  function Jt(F) {
    if (!n || !F || typeof F != "object")
      return !1;
    try {
      n.call(F);
      try {
        i.call(F);
      } catch {
        return !0;
      }
      return F instanceof Map;
    } catch {
    }
    return !1;
  }
  function Dn(F) {
    if (!u || !F || typeof F != "object")
      return !1;
    try {
      u.call(F, u);
      try {
        m.call(F, m);
      } catch {
        return !0;
      }
      return F instanceof WeakMap;
    } catch {
    }
    return !1;
  }
  function mn(F) {
    if (!g || !F || typeof F != "object")
      return !1;
    try {
      return g.call(F), !0;
    } catch {
    }
    return !1;
  }
  function jn(F) {
    if (!i || !F || typeof F != "object")
      return !1;
    try {
      i.call(F);
      try {
        n.call(F);
      } catch {
        return !0;
      }
      return F instanceof Set;
    } catch {
    }
    return !1;
  }
  function nt(F) {
    if (!m || !F || typeof F != "object")
      return !1;
    try {
      m.call(F, m);
      try {
        u.call(F, u);
      } catch {
        return !0;
      }
      return F instanceof WeakSet;
    } catch {
    }
    return !1;
  }
  function ri(F) {
    return !F || typeof F != "object" ? !1 : typeof HTMLElement < "u" && F instanceof HTMLElement ? !0 : typeof F.nodeName == "string" && typeof F.getAttribute == "function";
  }
  function Fo(F, H) {
    if (F.length > H.maxStringLength) {
      var qe = F.length - H.maxStringLength, Ke = "... " + qe + " more character" + (qe > 1 ? "s" : "");
      return Fo(w.call(F, 0, H.maxStringLength), H) + Ke;
    }
    var Fe = Ze[H.quoteStyle || "single"];
    Fe.lastIndex = 0;
    var Le = P.call(P.call(F, Fe, "\\$1"), /[\x00-\x1f]/g, li);
    return Pe(Le, "single", H);
  }
  function li(F) {
    var H = F.charCodeAt(0), qe = {
      8: "b",
      9: "t",
      10: "n",
      12: "f",
      13: "r"
    }[H];
    return qe ? "\\" + qe : "\\x" + (H < 16 ? "0" : "") + M.call(H.toString(16));
  }
  function Qn(F) {
    return "Object(" + F + ")";
  }
  function Xs(F) {
    return F + " { ? }";
  }
  function Bo(F, H, qe, Ke) {
    var Fe = Ke ? Jn(qe, Ke) : V.call(qe, ", ");
    return F + " (" + H + ") {" + Fe + "}";
  }
  function ci(F) {
    for (var H = 0; H < F.length; H++)
      if (kn(F[H], `
`) >= 0)
        return !1;
    return !0;
  }
  function Qs(F, H) {
    var qe;
    if (F.indent === "	")
      qe = "	";
    else if (typeof F.indent == "number" && F.indent > 0)
      qe = V.call(Array(F.indent + 1), " ");
    else
      return null;
    return {
      base: qe,
      prev: V.call(Array(H + 1), qe)
    };
  }
  function Jn(F, H) {
    if (F.length === 0)
      return "";
    var qe = `
` + H.prev + H.base;
    return qe + V.call(F, "," + qe) + `
` + H.prev;
  }
  function xs(F, H) {
    var qe = ut(F), Ke = [];
    if (qe) {
      Ke.length = F.length;
      for (var Fe = 0; Fe < F.length; Fe++)
        Ke[Fe] = Nt(F, Fe) ? H(F[Fe], F) : "";
    }
    var Le = typeof K == "function" ? K(F) : [], qt;
    if (ue) {
      qt = {};
      for (var An = 0; An < Le.length; An++)
        qt["$" + Le[An]] = Le[An];
    }
    for (var Vt in F)
      Nt(F, Vt) && (qe && String(Number(Vt)) === Vt && Vt < F.length || ue && qt["$" + Vt] instanceof Symbol || (R.call(/[^\w$]/, Vt) ? Ke.push(H(Vt, F) + ": " + H(F[Vt], F)) : Ke.push(Vt + ": " + H(F[Vt], F))));
    if (typeof K == "function")
      for (var hn = 0; hn < Le.length; hn++)
        ne.call(F, Le[hn]) && Ke.push("[" + H(Le[hn]) + "]: " + H(F[Le[hn]], F));
    return Ke;
  }
  return wi;
}
var xi, _c;
function J_() {
  if (_c) return xi;
  _c = 1;
  var t = /* @__PURE__ */ Va(), e = /* @__PURE__ */ Ns(), n = function(r, c, u) {
    for (var d = r, m; (m = d.next) != null; d = m)
      if (m.key === c)
        return d.next = m.next, u || (m.next = /** @type {NonNullable<typeof list.next>} */
        r.next, r.next = m), m;
  }, s = function(r, c) {
    if (r) {
      var u = n(r, c);
      return u && u.value;
    }
  }, o = function(r, c, u) {
    var d = n(r, c);
    d ? d.value = u : r.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */
    {
      // eslint-disable-line no-param-reassign, no-extra-parens
      key: c,
      next: r.next,
      value: u
    };
  }, a = function(r, c) {
    return r ? !!n(r, c) : !1;
  }, i = function(r, c) {
    if (r)
      return n(r, c, !0);
  };
  return xi = function() {
    var c, u = {
      assert: function(d) {
        if (!u.has(d))
          throw new e("Side channel does not contain " + t(d));
      },
      delete: function(d) {
        var m = c && c.next, _ = i(c, d);
        return _ && m && m === _ && (c = void 0), !!_;
      },
      get: function(d) {
        return s(c, d);
      },
      has: function(d) {
        return a(c, d);
      },
      set: function(d, m) {
        c || (c = {
          next: void 0
        }), o(
          /** @type {NonNullable<typeof $o>} */
          c,
          d,
          m
        );
      }
    };
    return u;
  }, xi;
}
var $i, vc;
function Bd() {
  return vc || (vc = 1, $i = Object), $i;
}
var zi, gc;
function Y_() {
  return gc || (gc = 1, zi = Error), zi;
}
var Si, kc;
function ev() {
  return kc || (kc = 1, Si = EvalError), Si;
}
var Ai, yc;
function tv() {
  return yc || (yc = 1, Ai = RangeError), Ai;
}
var Ci, bc;
function nv() {
  return bc || (bc = 1, Ci = ReferenceError), Ci;
}
var Pi, wc;
function sv() {
  return wc || (wc = 1, Pi = SyntaxError), Pi;
}
var Mi, xc;
function ov() {
  return xc || (xc = 1, Mi = URIError), Mi;
}
var Ti, $c;
function av() {
  return $c || ($c = 1, Ti = Math.abs), Ti;
}
var Ii, zc;
function iv() {
  return zc || (zc = 1, Ii = Math.floor), Ii;
}
var Ei, Sc;
function rv() {
  return Sc || (Sc = 1, Ei = Math.max), Ei;
}
var Oi, Ac;
function lv() {
  return Ac || (Ac = 1, Oi = Math.min), Oi;
}
var Ri, Cc;
function cv() {
  return Cc || (Cc = 1, Ri = Math.pow), Ri;
}
var Li, Pc;
function uv() {
  return Pc || (Pc = 1, Li = Math.round), Li;
}
var Di, Mc;
function dv() {
  return Mc || (Mc = 1, Di = Number.isNaN || function(e) {
    return e !== e;
  }), Di;
}
var ji, Tc;
function pv() {
  if (Tc) return ji;
  Tc = 1;
  var t = /* @__PURE__ */ dv();
  return ji = function(n) {
    return t(n) || n === 0 ? n : n < 0 ? -1 : 1;
  }, ji;
}
var Ni, Ic;
function mv() {
  return Ic || (Ic = 1, Ni = Object.getOwnPropertyDescriptor), Ni;
}
var Vi, Ec;
function qd() {
  if (Ec) return Vi;
  Ec = 1;
  var t = /* @__PURE__ */ mv();
  if (t)
    try {
      t([], "length");
    } catch {
      t = null;
    }
  return Vi = t, Vi;
}
var Ui, Oc;
function hv() {
  if (Oc) return Ui;
  Oc = 1;
  var t = Object.defineProperty || !1;
  if (t)
    try {
      t({}, "a", { value: 1 });
    } catch {
      t = !1;
    }
  return Ui = t, Ui;
}
var Fi, Rc;
function fv() {
  return Rc || (Rc = 1, Fi = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var e = {}, n = Symbol("test"), s = Object(n);
    if (typeof n == "string" || Object.prototype.toString.call(n) !== "[object Symbol]" || Object.prototype.toString.call(s) !== "[object Symbol]")
      return !1;
    var o = 42;
    e[n] = o;
    for (var a in e)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(e).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(e).length !== 0)
      return !1;
    var i = Object.getOwnPropertySymbols(e);
    if (i.length !== 1 || i[0] !== n || !Object.prototype.propertyIsEnumerable.call(e, n))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var r = (
        /** @type {PropertyDescriptor} */
        Object.getOwnPropertyDescriptor(e, n)
      );
      if (r.value !== o || r.enumerable !== !0)
        return !1;
    }
    return !0;
  }), Fi;
}
var Bi, Lc;
function _v() {
  if (Lc) return Bi;
  Lc = 1;
  var t = typeof Symbol < "u" && Symbol, e = fv();
  return Bi = function() {
    return typeof t != "function" || typeof Symbol != "function" || typeof t("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : e();
  }, Bi;
}
var qi, Dc;
function Hd() {
  return Dc || (Dc = 1, qi = typeof Reflect < "u" && Reflect.getPrototypeOf || null), qi;
}
var Hi, jc;
function Wd() {
  if (jc) return Hi;
  jc = 1;
  var t = /* @__PURE__ */ Bd();
  return Hi = t.getPrototypeOf || null, Hi;
}
var Wi, Nc;
function vv() {
  if (Nc) return Wi;
  Nc = 1;
  var t = "Function.prototype.bind called on incompatible ", e = Object.prototype.toString, n = Math.max, s = "[object Function]", o = function(c, u) {
    for (var d = [], m = 0; m < c.length; m += 1)
      d[m] = c[m];
    for (var _ = 0; _ < u.length; _ += 1)
      d[_ + c.length] = u[_];
    return d;
  }, a = function(c, u) {
    for (var d = [], m = u, _ = 0; m < c.length; m += 1, _ += 1)
      d[_] = c[m];
    return d;
  }, i = function(r, c) {
    for (var u = "", d = 0; d < r.length; d += 1)
      u += r[d], d + 1 < r.length && (u += c);
    return u;
  };
  return Wi = function(c) {
    var u = this;
    if (typeof u != "function" || e.apply(u) !== s)
      throw new TypeError(t + u);
    for (var d = a(arguments, 1), m, _ = function() {
      if (this instanceof m) {
        var y = u.apply(
          this,
          o(d, arguments)
        );
        return Object(y) === y ? y : this;
      }
      return u.apply(
        c,
        o(d, arguments)
      );
    }, g = n(0, u.length - d.length), v = [], z = 0; z < g; z++)
      v[z] = "$" + z;
    if (m = Function("binder", "return function (" + i(v, ",") + "){ return binder.apply(this,arguments); }")(_), u.prototype) {
      var h = function() {
      };
      h.prototype = u.prototype, m.prototype = new h(), h.prototype = null;
    }
    return m;
  }, Wi;
}
var Gi, Vc;
function Ua() {
  if (Vc) return Gi;
  Vc = 1;
  var t = vv();
  return Gi = Function.prototype.bind || t, Gi;
}
var Zi, Uc;
function ul() {
  return Uc || (Uc = 1, Zi = Function.prototype.call), Zi;
}
var Ki, Fc;
function Gd() {
  return Fc || (Fc = 1, Ki = Function.prototype.apply), Ki;
}
var Xi, Bc;
function gv() {
  return Bc || (Bc = 1, Xi = typeof Reflect < "u" && Reflect && Reflect.apply), Xi;
}
var Qi, qc;
function kv() {
  if (qc) return Qi;
  qc = 1;
  var t = Ua(), e = Gd(), n = ul(), s = gv();
  return Qi = s || t.call(n, e), Qi;
}
var Ji, Hc;
function Zd() {
  if (Hc) return Ji;
  Hc = 1;
  var t = Ua(), e = /* @__PURE__ */ Ns(), n = ul(), s = kv();
  return Ji = function(a) {
    if (a.length < 1 || typeof a[0] != "function")
      throw new e("a function is required");
    return s(t, n, a);
  }, Ji;
}
var Yi, Wc;
function yv() {
  if (Wc) return Yi;
  Wc = 1;
  var t = Zd(), e = /* @__PURE__ */ qd(), n;
  try {
    n = /** @type {{ __proto__?: typeof Array.prototype }} */
    [].__proto__ === Array.prototype;
  } catch (i) {
    if (!i || typeof i != "object" || !("code" in i) || i.code !== "ERR_PROTO_ACCESS")
      throw i;
  }
  var s = !!n && e && e(
    Object.prototype,
    /** @type {keyof typeof Object.prototype} */
    "__proto__"
  ), o = Object, a = o.getPrototypeOf;
  return Yi = s && typeof s.get == "function" ? t([s.get]) : typeof a == "function" ? (
    /** @type {import('./get')} */
    function(r) {
      return a(r == null ? r : o(r));
    }
  ) : !1, Yi;
}
var er, Gc;
function bv() {
  if (Gc) return er;
  Gc = 1;
  var t = Hd(), e = Wd(), n = /* @__PURE__ */ yv();
  return er = t ? function(o) {
    return t(o);
  } : e ? function(o) {
    if (!o || typeof o != "object" && typeof o != "function")
      throw new TypeError("getProto: not an object");
    return e(o);
  } : n ? function(o) {
    return n(o);
  } : null, er;
}
var tr, Zc;
function wv() {
  if (Zc) return tr;
  Zc = 1;
  var t = Function.prototype.call, e = Object.prototype.hasOwnProperty, n = Ua();
  return tr = n.call(t, e), tr;
}
var nr, Kc;
function dl() {
  if (Kc) return nr;
  Kc = 1;
  var t, e = /* @__PURE__ */ Bd(), n = /* @__PURE__ */ Y_(), s = /* @__PURE__ */ ev(), o = /* @__PURE__ */ tv(), a = /* @__PURE__ */ nv(), i = /* @__PURE__ */ sv(), r = /* @__PURE__ */ Ns(), c = /* @__PURE__ */ ov(), u = /* @__PURE__ */ av(), d = /* @__PURE__ */ iv(), m = /* @__PURE__ */ rv(), _ = /* @__PURE__ */ lv(), g = /* @__PURE__ */ cv(), v = /* @__PURE__ */ uv(), z = /* @__PURE__ */ pv(), h = Function, y = function(Ve) {
    try {
      return h('"use strict"; return (' + Ve + ").constructor;")();
    } catch {
    }
  }, w = /* @__PURE__ */ qd(), P = /* @__PURE__ */ hv(), M = function() {
    throw new r();
  }, E = w ? (function() {
    try {
      return arguments.callee, M;
    } catch {
      try {
        return w(arguments, "callee").get;
      } catch {
        return M;
      }
    }
  })() : M, R = _v()(), j = bv(), V = Wd(), X = Hd(), Z = Gd(), ae = ul(), K = {}, te = typeof Uint8Array > "u" || !j ? t : j(Uint8Array), ue = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError > "u" ? t : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer > "u" ? t : ArrayBuffer,
    "%ArrayIteratorPrototype%": R && j ? j([][Symbol.iterator]()) : t,
    "%AsyncFromSyncIteratorPrototype%": t,
    "%AsyncFunction%": K,
    "%AsyncGenerator%": K,
    "%AsyncGeneratorFunction%": K,
    "%AsyncIteratorPrototype%": K,
    "%Atomics%": typeof Atomics > "u" ? t : Atomics,
    "%BigInt%": typeof BigInt > "u" ? t : BigInt,
    "%BigInt64Array%": typeof BigInt64Array > "u" ? t : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array > "u" ? t : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView > "u" ? t : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": n,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": s,
    "%Float16Array%": typeof Float16Array > "u" ? t : Float16Array,
    "%Float32Array%": typeof Float32Array > "u" ? t : Float32Array,
    "%Float64Array%": typeof Float64Array > "u" ? t : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? t : FinalizationRegistry,
    "%Function%": h,
    "%GeneratorFunction%": K,
    "%Int8Array%": typeof Int8Array > "u" ? t : Int8Array,
    "%Int16Array%": typeof Int16Array > "u" ? t : Int16Array,
    "%Int32Array%": typeof Int32Array > "u" ? t : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": R && j ? j(j([][Symbol.iterator]())) : t,
    "%JSON%": typeof JSON == "object" ? JSON : t,
    "%Map%": typeof Map > "u" ? t : Map,
    "%MapIteratorPrototype%": typeof Map > "u" || !R || !j ? t : j((/* @__PURE__ */ new Map())[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": e,
    "%Object.getOwnPropertyDescriptor%": w,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise > "u" ? t : Promise,
    "%Proxy%": typeof Proxy > "u" ? t : Proxy,
    "%RangeError%": o,
    "%ReferenceError%": a,
    "%Reflect%": typeof Reflect > "u" ? t : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set > "u" ? t : Set,
    "%SetIteratorPrototype%": typeof Set > "u" || !R || !j ? t : j((/* @__PURE__ */ new Set())[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? t : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": R && j ? j(""[Symbol.iterator]()) : t,
    "%Symbol%": R ? Symbol : t,
    "%SyntaxError%": i,
    "%ThrowTypeError%": E,
    "%TypedArray%": te,
    "%TypeError%": r,
    "%Uint8Array%": typeof Uint8Array > "u" ? t : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? t : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array > "u" ? t : Uint16Array,
    "%Uint32Array%": typeof Uint32Array > "u" ? t : Uint32Array,
    "%URIError%": c,
    "%WeakMap%": typeof WeakMap > "u" ? t : WeakMap,
    "%WeakRef%": typeof WeakRef > "u" ? t : WeakRef,
    "%WeakSet%": typeof WeakSet > "u" ? t : WeakSet,
    "%Function.prototype.call%": ae,
    "%Function.prototype.apply%": Z,
    "%Object.defineProperty%": P,
    "%Object.getPrototypeOf%": V,
    "%Math.abs%": u,
    "%Math.floor%": d,
    "%Math.max%": m,
    "%Math.min%": _,
    "%Math.pow%": g,
    "%Math.round%": v,
    "%Math.sign%": z,
    "%Reflect.getPrototypeOf%": X
  };
  if (j)
    try {
      null.error;
    } catch (Ve) {
      var Ce = j(j(Ve));
      ue["%Error.prototype%"] = Ce;
    }
  var ne = function Ve(fe) {
    var Xe;
    if (fe === "%AsyncFunction%")
      Xe = y("async function () {}");
    else if (fe === "%GeneratorFunction%")
      Xe = y("function* () {}");
    else if (fe === "%AsyncGeneratorFunction%")
      Xe = y("async function* () {}");
    else if (fe === "%AsyncGenerator%") {
      var Ue = Ve("%AsyncGeneratorFunction%");
      Ue && (Xe = Ue.prototype);
    } else if (fe === "%AsyncIteratorPrototype%") {
      var Ye = Ve("%AsyncGenerator%");
      Ye && j && (Xe = j(Ye.prototype));
    }
    return ue[fe] = Xe, Xe;
  }, ee = {
    __proto__: null,
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  }, G = Ua(), oe = /* @__PURE__ */ wv(), _e = G.call(ae, Array.prototype.concat), de = G.call(Z, Array.prototype.splice), $e = G.call(ae, String.prototype.replace), Ze = G.call(ae, String.prototype.slice), Pe = G.call(ae, RegExp.prototype.exec), ie = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, ve = /\\(\\)?/g, ut = function(fe) {
    var Xe = Ze(fe, 0, 1), Ue = Ze(fe, -1);
    if (Xe === "%" && Ue !== "%")
      throw new i("invalid intrinsic syntax, expected closing `%`");
    if (Ue === "%" && Xe !== "%")
      throw new i("invalid intrinsic syntax, expected opening `%`");
    var Ye = [];
    return $e(fe, ie, function(dt, wt, pt, Nt) {
      Ye[Ye.length] = pt ? $e(Nt, ve, "$1") : wt || dt;
    }), Ye;
  }, ot = function(fe, Xe) {
    var Ue = fe, Ye;
    if (oe(ee, Ue) && (Ye = ee[Ue], Ue = "%" + Ye[0] + "%"), oe(ue, Ue)) {
      var dt = ue[Ue];
      if (dt === K && (dt = ne(Ue)), typeof dt > "u" && !Xe)
        throw new r("intrinsic " + fe + " exists, but is not available. Please file an issue!");
      return {
        alias: Ye,
        name: Ue,
        value: dt
      };
    }
    throw new i("intrinsic " + fe + " does not exist!");
  };
  return nr = function(fe, Xe) {
    if (typeof fe != "string" || fe.length === 0)
      throw new r("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof Xe != "boolean")
      throw new r('"allowMissing" argument must be a boolean');
    if (Pe(/^%?[^%]*%?$/, fe) === null)
      throw new i("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var Ue = ut(fe), Ye = Ue.length > 0 ? Ue[0] : "", dt = ot("%" + Ye + "%", Xe), wt = dt.name, pt = dt.value, Nt = !1, Bt = dt.alias;
    Bt && (Ye = Bt[0], de(Ue, _e([0, 1], Bt)));
    for (var Ln = 1, kn = !0; Ln < Ue.length; Ln += 1) {
      var Jt = Ue[Ln], Dn = Ze(Jt, 0, 1), mn = Ze(Jt, -1);
      if ((Dn === '"' || Dn === "'" || Dn === "`" || mn === '"' || mn === "'" || mn === "`") && Dn !== mn)
        throw new i("property names with quotes must have matching quotes");
      if ((Jt === "constructor" || !kn) && (Nt = !0), Ye += "." + Jt, wt = "%" + Ye + "%", oe(ue, wt))
        pt = ue[wt];
      else if (pt != null) {
        if (!(Jt in pt)) {
          if (!Xe)
            throw new r("base intrinsic for " + fe + " exists, but the property is not available.");
          return;
        }
        if (w && Ln + 1 >= Ue.length) {
          var jn = w(pt, Jt);
          kn = !!jn, kn && "get" in jn && !("originalValue" in jn.get) ? pt = jn.get : pt = pt[Jt];
        } else
          kn = oe(pt, Jt), pt = pt[Jt];
        kn && !Nt && (ue[wt] = pt);
      }
    }
    return pt;
  }, nr;
}
var sr, Xc;
function Kd() {
  if (Xc) return sr;
  Xc = 1;
  var t = /* @__PURE__ */ dl(), e = Zd(), n = e([t("%String.prototype.indexOf%")]);
  return sr = function(o, a) {
    var i = (
      /** @type {(this: unknown, ...args: unknown[]) => unknown} */
      t(o, !!a)
    );
    return typeof i == "function" && n(o, ".prototype.") > -1 ? e(
      /** @type {const} */
      [i]
    ) : i;
  }, sr;
}
var or, Qc;
function Xd() {
  if (Qc) return or;
  Qc = 1;
  var t = /* @__PURE__ */ dl(), e = /* @__PURE__ */ Kd(), n = /* @__PURE__ */ Va(), s = /* @__PURE__ */ Ns(), o = t("%Map%", !0), a = e("Map.prototype.get", !0), i = e("Map.prototype.set", !0), r = e("Map.prototype.has", !0), c = e("Map.prototype.delete", !0), u = e("Map.prototype.size", !0);
  return or = !!o && /** @type {Exclude<import('.'), false>} */
  function() {
    var m, _ = {
      assert: function(g) {
        if (!_.has(g))
          throw new s("Side channel does not contain " + n(g));
      },
      delete: function(g) {
        if (m) {
          var v = c(m, g);
          return u(m) === 0 && (m = void 0), v;
        }
        return !1;
      },
      get: function(g) {
        if (m)
          return a(m, g);
      },
      has: function(g) {
        return m ? r(m, g) : !1;
      },
      set: function(g, v) {
        m || (m = new o()), i(m, g, v);
      }
    };
    return _;
  }, or;
}
var ar, Jc;
function xv() {
  if (Jc) return ar;
  Jc = 1;
  var t = /* @__PURE__ */ dl(), e = /* @__PURE__ */ Kd(), n = /* @__PURE__ */ Va(), s = Xd(), o = /* @__PURE__ */ Ns(), a = t("%WeakMap%", !0), i = e("WeakMap.prototype.get", !0), r = e("WeakMap.prototype.set", !0), c = e("WeakMap.prototype.has", !0), u = e("WeakMap.prototype.delete", !0);
  return ar = a ? (
    /** @type {Exclude<import('.'), false>} */
    function() {
      var m, _, g = {
        assert: function(v) {
          if (!g.has(v))
            throw new o("Side channel does not contain " + n(v));
        },
        delete: function(v) {
          if (a && v && (typeof v == "object" || typeof v == "function")) {
            if (m)
              return u(m, v);
          } else if (s && _)
            return _.delete(v);
          return !1;
        },
        get: function(v) {
          return a && v && (typeof v == "object" || typeof v == "function") && m ? i(m, v) : _ && _.get(v);
        },
        has: function(v) {
          return a && v && (typeof v == "object" || typeof v == "function") && m ? c(m, v) : !!_ && _.has(v);
        },
        set: function(v, z) {
          a && v && (typeof v == "object" || typeof v == "function") ? (m || (m = new a()), r(m, v, z)) : s && (_ || (_ = s()), _.set(v, z));
        }
      };
      return g;
    }
  ) : s, ar;
}
var ir, Yc;
function $v() {
  if (Yc) return ir;
  Yc = 1;
  var t = /* @__PURE__ */ Ns(), e = /* @__PURE__ */ Va(), n = J_(), s = Xd(), o = xv(), a = o || s || n;
  return ir = function() {
    var r, c = {
      assert: function(u) {
        if (!c.has(u))
          throw new t("Side channel does not contain " + e(u));
      },
      delete: function(u) {
        return !!r && r.delete(u);
      },
      get: function(u) {
        return r && r.get(u);
      },
      has: function(u) {
        return !!r && r.has(u);
      },
      set: function(u, d) {
        r || (r = a()), r.set(u, d);
      }
    };
    return c;
  }, ir;
}
var rr, eu;
function pl() {
  if (eu) return rr;
  eu = 1;
  var t = String.prototype.replace, e = /%20/g, n = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
  };
  return rr = {
    default: n.RFC3986,
    formatters: {
      RFC1738: function(s) {
        return t.call(s, e, "+");
      },
      RFC3986: function(s) {
        return String(s);
      }
    },
    RFC1738: n.RFC1738,
    RFC3986: n.RFC3986
  }, rr;
}
var lr, tu;
function Qd() {
  if (tu) return lr;
  tu = 1;
  var t = /* @__PURE__ */ pl(), e = Object.prototype.hasOwnProperty, n = Array.isArray, s = (function() {
    for (var h = [], y = 0; y < 256; ++y)
      h.push("%" + ((y < 16 ? "0" : "") + y.toString(16)).toUpperCase());
    return h;
  })(), o = function(y) {
    for (; y.length > 1; ) {
      var w = y.pop(), P = w.obj[w.prop];
      if (n(P)) {
        for (var M = [], E = 0; E < P.length; ++E)
          typeof P[E] < "u" && M.push(P[E]);
        w.obj[w.prop] = M;
      }
    }
  }, a = function(y, w) {
    for (var P = w && w.plainObjects ? { __proto__: null } : {}, M = 0; M < y.length; ++M)
      typeof y[M] < "u" && (P[M] = y[M]);
    return P;
  }, i = function h(y, w, P) {
    if (!w)
      return y;
    if (typeof w != "object" && typeof w != "function") {
      if (n(y))
        y.push(w);
      else if (y && typeof y == "object")
        (P && (P.plainObjects || P.allowPrototypes) || !e.call(Object.prototype, w)) && (y[w] = !0);
      else
        return [y, w];
      return y;
    }
    if (!y || typeof y != "object")
      return [y].concat(w);
    var M = y;
    return n(y) && !n(w) && (M = a(y, P)), n(y) && n(w) ? (w.forEach(function(E, R) {
      if (e.call(y, R)) {
        var j = y[R];
        j && typeof j == "object" && E && typeof E == "object" ? y[R] = h(j, E, P) : y.push(E);
      } else
        y[R] = E;
    }), y) : Object.keys(w).reduce(function(E, R) {
      var j = w[R];
      return e.call(E, R) ? E[R] = h(E[R], j, P) : E[R] = j, E;
    }, M);
  }, r = function(y, w) {
    return Object.keys(w).reduce(function(P, M) {
      return P[M] = w[M], P;
    }, y);
  }, c = function(h, y, w) {
    var P = h.replace(/\+/g, " ");
    if (w === "iso-8859-1")
      return P.replace(/%[0-9a-f]{2}/gi, unescape);
    try {
      return decodeURIComponent(P);
    } catch {
      return P;
    }
  }, u = 1024, d = function(y, w, P, M, E) {
    if (y.length === 0)
      return y;
    var R = y;
    if (typeof y == "symbol" ? R = Symbol.prototype.toString.call(y) : typeof y != "string" && (R = String(y)), P === "iso-8859-1")
      return escape(R).replace(/%u[0-9a-f]{4}/gi, function(te) {
        return "%26%23" + parseInt(te.slice(2), 16) + "%3B";
      });
    for (var j = "", V = 0; V < R.length; V += u) {
      for (var X = R.length >= u ? R.slice(V, V + u) : R, Z = [], ae = 0; ae < X.length; ++ae) {
        var K = X.charCodeAt(ae);
        if (K === 45 || K === 46 || K === 95 || K === 126 || K >= 48 && K <= 57 || K >= 65 && K <= 90 || K >= 97 && K <= 122 || E === t.RFC1738 && (K === 40 || K === 41)) {
          Z[Z.length] = X.charAt(ae);
          continue;
        }
        if (K < 128) {
          Z[Z.length] = s[K];
          continue;
        }
        if (K < 2048) {
          Z[Z.length] = s[192 | K >> 6] + s[128 | K & 63];
          continue;
        }
        if (K < 55296 || K >= 57344) {
          Z[Z.length] = s[224 | K >> 12] + s[128 | K >> 6 & 63] + s[128 | K & 63];
          continue;
        }
        ae += 1, K = 65536 + ((K & 1023) << 10 | X.charCodeAt(ae) & 1023), Z[Z.length] = s[240 | K >> 18] + s[128 | K >> 12 & 63] + s[128 | K >> 6 & 63] + s[128 | K & 63];
      }
      j += Z.join("");
    }
    return j;
  }, m = function(y) {
    for (var w = [{ obj: { o: y }, prop: "o" }], P = [], M = 0; M < w.length; ++M)
      for (var E = w[M], R = E.obj[E.prop], j = Object.keys(R), V = 0; V < j.length; ++V) {
        var X = j[V], Z = R[X];
        typeof Z == "object" && Z !== null && P.indexOf(Z) === -1 && (w.push({ obj: R, prop: X }), P.push(Z));
      }
    return o(w), y;
  }, _ = function(y) {
    return Object.prototype.toString.call(y) === "[object RegExp]";
  }, g = function(y) {
    return !y || typeof y != "object" ? !1 : !!(y.constructor && y.constructor.isBuffer && y.constructor.isBuffer(y));
  }, v = function(y, w) {
    return [].concat(y, w);
  }, z = function(y, w) {
    if (n(y)) {
      for (var P = [], M = 0; M < y.length; M += 1)
        P.push(w(y[M]));
      return P;
    }
    return w(y);
  };
  return lr = {
    arrayToObject: a,
    assign: r,
    combine: v,
    compact: m,
    decode: c,
    encode: d,
    isBuffer: g,
    isRegExp: _,
    maybeMap: z,
    merge: i
  }, lr;
}
var cr, nu;
function zv() {
  if (nu) return cr;
  nu = 1;
  var t = $v(), e = /* @__PURE__ */ Qd(), n = /* @__PURE__ */ pl(), s = Object.prototype.hasOwnProperty, o = {
    brackets: function(h) {
      return h + "[]";
    },
    comma: "comma",
    indices: function(h, y) {
      return h + "[" + y + "]";
    },
    repeat: function(h) {
      return h;
    }
  }, a = Array.isArray, i = Array.prototype.push, r = function(z, h) {
    i.apply(z, a(h) ? h : [h]);
  }, c = Date.prototype.toISOString, u = n.default, d = {
    addQueryPrefix: !1,
    allowDots: !1,
    allowEmptyArrays: !1,
    arrayFormat: "indices",
    charset: "utf-8",
    charsetSentinel: !1,
    commaRoundTrip: !1,
    delimiter: "&",
    encode: !0,
    encodeDotInKeys: !1,
    encoder: e.encode,
    encodeValuesOnly: !1,
    filter: void 0,
    format: u,
    formatter: n.formatters[u],
    // deprecated
    indices: !1,
    serializeDate: function(h) {
      return c.call(h);
    },
    skipNulls: !1,
    strictNullHandling: !1
  }, m = function(h) {
    return typeof h == "string" || typeof h == "number" || typeof h == "boolean" || typeof h == "symbol" || typeof h == "bigint";
  }, _ = {}, g = function z(h, y, w, P, M, E, R, j, V, X, Z, ae, K, te, ue, Ce, ne, ee) {
    for (var G = h, oe = ee, _e = 0, de = !1; (oe = oe.get(_)) !== void 0 && !de; ) {
      var $e = oe.get(h);
      if (_e += 1, typeof $e < "u") {
        if ($e === _e)
          throw new RangeError("Cyclic object value");
        de = !0;
      }
      typeof oe.get(_) > "u" && (_e = 0);
    }
    if (typeof X == "function" ? G = X(y, G) : G instanceof Date ? G = K(G) : w === "comma" && a(G) && (G = e.maybeMap(G, function(wt) {
      return wt instanceof Date ? K(wt) : wt;
    })), G === null) {
      if (E)
        return V && !Ce ? V(y, d.encoder, ne, "key", te) : y;
      G = "";
    }
    if (m(G) || e.isBuffer(G)) {
      if (V) {
        var Ze = Ce ? y : V(y, d.encoder, ne, "key", te);
        return [ue(Ze) + "=" + ue(V(G, d.encoder, ne, "value", te))];
      }
      return [ue(y) + "=" + ue(String(G))];
    }
    var Pe = [];
    if (typeof G > "u")
      return Pe;
    var ie;
    if (w === "comma" && a(G))
      Ce && V && (G = e.maybeMap(G, V)), ie = [{ value: G.length > 0 ? G.join(",") || null : void 0 }];
    else if (a(X))
      ie = X;
    else {
      var ve = Object.keys(G);
      ie = Z ? ve.sort(Z) : ve;
    }
    var ut = j ? String(y).replace(/\./g, "%2E") : String(y), ot = P && a(G) && G.length === 1 ? ut + "[]" : ut;
    if (M && a(G) && G.length === 0)
      return ot + "[]";
    for (var Ve = 0; Ve < ie.length; ++Ve) {
      var fe = ie[Ve], Xe = typeof fe == "object" && fe && typeof fe.value < "u" ? fe.value : G[fe];
      if (!(R && Xe === null)) {
        var Ue = ae && j ? String(fe).replace(/\./g, "%2E") : String(fe), Ye = a(G) ? typeof w == "function" ? w(ot, Ue) : ot : ot + (ae ? "." + Ue : "[" + Ue + "]");
        ee.set(h, _e);
        var dt = t();
        dt.set(_, ee), r(Pe, z(
          Xe,
          Ye,
          w,
          P,
          M,
          E,
          R,
          j,
          w === "comma" && Ce && a(G) ? null : V,
          X,
          Z,
          ae,
          K,
          te,
          ue,
          Ce,
          ne,
          dt
        ));
      }
    }
    return Pe;
  }, v = function(h) {
    if (!h)
      return d;
    if (typeof h.allowEmptyArrays < "u" && typeof h.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof h.encodeDotInKeys < "u" && typeof h.encodeDotInKeys != "boolean")
      throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
    if (h.encoder !== null && typeof h.encoder < "u" && typeof h.encoder != "function")
      throw new TypeError("Encoder has to be a function.");
    var y = h.charset || d.charset;
    if (typeof h.charset < "u" && h.charset !== "utf-8" && h.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var w = n.default;
    if (typeof h.format < "u") {
      if (!s.call(n.formatters, h.format))
        throw new TypeError("Unknown format option provided.");
      w = h.format;
    }
    var P = n.formatters[w], M = d.filter;
    (typeof h.filter == "function" || a(h.filter)) && (M = h.filter);
    var E;
    if (h.arrayFormat in o ? E = h.arrayFormat : "indices" in h ? E = h.indices ? "indices" : "repeat" : E = d.arrayFormat, "commaRoundTrip" in h && typeof h.commaRoundTrip != "boolean")
      throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var R = typeof h.allowDots > "u" ? h.encodeDotInKeys === !0 ? !0 : d.allowDots : !!h.allowDots;
    return {
      addQueryPrefix: typeof h.addQueryPrefix == "boolean" ? h.addQueryPrefix : d.addQueryPrefix,
      allowDots: R,
      allowEmptyArrays: typeof h.allowEmptyArrays == "boolean" ? !!h.allowEmptyArrays : d.allowEmptyArrays,
      arrayFormat: E,
      charset: y,
      charsetSentinel: typeof h.charsetSentinel == "boolean" ? h.charsetSentinel : d.charsetSentinel,
      commaRoundTrip: !!h.commaRoundTrip,
      delimiter: typeof h.delimiter > "u" ? d.delimiter : h.delimiter,
      encode: typeof h.encode == "boolean" ? h.encode : d.encode,
      encodeDotInKeys: typeof h.encodeDotInKeys == "boolean" ? h.encodeDotInKeys : d.encodeDotInKeys,
      encoder: typeof h.encoder == "function" ? h.encoder : d.encoder,
      encodeValuesOnly: typeof h.encodeValuesOnly == "boolean" ? h.encodeValuesOnly : d.encodeValuesOnly,
      filter: M,
      format: w,
      formatter: P,
      serializeDate: typeof h.serializeDate == "function" ? h.serializeDate : d.serializeDate,
      skipNulls: typeof h.skipNulls == "boolean" ? h.skipNulls : d.skipNulls,
      sort: typeof h.sort == "function" ? h.sort : null,
      strictNullHandling: typeof h.strictNullHandling == "boolean" ? h.strictNullHandling : d.strictNullHandling
    };
  };
  return cr = function(z, h) {
    var y = z, w = v(h), P, M;
    typeof w.filter == "function" ? (M = w.filter, y = M("", y)) : a(w.filter) && (M = w.filter, P = M);
    var E = [];
    if (typeof y != "object" || y === null)
      return "";
    var R = o[w.arrayFormat], j = R === "comma" && w.commaRoundTrip;
    P || (P = Object.keys(y)), w.sort && P.sort(w.sort);
    for (var V = t(), X = 0; X < P.length; ++X) {
      var Z = P[X], ae = y[Z];
      w.skipNulls && ae === null || r(E, g(
        ae,
        Z,
        R,
        j,
        w.allowEmptyArrays,
        w.strictNullHandling,
        w.skipNulls,
        w.encodeDotInKeys,
        w.encode ? w.encoder : null,
        w.filter,
        w.sort,
        w.allowDots,
        w.serializeDate,
        w.format,
        w.formatter,
        w.encodeValuesOnly,
        w.charset,
        V
      ));
    }
    var K = E.join(w.delimiter), te = w.addQueryPrefix === !0 ? "?" : "";
    return w.charsetSentinel && (w.charset === "iso-8859-1" ? te += "utf8=%26%2310003%3B&" : te += "utf8=%E2%9C%93&"), K.length > 0 ? te + K : "";
  }, cr;
}
var ur, su;
function Sv() {
  if (su) return ur;
  su = 1;
  var t = /* @__PURE__ */ Qd(), e = Object.prototype.hasOwnProperty, n = Array.isArray, s = {
    allowDots: !1,
    allowEmptyArrays: !1,
    allowPrototypes: !1,
    allowSparse: !1,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: !1,
    comma: !1,
    decodeDotInKeys: !1,
    decoder: t.decode,
    delimiter: "&",
    depth: 5,
    duplicates: "combine",
    ignoreQueryPrefix: !1,
    interpretNumericEntities: !1,
    parameterLimit: 1e3,
    parseArrays: !0,
    plainObjects: !1,
    strictDepth: !1,
    strictNullHandling: !1,
    throwOnLimitExceeded: !1
  }, o = function(_) {
    return _.replace(/&#(\d+);/g, function(g, v) {
      return String.fromCharCode(parseInt(v, 10));
    });
  }, a = function(_, g, v) {
    if (_ && typeof _ == "string" && g.comma && _.indexOf(",") > -1)
      return _.split(",");
    if (g.throwOnLimitExceeded && v >= g.arrayLimit)
      throw new RangeError("Array limit exceeded. Only " + g.arrayLimit + " element" + (g.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
    return _;
  }, i = "utf8=%26%2310003%3B", r = "utf8=%E2%9C%93", c = function(g, v) {
    var z = { __proto__: null }, h = v.ignoreQueryPrefix ? g.replace(/^\?/, "") : g;
    h = h.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    var y = v.parameterLimit === 1 / 0 ? void 0 : v.parameterLimit, w = h.split(
      v.delimiter,
      v.throwOnLimitExceeded ? y + 1 : y
    );
    if (v.throwOnLimitExceeded && w.length > y)
      throw new RangeError("Parameter limit exceeded. Only " + y + " parameter" + (y === 1 ? "" : "s") + " allowed.");
    var P = -1, M, E = v.charset;
    if (v.charsetSentinel)
      for (M = 0; M < w.length; ++M)
        w[M].indexOf("utf8=") === 0 && (w[M] === r ? E = "utf-8" : w[M] === i && (E = "iso-8859-1"), P = M, M = w.length);
    for (M = 0; M < w.length; ++M)
      if (M !== P) {
        var R = w[M], j = R.indexOf("]="), V = j === -1 ? R.indexOf("=") : j + 1, X, Z;
        V === -1 ? (X = v.decoder(R, s.decoder, E, "key"), Z = v.strictNullHandling ? null : "") : (X = v.decoder(R.slice(0, V), s.decoder, E, "key"), Z = t.maybeMap(
          a(
            R.slice(V + 1),
            v,
            n(z[X]) ? z[X].length : 0
          ),
          function(K) {
            return v.decoder(K, s.decoder, E, "value");
          }
        )), Z && v.interpretNumericEntities && E === "iso-8859-1" && (Z = o(String(Z))), R.indexOf("[]=") > -1 && (Z = n(Z) ? [Z] : Z);
        var ae = e.call(z, X);
        ae && v.duplicates === "combine" ? z[X] = t.combine(z[X], Z) : (!ae || v.duplicates === "last") && (z[X] = Z);
      }
    return z;
  }, u = function(_, g, v, z) {
    var h = 0;
    if (_.length > 0 && _[_.length - 1] === "[]") {
      var y = _.slice(0, -1).join("");
      h = Array.isArray(g) && g[y] ? g[y].length : 0;
    }
    for (var w = z ? g : a(g, v, h), P = _.length - 1; P >= 0; --P) {
      var M, E = _[P];
      if (E === "[]" && v.parseArrays)
        M = v.allowEmptyArrays && (w === "" || v.strictNullHandling && w === null) ? [] : t.combine([], w);
      else {
        M = v.plainObjects ? { __proto__: null } : {};
        var R = E.charAt(0) === "[" && E.charAt(E.length - 1) === "]" ? E.slice(1, -1) : E, j = v.decodeDotInKeys ? R.replace(/%2E/g, ".") : R, V = parseInt(j, 10);
        !v.parseArrays && j === "" ? M = { 0: w } : !isNaN(V) && E !== j && String(V) === j && V >= 0 && v.parseArrays && V <= v.arrayLimit ? (M = [], M[V] = w) : j !== "__proto__" && (M[j] = w);
      }
      w = M;
    }
    return w;
  }, d = function(g, v, z, h) {
    if (g) {
      var y = z.allowDots ? g.replace(/\.([^.[]+)/g, "[$1]") : g, w = /(\[[^[\]]*])/, P = /(\[[^[\]]*])/g, M = z.depth > 0 && w.exec(y), E = M ? y.slice(0, M.index) : y, R = [];
      if (E) {
        if (!z.plainObjects && e.call(Object.prototype, E) && !z.allowPrototypes)
          return;
        R.push(E);
      }
      for (var j = 0; z.depth > 0 && (M = P.exec(y)) !== null && j < z.depth; ) {
        if (j += 1, !z.plainObjects && e.call(Object.prototype, M[1].slice(1, -1)) && !z.allowPrototypes)
          return;
        R.push(M[1]);
      }
      if (M) {
        if (z.strictDepth === !0)
          throw new RangeError("Input depth exceeded depth option of " + z.depth + " and strictDepth is true");
        R.push("[" + y.slice(M.index) + "]");
      }
      return u(R, v, z, h);
    }
  }, m = function(g) {
    if (!g)
      return s;
    if (typeof g.allowEmptyArrays < "u" && typeof g.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof g.decodeDotInKeys < "u" && typeof g.decodeDotInKeys != "boolean")
      throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
    if (g.decoder !== null && typeof g.decoder < "u" && typeof g.decoder != "function")
      throw new TypeError("Decoder has to be a function.");
    if (typeof g.charset < "u" && g.charset !== "utf-8" && g.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    if (typeof g.throwOnLimitExceeded < "u" && typeof g.throwOnLimitExceeded != "boolean")
      throw new TypeError("`throwOnLimitExceeded` option must be a boolean");
    var v = typeof g.charset > "u" ? s.charset : g.charset, z = typeof g.duplicates > "u" ? s.duplicates : g.duplicates;
    if (z !== "combine" && z !== "first" && z !== "last")
      throw new TypeError("The duplicates option must be either combine, first, or last");
    var h = typeof g.allowDots > "u" ? g.decodeDotInKeys === !0 ? !0 : s.allowDots : !!g.allowDots;
    return {
      allowDots: h,
      allowEmptyArrays: typeof g.allowEmptyArrays == "boolean" ? !!g.allowEmptyArrays : s.allowEmptyArrays,
      allowPrototypes: typeof g.allowPrototypes == "boolean" ? g.allowPrototypes : s.allowPrototypes,
      allowSparse: typeof g.allowSparse == "boolean" ? g.allowSparse : s.allowSparse,
      arrayLimit: typeof g.arrayLimit == "number" ? g.arrayLimit : s.arrayLimit,
      charset: v,
      charsetSentinel: typeof g.charsetSentinel == "boolean" ? g.charsetSentinel : s.charsetSentinel,
      comma: typeof g.comma == "boolean" ? g.comma : s.comma,
      decodeDotInKeys: typeof g.decodeDotInKeys == "boolean" ? g.decodeDotInKeys : s.decodeDotInKeys,
      decoder: typeof g.decoder == "function" ? g.decoder : s.decoder,
      delimiter: typeof g.delimiter == "string" || t.isRegExp(g.delimiter) ? g.delimiter : s.delimiter,
      // eslint-disable-next-line no-implicit-coercion, no-extra-parens
      depth: typeof g.depth == "number" || g.depth === !1 ? +g.depth : s.depth,
      duplicates: z,
      ignoreQueryPrefix: g.ignoreQueryPrefix === !0,
      interpretNumericEntities: typeof g.interpretNumericEntities == "boolean" ? g.interpretNumericEntities : s.interpretNumericEntities,
      parameterLimit: typeof g.parameterLimit == "number" ? g.parameterLimit : s.parameterLimit,
      parseArrays: g.parseArrays !== !1,
      plainObjects: typeof g.plainObjects == "boolean" ? g.plainObjects : s.plainObjects,
      strictDepth: typeof g.strictDepth == "boolean" ? !!g.strictDepth : s.strictDepth,
      strictNullHandling: typeof g.strictNullHandling == "boolean" ? g.strictNullHandling : s.strictNullHandling,
      throwOnLimitExceeded: typeof g.throwOnLimitExceeded == "boolean" ? g.throwOnLimitExceeded : !1
    };
  };
  return ur = function(_, g) {
    var v = m(g);
    if (_ === "" || _ === null || typeof _ > "u")
      return v.plainObjects ? { __proto__: null } : {};
    for (var z = typeof _ == "string" ? c(_, v) : _, h = v.plainObjects ? { __proto__: null } : {}, y = Object.keys(z), w = 0; w < y.length; ++w) {
      var P = y[w], M = d(P, z[P], v, typeof _ == "string");
      h = t.merge(h, M, v);
    }
    return v.allowSparse === !0 ? h : t.compact(h);
  }, ur;
}
var dr, ou;
function Av() {
  if (ou) return dr;
  ou = 1;
  var t = /* @__PURE__ */ zv(), e = /* @__PURE__ */ Sv(), n = /* @__PURE__ */ pl();
  return dr = {
    formats: n,
    parse: e,
    stringify: t
  }, dr;
}
var Cv = /* @__PURE__ */ Av();
const Pv = /* @__PURE__ */ Fd(Cv);
var Mv = Object.defineProperty, Tv = (t, e, n) => e in t ? Mv(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, va = (t, e, n) => Tv(t, typeof e != "symbol" ? e + "" : e, n), Lr = /* @__PURE__ */ ((t) => (t[t.INPUT = 0] = "INPUT", t[t.OUTPUT = 1] = "OUTPUT", t))(Lr || {});
let Iv = class extends Error {
  constructor(e, n, s) {
    let o = `Endpoint validation error in ${e === 0 ? "input" : "output"} of "${s.key ?? ""}"
${Jd(n.issues)}`;
    o.length > 5e5 && (o = o.slice(0, 499997) + "..."), super(o), va(this, "name", "EndpointValidationError");
  }
};
function au(t, e, n, s, o) {
  if (t) {
    const a = t.safeParse(e);
    if (a.success)
      return a.data;
    {
      const i = new Iv(
        n,
        a.error,
        s
      );
      if (o)
        o(i);
      else
        throw i;
    }
  }
  return e;
}
function Jd(t, e = 0) {
  const n = /* @__PURE__ */ new Set();
  for (const s of t) {
    const { path: o, ...a } = s;
    let i = `${o.map((r) => typeof r == "number" ? "[]" : r).join(".")}: `;
    if (a.code === "invalid_union") {
      const { unionErrors: r, ...c } = a;
      i += `${JSON.stringify(c)}
`;
      const u = [];
      for (const d of r)
        u.push(
          Jd(d.issues, e + 1)
        );
      i += u.join(
        `
${"  ".repeat(e + 1)}---
`
      );
    } else
      i += JSON.stringify(a);
    n.add(i);
  }
  return `${"  ".repeat(e)}${[...n].join(`
${"  ".repeat(e)}`)}`;
}
let Fa = class {
  constructor(e, n, s, o, a, i, r = (d) => d.json(), c, u) {
    va(this, "inputType"), va(this, "outputType"), this.kyInstance = e, this.middlewares = n, this.resolver = s, this.onValidationError = o, this.inputSchema = a, this.outputSchema = i, this.responseTransformer = r, this.onSuccess = c, this.key = u;
  }
  async fetch(e, n, s, o, ...a) {
    if (!s.value)
      throw new Error(`Not enabled. Key: ${JSON.stringify(o.key)}`);
    const i = au(
      this.inputSchema,
      e,
      Lr.INPUT,
      this,
      this.onValidationError
    );
    let r = this.resolver(i, ...a);
    for (const _ of n)
      r = _(r, o);
    const { url: c, ...u } = r, d = await this.responseTransformer(
      this.kyInstance(c, {
        ...u,
        searchParams: u.searchParams ? Pv.stringify(u.searchParams, {
          arrayFormat: "comma",
          skipNulls: !0
        }) : void 0
      })
    ), m = au(
      this.outputSchema,
      d,
      Lr.OUTPUT,
      this,
      this.onValidationError
    );
    try {
      C(
        () => {
          var _;
          return (_ = this.onSuccess) == null ? void 0 : _.call(this, {
            input: i,
            output: m
          });
        },
        o.context
      )();
    } catch {
    }
    return m;
  }
  runMiddlewares() {
    if (!Kh())
      throw new Error(
        "Middlewares outside of injection context not supported"
      );
    const e = this.middlewares.map(
      (n) => n()
    );
    return {
      beforeRequest: e.map(({ beforeRequest: n }) => n).filter((n) => n !== void 0),
      enabled: e.map(({ enabled: n }) => n).filter((n) => n !== void 0),
      key: e.map(({ key: n }) => n).filter((n) => n !== void 0)
    };
  }
}, Ev = class Yd extends Fa {
  constructor(e, n, s, ...o) {
    super(...o), va(this, "pageParamType"), this.initialPageParam = e, this.getNextPageParam = n, this.getPreviousPageParam = s;
  }
  static create(e, n, s) {
    return (o, a) => new Yd(
      a.initialPageParam,
      a.getNextPageParam,
      a.getPreviousPageParam,
      e,
      n,
      o,
      s,
      a.input,
      a.output,
      a.responseTransformer,
      a.onSuccess
    );
  }
  getQueryKey(e) {
    const { key: n } = this.runMiddlewares();
    return e === void 0 ? [this.key, n] : [this.key, n, e];
  }
  use(...[e]) {
    const {
      beforeRequest: n,
      enabled: s,
      key: o
    } = this.runMiddlewares(), a = A(
      () => s.every((r) => an(r))
    ), i = En();
    return {
      enabled: a,
      getNextPageParam: this.getNextPageParam,
      getPreviousPageParam: this.getPreviousPageParam,
      initialPageParam: this.initialPageParam,
      queryFn: async ({
        pageParam: r,
        queryKey: c
      }) => this.fetch(
        c[2],
        n,
        a,
        { context: i, key: c },
        r
      ),
      queryKey: [this.key, o, e]
    };
  }
  useWithManualPageParam(...[e, n]) {
    const {
      beforeRequest: s,
      enabled: o,
      key: a
    } = this.runMiddlewares(), i = A(
      () => o.every((c) => an(c))
    ), r = En();
    return {
      enabled: i,
      queryFn: async ({
        queryKey: c
      }) => this.fetch(
        c[2],
        s,
        i,
        { context: r, key: c },
        c[3]
      ),
      queryKey: [
        this.key,
        a,
        e,
        n
      ]
    };
  }
}, Ov = class ep extends Fa {
  static create(e, n, s) {
    return (o, a) => new ep(
      e,
      n,
      o,
      s,
      a == null ? void 0 : a.input,
      a == null ? void 0 : a.output,
      a == null ? void 0 : a.responseTransformer,
      a == null ? void 0 : a.onSuccess
    );
  }
  use() {
    const {
      beforeRequest: e,
      enabled: n,
      key: s
    } = this.runMiddlewares(), o = A(
      () => n.every((i) => an(i))
    ), a = En();
    return {
      mutationFn: async (...[i]) => this.fetch(i, e, o, { context: a }),
      mutationKey: [this.key, s]
    };
  }
};
class ml extends Fa {
  static create(e, n, s) {
    return (o, a) => new ml(
      e,
      n,
      o,
      s,
      a == null ? void 0 : a.input,
      a == null ? void 0 : a.output,
      a == null ? void 0 : a.responseTransformer,
      a == null ? void 0 : a.onSuccess
    );
  }
  async fetchPlain(e) {
    const { beforeRequest: n, enabled: s } = this.runMiddlewares(), o = A(
      () => s.every((i) => an(i))
    ), a = En();
    return this.fetch(e, n, o, {
      context: a
    });
  }
  getQueryKey(e) {
    const { key: n } = this.runMiddlewares();
    return e === void 0 ? [this.key, n] : [this.key, n, e];
  }
  use(...[e]) {
    const {
      beforeRequest: n,
      enabled: s,
      key: o
    } = this.runMiddlewares(), a = A(
      () => s.every((r) => an(r))
    ), i = En();
    return {
      enabled: a,
      queryFn: async ({
        queryKey: r
      }) => this.fetch(r[2], n, a, {
        context: i,
        key: r
      }),
      queryKey: [this.key, o, e]
    };
  }
}
function tp(t, e = []) {
  const { onValidationError: n, ...s } = t, o = Ud.extend({ retry: 0, ...s });
  return {
    infiniteQuery: Ev.create(
      o,
      e,
      n
    ),
    mutation: Ov.create(
      o,
      e,
      n
    ),
    query: ml.create(o, e, n),
    use: (a) => tp(t, [
      ...e,
      a
    ])
  };
}
function vt(t, e) {
  for (const [n, s] of Object.entries(t)) {
    const o = e ? `${e}.${n}` : n;
    s instanceof Fa ? s.key = o : vt(s, o);
  }
  return t;
}
var He;
(function(t) {
  t.assertEqual = (o) => {
  };
  function e(o) {
  }
  t.assertIs = e;
  function n(o) {
    throw new Error();
  }
  t.assertNever = n, t.arrayToEnum = (o) => {
    const a = {};
    for (const i of o)
      a[i] = i;
    return a;
  }, t.getValidEnumValues = (o) => {
    const a = t.objectKeys(o).filter((r) => typeof o[o[r]] != "number"), i = {};
    for (const r of a)
      i[r] = o[r];
    return t.objectValues(i);
  }, t.objectValues = (o) => t.objectKeys(o).map(function(a) {
    return o[a];
  }), t.objectKeys = typeof Object.keys == "function" ? (o) => Object.keys(o) : (o) => {
    const a = [];
    for (const i in o)
      Object.prototype.hasOwnProperty.call(o, i) && a.push(i);
    return a;
  }, t.find = (o, a) => {
    for (const i of o)
      if (a(i))
        return i;
  }, t.isInteger = typeof Number.isInteger == "function" ? (o) => Number.isInteger(o) : (o) => typeof o == "number" && Number.isFinite(o) && Math.floor(o) === o;
  function s(o, a = " | ") {
    return o.map((i) => typeof i == "string" ? `'${i}'` : i).join(a);
  }
  t.joinValues = s, t.jsonStringifyReplacer = (o, a) => typeof a == "bigint" ? a.toString() : a;
})(He || (He = {}));
var iu;
(function(t) {
  t.mergeShapes = (e, n) => ({
    ...e,
    ...n
    // second overwrites first
  });
})(iu || (iu = {}));
const ge = He.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), Bn = (t) => {
  switch (typeof t) {
    case "undefined":
      return ge.undefined;
    case "string":
      return ge.string;
    case "number":
      return Number.isNaN(t) ? ge.nan : ge.number;
    case "boolean":
      return ge.boolean;
    case "function":
      return ge.function;
    case "bigint":
      return ge.bigint;
    case "symbol":
      return ge.symbol;
    case "object":
      return Array.isArray(t) ? ge.array : t === null ? ge.null : t.then && typeof t.then == "function" && t.catch && typeof t.catch == "function" ? ge.promise : typeof Map < "u" && t instanceof Map ? ge.map : typeof Set < "u" && t instanceof Set ? ge.set : typeof Date < "u" && t instanceof Date ? ge.date : ge.object;
    default:
      return ge.unknown;
  }
}, se = He.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
class On extends Error {
  get errors() {
    return this.issues;
  }
  constructor(e) {
    super(), this.issues = [], this.addIssue = (s) => {
      this.issues = [...this.issues, s];
    }, this.addIssues = (s = []) => {
      this.issues = [...this.issues, ...s];
    };
    const n = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, n) : this.__proto__ = n, this.name = "ZodError", this.issues = e;
  }
  format(e) {
    const n = e || function(a) {
      return a.message;
    }, s = { _errors: [] }, o = (a) => {
      for (const i of a.issues)
        if (i.code === "invalid_union")
          i.unionErrors.map(o);
        else if (i.code === "invalid_return_type")
          o(i.returnTypeError);
        else if (i.code === "invalid_arguments")
          o(i.argumentsError);
        else if (i.path.length === 0)
          s._errors.push(n(i));
        else {
          let r = s, c = 0;
          for (; c < i.path.length; ) {
            const u = i.path[c];
            c === i.path.length - 1 ? (r[u] = r[u] || { _errors: [] }, r[u]._errors.push(n(i))) : r[u] = r[u] || { _errors: [] }, r = r[u], c++;
          }
        }
    };
    return o(this), s;
  }
  static assert(e) {
    if (!(e instanceof On))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, He.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (n) => n.message) {
    const n = {}, s = [];
    for (const o of this.issues)
      if (o.path.length > 0) {
        const a = o.path[0];
        n[a] = n[a] || [], n[a].push(e(o));
      } else
        s.push(e(o));
    return { formErrors: s, fieldErrors: n };
  }
  get formErrors() {
    return this.flatten();
  }
}
On.create = (t) => new On(t);
const Dr = (t, e) => {
  let n;
  switch (t.code) {
    case se.invalid_type:
      t.received === ge.undefined ? n = "Required" : n = `Expected ${t.expected}, received ${t.received}`;
      break;
    case se.invalid_literal:
      n = `Invalid literal value, expected ${JSON.stringify(t.expected, He.jsonStringifyReplacer)}`;
      break;
    case se.unrecognized_keys:
      n = `Unrecognized key(s) in object: ${He.joinValues(t.keys, ", ")}`;
      break;
    case se.invalid_union:
      n = "Invalid input";
      break;
    case se.invalid_union_discriminator:
      n = `Invalid discriminator value. Expected ${He.joinValues(t.options)}`;
      break;
    case se.invalid_enum_value:
      n = `Invalid enum value. Expected ${He.joinValues(t.options)}, received '${t.received}'`;
      break;
    case se.invalid_arguments:
      n = "Invalid function arguments";
      break;
    case se.invalid_return_type:
      n = "Invalid function return type";
      break;
    case se.invalid_date:
      n = "Invalid date";
      break;
    case se.invalid_string:
      typeof t.validation == "object" ? "includes" in t.validation ? (n = `Invalid input: must include "${t.validation.includes}"`, typeof t.validation.position == "number" && (n = `${n} at one or more positions greater than or equal to ${t.validation.position}`)) : "startsWith" in t.validation ? n = `Invalid input: must start with "${t.validation.startsWith}"` : "endsWith" in t.validation ? n = `Invalid input: must end with "${t.validation.endsWith}"` : He.assertNever(t.validation) : t.validation !== "regex" ? n = `Invalid ${t.validation}` : n = "Invalid";
      break;
    case se.too_small:
      t.type === "array" ? n = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "more than"} ${t.minimum} element(s)` : t.type === "string" ? n = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "over"} ${t.minimum} character(s)` : t.type === "number" ? n = `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "bigint" ? n = `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "date" ? n = `Date must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(t.minimum))}` : n = "Invalid input";
      break;
    case se.too_big:
      t.type === "array" ? n = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "less than"} ${t.maximum} element(s)` : t.type === "string" ? n = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "under"} ${t.maximum} character(s)` : t.type === "number" ? n = `Number must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "bigint" ? n = `BigInt must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "date" ? n = `Date must be ${t.exact ? "exactly" : t.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(t.maximum))}` : n = "Invalid input";
      break;
    case se.custom:
      n = "Invalid input";
      break;
    case se.invalid_intersection_types:
      n = "Intersection results could not be merged";
      break;
    case se.not_multiple_of:
      n = `Number must be a multiple of ${t.multipleOf}`;
      break;
    case se.not_finite:
      n = "Number must be finite";
      break;
    default:
      n = e.defaultError, He.assertNever(t);
  }
  return { message: n };
};
let Rv = Dr;
function Lv() {
  return Rv;
}
const Dv = (t) => {
  const { data: e, path: n, errorMaps: s, issueData: o } = t, a = [...n, ...o.path || []], i = {
    ...o,
    path: a
  };
  if (o.message !== void 0)
    return {
      ...o,
      path: a,
      message: o.message
    };
  let r = "";
  const c = s.filter((u) => !!u).slice().reverse();
  for (const u of c)
    r = u(i, { data: e, defaultError: r }).message;
  return {
    ...o,
    path: a,
    message: r
  };
};
function pe(t, e) {
  const n = Lv(), s = Dv({
    issueData: e,
    data: t.data,
    path: t.path,
    errorMaps: [
      t.common.contextualErrorMap,
      // contextual error map is first priority
      t.schemaErrorMap,
      // then schema-bound map if available
      n,
      // then global override map
      n === Dr ? void 0 : Dr
      // then global default map
    ].filter((o) => !!o)
  });
  t.common.issues.push(s);
}
class tn {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, n) {
    const s = [];
    for (const o of n) {
      if (o.status === "aborted")
        return Me;
      o.status === "dirty" && e.dirty(), s.push(o.value);
    }
    return { status: e.value, value: s };
  }
  static async mergeObjectAsync(e, n) {
    const s = [];
    for (const o of n) {
      const a = await o.key, i = await o.value;
      s.push({
        key: a,
        value: i
      });
    }
    return tn.mergeObjectSync(e, s);
  }
  static mergeObjectSync(e, n) {
    const s = {};
    for (const o of n) {
      const { key: a, value: i } = o;
      if (a.status === "aborted" || i.status === "aborted")
        return Me;
      a.status === "dirty" && e.dirty(), i.status === "dirty" && e.dirty(), a.value !== "__proto__" && (typeof i.value < "u" || o.alwaysSet) && (s[a.value] = i.value);
    }
    return { status: e.value, value: s };
  }
}
const Me = Object.freeze({
  status: "aborted"
}), co = (t) => ({ status: "dirty", value: t }), cn = (t) => ({ status: "valid", value: t }), ru = (t) => t.status === "aborted", lu = (t) => t.status === "dirty", Is = (t) => t.status === "valid", ga = (t) => typeof Promise < "u" && t instanceof Promise;
var be;
(function(t) {
  t.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, t.toString = (e) => typeof e == "string" ? e : e == null ? void 0 : e.message;
})(be || (be = {}));
class Gn {
  constructor(e, n, s, o) {
    this._cachedPath = [], this.parent = e, this.data = n, this._path = s, this._key = o;
  }
  get path() {
    return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const cu = (t, e) => {
  if (Is(e))
    return { success: !0, data: e.value };
  if (!t.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const n = new On(t.common.issues);
      return this._error = n, this._error;
    }
  };
};
function je(t) {
  if (!t)
    return {};
  const { errorMap: e, invalid_type_error: n, required_error: s, description: o } = t;
  if (e && (n || s))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: o } : { errorMap: (i, r) => {
    const { message: c } = t;
    return i.code === "invalid_enum_value" ? { message: c ?? r.defaultError } : typeof r.data > "u" ? { message: c ?? s ?? r.defaultError } : i.code !== "invalid_type" ? { message: r.defaultError } : { message: c ?? n ?? r.defaultError };
  }, description: o };
}
class Be {
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return Bn(e.data);
  }
  _getOrReturnCtx(e, n) {
    return n || {
      common: e.parent.common,
      data: e.data,
      parsedType: Bn(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new tn(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: Bn(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const n = this._parse(e);
    if (ga(n))
      throw new Error("Synchronous parse encountered promise.");
    return n;
  }
  _parseAsync(e) {
    const n = this._parse(e);
    return Promise.resolve(n);
  }
  parse(e, n) {
    const s = this.safeParse(e, n);
    if (s.success)
      return s.data;
    throw s.error;
  }
  safeParse(e, n) {
    const s = {
      common: {
        issues: [],
        async: (n == null ? void 0 : n.async) ?? !1,
        contextualErrorMap: n == null ? void 0 : n.errorMap
      },
      path: (n == null ? void 0 : n.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Bn(e)
    }, o = this._parseSync({ data: e, path: s.path, parent: s });
    return cu(s, o);
  }
  "~validate"(e) {
    var s, o;
    const n = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Bn(e)
    };
    if (!this["~standard"].async)
      try {
        const a = this._parseSync({ data: e, path: [], parent: n });
        return Is(a) ? {
          value: a.value
        } : {
          issues: n.common.issues
        };
      } catch (a) {
        (o = (s = a == null ? void 0 : a.message) == null ? void 0 : s.toLowerCase()) != null && o.includes("encountered") && (this["~standard"].async = !0), n.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: e, path: [], parent: n }).then((a) => Is(a) ? {
      value: a.value
    } : {
      issues: n.common.issues
    });
  }
  async parseAsync(e, n) {
    const s = await this.safeParseAsync(e, n);
    if (s.success)
      return s.data;
    throw s.error;
  }
  async safeParseAsync(e, n) {
    const s = {
      common: {
        issues: [],
        contextualErrorMap: n == null ? void 0 : n.errorMap,
        async: !0
      },
      path: (n == null ? void 0 : n.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Bn(e)
    }, o = this._parse({ data: e, path: s.path, parent: s }), a = await (ga(o) ? o : Promise.resolve(o));
    return cu(s, a);
  }
  refine(e, n) {
    const s = (o) => typeof n == "string" || typeof n > "u" ? { message: n } : typeof n == "function" ? n(o) : n;
    return this._refinement((o, a) => {
      const i = e(o), r = () => a.addIssue({
        code: se.custom,
        ...s(o)
      });
      return typeof Promise < "u" && i instanceof Promise ? i.then((c) => c ? !0 : (r(), !1)) : i ? !0 : (r(), !1);
    });
  }
  refinement(e, n) {
    return this._refinement((s, o) => e(s) ? !0 : (o.addIssue(typeof n == "function" ? n(s, o) : n), !1));
  }
  _refinement(e) {
    return new fs({
      schema: this,
      typeName: Te.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (n) => this["~validate"](n)
    };
  }
  optional() {
    return In.create(this, this._def);
  }
  nullable() {
    return _s.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return $n.create(this);
  }
  promise() {
    return za.create(this, this._def);
  }
  or(e) {
    return ya.create([this, e], this._def);
  }
  and(e) {
    return ba.create(this, e, this._def);
  }
  transform(e) {
    return new fs({
      ...je(this._def),
      schema: this,
      typeName: Te.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const n = typeof e == "function" ? e : () => e;
    return new Sa({
      ...je(this._def),
      innerType: this,
      defaultValue: n,
      typeName: Te.ZodDefault
    });
  }
  brand() {
    return new ap({
      typeName: Te.ZodBranded,
      type: this,
      ...je(this._def)
    });
  }
  catch(e) {
    const n = typeof e == "function" ? e : () => e;
    return new Aa({
      ...je(this._def),
      innerType: this,
      catchValue: n,
      typeName: Te.ZodCatch
    });
  }
  describe(e) {
    const n = this.constructor;
    return new n({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return fl.create(this, e);
  }
  readonly() {
    return Ca.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const jv = /^c[^\s-]{8,}$/i, Nv = /^[0-9a-z]+$/, Vv = /^[0-9A-HJKMNP-TV-Z]{26}$/i, Uv = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, Fv = /^[a-z0-9_-]{21}$/i, Bv = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, qv = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, Hv = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, Wv = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let pr;
const Gv = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Zv = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, Kv = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, Xv = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Qv = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, Jv = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, np = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", Yv = new RegExp(`^${np}$`);
function sp(t) {
  let e = "[0-5]\\d";
  t.precision ? e = `${e}\\.\\d{${t.precision}}` : t.precision == null && (e = `${e}(\\.\\d+)?`);
  const n = t.precision ? "+" : "?";
  return `([01]\\d|2[0-3]):[0-5]\\d(:${e})${n}`;
}
function eg(t) {
  return new RegExp(`^${sp(t)}$`);
}
function tg(t) {
  let e = `${np}T${sp(t)}`;
  const n = [];
  return n.push(t.local ? "Z?" : "Z"), t.offset && n.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${n.join("|")})`, new RegExp(`^${e}$`);
}
function ng(t, e) {
  return !!((e === "v4" || !e) && Gv.test(t) || (e === "v6" || !e) && Kv.test(t));
}
function sg(t, e) {
  if (!Bv.test(t))
    return !1;
  try {
    const [n] = t.split(".");
    if (!n)
      return !1;
    const s = n.replace(/-/g, "+").replace(/_/g, "/").padEnd(n.length + (4 - n.length % 4) % 4, "="), o = JSON.parse(atob(s));
    return !(typeof o != "object" || o === null || "typ" in o && (o == null ? void 0 : o.typ) !== "JWT" || !o.alg || e && o.alg !== e);
  } catch {
    return !1;
  }
}
function og(t, e) {
  return !!((e === "v4" || !e) && Zv.test(t) || (e === "v6" || !e) && Xv.test(t));
}
class qn extends Be {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== ge.string) {
      const a = this._getOrReturnCtx(e);
      return pe(a, {
        code: se.invalid_type,
        expected: ge.string,
        received: a.parsedType
      }), Me;
    }
    const s = new tn();
    let o;
    for (const a of this._def.checks)
      if (a.kind === "min")
        e.data.length < a.value && (o = this._getOrReturnCtx(e, o), pe(o, {
          code: se.too_small,
          minimum: a.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: a.message
        }), s.dirty());
      else if (a.kind === "max")
        e.data.length > a.value && (o = this._getOrReturnCtx(e, o), pe(o, {
          code: se.too_big,
          maximum: a.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: a.message
        }), s.dirty());
      else if (a.kind === "length") {
        const i = e.data.length > a.value, r = e.data.length < a.value;
        (i || r) && (o = this._getOrReturnCtx(e, o), i ? pe(o, {
          code: se.too_big,
          maximum: a.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: a.message
        }) : r && pe(o, {
          code: se.too_small,
          minimum: a.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: a.message
        }), s.dirty());
      } else if (a.kind === "email")
        Hv.test(e.data) || (o = this._getOrReturnCtx(e, o), pe(o, {
          validation: "email",
          code: se.invalid_string,
          message: a.message
        }), s.dirty());
      else if (a.kind === "emoji")
        pr || (pr = new RegExp(Wv, "u")), pr.test(e.data) || (o = this._getOrReturnCtx(e, o), pe(o, {
          validation: "emoji",
          code: se.invalid_string,
          message: a.message
        }), s.dirty());
      else if (a.kind === "uuid")
        Uv.test(e.data) || (o = this._getOrReturnCtx(e, o), pe(o, {
          validation: "uuid",
          code: se.invalid_string,
          message: a.message
        }), s.dirty());
      else if (a.kind === "nanoid")
        Fv.test(e.data) || (o = this._getOrReturnCtx(e, o), pe(o, {
          validation: "nanoid",
          code: se.invalid_string,
          message: a.message
        }), s.dirty());
      else if (a.kind === "cuid")
        jv.test(e.data) || (o = this._getOrReturnCtx(e, o), pe(o, {
          validation: "cuid",
          code: se.invalid_string,
          message: a.message
        }), s.dirty());
      else if (a.kind === "cuid2")
        Nv.test(e.data) || (o = this._getOrReturnCtx(e, o), pe(o, {
          validation: "cuid2",
          code: se.invalid_string,
          message: a.message
        }), s.dirty());
      else if (a.kind === "ulid")
        Vv.test(e.data) || (o = this._getOrReturnCtx(e, o), pe(o, {
          validation: "ulid",
          code: se.invalid_string,
          message: a.message
        }), s.dirty());
      else if (a.kind === "url")
        try {
          new URL(e.data);
        } catch {
          o = this._getOrReturnCtx(e, o), pe(o, {
            validation: "url",
            code: se.invalid_string,
            message: a.message
          }), s.dirty();
        }
      else a.kind === "regex" ? (a.regex.lastIndex = 0, a.regex.test(e.data) || (o = this._getOrReturnCtx(e, o), pe(o, {
        validation: "regex",
        code: se.invalid_string,
        message: a.message
      }), s.dirty())) : a.kind === "trim" ? e.data = e.data.trim() : a.kind === "includes" ? e.data.includes(a.value, a.position) || (o = this._getOrReturnCtx(e, o), pe(o, {
        code: se.invalid_string,
        validation: { includes: a.value, position: a.position },
        message: a.message
      }), s.dirty()) : a.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : a.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : a.kind === "startsWith" ? e.data.startsWith(a.value) || (o = this._getOrReturnCtx(e, o), pe(o, {
        code: se.invalid_string,
        validation: { startsWith: a.value },
        message: a.message
      }), s.dirty()) : a.kind === "endsWith" ? e.data.endsWith(a.value) || (o = this._getOrReturnCtx(e, o), pe(o, {
        code: se.invalid_string,
        validation: { endsWith: a.value },
        message: a.message
      }), s.dirty()) : a.kind === "datetime" ? tg(a).test(e.data) || (o = this._getOrReturnCtx(e, o), pe(o, {
        code: se.invalid_string,
        validation: "datetime",
        message: a.message
      }), s.dirty()) : a.kind === "date" ? Yv.test(e.data) || (o = this._getOrReturnCtx(e, o), pe(o, {
        code: se.invalid_string,
        validation: "date",
        message: a.message
      }), s.dirty()) : a.kind === "time" ? eg(a).test(e.data) || (o = this._getOrReturnCtx(e, o), pe(o, {
        code: se.invalid_string,
        validation: "time",
        message: a.message
      }), s.dirty()) : a.kind === "duration" ? qv.test(e.data) || (o = this._getOrReturnCtx(e, o), pe(o, {
        validation: "duration",
        code: se.invalid_string,
        message: a.message
      }), s.dirty()) : a.kind === "ip" ? ng(e.data, a.version) || (o = this._getOrReturnCtx(e, o), pe(o, {
        validation: "ip",
        code: se.invalid_string,
        message: a.message
      }), s.dirty()) : a.kind === "jwt" ? sg(e.data, a.alg) || (o = this._getOrReturnCtx(e, o), pe(o, {
        validation: "jwt",
        code: se.invalid_string,
        message: a.message
      }), s.dirty()) : a.kind === "cidr" ? og(e.data, a.version) || (o = this._getOrReturnCtx(e, o), pe(o, {
        validation: "cidr",
        code: se.invalid_string,
        message: a.message
      }), s.dirty()) : a.kind === "base64" ? Qv.test(e.data) || (o = this._getOrReturnCtx(e, o), pe(o, {
        validation: "base64",
        code: se.invalid_string,
        message: a.message
      }), s.dirty()) : a.kind === "base64url" ? Jv.test(e.data) || (o = this._getOrReturnCtx(e, o), pe(o, {
        validation: "base64url",
        code: se.invalid_string,
        message: a.message
      }), s.dirty()) : He.assertNever(a);
    return { status: s.value, value: e.data };
  }
  _regex(e, n, s) {
    return this.refinement((o) => e.test(o), {
      validation: n,
      code: se.invalid_string,
      ...be.errToObj(s)
    });
  }
  _addCheck(e) {
    return new qn({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...be.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...be.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...be.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...be.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ...be.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...be.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...be.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...be.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ...be.errToObj(e) });
  }
  base64url(e) {
    return this._addCheck({
      kind: "base64url",
      ...be.errToObj(e)
    });
  }
  jwt(e) {
    return this._addCheck({ kind: "jwt", ...be.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...be.errToObj(e) });
  }
  cidr(e) {
    return this._addCheck({ kind: "cidr", ...be.errToObj(e) });
  }
  datetime(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      offset: (e == null ? void 0 : e.offset) ?? !1,
      local: (e == null ? void 0 : e.local) ?? !1,
      ...be.errToObj(e == null ? void 0 : e.message)
    });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck({
      kind: "time",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      ...be.errToObj(e == null ? void 0 : e.message)
    });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ...be.errToObj(e) });
  }
  regex(e, n) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...be.errToObj(n)
    });
  }
  includes(e, n) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: n == null ? void 0 : n.position,
      ...be.errToObj(n == null ? void 0 : n.message)
    });
  }
  startsWith(e, n) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...be.errToObj(n)
    });
  }
  endsWith(e, n) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...be.errToObj(n)
    });
  }
  min(e, n) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...be.errToObj(n)
    });
  }
  max(e, n) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...be.errToObj(n)
    });
  }
  length(e, n) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...be.errToObj(n)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(e) {
    return this.min(1, be.errToObj(e));
  }
  trim() {
    return new qn({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new qn({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new qn({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((e) => e.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((e) => e.kind === "base64url");
  }
  get minLength() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
}
qn.create = (t) => new qn({
  checks: [],
  typeName: Te.ZodString,
  coerce: (t == null ? void 0 : t.coerce) ?? !1,
  ...je(t)
});
function ag(t, e) {
  const n = (t.toString().split(".")[1] || "").length, s = (e.toString().split(".")[1] || "").length, o = n > s ? n : s, a = Number.parseInt(t.toFixed(o).replace(".", "")), i = Number.parseInt(e.toFixed(o).replace(".", ""));
  return a % i / 10 ** o;
}
class Es extends Be {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== ge.number) {
      const a = this._getOrReturnCtx(e);
      return pe(a, {
        code: se.invalid_type,
        expected: ge.number,
        received: a.parsedType
      }), Me;
    }
    let s;
    const o = new tn();
    for (const a of this._def.checks)
      a.kind === "int" ? He.isInteger(e.data) || (s = this._getOrReturnCtx(e, s), pe(s, {
        code: se.invalid_type,
        expected: "integer",
        received: "float",
        message: a.message
      }), o.dirty()) : a.kind === "min" ? (a.inclusive ? e.data < a.value : e.data <= a.value) && (s = this._getOrReturnCtx(e, s), pe(s, {
        code: se.too_small,
        minimum: a.value,
        type: "number",
        inclusive: a.inclusive,
        exact: !1,
        message: a.message
      }), o.dirty()) : a.kind === "max" ? (a.inclusive ? e.data > a.value : e.data >= a.value) && (s = this._getOrReturnCtx(e, s), pe(s, {
        code: se.too_big,
        maximum: a.value,
        type: "number",
        inclusive: a.inclusive,
        exact: !1,
        message: a.message
      }), o.dirty()) : a.kind === "multipleOf" ? ag(e.data, a.value) !== 0 && (s = this._getOrReturnCtx(e, s), pe(s, {
        code: se.not_multiple_of,
        multipleOf: a.value,
        message: a.message
      }), o.dirty()) : a.kind === "finite" ? Number.isFinite(e.data) || (s = this._getOrReturnCtx(e, s), pe(s, {
        code: se.not_finite,
        message: a.message
      }), o.dirty()) : He.assertNever(a);
    return { status: o.value, value: e.data };
  }
  gte(e, n) {
    return this.setLimit("min", e, !0, be.toString(n));
  }
  gt(e, n) {
    return this.setLimit("min", e, !1, be.toString(n));
  }
  lte(e, n) {
    return this.setLimit("max", e, !0, be.toString(n));
  }
  lt(e, n) {
    return this.setLimit("max", e, !1, be.toString(n));
  }
  setLimit(e, n, s, o) {
    return new Es({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: n,
          inclusive: s,
          message: be.toString(o)
        }
      ]
    });
  }
  _addCheck(e) {
    return new Es({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: be.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: be.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: be.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: be.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: be.toString(e)
    });
  }
  multipleOf(e, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: be.toString(n)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: be.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: be.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: be.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && He.isInteger(e.value));
  }
  get isFinite() {
    let e = null, n = null;
    for (const s of this._def.checks) {
      if (s.kind === "finite" || s.kind === "int" || s.kind === "multipleOf")
        return !0;
      s.kind === "min" ? (n === null || s.value > n) && (n = s.value) : s.kind === "max" && (e === null || s.value < e) && (e = s.value);
    }
    return Number.isFinite(n) && Number.isFinite(e);
  }
}
Es.create = (t) => new Es({
  checks: [],
  typeName: Te.ZodNumber,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...je(t)
});
class vo extends Be {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce)
      try {
        e.data = BigInt(e.data);
      } catch {
        return this._getInvalidInput(e);
      }
    if (this._getType(e) !== ge.bigint)
      return this._getInvalidInput(e);
    let s;
    const o = new tn();
    for (const a of this._def.checks)
      a.kind === "min" ? (a.inclusive ? e.data < a.value : e.data <= a.value) && (s = this._getOrReturnCtx(e, s), pe(s, {
        code: se.too_small,
        type: "bigint",
        minimum: a.value,
        inclusive: a.inclusive,
        message: a.message
      }), o.dirty()) : a.kind === "max" ? (a.inclusive ? e.data > a.value : e.data >= a.value) && (s = this._getOrReturnCtx(e, s), pe(s, {
        code: se.too_big,
        type: "bigint",
        maximum: a.value,
        inclusive: a.inclusive,
        message: a.message
      }), o.dirty()) : a.kind === "multipleOf" ? e.data % a.value !== BigInt(0) && (s = this._getOrReturnCtx(e, s), pe(s, {
        code: se.not_multiple_of,
        multipleOf: a.value,
        message: a.message
      }), o.dirty()) : He.assertNever(a);
    return { status: o.value, value: e.data };
  }
  _getInvalidInput(e) {
    const n = this._getOrReturnCtx(e);
    return pe(n, {
      code: se.invalid_type,
      expected: ge.bigint,
      received: n.parsedType
    }), Me;
  }
  gte(e, n) {
    return this.setLimit("min", e, !0, be.toString(n));
  }
  gt(e, n) {
    return this.setLimit("min", e, !1, be.toString(n));
  }
  lte(e, n) {
    return this.setLimit("max", e, !0, be.toString(n));
  }
  lt(e, n) {
    return this.setLimit("max", e, !1, be.toString(n));
  }
  setLimit(e, n, s, o) {
    return new vo({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: n,
          inclusive: s,
          message: be.toString(o)
        }
      ]
    });
  }
  _addCheck(e) {
    return new vo({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: be.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: be.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: be.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: be.toString(e)
    });
  }
  multipleOf(e, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: be.toString(n)
    });
  }
  get minValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
}
vo.create = (t) => new vo({
  checks: [],
  typeName: Te.ZodBigInt,
  coerce: (t == null ? void 0 : t.coerce) ?? !1,
  ...je(t)
});
class jr extends Be {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== ge.boolean) {
      const s = this._getOrReturnCtx(e);
      return pe(s, {
        code: se.invalid_type,
        expected: ge.boolean,
        received: s.parsedType
      }), Me;
    }
    return cn(e.data);
  }
}
jr.create = (t) => new jr({
  typeName: Te.ZodBoolean,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...je(t)
});
class go extends Be {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== ge.date) {
      const a = this._getOrReturnCtx(e);
      return pe(a, {
        code: se.invalid_type,
        expected: ge.date,
        received: a.parsedType
      }), Me;
    }
    if (Number.isNaN(e.data.getTime())) {
      const a = this._getOrReturnCtx(e);
      return pe(a, {
        code: se.invalid_date
      }), Me;
    }
    const s = new tn();
    let o;
    for (const a of this._def.checks)
      a.kind === "min" ? e.data.getTime() < a.value && (o = this._getOrReturnCtx(e, o), pe(o, {
        code: se.too_small,
        message: a.message,
        inclusive: !0,
        exact: !1,
        minimum: a.value,
        type: "date"
      }), s.dirty()) : a.kind === "max" ? e.data.getTime() > a.value && (o = this._getOrReturnCtx(e, o), pe(o, {
        code: se.too_big,
        message: a.message,
        inclusive: !0,
        exact: !1,
        maximum: a.value,
        type: "date"
      }), s.dirty()) : He.assertNever(a);
    return {
      status: s.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new go({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, n) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: be.toString(n)
    });
  }
  max(e, n) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: be.toString(n)
    });
  }
  get minDate() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e != null ? new Date(e) : null;
  }
}
go.create = (t) => new go({
  checks: [],
  coerce: (t == null ? void 0 : t.coerce) || !1,
  typeName: Te.ZodDate,
  ...je(t)
});
class uu extends Be {
  _parse(e) {
    if (this._getType(e) !== ge.symbol) {
      const s = this._getOrReturnCtx(e);
      return pe(s, {
        code: se.invalid_type,
        expected: ge.symbol,
        received: s.parsedType
      }), Me;
    }
    return cn(e.data);
  }
}
uu.create = (t) => new uu({
  typeName: Te.ZodSymbol,
  ...je(t)
});
class Nr extends Be {
  _parse(e) {
    if (this._getType(e) !== ge.undefined) {
      const s = this._getOrReturnCtx(e);
      return pe(s, {
        code: se.invalid_type,
        expected: ge.undefined,
        received: s.parsedType
      }), Me;
    }
    return cn(e.data);
  }
}
Nr.create = (t) => new Nr({
  typeName: Te.ZodUndefined,
  ...je(t)
});
class ka extends Be {
  _parse(e) {
    if (this._getType(e) !== ge.null) {
      const s = this._getOrReturnCtx(e);
      return pe(s, {
        code: se.invalid_type,
        expected: ge.null,
        received: s.parsedType
      }), Me;
    }
    return cn(e.data);
  }
}
ka.create = (t) => new ka({
  typeName: Te.ZodNull,
  ...je(t)
});
class ko extends Be {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return cn(e.data);
  }
}
ko.create = (t) => new ko({
  typeName: Te.ZodAny,
  ...je(t)
});
class Vr extends Be {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return cn(e.data);
  }
}
Vr.create = (t) => new Vr({
  typeName: Te.ZodUnknown,
  ...je(t)
});
class Zn extends Be {
  _parse(e) {
    const n = this._getOrReturnCtx(e);
    return pe(n, {
      code: se.invalid_type,
      expected: ge.never,
      received: n.parsedType
    }), Me;
  }
}
Zn.create = (t) => new Zn({
  typeName: Te.ZodNever,
  ...je(t)
});
class du extends Be {
  _parse(e) {
    if (this._getType(e) !== ge.undefined) {
      const s = this._getOrReturnCtx(e);
      return pe(s, {
        code: se.invalid_type,
        expected: ge.void,
        received: s.parsedType
      }), Me;
    }
    return cn(e.data);
  }
}
du.create = (t) => new du({
  typeName: Te.ZodVoid,
  ...je(t)
});
class $n extends Be {
  _parse(e) {
    const { ctx: n, status: s } = this._processInputParams(e), o = this._def;
    if (n.parsedType !== ge.array)
      return pe(n, {
        code: se.invalid_type,
        expected: ge.array,
        received: n.parsedType
      }), Me;
    if (o.exactLength !== null) {
      const i = n.data.length > o.exactLength.value, r = n.data.length < o.exactLength.value;
      (i || r) && (pe(n, {
        code: i ? se.too_big : se.too_small,
        minimum: r ? o.exactLength.value : void 0,
        maximum: i ? o.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: o.exactLength.message
      }), s.dirty());
    }
    if (o.minLength !== null && n.data.length < o.minLength.value && (pe(n, {
      code: se.too_small,
      minimum: o.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: o.minLength.message
    }), s.dirty()), o.maxLength !== null && n.data.length > o.maxLength.value && (pe(n, {
      code: se.too_big,
      maximum: o.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: o.maxLength.message
    }), s.dirty()), n.common.async)
      return Promise.all([...n.data].map((i, r) => o.type._parseAsync(new Gn(n, i, n.path, r)))).then((i) => tn.mergeArray(s, i));
    const a = [...n.data].map((i, r) => o.type._parseSync(new Gn(n, i, n.path, r)));
    return tn.mergeArray(s, a);
  }
  get element() {
    return this._def.type;
  }
  min(e, n) {
    return new $n({
      ...this._def,
      minLength: { value: e, message: be.toString(n) }
    });
  }
  max(e, n) {
    return new $n({
      ...this._def,
      maxLength: { value: e, message: be.toString(n) }
    });
  }
  length(e, n) {
    return new $n({
      ...this._def,
      exactLength: { value: e, message: be.toString(n) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
$n.create = (t, e) => new $n({
  type: t,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: Te.ZodArray,
  ...je(e)
});
function As(t) {
  if (t instanceof kt) {
    const e = {};
    for (const n in t.shape) {
      const s = t.shape[n];
      e[n] = In.create(As(s));
    }
    return new kt({
      ...t._def,
      shape: () => e
    });
  } else return t instanceof $n ? new $n({
    ...t._def,
    type: As(t.element)
  }) : t instanceof In ? In.create(As(t.unwrap())) : t instanceof _s ? _s.create(As(t.unwrap())) : t instanceof ms ? ms.create(t.items.map((e) => As(e))) : t;
}
class kt extends Be {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), n = He.objectKeys(e);
    return this._cached = { shape: e, keys: n }, this._cached;
  }
  _parse(e) {
    if (this._getType(e) !== ge.object) {
      const u = this._getOrReturnCtx(e);
      return pe(u, {
        code: se.invalid_type,
        expected: ge.object,
        received: u.parsedType
      }), Me;
    }
    const { status: s, ctx: o } = this._processInputParams(e), { shape: a, keys: i } = this._getCached(), r = [];
    if (!(this._def.catchall instanceof Zn && this._def.unknownKeys === "strip"))
      for (const u in o.data)
        i.includes(u) || r.push(u);
    const c = [];
    for (const u of i) {
      const d = a[u], m = o.data[u];
      c.push({
        key: { status: "valid", value: u },
        value: d._parse(new Gn(o, m, o.path, u)),
        alwaysSet: u in o.data
      });
    }
    if (this._def.catchall instanceof Zn) {
      const u = this._def.unknownKeys;
      if (u === "passthrough")
        for (const d of r)
          c.push({
            key: { status: "valid", value: d },
            value: { status: "valid", value: o.data[d] }
          });
      else if (u === "strict")
        r.length > 0 && (pe(o, {
          code: se.unrecognized_keys,
          keys: r
        }), s.dirty());
      else if (u !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const u = this._def.catchall;
      for (const d of r) {
        const m = o.data[d];
        c.push({
          key: { status: "valid", value: d },
          value: u._parse(
            new Gn(o, m, o.path, d)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: d in o.data
        });
      }
    }
    return o.common.async ? Promise.resolve().then(async () => {
      const u = [];
      for (const d of c) {
        const m = await d.key, _ = await d.value;
        u.push({
          key: m,
          value: _,
          alwaysSet: d.alwaysSet
        });
      }
      return u;
    }).then((u) => tn.mergeObjectSync(s, u)) : tn.mergeObjectSync(s, c);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return be.errToObj, new kt({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (n, s) => {
          var a, i;
          const o = ((i = (a = this._def).errorMap) == null ? void 0 : i.call(a, n, s).message) ?? s.defaultError;
          return n.code === "unrecognized_keys" ? {
            message: be.errToObj(e).message ?? o
          } : {
            message: o
          };
        }
      } : {}
    });
  }
  strip() {
    return new kt({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new kt({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new kt({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new kt({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: Te.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, n) {
    return this.augment({ [e]: n });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new kt({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const n = {};
    for (const s of He.objectKeys(e))
      e[s] && this.shape[s] && (n[s] = this.shape[s]);
    return new kt({
      ...this._def,
      shape: () => n
    });
  }
  omit(e) {
    const n = {};
    for (const s of He.objectKeys(this.shape))
      e[s] || (n[s] = this.shape[s]);
    return new kt({
      ...this._def,
      shape: () => n
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return As(this);
  }
  partial(e) {
    const n = {};
    for (const s of He.objectKeys(this.shape)) {
      const o = this.shape[s];
      e && !e[s] ? n[s] = o : n[s] = o.optional();
    }
    return new kt({
      ...this._def,
      shape: () => n
    });
  }
  required(e) {
    const n = {};
    for (const s of He.objectKeys(this.shape))
      if (e && !e[s])
        n[s] = this.shape[s];
      else {
        let a = this.shape[s];
        for (; a instanceof In; )
          a = a._def.innerType;
        n[s] = a;
      }
    return new kt({
      ...this._def,
      shape: () => n
    });
  }
  keyof() {
    return op(He.objectKeys(this.shape));
  }
}
kt.create = (t, e) => new kt({
  shape: () => t,
  unknownKeys: "strip",
  catchall: Zn.create(),
  typeName: Te.ZodObject,
  ...je(e)
});
kt.strictCreate = (t, e) => new kt({
  shape: () => t,
  unknownKeys: "strict",
  catchall: Zn.create(),
  typeName: Te.ZodObject,
  ...je(e)
});
kt.lazycreate = (t, e) => new kt({
  shape: t,
  unknownKeys: "strip",
  catchall: Zn.create(),
  typeName: Te.ZodObject,
  ...je(e)
});
class ya extends Be {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), s = this._def.options;
    function o(a) {
      for (const r of a)
        if (r.result.status === "valid")
          return r.result;
      for (const r of a)
        if (r.result.status === "dirty")
          return n.common.issues.push(...r.ctx.common.issues), r.result;
      const i = a.map((r) => new On(r.ctx.common.issues));
      return pe(n, {
        code: se.invalid_union,
        unionErrors: i
      }), Me;
    }
    if (n.common.async)
      return Promise.all(s.map(async (a) => {
        const i = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await a._parseAsync({
            data: n.data,
            path: n.path,
            parent: i
          }),
          ctx: i
        };
      })).then(o);
    {
      let a;
      const i = [];
      for (const c of s) {
        const u = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        }, d = c._parseSync({
          data: n.data,
          path: n.path,
          parent: u
        });
        if (d.status === "valid")
          return d;
        d.status === "dirty" && !a && (a = { result: d, ctx: u }), u.common.issues.length && i.push(u.common.issues);
      }
      if (a)
        return n.common.issues.push(...a.ctx.common.issues), a.result;
      const r = i.map((c) => new On(c));
      return pe(n, {
        code: se.invalid_union,
        unionErrors: r
      }), Me;
    }
  }
  get options() {
    return this._def.options;
  }
}
ya.create = (t, e) => new ya({
  options: t,
  typeName: Te.ZodUnion,
  ...je(e)
});
const Mn = (t) => t instanceof wa ? Mn(t.schema) : t instanceof fs ? Mn(t.innerType()) : t instanceof xa ? [t.value] : t instanceof hs ? t.options : t instanceof $a ? He.objectValues(t.enum) : t instanceof Sa ? Mn(t._def.innerType) : t instanceof Nr ? [void 0] : t instanceof ka ? [null] : t instanceof In ? [void 0, ...Mn(t.unwrap())] : t instanceof _s ? [null, ...Mn(t.unwrap())] : t instanceof ap || t instanceof Ca ? Mn(t.unwrap()) : t instanceof Aa ? Mn(t._def.innerType) : [];
class hl extends Be {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    if (n.parsedType !== ge.object)
      return pe(n, {
        code: se.invalid_type,
        expected: ge.object,
        received: n.parsedType
      }), Me;
    const s = this.discriminator, o = n.data[s], a = this.optionsMap.get(o);
    return a ? n.common.async ? a._parseAsync({
      data: n.data,
      path: n.path,
      parent: n
    }) : a._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }) : (pe(n, {
      code: se.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [s]
    }), Me);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, n, s) {
    const o = /* @__PURE__ */ new Map();
    for (const a of n) {
      const i = Mn(a.shape[e]);
      if (!i.length)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const r of i) {
        if (o.has(r))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(r)}`);
        o.set(r, a);
      }
    }
    return new hl({
      typeName: Te.ZodDiscriminatedUnion,
      discriminator: e,
      options: n,
      optionsMap: o,
      ...je(s)
    });
  }
}
function Ur(t, e) {
  const n = Bn(t), s = Bn(e);
  if (t === e)
    return { valid: !0, data: t };
  if (n === ge.object && s === ge.object) {
    const o = He.objectKeys(e), a = He.objectKeys(t).filter((r) => o.indexOf(r) !== -1), i = { ...t, ...e };
    for (const r of a) {
      const c = Ur(t[r], e[r]);
      if (!c.valid)
        return { valid: !1 };
      i[r] = c.data;
    }
    return { valid: !0, data: i };
  } else if (n === ge.array && s === ge.array) {
    if (t.length !== e.length)
      return { valid: !1 };
    const o = [];
    for (let a = 0; a < t.length; a++) {
      const i = t[a], r = e[a], c = Ur(i, r);
      if (!c.valid)
        return { valid: !1 };
      o.push(c.data);
    }
    return { valid: !0, data: o };
  } else return n === ge.date && s === ge.date && +t == +e ? { valid: !0, data: t } : { valid: !1 };
}
class ba extends Be {
  _parse(e) {
    const { status: n, ctx: s } = this._processInputParams(e), o = (a, i) => {
      if (ru(a) || ru(i))
        return Me;
      const r = Ur(a.value, i.value);
      return r.valid ? ((lu(a) || lu(i)) && n.dirty(), { status: n.value, value: r.data }) : (pe(s, {
        code: se.invalid_intersection_types
      }), Me);
    };
    return s.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: s.data,
        path: s.path,
        parent: s
      }),
      this._def.right._parseAsync({
        data: s.data,
        path: s.path,
        parent: s
      })
    ]).then(([a, i]) => o(a, i)) : o(this._def.left._parseSync({
      data: s.data,
      path: s.path,
      parent: s
    }), this._def.right._parseSync({
      data: s.data,
      path: s.path,
      parent: s
    }));
  }
}
ba.create = (t, e, n) => new ba({
  left: t,
  right: e,
  typeName: Te.ZodIntersection,
  ...je(n)
});
class ms extends Be {
  _parse(e) {
    const { status: n, ctx: s } = this._processInputParams(e);
    if (s.parsedType !== ge.array)
      return pe(s, {
        code: se.invalid_type,
        expected: ge.array,
        received: s.parsedType
      }), Me;
    if (s.data.length < this._def.items.length)
      return pe(s, {
        code: se.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), Me;
    !this._def.rest && s.data.length > this._def.items.length && (pe(s, {
      code: se.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), n.dirty());
    const a = [...s.data].map((i, r) => {
      const c = this._def.items[r] || this._def.rest;
      return c ? c._parse(new Gn(s, i, s.path, r)) : null;
    }).filter((i) => !!i);
    return s.common.async ? Promise.all(a).then((i) => tn.mergeArray(n, i)) : tn.mergeArray(n, a);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new ms({
      ...this._def,
      rest: e
    });
  }
}
ms.create = (t, e) => {
  if (!Array.isArray(t))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new ms({
    items: t,
    typeName: Te.ZodTuple,
    rest: null,
    ...je(e)
  });
};
class pu extends Be {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: n, ctx: s } = this._processInputParams(e);
    if (s.parsedType !== ge.map)
      return pe(s, {
        code: se.invalid_type,
        expected: ge.map,
        received: s.parsedType
      }), Me;
    const o = this._def.keyType, a = this._def.valueType, i = [...s.data.entries()].map(([r, c], u) => ({
      key: o._parse(new Gn(s, r, s.path, [u, "key"])),
      value: a._parse(new Gn(s, c, s.path, [u, "value"]))
    }));
    if (s.common.async) {
      const r = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const c of i) {
          const u = await c.key, d = await c.value;
          if (u.status === "aborted" || d.status === "aborted")
            return Me;
          (u.status === "dirty" || d.status === "dirty") && n.dirty(), r.set(u.value, d.value);
        }
        return { status: n.value, value: r };
      });
    } else {
      const r = /* @__PURE__ */ new Map();
      for (const c of i) {
        const u = c.key, d = c.value;
        if (u.status === "aborted" || d.status === "aborted")
          return Me;
        (u.status === "dirty" || d.status === "dirty") && n.dirty(), r.set(u.value, d.value);
      }
      return { status: n.value, value: r };
    }
  }
}
pu.create = (t, e, n) => new pu({
  valueType: e,
  keyType: t,
  typeName: Te.ZodMap,
  ...je(n)
});
class yo extends Be {
  _parse(e) {
    const { status: n, ctx: s } = this._processInputParams(e);
    if (s.parsedType !== ge.set)
      return pe(s, {
        code: se.invalid_type,
        expected: ge.set,
        received: s.parsedType
      }), Me;
    const o = this._def;
    o.minSize !== null && s.data.size < o.minSize.value && (pe(s, {
      code: se.too_small,
      minimum: o.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: o.minSize.message
    }), n.dirty()), o.maxSize !== null && s.data.size > o.maxSize.value && (pe(s, {
      code: se.too_big,
      maximum: o.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: o.maxSize.message
    }), n.dirty());
    const a = this._def.valueType;
    function i(c) {
      const u = /* @__PURE__ */ new Set();
      for (const d of c) {
        if (d.status === "aborted")
          return Me;
        d.status === "dirty" && n.dirty(), u.add(d.value);
      }
      return { status: n.value, value: u };
    }
    const r = [...s.data.values()].map((c, u) => a._parse(new Gn(s, c, s.path, u)));
    return s.common.async ? Promise.all(r).then((c) => i(c)) : i(r);
  }
  min(e, n) {
    return new yo({
      ...this._def,
      minSize: { value: e, message: be.toString(n) }
    });
  }
  max(e, n) {
    return new yo({
      ...this._def,
      maxSize: { value: e, message: be.toString(n) }
    });
  }
  size(e, n) {
    return this.min(e, n).max(e, n);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
yo.create = (t, e) => new yo({
  valueType: t,
  minSize: null,
  maxSize: null,
  typeName: Te.ZodSet,
  ...je(e)
});
class wa extends Be {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    return this._def.getter()._parse({ data: n.data, path: n.path, parent: n });
  }
}
wa.create = (t, e) => new wa({
  getter: t,
  typeName: Te.ZodLazy,
  ...je(e)
});
class xa extends Be {
  _parse(e) {
    if (e.data !== this._def.value) {
      const n = this._getOrReturnCtx(e);
      return pe(n, {
        received: n.data,
        code: se.invalid_literal,
        expected: this._def.value
      }), Me;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
xa.create = (t, e) => new xa({
  value: t,
  typeName: Te.ZodLiteral,
  ...je(e)
});
function op(t, e) {
  return new hs({
    values: t,
    typeName: Te.ZodEnum,
    ...je(e)
  });
}
class hs extends Be {
  _parse(e) {
    if (typeof e.data != "string") {
      const n = this._getOrReturnCtx(e), s = this._def.values;
      return pe(n, {
        expected: He.joinValues(s),
        received: n.parsedType,
        code: se.invalid_type
      }), Me;
    }
    if (this._cache || (this._cache = new Set(this._def.values)), !this._cache.has(e.data)) {
      const n = this._getOrReturnCtx(e), s = this._def.values;
      return pe(n, {
        received: n.data,
        code: se.invalid_enum_value,
        options: s
      }), Me;
    }
    return cn(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const n of this._def.values)
      e[n] = n;
    return e;
  }
  get Values() {
    const e = {};
    for (const n of this._def.values)
      e[n] = n;
    return e;
  }
  get Enum() {
    const e = {};
    for (const n of this._def.values)
      e[n] = n;
    return e;
  }
  extract(e, n = this._def) {
    return hs.create(e, {
      ...this._def,
      ...n
    });
  }
  exclude(e, n = this._def) {
    return hs.create(this.options.filter((s) => !e.includes(s)), {
      ...this._def,
      ...n
    });
  }
}
hs.create = op;
class $a extends Be {
  _parse(e) {
    const n = He.getValidEnumValues(this._def.values), s = this._getOrReturnCtx(e);
    if (s.parsedType !== ge.string && s.parsedType !== ge.number) {
      const o = He.objectValues(n);
      return pe(s, {
        expected: He.joinValues(o),
        received: s.parsedType,
        code: se.invalid_type
      }), Me;
    }
    if (this._cache || (this._cache = new Set(He.getValidEnumValues(this._def.values))), !this._cache.has(e.data)) {
      const o = He.objectValues(n);
      return pe(s, {
        received: s.data,
        code: se.invalid_enum_value,
        options: o
      }), Me;
    }
    return cn(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
$a.create = (t, e) => new $a({
  values: t,
  typeName: Te.ZodNativeEnum,
  ...je(e)
});
class za extends Be {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    if (n.parsedType !== ge.promise && n.common.async === !1)
      return pe(n, {
        code: se.invalid_type,
        expected: ge.promise,
        received: n.parsedType
      }), Me;
    const s = n.parsedType === ge.promise ? n.data : Promise.resolve(n.data);
    return cn(s.then((o) => this._def.type.parseAsync(o, {
      path: n.path,
      errorMap: n.common.contextualErrorMap
    })));
  }
}
za.create = (t, e) => new za({
  type: t,
  typeName: Te.ZodPromise,
  ...je(e)
});
class fs extends Be {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === Te.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: n, ctx: s } = this._processInputParams(e), o = this._def.effect || null, a = {
      addIssue: (i) => {
        pe(s, i), i.fatal ? n.abort() : n.dirty();
      },
      get path() {
        return s.path;
      }
    };
    if (a.addIssue = a.addIssue.bind(a), o.type === "preprocess") {
      const i = o.transform(s.data, a);
      if (s.common.async)
        return Promise.resolve(i).then(async (r) => {
          if (n.value === "aborted")
            return Me;
          const c = await this._def.schema._parseAsync({
            data: r,
            path: s.path,
            parent: s
          });
          return c.status === "aborted" ? Me : c.status === "dirty" || n.value === "dirty" ? co(c.value) : c;
        });
      {
        if (n.value === "aborted")
          return Me;
        const r = this._def.schema._parseSync({
          data: i,
          path: s.path,
          parent: s
        });
        return r.status === "aborted" ? Me : r.status === "dirty" || n.value === "dirty" ? co(r.value) : r;
      }
    }
    if (o.type === "refinement") {
      const i = (r) => {
        const c = o.refinement(r, a);
        if (s.common.async)
          return Promise.resolve(c);
        if (c instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return r;
      };
      if (s.common.async === !1) {
        const r = this._def.schema._parseSync({
          data: s.data,
          path: s.path,
          parent: s
        });
        return r.status === "aborted" ? Me : (r.status === "dirty" && n.dirty(), i(r.value), { status: n.value, value: r.value });
      } else
        return this._def.schema._parseAsync({ data: s.data, path: s.path, parent: s }).then((r) => r.status === "aborted" ? Me : (r.status === "dirty" && n.dirty(), i(r.value).then(() => ({ status: n.value, value: r.value }))));
    }
    if (o.type === "transform")
      if (s.common.async === !1) {
        const i = this._def.schema._parseSync({
          data: s.data,
          path: s.path,
          parent: s
        });
        if (!Is(i))
          return Me;
        const r = o.transform(i.value, a);
        if (r instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: n.value, value: r };
      } else
        return this._def.schema._parseAsync({ data: s.data, path: s.path, parent: s }).then((i) => Is(i) ? Promise.resolve(o.transform(i.value, a)).then((r) => ({
          status: n.value,
          value: r
        })) : Me);
    He.assertNever(o);
  }
}
fs.create = (t, e, n) => new fs({
  schema: t,
  typeName: Te.ZodEffects,
  effect: e,
  ...je(n)
});
fs.createWithPreprocess = (t, e, n) => new fs({
  schema: e,
  effect: { type: "preprocess", transform: t },
  typeName: Te.ZodEffects,
  ...je(n)
});
class In extends Be {
  _parse(e) {
    return this._getType(e) === ge.undefined ? cn(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
In.create = (t, e) => new In({
  innerType: t,
  typeName: Te.ZodOptional,
  ...je(e)
});
class _s extends Be {
  _parse(e) {
    return this._getType(e) === ge.null ? cn(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
_s.create = (t, e) => new _s({
  innerType: t,
  typeName: Te.ZodNullable,
  ...je(e)
});
class Sa extends Be {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    let s = n.data;
    return n.parsedType === ge.undefined && (s = this._def.defaultValue()), this._def.innerType._parse({
      data: s,
      path: n.path,
      parent: n
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
Sa.create = (t, e) => new Sa({
  innerType: t,
  typeName: Te.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...je(e)
});
class Aa extends Be {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), s = {
      ...n,
      common: {
        ...n.common,
        issues: []
      }
    }, o = this._def.innerType._parse({
      data: s.data,
      path: s.path,
      parent: {
        ...s
      }
    });
    return ga(o) ? o.then((a) => ({
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new On(s.common.issues);
        },
        input: s.data
      })
    })) : {
      status: "valid",
      value: o.status === "valid" ? o.value : this._def.catchValue({
        get error() {
          return new On(s.common.issues);
        },
        input: s.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
Aa.create = (t, e) => new Aa({
  innerType: t,
  typeName: Te.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...je(e)
});
class mu extends Be {
  _parse(e) {
    if (this._getType(e) !== ge.nan) {
      const s = this._getOrReturnCtx(e);
      return pe(s, {
        code: se.invalid_type,
        expected: ge.nan,
        received: s.parsedType
      }), Me;
    }
    return { status: "valid", value: e.data };
  }
}
mu.create = (t) => new mu({
  typeName: Te.ZodNaN,
  ...je(t)
});
class ap extends Be {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), s = n.data;
    return this._def.type._parse({
      data: s,
      path: n.path,
      parent: n
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class fl extends Be {
  _parse(e) {
    const { status: n, ctx: s } = this._processInputParams(e);
    if (s.common.async)
      return (async () => {
        const a = await this._def.in._parseAsync({
          data: s.data,
          path: s.path,
          parent: s
        });
        return a.status === "aborted" ? Me : a.status === "dirty" ? (n.dirty(), co(a.value)) : this._def.out._parseAsync({
          data: a.value,
          path: s.path,
          parent: s
        });
      })();
    {
      const o = this._def.in._parseSync({
        data: s.data,
        path: s.path,
        parent: s
      });
      return o.status === "aborted" ? Me : o.status === "dirty" ? (n.dirty(), {
        status: "dirty",
        value: o.value
      }) : this._def.out._parseSync({
        data: o.value,
        path: s.path,
        parent: s
      });
    }
  }
  static create(e, n) {
    return new fl({
      in: e,
      out: n,
      typeName: Te.ZodPipeline
    });
  }
}
class Ca extends Be {
  _parse(e) {
    const n = this._def.innerType._parse(e), s = (o) => (Is(o) && (o.value = Object.freeze(o.value)), o);
    return ga(n) ? n.then((o) => s(o)) : s(n);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Ca.create = (t, e) => new Ca({
  innerType: t,
  typeName: Te.ZodReadonly,
  ...je(e)
});
function hu(t, e) {
  const n = typeof t == "function" ? t(e) : typeof t == "string" ? { message: t } : t;
  return typeof n == "string" ? { message: n } : n;
}
function ip(t, e = {}, n) {
  return t ? ko.create().superRefine((s, o) => {
    const a = t(s);
    if (a instanceof Promise)
      return a.then((i) => {
        if (!i) {
          const r = hu(e, s), c = r.fatal ?? n ?? !0;
          o.addIssue({ code: "custom", ...r, fatal: c });
        }
      });
    if (!a) {
      const i = hu(e, s), r = i.fatal ?? n ?? !0;
      o.addIssue({ code: "custom", ...i, fatal: r });
    }
  }) : ko.create();
}
var Te;
(function(t) {
  t.ZodString = "ZodString", t.ZodNumber = "ZodNumber", t.ZodNaN = "ZodNaN", t.ZodBigInt = "ZodBigInt", t.ZodBoolean = "ZodBoolean", t.ZodDate = "ZodDate", t.ZodSymbol = "ZodSymbol", t.ZodUndefined = "ZodUndefined", t.ZodNull = "ZodNull", t.ZodAny = "ZodAny", t.ZodUnknown = "ZodUnknown", t.ZodNever = "ZodNever", t.ZodVoid = "ZodVoid", t.ZodArray = "ZodArray", t.ZodObject = "ZodObject", t.ZodUnion = "ZodUnion", t.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", t.ZodIntersection = "ZodIntersection", t.ZodTuple = "ZodTuple", t.ZodRecord = "ZodRecord", t.ZodMap = "ZodMap", t.ZodSet = "ZodSet", t.ZodFunction = "ZodFunction", t.ZodLazy = "ZodLazy", t.ZodLiteral = "ZodLiteral", t.ZodEnum = "ZodEnum", t.ZodEffects = "ZodEffects", t.ZodNativeEnum = "ZodNativeEnum", t.ZodOptional = "ZodOptional", t.ZodNullable = "ZodNullable", t.ZodDefault = "ZodDefault", t.ZodCatch = "ZodCatch", t.ZodPromise = "ZodPromise", t.ZodBranded = "ZodBranded", t.ZodPipeline = "ZodPipeline", t.ZodReadonly = "ZodReadonly";
})(Te || (Te = {}));
const ig = (t, e = {
  message: `Input not instance of ${t.name}`
}) => ip((n) => n instanceof t, e), U = qn.create, O = Es.create, Wt = jr.create, ss = go.create, bo = ka.create;
ko.create;
const rg = Vr.create;
Zn.create;
const rt = $n.create, B = kt.create, Kn = ya.create, _l = hl.create;
ba.create;
const Xn = ms.create, vl = wa.create, at = xa.create;
hs.create;
const un = $a.create;
za.create;
In.create;
_s.create;
const Ot = [];
for (let t = 0; t < 256; ++t)
  Ot.push((t + 256).toString(16).slice(1));
function lg(t, e = 0) {
  return (Ot[t[e + 0]] + Ot[t[e + 1]] + Ot[t[e + 2]] + Ot[t[e + 3]] + "-" + Ot[t[e + 4]] + Ot[t[e + 5]] + "-" + Ot[t[e + 6]] + Ot[t[e + 7]] + "-" + Ot[t[e + 8]] + Ot[t[e + 9]] + "-" + Ot[t[e + 10]] + Ot[t[e + 11]] + Ot[t[e + 12]] + Ot[t[e + 13]] + Ot[t[e + 14]] + Ot[t[e + 15]]).toLowerCase();
}
let mr;
const cg = new Uint8Array(16);
function ug() {
  if (!mr) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    mr = crypto.getRandomValues.bind(crypto);
  }
  return mr(cg);
}
const dg = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), fu = { randomUUID: dg };
function rp(t, e, n) {
  var o;
  if (fu.randomUUID && !t)
    return fu.randomUUID();
  t = t || {};
  const s = t.random ?? ((o = t.rng) == null ? void 0 : o.call(t)) ?? ug();
  if (s.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return s[6] = s[6] & 15 | 64, s[8] = s[8] & 63 | 128, lg(s);
}
function lp(t, e) {
  return function() {
    return t.apply(e, arguments);
  };
}
const { toString: pg } = Object.prototype, { getPrototypeOf: gl } = Object, { iterator: Ba, toStringTag: cp } = Symbol, qa = /* @__PURE__ */ ((t) => (e) => {
  const n = pg.call(e);
  return t[n] || (t[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), gn = (t) => (t = t.toLowerCase(), (e) => qa(e) === t), Ha = (t) => (e) => typeof e === t, { isArray: Vs } = Array, Os = Ha("undefined");
function zo(t) {
  return t !== null && !Os(t) && t.constructor !== null && !Os(t.constructor) && Gt(t.constructor.isBuffer) && t.constructor.isBuffer(t);
}
const up = gn("ArrayBuffer");
function mg(t) {
  let e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(t) : e = t && t.buffer && up(t.buffer), e;
}
const hg = Ha("string"), Gt = Ha("function"), dp = Ha("number"), So = (t) => t !== null && typeof t == "object", fg = (t) => t === !0 || t === !1, ua = (t) => {
  if (qa(t) !== "object")
    return !1;
  const e = gl(t);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(cp in t) && !(Ba in t);
}, _g = (t) => {
  if (!So(t) || zo(t))
    return !1;
  try {
    return Object.keys(t).length === 0 && Object.getPrototypeOf(t) === Object.prototype;
  } catch {
    return !1;
  }
}, vg = gn("Date"), gg = gn("File"), kg = gn("Blob"), yg = gn("FileList"), bg = (t) => So(t) && Gt(t.pipe), wg = (t) => {
  let e;
  return t && (typeof FormData == "function" && t instanceof FormData || Gt(t.append) && ((e = qa(t)) === "formdata" || // detect form-data instance
  e === "object" && Gt(t.toString) && t.toString() === "[object FormData]"));
}, xg = gn("URLSearchParams"), [$g, zg, Sg, Ag] = ["ReadableStream", "Request", "Response", "Headers"].map(gn), Cg = (t) => t.trim ? t.trim() : t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Ao(t, e, { allOwnKeys: n = !1 } = {}) {
  if (t === null || typeof t > "u")
    return;
  let s, o;
  if (typeof t != "object" && (t = [t]), Vs(t))
    for (s = 0, o = t.length; s < o; s++)
      e.call(null, t[s], s, t);
  else {
    if (zo(t))
      return;
    const a = n ? Object.getOwnPropertyNames(t) : Object.keys(t), i = a.length;
    let r;
    for (s = 0; s < i; s++)
      r = a[s], e.call(null, t[r], r, t);
  }
}
function pp(t, e) {
  if (zo(t))
    return null;
  e = e.toLowerCase();
  const n = Object.keys(t);
  let s = n.length, o;
  for (; s-- > 0; )
    if (o = n[s], e === o.toLowerCase())
      return o;
  return null;
}
const os = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, mp = (t) => !Os(t) && t !== os;
function Fr() {
  const { caseless: t, skipUndefined: e } = mp(this) && this || {}, n = {}, s = (o, a) => {
    const i = t && pp(n, a) || a;
    ua(n[i]) && ua(o) ? n[i] = Fr(n[i], o) : ua(o) ? n[i] = Fr({}, o) : Vs(o) ? n[i] = o.slice() : (!e || !Os(o)) && (n[i] = o);
  };
  for (let o = 0, a = arguments.length; o < a; o++)
    arguments[o] && Ao(arguments[o], s);
  return n;
}
const Pg = (t, e, n, { allOwnKeys: s } = {}) => (Ao(e, (o, a) => {
  n && Gt(o) ? t[a] = lp(o, n) : t[a] = o;
}, { allOwnKeys: s }), t), Mg = (t) => (t.charCodeAt(0) === 65279 && (t = t.slice(1)), t), Tg = (t, e, n, s) => {
  t.prototype = Object.create(e.prototype, s), t.prototype.constructor = t, Object.defineProperty(t, "super", {
    value: e.prototype
  }), n && Object.assign(t.prototype, n);
}, Ig = (t, e, n, s) => {
  let o, a, i;
  const r = {};
  if (e = e || {}, t == null) return e;
  do {
    for (o = Object.getOwnPropertyNames(t), a = o.length; a-- > 0; )
      i = o[a], (!s || s(i, t, e)) && !r[i] && (e[i] = t[i], r[i] = !0);
    t = n !== !1 && gl(t);
  } while (t && (!n || n(t, e)) && t !== Object.prototype);
  return e;
}, Eg = (t, e, n) => {
  t = String(t), (n === void 0 || n > t.length) && (n = t.length), n -= e.length;
  const s = t.indexOf(e, n);
  return s !== -1 && s === n;
}, Og = (t) => {
  if (!t) return null;
  if (Vs(t)) return t;
  let e = t.length;
  if (!dp(e)) return null;
  const n = new Array(e);
  for (; e-- > 0; )
    n[e] = t[e];
  return n;
}, Rg = /* @__PURE__ */ ((t) => (e) => t && e instanceof t)(typeof Uint8Array < "u" && gl(Uint8Array)), Lg = (t, e) => {
  const s = (t && t[Ba]).call(t);
  let o;
  for (; (o = s.next()) && !o.done; ) {
    const a = o.value;
    e.call(t, a[0], a[1]);
  }
}, Dg = (t, e) => {
  let n;
  const s = [];
  for (; (n = t.exec(e)) !== null; )
    s.push(n);
  return s;
}, jg = gn("HTMLFormElement"), Ng = (t) => t.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, s, o) {
    return s.toUpperCase() + o;
  }
), _u = (({ hasOwnProperty: t }) => (e, n) => t.call(e, n))(Object.prototype), Vg = gn("RegExp"), hp = (t, e) => {
  const n = Object.getOwnPropertyDescriptors(t), s = {};
  Ao(n, (o, a) => {
    let i;
    (i = e(o, a, t)) !== !1 && (s[a] = i || o);
  }), Object.defineProperties(t, s);
}, Ug = (t) => {
  hp(t, (e, n) => {
    if (Gt(t) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const s = t[n];
    if (Gt(s)) {
      if (e.enumerable = !1, "writable" in e) {
        e.writable = !1;
        return;
      }
      e.set || (e.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, Fg = (t, e) => {
  const n = {}, s = (o) => {
    o.forEach((a) => {
      n[a] = !0;
    });
  };
  return Vs(t) ? s(t) : s(String(t).split(e)), n;
}, Bg = () => {
}, qg = (t, e) => t != null && Number.isFinite(t = +t) ? t : e;
function Hg(t) {
  return !!(t && Gt(t.append) && t[cp] === "FormData" && t[Ba]);
}
const Wg = (t) => {
  const e = new Array(10), n = (s, o) => {
    if (So(s)) {
      if (e.indexOf(s) >= 0)
        return;
      if (zo(s))
        return s;
      if (!("toJSON" in s)) {
        e[o] = s;
        const a = Vs(s) ? [] : {};
        return Ao(s, (i, r) => {
          const c = n(i, o + 1);
          !Os(c) && (a[r] = c);
        }), e[o] = void 0, a;
      }
    }
    return s;
  };
  return n(t, 0);
}, Gg = gn("AsyncFunction"), Zg = (t) => t && (So(t) || Gt(t)) && Gt(t.then) && Gt(t.catch), fp = ((t, e) => t ? setImmediate : e ? ((n, s) => (os.addEventListener("message", ({ source: o, data: a }) => {
  o === os && a === n && s.length && s.shift()();
}, !1), (o) => {
  s.push(o), os.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(
  typeof setImmediate == "function",
  Gt(os.postMessage)
), Kg = typeof queueMicrotask < "u" ? queueMicrotask.bind(os) : typeof process < "u" && process.nextTick || fp, Xg = (t) => t != null && Gt(t[Ba]), W = {
  isArray: Vs,
  isArrayBuffer: up,
  isBuffer: zo,
  isFormData: wg,
  isArrayBufferView: mg,
  isString: hg,
  isNumber: dp,
  isBoolean: fg,
  isObject: So,
  isPlainObject: ua,
  isEmptyObject: _g,
  isReadableStream: $g,
  isRequest: zg,
  isResponse: Sg,
  isHeaders: Ag,
  isUndefined: Os,
  isDate: vg,
  isFile: gg,
  isBlob: kg,
  isRegExp: Vg,
  isFunction: Gt,
  isStream: bg,
  isURLSearchParams: xg,
  isTypedArray: Rg,
  isFileList: yg,
  forEach: Ao,
  merge: Fr,
  extend: Pg,
  trim: Cg,
  stripBOM: Mg,
  inherits: Tg,
  toFlatObject: Ig,
  kindOf: qa,
  kindOfTest: gn,
  endsWith: Eg,
  toArray: Og,
  forEachEntry: Lg,
  matchAll: Dg,
  isHTMLForm: jg,
  hasOwnProperty: _u,
  hasOwnProp: _u,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: hp,
  freezeMethods: Ug,
  toObjectSet: Fg,
  toCamelCase: Ng,
  noop: Bg,
  toFiniteNumber: qg,
  findKey: pp,
  global: os,
  isContextDefined: mp,
  isSpecCompliantForm: Hg,
  toJSONObject: Wg,
  isAsyncFn: Gg,
  isThenable: Zg,
  setImmediate: fp,
  asap: Kg,
  isIterable: Xg
};
function Oe(t, e, n, s, o) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = t, this.name = "AxiosError", e && (this.code = e), n && (this.config = n), s && (this.request = s), o && (this.response = o, this.status = o.status ? o.status : null);
}
W.inherits(Oe, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: W.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const _p = Oe.prototype, vp = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((t) => {
  vp[t] = { value: t };
});
Object.defineProperties(Oe, vp);
Object.defineProperty(_p, "isAxiosError", { value: !0 });
Oe.from = (t, e, n, s, o, a) => {
  const i = Object.create(_p);
  W.toFlatObject(t, i, function(d) {
    return d !== Error.prototype;
  }, (u) => u !== "isAxiosError");
  const r = t && t.message ? t.message : "Error", c = e == null && t ? t.code : e;
  return Oe.call(i, r, c, n, s, o), t && i.cause == null && Object.defineProperty(i, "cause", { value: t, configurable: !0 }), i.name = t && t.name || "Error", a && Object.assign(i, a), i;
};
const Qg = null;
function Br(t) {
  return W.isPlainObject(t) || W.isArray(t);
}
function gp(t) {
  return W.endsWith(t, "[]") ? t.slice(0, -2) : t;
}
function vu(t, e, n) {
  return t ? t.concat(e).map(function(o, a) {
    return o = gp(o), !n && a ? "[" + o + "]" : o;
  }).join(n ? "." : "") : e;
}
function Jg(t) {
  return W.isArray(t) && !t.some(Br);
}
const Yg = W.toFlatObject(W, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function Wa(t, e, n) {
  if (!W.isObject(t))
    throw new TypeError("target must be an object");
  e = e || new FormData(), n = W.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(z, h) {
    return !W.isUndefined(h[z]);
  });
  const s = n.metaTokens, o = n.visitor || d, a = n.dots, i = n.indexes, c = (n.Blob || typeof Blob < "u" && Blob) && W.isSpecCompliantForm(e);
  if (!W.isFunction(o))
    throw new TypeError("visitor must be a function");
  function u(v) {
    if (v === null) return "";
    if (W.isDate(v))
      return v.toISOString();
    if (W.isBoolean(v))
      return v.toString();
    if (!c && W.isBlob(v))
      throw new Oe("Blob is not supported. Use a Buffer instead.");
    return W.isArrayBuffer(v) || W.isTypedArray(v) ? c && typeof Blob == "function" ? new Blob([v]) : Buffer.from(v) : v;
  }
  function d(v, z, h) {
    let y = v;
    if (v && !h && typeof v == "object") {
      if (W.endsWith(z, "{}"))
        z = s ? z : z.slice(0, -2), v = JSON.stringify(v);
      else if (W.isArray(v) && Jg(v) || (W.isFileList(v) || W.endsWith(z, "[]")) && (y = W.toArray(v)))
        return z = gp(z), y.forEach(function(P, M) {
          !(W.isUndefined(P) || P === null) && e.append(
            // eslint-disable-next-line no-nested-ternary
            i === !0 ? vu([z], M, a) : i === null ? z : z + "[]",
            u(P)
          );
        }), !1;
    }
    return Br(v) ? !0 : (e.append(vu(h, z, a), u(v)), !1);
  }
  const m = [], _ = Object.assign(Yg, {
    defaultVisitor: d,
    convertValue: u,
    isVisitable: Br
  });
  function g(v, z) {
    if (!W.isUndefined(v)) {
      if (m.indexOf(v) !== -1)
        throw Error("Circular reference detected in " + z.join("."));
      m.push(v), W.forEach(v, function(y, w) {
        (!(W.isUndefined(y) || y === null) && o.call(
          e,
          y,
          W.isString(w) ? w.trim() : w,
          z,
          _
        )) === !0 && g(y, z ? z.concat(w) : [w]);
      }), m.pop();
    }
  }
  if (!W.isObject(t))
    throw new TypeError("data must be an object");
  return g(t), e;
}
function gu(t) {
  const e = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(t).replace(/[!'()~]|%20|%00/g, function(s) {
    return e[s];
  });
}
function kl(t, e) {
  this._pairs = [], t && Wa(t, this, e);
}
const kp = kl.prototype;
kp.append = function(e, n) {
  this._pairs.push([e, n]);
};
kp.toString = function(e) {
  const n = e ? function(s) {
    return e.call(this, s, gu);
  } : gu;
  return this._pairs.map(function(o) {
    return n(o[0]) + "=" + n(o[1]);
  }, "").join("&");
};
function e1(t) {
  return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function yp(t, e, n) {
  if (!e)
    return t;
  const s = n && n.encode || e1;
  W.isFunction(n) && (n = {
    serialize: n
  });
  const o = n && n.serialize;
  let a;
  if (o ? a = o(e, n) : a = W.isURLSearchParams(e) ? e.toString() : new kl(e, n).toString(s), a) {
    const i = t.indexOf("#");
    i !== -1 && (t = t.slice(0, i)), t += (t.indexOf("?") === -1 ? "?" : "&") + a;
  }
  return t;
}
class ku {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(e, n, s) {
    return this.handlers.push({
      fulfilled: e,
      rejected: n,
      synchronous: s ? s.synchronous : !1,
      runWhen: s ? s.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(e) {
    W.forEach(this.handlers, function(s) {
      s !== null && e(s);
    });
  }
}
const bp = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, t1 = typeof URLSearchParams < "u" ? URLSearchParams : kl, n1 = typeof FormData < "u" ? FormData : null, s1 = typeof Blob < "u" ? Blob : null, o1 = {
  isBrowser: !0,
  classes: {
    URLSearchParams: t1,
    FormData: n1,
    Blob: s1
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, yl = typeof window < "u" && typeof document < "u", qr = typeof navigator == "object" && navigator || void 0, a1 = yl && (!qr || ["ReactNative", "NativeScript", "NS"].indexOf(qr.product) < 0), i1 = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", r1 = yl && window.location.href || "http://localhost", l1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: yl,
  hasStandardBrowserEnv: a1,
  hasStandardBrowserWebWorkerEnv: i1,
  navigator: qr,
  origin: r1
}, Symbol.toStringTag, { value: "Module" })), Ut = {
  ...l1,
  ...o1
};
function c1(t, e) {
  return Wa(t, new Ut.classes.URLSearchParams(), {
    visitor: function(n, s, o, a) {
      return Ut.isNode && W.isBuffer(n) ? (this.append(s, n.toString("base64")), !1) : a.defaultVisitor.apply(this, arguments);
    },
    ...e
  });
}
function u1(t) {
  return W.matchAll(/\w+|\[(\w*)]/g, t).map((e) => e[0] === "[]" ? "" : e[1] || e[0]);
}
function d1(t) {
  const e = {}, n = Object.keys(t);
  let s;
  const o = n.length;
  let a;
  for (s = 0; s < o; s++)
    a = n[s], e[a] = t[a];
  return e;
}
function wp(t) {
  function e(n, s, o, a) {
    let i = n[a++];
    if (i === "__proto__") return !0;
    const r = Number.isFinite(+i), c = a >= n.length;
    return i = !i && W.isArray(o) ? o.length : i, c ? (W.hasOwnProp(o, i) ? o[i] = [o[i], s] : o[i] = s, !r) : ((!o[i] || !W.isObject(o[i])) && (o[i] = []), e(n, s, o[i], a) && W.isArray(o[i]) && (o[i] = d1(o[i])), !r);
  }
  if (W.isFormData(t) && W.isFunction(t.entries)) {
    const n = {};
    return W.forEachEntry(t, (s, o) => {
      e(u1(s), o, n, 0);
    }), n;
  }
  return null;
}
function p1(t, e, n) {
  if (W.isString(t))
    try {
      return (e || JSON.parse)(t), W.trim(t);
    } catch (s) {
      if (s.name !== "SyntaxError")
        throw s;
    }
  return (n || JSON.stringify)(t);
}
const Co = {
  transitional: bp,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(e, n) {
    const s = n.getContentType() || "", o = s.indexOf("application/json") > -1, a = W.isObject(e);
    if (a && W.isHTMLForm(e) && (e = new FormData(e)), W.isFormData(e))
      return o ? JSON.stringify(wp(e)) : e;
    if (W.isArrayBuffer(e) || W.isBuffer(e) || W.isStream(e) || W.isFile(e) || W.isBlob(e) || W.isReadableStream(e))
      return e;
    if (W.isArrayBufferView(e))
      return e.buffer;
    if (W.isURLSearchParams(e))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let r;
    if (a) {
      if (s.indexOf("application/x-www-form-urlencoded") > -1)
        return c1(e, this.formSerializer).toString();
      if ((r = W.isFileList(e)) || s.indexOf("multipart/form-data") > -1) {
        const c = this.env && this.env.FormData;
        return Wa(
          r ? { "files[]": e } : e,
          c && new c(),
          this.formSerializer
        );
      }
    }
    return a || o ? (n.setContentType("application/json", !1), p1(e)) : e;
  }],
  transformResponse: [function(e) {
    const n = this.transitional || Co.transitional, s = n && n.forcedJSONParsing, o = this.responseType === "json";
    if (W.isResponse(e) || W.isReadableStream(e))
      return e;
    if (e && W.isString(e) && (s && !this.responseType || o)) {
      const i = !(n && n.silentJSONParsing) && o;
      try {
        return JSON.parse(e, this.parseReviver);
      } catch (r) {
        if (i)
          throw r.name === "SyntaxError" ? Oe.from(r, Oe.ERR_BAD_RESPONSE, this, null, this.response) : r;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Ut.classes.FormData,
    Blob: Ut.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
W.forEach(["delete", "get", "head", "post", "put", "patch"], (t) => {
  Co.headers[t] = {};
});
const m1 = W.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), h1 = (t) => {
  const e = {};
  let n, s, o;
  return t && t.split(`
`).forEach(function(i) {
    o = i.indexOf(":"), n = i.substring(0, o).trim().toLowerCase(), s = i.substring(o + 1).trim(), !(!n || e[n] && m1[n]) && (n === "set-cookie" ? e[n] ? e[n].push(s) : e[n] = [s] : e[n] = e[n] ? e[n] + ", " + s : s);
  }), e;
}, yu = Symbol("internals");
function ao(t) {
  return t && String(t).trim().toLowerCase();
}
function da(t) {
  return t === !1 || t == null ? t : W.isArray(t) ? t.map(da) : String(t);
}
function f1(t) {
  const e = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let s;
  for (; s = n.exec(t); )
    e[s[1]] = s[2];
  return e;
}
const _1 = (t) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(t.trim());
function hr(t, e, n, s, o) {
  if (W.isFunction(s))
    return s.call(this, e, n);
  if (o && (e = n), !!W.isString(e)) {
    if (W.isString(s))
      return e.indexOf(s) !== -1;
    if (W.isRegExp(s))
      return s.test(e);
  }
}
function v1(t) {
  return t.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, n, s) => n.toUpperCase() + s);
}
function g1(t, e) {
  const n = W.toCamelCase(" " + e);
  ["get", "set", "has"].forEach((s) => {
    Object.defineProperty(t, s + n, {
      value: function(o, a, i) {
        return this[s].call(this, e, o, a, i);
      },
      configurable: !0
    });
  });
}
let Zt = class {
  constructor(e) {
    e && this.set(e);
  }
  set(e, n, s) {
    const o = this;
    function a(r, c, u) {
      const d = ao(c);
      if (!d)
        throw new Error("header name must be a non-empty string");
      const m = W.findKey(o, d);
      (!m || o[m] === void 0 || u === !0 || u === void 0 && o[m] !== !1) && (o[m || c] = da(r));
    }
    const i = (r, c) => W.forEach(r, (u, d) => a(u, d, c));
    if (W.isPlainObject(e) || e instanceof this.constructor)
      i(e, n);
    else if (W.isString(e) && (e = e.trim()) && !_1(e))
      i(h1(e), n);
    else if (W.isObject(e) && W.isIterable(e)) {
      let r = {}, c, u;
      for (const d of e) {
        if (!W.isArray(d))
          throw TypeError("Object iterator must return a key-value pair");
        r[u = d[0]] = (c = r[u]) ? W.isArray(c) ? [...c, d[1]] : [c, d[1]] : d[1];
      }
      i(r, n);
    } else
      e != null && a(n, e, s);
    return this;
  }
  get(e, n) {
    if (e = ao(e), e) {
      const s = W.findKey(this, e);
      if (s) {
        const o = this[s];
        if (!n)
          return o;
        if (n === !0)
          return f1(o);
        if (W.isFunction(n))
          return n.call(this, o, s);
        if (W.isRegExp(n))
          return n.exec(o);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, n) {
    if (e = ao(e), e) {
      const s = W.findKey(this, e);
      return !!(s && this[s] !== void 0 && (!n || hr(this, this[s], s, n)));
    }
    return !1;
  }
  delete(e, n) {
    const s = this;
    let o = !1;
    function a(i) {
      if (i = ao(i), i) {
        const r = W.findKey(s, i);
        r && (!n || hr(s, s[r], r, n)) && (delete s[r], o = !0);
      }
    }
    return W.isArray(e) ? e.forEach(a) : a(e), o;
  }
  clear(e) {
    const n = Object.keys(this);
    let s = n.length, o = !1;
    for (; s--; ) {
      const a = n[s];
      (!e || hr(this, this[a], a, e, !0)) && (delete this[a], o = !0);
    }
    return o;
  }
  normalize(e) {
    const n = this, s = {};
    return W.forEach(this, (o, a) => {
      const i = W.findKey(s, a);
      if (i) {
        n[i] = da(o), delete n[a];
        return;
      }
      const r = e ? v1(a) : String(a).trim();
      r !== a && delete n[a], n[r] = da(o), s[r] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const n = /* @__PURE__ */ Object.create(null);
    return W.forEach(this, (s, o) => {
      s != null && s !== !1 && (n[o] = e && W.isArray(s) ? s.join(", ") : s);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, n]) => e + ": " + n).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...n) {
    const s = new this(e);
    return n.forEach((o) => s.set(o)), s;
  }
  static accessor(e) {
    const s = (this[yu] = this[yu] = {
      accessors: {}
    }).accessors, o = this.prototype;
    function a(i) {
      const r = ao(i);
      s[r] || (g1(o, i), s[r] = !0);
    }
    return W.isArray(e) ? e.forEach(a) : a(e), this;
  }
};
Zt.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
W.reduceDescriptors(Zt.prototype, ({ value: t }, e) => {
  let n = e[0].toUpperCase() + e.slice(1);
  return {
    get: () => t,
    set(s) {
      this[n] = s;
    }
  };
});
W.freezeMethods(Zt);
function fr(t, e) {
  const n = this || Co, s = e || n, o = Zt.from(s.headers);
  let a = s.data;
  return W.forEach(t, function(r) {
    a = r.call(n, a, o.normalize(), e ? e.status : void 0);
  }), o.normalize(), a;
}
function xp(t) {
  return !!(t && t.__CANCEL__);
}
function Us(t, e, n) {
  Oe.call(this, t ?? "canceled", Oe.ERR_CANCELED, e, n), this.name = "CanceledError";
}
W.inherits(Us, Oe, {
  __CANCEL__: !0
});
function $p(t, e, n) {
  const s = n.config.validateStatus;
  !n.status || !s || s(n.status) ? t(n) : e(new Oe(
    "Request failed with status code " + n.status,
    [Oe.ERR_BAD_REQUEST, Oe.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function k1(t) {
  const e = /^([-+\w]{1,25})(:?\/\/|:)/.exec(t);
  return e && e[1] || "";
}
function y1(t, e) {
  t = t || 10;
  const n = new Array(t), s = new Array(t);
  let o = 0, a = 0, i;
  return e = e !== void 0 ? e : 1e3, function(c) {
    const u = Date.now(), d = s[a];
    i || (i = u), n[o] = c, s[o] = u;
    let m = a, _ = 0;
    for (; m !== o; )
      _ += n[m++], m = m % t;
    if (o = (o + 1) % t, o === a && (a = (a + 1) % t), u - i < e)
      return;
    const g = d && u - d;
    return g ? Math.round(_ * 1e3 / g) : void 0;
  };
}
function b1(t, e) {
  let n = 0, s = 1e3 / e, o, a;
  const i = (u, d = Date.now()) => {
    n = d, o = null, a && (clearTimeout(a), a = null), t(...u);
  };
  return [(...u) => {
    const d = Date.now(), m = d - n;
    m >= s ? i(u, d) : (o = u, a || (a = setTimeout(() => {
      a = null, i(o);
    }, s - m)));
  }, () => o && i(o)];
}
const Pa = (t, e, n = 3) => {
  let s = 0;
  const o = y1(50, 250);
  return b1((a) => {
    const i = a.loaded, r = a.lengthComputable ? a.total : void 0, c = i - s, u = o(c), d = i <= r;
    s = i;
    const m = {
      loaded: i,
      total: r,
      progress: r ? i / r : void 0,
      bytes: c,
      rate: u || void 0,
      estimated: u && r && d ? (r - i) / u : void 0,
      event: a,
      lengthComputable: r != null,
      [e ? "download" : "upload"]: !0
    };
    t(m);
  }, n);
}, bu = (t, e) => {
  const n = t != null;
  return [(s) => e[0]({
    lengthComputable: n,
    total: t,
    loaded: s
  }), e[1]];
}, wu = (t) => (...e) => W.asap(() => t(...e)), w1 = Ut.hasStandardBrowserEnv ? /* @__PURE__ */ ((t, e) => (n) => (n = new URL(n, Ut.origin), t.protocol === n.protocol && t.host === n.host && (e || t.port === n.port)))(
  new URL(Ut.origin),
  Ut.navigator && /(msie|trident)/i.test(Ut.navigator.userAgent)
) : () => !0, x1 = Ut.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(t, e, n, s, o, a) {
      const i = [t + "=" + encodeURIComponent(e)];
      W.isNumber(n) && i.push("expires=" + new Date(n).toGMTString()), W.isString(s) && i.push("path=" + s), W.isString(o) && i.push("domain=" + o), a === !0 && i.push("secure"), document.cookie = i.join("; ");
    },
    read(t) {
      const e = document.cookie.match(new RegExp("(^|;\\s*)(" + t + ")=([^;]*)"));
      return e ? decodeURIComponent(e[3]) : null;
    },
    remove(t) {
      this.write(t, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function $1(t) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(t);
}
function z1(t, e) {
  return e ? t.replace(/\/?\/$/, "") + "/" + e.replace(/^\/+/, "") : t;
}
function zp(t, e, n) {
  let s = !$1(e);
  return t && (s || n == !1) ? z1(t, e) : e;
}
const xu = (t) => t instanceof Zt ? { ...t } : t;
function vs(t, e) {
  e = e || {};
  const n = {};
  function s(u, d, m, _) {
    return W.isPlainObject(u) && W.isPlainObject(d) ? W.merge.call({ caseless: _ }, u, d) : W.isPlainObject(d) ? W.merge({}, d) : W.isArray(d) ? d.slice() : d;
  }
  function o(u, d, m, _) {
    if (W.isUndefined(d)) {
      if (!W.isUndefined(u))
        return s(void 0, u, m, _);
    } else return s(u, d, m, _);
  }
  function a(u, d) {
    if (!W.isUndefined(d))
      return s(void 0, d);
  }
  function i(u, d) {
    if (W.isUndefined(d)) {
      if (!W.isUndefined(u))
        return s(void 0, u);
    } else return s(void 0, d);
  }
  function r(u, d, m) {
    if (m in e)
      return s(u, d);
    if (m in t)
      return s(void 0, u);
  }
  const c = {
    url: a,
    method: a,
    data: a,
    baseURL: i,
    transformRequest: i,
    transformResponse: i,
    paramsSerializer: i,
    timeout: i,
    timeoutMessage: i,
    withCredentials: i,
    withXSRFToken: i,
    adapter: i,
    responseType: i,
    xsrfCookieName: i,
    xsrfHeaderName: i,
    onUploadProgress: i,
    onDownloadProgress: i,
    decompress: i,
    maxContentLength: i,
    maxBodyLength: i,
    beforeRedirect: i,
    transport: i,
    httpAgent: i,
    httpsAgent: i,
    cancelToken: i,
    socketPath: i,
    responseEncoding: i,
    validateStatus: r,
    headers: (u, d, m) => o(xu(u), xu(d), m, !0)
  };
  return W.forEach(Object.keys({ ...t, ...e }), function(d) {
    const m = c[d] || o, _ = m(t[d], e[d], d);
    W.isUndefined(_) && m !== r || (n[d] = _);
  }), n;
}
const Sp = (t) => {
  const e = vs({}, t);
  let { data: n, withXSRFToken: s, xsrfHeaderName: o, xsrfCookieName: a, headers: i, auth: r } = e;
  if (e.headers = i = Zt.from(i), e.url = yp(zp(e.baseURL, e.url, e.allowAbsoluteUrls), t.params, t.paramsSerializer), r && i.set(
    "Authorization",
    "Basic " + btoa((r.username || "") + ":" + (r.password ? unescape(encodeURIComponent(r.password)) : ""))
  ), W.isFormData(n)) {
    if (Ut.hasStandardBrowserEnv || Ut.hasStandardBrowserWebWorkerEnv)
      i.setContentType(void 0);
    else if (W.isFunction(n.getHeaders)) {
      const c = n.getHeaders(), u = ["content-type", "content-length"];
      Object.entries(c).forEach(([d, m]) => {
        u.includes(d.toLowerCase()) && i.set(d, m);
      });
    }
  }
  if (Ut.hasStandardBrowserEnv && (s && W.isFunction(s) && (s = s(e)), s || s !== !1 && w1(e.url))) {
    const c = o && a && x1.read(a);
    c && i.set(o, c);
  }
  return e;
}, S1 = typeof XMLHttpRequest < "u", A1 = S1 && function(t) {
  return new Promise(function(n, s) {
    const o = Sp(t);
    let a = o.data;
    const i = Zt.from(o.headers).normalize();
    let { responseType: r, onUploadProgress: c, onDownloadProgress: u } = o, d, m, _, g, v;
    function z() {
      g && g(), v && v(), o.cancelToken && o.cancelToken.unsubscribe(d), o.signal && o.signal.removeEventListener("abort", d);
    }
    let h = new XMLHttpRequest();
    h.open(o.method.toUpperCase(), o.url, !0), h.timeout = o.timeout;
    function y() {
      if (!h)
        return;
      const P = Zt.from(
        "getAllResponseHeaders" in h && h.getAllResponseHeaders()
      ), E = {
        data: !r || r === "text" || r === "json" ? h.responseText : h.response,
        status: h.status,
        statusText: h.statusText,
        headers: P,
        config: t,
        request: h
      };
      $p(function(j) {
        n(j), z();
      }, function(j) {
        s(j), z();
      }, E), h = null;
    }
    "onloadend" in h ? h.onloadend = y : h.onreadystatechange = function() {
      !h || h.readyState !== 4 || h.status === 0 && !(h.responseURL && h.responseURL.indexOf("file:") === 0) || setTimeout(y);
    }, h.onabort = function() {
      h && (s(new Oe("Request aborted", Oe.ECONNABORTED, t, h)), h = null);
    }, h.onerror = function(M) {
      const E = M && M.message ? M.message : "Network Error", R = new Oe(E, Oe.ERR_NETWORK, t, h);
      R.event = M || null, s(R), h = null;
    }, h.ontimeout = function() {
      let M = o.timeout ? "timeout of " + o.timeout + "ms exceeded" : "timeout exceeded";
      const E = o.transitional || bp;
      o.timeoutErrorMessage && (M = o.timeoutErrorMessage), s(new Oe(
        M,
        E.clarifyTimeoutError ? Oe.ETIMEDOUT : Oe.ECONNABORTED,
        t,
        h
      )), h = null;
    }, a === void 0 && i.setContentType(null), "setRequestHeader" in h && W.forEach(i.toJSON(), function(M, E) {
      h.setRequestHeader(E, M);
    }), W.isUndefined(o.withCredentials) || (h.withCredentials = !!o.withCredentials), r && r !== "json" && (h.responseType = o.responseType), u && ([_, v] = Pa(u, !0), h.addEventListener("progress", _)), c && h.upload && ([m, g] = Pa(c), h.upload.addEventListener("progress", m), h.upload.addEventListener("loadend", g)), (o.cancelToken || o.signal) && (d = (P) => {
      h && (s(!P || P.type ? new Us(null, t, h) : P), h.abort(), h = null);
    }, o.cancelToken && o.cancelToken.subscribe(d), o.signal && (o.signal.aborted ? d() : o.signal.addEventListener("abort", d)));
    const w = k1(o.url);
    if (w && Ut.protocols.indexOf(w) === -1) {
      s(new Oe("Unsupported protocol " + w + ":", Oe.ERR_BAD_REQUEST, t));
      return;
    }
    h.send(a || null);
  });
}, C1 = (t, e) => {
  const { length: n } = t = t ? t.filter(Boolean) : [];
  if (e || n) {
    let s = new AbortController(), o;
    const a = function(u) {
      if (!o) {
        o = !0, r();
        const d = u instanceof Error ? u : this.reason;
        s.abort(d instanceof Oe ? d : new Us(d instanceof Error ? d.message : d));
      }
    };
    let i = e && setTimeout(() => {
      i = null, a(new Oe(`timeout ${e} of ms exceeded`, Oe.ETIMEDOUT));
    }, e);
    const r = () => {
      t && (i && clearTimeout(i), i = null, t.forEach((u) => {
        u.unsubscribe ? u.unsubscribe(a) : u.removeEventListener("abort", a);
      }), t = null);
    };
    t.forEach((u) => u.addEventListener("abort", a));
    const { signal: c } = s;
    return c.unsubscribe = () => W.asap(r), c;
  }
}, P1 = function* (t, e) {
  let n = t.byteLength;
  if (n < e) {
    yield t;
    return;
  }
  let s = 0, o;
  for (; s < n; )
    o = s + e, yield t.slice(s, o), s = o;
}, M1 = async function* (t, e) {
  for await (const n of T1(t))
    yield* P1(n, e);
}, T1 = async function* (t) {
  if (t[Symbol.asyncIterator]) {
    yield* t;
    return;
  }
  const e = t.getReader();
  try {
    for (; ; ) {
      const { done: n, value: s } = await e.read();
      if (n)
        break;
      yield s;
    }
  } finally {
    await e.cancel();
  }
}, $u = (t, e, n, s) => {
  const o = M1(t, e);
  let a = 0, i, r = (c) => {
    i || (i = !0, s && s(c));
  };
  return new ReadableStream({
    async pull(c) {
      try {
        const { done: u, value: d } = await o.next();
        if (u) {
          r(), c.close();
          return;
        }
        let m = d.byteLength;
        if (n) {
          let _ = a += m;
          n(_);
        }
        c.enqueue(new Uint8Array(d));
      } catch (u) {
        throw r(u), u;
      }
    },
    cancel(c) {
      return r(c), o.return();
    }
  }, {
    highWaterMark: 2
  });
}, zu = 64 * 1024, { isFunction: ta } = W, I1 = (({ Request: t, Response: e }) => ({
  Request: t,
  Response: e
}))(W.global), {
  ReadableStream: Su,
  TextEncoder: Au
} = W.global, Cu = (t, ...e) => {
  try {
    return !!t(...e);
  } catch {
    return !1;
  }
}, E1 = (t) => {
  t = W.merge.call({
    skipUndefined: !0
  }, I1, t);
  const { fetch: e, Request: n, Response: s } = t, o = e ? ta(e) : typeof fetch == "function", a = ta(n), i = ta(s);
  if (!o)
    return !1;
  const r = o && ta(Su), c = o && (typeof Au == "function" ? /* @__PURE__ */ ((v) => (z) => v.encode(z))(new Au()) : async (v) => new Uint8Array(await new n(v).arrayBuffer())), u = a && r && Cu(() => {
    let v = !1;
    const z = new n(Ut.origin, {
      body: new Su(),
      method: "POST",
      get duplex() {
        return v = !0, "half";
      }
    }).headers.has("Content-Type");
    return v && !z;
  }), d = i && r && Cu(() => W.isReadableStream(new s("").body)), m = {
    stream: d && ((v) => v.body)
  };
  o && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((v) => {
    !m[v] && (m[v] = (z, h) => {
      let y = z && z[v];
      if (y)
        return y.call(z);
      throw new Oe(`Response type '${v}' is not supported`, Oe.ERR_NOT_SUPPORT, h);
    });
  });
  const _ = async (v) => {
    if (v == null)
      return 0;
    if (W.isBlob(v))
      return v.size;
    if (W.isSpecCompliantForm(v))
      return (await new n(Ut.origin, {
        method: "POST",
        body: v
      }).arrayBuffer()).byteLength;
    if (W.isArrayBufferView(v) || W.isArrayBuffer(v))
      return v.byteLength;
    if (W.isURLSearchParams(v) && (v = v + ""), W.isString(v))
      return (await c(v)).byteLength;
  }, g = async (v, z) => {
    const h = W.toFiniteNumber(v.getContentLength());
    return h ?? _(z);
  };
  return async (v) => {
    let {
      url: z,
      method: h,
      data: y,
      signal: w,
      cancelToken: P,
      timeout: M,
      onDownloadProgress: E,
      onUploadProgress: R,
      responseType: j,
      headers: V,
      withCredentials: X = "same-origin",
      fetchOptions: Z
    } = Sp(v), ae = e || fetch;
    j = j ? (j + "").toLowerCase() : "text";
    let K = C1([w, P && P.toAbortSignal()], M), te = null;
    const ue = K && K.unsubscribe && (() => {
      K.unsubscribe();
    });
    let Ce;
    try {
      if (R && u && h !== "get" && h !== "head" && (Ce = await g(V, y)) !== 0) {
        let de = new n(z, {
          method: "POST",
          body: y,
          duplex: "half"
        }), $e;
        if (W.isFormData(y) && ($e = de.headers.get("content-type")) && V.setContentType($e), de.body) {
          const [Ze, Pe] = bu(
            Ce,
            Pa(wu(R))
          );
          y = $u(de.body, zu, Ze, Pe);
        }
      }
      W.isString(X) || (X = X ? "include" : "omit");
      const ne = a && "credentials" in n.prototype, ee = {
        ...Z,
        signal: K,
        method: h.toUpperCase(),
        headers: V.normalize().toJSON(),
        body: y,
        duplex: "half",
        credentials: ne ? X : void 0
      };
      te = a && new n(z, ee);
      let G = await (a ? ae(te, Z) : ae(z, ee));
      const oe = d && (j === "stream" || j === "response");
      if (d && (E || oe && ue)) {
        const de = {};
        ["status", "statusText", "headers"].forEach((ie) => {
          de[ie] = G[ie];
        });
        const $e = W.toFiniteNumber(G.headers.get("content-length")), [Ze, Pe] = E && bu(
          $e,
          Pa(wu(E), !0)
        ) || [];
        G = new s(
          $u(G.body, zu, Ze, () => {
            Pe && Pe(), ue && ue();
          }),
          de
        );
      }
      j = j || "text";
      let _e = await m[W.findKey(m, j) || "text"](G, v);
      return !oe && ue && ue(), await new Promise((de, $e) => {
        $p(de, $e, {
          data: _e,
          headers: Zt.from(G.headers),
          status: G.status,
          statusText: G.statusText,
          config: v,
          request: te
        });
      });
    } catch (ne) {
      throw ue && ue(), ne && ne.name === "TypeError" && /Load failed|fetch/i.test(ne.message) ? Object.assign(
        new Oe("Network Error", Oe.ERR_NETWORK, v, te),
        {
          cause: ne.cause || ne
        }
      ) : Oe.from(ne, ne && ne.code, v, te);
    }
  };
}, O1 = /* @__PURE__ */ new Map(), Ap = (t) => {
  let e = t ? t.env : {};
  const { fetch: n, Request: s, Response: o } = e, a = [
    s,
    o,
    n
  ];
  let i = a.length, r = i, c, u, d = O1;
  for (; r--; )
    c = a[r], u = d.get(c), u === void 0 && d.set(c, u = r ? /* @__PURE__ */ new Map() : E1(e)), d = u;
  return u;
};
Ap();
const Hr = {
  http: Qg,
  xhr: A1,
  fetch: {
    get: Ap
  }
};
W.forEach(Hr, (t, e) => {
  if (t) {
    try {
      Object.defineProperty(t, "name", { value: e });
    } catch {
    }
    Object.defineProperty(t, "adapterName", { value: e });
  }
});
const Pu = (t) => `- ${t}`, R1 = (t) => W.isFunction(t) || t === null || t === !1, Cp = {
  getAdapter: (t, e) => {
    t = W.isArray(t) ? t : [t];
    const { length: n } = t;
    let s, o;
    const a = {};
    for (let i = 0; i < n; i++) {
      s = t[i];
      let r;
      if (o = s, !R1(s) && (o = Hr[(r = String(s)).toLowerCase()], o === void 0))
        throw new Oe(`Unknown adapter '${r}'`);
      if (o && (W.isFunction(o) || (o = o.get(e))))
        break;
      a[r || "#" + i] = o;
    }
    if (!o) {
      const i = Object.entries(a).map(
        ([c, u]) => `adapter ${c} ` + (u === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let r = n ? i.length > 1 ? `since :
` + i.map(Pu).join(`
`) : " " + Pu(i[0]) : "as no adapter specified";
      throw new Oe(
        "There is no suitable adapter to dispatch the request " + r,
        "ERR_NOT_SUPPORT"
      );
    }
    return o;
  },
  adapters: Hr
};
function _r(t) {
  if (t.cancelToken && t.cancelToken.throwIfRequested(), t.signal && t.signal.aborted)
    throw new Us(null, t);
}
function Mu(t) {
  return _r(t), t.headers = Zt.from(t.headers), t.data = fr.call(
    t,
    t.transformRequest
  ), ["post", "put", "patch"].indexOf(t.method) !== -1 && t.headers.setContentType("application/x-www-form-urlencoded", !1), Cp.getAdapter(t.adapter || Co.adapter, t)(t).then(function(s) {
    return _r(t), s.data = fr.call(
      t,
      t.transformResponse,
      s
    ), s.headers = Zt.from(s.headers), s;
  }, function(s) {
    return xp(s) || (_r(t), s && s.response && (s.response.data = fr.call(
      t,
      t.transformResponse,
      s.response
    ), s.response.headers = Zt.from(s.response.headers))), Promise.reject(s);
  });
}
const Pp = "1.12.2", Ga = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((t, e) => {
  Ga[t] = function(s) {
    return typeof s === t || "a" + (e < 1 ? "n " : " ") + t;
  };
});
const Tu = {};
Ga.transitional = function(e, n, s) {
  function o(a, i) {
    return "[Axios v" + Pp + "] Transitional option '" + a + "'" + i + (s ? ". " + s : "");
  }
  return (a, i, r) => {
    if (e === !1)
      throw new Oe(
        o(i, " has been removed" + (n ? " in " + n : "")),
        Oe.ERR_DEPRECATED
      );
    return n && !Tu[i] && (Tu[i] = !0, console.warn(
      o(
        i,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), e ? e(a, i, r) : !0;
  };
};
Ga.spelling = function(e) {
  return (n, s) => (console.warn(`${s} is likely a misspelling of ${e}`), !0);
};
function L1(t, e, n) {
  if (typeof t != "object")
    throw new Oe("options must be an object", Oe.ERR_BAD_OPTION_VALUE);
  const s = Object.keys(t);
  let o = s.length;
  for (; o-- > 0; ) {
    const a = s[o], i = e[a];
    if (i) {
      const r = t[a], c = r === void 0 || i(r, a, t);
      if (c !== !0)
        throw new Oe("option " + a + " must be " + c, Oe.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new Oe("Unknown option " + a, Oe.ERR_BAD_OPTION);
  }
}
const pa = {
  assertOptions: L1,
  validators: Ga
}, wn = pa.validators;
let ls = class {
  constructor(e) {
    this.defaults = e || {}, this.interceptors = {
      request: new ku(),
      response: new ku()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(e, n) {
    try {
      return await this._request(e, n);
    } catch (s) {
      if (s instanceof Error) {
        let o = {};
        Error.captureStackTrace ? Error.captureStackTrace(o) : o = new Error();
        const a = o.stack ? o.stack.replace(/^.+\n/, "") : "";
        try {
          s.stack ? a && !String(s.stack).endsWith(a.replace(/^.+\n.+\n/, "")) && (s.stack += `
` + a) : s.stack = a;
        } catch {
        }
      }
      throw s;
    }
  }
  _request(e, n) {
    typeof e == "string" ? (n = n || {}, n.url = e) : n = e || {}, n = vs(this.defaults, n);
    const { transitional: s, paramsSerializer: o, headers: a } = n;
    s !== void 0 && pa.assertOptions(s, {
      silentJSONParsing: wn.transitional(wn.boolean),
      forcedJSONParsing: wn.transitional(wn.boolean),
      clarifyTimeoutError: wn.transitional(wn.boolean)
    }, !1), o != null && (W.isFunction(o) ? n.paramsSerializer = {
      serialize: o
    } : pa.assertOptions(o, {
      encode: wn.function,
      serialize: wn.function
    }, !0)), n.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? n.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : n.allowAbsoluteUrls = !0), pa.assertOptions(n, {
      baseUrl: wn.spelling("baseURL"),
      withXsrfToken: wn.spelling("withXSRFToken")
    }, !0), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let i = a && W.merge(
      a.common,
      a[n.method]
    );
    a && W.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (v) => {
        delete a[v];
      }
    ), n.headers = Zt.concat(i, a);
    const r = [];
    let c = !0;
    this.interceptors.request.forEach(function(z) {
      typeof z.runWhen == "function" && z.runWhen(n) === !1 || (c = c && z.synchronous, r.unshift(z.fulfilled, z.rejected));
    });
    const u = [];
    this.interceptors.response.forEach(function(z) {
      u.push(z.fulfilled, z.rejected);
    });
    let d, m = 0, _;
    if (!c) {
      const v = [Mu.bind(this), void 0];
      for (v.unshift(...r), v.push(...u), _ = v.length, d = Promise.resolve(n); m < _; )
        d = d.then(v[m++], v[m++]);
      return d;
    }
    _ = r.length;
    let g = n;
    for (; m < _; ) {
      const v = r[m++], z = r[m++];
      try {
        g = v(g);
      } catch (h) {
        z.call(this, h);
        break;
      }
    }
    try {
      d = Mu.call(this, g);
    } catch (v) {
      return Promise.reject(v);
    }
    for (m = 0, _ = u.length; m < _; )
      d = d.then(u[m++], u[m++]);
    return d;
  }
  getUri(e) {
    e = vs(this.defaults, e);
    const n = zp(e.baseURL, e.url, e.allowAbsoluteUrls);
    return yp(n, e.params, e.paramsSerializer);
  }
};
W.forEach(["delete", "get", "head", "options"], function(e) {
  ls.prototype[e] = function(n, s) {
    return this.request(vs(s || {}, {
      method: e,
      url: n,
      data: (s || {}).data
    }));
  };
});
W.forEach(["post", "put", "patch"], function(e) {
  function n(s) {
    return function(a, i, r) {
      return this.request(vs(r || {}, {
        method: e,
        headers: s ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: a,
        data: i
      }));
    };
  }
  ls.prototype[e] = n(), ls.prototype[e + "Form"] = n(!0);
});
let D1 = class Mp {
  constructor(e) {
    if (typeof e != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(a) {
      n = a;
    });
    const s = this;
    this.promise.then((o) => {
      if (!s._listeners) return;
      let a = s._listeners.length;
      for (; a-- > 0; )
        s._listeners[a](o);
      s._listeners = null;
    }), this.promise.then = (o) => {
      let a;
      const i = new Promise((r) => {
        s.subscribe(r), a = r;
      }).then(o);
      return i.cancel = function() {
        s.unsubscribe(a);
      }, i;
    }, e(function(a, i, r) {
      s.reason || (s.reason = new Us(a, i, r), n(s.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(e) {
    if (this.reason) {
      e(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(e) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(e);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const e = new AbortController(), n = (s) => {
      e.abort(s);
    };
    return this.subscribe(n), e.signal.unsubscribe = () => this.unsubscribe(n), e.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let e;
    return {
      token: new Mp(function(o) {
        e = o;
      }),
      cancel: e
    };
  }
};
function j1(t) {
  return function(n) {
    return t.apply(null, n);
  };
}
function N1(t) {
  return W.isObject(t) && t.isAxiosError === !0;
}
const Wr = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Wr).forEach(([t, e]) => {
  Wr[e] = t;
});
function Tp(t) {
  const e = new ls(t), n = lp(ls.prototype.request, e);
  return W.extend(n, ls.prototype, e, { allOwnKeys: !0 }), W.extend(n, e, null, { allOwnKeys: !0 }), n.create = function(o) {
    return Tp(vs(t, o));
  }, n;
}
const ht = Tp(Co);
ht.Axios = ls;
ht.CanceledError = Us;
ht.CancelToken = D1;
ht.isCancel = xp;
ht.VERSION = Pp;
ht.toFormData = Wa;
ht.AxiosError = Oe;
ht.Cancel = ht.CanceledError;
ht.all = function(e) {
  return Promise.all(e);
};
ht.spread = j1;
ht.isAxiosError = N1;
ht.mergeConfig = vs;
ht.AxiosHeaders = Zt;
ht.formToJSON = (t) => wp(W.isHTMLForm(t) ? new FormData(t) : t);
ht.getAdapter = Cp.getAdapter;
ht.HttpStatusCode = Wr;
ht.default = ht;
const {
  Axios: uie,
  AxiosError: die,
  CanceledError: pie,
  isCancel: mie,
  CancelToken: hie,
  VERSION: fie,
  all: _ie,
  Cancel: vie,
  isAxiosError: gie,
  spread: kie,
  toFormData: yie,
  AxiosHeaders: bie,
  HttpStatusCode: wie,
  formToJSON: xie,
  getAdapter: $ie,
  mergeConfig: zie
} = ht;
var vr = { exports: {} };
/*!
 * Pusher JavaScript Library v8.4.0
 * https://pusher.com/
 *
 * Copyright 2020, Pusher
 * Released under the MIT licence.
 */
var Iu;
function V1() {
  return Iu || (Iu = 1, (function(t, e) {
    (function(s, o) {
      t.exports = o();
    })(window, function() {
      return (
        /******/
        (function(n) {
          var s = {};
          function o(a) {
            if (s[a])
              return s[a].exports;
            var i = s[a] = {
              /******/
              i: a,
              /******/
              l: !1,
              /******/
              exports: {}
              /******/
            };
            return n[a].call(i.exports, i, i.exports, o), i.l = !0, i.exports;
          }
          return o.m = n, o.c = s, o.d = function(a, i, r) {
            o.o(a, i) || Object.defineProperty(a, i, { enumerable: !0, get: r });
          }, o.r = function(a) {
            typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(a, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(a, "__esModule", { value: !0 });
          }, o.t = function(a, i) {
            if (i & 1 && (a = o(a)), i & 8 || i & 4 && typeof a == "object" && a && a.__esModule) return a;
            var r = /* @__PURE__ */ Object.create(null);
            if (o.r(r), Object.defineProperty(r, "default", { enumerable: !0, value: a }), i & 2 && typeof a != "string") for (var c in a) o.d(r, c, (function(u) {
              return a[u];
            }).bind(null, c));
            return r;
          }, o.n = function(a) {
            var i = a && a.__esModule ? (
              /******/
              function() {
                return a.default;
              }
            ) : (
              /******/
              function() {
                return a;
              }
            );
            return o.d(i, "a", i), i;
          }, o.o = function(a, i) {
            return Object.prototype.hasOwnProperty.call(a, i);
          }, o.p = "", o(o.s = 2);
        })([
          /* 0 */
          /***/
          (function(n, s, o) {
            var a = this && this.__extends || /* @__PURE__ */ (function() {
              var z = function(h, y) {
                return z = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(w, P) {
                  w.__proto__ = P;
                } || function(w, P) {
                  for (var M in P) P.hasOwnProperty(M) && (w[M] = P[M]);
                }, z(h, y);
              };
              return function(h, y) {
                z(h, y);
                function w() {
                  this.constructor = h;
                }
                h.prototype = y === null ? Object.create(y) : (w.prototype = y.prototype, new w());
              };
            })();
            Object.defineProperty(s, "__esModule", { value: !0 });
            var i = 256, r = (
              /** @class */
              (function() {
                function z(h) {
                  h === void 0 && (h = "="), this._paddingCharacter = h;
                }
                return z.prototype.encodedLength = function(h) {
                  return this._paddingCharacter ? (h + 2) / 3 * 4 | 0 : (h * 8 + 5) / 6 | 0;
                }, z.prototype.encode = function(h) {
                  for (var y = "", w = 0; w < h.length - 2; w += 3) {
                    var P = h[w] << 16 | h[w + 1] << 8 | h[w + 2];
                    y += this._encodeByte(P >>> 18 & 63), y += this._encodeByte(P >>> 12 & 63), y += this._encodeByte(P >>> 6 & 63), y += this._encodeByte(P >>> 0 & 63);
                  }
                  var M = h.length - w;
                  if (M > 0) {
                    var P = h[w] << 16 | (M === 2 ? h[w + 1] << 8 : 0);
                    y += this._encodeByte(P >>> 18 & 63), y += this._encodeByte(P >>> 12 & 63), M === 2 ? y += this._encodeByte(P >>> 6 & 63) : y += this._paddingCharacter || "", y += this._paddingCharacter || "";
                  }
                  return y;
                }, z.prototype.maxDecodedLength = function(h) {
                  return this._paddingCharacter ? h / 4 * 3 | 0 : (h * 6 + 7) / 8 | 0;
                }, z.prototype.decodedLength = function(h) {
                  return this.maxDecodedLength(h.length - this._getPaddingLength(h));
                }, z.prototype.decode = function(h) {
                  if (h.length === 0)
                    return new Uint8Array(0);
                  for (var y = this._getPaddingLength(h), w = h.length - y, P = new Uint8Array(this.maxDecodedLength(w)), M = 0, E = 0, R = 0, j = 0, V = 0, X = 0, Z = 0; E < w - 4; E += 4)
                    j = this._decodeChar(h.charCodeAt(E + 0)), V = this._decodeChar(h.charCodeAt(E + 1)), X = this._decodeChar(h.charCodeAt(E + 2)), Z = this._decodeChar(h.charCodeAt(E + 3)), P[M++] = j << 2 | V >>> 4, P[M++] = V << 4 | X >>> 2, P[M++] = X << 6 | Z, R |= j & i, R |= V & i, R |= X & i, R |= Z & i;
                  if (E < w - 1 && (j = this._decodeChar(h.charCodeAt(E)), V = this._decodeChar(h.charCodeAt(E + 1)), P[M++] = j << 2 | V >>> 4, R |= j & i, R |= V & i), E < w - 2 && (X = this._decodeChar(h.charCodeAt(E + 2)), P[M++] = V << 4 | X >>> 2, R |= X & i), E < w - 3 && (Z = this._decodeChar(h.charCodeAt(E + 3)), P[M++] = X << 6 | Z, R |= Z & i), R !== 0)
                    throw new Error("Base64Coder: incorrect characters for decoding");
                  return P;
                }, z.prototype._encodeByte = function(h) {
                  var y = h;
                  return y += 65, y += 25 - h >>> 8 & 6, y += 51 - h >>> 8 & -75, y += 61 - h >>> 8 & -15, y += 62 - h >>> 8 & 3, String.fromCharCode(y);
                }, z.prototype._decodeChar = function(h) {
                  var y = i;
                  return y += (42 - h & h - 44) >>> 8 & -i + h - 43 + 62, y += (46 - h & h - 48) >>> 8 & -i + h - 47 + 63, y += (47 - h & h - 58) >>> 8 & -i + h - 48 + 52, y += (64 - h & h - 91) >>> 8 & -i + h - 65 + 0, y += (96 - h & h - 123) >>> 8 & -i + h - 97 + 26, y;
                }, z.prototype._getPaddingLength = function(h) {
                  var y = 0;
                  if (this._paddingCharacter) {
                    for (var w = h.length - 1; w >= 0 && h[w] === this._paddingCharacter; w--)
                      y++;
                    if (h.length < 4 || y > 2)
                      throw new Error("Base64Coder: incorrect padding");
                  }
                  return y;
                }, z;
              })()
            );
            s.Coder = r;
            var c = new r();
            function u(z) {
              return c.encode(z);
            }
            s.encode = u;
            function d(z) {
              return c.decode(z);
            }
            s.decode = d;
            var m = (
              /** @class */
              (function(z) {
                a(h, z);
                function h() {
                  return z !== null && z.apply(this, arguments) || this;
                }
                return h.prototype._encodeByte = function(y) {
                  var w = y;
                  return w += 65, w += 25 - y >>> 8 & 6, w += 51 - y >>> 8 & -75, w += 61 - y >>> 8 & -13, w += 62 - y >>> 8 & 49, String.fromCharCode(w);
                }, h.prototype._decodeChar = function(y) {
                  var w = i;
                  return w += (44 - y & y - 46) >>> 8 & -i + y - 45 + 62, w += (94 - y & y - 96) >>> 8 & -i + y - 95 + 63, w += (47 - y & y - 58) >>> 8 & -i + y - 48 + 52, w += (64 - y & y - 91) >>> 8 & -i + y - 65 + 0, w += (96 - y & y - 123) >>> 8 & -i + y - 97 + 26, w;
                }, h;
              })(r)
            );
            s.URLSafeCoder = m;
            var _ = new m();
            function g(z) {
              return _.encode(z);
            }
            s.encodeURLSafe = g;
            function v(z) {
              return _.decode(z);
            }
            s.decodeURLSafe = v, s.encodedLength = function(z) {
              return c.encodedLength(z);
            }, s.maxDecodedLength = function(z) {
              return c.maxDecodedLength(z);
            }, s.decodedLength = function(z) {
              return c.decodedLength(z);
            };
          }),
          /* 1 */
          /***/
          (function(n, s, o) {
            Object.defineProperty(s, "__esModule", { value: !0 });
            var a = "utf8: invalid string", i = "utf8: invalid source encoding";
            function r(d) {
              for (var m = new Uint8Array(c(d)), _ = 0, g = 0; g < d.length; g++) {
                var v = d.charCodeAt(g);
                v < 128 ? m[_++] = v : v < 2048 ? (m[_++] = 192 | v >> 6, m[_++] = 128 | v & 63) : v < 55296 ? (m[_++] = 224 | v >> 12, m[_++] = 128 | v >> 6 & 63, m[_++] = 128 | v & 63) : (g++, v = (v & 1023) << 10, v |= d.charCodeAt(g) & 1023, v += 65536, m[_++] = 240 | v >> 18, m[_++] = 128 | v >> 12 & 63, m[_++] = 128 | v >> 6 & 63, m[_++] = 128 | v & 63);
              }
              return m;
            }
            s.encode = r;
            function c(d) {
              for (var m = 0, _ = 0; _ < d.length; _++) {
                var g = d.charCodeAt(_);
                if (g < 128)
                  m += 1;
                else if (g < 2048)
                  m += 2;
                else if (g < 55296)
                  m += 3;
                else if (g <= 57343) {
                  if (_ >= d.length - 1)
                    throw new Error(a);
                  _++, m += 4;
                } else
                  throw new Error(a);
              }
              return m;
            }
            s.encodedLength = c;
            function u(d) {
              for (var m = [], _ = 0; _ < d.length; _++) {
                var g = d[_];
                if (g & 128) {
                  var v = void 0;
                  if (g < 224) {
                    if (_ >= d.length)
                      throw new Error(i);
                    var z = d[++_];
                    if ((z & 192) !== 128)
                      throw new Error(i);
                    g = (g & 31) << 6 | z & 63, v = 128;
                  } else if (g < 240) {
                    if (_ >= d.length - 1)
                      throw new Error(i);
                    var z = d[++_], h = d[++_];
                    if ((z & 192) !== 128 || (h & 192) !== 128)
                      throw new Error(i);
                    g = (g & 15) << 12 | (z & 63) << 6 | h & 63, v = 2048;
                  } else if (g < 248) {
                    if (_ >= d.length - 2)
                      throw new Error(i);
                    var z = d[++_], h = d[++_], y = d[++_];
                    if ((z & 192) !== 128 || (h & 192) !== 128 || (y & 192) !== 128)
                      throw new Error(i);
                    g = (g & 15) << 18 | (z & 63) << 12 | (h & 63) << 6 | y & 63, v = 65536;
                  } else
                    throw new Error(i);
                  if (g < v || g >= 55296 && g <= 57343)
                    throw new Error(i);
                  if (g >= 65536) {
                    if (g > 1114111)
                      throw new Error(i);
                    g -= 65536, m.push(String.fromCharCode(55296 | g >> 10)), g = 56320 | g & 1023;
                  }
                }
                m.push(String.fromCharCode(g));
              }
              return m.join("");
            }
            s.decode = u;
          }),
          /* 2 */
          /***/
          (function(n, s, o) {
            n.exports = o(3).default;
          }),
          /* 3 */
          /***/
          (function(n, s, o) {
            o.r(s);
            class a {
              constructor(p, f) {
                this.lastId = 0, this.prefix = p, this.name = f;
              }
              create(p) {
                this.lastId++;
                var f = this.lastId, S = this.prefix + f, T = this.name + "[" + f + "]", Y = !1, le = function() {
                  Y || (p.apply(null, arguments), Y = !0);
                };
                return this[f] = le, { number: f, id: S, name: T, callback: le };
              }
              remove(p) {
                delete this[p.number];
              }
            }
            var i = new a("_pusher_script_", "Pusher.ScriptReceivers"), r = {
              VERSION: "8.4.0",
              PROTOCOL: 7,
              wsPort: 80,
              wssPort: 443,
              wsPath: "",
              httpHost: "sockjs.pusher.com",
              httpPort: 80,
              httpsPort: 443,
              httpPath: "/pusher",
              stats_host: "stats.pusher.com",
              authEndpoint: "/pusher/auth",
              authTransport: "ajax",
              activityTimeout: 12e4,
              pongTimeout: 3e4,
              unavailableTimeout: 1e4,
              userAuthentication: {
                endpoint: "/pusher/user-auth",
                transport: "ajax"
              },
              channelAuthorization: {
                endpoint: "/pusher/auth",
                transport: "ajax"
              },
              cdn_http: "http://js.pusher.com",
              cdn_https: "https://js.pusher.com",
              dependency_suffix: ""
            }, c = r;
            class u {
              constructor(p) {
                this.options = p, this.receivers = p.receivers || i, this.loading = {};
              }
              load(p, f, S) {
                var T = this;
                if (T.loading[p] && T.loading[p].length > 0)
                  T.loading[p].push(S);
                else {
                  T.loading[p] = [S];
                  var Y = Ee.createScriptRequest(T.getPath(p, f)), le = T.receivers.create(function(ye) {
                    if (T.receivers.remove(le), T.loading[p]) {
                      var Ie = T.loading[p];
                      delete T.loading[p];
                      for (var Ge = function(gt) {
                        gt || Y.cleanup();
                      }, Qe = 0; Qe < Ie.length; Qe++)
                        Ie[Qe](ye, Ge);
                    }
                  });
                  Y.send(le);
                }
              }
              getRoot(p) {
                var f, S = Ee.getDocument().location.protocol;
                return p && p.useTLS || S === "https:" ? f = this.options.cdn_https : f = this.options.cdn_http, f.replace(/\/*$/, "") + "/" + this.options.version;
              }
              getPath(p, f) {
                return this.getRoot(f) + "/" + p + this.options.suffix + ".js";
              }
            }
            var d = new a("_pusher_dependencies", "Pusher.DependenciesReceivers"), m = new u({
              cdn_http: c.cdn_http,
              cdn_https: c.cdn_https,
              version: c.VERSION,
              suffix: c.dependency_suffix,
              receivers: d
            });
            const _ = {
              baseUrl: "https://pusher.com",
              urls: {
                authenticationEndpoint: {
                  path: "/docs/channels/server_api/authenticating_users"
                },
                authorizationEndpoint: {
                  path: "/docs/channels/server_api/authorizing-users/"
                },
                javascriptQuickStart: {
                  path: "/docs/javascript_quick_start"
                },
                triggeringClientEvents: {
                  path: "/docs/client_api_guide/client_events#trigger-events"
                },
                encryptedChannelSupport: {
                  fullUrl: "https://github.com/pusher/pusher-js/tree/cc491015371a4bde5743d1c87a0fbac0feb53195#encrypted-channel-support"
                }
              }
            };
            var v = { buildLogSuffix: function(k) {
              const p = "See:", f = _.urls[k];
              if (!f)
                return "";
              let S;
              return f.fullUrl ? S = f.fullUrl : f.path && (S = _.baseUrl + f.path), S ? `${p} ${S}` : "";
            } }, z;
            (function(k) {
              k.UserAuthentication = "user-authentication", k.ChannelAuthorization = "channel-authorization";
            })(z || (z = {}));
            class h extends Error {
              constructor(p) {
                super(p), Object.setPrototypeOf(this, new.target.prototype);
              }
            }
            class y extends Error {
              constructor(p) {
                super(p), Object.setPrototypeOf(this, new.target.prototype);
              }
            }
            class w extends Error {
              constructor(p) {
                super(p), Object.setPrototypeOf(this, new.target.prototype);
              }
            }
            class P extends Error {
              constructor(p) {
                super(p), Object.setPrototypeOf(this, new.target.prototype);
              }
            }
            class M extends Error {
              constructor(p) {
                super(p), Object.setPrototypeOf(this, new.target.prototype);
              }
            }
            class E extends Error {
              constructor(p) {
                super(p), Object.setPrototypeOf(this, new.target.prototype);
              }
            }
            class R extends Error {
              constructor(p) {
                super(p), Object.setPrototypeOf(this, new.target.prototype);
              }
            }
            class j extends Error {
              constructor(p) {
                super(p), Object.setPrototypeOf(this, new.target.prototype);
              }
            }
            class V extends Error {
              constructor(p, f) {
                super(f), this.status = p, Object.setPrototypeOf(this, new.target.prototype);
              }
            }
            var Z = function(k, p, f, S, T) {
              const Y = Ee.createXHR();
              Y.open("POST", f.endpoint, !0), Y.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
              for (var le in f.headers)
                Y.setRequestHeader(le, f.headers[le]);
              if (f.headersProvider != null) {
                let ye = f.headersProvider();
                for (var le in ye)
                  Y.setRequestHeader(le, ye[le]);
              }
              return Y.onreadystatechange = function() {
                if (Y.readyState === 4)
                  if (Y.status === 200) {
                    let ye, Ie = !1;
                    try {
                      ye = JSON.parse(Y.responseText), Ie = !0;
                    } catch {
                      T(new V(200, `JSON returned from ${S.toString()} endpoint was invalid, yet status code was 200. Data was: ${Y.responseText}`), null);
                    }
                    Ie && T(null, ye);
                  } else {
                    let ye = "";
                    switch (S) {
                      case z.UserAuthentication:
                        ye = v.buildLogSuffix("authenticationEndpoint");
                        break;
                      case z.ChannelAuthorization:
                        ye = `Clients must be authorized to join private or presence channels. ${v.buildLogSuffix("authorizationEndpoint")}`;
                        break;
                    }
                    T(new V(Y.status, `Unable to retrieve auth string from ${S.toString()} endpoint - received status: ${Y.status} from ${f.endpoint}. ${ye}`), null);
                  }
              }, Y.send(p), Y;
            };
            function ae(k) {
              return ee(Ce(k));
            }
            var K = String.fromCharCode, te = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", ue = function(k) {
              var p = k.charCodeAt(0);
              return p < 128 ? k : p < 2048 ? K(192 | p >>> 6) + K(128 | p & 63) : K(224 | p >>> 12 & 15) + K(128 | p >>> 6 & 63) + K(128 | p & 63);
            }, Ce = function(k) {
              return k.replace(/[^\x00-\x7F]/g, ue);
            }, ne = function(k) {
              var p = [0, 2, 1][k.length % 3], f = k.charCodeAt(0) << 16 | (k.length > 1 ? k.charCodeAt(1) : 0) << 8 | (k.length > 2 ? k.charCodeAt(2) : 0), S = [
                te.charAt(f >>> 18),
                te.charAt(f >>> 12 & 63),
                p >= 2 ? "=" : te.charAt(f >>> 6 & 63),
                p >= 1 ? "=" : te.charAt(f & 63)
              ];
              return S.join("");
            }, ee = window.btoa || function(k) {
              return k.replace(/[\s\S]{1,3}/g, ne);
            };
            class G {
              constructor(p, f, S, T) {
                this.clear = f, this.timer = p(() => {
                  this.timer && (this.timer = T(this.timer));
                }, S);
              }
              isRunning() {
                return this.timer !== null;
              }
              ensureAborted() {
                this.timer && (this.clear(this.timer), this.timer = null);
              }
            }
            var oe = G;
            function _e(k) {
              window.clearTimeout(k);
            }
            function de(k) {
              window.clearInterval(k);
            }
            class $e extends oe {
              constructor(p, f) {
                super(setTimeout, _e, p, function(S) {
                  return f(), null;
                });
              }
            }
            class Ze extends oe {
              constructor(p, f) {
                super(setInterval, de, p, function(S) {
                  return f(), S;
                });
              }
            }
            var Pe = {
              now() {
                return Date.now ? Date.now() : (/* @__PURE__ */ new Date()).valueOf();
              },
              defer(k) {
                return new $e(0, k);
              },
              method(k, ...p) {
                var f = Array.prototype.slice.call(arguments, 1);
                return function(S) {
                  return S[k].apply(S, f.concat(arguments));
                };
              }
            }, ie = Pe;
            function ve(k, ...p) {
              for (var f = 0; f < p.length; f++) {
                var S = p[f];
                for (var T in S)
                  S[T] && S[T].constructor && S[T].constructor === Object ? k[T] = ve(k[T] || {}, S[T]) : k[T] = S[T];
              }
              return k;
            }
            function ut() {
              for (var k = ["Pusher"], p = 0; p < arguments.length; p++)
                typeof arguments[p] == "string" ? k.push(arguments[p]) : k.push(mn(arguments[p]));
              return k.join(" : ");
            }
            function ot(k, p) {
              var f = Array.prototype.indexOf;
              if (k === null)
                return -1;
              if (f && k.indexOf === f)
                return k.indexOf(p);
              for (var S = 0, T = k.length; S < T; S++)
                if (k[S] === p)
                  return S;
              return -1;
            }
            function Ve(k, p) {
              for (var f in k)
                Object.prototype.hasOwnProperty.call(k, f) && p(k[f], f, k);
            }
            function fe(k) {
              var p = [];
              return Ve(k, function(f, S) {
                p.push(S);
              }), p;
            }
            function Xe(k) {
              var p = [];
              return Ve(k, function(f) {
                p.push(f);
              }), p;
            }
            function Ue(k, p, f) {
              for (var S = 0; S < k.length; S++)
                p.call(f || window, k[S], S, k);
            }
            function Ye(k, p) {
              for (var f = [], S = 0; S < k.length; S++)
                f.push(p(k[S], S, k, f));
              return f;
            }
            function dt(k, p) {
              var f = {};
              return Ve(k, function(S, T) {
                f[T] = p(S);
              }), f;
            }
            function wt(k, p) {
              p = p || function(T) {
                return !!T;
              };
              for (var f = [], S = 0; S < k.length; S++)
                p(k[S], S, k, f) && f.push(k[S]);
              return f;
            }
            function pt(k, p) {
              var f = {};
              return Ve(k, function(S, T) {
                (p && p(S, T, k, f) || S) && (f[T] = S);
              }), f;
            }
            function Nt(k) {
              var p = [];
              return Ve(k, function(f, S) {
                p.push([S, f]);
              }), p;
            }
            function Bt(k, p) {
              for (var f = 0; f < k.length; f++)
                if (p(k[f], f, k))
                  return !0;
              return !1;
            }
            function Ln(k, p) {
              for (var f = 0; f < k.length; f++)
                if (!p(k[f], f, k))
                  return !1;
              return !0;
            }
            function kn(k) {
              return dt(k, function(p) {
                return typeof p == "object" && (p = mn(p)), encodeURIComponent(ae(p.toString()));
              });
            }
            function Jt(k) {
              var p = pt(k, function(S) {
                return S !== void 0;
              }), f = Ye(Nt(kn(p)), ie.method("join", "=")).join("&");
              return f;
            }
            function Dn(k) {
              var p = [], f = [];
              return (function S(T, Y) {
                var le, ye, Ie;
                switch (typeof T) {
                  case "object":
                    if (!T)
                      return null;
                    for (le = 0; le < p.length; le += 1)
                      if (p[le] === T)
                        return { $ref: f[le] };
                    if (p.push(T), f.push(Y), Object.prototype.toString.apply(T) === "[object Array]")
                      for (Ie = [], le = 0; le < T.length; le += 1)
                        Ie[le] = S(T[le], Y + "[" + le + "]");
                    else {
                      Ie = {};
                      for (ye in T)
                        Object.prototype.hasOwnProperty.call(T, ye) && (Ie[ye] = S(T[ye], Y + "[" + JSON.stringify(ye) + "]"));
                    }
                    return Ie;
                  case "number":
                  case "string":
                  case "boolean":
                    return T;
                }
              })(k, "$");
            }
            function mn(k) {
              try {
                return JSON.stringify(k);
              } catch {
                return JSON.stringify(Dn(k));
              }
            }
            class jn {
              constructor() {
                this.globalLog = (p) => {
                  window.console && window.console.log && window.console.log(p);
                };
              }
              debug(...p) {
                this.log(this.globalLog, p);
              }
              warn(...p) {
                this.log(this.globalLogWarn, p);
              }
              error(...p) {
                this.log(this.globalLogError, p);
              }
              globalLogWarn(p) {
                window.console && window.console.warn ? window.console.warn(p) : this.globalLog(p);
              }
              globalLogError(p) {
                window.console && window.console.error ? window.console.error(p) : this.globalLogWarn(p);
              }
              log(p, ...f) {
                var S = ut.apply(this, arguments);
                vi.log ? vi.log(S) : vi.logToConsole && p.bind(this)(S);
              }
            }
            var nt = new jn(), ri = function(k, p, f, S, T) {
              (f.headers !== void 0 || f.headersProvider != null) && nt.warn(`To send headers with the ${S.toString()} request, you must use AJAX, rather than JSONP.`);
              var Y = k.nextAuthCallbackID.toString();
              k.nextAuthCallbackID++;
              var le = k.getDocument(), ye = le.createElement("script");
              k.auth_callbacks[Y] = function(Qe) {
                T(null, Qe);
              };
              var Ie = "Pusher.auth_callbacks['" + Y + "']";
              ye.src = f.endpoint + "?callback=" + encodeURIComponent(Ie) + "&" + p;
              var Ge = le.getElementsByTagName("head")[0] || le.documentElement;
              Ge.insertBefore(ye, Ge.firstChild);
            }, Fo = ri;
            class li {
              constructor(p) {
                this.src = p;
              }
              send(p) {
                var f = this, S = "Error loading " + f.src;
                f.script = document.createElement("script"), f.script.id = p.id, f.script.src = f.src, f.script.type = "text/javascript", f.script.charset = "UTF-8", f.script.addEventListener ? (f.script.onerror = function() {
                  p.callback(S);
                }, f.script.onload = function() {
                  p.callback(null);
                }) : f.script.onreadystatechange = function() {
                  (f.script.readyState === "loaded" || f.script.readyState === "complete") && p.callback(null);
                }, f.script.async === void 0 && document.attachEvent && /opera/i.test(navigator.userAgent) ? (f.errorScript = document.createElement("script"), f.errorScript.id = p.id + "_error", f.errorScript.text = p.name + "('" + S + "');", f.script.async = f.errorScript.async = !1) : f.script.async = !0;
                var T = document.getElementsByTagName("head")[0];
                T.insertBefore(f.script, T.firstChild), f.errorScript && T.insertBefore(f.errorScript, f.script.nextSibling);
              }
              cleanup() {
                this.script && (this.script.onload = this.script.onerror = null, this.script.onreadystatechange = null), this.script && this.script.parentNode && this.script.parentNode.removeChild(this.script), this.errorScript && this.errorScript.parentNode && this.errorScript.parentNode.removeChild(this.errorScript), this.script = null, this.errorScript = null;
              }
            }
            class Qn {
              constructor(p, f) {
                this.url = p, this.data = f;
              }
              send(p) {
                if (!this.request) {
                  var f = Jt(this.data), S = this.url + "/" + p.number + "?" + f;
                  this.request = Ee.createScriptRequest(S), this.request.send(p);
                }
              }
              cleanup() {
                this.request && this.request.cleanup();
              }
            }
            var Xs = function(k, p) {
              return function(f, S) {
                var T = "http" + (p ? "s" : "") + "://", Y = T + (k.host || k.options.host) + k.options.path, le = Ee.createJSONPRequest(Y, f), ye = Ee.ScriptReceivers.create(function(Ie, Ge) {
                  i.remove(ye), le.cleanup(), Ge && Ge.host && (k.host = Ge.host), S && S(Ie, Ge);
                });
                le.send(ye);
              };
            }, Bo = {
              name: "jsonp",
              getAgent: Xs
            }, ci = Bo;
            function Qs(k, p, f) {
              var S = k + (p.useTLS ? "s" : ""), T = p.useTLS ? p.hostTLS : p.hostNonTLS;
              return S + "://" + T + f;
            }
            function Jn(k, p) {
              var f = "/app/" + k, S = "?protocol=" + c.PROTOCOL + "&client=js&version=" + c.VERSION + (p ? "&" + p : "");
              return f + S;
            }
            var xs = {
              getInitial: function(k, p) {
                var f = (p.httpPath || "") + Jn(k, "flash=false");
                return Qs("ws", p, f);
              }
            }, F = {
              getInitial: function(k, p) {
                var f = (p.httpPath || "/pusher") + Jn(k);
                return Qs("http", p, f);
              }
            }, H = {
              getInitial: function(k, p) {
                return Qs("http", p, p.httpPath || "/pusher");
              },
              getPath: function(k, p) {
                return Jn(k);
              }
            };
            class qe {
              constructor() {
                this._callbacks = {};
              }
              get(p) {
                return this._callbacks[Ke(p)];
              }
              add(p, f, S) {
                var T = Ke(p);
                this._callbacks[T] = this._callbacks[T] || [], this._callbacks[T].push({
                  fn: f,
                  context: S
                });
              }
              remove(p, f, S) {
                if (!p && !f && !S) {
                  this._callbacks = {};
                  return;
                }
                var T = p ? [Ke(p)] : fe(this._callbacks);
                f || S ? this.removeCallback(T, f, S) : this.removeAllCallbacks(T);
              }
              removeCallback(p, f, S) {
                Ue(p, function(T) {
                  this._callbacks[T] = wt(this._callbacks[T] || [], function(Y) {
                    return f && f !== Y.fn || S && S !== Y.context;
                  }), this._callbacks[T].length === 0 && delete this._callbacks[T];
                }, this);
              }
              removeAllCallbacks(p) {
                Ue(p, function(f) {
                  delete this._callbacks[f];
                }, this);
              }
            }
            function Ke(k) {
              return "_" + k;
            }
            class Fe {
              constructor(p) {
                this.callbacks = new qe(), this.global_callbacks = [], this.failThrough = p;
              }
              bind(p, f, S) {
                return this.callbacks.add(p, f, S), this;
              }
              bind_global(p) {
                return this.global_callbacks.push(p), this;
              }
              unbind(p, f, S) {
                return this.callbacks.remove(p, f, S), this;
              }
              unbind_global(p) {
                return p ? (this.global_callbacks = wt(this.global_callbacks || [], (f) => f !== p), this) : (this.global_callbacks = [], this);
              }
              unbind_all() {
                return this.unbind(), this.unbind_global(), this;
              }
              emit(p, f, S) {
                for (var T = 0; T < this.global_callbacks.length; T++)
                  this.global_callbacks[T](p, f);
                var Y = this.callbacks.get(p), le = [];
                if (S ? le.push(f, S) : f && le.push(f), Y && Y.length > 0)
                  for (var T = 0; T < Y.length; T++)
                    Y[T].fn.apply(Y[T].context || window, le);
                else this.failThrough && this.failThrough(p, f);
                return this;
              }
            }
            class Le extends Fe {
              constructor(p, f, S, T, Y) {
                super(), this.initialize = Ee.transportConnectionInitializer, this.hooks = p, this.name = f, this.priority = S, this.key = T, this.options = Y, this.state = "new", this.timeline = Y.timeline, this.activityTimeout = Y.activityTimeout, this.id = this.timeline.generateUniqueID();
              }
              handlesActivityChecks() {
                return !!this.hooks.handlesActivityChecks;
              }
              supportsPing() {
                return !!this.hooks.supportsPing;
              }
              connect() {
                if (this.socket || this.state !== "initialized")
                  return !1;
                var p = this.hooks.urls.getInitial(this.key, this.options);
                try {
                  this.socket = this.hooks.getSocket(p, this.options);
                } catch (f) {
                  return ie.defer(() => {
                    this.onError(f), this.changeState("closed");
                  }), !1;
                }
                return this.bindListeners(), nt.debug("Connecting", { transport: this.name, url: p }), this.changeState("connecting"), !0;
              }
              close() {
                return this.socket ? (this.socket.close(), !0) : !1;
              }
              send(p) {
                return this.state === "open" ? (ie.defer(() => {
                  this.socket && this.socket.send(p);
                }), !0) : !1;
              }
              ping() {
                this.state === "open" && this.supportsPing() && this.socket.ping();
              }
              onOpen() {
                this.hooks.beforeOpen && this.hooks.beforeOpen(this.socket, this.hooks.urls.getPath(this.key, this.options)), this.changeState("open"), this.socket.onopen = void 0;
              }
              onError(p) {
                this.emit("error", { type: "WebSocketError", error: p }), this.timeline.error(this.buildTimelineMessage({ error: p.toString() }));
              }
              onClose(p) {
                p ? this.changeState("closed", {
                  code: p.code,
                  reason: p.reason,
                  wasClean: p.wasClean
                }) : this.changeState("closed"), this.unbindListeners(), this.socket = void 0;
              }
              onMessage(p) {
                this.emit("message", p);
              }
              onActivity() {
                this.emit("activity");
              }
              bindListeners() {
                this.socket.onopen = () => {
                  this.onOpen();
                }, this.socket.onerror = (p) => {
                  this.onError(p);
                }, this.socket.onclose = (p) => {
                  this.onClose(p);
                }, this.socket.onmessage = (p) => {
                  this.onMessage(p);
                }, this.supportsPing() && (this.socket.onactivity = () => {
                  this.onActivity();
                });
              }
              unbindListeners() {
                this.socket && (this.socket.onopen = void 0, this.socket.onerror = void 0, this.socket.onclose = void 0, this.socket.onmessage = void 0, this.supportsPing() && (this.socket.onactivity = void 0));
              }
              changeState(p, f) {
                this.state = p, this.timeline.info(this.buildTimelineMessage({
                  state: p,
                  params: f
                })), this.emit(p, f);
              }
              buildTimelineMessage(p) {
                return ve({ cid: this.id }, p);
              }
            }
            class qt {
              constructor(p) {
                this.hooks = p;
              }
              isSupported(p) {
                return this.hooks.isSupported(p);
              }
              createConnection(p, f, S, T) {
                return new Le(this.hooks, p, f, S, T);
              }
            }
            var An = new qt({
              urls: xs,
              handlesActivityChecks: !1,
              supportsPing: !1,
              isInitialized: function() {
                return !!Ee.getWebSocketAPI();
              },
              isSupported: function() {
                return !!Ee.getWebSocketAPI();
              },
              getSocket: function(k) {
                return Ee.createWebSocket(k);
              }
            }), Vt = {
              urls: F,
              handlesActivityChecks: !1,
              supportsPing: !0,
              isInitialized: function() {
                return !0;
              }
            }, hn = ve({
              getSocket: function(k) {
                return Ee.HTTPFactory.createStreamingSocket(k);
              }
            }, Vt), $s = ve({
              getSocket: function(k) {
                return Ee.HTTPFactory.createPollingSocket(k);
              }
            }, Vt), Cn = {
              isSupported: function() {
                return Ee.isXHRSupported();
              }
            }, Yt = new qt(ve({}, hn, Cn)), qo = new qt(ve({}, $s, Cn)), Ho = {
              ws: An,
              xhr_streaming: Yt,
              xhr_polling: qo
            }, Yn = Ho, es = new qt({
              file: "sockjs",
              urls: H,
              handlesActivityChecks: !0,
              supportsPing: !1,
              isSupported: function() {
                return !0;
              },
              isInitialized: function() {
                return window.SockJS !== void 0;
              },
              getSocket: function(k, p) {
                return new window.SockJS(k, null, {
                  js_path: m.getPath("sockjs", {
                    useTLS: p.useTLS
                  }),
                  ignore_null_origin: p.ignoreNullOrigin
                });
              },
              beforeOpen: function(k, p) {
                k.send(JSON.stringify({
                  path: p
                }));
              }
            }), zs = {
              isSupported: function(k) {
                var p = Ee.isXDRSupported(k.useTLS);
                return p;
              }
            }, Ss = new qt(ve({}, hn, zs)), Js = new qt(ve({}, $s, zs));
            Yn.xdr_streaming = Ss, Yn.xdr_polling = Js, Yn.sockjs = es;
            var Ys = Yn;
            class Wo extends Fe {
              constructor() {
                super();
                var p = this;
                window.addEventListener !== void 0 && (window.addEventListener("online", function() {
                  p.emit("online");
                }, !1), window.addEventListener("offline", function() {
                  p.emit("offline");
                }, !1));
              }
              isOnline() {
                return window.navigator.onLine === void 0 ? !0 : window.navigator.onLine;
              }
            }
            var Go = new Wo();
            class eo {
              constructor(p, f, S) {
                this.manager = p, this.transport = f, this.minPingDelay = S.minPingDelay, this.maxPingDelay = S.maxPingDelay, this.pingDelay = void 0;
              }
              createConnection(p, f, S, T) {
                T = ve({}, T, {
                  activityTimeout: this.pingDelay
                });
                var Y = this.transport.createConnection(p, f, S, T), le = null, ye = function() {
                  Y.unbind("open", ye), Y.bind("closed", Ie), le = ie.now();
                }, Ie = (Ge) => {
                  if (Y.unbind("closed", Ie), Ge.code === 1002 || Ge.code === 1003)
                    this.manager.reportDeath();
                  else if (!Ge.wasClean && le) {
                    var Qe = ie.now() - le;
                    Qe < 2 * this.maxPingDelay && (this.manager.reportDeath(), this.pingDelay = Math.max(Qe / 2, this.minPingDelay));
                  }
                };
                return Y.bind("open", ye), Y;
              }
              isSupported(p) {
                return this.manager.isAlive() && this.transport.isSupported(p);
              }
            }
            const to = {
              decodeMessage: function(k) {
                try {
                  var p = JSON.parse(k.data), f = p.data;
                  if (typeof f == "string")
                    try {
                      f = JSON.parse(p.data);
                    } catch {
                    }
                  var S = {
                    event: p.event,
                    channel: p.channel,
                    data: f
                  };
                  return p.user_id && (S.user_id = p.user_id), S;
                } catch (T) {
                  throw { type: "MessageParseError", error: T, data: k.data };
                }
              },
              encodeMessage: function(k) {
                return JSON.stringify(k);
              },
              processHandshake: function(k) {
                var p = to.decodeMessage(k);
                if (p.event === "pusher:connection_established") {
                  if (!p.data.activity_timeout)
                    throw "No activity timeout specified in handshake";
                  return {
                    action: "connected",
                    id: p.data.socket_id,
                    activityTimeout: p.data.activity_timeout * 1e3
                  };
                } else {
                  if (p.event === "pusher:error")
                    return {
                      action: this.getCloseAction(p.data),
                      error: this.getCloseError(p.data)
                    };
                  throw "Invalid handshake";
                }
              },
              getCloseAction: function(k) {
                return k.code < 4e3 ? k.code >= 1002 && k.code <= 1004 ? "backoff" : null : k.code === 4e3 ? "tls_only" : k.code < 4100 ? "refused" : k.code < 4200 ? "backoff" : k.code < 4300 ? "retry" : "refused";
              },
              getCloseError: function(k) {
                return k.code !== 1e3 && k.code !== 1001 ? {
                  type: "PusherError",
                  data: {
                    code: k.code,
                    message: k.reason || k.message
                  }
                } : null;
              }
            };
            var fn = to;
            class Zo extends Fe {
              constructor(p, f) {
                super(), this.id = p, this.transport = f, this.activityTimeout = f.activityTimeout, this.bindListeners();
              }
              handlesActivityChecks() {
                return this.transport.handlesActivityChecks();
              }
              send(p) {
                return this.transport.send(p);
              }
              send_event(p, f, S) {
                var T = { event: p, data: f };
                return S && (T.channel = S), nt.debug("Event sent", T), this.send(fn.encodeMessage(T));
              }
              ping() {
                this.transport.supportsPing() ? this.transport.ping() : this.send_event("pusher:ping", {});
              }
              close() {
                this.transport.close();
              }
              bindListeners() {
                var p = {
                  message: (S) => {
                    var T;
                    try {
                      T = fn.decodeMessage(S);
                    } catch (Y) {
                      this.emit("error", {
                        type: "MessageParseError",
                        error: Y,
                        data: S.data
                      });
                    }
                    if (T !== void 0) {
                      switch (nt.debug("Event recd", T), T.event) {
                        case "pusher:error":
                          this.emit("error", {
                            type: "PusherError",
                            data: T.data
                          });
                          break;
                        case "pusher:ping":
                          this.emit("ping");
                          break;
                        case "pusher:pong":
                          this.emit("pong");
                          break;
                      }
                      this.emit("message", T);
                    }
                  },
                  activity: () => {
                    this.emit("activity");
                  },
                  error: (S) => {
                    this.emit("error", S);
                  },
                  closed: (S) => {
                    f(), S && S.code && this.handleCloseEvent(S), this.transport = null, this.emit("closed");
                  }
                }, f = () => {
                  Ve(p, (S, T) => {
                    this.transport.unbind(T, S);
                  });
                };
                Ve(p, (S, T) => {
                  this.transport.bind(T, S);
                });
              }
              handleCloseEvent(p) {
                var f = fn.getCloseAction(p), S = fn.getCloseError(p);
                S && this.emit("error", S), f && this.emit(f, { action: f, error: S });
              }
            }
            class ui {
              constructor(p, f) {
                this.transport = p, this.callback = f, this.bindListeners();
              }
              close() {
                this.unbindListeners(), this.transport.close();
              }
              bindListeners() {
                this.onMessage = (p) => {
                  this.unbindListeners();
                  var f;
                  try {
                    f = fn.processHandshake(p);
                  } catch (S) {
                    this.finish("error", { error: S }), this.transport.close();
                    return;
                  }
                  f.action === "connected" ? this.finish("connected", {
                    connection: new Zo(f.id, this.transport),
                    activityTimeout: f.activityTimeout
                  }) : (this.finish(f.action, { error: f.error }), this.transport.close());
                }, this.onClosed = (p) => {
                  this.unbindListeners();
                  var f = fn.getCloseAction(p) || "backoff", S = fn.getCloseError(p);
                  this.finish(f, { error: S });
                }, this.transport.bind("message", this.onMessage), this.transport.bind("closed", this.onClosed);
              }
              unbindListeners() {
                this.transport.unbind("message", this.onMessage), this.transport.unbind("closed", this.onClosed);
              }
              finish(p, f) {
                this.callback(ve({ transport: this.transport, action: p }, f));
              }
            }
            class no {
              constructor(p, f) {
                this.timeline = p, this.options = f || {};
              }
              send(p, f) {
                this.timeline.isEmpty() || this.timeline.send(Ee.TimelineTransport.getAgent(this, p), f);
              }
            }
            class yn extends Fe {
              constructor(p, f) {
                super(function(S, T) {
                  nt.debug("No callbacks on " + p + " for " + S);
                }), this.name = p, this.pusher = f, this.subscribed = !1, this.subscriptionPending = !1, this.subscriptionCancelled = !1;
              }
              authorize(p, f) {
                return f(null, { auth: "" });
              }
              trigger(p, f) {
                if (p.indexOf("client-") !== 0)
                  throw new h("Event '" + p + "' does not start with 'client-'");
                if (!this.subscribed) {
                  var S = v.buildLogSuffix("triggeringClientEvents");
                  nt.warn(`Client event triggered before channel 'subscription_succeeded' event . ${S}`);
                }
                return this.pusher.send_event(p, f, this.name);
              }
              disconnect() {
                this.subscribed = !1, this.subscriptionPending = !1;
              }
              handleEvent(p) {
                var f = p.event, S = p.data;
                if (f === "pusher_internal:subscription_succeeded")
                  this.handleSubscriptionSucceededEvent(p);
                else if (f === "pusher_internal:subscription_count")
                  this.handleSubscriptionCountEvent(p);
                else if (f.indexOf("pusher_internal:") !== 0) {
                  var T = {};
                  this.emit(f, S, T);
                }
              }
              handleSubscriptionSucceededEvent(p) {
                this.subscriptionPending = !1, this.subscribed = !0, this.subscriptionCancelled ? this.pusher.unsubscribe(this.name) : this.emit("pusher:subscription_succeeded", p.data);
              }
              handleSubscriptionCountEvent(p) {
                p.data.subscription_count && (this.subscriptionCount = p.data.subscription_count), this.emit("pusher:subscription_count", p.data);
              }
              subscribe() {
                this.subscribed || (this.subscriptionPending = !0, this.subscriptionCancelled = !1, this.authorize(this.pusher.connection.socket_id, (p, f) => {
                  p ? (this.subscriptionPending = !1, nt.error(p.toString()), this.emit("pusher:subscription_error", Object.assign({}, {
                    type: "AuthError",
                    error: p.message
                  }, p instanceof V ? { status: p.status } : {}))) : this.pusher.send_event("pusher:subscribe", {
                    auth: f.auth,
                    channel_data: f.channel_data,
                    channel: this.name
                  });
                }));
              }
              unsubscribe() {
                this.subscribed = !1, this.pusher.send_event("pusher:unsubscribe", {
                  channel: this.name
                });
              }
              cancelSubscription() {
                this.subscriptionCancelled = !0;
              }
              reinstateSubscription() {
                this.subscriptionCancelled = !1;
              }
            }
            class Nn extends yn {
              authorize(p, f) {
                return this.pusher.config.channelAuthorizer({
                  channelName: this.name,
                  socketId: p
                }, f);
              }
            }
            class di {
              constructor() {
                this.reset();
              }
              get(p) {
                return Object.prototype.hasOwnProperty.call(this.members, p) ? {
                  id: p,
                  info: this.members[p]
                } : null;
              }
              each(p) {
                Ve(this.members, (f, S) => {
                  p(this.get(S));
                });
              }
              setMyID(p) {
                this.myID = p;
              }
              onSubscription(p) {
                this.members = p.presence.hash, this.count = p.presence.count, this.me = this.get(this.myID);
              }
              addMember(p) {
                return this.get(p.user_id) === null && this.count++, this.members[p.user_id] = p.user_info, this.get(p.user_id);
              }
              removeMember(p) {
                var f = this.get(p.user_id);
                return f && (delete this.members[p.user_id], this.count--), f;
              }
              reset() {
                this.members = {}, this.count = 0, this.myID = null, this.me = null;
              }
            }
            var Ko = function(k, p, f, S) {
              function T(Y) {
                return Y instanceof f ? Y : new f(function(le) {
                  le(Y);
                });
              }
              return new (f || (f = Promise))(function(Y, le) {
                function ye(Qe) {
                  try {
                    Ge(S.next(Qe));
                  } catch (gt) {
                    le(gt);
                  }
                }
                function Ie(Qe) {
                  try {
                    Ge(S.throw(Qe));
                  } catch (gt) {
                    le(gt);
                  }
                }
                function Ge(Qe) {
                  Qe.done ? Y(Qe.value) : T(Qe.value).then(ye, Ie);
                }
                Ge((S = S.apply(k, p || [])).next());
              });
            };
            class Pm extends Nn {
              constructor(p, f) {
                super(p, f), this.members = new di();
              }
              authorize(p, f) {
                super.authorize(p, (S, T) => Ko(this, void 0, void 0, function* () {
                  if (!S)
                    if (T = T, T.channel_data != null) {
                      var Y = JSON.parse(T.channel_data);
                      this.members.setMyID(Y.user_id);
                    } else if (yield this.pusher.user.signinDonePromise, this.pusher.user.user_data != null)
                      this.members.setMyID(this.pusher.user.user_data.id);
                    else {
                      let le = v.buildLogSuffix("authorizationEndpoint");
                      nt.error(`Invalid auth response for channel '${this.name}', expected 'channel_data' field. ${le}, or the user should be signed in.`), f("Invalid auth response");
                      return;
                    }
                  f(S, T);
                }));
              }
              handleEvent(p) {
                var f = p.event;
                if (f.indexOf("pusher_internal:") === 0)
                  this.handleInternalEvent(p);
                else {
                  var S = p.data, T = {};
                  p.user_id && (T.user_id = p.user_id), this.emit(f, S, T);
                }
              }
              handleInternalEvent(p) {
                var f = p.event, S = p.data;
                switch (f) {
                  case "pusher_internal:subscription_succeeded":
                    this.handleSubscriptionSucceededEvent(p);
                    break;
                  case "pusher_internal:subscription_count":
                    this.handleSubscriptionCountEvent(p);
                    break;
                  case "pusher_internal:member_added":
                    var T = this.members.addMember(S);
                    this.emit("pusher:member_added", T);
                    break;
                  case "pusher_internal:member_removed":
                    var Y = this.members.removeMember(S);
                    Y && this.emit("pusher:member_removed", Y);
                    break;
                }
              }
              handleSubscriptionSucceededEvent(p) {
                this.subscriptionPending = !1, this.subscribed = !0, this.subscriptionCancelled ? this.pusher.unsubscribe(this.name) : (this.members.onSubscription(p.data), this.emit("pusher:subscription_succeeded", this.members));
              }
              disconnect() {
                this.members.reset(), super.disconnect();
              }
            }
            var Mm = o(1), pi = o(0);
            class Tm extends Nn {
              constructor(p, f, S) {
                super(p, f), this.key = null, this.nacl = S;
              }
              authorize(p, f) {
                super.authorize(p, (S, T) => {
                  if (S) {
                    f(S, T);
                    return;
                  }
                  let Y = T.shared_secret;
                  if (!Y) {
                    f(new Error(`No shared_secret key in auth payload for encrypted channel: ${this.name}`), null);
                    return;
                  }
                  this.key = Object(pi.decode)(Y), delete T.shared_secret, f(null, T);
                });
              }
              trigger(p, f) {
                throw new E("Client events are not currently supported for encrypted channels");
              }
              handleEvent(p) {
                var f = p.event, S = p.data;
                if (f.indexOf("pusher_internal:") === 0 || f.indexOf("pusher:") === 0) {
                  super.handleEvent(p);
                  return;
                }
                this.handleEncryptedEvent(f, S);
              }
              handleEncryptedEvent(p, f) {
                if (!this.key) {
                  nt.debug("Received encrypted event before key has been retrieved from the authEndpoint");
                  return;
                }
                if (!f.ciphertext || !f.nonce) {
                  nt.error("Unexpected format for encrypted event, expected object with `ciphertext` and `nonce` fields, got: " + f);
                  return;
                }
                let S = Object(pi.decode)(f.ciphertext);
                if (S.length < this.nacl.secretbox.overheadLength) {
                  nt.error(`Expected encrypted event ciphertext length to be ${this.nacl.secretbox.overheadLength}, got: ${S.length}`);
                  return;
                }
                let T = Object(pi.decode)(f.nonce);
                if (T.length < this.nacl.secretbox.nonceLength) {
                  nt.error(`Expected encrypted event nonce length to be ${this.nacl.secretbox.nonceLength}, got: ${T.length}`);
                  return;
                }
                let Y = this.nacl.secretbox.open(S, T, this.key);
                if (Y === null) {
                  nt.debug("Failed to decrypt an event, probably because it was encrypted with a different key. Fetching a new key from the authEndpoint..."), this.authorize(this.pusher.connection.socket_id, (le, ye) => {
                    if (le) {
                      nt.error(`Failed to make a request to the authEndpoint: ${ye}. Unable to fetch new key, so dropping encrypted event`);
                      return;
                    }
                    if (Y = this.nacl.secretbox.open(S, T, this.key), Y === null) {
                      nt.error("Failed to decrypt event with new key. Dropping encrypted event");
                      return;
                    }
                    this.emit(p, this.getDataToEmit(Y));
                  });
                  return;
                }
                this.emit(p, this.getDataToEmit(Y));
              }
              getDataToEmit(p) {
                let f = Object(Mm.decode)(p);
                try {
                  return JSON.parse(f);
                } catch {
                  return f;
                }
              }
            }
            class Im extends Fe {
              constructor(p, f) {
                super(), this.state = "initialized", this.connection = null, this.key = p, this.options = f, this.timeline = this.options.timeline, this.usingTLS = this.options.useTLS, this.errorCallbacks = this.buildErrorCallbacks(), this.connectionCallbacks = this.buildConnectionCallbacks(this.errorCallbacks), this.handshakeCallbacks = this.buildHandshakeCallbacks(this.errorCallbacks);
                var S = Ee.getNetwork();
                S.bind("online", () => {
                  this.timeline.info({ netinfo: "online" }), (this.state === "connecting" || this.state === "unavailable") && this.retryIn(0);
                }), S.bind("offline", () => {
                  this.timeline.info({ netinfo: "offline" }), this.connection && this.sendActivityCheck();
                }), this.updateStrategy();
              }
              connect() {
                if (!(this.connection || this.runner)) {
                  if (!this.strategy.isSupported()) {
                    this.updateState("failed");
                    return;
                  }
                  this.updateState("connecting"), this.startConnecting(), this.setUnavailableTimer();
                }
              }
              send(p) {
                return this.connection ? this.connection.send(p) : !1;
              }
              send_event(p, f, S) {
                return this.connection ? this.connection.send_event(p, f, S) : !1;
              }
              disconnect() {
                this.disconnectInternally(), this.updateState("disconnected");
              }
              isUsingTLS() {
                return this.usingTLS;
              }
              startConnecting() {
                var p = (f, S) => {
                  f ? this.runner = this.strategy.connect(0, p) : S.action === "error" ? (this.emit("error", {
                    type: "HandshakeError",
                    error: S.error
                  }), this.timeline.error({ handshakeError: S.error })) : (this.abortConnecting(), this.handshakeCallbacks[S.action](S));
                };
                this.runner = this.strategy.connect(0, p);
              }
              abortConnecting() {
                this.runner && (this.runner.abort(), this.runner = null);
              }
              disconnectInternally() {
                if (this.abortConnecting(), this.clearRetryTimer(), this.clearUnavailableTimer(), this.connection) {
                  var p = this.abandonConnection();
                  p.close();
                }
              }
              updateStrategy() {
                this.strategy = this.options.getStrategy({
                  key: this.key,
                  timeline: this.timeline,
                  useTLS: this.usingTLS
                });
              }
              retryIn(p) {
                this.timeline.info({ action: "retry", delay: p }), p > 0 && this.emit("connecting_in", Math.round(p / 1e3)), this.retryTimer = new $e(p || 0, () => {
                  this.disconnectInternally(), this.connect();
                });
              }
              clearRetryTimer() {
                this.retryTimer && (this.retryTimer.ensureAborted(), this.retryTimer = null);
              }
              setUnavailableTimer() {
                this.unavailableTimer = new $e(this.options.unavailableTimeout, () => {
                  this.updateState("unavailable");
                });
              }
              clearUnavailableTimer() {
                this.unavailableTimer && this.unavailableTimer.ensureAborted();
              }
              sendActivityCheck() {
                this.stopActivityCheck(), this.connection.ping(), this.activityTimer = new $e(this.options.pongTimeout, () => {
                  this.timeline.error({ pong_timed_out: this.options.pongTimeout }), this.retryIn(0);
                });
              }
              resetActivityCheck() {
                this.stopActivityCheck(), this.connection && !this.connection.handlesActivityChecks() && (this.activityTimer = new $e(this.activityTimeout, () => {
                  this.sendActivityCheck();
                }));
              }
              stopActivityCheck() {
                this.activityTimer && this.activityTimer.ensureAborted();
              }
              buildConnectionCallbacks(p) {
                return ve({}, p, {
                  message: (f) => {
                    this.resetActivityCheck(), this.emit("message", f);
                  },
                  ping: () => {
                    this.send_event("pusher:pong", {});
                  },
                  activity: () => {
                    this.resetActivityCheck();
                  },
                  error: (f) => {
                    this.emit("error", f);
                  },
                  closed: () => {
                    this.abandonConnection(), this.shouldRetry() && this.retryIn(1e3);
                  }
                });
              }
              buildHandshakeCallbacks(p) {
                return ve({}, p, {
                  connected: (f) => {
                    this.activityTimeout = Math.min(this.options.activityTimeout, f.activityTimeout, f.connection.activityTimeout || 1 / 0), this.clearUnavailableTimer(), this.setConnection(f.connection), this.socket_id = this.connection.id, this.updateState("connected", { socket_id: this.socket_id });
                  }
                });
              }
              buildErrorCallbacks() {
                let p = (f) => (S) => {
                  S.error && this.emit("error", { type: "WebSocketError", error: S.error }), f(S);
                };
                return {
                  tls_only: p(() => {
                    this.usingTLS = !0, this.updateStrategy(), this.retryIn(0);
                  }),
                  refused: p(() => {
                    this.disconnect();
                  }),
                  backoff: p(() => {
                    this.retryIn(1e3);
                  }),
                  retry: p(() => {
                    this.retryIn(0);
                  })
                };
              }
              setConnection(p) {
                this.connection = p;
                for (var f in this.connectionCallbacks)
                  this.connection.bind(f, this.connectionCallbacks[f]);
                this.resetActivityCheck();
              }
              abandonConnection() {
                if (this.connection) {
                  this.stopActivityCheck();
                  for (var p in this.connectionCallbacks)
                    this.connection.unbind(p, this.connectionCallbacks[p]);
                  var f = this.connection;
                  return this.connection = null, f;
                }
              }
              updateState(p, f) {
                var S = this.state;
                if (this.state = p, S !== p) {
                  var T = p;
                  T === "connected" && (T += " with new socket ID " + f.socket_id), nt.debug("State changed", S + " -> " + T), this.timeline.info({ state: p, params: f }), this.emit("state_change", { previous: S, current: p }), this.emit(p, f);
                }
              }
              shouldRetry() {
                return this.state === "connecting" || this.state === "connected";
              }
            }
            class Em {
              constructor() {
                this.channels = {};
              }
              add(p, f) {
                return this.channels[p] || (this.channels[p] = Om(p, f)), this.channels[p];
              }
              all() {
                return Xe(this.channels);
              }
              find(p) {
                return this.channels[p];
              }
              remove(p) {
                var f = this.channels[p];
                return delete this.channels[p], f;
              }
              disconnect() {
                Ve(this.channels, function(p) {
                  p.disconnect();
                });
              }
            }
            function Om(k, p) {
              if (k.indexOf("private-encrypted-") === 0) {
                if (p.config.nacl)
                  return Pn.createEncryptedChannel(k, p, p.config.nacl);
                let f = "Tried to subscribe to a private-encrypted- channel but no nacl implementation available", S = v.buildLogSuffix("encryptedChannelSupport");
                throw new E(`${f}. ${S}`);
              } else {
                if (k.indexOf("private-") === 0)
                  return Pn.createPrivateChannel(k, p);
                if (k.indexOf("presence-") === 0)
                  return Pn.createPresenceChannel(k, p);
                if (k.indexOf("#") === 0)
                  throw new y('Cannot create a channel with name "' + k + '".');
                return Pn.createChannel(k, p);
              }
            }
            var Rm = {
              createChannels() {
                return new Em();
              },
              createConnectionManager(k, p) {
                return new Im(k, p);
              },
              createChannel(k, p) {
                return new yn(k, p);
              },
              createPrivateChannel(k, p) {
                return new Nn(k, p);
              },
              createPresenceChannel(k, p) {
                return new Pm(k, p);
              },
              createEncryptedChannel(k, p, f) {
                return new Tm(k, p, f);
              },
              createTimelineSender(k, p) {
                return new no(k, p);
              },
              createHandshake(k, p) {
                return new ui(k, p);
              },
              createAssistantToTheTransportManager(k, p, f) {
                return new eo(k, p, f);
              }
            }, Pn = Rm;
            class Bl {
              constructor(p) {
                this.options = p || {}, this.livesLeft = this.options.lives || 1 / 0;
              }
              getAssistant(p) {
                return Pn.createAssistantToTheTransportManager(this, p, {
                  minPingDelay: this.options.minPingDelay,
                  maxPingDelay: this.options.maxPingDelay
                });
              }
              isAlive() {
                return this.livesLeft > 0;
              }
              reportDeath() {
                this.livesLeft -= 1;
              }
            }
            class ts {
              constructor(p, f) {
                this.strategies = p, this.loop = !!f.loop, this.failFast = !!f.failFast, this.timeout = f.timeout, this.timeoutLimit = f.timeoutLimit;
              }
              isSupported() {
                return Bt(this.strategies, ie.method("isSupported"));
              }
              connect(p, f) {
                var S = this.strategies, T = 0, Y = this.timeout, le = null, ye = (Ie, Ge) => {
                  Ge ? f(null, Ge) : (T = T + 1, this.loop && (T = T % S.length), T < S.length ? (Y && (Y = Y * 2, this.timeoutLimit && (Y = Math.min(Y, this.timeoutLimit))), le = this.tryStrategy(S[T], p, { timeout: Y, failFast: this.failFast }, ye)) : f(!0));
                };
                return le = this.tryStrategy(S[T], p, { timeout: Y, failFast: this.failFast }, ye), {
                  abort: function() {
                    le.abort();
                  },
                  forceMinPriority: function(Ie) {
                    p = Ie, le && le.forceMinPriority(Ie);
                  }
                };
              }
              tryStrategy(p, f, S, T) {
                var Y = null, le = null;
                return S.timeout > 0 && (Y = new $e(S.timeout, function() {
                  le.abort(), T(!0);
                })), le = p.connect(f, function(ye, Ie) {
                  ye && Y && Y.isRunning() && !S.failFast || (Y && Y.ensureAborted(), T(ye, Ie));
                }), {
                  abort: function() {
                    Y && Y.ensureAborted(), le.abort();
                  },
                  forceMinPriority: function(ye) {
                    le.forceMinPriority(ye);
                  }
                };
              }
            }
            class mi {
              constructor(p) {
                this.strategies = p;
              }
              isSupported() {
                return Bt(this.strategies, ie.method("isSupported"));
              }
              connect(p, f) {
                return Lm(this.strategies, p, function(S, T) {
                  return function(Y, le) {
                    if (T[S].error = Y, Y) {
                      Dm(T) && f(!0);
                      return;
                    }
                    Ue(T, function(ye) {
                      ye.forceMinPriority(le.transport.priority);
                    }), f(null, le);
                  };
                });
              }
            }
            function Lm(k, p, f) {
              var S = Ye(k, function(T, Y, le, ye) {
                return T.connect(p, f(Y, ye));
              });
              return {
                abort: function() {
                  Ue(S, jm);
                },
                forceMinPriority: function(T) {
                  Ue(S, function(Y) {
                    Y.forceMinPriority(T);
                  });
                }
              };
            }
            function Dm(k) {
              return Ln(k, function(p) {
                return !!p.error;
              });
            }
            function jm(k) {
              !k.error && !k.aborted && (k.abort(), k.aborted = !0);
            }
            class Nm {
              constructor(p, f, S) {
                this.strategy = p, this.transports = f, this.ttl = S.ttl || 1800 * 1e3, this.usingTLS = S.useTLS, this.timeline = S.timeline;
              }
              isSupported() {
                return this.strategy.isSupported();
              }
              connect(p, f) {
                var S = this.usingTLS, T = Vm(S), Y = T && T.cacheSkipCount ? T.cacheSkipCount : 0, le = [this.strategy];
                if (T && T.timestamp + this.ttl >= ie.now()) {
                  var ye = this.transports[T.transport];
                  ye && (["ws", "wss"].includes(T.transport) || Y > 3 ? (this.timeline.info({
                    cached: !0,
                    transport: T.transport,
                    latency: T.latency
                  }), le.push(new ts([ye], {
                    timeout: T.latency * 2 + 1e3,
                    failFast: !0
                  }))) : Y++);
                }
                var Ie = ie.now(), Ge = le.pop().connect(p, function Qe(gt, Jo) {
                  gt ? (ql(S), le.length > 0 ? (Ie = ie.now(), Ge = le.pop().connect(p, Qe)) : f(gt)) : (Um(S, Jo.transport.name, ie.now() - Ie, Y), f(null, Jo));
                });
                return {
                  abort: function() {
                    Ge.abort();
                  },
                  forceMinPriority: function(Qe) {
                    p = Qe, Ge && Ge.forceMinPriority(Qe);
                  }
                };
              }
            }
            function hi(k) {
              return "pusherTransport" + (k ? "TLS" : "NonTLS");
            }
            function Vm(k) {
              var p = Ee.getLocalStorage();
              if (p)
                try {
                  var f = p[hi(k)];
                  if (f)
                    return JSON.parse(f);
                } catch {
                  ql(k);
                }
              return null;
            }
            function Um(k, p, f, S) {
              var T = Ee.getLocalStorage();
              if (T)
                try {
                  T[hi(k)] = mn({
                    timestamp: ie.now(),
                    transport: p,
                    latency: f,
                    cacheSkipCount: S
                  });
                } catch {
                }
            }
            function ql(k) {
              var p = Ee.getLocalStorage();
              if (p)
                try {
                  delete p[hi(k)];
                } catch {
                }
            }
            class Xo {
              constructor(p, { delay: f }) {
                this.strategy = p, this.options = { delay: f };
              }
              isSupported() {
                return this.strategy.isSupported();
              }
              connect(p, f) {
                var S = this.strategy, T, Y = new $e(this.options.delay, function() {
                  T = S.connect(p, f);
                });
                return {
                  abort: function() {
                    Y.ensureAborted(), T && T.abort();
                  },
                  forceMinPriority: function(le) {
                    p = le, T && T.forceMinPriority(le);
                  }
                };
              }
            }
            class so {
              constructor(p, f, S) {
                this.test = p, this.trueBranch = f, this.falseBranch = S;
              }
              isSupported() {
                var p = this.test() ? this.trueBranch : this.falseBranch;
                return p.isSupported();
              }
              connect(p, f) {
                var S = this.test() ? this.trueBranch : this.falseBranch;
                return S.connect(p, f);
              }
            }
            class Fm {
              constructor(p) {
                this.strategy = p;
              }
              isSupported() {
                return this.strategy.isSupported();
              }
              connect(p, f) {
                var S = this.strategy.connect(p, function(T, Y) {
                  Y && S.abort(), f(T, Y);
                });
                return S;
              }
            }
            function oo(k) {
              return function() {
                return k.isSupported();
              };
            }
            var Bm = function(k, p, f) {
              var S = {};
              function T(tc, Fh, Bh, qh, Hh) {
                var nc = f(k, tc, Fh, Bh, qh, Hh);
                return S[tc] = nc, nc;
              }
              var Y = Object.assign({}, p, {
                hostNonTLS: k.wsHost + ":" + k.wsPort,
                hostTLS: k.wsHost + ":" + k.wssPort,
                httpPath: k.wsPath
              }), le = Object.assign({}, Y, {
                useTLS: !0
              }), ye = Object.assign({}, p, {
                hostNonTLS: k.httpHost + ":" + k.httpPort,
                hostTLS: k.httpHost + ":" + k.httpsPort,
                httpPath: k.httpPath
              }), Ie = {
                loop: !0,
                timeout: 15e3,
                timeoutLimit: 6e4
              }, Ge = new Bl({
                minPingDelay: 1e4,
                maxPingDelay: k.activityTimeout
              }), Qe = new Bl({
                lives: 2,
                minPingDelay: 1e4,
                maxPingDelay: k.activityTimeout
              }), gt = T("ws", "ws", 3, Y, Ge), Jo = T("wss", "ws", 3, le, Ge), Dh = T("sockjs", "sockjs", 1, ye), Kl = T("xhr_streaming", "xhr_streaming", 1, ye, Qe), jh = T("xdr_streaming", "xdr_streaming", 1, ye, Qe), Xl = T("xhr_polling", "xhr_polling", 1, ye), Nh = T("xdr_polling", "xdr_polling", 1, ye), Ql = new ts([gt], Ie), Vh = new ts([Jo], Ie), Uh = new ts([Dh], Ie), Jl = new ts([
                new so(oo(Kl), Kl, jh)
              ], Ie), Yl = new ts([
                new so(oo(Xl), Xl, Nh)
              ], Ie), ec = new ts([
                new so(oo(Jl), new mi([
                  Jl,
                  new Xo(Yl, { delay: 4e3 })
                ]), Yl)
              ], Ie), gi = new so(oo(ec), ec, Uh), ki;
              return p.useTLS ? ki = new mi([
                Ql,
                new Xo(gi, { delay: 2e3 })
              ]) : ki = new mi([
                Ql,
                new Xo(Vh, { delay: 2e3 }),
                new Xo(gi, { delay: 5e3 })
              ]), new Nm(new Fm(new so(oo(gt), ki, gi)), S, {
                ttl: 18e5,
                timeline: p.timeline,
                useTLS: p.useTLS
              });
            }, qm = Bm, Hm = (function() {
              var k = this;
              k.timeline.info(k.buildTimelineMessage({
                transport: k.name + (k.options.useTLS ? "s" : "")
              })), k.hooks.isInitialized() ? k.changeState("initialized") : k.hooks.file ? (k.changeState("initializing"), m.load(k.hooks.file, { useTLS: k.options.useTLS }, function(p, f) {
                k.hooks.isInitialized() ? (k.changeState("initialized"), f(!0)) : (p && k.onError(p), k.onClose(), f(!1));
              })) : k.onClose();
            }), Wm = {
              getRequest: function(k) {
                var p = new window.XDomainRequest();
                return p.ontimeout = function() {
                  k.emit("error", new w()), k.close();
                }, p.onerror = function(f) {
                  k.emit("error", f), k.close();
                }, p.onprogress = function() {
                  p.responseText && p.responseText.length > 0 && k.onChunk(200, p.responseText);
                }, p.onload = function() {
                  p.responseText && p.responseText.length > 0 && k.onChunk(200, p.responseText), k.emit("finished", 200), k.close();
                }, p;
              },
              abortRequest: function(k) {
                k.ontimeout = k.onerror = k.onprogress = k.onload = null, k.abort();
              }
            }, Gm = Wm;
            const Zm = 256 * 1024;
            class Km extends Fe {
              constructor(p, f, S) {
                super(), this.hooks = p, this.method = f, this.url = S;
              }
              start(p) {
                this.position = 0, this.xhr = this.hooks.getRequest(this), this.unloader = () => {
                  this.close();
                }, Ee.addUnloadListener(this.unloader), this.xhr.open(this.method, this.url, !0), this.xhr.setRequestHeader && this.xhr.setRequestHeader("Content-Type", "application/json"), this.xhr.send(p);
              }
              close() {
                this.unloader && (Ee.removeUnloadListener(this.unloader), this.unloader = null), this.xhr && (this.hooks.abortRequest(this.xhr), this.xhr = null);
              }
              onChunk(p, f) {
                for (; ; ) {
                  var S = this.advanceBuffer(f);
                  if (S)
                    this.emit("chunk", { status: p, data: S });
                  else
                    break;
                }
                this.isBufferTooLong(f) && this.emit("buffer_too_long");
              }
              advanceBuffer(p) {
                var f = p.slice(this.position), S = f.indexOf(`
`);
                return S !== -1 ? (this.position += S + 1, f.slice(0, S)) : null;
              }
              isBufferTooLong(p) {
                return this.position === p.length && p.length > Zm;
              }
            }
            var fi;
            (function(k) {
              k[k.CONNECTING = 0] = "CONNECTING", k[k.OPEN = 1] = "OPEN", k[k.CLOSED = 3] = "CLOSED";
            })(fi || (fi = {}));
            var ns = fi, Xm = 1;
            class Qm {
              constructor(p, f) {
                this.hooks = p, this.session = Wl(1e3) + "/" + th(8), this.location = Jm(f), this.readyState = ns.CONNECTING, this.openStream();
              }
              send(p) {
                return this.sendRaw(JSON.stringify([p]));
              }
              ping() {
                this.hooks.sendHeartbeat(this);
              }
              close(p, f) {
                this.onClose(p, f, !0);
              }
              sendRaw(p) {
                if (this.readyState === ns.OPEN)
                  try {
                    return Ee.createSocketRequest("POST", Hl(Ym(this.location, this.session))).start(p), !0;
                  } catch {
                    return !1;
                  }
                else
                  return !1;
              }
              reconnect() {
                this.closeStream(), this.openStream();
              }
              onClose(p, f, S) {
                this.closeStream(), this.readyState = ns.CLOSED, this.onclose && this.onclose({
                  code: p,
                  reason: f,
                  wasClean: S
                });
              }
              onChunk(p) {
                if (p.status === 200) {
                  this.readyState === ns.OPEN && this.onActivity();
                  var f, S = p.data.slice(0, 1);
                  switch (S) {
                    case "o":
                      f = JSON.parse(p.data.slice(1) || "{}"), this.onOpen(f);
                      break;
                    case "a":
                      f = JSON.parse(p.data.slice(1) || "[]");
                      for (var T = 0; T < f.length; T++)
                        this.onEvent(f[T]);
                      break;
                    case "m":
                      f = JSON.parse(p.data.slice(1) || "null"), this.onEvent(f);
                      break;
                    case "h":
                      this.hooks.onHeartbeat(this);
                      break;
                    case "c":
                      f = JSON.parse(p.data.slice(1) || "[]"), this.onClose(f[0], f[1], !0);
                      break;
                  }
                }
              }
              onOpen(p) {
                this.readyState === ns.CONNECTING ? (p && p.hostname && (this.location.base = eh(this.location.base, p.hostname)), this.readyState = ns.OPEN, this.onopen && this.onopen()) : this.onClose(1006, "Server lost session", !0);
              }
              onEvent(p) {
                this.readyState === ns.OPEN && this.onmessage && this.onmessage({ data: p });
              }
              onActivity() {
                this.onactivity && this.onactivity();
              }
              onError(p) {
                this.onerror && this.onerror(p);
              }
              openStream() {
                this.stream = Ee.createSocketRequest("POST", Hl(this.hooks.getReceiveURL(this.location, this.session))), this.stream.bind("chunk", (p) => {
                  this.onChunk(p);
                }), this.stream.bind("finished", (p) => {
                  this.hooks.onFinished(this, p);
                }), this.stream.bind("buffer_too_long", () => {
                  this.reconnect();
                });
                try {
                  this.stream.start();
                } catch (p) {
                  ie.defer(() => {
                    this.onError(p), this.onClose(1006, "Could not start streaming", !1);
                  });
                }
              }
              closeStream() {
                this.stream && (this.stream.unbind_all(), this.stream.close(), this.stream = null);
              }
            }
            function Jm(k) {
              var p = /([^\?]*)\/*(\??.*)/.exec(k);
              return {
                base: p[1],
                queryString: p[2]
              };
            }
            function Ym(k, p) {
              return k.base + "/" + p + "/xhr_send";
            }
            function Hl(k) {
              var p = k.indexOf("?") === -1 ? "?" : "&";
              return k + p + "t=" + +/* @__PURE__ */ new Date() + "&n=" + Xm++;
            }
            function eh(k, p) {
              var f = /(https?:\/\/)([^\/:]+)((\/|:)?.*)/.exec(k);
              return f[1] + p + f[3];
            }
            function Wl(k) {
              return Ee.randomInt(k);
            }
            function th(k) {
              for (var p = [], f = 0; f < k; f++)
                p.push(Wl(32).toString(32));
              return p.join("");
            }
            var nh = Qm, sh = {
              getReceiveURL: function(k, p) {
                return k.base + "/" + p + "/xhr_streaming" + k.queryString;
              },
              onHeartbeat: function(k) {
                k.sendRaw("[]");
              },
              sendHeartbeat: function(k) {
                k.sendRaw("[]");
              },
              onFinished: function(k, p) {
                k.onClose(1006, "Connection interrupted (" + p + ")", !1);
              }
            }, oh = sh, ah = {
              getReceiveURL: function(k, p) {
                return k.base + "/" + p + "/xhr" + k.queryString;
              },
              onHeartbeat: function() {
              },
              sendHeartbeat: function(k) {
                k.sendRaw("[]");
              },
              onFinished: function(k, p) {
                p === 200 ? k.reconnect() : k.onClose(1006, "Connection interrupted (" + p + ")", !1);
              }
            }, ih = ah, rh = {
              getRequest: function(k) {
                var p = Ee.getXHRAPI(), f = new p();
                return f.onreadystatechange = f.onprogress = function() {
                  switch (f.readyState) {
                    case 3:
                      f.responseText && f.responseText.length > 0 && k.onChunk(f.status, f.responseText);
                      break;
                    case 4:
                      f.responseText && f.responseText.length > 0 && k.onChunk(f.status, f.responseText), k.emit("finished", f.status), k.close();
                      break;
                  }
                }, f;
              },
              abortRequest: function(k) {
                k.onreadystatechange = null, k.abort();
              }
            }, lh = rh, ch = {
              createStreamingSocket(k) {
                return this.createSocket(oh, k);
              },
              createPollingSocket(k) {
                return this.createSocket(ih, k);
              },
              createSocket(k, p) {
                return new nh(k, p);
              },
              createXHR(k, p) {
                return this.createRequest(lh, k, p);
              },
              createRequest(k, p, f) {
                return new Km(k, p, f);
              }
            }, Gl = ch;
            Gl.createXDR = function(k, p) {
              return this.createRequest(Gm, k, p);
            };
            var uh = Gl, dh = {
              nextAuthCallbackID: 1,
              auth_callbacks: {},
              ScriptReceivers: i,
              DependenciesReceivers: d,
              getDefaultStrategy: qm,
              Transports: Ys,
              transportConnectionInitializer: Hm,
              HTTPFactory: uh,
              TimelineTransport: ci,
              getXHRAPI() {
                return window.XMLHttpRequest;
              },
              getWebSocketAPI() {
                return window.WebSocket || window.MozWebSocket;
              },
              setup(k) {
                window.Pusher = k;
                var p = () => {
                  this.onDocumentBody(k.ready);
                };
                window.JSON ? p() : m.load("json2", {}, p);
              },
              getDocument() {
                return document;
              },
              getProtocol() {
                return this.getDocument().location.protocol;
              },
              getAuthorizers() {
                return { ajax: Z, jsonp: Fo };
              },
              onDocumentBody(k) {
                document.body ? k() : setTimeout(() => {
                  this.onDocumentBody(k);
                }, 0);
              },
              createJSONPRequest(k, p) {
                return new Qn(k, p);
              },
              createScriptRequest(k) {
                return new li(k);
              },
              getLocalStorage() {
                try {
                  return window.localStorage;
                } catch {
                  return;
                }
              },
              createXHR() {
                return this.getXHRAPI() ? this.createXMLHttpRequest() : this.createMicrosoftXHR();
              },
              createXMLHttpRequest() {
                var k = this.getXHRAPI();
                return new k();
              },
              createMicrosoftXHR() {
                return new ActiveXObject("Microsoft.XMLHTTP");
              },
              getNetwork() {
                return Go;
              },
              createWebSocket(k) {
                var p = this.getWebSocketAPI();
                return new p(k);
              },
              createSocketRequest(k, p) {
                if (this.isXHRSupported())
                  return this.HTTPFactory.createXHR(k, p);
                if (this.isXDRSupported(p.indexOf("https:") === 0))
                  return this.HTTPFactory.createXDR(k, p);
                throw "Cross-origin HTTP requests are not supported";
              },
              isXHRSupported() {
                var k = this.getXHRAPI();
                return !!k && new k().withCredentials !== void 0;
              },
              isXDRSupported(k) {
                var p = k ? "https:" : "http:", f = this.getProtocol();
                return !!window.XDomainRequest && f === p;
              },
              addUnloadListener(k) {
                window.addEventListener !== void 0 ? window.addEventListener("unload", k, !1) : window.attachEvent !== void 0 && window.attachEvent("onunload", k);
              },
              removeUnloadListener(k) {
                window.addEventListener !== void 0 ? window.removeEventListener("unload", k, !1) : window.detachEvent !== void 0 && window.detachEvent("onunload", k);
              },
              randomInt(k) {
                return Math.floor(function() {
                  return (window.crypto || window.msCrypto).getRandomValues(new Uint32Array(1))[0] / Math.pow(2, 32);
                }() * k);
              }
            }, Ee = dh, _i;
            (function(k) {
              k[k.ERROR = 3] = "ERROR", k[k.INFO = 6] = "INFO", k[k.DEBUG = 7] = "DEBUG";
            })(_i || (_i = {}));
            var Qo = _i;
            class ph {
              constructor(p, f, S) {
                this.key = p, this.session = f, this.events = [], this.options = S || {}, this.sent = 0, this.uniqueID = 0;
              }
              log(p, f) {
                p <= this.options.level && (this.events.push(ve({}, f, { timestamp: ie.now() })), this.options.limit && this.events.length > this.options.limit && this.events.shift());
              }
              error(p) {
                this.log(Qo.ERROR, p);
              }
              info(p) {
                this.log(Qo.INFO, p);
              }
              debug(p) {
                this.log(Qo.DEBUG, p);
              }
              isEmpty() {
                return this.events.length === 0;
              }
              send(p, f) {
                var S = ve({
                  session: this.session,
                  bundle: this.sent + 1,
                  key: this.key,
                  lib: "js",
                  version: this.options.version,
                  cluster: this.options.cluster,
                  features: this.options.features,
                  timeline: this.events
                }, this.options.params);
                return this.events = [], p(S, (T, Y) => {
                  T || this.sent++, f && f(T, Y);
                }), !0;
              }
              generateUniqueID() {
                return this.uniqueID++, this.uniqueID;
              }
            }
            class mh {
              constructor(p, f, S, T) {
                this.name = p, this.priority = f, this.transport = S, this.options = T || {};
              }
              isSupported() {
                return this.transport.isSupported({
                  useTLS: this.options.useTLS
                });
              }
              connect(p, f) {
                if (this.isSupported()) {
                  if (this.priority < p)
                    return Zl(new P(), f);
                } else return Zl(new j(), f);
                var S = !1, T = this.transport.createConnection(this.name, this.priority, this.options.key, this.options), Y = null, le = function() {
                  T.unbind("initialized", le), T.connect();
                }, ye = function() {
                  Y = Pn.createHandshake(T, function(gt) {
                    S = !0, Qe(), f(null, gt);
                  });
                }, Ie = function(gt) {
                  Qe(), f(gt);
                }, Ge = function() {
                  Qe();
                  var gt;
                  gt = mn(T), f(new M(gt));
                }, Qe = function() {
                  T.unbind("initialized", le), T.unbind("open", ye), T.unbind("error", Ie), T.unbind("closed", Ge);
                };
                return T.bind("initialized", le), T.bind("open", ye), T.bind("error", Ie), T.bind("closed", Ge), T.initialize(), {
                  abort: () => {
                    S || (Qe(), Y ? Y.close() : T.close());
                  },
                  forceMinPriority: (gt) => {
                    S || this.priority < gt && (Y ? Y.close() : T.close());
                  }
                };
              }
            }
            function Zl(k, p) {
              return ie.defer(function() {
                p(k);
              }), {
                abort: function() {
                },
                forceMinPriority: function() {
                }
              };
            }
            const { Transports: hh } = Ee;
            var fh = function(k, p, f, S, T, Y) {
              var le = hh[f];
              if (!le)
                throw new R(f);
              var ye = (!k.enabledTransports || ot(k.enabledTransports, p) !== -1) && (!k.disabledTransports || ot(k.disabledTransports, p) === -1), Ie;
              return ye ? (T = Object.assign({ ignoreNullOrigin: k.ignoreNullOrigin }, T), Ie = new mh(p, S, Y ? Y.getAssistant(le) : le, T)) : Ie = _h, Ie;
            }, _h = {
              isSupported: function() {
                return !1;
              },
              connect: function(k, p) {
                var f = ie.defer(function() {
                  p(new j());
                });
                return {
                  abort: function() {
                    f.ensureAborted();
                  },
                  forceMinPriority: function() {
                  }
                };
              }
            };
            function vh(k) {
              if (k == null)
                throw "You must pass an options object";
              if (k.cluster == null)
                throw "Options object must provide a cluster";
              "disableStats" in k && nt.warn("The disableStats option is deprecated in favor of enableStats");
            }
            const gh = (k, p) => {
              var f = "socket_id=" + encodeURIComponent(k.socketId);
              for (var S in p.params)
                f += "&" + encodeURIComponent(S) + "=" + encodeURIComponent(p.params[S]);
              if (p.paramsProvider != null) {
                let T = p.paramsProvider();
                for (var S in T)
                  f += "&" + encodeURIComponent(S) + "=" + encodeURIComponent(T[S]);
              }
              return f;
            };
            var kh = (k) => {
              if (typeof Ee.getAuthorizers()[k.transport] > "u")
                throw `'${k.transport}' is not a recognized auth transport`;
              return (p, f) => {
                const S = gh(p, k);
                Ee.getAuthorizers()[k.transport](Ee, S, k, z.UserAuthentication, f);
              };
            };
            const yh = (k, p) => {
              var f = "socket_id=" + encodeURIComponent(k.socketId);
              f += "&channel_name=" + encodeURIComponent(k.channelName);
              for (var S in p.params)
                f += "&" + encodeURIComponent(S) + "=" + encodeURIComponent(p.params[S]);
              if (p.paramsProvider != null) {
                let T = p.paramsProvider();
                for (var S in T)
                  f += "&" + encodeURIComponent(S) + "=" + encodeURIComponent(T[S]);
              }
              return f;
            };
            var bh = (k) => {
              if (typeof Ee.getAuthorizers()[k.transport] > "u")
                throw `'${k.transport}' is not a recognized auth transport`;
              return (p, f) => {
                const S = yh(p, k);
                Ee.getAuthorizers()[k.transport](Ee, S, k, z.ChannelAuthorization, f);
              };
            };
            const wh = (k, p, f) => {
              const S = {
                authTransport: p.transport,
                authEndpoint: p.endpoint,
                auth: {
                  params: p.params,
                  headers: p.headers
                }
              };
              return (T, Y) => {
                const le = k.channel(T.channelName);
                f(le, S).authorize(T.socketId, Y);
              };
            };
            function xh(k, p) {
              let f = {
                activityTimeout: k.activityTimeout || c.activityTimeout,
                cluster: k.cluster,
                httpPath: k.httpPath || c.httpPath,
                httpPort: k.httpPort || c.httpPort,
                httpsPort: k.httpsPort || c.httpsPort,
                pongTimeout: k.pongTimeout || c.pongTimeout,
                statsHost: k.statsHost || c.stats_host,
                unavailableTimeout: k.unavailableTimeout || c.unavailableTimeout,
                wsPath: k.wsPath || c.wsPath,
                wsPort: k.wsPort || c.wsPort,
                wssPort: k.wssPort || c.wssPort,
                enableStats: Ch(k),
                httpHost: $h(k),
                useTLS: Ah(k),
                wsHost: zh(k),
                userAuthenticator: Ph(k),
                channelAuthorizer: Th(k, p)
              };
              return "disabledTransports" in k && (f.disabledTransports = k.disabledTransports), "enabledTransports" in k && (f.enabledTransports = k.enabledTransports), "ignoreNullOrigin" in k && (f.ignoreNullOrigin = k.ignoreNullOrigin), "timelineParams" in k && (f.timelineParams = k.timelineParams), "nacl" in k && (f.nacl = k.nacl), f;
            }
            function $h(k) {
              return k.httpHost ? k.httpHost : k.cluster ? `sockjs-${k.cluster}.pusher.com` : c.httpHost;
            }
            function zh(k) {
              return k.wsHost ? k.wsHost : Sh(k.cluster);
            }
            function Sh(k) {
              return `ws-${k}.pusher.com`;
            }
            function Ah(k) {
              return Ee.getProtocol() === "https:" ? !0 : k.forceTLS !== !1;
            }
            function Ch(k) {
              return "enableStats" in k ? k.enableStats : "disableStats" in k ? !k.disableStats : !1;
            }
            function Ph(k) {
              const p = Object.assign(Object.assign({}, c.userAuthentication), k.userAuthentication);
              return "customHandler" in p && p.customHandler != null ? p.customHandler : kh(p);
            }
            function Mh(k, p) {
              let f;
              return "channelAuthorization" in k ? f = Object.assign(Object.assign({}, c.channelAuthorization), k.channelAuthorization) : (f = {
                transport: k.authTransport || c.authTransport,
                endpoint: k.authEndpoint || c.authEndpoint
              }, "auth" in k && ("params" in k.auth && (f.params = k.auth.params), "headers" in k.auth && (f.headers = k.auth.headers)), "authorizer" in k && (f.customHandler = wh(p, f, k.authorizer))), f;
            }
            function Th(k, p) {
              const f = Mh(k, p);
              return "customHandler" in f && f.customHandler != null ? f.customHandler : bh(f);
            }
            class Ih extends Fe {
              constructor(p) {
                super(function(f, S) {
                  nt.debug(`No callbacks on watchlist events for ${f}`);
                }), this.pusher = p, this.bindWatchlistInternalEvent();
              }
              handleEvent(p) {
                p.data.events.forEach((f) => {
                  this.emit(f.name, f);
                });
              }
              bindWatchlistInternalEvent() {
                this.pusher.connection.bind("message", (p) => {
                  var f = p.event;
                  f === "pusher_internal:watchlist_events" && this.handleEvent(p);
                });
              }
            }
            function Eh() {
              let k, p;
              return { promise: new Promise((S, T) => {
                k = S, p = T;
              }), resolve: k, reject: p };
            }
            var Oh = Eh;
            class Rh extends Fe {
              constructor(p) {
                super(function(f, S) {
                  nt.debug("No callbacks on user for " + f);
                }), this.signin_requested = !1, this.user_data = null, this.serverToUserChannel = null, this.signinDonePromise = null, this._signinDoneResolve = null, this._onAuthorize = (f, S) => {
                  if (f) {
                    nt.warn(`Error during signin: ${f}`), this._cleanup();
                    return;
                  }
                  this.pusher.send_event("pusher:signin", {
                    auth: S.auth,
                    user_data: S.user_data
                  });
                }, this.pusher = p, this.pusher.connection.bind("state_change", ({ previous: f, current: S }) => {
                  f !== "connected" && S === "connected" && this._signin(), f === "connected" && S !== "connected" && (this._cleanup(), this._newSigninPromiseIfNeeded());
                }), this.watchlist = new Ih(p), this.pusher.connection.bind("message", (f) => {
                  var S = f.event;
                  S === "pusher:signin_success" && this._onSigninSuccess(f.data), this.serverToUserChannel && this.serverToUserChannel.name === f.channel && this.serverToUserChannel.handleEvent(f);
                });
              }
              signin() {
                this.signin_requested || (this.signin_requested = !0, this._signin());
              }
              _signin() {
                this.signin_requested && (this._newSigninPromiseIfNeeded(), this.pusher.connection.state === "connected" && this.pusher.config.userAuthenticator({
                  socketId: this.pusher.connection.socket_id
                }, this._onAuthorize));
              }
              _onSigninSuccess(p) {
                try {
                  this.user_data = JSON.parse(p.user_data);
                } catch {
                  nt.error(`Failed parsing user data after signin: ${p.user_data}`), this._cleanup();
                  return;
                }
                if (typeof this.user_data.id != "string" || this.user_data.id === "") {
                  nt.error(`user_data doesn't contain an id. user_data: ${this.user_data}`), this._cleanup();
                  return;
                }
                this._signinDoneResolve(), this._subscribeChannels();
              }
              _subscribeChannels() {
                const p = (f) => {
                  f.subscriptionPending && f.subscriptionCancelled ? f.reinstateSubscription() : !f.subscriptionPending && this.pusher.connection.state === "connected" && f.subscribe();
                };
                this.serverToUserChannel = new yn(`#server-to-user-${this.user_data.id}`, this.pusher), this.serverToUserChannel.bind_global((f, S) => {
                  f.indexOf("pusher_internal:") === 0 || f.indexOf("pusher:") === 0 || this.emit(f, S);
                }), p(this.serverToUserChannel);
              }
              _cleanup() {
                this.user_data = null, this.serverToUserChannel && (this.serverToUserChannel.unbind_all(), this.serverToUserChannel.disconnect(), this.serverToUserChannel = null), this.signin_requested && this._signinDoneResolve();
              }
              _newSigninPromiseIfNeeded() {
                if (!this.signin_requested || this.signinDonePromise && !this.signinDonePromise.done)
                  return;
                const { promise: p, resolve: f } = Oh();
                p.done = !1;
                const S = () => {
                  p.done = !0;
                };
                p.then(S).catch(S), this.signinDonePromise = p, this._signinDoneResolve = f;
              }
            }
            class Et {
              static ready() {
                Et.isReady = !0;
                for (var p = 0, f = Et.instances.length; p < f; p++)
                  Et.instances[p].connect();
              }
              static getClientFeatures() {
                return fe(pt({ ws: Ee.Transports.ws }, function(p) {
                  return p.isSupported({});
                }));
              }
              constructor(p, f) {
                Lh(p), vh(f), this.key = p, this.config = xh(f, this), this.channels = Pn.createChannels(), this.global_emitter = new Fe(), this.sessionID = Ee.randomInt(1e9), this.timeline = new ph(this.key, this.sessionID, {
                  cluster: this.config.cluster,
                  features: Et.getClientFeatures(),
                  params: this.config.timelineParams || {},
                  limit: 50,
                  level: Qo.INFO,
                  version: c.VERSION
                }), this.config.enableStats && (this.timelineSender = Pn.createTimelineSender(this.timeline, {
                  host: this.config.statsHost,
                  path: "/timeline/v2/" + Ee.TimelineTransport.name
                }));
                var S = (T) => Ee.getDefaultStrategy(this.config, T, fh);
                this.connection = Pn.createConnectionManager(this.key, {
                  getStrategy: S,
                  timeline: this.timeline,
                  activityTimeout: this.config.activityTimeout,
                  pongTimeout: this.config.pongTimeout,
                  unavailableTimeout: this.config.unavailableTimeout,
                  useTLS: !!this.config.useTLS
                }), this.connection.bind("connected", () => {
                  this.subscribeAll(), this.timelineSender && this.timelineSender.send(this.connection.isUsingTLS());
                }), this.connection.bind("message", (T) => {
                  var Y = T.event, le = Y.indexOf("pusher_internal:") === 0;
                  if (T.channel) {
                    var ye = this.channel(T.channel);
                    ye && ye.handleEvent(T);
                  }
                  le || this.global_emitter.emit(T.event, T.data);
                }), this.connection.bind("connecting", () => {
                  this.channels.disconnect();
                }), this.connection.bind("disconnected", () => {
                  this.channels.disconnect();
                }), this.connection.bind("error", (T) => {
                  nt.warn(T);
                }), Et.instances.push(this), this.timeline.info({ instances: Et.instances.length }), this.user = new Rh(this), Et.isReady && this.connect();
              }
              channel(p) {
                return this.channels.find(p);
              }
              allChannels() {
                return this.channels.all();
              }
              connect() {
                if (this.connection.connect(), this.timelineSender && !this.timelineSenderTimer) {
                  var p = this.connection.isUsingTLS(), f = this.timelineSender;
                  this.timelineSenderTimer = new Ze(6e4, function() {
                    f.send(p);
                  });
                }
              }
              disconnect() {
                this.connection.disconnect(), this.timelineSenderTimer && (this.timelineSenderTimer.ensureAborted(), this.timelineSenderTimer = null);
              }
              bind(p, f, S) {
                return this.global_emitter.bind(p, f, S), this;
              }
              unbind(p, f, S) {
                return this.global_emitter.unbind(p, f, S), this;
              }
              bind_global(p) {
                return this.global_emitter.bind_global(p), this;
              }
              unbind_global(p) {
                return this.global_emitter.unbind_global(p), this;
              }
              unbind_all(p) {
                return this.global_emitter.unbind_all(), this;
              }
              subscribeAll() {
                var p;
                for (p in this.channels.channels)
                  this.channels.channels.hasOwnProperty(p) && this.subscribe(p);
              }
              subscribe(p) {
                var f = this.channels.add(p, this);
                return f.subscriptionPending && f.subscriptionCancelled ? f.reinstateSubscription() : !f.subscriptionPending && this.connection.state === "connected" && f.subscribe(), f;
              }
              unsubscribe(p) {
                var f = this.channels.find(p);
                f && f.subscriptionPending ? f.cancelSubscription() : (f = this.channels.remove(p), f && f.subscribed && f.unsubscribe());
              }
              send_event(p, f, S) {
                return this.connection.send_event(p, f, S);
              }
              shouldUseTLS() {
                return this.config.useTLS;
              }
              signin() {
                this.user.signin();
              }
            }
            Et.instances = [], Et.isReady = !1, Et.logToConsole = !1, Et.Runtime = Ee, Et.ScriptReceivers = Ee.ScriptReceivers, Et.DependenciesReceivers = Ee.DependenciesReceivers, Et.auth_callbacks = Ee.auth_callbacks;
            var vi = s.default = Et;
            function Lh(k) {
              if (k == null)
                throw "You must pass your app key when you instantiate Pusher.";
            }
            Ee.setup(Et);
          })
          /******/
        ])
      );
    });
  })(vr)), vr.exports;
}
var U1 = V1();
const F1 = /* @__PURE__ */ Fd(U1);
var B1 = Object.defineProperty, q1 = (t, e, n) => e in t ? B1(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, H1 = (t, e, n) => q1(t, e + "", n);
function Ip(t, e, n) {
  const s = _t(t);
  re((o) => {
    const a = s.value;
    a && (a.bind(e, n), o(() => {
      a.unbind(e, n);
    }));
  });
}
function W1(t) {
  try {
    return { data: t() };
  } catch (e) {
    return { error: e };
  }
}
function Ep(t) {
  const e = N(na()), n = N();
  return re(() => {
    const s = W1(t);
    if (!(n.value !== void 0 && G1(s, n.value))) {
      if (n.value = s, s.data) {
        e.value.settled && (e.value = na()), e.value.resolve(void 0);
        return;
      }
      if ("error" in s) {
        e.value.settled && (e.value = na()), e.value.reject(s.error);
        return;
      }
      e.value = na();
    }
  }), A(() => e.value.promise);
}
function na() {
  function t(i) {
    o(i), a.settled = !0;
  }
  function e(i) {
    s(i), a.settled = !0;
  }
  const {
    promise: n,
    reject: s,
    resolve: o
  } = Promise.withResolvers(), a = { promise: n, reject: e, resolve: t, settled: !1 };
  return a;
}
function G1(t, e) {
  return "data" in t && "data" in e && t.data === e.data || "error" in t && "error" in e && t.error === e.error;
}
const ma = /* @__PURE__ */ J({
  __name: "SmuFeature",
  props: {
    name: {}
  },
  setup(t) {
    const { hasAccess: e } = Mo();
    return (n, s) => l(e)(n.name) ? St(n.$slots, "default", { key: 0 }) : Q("", !0);
  }
});
function Z1(t) {
  return Po(Op(t));
}
function Op(t) {
  const { cyan: e, key: n, magenta: s, yellow: o } = t;
  return {
    blue: Math.round(255 * (1 - o / 100) * (1 - n / 100)),
    green: Math.round(255 * (1 - s / 100) * (1 - n / 100)),
    red: Math.round(255 * (1 - e / 100) * (1 - n / 100))
  };
}
function Za(t) {
  if (!Dp(t)) return;
  t.length === 4 && (t = `#${t[1] ?? ""}${t[1] ?? ""}${t[2] ?? ""}${t[2] ?? ""}${t[3] ?? ""}${t[3] ?? ""}`);
  const e = Rp(t);
  if (e)
    return Po(e);
}
function Rp(t) {
  if (Dp(t))
    return t.length === 4 && (t = `#${t[1] ?? ""}${t[1] ?? ""}${t[2] ?? ""}${t[2] ?? ""}${t[3] ?? ""}${t[3] ?? ""}`), {
      blue: Number.parseInt(t.slice(5, 7), 16),
      green: Number.parseInt(t.slice(3, 5), 16),
      red: Number.parseInt(t.slice(1, 3), 16)
    };
}
function K1(t) {
  const e = cs(t);
  return X1(e);
}
function Lp(t) {
  return Q1(cs(t));
}
function cs(t) {
  const { hue: e, saturation: n, value: s } = t, o = e / 360, a = n / 100, i = s / 100;
  let r = 0, c = 0, u = 0;
  const d = Math.floor(o * 6), m = o * 6 - d, _ = i * (1 - a), g = i * (1 - m * a), v = i * (1 - (1 - m) * a);
  switch (d % 6) {
    case 0:
      r = i, c = v, u = _;
      break;
    case 1:
      r = g, c = i, u = _;
      break;
    case 2:
      r = _, c = i, u = v;
      break;
    case 3:
      r = _, c = g, u = i;
      break;
    case 4:
      r = v, c = _, u = i;
      break;
    case 5:
      r = i, c = _, u = g;
      break;
  }
  return {
    blue: Math.round(u * 255),
    green: Math.round(c * 255),
    red: Math.round(r * 255)
  };
}
function Gr(t, e) {
  return t.red === e.red && t.green === e.green && t.blue === e.blue;
}
function Dp(t) {
  return /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(t);
}
function X1(t) {
  const { blue: e, green: n, red: s } = t, o = s / 255, a = e / 255, i = n / 255, r = 1 - Math.max(o, i, a);
  return r === 1 ? {
    cyan: 0,
    key: 100,
    magenta: 0,
    yellow: 0
  } : {
    cyan: (1 - o - r) / (1 - r) * 100,
    key: r * 100,
    magenta: (1 - i - r) / (1 - r) * 100,
    yellow: (1 - a - r) / (1 - r) * 100
  };
}
function Q1({ blue: t, green: e, red: n }) {
  return `#${(1 << 24 | n << 16 | e << 8 | t).toString(16).slice(1).toUpperCase()}`;
}
function Po(t) {
  const { blue: e, green: n, red: s } = t, o = s / 255, a = n / 255, i = e / 255, r = Math.max(o, a, i), c = Math.min(o, a, i), u = r - c;
  let d = 0;
  if (u !== 0) {
    switch (r) {
      case i:
        d = (o - a) / u + 4;
        break;
      case a:
        d = (i - o) / u + 2;
        break;
      case o:
        d = (a - i) / u + (a < i ? 6 : 0);
        break;
    }
    d *= 60;
  }
  const m = r === 0 ? 0 : u / r;
  return {
    hue: d,
    saturation: m * 100,
    value: r * 100
  };
}
function J1(t) {
  const e = N({ hue: 0, saturation: 0, value: 0 });
  return {
    colorHSV: A({
      get() {
        return Y1(t.value, cs(e.value)) ? e.value : Po({ ...t.value });
      },
      set(n) {
        e.value = { ...n }, t.value = cs({ ...n });
      }
    })
  };
}
function Y1(t, e) {
  return t.red === e.red && t.green === e.green && t.blue === e.blue;
}
function Ka(t) {
  const e = A({
    get() {
      return cs(t.value);
    },
    set(a) {
      t.value = Po(a);
    }
  }), n = N("#000"), s = A({
    get() {
      const a = Rp(n.value);
      if (!a)
        throw new Error("unexpected error in hex to rgb conversion");
      return Gr(cs(t.value), a) ? n.value : Lp(t.value);
    },
    set(a) {
      const i = Za(a);
      i && (n.value = a, t.value = i);
    }
  }), o = N({ cyan: 0, key: 0, magenta: 0, yellow: 0 });
  return {
    colorCMYK: A({
      get() {
        return Gr(cs(t.value), Op(o.value)) ? o.value : K1({ ...t.value });
      },
      set(a) {
        o.value = { ...a }, t.value = Z1({ ...a });
      }
    }),
    colorHex: s,
    colorRGB: e
  };
}
const jp = (t, e = 250) => {
  async function n(s) {
    if (!t.value) return;
    const o = getComputedStyle(t.value).height;
    s(), await ol();
    const a = getComputedStyle(t.value).height, i = Number.parseInt(o) > Number.parseInt(a);
    i && s();
    const r = t.value.animate(
      [
        { height: o, overflow: "hidden" },
        { height: a, overflow: "hidden" }
      ],
      { duration: e, easing: "cubic-bezier(0.4, 0, 0.2, 1)" }
    );
    i && (await r.finished, s());
  }
  return {
    animateHeight: n
  };
};
var Zr = /* @__PURE__ */ ((t) => (t[t.ACCEPTED = 202] = "ACCEPTED", t[t.CREATED = 201] = "CREATED", t[t.NO_CONTENT = 204] = "NO_CONTENT", t[t.NOT_MODIFIED = 304] = "NOT_MODIFIED", t[t.OK = 200] = "OK", t))(Zr || {});
const ek = 10080 * 60 * 1e3, tk = (t, e, n) => {
  const s = N(3), o = N(
    Object.assign({}, t.defaults.headers)
  );
  a();
  function a() {
    o.value.common = Object.fromEntries(
      Object.entries(o.value.common).filter((y) => {
        const w = y[0];
        return n ? !n.excludedHeadersForCacheKey.includes(w) : !0;
      })
    );
  }
  async function i(y, w) {
    const P = await t.get(
      y,
      z(y, w)
    );
    if (P.status === Zr.NOT_MODIFIED) {
      const M = v(
        y,
        w == null ? void 0 : w.headers
      );
      if (M !== null)
        return M;
      if (s.value === 0)
        throw new Error("Unexpected local storage state occurred.");
      return await i(y, w);
    }
    return m(P, y, w == null ? void 0 : w.headers), s.value = 3, P;
  }
  function r(y) {
    return y ? (
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- fix next time
      y.expire_timestamp !== void 0 && // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- fix next time
      y.entries !== void 0
    ) : !1;
  }
  function c() {
    const y = localStorage.getItem(e);
    if (!y)
      return u();
    try {
      const w = JSON.parse(y);
      return r(w) ? w.expire_timestamp < Date.now() ? (localStorage.removeItem(e), u()) : w : u();
    } catch {
      return u();
    }
  }
  function u() {
    return {
      entries: [],
      expire_timestamp: new Date(
        Date.now() + ek
      ).getTime()
    };
  }
  function d(y, w) {
    return JSON.stringify({
      defaultHeaders: o.value,
      requestSpecificHeaders: w,
      url: y
    });
  }
  function m(y, w, P) {
    const M = y.headers.etag;
    if (!M)
      return;
    const E = c(), R = d(
      w,
      P
    );
    E.entries = E.entries.filter(
      (j) => j.request_identifier !== R
    ), E.entries.push({
      etag: M,
      request_identifier: R,
      response: y
    }), localStorage.setItem(
      e,
      JSON.stringify(E)
    );
  }
  function _(y, w) {
    return c().entries.find(
      (P) => P.request_identifier === d(y, w)
    ) ?? null;
  }
  function g(y, w) {
    var P;
    return ((P = _(
      y,
      w
    )) == null ? void 0 : P.etag) ?? null;
  }
  function v(y, w) {
    var P;
    const M = d(
      y,
      w
    );
    return ((P = c().entries.find(
      (E) => E.request_identifier === M
      // eslint-disable-next-line unicorn/no-null -- fix next time
    )) == null ? void 0 : P.response) ?? null;
  }
  function z(y, w) {
    return w ? (w.data ?? (w.data = {}), w.headers = {
      // eslint-disable-next-line @typescript-eslint/no-misused-spread -- fix next time
      ...w.headers,
      "If-None-Match": g(y, w.headers) ?? void 0
    }, w.validateStatus = h, w) : {
      data: {},
      headers: {
        "If-None-Match": g(y) ?? void 0
      },
      validateStatus: h
    };
  }
  function h(y) {
    return y <= 300 || y === Zr.NOT_MODIFIED;
  }
  return {
    get: i
  };
}, nk = st("smake-use-feature-flag-store", () => ({
  featureFlags: N(/* @__PURE__ */ new Map())
}));
function Mo() {
  const { featureFlags: t } = D(nk());
  function e(o) {
    return t.value.get(o) ?? !1;
  }
  function n(o) {
    t.value.set(o, !0);
  }
  function s(o) {
    t.value.set(o, !1);
  }
  return {
    featureFlags: t,
    giveAccessToFeature: n,
    hasAccess: e,
    removeAccessFromFeature: s
  };
}
const Xa = () => {
  function t(s, o, a) {
    return new Intl.NumberFormat(o, {
      currency: a,
      style: "currency"
    }).format(s);
  }
  function e(s, o, a) {
    return new Intl.NumberFormat(o, {
      maximumFractionDigits: 2,
      minimumFractionDigits: a,
      style: "decimal"
    }).format(s);
  }
  function n(s, o, a, i) {
    const r = o ?? 1;
    return t(
      s + s / 100 * r,
      a,
      i
    );
  }
  return {
    currencyFormat: t,
    decimalFormat: e,
    priceWithTax: n
  };
}, Vn = ht.create(), sk = 24, { idle: ok } = cd(sk * 60 * 60 * 1e3), Un = N(!1), sa = N(""), gr = N(0), kr = N(), xt = () => {
  async function t(c) {
    Un.value = !1, Vn.defaults.baseURL = c.baseUrl, sa.value = rp(), localStorage.getItem("designer-locale") !== c.acceptLanguage && (localStorage.removeItem("designer-api-client-cache"), localStorage.setItem(
      "designer-locale",
      c.acceptLanguage
    )), Vn.defaults.headers.common = {
      Accept: "application/json",
      "Accept-Language": c.acceptLanguage,
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      "X-Api-Version": c.apiVersion ?? "2024-07-15",
      "X-App-User": c.user_external_identifier,
      "X-Tab-Session-Id": sa.value
    };
    try {
      if (await n(c))
        return;
      await s(c.token);
    } catch (u) {
      throw Un.value = !0, new Eu(u);
    }
  }
  async function e(c) {
    try {
      await s(c);
    } catch (u) {
      throw Un.value = !0, new Eu(u);
    }
    Un.value = !1;
  }
  async function n(c) {
    if (!c.user_external_identifier)
      return !1;
    Vn.defaults.headers.common["X-Designer-Token"] = c.token;
    try {
      const u = await br().endpoints.auth.login({
        designer_token: c.token,
        external_identifier: c.user_external_identifier
      });
      i(u);
    } catch {
      return !1;
    }
    return delete Vn.defaults.headers.common["X-Designer-Token"], !0;
  }
  async function s(c) {
    Vn.defaults.headers.common.Authorization = `Bearer ${c}`, delete Vn.defaults.headers.common["X-Designer-Token"], i(await br().endpoints.auth.token.refresh());
  }
  function o(c) {
    const u = c * 1e3, d = 60 * 1e3, m = u - d - Date.now();
    setTimeout(a, m);
  }
  async function a() {
    if (ok.value) {
      Un.value = !0;
      return;
    }
    try {
      i(await br().endpoints.auth.token.refresh());
    } catch {
      Un.value = !0;
    }
  }
  function i(c) {
    kr.value = c, Vn.defaults.headers.common.Authorization = `Bearer ${c.token_string}`, o(c.expire_date), gr.value = c.user_id;
  }
  function r() {
    kr.value = void 0, gr.value = 0, sa.value = "", Un.value = !1;
  }
  return {
    axiosInstance: Vn,
    init: t,
    isDesignerSessionExpired: Un,
    renewToken: e,
    resetGlobals: r,
    tokenData: Tn(kr),
    userId: Tn(gr),
    xTabSessionId: Tn(sa)
  };
}, ak = () => {
  const { axiosInstance: t } = xt();
  async function e(n) {
    return (await t.post("auth/login", n)).data;
  }
  return {
    login: e
  };
}, ik = 3, yr = N(0), rk = () => {
  const { axiosInstance: t } = xt();
  async function e() {
    try {
      const n = (
        // eslint-disable-next-line unicorn/no-await-expression-member -- fix next time
        (await t.post("auth/token/refresh", {})).data
      );
      return yr.value = 0, n;
    } catch (n) {
      if (yr.value < ik)
        return yr.value += 1, e();
      throw n;
    }
  }
  return {
    refresh: e
  };
}, lk = () => ({
  token: {
    ...rk()
  },
  ...ak()
}), zn = () => tk(
  xt().axiosInstance,
  "designer-api-client-cache",
  {
    excludedHeadersForCacheKey: ["X-Tab-Session-Id", "Authorization"]
  }
), ck = () => {
  const { get: t } = zn();
  async function e() {
    return (await t("colors?per_page=100")).data;
  }
  return { list: e };
}, uk = () => ({
  ...ck()
}), dk = () => {
  const { get: t } = zn();
  async function e(n) {
    return (
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions, unicorn/no-await-expression-member -- fix next time, fix next time
      (await t(`products/${n}/color-variants`)).data
    );
  }
  return { listByProductId: e };
}, pk = () => ({
  ...dk()
}), mk = () => {
  const { get: t } = zn();
  async function e() {
    return (await t("configurations")).data;
  }
  async function n() {
    return (await t("configurations/app")).data;
  }
  async function s() {
    return (await t("configurations/designer")).data;
  }
  return {
    get: e,
    getForApp: n,
    getForDesigner: s
  };
}, hk = () => ({
  ...mk()
}), fk = () => {
  const { axiosInstance: t } = xt();
  async function e(s) {
    return (await t.get("customer-logos", {
      params: s
    })).data;
  }
  async function n() {
    return (await t.get(
      "customer-logos/count"
    )).data;
  }
  return {
    count: n,
    list: e
  };
}, _k = () => {
  const { axiosInstance: t } = xt();
  async function e(n) {
    return (await t.patch(
      `customer-logos/${n.id.toString()}`,
      {
        ...n,
        id: void 0
      }
    )).data;
  }
  return {
    update: e
  };
}, vk = () => ({
  ...fk(),
  ..._k()
}), gk = () => {
  const { axiosInstance: t } = xt();
  async function e(n) {
    return (await t.post(
      "designs/preview",
      n
    )).data;
  }
  return {
    fetchPreview: e
  };
}, kk = () => {
  const { axiosInstance: t } = xt();
  async function e(r) {
    return (await t.post(
      "designs/favored",
      r
    )).data;
  }
  async function n(r) {
    return (await t.get(
      `designs/favored/${r.toString()}`
    )).data;
  }
  async function s(r) {
    return (await t.get("designs/favored", {
      params: r
    })).data;
  }
  async function o() {
    return (await t.get(
      "designs/favored/count"
    )).data;
  }
  async function a(r) {
    return (await t.patch(
      `designs/favored/${r.id.toString()}`,
      {
        ...r,
        id: void 0
      }
    )).data;
  }
  async function i(r) {
    await t.delete(
      `designs/favored/${r.toString()}`
    );
  }
  return {
    count: o,
    create: e,
    delete: i,
    getById: n,
    list: s,
    update: a
  };
}, yk = () => ({
  ...gk(),
  favored: kk()
}), bk = () => {
  const { get: t } = zn();
  async function e() {
    return (await t("fonts?per_page=100")).data;
  }
  return { list: e };
}, wk = () => ({
  ...bk()
}), xk = () => {
  const { axiosInstance: t } = xt();
  async function e(o) {
    return (await t.get(`logos/${o}`)).data;
  }
  async function n(o) {
    return (await t.get("logos", {
      params: o
    })).data;
  }
  async function s() {
    return (await t.get(
      "logos/count"
    )).data.count;
  }
  return {
    count: s,
    get: e,
    list: n
  };
}, $k = () => ({
  ...xk()
}), zk = () => {
  const { axiosInstance: t } = xt();
  async function e(n) {
    return (await t.post(
      "prices",
      n
    )).data;
  }
  return { getByItems: e };
}, Sk = () => ({
  ...zk()
}), Ak = () => {
  const { get: t } = zn();
  async function e() {
    return (await t("production-methods")).data;
  }
  return { list: e };
}, Ck = () => ({
  ...Ak()
}), Pk = () => {
  const { get: t } = zn();
  async function e(n, s) {
    return (await t("products", {
      params: {
        page: n,
        per_page: s
      }
    })).data;
  }
  return { list: e };
}, Mk = () => ({
  ...Pk()
}), Tk = () => {
  const t = zn();
  async function e() {
    return (await t.get("settings")).data;
  }
  return { get: e };
}, Ik = () => ({
  ...Tk()
}), Ek = () => {
  const { axiosInstance: t } = xt();
  async function e(n) {
    return (await t.post(
      "texts/preview",
      n
    )).data;
  }
  return {
    fetchPreview: e
  };
}, Ok = () => {
  const { get: t } = zn();
  async function e(n) {
    return (await t(`texts/${n}`)).data;
  }
  return { getById: e };
}, Rk = () => {
  const { axiosInstance: t } = xt();
  async function e(n) {
    const s = await t.post("texts", n);
    return Number.parseInt(s.headers["x-identifier"]);
  }
  return {
    storeText: e
  };
}, Lk = () => {
  const { axiosInstance: t } = xt();
  async function e(n, s) {
    return await t.put(
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands -- fix next time
      "texts/" + s,
      n
    );
  }
  return { updateText: e };
}, Dk = () => ({
  ...Rk(),
  ...Lk(),
  ...Ok(),
  ...Ek()
}), jk = () => {
  const { axiosInstance: t } = xt(), { get: e } = zn();
  async function n() {
    try {
      return (await e("users/current")).data;
    } catch {
      return (await t.post("/users", {
        external_identifier: t.defaults.headers.common["X-App-User"]
      })).data;
    }
  }
  return { current: n };
}, Nk = () => ({
  ...jk()
}), Vk = () => {
  const { axiosInstance: t } = xt();
  async function e(o, a) {
    const i = await t.post(
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- fix next time
      `variants/${o}/design-for-pdf-download`,
      a
    );
    return Number.parseInt(i.headers["x-identifier"]);
  }
  async function n(o) {
    const a = await t.get(
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- fix next time
      `variants/${o}/pdf-download`,
      {
        responseType: "arraybuffer"
      }
    );
    return new Blob([a.data], { type: "application/pdf" });
  }
  async function s(o) {
    return (await t.get(
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- fix next time
      `variants/${o}/preview-html`,
      {
        data: {}
      }
    )).data;
  }
  return {
    getHTMLPreviewByVariantId: s,
    getPdfByVariantId: n,
    storeVariantForPdfDownload: e
  };
}, Uk = () => {
  const { axiosInstance: t } = xt();
  async function e(n) {
    return await t.delete(
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- fix next time
      `variants/archived/${n}`,
      { data: {} }
    );
  }
  return {
    deleteVariantByIdFromArchive: e
  };
}, Fk = () => {
  const { axiosInstance: t } = xt();
  async function e(s) {
    return (await t.get("favorites/variants", { params: s })).data;
  }
  async function n(s) {
    return (await t.get(
      `favorites/variants/${s.toString()}`
    )).data;
  }
  return {
    getById: n,
    list: e
  };
}, Bk = () => {
  const { get: t } = zn();
  async function e(i) {
    return (await t(
      `variants/cached/variant-id/${i.toString()}`
    )).data;
  }
  async function n(i) {
    return i = encodeURIComponent(
      i
    ), (await t(
      `variants/cached/external-identifier/${i}`
    )).data;
  }
  async function s(i) {
    return (await t("variants", {
      params: i
    })).data;
  }
  async function o(i, r) {
    return (await t("variants/archived", {
      params: {
        page: i,
        per_page: r
      }
    })).data;
  }
  async function a(i) {
    return (await t(
      `variants/archived/${i.toString()}`
    )).data;
  }
  return {
    getArchivedById: a,
    getByExternalIdentifier: n,
    getById: e,
    list: s,
    listArchived: o
  };
}, qk = () => {
  const { axiosInstance: t } = xt();
  async function e(s, o) {
    const a = await t.post(
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- fix next time
      `variants/${s}/archive`,
      o
    );
    return Number.parseInt(a.headers["x-identifier"]);
  }
  async function n(s, o) {
    const a = await t.post(
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- fix next time
      `variants/${s}/design`,
      o
    );
    return Number.parseInt(a.headers["x-identifier"]);
  }
  return {
    storeVariant: n,
    storeVariantToArchive: e
  };
}, Hk = () => ({
  ...Bk(),
  ...qk(),
  ...Vk(),
  ...Uk(),
  favorite: Fk()
}), Wk = () => {
  const { axiosInstance: t } = xt();
  async function e() {
    return (await t.get(
      "logos/category-tree"
    )).data;
  }
  async function n() {
    return (await t.get("logos/categories")).data;
  }
  return {
    getTree: e,
    list: n
  };
}, Gk = () => ({
  ...Wk()
}), {
  init: Zk,
  isDesignerSessionExpired: Kk,
  renewToken: Xk,
  resetGlobals: Qk,
  tokenData: Jk,
  userId: Yk,
  xTabSessionId: e0
} = xt(), br = () => ({
  endpoints: {
    auth: lk(),
    colors: uk(),
    colorVariants: pk(),
    configurations: hk(),
    customerLogos: vk(),
    designs: yk(),
    fonts: wk(),
    logoCategories: Gk(),
    logos: $k(),
    prices: Sk(),
    productionMethods: Ck(),
    products: Mk(),
    settings: Ik(),
    texts: Dk(),
    users: Nk(),
    variants: Hk()
  },
  init: Zk,
  isDesignerSessionExpired: Kk,
  renewToken: Xk,
  resetGlobals: Qk,
  tokenData: Jk,
  userId: Yk,
  xTabSessionId: e0
});
let t0 = class extends Error {
  constructor(e) {
    super(), H1(this, "previous"), this.message = this.constructor.name, this.previous = e ?? null;
  }
};
class Eu extends t0 {
}
const oa = ht.create(), wr = N(!1), n0 = () => {
  function t(n) {
    wr.value = !1, oa.defaults.baseURL = n.baseUrl, oa.defaults.headers.common = {
      Accept: "application/json",
      "Accept-Language": n.acceptLanguage,
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${n.token}`,
      "Content-Type": "application/json"
    }, wr.value = !0;
  }
  function e(n) {
    oa.defaults.headers.common.Authorization = `Bearer ${n}`;
  }
  return {
    axiosInstance: oa,
    init: t,
    isInitialized: Tn(wr),
    renewToken: e
  };
};
n0();
function s0(t, e) {
  const n = N(), s = _t(t), o = typeof e == "function" ? N(e) : _t(e), a = N();
  re((r) => {
    n.value && (n.value.connection.callbacks.add(
      "state_change",
      ({ current: c }) => {
        a.value = c;
      },
      void 0
    ), n.value.connection.callbacks.add(
      "error",
      (c) => {
        o.value && o.value(c);
      },
      void 0
    ), r(() => {
      var c, u, d;
      (c = n.value) == null || c.connection.callbacks.remove("connected"), (u = n.value) == null || u.connection.callbacks.remove("usePusher"), (d = n.value) == null || d.connection.callbacks.remove("disconnected");
    }));
  });
  const i = Ep(() => {
    if (a.value === "failed")
      throw new Error("connection failed");
    return a.value === "connected";
  });
  return re((r) => {
    s.value && (n.value = ds(
      new F1(s.value.appKey, {
        cluster: s.value.cluster
      })
    ), a.value = "connecting", r(() => {
      var c;
      (c = n.value) == null || c.disconnect(), n.value = void 0;
    }));
  }), {
    /**
     * @description Promise that can be awaited to ensure to pusher connection is available. This is probably only needed in automated tests
     **/
    connected: i,
    /**
     * @description Connection state as ref. Useful when setting up a new project with pusher to verify the conenction works.
     **/
    connectionStatus: Tn(a),
    pusher: n
  };
}
function Ou(t, e, n) {
  const s = _t(t), o = _t(e), a = _t(n), i = N(), r = N(!1), c = Ep(() => r.value);
  return re(() => {
    i.value && s.value && (i.value.callbacks.add(
      "pusher:subscription_succeeded",
      () => {
        r.value = !0;
      },
      void 0
    ), i.value.callbacks.add(
      "pusher:subscription_error",
      (u) => {
        r.value = !1, a.value && a.value(u);
      },
      void 0
    ));
  }), re((u) => {
    if (!s.value || o.value === void 0) return;
    const d = o.value;
    i.value = ds(s.value.subscribe(o.value)), u(() => {
      var m;
      (m = s.value) == null || m.unsubscribe(d), i.value = void 0;
    });
  }), {
    channel: i,
    isSubscribed: r,
    subcription: c
  };
}
/**
* @vue/shared v3.5.21
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
process.env.NODE_ENV !== "production" && Object.freeze({});
process.env.NODE_ENV !== "production" && Object.freeze([]);
const Np = (t) => {
  const e = /* @__PURE__ */ Object.create(null);
  return ((n) => e[n] || (e[n] = t(n)));
}, o0 = /-\w/g, a0 = Np(
  (t) => t.replace(o0, (e) => e.slice(1).toUpperCase())
), i0 = Np((t) => t.charAt(0).toUpperCase() + t.slice(1)), r0 = [
  "AnimatedSprite",
  "BitmapText",
  "Container",
  "Graphics",
  "HtmlText",
  "Mesh",
  "MeshPlane",
  "MeshRope",
  "MeshSimple",
  "NineSlicePlane",
  "NineSliceSprite",
  "ParticleContainer",
  "PerspectiveMesh",
  "RenderContainer",
  "RenderLayer",
  "Sprite",
  "Text",
  "TilingSprite"
];
function l0(t) {
  return r0.includes(t);
}
function c0(t) {
  return t = i0(a0(t)), t.startsWith("Pixi") && (t = t.slice(4)), t;
}
class Ht {
  /** @param {Viewport} parent */
  constructor(e) {
    this.parent = e, this.paused = !1;
  }
  /** Called when plugin is removed */
  destroy() {
  }
  /** Handler for pointerdown PIXI event */
  down(e) {
    return !1;
  }
  /** Handler for pointermove PIXI event */
  move(e) {
    return !1;
  }
  /** Handler for pointerup PIXI event */
  up(e) {
    return !1;
  }
  /** Handler for wheel event on div */
  wheel(e) {
    return !1;
  }
  /**
   * Called on each tick
   * @param {number} elapsed time in millisecond since last update
   */
  update(e) {
  }
  /** Called when the viewport is resized */
  resize() {
  }
  /** Called when the viewport is manually moved */
  reset() {
  }
  /** Pause the plugin */
  pause() {
    this.paused = !0;
  }
  /** Un-pause the plugin */
  resume() {
    this.paused = !1;
  }
}
var u0 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function d0(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Vp = { exports: {} };
(function(t, e) {
  (function() {
    var n, s;
    s = function(o) {
      return t.exports = o;
    }, n = {
      linear: function(o, a, i, r) {
        return i * o / r + a;
      },
      easeInQuad: function(o, a, i, r) {
        return i * (o /= r) * o + a;
      },
      easeOutQuad: function(o, a, i, r) {
        return -i * (o /= r) * (o - 2) + a;
      },
      easeInOutQuad: function(o, a, i, r) {
        return (o /= r / 2) < 1 ? i / 2 * o * o + a : -i / 2 * (--o * (o - 2) - 1) + a;
      },
      easeInCubic: function(o, a, i, r) {
        return i * (o /= r) * o * o + a;
      },
      easeOutCubic: function(o, a, i, r) {
        return i * ((o = o / r - 1) * o * o + 1) + a;
      },
      easeInOutCubic: function(o, a, i, r) {
        return (o /= r / 2) < 1 ? i / 2 * o * o * o + a : i / 2 * ((o -= 2) * o * o + 2) + a;
      },
      easeInQuart: function(o, a, i, r) {
        return i * (o /= r) * o * o * o + a;
      },
      easeOutQuart: function(o, a, i, r) {
        return -i * ((o = o / r - 1) * o * o * o - 1) + a;
      },
      easeInOutQuart: function(o, a, i, r) {
        return (o /= r / 2) < 1 ? i / 2 * o * o * o * o + a : -i / 2 * ((o -= 2) * o * o * o - 2) + a;
      },
      easeInQuint: function(o, a, i, r) {
        return i * (o /= r) * o * o * o * o + a;
      },
      easeOutQuint: function(o, a, i, r) {
        return i * ((o = o / r - 1) * o * o * o * o + 1) + a;
      },
      easeInOutQuint: function(o, a, i, r) {
        return (o /= r / 2) < 1 ? i / 2 * o * o * o * o * o + a : i / 2 * ((o -= 2) * o * o * o * o + 2) + a;
      },
      easeInSine: function(o, a, i, r) {
        return -i * Math.cos(o / r * (Math.PI / 2)) + i + a;
      },
      easeOutSine: function(o, a, i, r) {
        return i * Math.sin(o / r * (Math.PI / 2)) + a;
      },
      easeInOutSine: function(o, a, i, r) {
        return -i / 2 * (Math.cos(Math.PI * o / r) - 1) + a;
      },
      easeInExpo: function(o, a, i, r) {
        return o === 0 ? a : i * Math.pow(2, 10 * (o / r - 1)) + a;
      },
      easeOutExpo: function(o, a, i, r) {
        return o === r ? a + i : i * (-Math.pow(2, -10 * o / r) + 1) + a;
      },
      easeInOutExpo: function(o, a, i, r) {
        return (o /= r / 2) < 1 ? i / 2 * Math.pow(2, 10 * (o - 1)) + a : i / 2 * (-Math.pow(2, -10 * --o) + 2) + a;
      },
      easeInCirc: function(o, a, i, r) {
        return -i * (Math.sqrt(1 - (o /= r) * o) - 1) + a;
      },
      easeOutCirc: function(o, a, i, r) {
        return i * Math.sqrt(1 - (o = o / r - 1) * o) + a;
      },
      easeInOutCirc: function(o, a, i, r) {
        return (o /= r / 2) < 1 ? -i / 2 * (Math.sqrt(1 - o * o) - 1) + a : i / 2 * (Math.sqrt(1 - (o -= 2) * o) + 1) + a;
      },
      easeInElastic: function(o, a, i, r) {
        var c, u, d;
        return d = 1.70158, u = 0, c = i, o === 0 || (o /= r), u || (u = r * 0.3), c < Math.abs(i) ? (c = i, d = u / 4) : d = u / (2 * Math.PI) * Math.asin(i / c), -(c * Math.pow(2, 10 * (o -= 1)) * Math.sin((o * r - d) * (2 * Math.PI) / u)) + a;
      },
      easeOutElastic: function(o, a, i, r) {
        var c, u, d;
        return d = 1.70158, u = 0, c = i, o === 0 || (o /= r), u || (u = r * 0.3), c < Math.abs(i) ? (c = i, d = u / 4) : d = u / (2 * Math.PI) * Math.asin(i / c), c * Math.pow(2, -10 * o) * Math.sin((o * r - d) * (2 * Math.PI) / u) + i + a;
      },
      easeInOutElastic: function(o, a, i, r) {
        var c, u, d;
        return d = 1.70158, u = 0, c = i, o === 0 || (o /= r / 2), u || (u = r * (0.3 * 1.5)), c < Math.abs(i) ? (c = i, d = u / 4) : d = u / (2 * Math.PI) * Math.asin(i / c), o < 1 ? -0.5 * (c * Math.pow(2, 10 * (o -= 1)) * Math.sin((o * r - d) * (2 * Math.PI) / u)) + a : c * Math.pow(2, -10 * (o -= 1)) * Math.sin((o * r - d) * (2 * Math.PI) / u) * 0.5 + i + a;
      },
      easeInBack: function(o, a, i, r, c) {
        return c === void 0 && (c = 1.70158), i * (o /= r) * o * ((c + 1) * o - c) + a;
      },
      easeOutBack: function(o, a, i, r, c) {
        return c === void 0 && (c = 1.70158), i * ((o = o / r - 1) * o * ((c + 1) * o + c) + 1) + a;
      },
      easeInOutBack: function(o, a, i, r, c) {
        return c === void 0 && (c = 1.70158), (o /= r / 2) < 1 ? i / 2 * (o * o * (((c *= 1.525) + 1) * o - c)) + a : i / 2 * ((o -= 2) * o * (((c *= 1.525) + 1) * o + c) + 2) + a;
      },
      easeInBounce: function(o, a, i, r) {
        var c;
        return c = n.easeOutBounce(r - o, 0, i, r), i - c + a;
      },
      easeOutBounce: function(o, a, i, r) {
        return (o /= r) < 1 / 2.75 ? i * (7.5625 * o * o) + a : o < 2 / 2.75 ? i * (7.5625 * (o -= 1.5 / 2.75) * o + 0.75) + a : o < 2.5 / 2.75 ? i * (7.5625 * (o -= 2.25 / 2.75) * o + 0.9375) + a : i * (7.5625 * (o -= 2.625 / 2.75) * o + 0.984375) + a;
      },
      easeInOutBounce: function(o, a, i, r) {
        var c;
        return o < r / 2 ? (c = n.easeInBounce(o * 2, 0, i, r), c * 0.5 + a) : (c = n.easeOutBounce(o * 2 - r, 0, i, r), c * 0.5 + i * 0.5 + a);
      }
    }, s(n);
  }).call(u0);
})(Vp);
var p0 = Vp.exports;
const Ru = /* @__PURE__ */ d0(p0);
function Qa(t, e) {
  if (t) {
    if (typeof t == "function")
      return t;
    if (typeof t == "string")
      return Ru[t];
  } else
    return Ru[e];
}
const m0 = {
  removeOnInterrupt: !1,
  ease: "linear",
  time: 1e3
};
class h0 extends Ht {
  /**
   * This is called by {@link Viewport.animate}.
   *
   * @param parent
   * @param options
   */
  constructor(e, n = {}) {
    super(e), this.startWidth = null, this.startHeight = null, this.deltaWidth = null, this.deltaHeight = null, this.width = null, this.height = null, this.time = 0, this.options = Object.assign({}, m0, n), this.options.ease = Qa(this.options.ease), this.setupPosition(), this.setupZoom(), this.time = 0;
  }
  /**
   * Setup `startX`, `startY`, `deltaX`, `deltaY`, `keepCenter`.
   *
   * This is called during construction.
   */
  setupPosition() {
    typeof this.options.position < "u" ? (this.startX = this.parent.center.x, this.startY = this.parent.center.y, this.deltaX = this.options.position.x - this.parent.center.x, this.deltaY = this.options.position.y - this.parent.center.y, this.keepCenter = !1) : this.keepCenter = !0;
  }
  /**
   * Setup `startWidth, `startHeight`, `deltaWidth, `deltaHeight, `width`, `height`.
   *
   * This is called during construction.
   */
  setupZoom() {
    this.width = null, this.height = null, typeof this.options.scale < "u" ? this.width = this.parent.screenWidth / this.options.scale : typeof this.options.scaleX < "u" || typeof this.options.scaleY < "u" ? (typeof this.options.scaleX < "u" && (this.width = this.parent.screenWidth / this.options.scaleX), typeof this.options.scaleY < "u" && (this.height = this.parent.screenHeight / this.options.scaleY)) : (typeof this.options.width < "u" && (this.width = this.options.width), typeof this.options.height < "u" && (this.height = this.options.height)), this.width !== null && (this.startWidth = this.parent.screenWidthInWorldPixels, this.deltaWidth = this.width - this.startWidth), this.height !== null && (this.startHeight = this.parent.screenHeightInWorldPixels, this.deltaHeight = this.height - this.startHeight);
  }
  down() {
    return this.options.removeOnInterrupt && this.parent.plugins.remove("animate"), !1;
  }
  complete() {
    this.parent.plugins.remove("animate"), this.width !== null && this.parent.fitWidth(this.width, this.keepCenter, this.height === null), this.height !== null && this.parent.fitHeight(this.height, this.keepCenter, this.width === null), !this.keepCenter && this.options.position && this.parent.moveCenter(this.options.position), this.parent.emit("animate-end", this.parent), this.options.callbackOnComplete && this.options.callbackOnComplete(this.parent);
  }
  update(e) {
    if (this.paused)
      return;
    this.time += e;
    const n = new $t(this.parent.scale.x, this.parent.scale.y);
    if (this.time >= this.options.time) {
      const s = this.parent.width, o = this.parent.height;
      this.complete(), (s !== this.parent.width || o !== this.parent.height) && this.parent.emit("zoomed", { viewport: this.parent, original: n, type: "animate" });
    } else {
      const s = this.options.ease(this.time, 0, 1, this.options.time);
      if (this.width !== null) {
        const o = this.startWidth, a = this.deltaWidth;
        this.parent.fitWidth(
          o + a * s,
          this.keepCenter,
          this.height === null
        );
      }
      if (this.height !== null) {
        const o = this.startHeight, a = this.deltaHeight;
        this.parent.fitHeight(
          o + a * s,
          this.keepCenter,
          this.width === null
        );
      }
      if (this.width === null ? this.parent.scale.x = this.parent.scale.y : this.height === null && (this.parent.scale.y = this.parent.scale.x), !this.keepCenter) {
        const o = this.startX, a = this.startY, i = this.deltaX, r = this.deltaY, c = new $t(this.parent.x, this.parent.y);
        this.parent.moveCenter(o + i * s, a + r * s), this.parent.emit("moved", { viewport: this.parent, original: c, type: "animate" });
      }
      (this.width || this.height) && this.parent.emit("zoomed", { viewport: this.parent, original: n, type: "animate" });
    }
  }
}
const f0 = {
  sides: "all",
  friction: 0.5,
  time: 150,
  ease: "easeInOutSine",
  underflow: "center",
  bounceBox: null
};
let _0 = class extends Ht {
  /**
   * This is called by {@link Viewport.bounce}.
   */
  constructor(e, n = {}) {
    super(e), this.options = Object.assign({}, f0, n), this.ease = Qa(this.options.ease, "easeInOutSine"), this.options.sides ? this.options.sides === "all" ? this.top = this.bottom = this.left = this.right = !0 : this.options.sides === "horizontal" ? (this.right = this.left = !0, this.top = this.bottom = !1) : this.options.sides === "vertical" ? (this.left = this.right = !1, this.top = this.bottom = !0) : (this.top = this.options.sides.indexOf("top") !== -1, this.bottom = this.options.sides.indexOf("bottom") !== -1, this.left = this.options.sides.indexOf("left") !== -1, this.right = this.options.sides.indexOf("right") !== -1) : this.left = this.top = this.right = this.bottom = !1;
    const s = this.options.underflow.toLowerCase();
    s === "center" ? (this.underflowX = 0, this.underflowY = 0) : (this.underflowX = s.indexOf("left") !== -1 ? -1 : s.indexOf("right") !== -1 ? 1 : 0, this.underflowY = s.indexOf("top") !== -1 ? -1 : s.indexOf("bottom") !== -1 ? 1 : 0), this.reset();
  }
  isActive() {
    return this.toX !== null || this.toY !== null;
  }
  down() {
    return this.toX = this.toY = null, !1;
  }
  up() {
    return this.bounce(), !1;
  }
  update(e) {
    if (!this.paused) {
      if (this.bounce(), this.toX) {
        const n = this.toX;
        n.time += e, this.parent.emit("moved", { viewport: this.parent, type: "bounce-x" }), n.time >= this.options.time ? (this.parent.x = n.end, this.toX = null, this.parent.emit("bounce-x-end", this.parent)) : this.parent.x = this.ease(n.time, n.start, n.delta, this.options.time);
      }
      if (this.toY) {
        const n = this.toY;
        n.time += e, this.parent.emit("moved", { viewport: this.parent, type: "bounce-y" }), n.time >= this.options.time ? (this.parent.y = n.end, this.toY = null, this.parent.emit("bounce-y-end", this.parent)) : this.parent.y = this.ease(n.time, n.start, n.delta, this.options.time);
      }
    }
  }
  /** @internal */
  calcUnderflowX() {
    let e;
    switch (this.underflowX) {
      case -1:
        e = 0;
        break;
      case 1:
        e = this.parent.screenWidth - this.parent.screenWorldWidth;
        break;
      default:
        e = (this.parent.screenWidth - this.parent.screenWorldWidth) / 2;
    }
    return e;
  }
  /** @internal */
  calcUnderflowY() {
    let e;
    switch (this.underflowY) {
      case -1:
        e = 0;
        break;
      case 1:
        e = this.parent.screenHeight - this.parent.screenWorldHeight;
        break;
      default:
        e = (this.parent.screenHeight - this.parent.screenWorldHeight) / 2;
    }
    return e;
  }
  oob() {
    const e = this.options.bounceBox;
    if (e) {
      const n = typeof e.x > "u" ? 0 : e.x, s = typeof e.y > "u" ? 0 : e.y, o = typeof e.width > "u" ? this.parent.worldWidth : e.width, a = typeof e.height > "u" ? this.parent.worldHeight : e.height;
      return {
        left: this.parent.left < n,
        right: this.parent.right > o,
        top: this.parent.top < s,
        bottom: this.parent.bottom > a,
        topLeft: new $t(
          n * this.parent.scale.x,
          s * this.parent.scale.y
        ),
        bottomRight: new $t(
          o * this.parent.scale.x - this.parent.screenWidth,
          a * this.parent.scale.y - this.parent.screenHeight
        )
      };
    }
    return {
      left: this.parent.left < 0,
      right: this.parent.right > this.parent.worldWidth,
      top: this.parent.top < 0,
      bottom: this.parent.bottom > this.parent.worldHeight,
      topLeft: new $t(0, 0),
      bottomRight: new $t(
        this.parent.worldWidth * this.parent.scale.x - this.parent.screenWidth,
        this.parent.worldHeight * this.parent.scale.y - this.parent.screenHeight
      )
    };
  }
  bounce() {
    var e, n;
    if (this.paused)
      return;
    let s, o = this.parent.plugins.get("decelerate", !0);
    o && (o.x || o.y) && (o.x && o.percentChangeX === ((e = o.options) == null ? void 0 : e.friction) || o.y && o.percentChangeY === ((n = o.options) == null ? void 0 : n.friction)) && (s = this.oob(), (s.left && this.left || s.right && this.right) && (o.percentChangeX = this.options.friction), (s.top && this.top || s.bottom && this.bottom) && (o.percentChangeY = this.options.friction));
    const a = this.parent.plugins.get("drag", !0) || {}, i = this.parent.plugins.get("pinch", !0) || {};
    if (o = o || {}, !(a != null && a.active) && !(i != null && i.active) && (!this.toX || !this.toY) && (!o.x || !o.y)) {
      s = s || this.oob();
      const r = s.topLeft, c = s.bottomRight;
      if (!this.toX && !o.x) {
        let u = null;
        s.left && this.left ? u = this.parent.screenWorldWidth < this.parent.screenWidth ? this.calcUnderflowX() : -r.x : s.right && this.right && (u = this.parent.screenWorldWidth < this.parent.screenWidth ? this.calcUnderflowX() : -c.x), u !== null && this.parent.x !== u && (this.toX = { time: 0, start: this.parent.x, delta: u - this.parent.x, end: u }, this.parent.emit("bounce-x-start", this.parent));
      }
      if (!this.toY && !o.y) {
        let u = null;
        s.top && this.top ? u = this.parent.screenWorldHeight < this.parent.screenHeight ? this.calcUnderflowY() : -r.y : s.bottom && this.bottom && (u = this.parent.screenWorldHeight < this.parent.screenHeight ? this.calcUnderflowY() : -c.y), u !== null && this.parent.y !== u && (this.toY = { time: 0, start: this.parent.y, delta: u - this.parent.y, end: u }, this.parent.emit("bounce-y-start", this.parent));
      }
    }
  }
  reset() {
    this.toX = this.toY = null, this.bounce();
  }
};
const v0 = {
  left: !1,
  right: !1,
  top: !1,
  bottom: !1,
  direction: null,
  underflow: "center"
};
let g0 = class extends Ht {
  /**
   * This is called by {@link Viewport.clamp}.
   */
  constructor(e, n = {}) {
    super(e), this.options = Object.assign({}, v0, n), this.options.direction && (this.options.left = this.options.direction === "x" || this.options.direction === "all" ? !0 : null, this.options.right = this.options.direction === "x" || this.options.direction === "all" ? !0 : null, this.options.top = this.options.direction === "y" || this.options.direction === "all" ? !0 : null, this.options.bottom = this.options.direction === "y" || this.options.direction === "all" ? !0 : null), this.parseUnderflow(), this.last = { x: null, y: null, scaleX: null, scaleY: null }, this.update();
  }
  parseUnderflow() {
    const e = this.options.underflow.toLowerCase();
    e === "none" ? this.noUnderflow = !0 : e === "center" ? (this.underflowX = this.underflowY = 0, this.noUnderflow = !1) : (this.underflowX = e.indexOf("left") !== -1 ? -1 : e.indexOf("right") !== -1 ? 1 : 0, this.underflowY = e.indexOf("top") !== -1 ? -1 : e.indexOf("bottom") !== -1 ? 1 : 0, this.noUnderflow = !1);
  }
  move() {
    return this.update(), !1;
  }
  update() {
    if (this.paused || this.parent.x === this.last.x && this.parent.y === this.last.y && this.parent.scale.x === this.last.scaleX && this.parent.scale.y === this.last.scaleY)
      return;
    const e = new $t(this.parent.x, this.parent.y), n = this.parent.plugins.decelerate || {};
    if (this.options.left !== null || this.options.right !== null) {
      let s = !1;
      if (!this.noUnderflow && this.parent.screenWorldWidth < this.parent.screenWidth)
        switch (this.underflowX) {
          case -1:
            this.parent.x !== 0 && (this.parent.x = 0, s = !0);
            break;
          case 1:
            this.parent.x !== this.parent.screenWidth - this.parent.screenWorldWidth && (this.parent.x = this.parent.screenWidth - this.parent.screenWorldWidth, s = !0);
            break;
          default:
            this.parent.x !== (this.parent.screenWidth - this.parent.screenWorldWidth) / 2 && (this.parent.x = (this.parent.screenWidth - this.parent.screenWorldWidth) / 2, s = !0);
        }
      else
        this.options.left !== null && this.parent.left < (this.options.left === !0 ? 0 : this.options.left) && (this.parent.x = -(this.options.left === !0 ? 0 : this.options.left) * this.parent.scale.x, n.x = 0, s = !0), this.options.right !== null && this.parent.right > (this.options.right === !0 ? this.parent.worldWidth : this.options.right) && (this.parent.x = -(this.options.right === !0 ? this.parent.worldWidth : this.options.right) * this.parent.scale.x + this.parent.screenWidth, n.x = 0, s = !0);
      s && this.parent.emit("moved", { viewport: this.parent, original: e, type: "clamp-x" });
    }
    if (this.options.top !== null || this.options.bottom !== null) {
      let s = !1;
      if (!this.noUnderflow && this.parent.screenWorldHeight < this.parent.screenHeight)
        switch (this.underflowY) {
          case -1:
            this.parent.y !== 0 && (this.parent.y = 0, s = !0);
            break;
          case 1:
            this.parent.y !== this.parent.screenHeight - this.parent.screenWorldHeight && (this.parent.y = this.parent.screenHeight - this.parent.screenWorldHeight, s = !0);
            break;
          default:
            this.parent.y !== (this.parent.screenHeight - this.parent.screenWorldHeight) / 2 && (this.parent.y = (this.parent.screenHeight - this.parent.screenWorldHeight) / 2, s = !0);
        }
      else
        this.options.top !== null && this.parent.top < (this.options.top === !0 ? 0 : this.options.top) && (this.parent.y = -(this.options.top === !0 ? 0 : this.options.top) * this.parent.scale.y, n.y = 0, s = !0), this.options.bottom !== null && this.parent.bottom > (this.options.bottom === !0 ? this.parent.worldHeight : this.options.bottom) && (this.parent.y = -(this.options.bottom === !0 ? this.parent.worldHeight : this.options.bottom) * this.parent.scale.y + this.parent.screenHeight, n.y = 0, s = !0);
      s && this.parent.emit("moved", { viewport: this.parent, original: e, type: "clamp-y" });
    }
    this.last.x = this.parent.x, this.last.y = this.parent.y, this.last.scaleX = this.parent.scale.x, this.last.scaleY = this.parent.scale.y;
  }
  reset() {
    this.update();
  }
};
const k0 = {
  minWidth: null,
  minHeight: null,
  maxWidth: null,
  maxHeight: null,
  minScale: null,
  maxScale: null
};
class y0 extends Ht {
  /**
   * This is called by {@link Viewport.clampZoom}.
   */
  constructor(e, n = {}) {
    super(e), this.options = Object.assign({}, k0, n), this.clamp();
  }
  resize() {
    this.clamp();
  }
  /** Clamp the viewport scale zoom) */
  clamp() {
    if (!this.paused) {
      if (this.options.minWidth || this.options.minHeight || this.options.maxWidth || this.options.maxHeight) {
        let e = this.parent.worldScreenWidth, n = this.parent.worldScreenHeight;
        if (this.options.minWidth !== null && e < this.options.minWidth) {
          const s = this.parent.scale.x;
          this.parent.fitWidth(this.options.minWidth, !1, !1, !0), this.parent.scale.y *= this.parent.scale.x / s, e = this.parent.worldScreenWidth, n = this.parent.worldScreenHeight, this.parent.emit("zoomed", { viewport: this.parent, type: "clamp-zoom" });
        }
        if (this.options.maxWidth !== null && e > this.options.maxWidth) {
          const s = this.parent.scale.x;
          this.parent.fitWidth(this.options.maxWidth, !1, !1, !0), this.parent.scale.y *= this.parent.scale.x / s, e = this.parent.worldScreenWidth, n = this.parent.worldScreenHeight, this.parent.emit("zoomed", { viewport: this.parent, type: "clamp-zoom" });
        }
        if (this.options.minHeight !== null && n < this.options.minHeight) {
          const s = this.parent.scale.y;
          this.parent.fitHeight(this.options.minHeight, !1, !1, !0), this.parent.scale.x *= this.parent.scale.y / s, e = this.parent.worldScreenWidth, n = this.parent.worldScreenHeight, this.parent.emit("zoomed", { viewport: this.parent, type: "clamp-zoom" });
        }
        if (this.options.maxHeight !== null && n > this.options.maxHeight) {
          const s = this.parent.scale.y;
          this.parent.fitHeight(this.options.maxHeight, !1, !1, !0), this.parent.scale.x *= this.parent.scale.y / s, this.parent.emit("zoomed", { viewport: this.parent, type: "clamp-zoom" });
        }
      } else if (this.options.minScale || this.options.maxScale) {
        const e = { x: null, y: null }, n = { x: null, y: null };
        if (typeof this.options.minScale == "number")
          e.x = this.options.minScale, e.y = this.options.minScale;
        else if (this.options.minScale !== null) {
          const a = this.options.minScale;
          e.x = typeof a.x > "u" ? null : a.x, e.y = typeof a.y > "u" ? null : a.y;
        }
        if (typeof this.options.maxScale == "number")
          n.x = this.options.maxScale, n.y = this.options.maxScale;
        else if (this.options.maxScale !== null) {
          const a = this.options.maxScale;
          n.x = typeof a.x > "u" ? null : a.x, n.y = typeof a.y > "u" ? null : a.y;
        }
        let s = this.parent.scale.x, o = this.parent.scale.y;
        e.x !== null && s < e.x && (s = e.x), n.x !== null && s > n.x && (s = n.x), e.y !== null && o < e.y && (o = e.y), n.y !== null && o > n.y && (o = n.y), (s !== this.parent.scale.x || o !== this.parent.scale.y) && (this.parent.scale.set(s, o), this.parent.emit("zoomed", { viewport: this.parent, type: "clamp-zoom" }));
      }
    }
  }
  reset() {
    this.clamp();
  }
}
const b0 = {
  friction: 0.98,
  bounce: 0.8,
  minSpeed: 0.01
}, Fn = 16;
let w0 = class extends Ht {
  /**
   * This is called by {@link Viewport.decelerate}.
   */
  constructor(e, n = {}) {
    super(e), this.options = Object.assign({}, b0, n), this.saved = [], this.timeSinceRelease = 0, this.reset(), this.parent.on("moved", (s) => this.handleMoved(s));
  }
  down() {
    return this.saved = [], this.x = this.y = null, !1;
  }
  isActive() {
    return !!(this.x || this.y);
  }
  move() {
    if (this.paused)
      return !1;
    const e = this.parent.input.count();
    return (e === 1 || e > 1 && !this.parent.plugins.get("pinch", !0)) && (this.saved.push({ x: this.parent.x, y: this.parent.y, time: performance.now() }), this.saved.length > 60 && this.saved.splice(0, 30)), !1;
  }
  /** Listener to viewport's "moved" event. */
  handleMoved(e) {
    if (this.saved.length) {
      const n = this.saved[this.saved.length - 1];
      e.type === "clamp-x" && e.original ? n.x === e.original.x && (n.x = this.parent.x) : e.type === "clamp-y" && e.original && n.y === e.original.y && (n.y = this.parent.y);
    }
  }
  up() {
    if (this.parent.input.count() === 0 && this.saved.length) {
      const e = performance.now();
      for (const n of this.saved)
        if (n.time >= e - 100) {
          const s = e - n.time;
          this.x = (this.parent.x - n.x) / s, this.y = (this.parent.y - n.y) / s, this.percentChangeX = this.percentChangeY = this.options.friction, this.timeSinceRelease = 0;
          break;
        }
    }
    return !1;
  }
  /**
   * Manually activate deceleration, starting from the (x, y) velocity components passed in the options.
   *
   * @param {object} options
   * @param {number} [options.x] - Specify x-component of initial velocity.
   * @param {number} [options.y] - Specify y-component of initial velocity.
   */
  activate(e) {
    e = e || {}, typeof e.x < "u" && (this.x = e.x, this.percentChangeX = this.options.friction), typeof e.y < "u" && (this.y = e.y, this.percentChangeY = this.options.friction);
  }
  update(e) {
    if (this.paused)
      return;
    const n = this.x || this.y, s = this.timeSinceRelease, o = this.timeSinceRelease + e;
    if (this.x) {
      const a = this.percentChangeX, i = Math.log(a);
      this.parent.x += this.x * Fn / i * (Math.pow(a, o / Fn) - Math.pow(a, s / Fn)), this.x *= Math.pow(this.percentChangeX, e / Fn);
    }
    if (this.y) {
      const a = this.percentChangeY, i = Math.log(a);
      this.parent.y += this.y * Fn / i * (Math.pow(a, o / Fn) - Math.pow(a, s / Fn)), this.y *= Math.pow(this.percentChangeY, e / Fn);
    }
    this.timeSinceRelease += e, this.x && this.y ? Math.abs(this.x) < this.options.minSpeed && Math.abs(this.y) < this.options.minSpeed && (this.x = 0, this.y = 0) : (Math.abs(this.x || 0) < this.options.minSpeed && (this.x = 0), Math.abs(this.y || 0) < this.options.minSpeed && (this.y = 0)), n && this.parent.emit("moved", { viewport: this.parent, type: "decelerate" });
  }
  reset() {
    this.x = this.y = null;
  }
};
const x0 = {
  direction: "all",
  pressDrag: !0,
  wheel: !0,
  wheelScroll: 1,
  reverse: !1,
  clampWheel: !1,
  underflow: "center",
  factor: 1,
  mouseButtons: "all",
  keyToPress: null,
  ignoreKeyToPressOnTouch: !1,
  lineHeight: 20,
  wheelSwapAxes: !1
};
class $0 extends Ht {
  /**
   * This is called by {@link Viewport.drag}.
   */
  constructor(e, n = {}) {
    super(e), this.windowEventHandlers = [], this.options = Object.assign({}, x0, n), this.moved = !1, this.reverse = this.options.reverse ? 1 : -1, this.xDirection = !this.options.direction || this.options.direction === "all" || this.options.direction === "x", this.yDirection = !this.options.direction || this.options.direction === "all" || this.options.direction === "y", this.keyIsPressed = !1, this.parseUnderflow(), this.mouseButtons(this.options.mouseButtons), this.options.keyToPress && this.handleKeyPresses(this.options.keyToPress);
  }
  /**
   * Handles keypress events and set the keyIsPressed boolean accordingly
   *
   * @param {array} codes - key codes that can be used to trigger drag event
   */
  handleKeyPresses(e) {
    const n = (o) => {
      e.includes(o.code) && (this.keyIsPressed = !0);
    }, s = (o) => {
      e.includes(o.code) && (this.keyIsPressed = !1);
    };
    this.addWindowEventHandler("keyup", s), this.addWindowEventHandler("keydown", n);
  }
  addWindowEventHandler(e, n) {
    typeof window > "u" || (window.addEventListener(e, n), this.windowEventHandlers.push({ event: e, handler: n }));
  }
  destroy() {
    typeof window > "u" || this.windowEventHandlers.forEach(({ event: e, handler: n }) => {
      window.removeEventListener(e, n);
    });
  }
  /**
   * initialize mousebuttons array
   * @param {string} buttons
   */
  mouseButtons(e) {
    !e || e === "all" ? this.mouse = [!0, !0, !0] : this.mouse = [
      e.indexOf("left") !== -1,
      e.indexOf("middle") !== -1,
      e.indexOf("right") !== -1
    ];
  }
  parseUnderflow() {
    const e = this.options.underflow.toLowerCase();
    e === "center" ? (this.underflowX = 0, this.underflowY = 0) : (e.includes("left") ? this.underflowX = -1 : e.includes("right") ? this.underflowX = 1 : this.underflowX = 0, e.includes("top") ? this.underflowY = -1 : e.includes("bottom") ? this.underflowY = 1 : this.underflowY = 0);
  }
  /**
   * @param {PIXI.FederatedPointerEvent} event
   * @returns {boolean}
   */
  checkButtons(e) {
    const n = e.pointerType === "mouse", s = this.parent.input.count();
    return !!((s === 1 || s > 1 && !this.parent.plugins.get("pinch", !0)) && (!n || this.mouse[e.button]));
  }
  /**
   * @param {PIXI.FederatedPointerEvent} event
   * @returns {boolean}
   */
  checkKeyPress(e) {
    return !this.options.keyToPress || this.keyIsPressed || this.options.ignoreKeyToPressOnTouch && e.data.pointerType === "touch";
  }
  down(e) {
    return this.paused || !this.options.pressDrag ? !1 : this.checkButtons(e) && this.checkKeyPress(e) ? (this.last = { x: e.global.x, y: e.global.y }, this.current = e.pointerId, !0) : (this.last = null, !1);
  }
  get active() {
    return this.moved;
  }
  move(e) {
    if (this.paused || !this.options.pressDrag)
      return !1;
    if (this.last && this.current === e.data.pointerId) {
      const n = e.global.x, s = e.global.y, o = this.parent.input.count();
      if (o === 1 || o > 1 && !this.parent.plugins.get("pinch", !0)) {
        const a = n - this.last.x, i = s - this.last.y;
        if (this.moved || this.xDirection && this.parent.input.checkThreshold(a) || this.yDirection && this.parent.input.checkThreshold(i)) {
          const r = { x: n, y: s };
          return this.xDirection && (this.parent.x += (r.x - this.last.x) * this.options.factor), this.yDirection && (this.parent.y += (r.y - this.last.y) * this.options.factor), this.last = r, this.moved || this.parent.emit("drag-start", {
            event: e,
            screen: new $t(this.last.x, this.last.y),
            world: this.parent.toWorld(new $t(this.last.x, this.last.y)),
            viewport: this.parent
          }), this.moved = !0, this.parent.emit("moved", { viewport: this.parent, type: "drag" }), !0;
        }
      } else
        this.moved = !1;
    }
    return !1;
  }
  up(e) {
    if (this.paused)
      return !1;
    const n = this.parent.input.touches;
    if (n.length === 1) {
      const s = n[0];
      return s.last && (this.last = { x: s.last.x, y: s.last.y }, this.current = s.id), this.moved = !1, !0;
    } else if (this.last && this.moved) {
      const s = new $t(this.last.x, this.last.y);
      return this.parent.emit("drag-end", {
        event: e,
        screen: s,
        world: this.parent.toWorld(s),
        viewport: this.parent
      }), this.last = null, this.moved = !1, !0;
    }
    return !1;
  }
  wheel(e) {
    if (this.paused)
      return !1;
    if (this.options.wheel) {
      const n = this.parent.plugins.get("wheel", !0);
      if (!n || !n.options.wheelZoom && !e.ctrlKey) {
        const s = e.deltaMode ? this.options.lineHeight : 1, o = [e.deltaX, e.deltaY], [a, i] = this.options.wheelSwapAxes ? o.reverse() : o;
        return this.xDirection && (this.parent.x += a * s * this.options.wheelScroll * this.reverse), this.yDirection && (this.parent.y += i * s * this.options.wheelScroll * this.reverse), this.options.clampWheel && this.clamp(), this.parent.emit("wheel-scroll", this.parent), this.parent.emit("moved", { viewport: this.parent, type: "wheel" }), this.parent.options.passiveWheel || e.preventDefault(), this.parent.options.stopPropagation && e.stopPropagation(), !0;
      }
    }
    return !1;
  }
  resume() {
    this.last = null, this.paused = !1;
  }
  clamp() {
    const e = this.parent.plugins.get("decelerate", !0) || {};
    if (this.options.clampWheel !== "y")
      if (this.parent.screenWorldWidth < this.parent.screenWidth)
        switch (this.underflowX) {
          case -1:
            this.parent.x = 0;
            break;
          case 1:
            this.parent.x = this.parent.screenWidth - this.parent.screenWorldWidth;
            break;
          default:
            this.parent.x = (this.parent.screenWidth - this.parent.screenWorldWidth) / 2;
        }
      else
        this.parent.left < 0 ? (this.parent.x = 0, e.x = 0) : this.parent.right > this.parent.worldWidth && (this.parent.x = -this.parent.worldWidth * this.parent.scale.x + this.parent.screenWidth, e.x = 0);
    if (this.options.clampWheel !== "x")
      if (this.parent.screenWorldHeight < this.parent.screenHeight)
        switch (this.underflowY) {
          case -1:
            this.parent.y = 0;
            break;
          case 1:
            this.parent.y = this.parent.screenHeight - this.parent.screenWorldHeight;
            break;
          default:
            this.parent.y = (this.parent.screenHeight - this.parent.screenWorldHeight) / 2;
        }
      else
        this.parent.top < 0 && (this.parent.y = 0, e.y = 0), this.parent.bottom > this.parent.worldHeight && (this.parent.y = -this.parent.worldHeight * this.parent.scale.y + this.parent.screenHeight, e.y = 0);
  }
}
const z0 = {
  speed: 0,
  acceleration: null,
  radius: null
};
class S0 extends Ht {
  /**
   * This is called by {@link Viewport.follow}.
   *
   * @param parent
   * @param target - target to follow
   * @param options
   */
  constructor(e, n, s = {}) {
    super(e), this.target = n, this.options = Object.assign({}, z0, s), this.velocity = { x: 0, y: 0 };
  }
  update(e) {
    if (this.paused)
      return;
    const n = this.parent.center;
    let s = this.target.x, o = this.target.y;
    if (this.options.radius)
      if (Math.sqrt(Math.pow(this.target.y - n.y, 2) + Math.pow(this.target.x - n.x, 2)) > this.options.radius) {
        const r = Math.atan2(this.target.y - n.y, this.target.x - n.x);
        s = this.target.x - Math.cos(r) * this.options.radius, o = this.target.y - Math.sin(r) * this.options.radius;
      } else
        return;
    const a = s - n.x, i = o - n.y;
    if (a || i)
      if (this.options.speed)
        if (this.options.acceleration) {
          const r = Math.atan2(o - n.y, s - n.x), c = Math.sqrt(Math.pow(a, 2) + Math.pow(i, 2));
          if (c) {
            const u = (Math.pow(this.velocity.x, 2) + Math.pow(this.velocity.y, 2)) / (2 * this.options.acceleration);
            c > u ? this.velocity = {
              x: Math.min(this.velocity.x + (this.options.acceleration * e, this.options.speed)),
              y: Math.min(this.velocity.y + (this.options.acceleration * e, this.options.speed))
            } : this.velocity = {
              x: Math.max(this.velocity.x - this.options.acceleration * this.options.speed, 0),
              y: Math.max(this.velocity.y - this.options.acceleration * this.options.speed, 0)
            };
            const d = Math.cos(r) * this.velocity.x, m = Math.sin(r) * this.velocity.y, _ = Math.abs(d) > Math.abs(a) ? s : n.x + d, g = Math.abs(m) > Math.abs(i) ? o : n.y + m;
            this.parent.moveCenter(_, g), this.parent.emit("moved", { viewport: this.parent, type: "follow" });
          }
        } else {
          const r = Math.atan2(o - n.y, s - n.x), c = Math.cos(r) * this.options.speed, u = Math.sin(r) * this.options.speed, d = Math.abs(c) > Math.abs(a) ? s : n.x + c, m = Math.abs(u) > Math.abs(i) ? o : n.y + u;
          this.parent.moveCenter(d, m), this.parent.emit("moved", { viewport: this.parent, type: "follow" });
        }
      else
        this.parent.moveCenter(s, o), this.parent.emit("moved", { viewport: this.parent, type: "follow" });
  }
}
const A0 = {
  radius: null,
  distance: null,
  top: null,
  bottom: null,
  left: null,
  right: null,
  speed: 8,
  reverse: !1,
  noDecelerate: !1,
  linear: !1,
  allowButtons: !1
};
class C0 extends Ht {
  /**
   * This is called by {@link Viewport.mouseEdges}.
   */
  constructor(e, n = {}) {
    super(e), this.options = Object.assign({}, A0, n), this.reverse = this.options.reverse ? 1 : -1, this.radiusSquared = typeof this.options.radius == "number" ? Math.pow(this.options.radius, 2) : null, this.resize();
  }
  resize() {
    const e = this.options.distance;
    e !== null ? (this.left = e, this.top = e, this.right = this.parent.screenWidth - e, this.bottom = this.parent.screenHeight - e) : this.options.radius || (this.left = this.options.left, this.top = this.options.top, this.right = this.options.right === null ? null : this.parent.screenWidth - this.options.right, this.bottom = this.options.bottom === null ? null : this.parent.screenHeight - this.options.bottom);
  }
  down() {
    return this.paused || this.options.allowButtons || (this.horizontal = this.vertical = null), !1;
  }
  move(e) {
    if (this.paused || e.pointerType !== "mouse" && e.pointerId !== 1 || !this.options.allowButtons && e.buttons !== 0)
      return !1;
    const n = e.global.x, s = e.global.y;
    if (this.radiusSquared) {
      const o = this.parent.toScreen(this.parent.center);
      if (Math.pow(o.x - n, 2) + Math.pow(o.y - s, 2) >= this.radiusSquared) {
        const a = Math.atan2(o.y - s, o.x - n);
        this.options.linear ? (this.horizontal = Math.round(Math.cos(a)) * this.options.speed * this.reverse * (60 / 1e3), this.vertical = Math.round(Math.sin(a)) * this.options.speed * this.reverse * (60 / 1e3)) : (this.horizontal = Math.cos(a) * this.options.speed * this.reverse * (60 / 1e3), this.vertical = Math.sin(a) * this.options.speed * this.reverse * (60 / 1e3));
      } else
        this.horizontal && this.decelerateHorizontal(), this.vertical && this.decelerateVertical(), this.horizontal = this.vertical = 0;
    } else
      this.left !== null && n < this.left ? this.horizontal = Number(this.reverse) * this.options.speed * (60 / 1e3) : this.right !== null && n > this.right ? this.horizontal = -1 * this.reverse * this.options.speed * (60 / 1e3) : (this.decelerateHorizontal(), this.horizontal = 0), this.top !== null && s < this.top ? this.vertical = Number(this.reverse) * this.options.speed * (60 / 1e3) : this.bottom !== null && s > this.bottom ? this.vertical = -1 * this.reverse * this.options.speed * (60 / 1e3) : (this.decelerateVertical(), this.vertical = 0);
    return !1;
  }
  decelerateHorizontal() {
    const e = this.parent.plugins.get("decelerate", !0);
    this.horizontal && e && !this.options.noDecelerate && e.activate({ x: this.horizontal * this.options.speed * this.reverse / (1e3 / 60) });
  }
  decelerateVertical() {
    const e = this.parent.plugins.get("decelerate", !0);
    this.vertical && e && !this.options.noDecelerate && e.activate({ y: this.vertical * this.options.speed * this.reverse / (1e3 / 60) });
  }
  up() {
    return this.paused || (this.horizontal && this.decelerateHorizontal(), this.vertical && this.decelerateVertical(), this.horizontal = this.vertical = null), !1;
  }
  update() {
    if (!this.paused && (this.horizontal || this.vertical)) {
      const e = this.parent.center;
      this.horizontal && (e.x += this.horizontal * this.options.speed), this.vertical && (e.y += this.vertical * this.options.speed), this.parent.moveCenter(e), this.parent.emit("moved", { viewport: this.parent, type: "mouse-edges" });
    }
  }
}
const P0 = {
  noDrag: !1,
  percent: 1,
  center: null,
  factor: 1,
  axis: "all"
};
let M0 = class extends Ht {
  /**
   * This is called by {@link Viewport.pinch}.
   */
  constructor(e, n = {}) {
    super(e), this.active = !1, this.pinching = !1, this.moved = !1, this.options = Object.assign({}, P0, n);
  }
  down() {
    return this.parent.input.count() >= 2 ? (this.active = !0, !0) : !1;
  }
  isAxisX() {
    return ["all", "x"].includes(this.options.axis);
  }
  isAxisY() {
    return ["all", "y"].includes(this.options.axis);
  }
  move(e) {
    if (this.paused || !this.active)
      return !1;
    const n = e.global.x, s = e.global.y, o = this.parent.input.touches;
    if (o.length >= 2) {
      const a = o[0], i = o[1], r = a.last && i.last ? Math.sqrt(Math.pow(i.last.x - a.last.x, 2) + Math.pow(i.last.y - a.last.y, 2)) : null;
      if (a.id === e.pointerId ? a.last = { x: n, y: s, data: e } : i.id === e.pointerId && (i.last = { x: n, y: s, data: e }), r) {
        let c;
        const u = new $t(
          a.last.x + (i.last.x - a.last.x) / 2,
          a.last.y + (i.last.y - a.last.y) / 2
        );
        this.options.center || (c = this.parent.toLocal(u));
        let d = Math.sqrt(Math.pow(
          i.last.x - a.last.x,
          2
        ) + Math.pow(i.last.y - a.last.y, 2));
        d = d === 0 ? d = 1e-10 : d;
        const m = (1 - r / d) * this.options.percent * (this.isAxisX() ? this.parent.scale.x : this.parent.scale.y);
        this.isAxisX() && (this.parent.scale.x += m), this.isAxisY() && (this.parent.scale.y += m), this.parent.emit("zoomed", { viewport: this.parent, type: "pinch", center: u });
        const _ = this.parent.plugins.get("clamp-zoom", !0);
        if (_ && _.clamp(), this.options.center)
          this.parent.moveCenter(this.options.center);
        else {
          const g = this.parent.toGlobal(c);
          this.parent.x += (u.x - g.x) * this.options.factor, this.parent.y += (u.y - g.y) * this.options.factor, this.parent.emit("moved", { viewport: this.parent, type: "pinch" });
        }
        !this.options.noDrag && this.lastCenter && (this.parent.x += (u.x - this.lastCenter.x) * this.options.factor, this.parent.y += (u.y - this.lastCenter.y) * this.options.factor, this.parent.emit("moved", { viewport: this.parent, type: "pinch" })), this.lastCenter = u, this.moved = !0;
      } else
        this.pinching || (this.parent.emit("pinch-start", this.parent), this.pinching = !0);
      return !0;
    }
    return !1;
  }
  up() {
    return this.pinching && this.parent.input.touches.length <= 1 ? (this.active = !1, this.lastCenter = null, this.pinching = !1, this.moved = !1, this.parent.emit("pinch-end", this.parent), !0) : !1;
  }
};
const T0 = {
  topLeft: !1,
  friction: 0.8,
  time: 1e3,
  ease: "easeInOutSine",
  interrupt: !0,
  removeOnComplete: !1,
  removeOnInterrupt: !1,
  forceStart: !1
};
class I0 extends Ht {
  /**
   * This is called by {@link Viewport.snap}.
   */
  constructor(e, n, s, o = {}) {
    super(e), this.options = Object.assign({}, T0, o), this.ease = Qa(o.ease, "easeInOutSine"), this.x = n, this.y = s, this.options.forceStart && this.snapStart();
  }
  snapStart() {
    this.percent = 0, this.snapping = { time: 0 };
    const e = this.options.topLeft ? this.parent.corner : this.parent.center;
    this.deltaX = this.x - e.x, this.deltaY = this.y - e.y, this.startX = e.x, this.startY = e.y, this.parent.emit("snap-start", this.parent);
  }
  wheel() {
    return this.options.removeOnInterrupt && this.parent.plugins.remove("snap"), !1;
  }
  down() {
    return this.options.removeOnInterrupt ? this.parent.plugins.remove("snap") : this.options.interrupt && (this.snapping = null), !1;
  }
  up() {
    if (this.parent.input.count() === 0) {
      const e = this.parent.plugins.get("decelerate", !0);
      e && (e.x || e.y) && (e.percentChangeX = e.percentChangeY = this.options.friction);
    }
    return !1;
  }
  update(e) {
    if (!this.paused && !(this.options.interrupt && this.parent.input.count() !== 0))
      if (this.snapping) {
        const n = this.snapping;
        n.time += e;
        let s, o, a;
        const i = this.startX, r = this.startY, c = this.deltaX, u = this.deltaY;
        if (n.time > this.options.time)
          s = !0, o = i + c, a = r + u;
        else {
          const d = this.ease(n.time, 0, 1, this.options.time);
          o = i + c * d, a = r + u * d;
        }
        this.options.topLeft ? this.parent.moveCorner(o, a) : this.parent.moveCenter(o, a), this.parent.emit("moved", { viewport: this.parent, type: "snap" }), s && (this.options.removeOnComplete && this.parent.plugins.remove("snap"), this.parent.emit("snap-end", this.parent), this.snapping = null);
      } else {
        const n = this.options.topLeft ? this.parent.corner : this.parent.center;
        (n.x !== this.x || n.y !== this.y) && this.snapStart();
      }
  }
}
const E0 = {
  width: 0,
  height: 0,
  time: 1e3,
  ease: "easeInOutSine",
  center: null,
  interrupt: !0,
  removeOnComplete: !1,
  removeOnInterrupt: !1,
  forceStart: !1,
  noMove: !1
};
class O0 extends Ht {
  /**
   * This is called by {@link Viewport.snapZoom}.
   */
  constructor(e, n = {}) {
    super(e), this.options = Object.assign({}, E0, n), this.ease = Qa(this.options.ease), this.xIndependent = !1, this.yIndependent = !1, this.xScale = 0, this.yScale = 0, this.options.width > 0 && (this.xScale = e.screenWidth / this.options.width, this.xIndependent = !0), this.options.height > 0 && (this.yScale = e.screenHeight / this.options.height, this.yIndependent = !0), this.xScale = this.xIndependent ? this.xScale : this.yScale, this.yScale = this.yIndependent ? this.yScale : this.xScale, this.options.time === 0 ? (e.container.scale.x = this.xScale, e.container.scale.y = this.yScale, this.options.removeOnComplete && this.parent.plugins.remove("snap-zoom")) : n.forceStart && this.createSnapping();
  }
  createSnapping() {
    const e = this.parent.worldScreenWidth, n = this.parent.worldScreenHeight, s = this.parent.screenWidth / this.xScale, o = this.parent.screenHeight / this.yScale;
    this.snapping = {
      time: 0,
      startX: e,
      startY: n,
      deltaX: s - e,
      deltaY: o - n
    }, this.parent.emit("snap-zoom-start", this.parent);
  }
  resize() {
    this.snapping = null, this.options.width > 0 && (this.xScale = this.parent.screenWidth / this.options.width), this.options.height > 0 && (this.yScale = this.parent.screenHeight / this.options.height), this.xScale = this.xIndependent ? this.xScale : this.yScale, this.yScale = this.yIndependent ? this.yScale : this.xScale;
  }
  wheel() {
    return this.options.removeOnInterrupt && this.parent.plugins.remove("snap-zoom"), !1;
  }
  down() {
    return this.options.removeOnInterrupt ? this.parent.plugins.remove("snap-zoom") : this.options.interrupt && (this.snapping = null), !1;
  }
  update(e) {
    if (this.paused || this.options.interrupt && this.parent.input.count() !== 0)
      return;
    let n;
    if (!this.options.center && !this.options.noMove && (n = this.parent.center), !this.snapping)
      (this.parent.scale.x !== this.xScale || this.parent.scale.y !== this.yScale) && this.createSnapping();
    else if (this.snapping) {
      const s = this.snapping;
      if (s.time += e, s.time >= this.options.time)
        this.parent.scale.set(this.xScale, this.yScale), this.options.removeOnComplete && this.parent.plugins.remove("snap-zoom"), this.parent.emit("snap-zoom-end", this.parent), this.snapping = null;
      else {
        const a = this.snapping, i = this.ease(a.time, a.startX, a.deltaX, this.options.time), r = this.ease(a.time, a.startY, a.deltaY, this.options.time);
        this.parent.scale.x = this.parent.screenWidth / i, this.parent.scale.y = this.parent.screenHeight / r;
      }
      const o = this.parent.plugins.get("clamp-zoom", !0);
      o && o.clamp(), this.options.noMove || (this.options.center ? this.parent.moveCenter(this.options.center) : this.parent.moveCenter(n));
    }
  }
  resume() {
    this.snapping = null, super.resume();
  }
}
const R0 = {
  percent: 0.1,
  smooth: !1,
  interrupt: !0,
  reverse: !1,
  center: null,
  lineHeight: 20,
  axis: "all",
  keyToPress: null,
  trackpadPinch: !1,
  wheelZoom: !0
};
class L0 extends Ht {
  /**
   * This is called by {@link Viewport.wheel}.
   */
  constructor(e, n = {}) {
    super(e), this.options = Object.assign({}, R0, n), this.keyIsPressed = !1, this.options.keyToPress && this.handleKeyPresses(this.options.keyToPress);
  }
  /**
   * Handles keypress events and set the keyIsPressed boolean accordingly
   *
   * @param {array} codes - key codes that can be used to trigger zoom event
   */
  handleKeyPresses(e) {
    typeof window > "u" || (window.addEventListener("keydown", (n) => {
      e.includes(n.code) && (this.keyIsPressed = !0);
    }), window.addEventListener("keyup", (n) => {
      e.includes(n.code) && (this.keyIsPressed = !1);
    }));
  }
  checkKeyPress() {
    return !this.options.keyToPress || this.keyIsPressed;
  }
  down() {
    return this.options.interrupt && (this.smoothing = null), !1;
  }
  isAxisX() {
    return ["all", "x"].includes(this.options.axis);
  }
  isAxisY() {
    return ["all", "y"].includes(this.options.axis);
  }
  update() {
    if (this.smoothing) {
      const e = this.smoothingCenter, n = this.smoothing;
      let s;
      this.options.center || (s = this.parent.toLocal(e)), this.isAxisX() && (this.parent.scale.x += n.x), this.isAxisY() && (this.parent.scale.y += n.y), this.parent.emit("zoomed", { viewport: this.parent, type: "wheel" });
      const o = this.parent.plugins.get("clamp-zoom", !0);
      if (o && o.clamp(), this.options.center)
        this.parent.moveCenter(this.options.center);
      else {
        const a = this.parent.toGlobal(s);
        this.parent.x += e.x - a.x, this.parent.y += e.y - a.y;
      }
      this.parent.emit("moved", { viewport: this.parent, type: "wheel" }), this.smoothingCount++, this.smoothingCount >= this.options.smooth && (this.smoothing = null);
    }
  }
  pinch(e) {
    if (this.paused)
      return;
    const n = this.parent.input.getPointerPosition(e), s = -e.deltaY * (e.deltaMode ? this.options.lineHeight : 1) / 200, o = Math.pow(2, (1 + this.options.percent) * s);
    let a;
    this.options.center || (a = this.parent.toLocal(n)), this.isAxisX() && (this.parent.scale.x *= o), this.isAxisY() && (this.parent.scale.y *= o), this.parent.emit("zoomed", { viewport: this.parent, type: "wheel" });
    const i = this.parent.plugins.get("clamp-zoom", !0);
    if (i && i.clamp(), this.options.center)
      this.parent.moveCenter(this.options.center);
    else {
      const r = this.parent.toGlobal(a);
      this.parent.x += n.x - r.x, this.parent.y += n.y - r.y;
    }
    this.parent.emit("moved", { viewport: this.parent, type: "wheel" }), this.parent.emit(
      "wheel-start",
      { event: e, viewport: this.parent }
    );
  }
  wheel(e) {
    if (this.paused || !this.checkKeyPress())
      return !1;
    if (e.ctrlKey && this.options.trackpadPinch)
      this.pinch(e);
    else if (this.options.wheelZoom) {
      const n = this.parent.input.getPointerPosition(e), s = (this.options.reverse ? -1 : 1) * -e.deltaY * (e.deltaMode ? this.options.lineHeight : 1) / 500, o = Math.pow(2, (1 + this.options.percent) * s);
      if (this.options.smooth) {
        const a = {
          x: this.smoothing ? this.smoothing.x * (this.options.smooth - this.smoothingCount) : 0,
          y: this.smoothing ? this.smoothing.y * (this.options.smooth - this.smoothingCount) : 0
        };
        this.smoothing = {
          x: ((this.parent.scale.x + a.x) * o - this.parent.scale.x) / this.options.smooth,
          y: ((this.parent.scale.y + a.y) * o - this.parent.scale.y) / this.options.smooth
        }, this.smoothingCount = 0, this.smoothingCenter = n;
      } else {
        let a;
        this.options.center || (a = this.parent.toLocal(n)), this.isAxisX() && (this.parent.scale.x *= o), this.isAxisY() && (this.parent.scale.y *= o), this.parent.emit("zoomed", { viewport: this.parent, type: "wheel" });
        const i = this.parent.plugins.get("clamp-zoom", !0);
        if (i && i.clamp(), this.options.center)
          this.parent.moveCenter(this.options.center);
        else {
          const r = this.parent.toGlobal(a);
          this.parent.x += n.x - r.x, this.parent.y += n.y - r.y;
        }
      }
      this.parent.emit("moved", { viewport: this.parent, type: "wheel" }), this.parent.emit(
        "wheel-start",
        { event: e, viewport: this.parent }
      );
    }
    return !this.parent.options.passiveWheel;
  }
}
class D0 {
  constructor(e) {
    this.viewport = e, this.touches = [], this.addListeners();
  }
  /** Add input listeners */
  addListeners() {
    this.viewport.eventMode = "static", this.viewport.forceHitArea || (this.viewport.hitArea = new ca(0, 0, this.viewport.worldWidth, this.viewport.worldHeight)), this.viewport.on("pointerdown", this.down, this), this.viewport.options.allowPreserveDragOutside ? this.viewport.on("globalpointermove", this.move, this) : this.viewport.on("pointermove", this.move, this), this.viewport.on("pointerup", this.up, this), this.viewport.on("pointerupoutside", this.up, this), this.viewport.on("pointercancel", this.up, this), this.viewport.options.allowPreserveDragOutside || this.viewport.on("pointerleave", this.up, this), this.wheelFunction = (e) => this.handleWheel(e), this.viewport.options.events.domElement.addEventListener(
      "wheel",
      this.wheelFunction,
      { passive: this.viewport.options.passiveWheel }
    ), this.isMouseDown = !1;
  }
  /**
   * Removes all event listeners from viewport
   * (useful for cleanup of wheel when removing viewport)
   */
  destroy() {
    var e;
    (e = this.viewport.options.events.domElement) == null || e.removeEventListener("wheel", this.wheelFunction);
  }
  /**
   * handle down events for viewport
   *
   * @param {PIXI.FederatedPointerEvent} event
   */
  down(e) {
    if (!(this.viewport.pause || !this.viewport.visible)) {
      if (e.pointerType === "mouse" ? this.isMouseDown = !0 : this.get(e.pointerId) || this.touches.push({ id: e.pointerId, last: null }), this.count() === 1) {
        this.last = e.global.clone();
        const n = this.viewport.plugins.get("decelerate", !0), s = this.viewport.plugins.get("bounce", !0);
        (!n || !n.isActive()) && (!s || !s.isActive()) ? this.clickedAvailable = !0 : this.clickedAvailable = !1;
      } else
        this.clickedAvailable = !1;
      this.viewport.plugins.down(e) && this.viewport.options.stopPropagation && e.stopPropagation();
    }
  }
  /** Clears all pointer events */
  clear() {
    this.isMouseDown = !1, this.touches = [], this.last = null;
  }
  /**
   * @param {number} change
   * @returns whether change exceeds threshold
   */
  checkThreshold(e) {
    return Math.abs(e) >= this.viewport.threshold;
  }
  /** Handle move events for viewport */
  move(e) {
    if (this.viewport.pause || !this.viewport.visible)
      return;
    const n = this.viewport.plugins.move(e);
    if (this.clickedAvailable && this.last) {
      const s = e.global.x - this.last.x, o = e.global.y - this.last.y;
      (this.checkThreshold(s) || this.checkThreshold(o)) && (this.clickedAvailable = !1);
    }
    n && this.viewport.options.stopPropagation && e.stopPropagation();
  }
  /** Handle up events for viewport */
  up(e) {
    if (this.viewport.pause || !this.viewport.visible)
      return;
    e.pointerType === "mouse" && (this.isMouseDown = !1), e.pointerType !== "mouse" && this.remove(e.pointerId);
    const n = this.viewport.plugins.up(e);
    this.clickedAvailable && this.count() === 0 && this.last && (this.viewport.emit("clicked", {
      event: e,
      screen: this.last,
      world: this.viewport.toWorld(this.last),
      viewport: this.viewport
    }), this.clickedAvailable = !1), n && this.viewport.options.stopPropagation && e.stopPropagation();
  }
  /** Gets pointer position if this.interaction is set */
  getPointerPosition(e) {
    const n = new $t();
    return this.viewport.options.events.mapPositionToPoint(n, e.clientX, e.clientY), n;
  }
  /** Handle wheel events */
  handleWheel(e) {
    if (this.viewport.pause || !this.viewport.visible)
      return;
    const n = this.viewport.toLocal(this.getPointerPosition(e));
    this.viewport.left <= n.x && n.x <= this.viewport.right && this.viewport.top <= n.y && n.y <= this.viewport.bottom && this.viewport.plugins.wheel(e) && !this.viewport.options.passiveWheel && e.preventDefault();
  }
  pause() {
    this.touches = [], this.isMouseDown = !1;
  }
  /** Get touch by id */
  get(e) {
    for (const n of this.touches)
      if (n.id === e)
        return n;
    return null;
  }
  /** Remove touch by number */
  remove(e) {
    for (let n = 0; n < this.touches.length; n++)
      if (this.touches[n].id === e) {
        this.touches.splice(n, 1);
        return;
      }
  }
  /**
   * @returns {number} count of mouse/touch pointers that are down on the viewport
   */
  count() {
    return (this.isMouseDown ? 1 : 0) + this.touches.length;
  }
}
const io = [
  "drag",
  "pinch",
  "wheel",
  "follow",
  "mouse-edges",
  "decelerate",
  "animate",
  "bounce",
  "snap-zoom",
  "clamp-zoom",
  "snap",
  "clamp"
];
class j0 {
  /** This is called by {@link Viewport} to initialize the {@link Viewport.plugins plugins}. */
  constructor(e) {
    this.viewport = e, this.list = [], this.plugins = {};
  }
  /**
   * Inserts a named plugin or a user plugin into the viewport
   * default plugin order: 'drag', 'pinch', 'wheel', 'follow', 'mouse-edges', 'decelerate', 'bounce',
   * 'snap-zoom', 'clamp-zoom', 'snap', 'clamp'
   *
   * @param {string} name of plugin
   * @param {Plugin} plugin - instantiated Plugin class
   * @param {number} index to insert userPlugin (otherwise inserts it at the end)
   */
  add(e, n, s = io.length) {
    const o = this.plugins[e];
    o && o.destroy(), this.plugins[e] = n;
    const a = io.indexOf(e);
    a !== -1 && io.splice(a, 1), io.splice(s, 0, e), this.sort();
  }
  /**
   * Get plugin
   *
   * @param {string} name of plugin
   * @param {boolean} [ignorePaused] return null if plugin is paused
   */
  get(e, n) {
    var s;
    return n && (s = this.plugins[e]) != null && s.paused ? null : this.plugins[e];
  }
  /**
   * Update all active plugins
   *
   * @internal
   * @ignore
   * @param {number} elapsed type in milliseconds since last update
   */
  update(e) {
    for (const n of this.list)
      n.update(e);
  }
  /**
   * Resize all active plugins
   *
   * @internal
   * @ignore
   */
  resize() {
    for (const e of this.list)
      e.resize();
  }
  /** Clamps and resets bounce and decelerate (as needed) after manually moving viewport */
  reset() {
    for (const e of this.list)
      e.reset();
  }
  /** removes all installed plugins */
  removeAll() {
    this.list.forEach((e) => {
      e.destroy();
    }), this.plugins = {}, this.sort();
  }
  /**
   * Removes installed plugin
   *
   * @param {string} name of plugin (e.g., 'drag', 'pinch')
   */
  remove(e) {
    var n;
    this.plugins[e] && ((n = this.plugins[e]) == null || n.destroy(), delete this.plugins[e], this.viewport.emit("plugin-remove", e), this.sort());
  }
  /**
   * Pause plugin
   *
   * @param {string} name of plugin (e.g., 'drag', 'pinch')
   */
  pause(e) {
    var n;
    (n = this.plugins[e]) == null || n.pause();
  }
  /**
   * Resume plugin
   *
   * @param {string} name of plugin (e.g., 'drag', 'pinch')
   */
  resume(e) {
    var n;
    (n = this.plugins[e]) == null || n.resume();
  }
  /**
   * Sort plugins according to PLUGIN_ORDER
   *
   * @internal
   * @ignore
   */
  sort() {
    this.list = [];
    for (const e of io)
      this.plugins[e] && this.list.push(this.plugins[e]);
  }
  /**
   * Handle down for all plugins
   *
   * @internal
   * @ignore
   */
  down(e) {
    let n = !1;
    for (const s of this.list)
      s.down(e) && (n = !0);
    return n;
  }
  /**
   * Handle move for all plugins
   *
   * @internal
   * @ignore
   */
  move(e) {
    let n = !1;
    for (const s of this.viewport.plugins.list)
      s.move(e) && (n = !0);
    return n;
  }
  /**
   * Handle up for all plugins
   *
   * @internal
   * @ignore
   */
  up(e) {
    let n = !1;
    for (const s of this.list)
      s.up(e) && (n = !0);
    return n;
  }
  /**
   * Handle wheel event for all plugins
   *
   * @internal
   * @ignore
   */
  wheel(e) {
    let n = !1;
    for (const s of this.list)
      s.wheel(e) && (n = !0);
    return n;
  }
}
const N0 = {
  screenWidth: typeof window > "u" ? 0 : window.innerWidth,
  screenHeight: typeof window > "u" ? 0 : window.innerHeight,
  worldWidth: null,
  worldHeight: null,
  threshold: 5,
  passiveWheel: !0,
  stopPropagation: !1,
  forceHitArea: null,
  noTicker: !1,
  disableOnContextMenu: !1,
  ticker: gf.shared,
  allowPreserveDragOutside: !1
};
let V0 = class extends hd {
  /**
   * @param {IViewportOptions} ViewportOptions
   * @param {number} [options.screenWidth=window.innerWidth]
   * @param {number} [options.screenHeight=window.innerHeight]
   * @param {number} [options.worldWidth=this.width]
   * @param {number} [options.worldHeight=this.height]
   * @param {number} [options.threshold=5] number of pixels to move to trigger an input event (e.g., drag, pinch)
   * or disable a clicked event
   * @param {boolean} [options.passiveWheel=true] whether the 'wheel' event is set to passive (note: if false,
   * e.preventDefault() will be called when wheel is used over the viewport)
   * @param {boolean} [options.stopPropagation=false] whether to stopPropagation of events that impact the viewport
   * (except wheel events, see options.passiveWheel)
   * @param {HitArea} [options.forceHitArea] change the default hitArea from world size to a new value
   * @param {boolean} [options.noTicker] set this if you want to manually call update() function on each frame
   * @param {PIXI.Ticker} [options.ticker=PIXI.Ticker.shared] use this PIXI.ticker for updates
   * @param {PIXI.EventSystem} [options.events] EventSystem available from app.events or added manually and passed here
   * location on screen
   * @param {boolean} [options.disableOnContextMenu] remove oncontextmenu=() => {} from the pixi's events.domElement
   */
  constructor(e) {
    super(), this._disableOnContextMenu = (n) => n.preventDefault(), this.options = {
      ...N0,
      ...e
    }, this.screenWidth = this.options.screenWidth, this.screenHeight = this.options.screenHeight, this._worldWidth = this.options.worldWidth, this._worldHeight = this.options.worldHeight, this.forceHitArea = this.options.forceHitArea, this.threshold = this.options.threshold, this.options.disableOnContextMenu && this.options.events.domElement.addEventListener("contextmenu", this._disableOnContextMenu), this.options.noTicker || (this.tickerFunction = () => this.update(this.options.ticker.elapsedMS), this.options.ticker.add(this.tickerFunction)), this.input = new D0(this), this.plugins = new j0(this);
  }
  /** Overrides PIXI.Container's destroy to also remove the 'wheel' and PIXI.Ticker listeners */
  destroy(e) {
    var n;
    !this.options.noTicker && this.tickerFunction && this.options.ticker.remove(this.tickerFunction), this.options.disableOnContextMenu && ((n = this.options.events.domElement) == null || n.removeEventListener("contextmenu", this._disableOnContextMenu)), this.input.destroy(), super.destroy(e);
  }
  /**
   * Update viewport on each frame.
   *
   * By default, you do not need to call this unless you set `options.noTicker=true`.
   *
   * @param {number} elapsed time in milliseconds since last update
   */
  update(e) {
    this.pause || (this.plugins.update(e), this.lastViewport && (this.lastViewport.x !== this.x || this.lastViewport.y !== this.y ? this.moving = !0 : this.moving && (this.emit("moved-end", this), this.moving = !1), this.lastViewport.scaleX !== this.scale.x || this.lastViewport.scaleY !== this.scale.y ? this.zooming = !0 : this.zooming && (this.emit("zoomed-end", this), this.zooming = !1)), this.forceHitArea || (this._hitAreaDefault = new ca(this.left, this.top, this.worldScreenWidth, this.worldScreenHeight), this.hitArea = this._hitAreaDefault), this._dirty = this._dirty || !this.lastViewport || this.lastViewport.x !== this.x || this.lastViewport.y !== this.y || this.lastViewport.scaleX !== this.scale.x || this.lastViewport.scaleY !== this.scale.y, this.lastViewport = {
      x: this.x,
      y: this.y,
      scaleX: this.scale.x,
      scaleY: this.scale.y
    }, this.emit("frame-end", this));
  }
  /**
   * Use this to set screen and world sizes, needed for pinch/wheel/clamp/bounce.
   * @param {number} screenWidth=window.innerWidth
   * @param {number} screenHeight=window.innerHeight
   * @param {number} [worldWidth]
   * @param {number} [worldHeight]
   */
  resize(e = typeof window > "u" ? 0 : window.innerWidth, n = typeof window > "u" ? 0 : window.innerHeight, s, o) {
    this.screenWidth = e, this.screenHeight = n, typeof s < "u" && (this._worldWidth = s), typeof o < "u" && (this._worldHeight = o), this.plugins.resize(), this.dirty = !0;
  }
  /** World width, in pixels */
  get worldWidth() {
    return this._worldWidth ? this._worldWidth : this.width / this.scale.x;
  }
  set worldWidth(e) {
    this._worldWidth = e, this.plugins.resize();
  }
  /** World height, in pixels */
  get worldHeight() {
    return this._worldHeight ? this._worldHeight : this.height / this.scale.y;
  }
  set worldHeight(e) {
    this._worldHeight = e, this.plugins.resize();
  }
  /** Get visible world bounds of viewport */
  getVisibleBounds() {
    return new ca(this.left, this.top, this.worldScreenWidth, this.worldScreenHeight);
  }
  /**
   * Changes coordinate from screen to world
   * @param {number|PIXI.Point} x
   * @param {number} y
   * @returns {PIXI.Point}
   */
  toWorld(e, n) {
    return arguments.length === 2 ? this.toLocal(new $t(e, n)) : this.toLocal(e);
  }
  /**
   * Changes coordinate from world to screen
   * @param {number|PIXI.Point} x
   * @param {number} y
   * @returns {PIXI.Point}
   */
  toScreen(e, n) {
    return arguments.length === 2 ? this.toGlobal(new $t(e, n)) : this.toGlobal(e);
  }
  /** Screen width in world coordinates */
  get worldScreenWidth() {
    return this.screenWidth / this.scale.x;
  }
  /** Screen height in world coordinates */
  get worldScreenHeight() {
    return this.screenHeight / this.scale.y;
  }
  /** World width in screen coordinates */
  get screenWorldWidth() {
    return this.worldWidth * this.scale.x;
  }
  /** World height in screen coordinates */
  get screenWorldHeight() {
    return this.worldHeight * this.scale.y;
  }
  /** Center of screen in world coordinates */
  get center() {
    return new $t(
      this.worldScreenWidth / 2 - this.x / this.scale.x,
      this.worldScreenHeight / 2 - this.y / this.scale.y
    );
  }
  set center(e) {
    this.moveCenter(e);
  }
  /**
   * Move center of viewport to (x, y)
   * @param {number|PIXI.Point} x
   * @param {number} [y]
   * @return {Viewport}
   */
  moveCenter(...e) {
    let n, s;
    typeof e[0] == "number" ? (n = e[0], s = e[1]) : (n = e[0].x, s = e[0].y);
    const o = (this.worldScreenWidth / 2 - n) * this.scale.x, a = (this.worldScreenHeight / 2 - s) * this.scale.y;
    return (this.x !== o || this.y !== a) && (this.position.set(o, a), this.plugins.reset(), this.dirty = !0), this;
  }
  /** Top-left corner of Viewport */
  get corner() {
    return new $t(-this.x / this.scale.x, -this.y / this.scale.y);
  }
  set corner(e) {
    this.moveCorner(e);
  }
  /**
   * MoveCorner
   * @param {number|PIXI.Point} x
   * @param {number} [y]
   * @returns {Viewport}
   */
  moveCorner(...e) {
    let n, s;
    return e.length === 1 ? (n = -e[0].x * this.scale.x, s = -e[0].y * this.scale.y) : (n = -e[0] * this.scale.x, s = -e[1] * this.scale.y), (n !== this.x || s !== this.y) && (this.position.set(n, s), this.plugins.reset(), this.dirty = !0), this;
  }
  /** Get how many world pixels fit in screen's width */
  get screenWidthInWorldPixels() {
    return this.screenWidth / this.scale.x;
  }
  /** Get how many world pixels fit on screen's height */
  get screenHeightInWorldPixels() {
    return this.screenHeight / this.scale.y;
  }
  /**
   * Find the scale value that fits a world width on the screen
   * does not change the viewport (use fit... to change)
   *
   * @param width - Width in world pixels
   * @return - scale
   */
  findFitWidth(e) {
    return this.screenWidth / e;
  }
  /**
   * Finds the scale value that fits a world height on the screens
   * does not change the viewport (use fit... to change)
   *
   * @param height - Height in world pixels
   * @return - scale
   */
  findFitHeight(e) {
    return this.screenHeight / e;
  }
  /**
   * Finds the scale value that fits the smaller of a world width and world height on the screen
   * does not change the viewport (use fit... to change)
   *
   * @param {number} width in world pixels
   * @param {number} height in world pixels
   * @returns {number} scale
   */
  findFit(e, n) {
    const s = this.screenWidth / e, o = this.screenHeight / n;
    return Math.min(s, o);
  }
  /**
   * Finds the scale value that fits the larger of a world width and world height on the screen
   * does not change the viewport (use fit... to change)
   *
   * @param {number} width in world pixels
   * @param {number} height in world pixels
   * @returns {number} scale
   */
  findCover(e, n) {
    const s = this.screenWidth / e, o = this.screenHeight / n;
    return Math.max(s, o);
  }
  /**
   * Change zoom so the width fits in the viewport
   *
   * @param width - width in world coordinates
   * @param center - maintain the same center
   * @param scaleY - whether to set scaleY=scaleX
   * @param noClamp - whether to disable clamp-zoom
   * @returns {Viewport} this
   */
  fitWidth(e = this.worldWidth, n, s = !0, o) {
    let a;
    n && (a = this.center), this.scale.x = this.screenWidth / e, s && (this.scale.y = this.scale.x);
    const i = this.plugins.get("clamp-zoom", !0);
    return !o && i && i.clamp(), n && a && this.moveCenter(a), this;
  }
  /**
   * Change zoom so the height fits in the viewport
   *
   * @param {number} [height=this.worldHeight] in world coordinates
   * @param {boolean} [center] maintain the same center of the screen after zoom
   * @param {boolean} [scaleX=true] whether to set scaleX = scaleY
   * @param {boolean} [noClamp] whether to disable clamp-zoom
   * @returns {Viewport} this
   */
  fitHeight(e = this.worldHeight, n, s = !0, o) {
    let a;
    n && (a = this.center), this.scale.y = this.screenHeight / e, s && (this.scale.x = this.scale.y);
    const i = this.plugins.get("clamp-zoom", !0);
    return !o && i && i.clamp(), n && a && this.moveCenter(a), this;
  }
  /**
   * Change zoom so it fits the entire world in the viewport
   *
   * @param {boolean} center maintain the same center of the screen after zoom
   * @returns {Viewport} this
   */
  fitWorld(e) {
    let n;
    e && (n = this.center), this.scale.x = this.screenWidth / this.worldWidth, this.scale.y = this.screenHeight / this.worldHeight, this.scale.x < this.scale.y ? this.scale.y = this.scale.x : this.scale.x = this.scale.y;
    const s = this.plugins.get("clamp-zoom", !0);
    return s && s.clamp(), e && n && this.moveCenter(n), this;
  }
  /**
   * Change zoom so it fits the size or the entire world in the viewport
   *
   * @param {boolean} [center] maintain the same center of the screen after zoom
   * @param {number} [width=this.worldWidth] desired width
   * @param {number} [height=this.worldHeight] desired height
   * @returns {Viewport} this
   */
  fit(e, n = this.worldWidth, s = this.worldHeight) {
    let o;
    e && (o = this.center), this.scale.x = this.screenWidth / n, this.scale.y = this.screenHeight / s, this.scale.x < this.scale.y ? this.scale.y = this.scale.x : this.scale.x = this.scale.y;
    const a = this.plugins.get("clamp-zoom", !0);
    return a && a.clamp(), e && o && this.moveCenter(o), this;
  }
  /**
   * Zoom viewport to specific value.
   *
   * @param {number} scale value (e.g., 1 would be 100%, 0.25 would be 25%)
   * @param {boolean} [center] maintain the same center of the screen after zoom
   * @return {Viewport} this
   */
  setZoom(e, n) {
    let s;
    n && (s = this.center), this.scale.set(e);
    const o = this.plugins.get("clamp-zoom", !0);
    return o && o.clamp(), n && s && this.moveCenter(s), this;
  }
  /**
   * Zoom viewport by a certain percent (in both x and y direction).
   *
   * @param {number} percent change (e.g., 0.25 would increase a starting scale of 1.0 to 1.25)
   * @param {boolean} [center] maintain the same center of the screen after zoom
   * @return {Viewport} this
   */
  zoomPercent(e, n) {
    return this.setZoom(this.scale.x + this.scale.x * e, n);
  }
  /**
   * Zoom viewport by increasing/decreasing width by a certain number of pixels.
   *
   * @param {number} change in pixels
   * @param {boolean} [center] maintain the same center of the screen after zoom
   * @return {Viewport} this
   */
  zoom(e, n) {
    return this.fitWidth(e + this.worldScreenWidth, n), this;
  }
  /** Changes scale of viewport and maintains center of viewport */
  get scaled() {
    return this.scale.x;
  }
  set scaled(e) {
    this.setZoom(e, !0);
  }
  /**
   * Returns zoom to the desired scale
   *
   * @param {ISnapZoomOptions} options
   * @param {number} [options.width=0] - the desired width to snap (to maintain aspect ratio, choose width or height)
   * @param {number} [options.height=0] - the desired height to snap (to maintain aspect ratio, choose width or height)
   * @param {number} [options.time=1000] - time for snapping in ms
   * @param {(string|function)} [options.ease=easeInOutSine] ease function or name (see http://easings.net/
   *   for supported names)
   * @param {PIXI.Point} [options.center] - place this point at center during zoom instead of center of the viewport
   * @param {boolean} [options.interrupt=true] - pause snapping with any user input on the viewport
   * @param {boolean} [options.removeOnComplete] - removes this plugin after snapping is complete
   * @param {boolean} [options.removeOnInterrupt] - removes this plugin if interrupted by any user input
   * @param {boolean} [options.forceStart] - starts the snap immediately regardless of whether the viewport is at the
   *   desired zoom
   * @param {boolean} [options.noMove] - zoom but do not move
   */
  snapZoom(e) {
    return this.plugins.add("snap-zoom", new O0(this, e)), this;
  }
  /** Is container out of world bounds */
  OOB() {
    return {
      left: this.left < 0,
      right: this.right > this.worldWidth,
      top: this.top < 0,
      bottom: this.bottom > this.worldHeight,
      cornerPoint: new $t(
        this.worldWidth * this.scale.x - this.screenWidth,
        this.worldHeight * this.scale.y - this.screenHeight
      )
    };
  }
  /** World coordinates of the right edge of the screen */
  get right() {
    return -this.x / this.scale.x + this.worldScreenWidth;
  }
  set right(e) {
    this.x = -e * this.scale.x + this.screenWidth, this.plugins.reset();
  }
  /** World coordinates of the left edge of the screen */
  get left() {
    return -this.x / this.scale.x;
  }
  set left(e) {
    this.x = -e * this.scale.x, this.plugins.reset();
  }
  /** World coordinates of the top edge of the screen */
  get top() {
    return -this.y / this.scale.y;
  }
  set top(e) {
    this.y = -e * this.scale.y, this.plugins.reset();
  }
  /** World coordinates of the bottom edge of the screen */
  get bottom() {
    return -this.y / this.scale.y + this.worldScreenHeight;
  }
  set bottom(e) {
    this.y = -e * this.scale.y + this.screenHeight, this.plugins.reset();
  }
  /**
   * Determines whether the viewport is dirty (i.e., needs to be rendered to the screen because of a change)
   */
  get dirty() {
    return !!this._dirty;
  }
  set dirty(e) {
    this._dirty = e;
  }
  /**
   * Permanently changes the Viewport's hitArea
   *
   * NOTE: if not set then hitArea = PIXI.Rectangle(Viewport.left, Viewport.top, Viewport.worldScreenWidth,
   * Viewport.worldScreenHeight)
   */
  get forceHitArea() {
    return this._forceHitArea;
  }
  set forceHitArea(e) {
    e ? (this._forceHitArea = e, this.hitArea = e) : (this._forceHitArea = null, this.hitArea = new ca(0, 0, this.worldWidth, this.worldHeight));
  }
  /**
   * Enable one-finger touch to drag
   *
   * NOTE: if you expect users to use right-click dragging, you should enable `viewport.options.disableOnContextMenu`
   * to avoid the context menu popping up on each right-click drag.
   *
   * @param {IDragOptions} [options]
   * @param {string} [options.direction=all] direction to drag
   * @param {boolean} [options.pressDrag=true] whether click to drag is active
   * @param {boolean} [options.wheel=true] use wheel to scroll in direction (unless wheel plugin is active)
   * @param {number} [options.wheelScroll=1] number of pixels to scroll with each wheel spin
   * @param {boolean} [options.reverse] reverse the direction of the wheel scroll
   * @param {(boolean|string)} [options.clampWheel=false] clamp wheel(to avoid weird bounce with mouse wheel)
   * @param {string} [options.underflow=center] where to place world if too small for screen
   * @param {number} [options.factor=1] factor to multiply drag to increase the speed of movement
   * @param {string} [options.mouseButtons=all] changes which mouse buttons trigger drag, use: 'all', 'left',
   *  'right' 'middle', or some combination, like, 'middle-right'; you may want to set
   *   viewport.options.disableOnContextMenu if you want to use right-click dragging
   * @param {string[]} [options.keyToPress=null] - array containing
   *  {@link key|https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/code} codes of keys that can be
   *  pressed for the drag to be triggered, e.g.: ['ShiftLeft', 'ShiftRight'}.
   * @param {boolean} [options.ignoreKeyToPressOnTouch=false] - ignore keyToPress for touch events
   * @param {number} [options.lineHeight=20] - scaling factor for non-DOM_DELTA_PIXEL scrolling events
   * @returns {Viewport} this
   */
  drag(e) {
    return this.plugins.add("drag", new $0(this, e)), this;
  }
  /**
   * Clamp to world boundaries or other provided boundaries
   * There are three ways to clamp:
   * 1. direction: 'all' = the world is clamped to its world boundaries, ie, you cannot drag any part of offscreen
   *    direction: 'x' | 'y' = only the x or y direction is clamped to its world boundary
   * 2. left, right, top, bottom = true | number = the world is clamped to the world's pixel location for each side;
   *    if any of these are set to true, then the location is set to the boundary
   *    [0, viewport.worldWidth/viewport.worldHeight], eg: to allow the world to be completely dragged offscreen,
   *    set [-viewport.worldWidth, -viewport.worldHeight, viewport.worldWidth * 2, viewport.worldHeight * 2]
   *
   * Underflow determines what happens when the world is smaller than the viewport
   * 1. none = the world is clamped but there is no special behavior
   * 2. center = the world is centered on the viewport
   * 3. combination of top/bottom/center and left/right/center (case insensitive) = the world is stuck to the
   *     appropriate boundaries
   *
   * NOTES:
   *   clamp is disabled if called with no options; use { direction: 'all' } for all edge clamping
   *   screenWidth, screenHeight, worldWidth, and worldHeight needs to be set for this to work properly
   *
   * @param {object} [options]
   * @param {(number|boolean)} [options.left=false] - clamp left; true = 0
   * @param {(number|boolean)} [options.right=false] - clamp right; true = viewport.worldWidth
   * @param {(number|boolean)} [options.top=false] - clamp top; true = 0
   * @param {(number|boolean)} [options.bottom=false] - clamp bottom; true = viewport.worldHeight
   * @param {string} [direction] - (all, x, or y) using clamps of [0, viewport.worldWidth/viewport.worldHeight];
   *  replaces left/right/top/bottom if set
   * @param {string} [underflow=center] - where to place world if too small for screen (e.g., top-right, center,
   *  none, bottomLeft)     * @returns {Viewport} this
   */
  clamp(e) {
    return this.plugins.add("clamp", new g0(this, e)), this;
  }
  /**
   * Decelerate after a move
   *
   * NOTE: this fires 'moved' event during deceleration
   *
   * @param {IDecelerateOptions} [options]
   * @param {number} [options.friction=0.95] - percent to decelerate after movement
   * @param {number} [options.bounce=0.8] - percent to decelerate when past boundaries (only applicable when
   *   viewport.bounce() is active)
   * @param {number} [options.minSpeed=0.01] - minimum velocity before stopping/reversing acceleration
   * @return {Viewport} this
   */
  decelerate(e) {
    return this.plugins.add("decelerate", new w0(this, e)), this;
  }
  /**
   * Bounce on borders
   * NOTES:
   *    screenWidth, screenHeight, worldWidth, and worldHeight needs to be set for this to work properly
   *    fires 'moved', 'bounce-x-start', 'bounce-y-start', 'bounce-x-end', and 'bounce-y-end' events
   * @param {object} [options]
   * @param {string} [options.sides=all] - all, horizontal, vertical, or combination of top, bottom, right, left
   *  (e.g., 'top-bottom-right')
   * @param {number} [options.friction=0.5] - friction to apply to decelerate if active
   * @param {number} [options.time=150] - time in ms to finish bounce
   * @param {object} [options.bounceBox] - use this bounceBox instead of (0, 0, viewport.worldWidth, viewport.worldHeight)
   * @param {number} [options.bounceBox.x=0]
   * @param {number} [options.bounceBox.y=0]
   * @param {number} [options.bounceBox.width=viewport.worldWidth]
   * @param {number} [options.bounceBox.height=viewport.worldHeight]
   * @param {string|function} [options.ease=easeInOutSine] - ease function or name
   *  (see http://easings.net/ for supported names)
   * @param {string} [options.underflow=center] - (top/bottom/center and left/right/center, or center)
   *  where to place world if too small for screen
   * @return {Viewport} this
   */
  bounce(e) {
    return this.plugins.add("bounce", new _0(this, e)), this;
  }
  /**
   * Enable pinch to zoom and two-finger touch to drag
   *
   * @param {PinchOptions} [options]
   * @param {boolean} [options.noDrag] - disable two-finger dragging
   * @param {number} [options.percent=1] - percent to modify pinch speed
   * @param {number} [options.factor=1] - factor to multiply two-finger drag to increase the speed of movement
   * @param {PIXI.Point} [options.center] - place this point at center during zoom instead of center of two fingers
   * @param {('all'|'x'|'y')} [options.axis=all] - axis to zoom
   * @return {Viewport} this
   */
  pinch(e) {
    return this.plugins.add("pinch", new M0(this, e)), this;
  }
  /**
   * Snap to a point
   *
   * @param {number} x
   * @param {number} y
   * @param {ISnapOptions} [options]
   * @param {boolean} [options.topLeft] - snap to the top-left of viewport instead of center
   * @param {number} [options.friction=0.8] - friction/frame to apply if decelerate is active
   * @param {number} [options.time=1000] - time in ms to snap
   * @param {string|function} [options.ease=easeInOutSine] - ease function or name (see http://easings.net/
   *   for supported names)
   * @param {boolean} [options.interrupt=true] - pause snapping with any user input on the viewport
   * @param {boolean} [options.removeOnComplete] - removes this plugin after snapping is complete
   * @param {boolean} [options.removeOnInterrupt] - removes this plugin if interrupted by any user input
   * @param {boolean} [options.forceStart] - starts the snap immediately regardless of whether the viewport is at
   *   the desired location
   * @return {Viewport} this
   */
  snap(e, n, s) {
    return this.plugins.add("snap", new I0(this, e, n, s)), this;
  }
  /**
   * Follow a target
   *
   * NOTES:
   *    uses the (x, y) as the center to follow; for PIXI.Sprite to work properly, use sprite.anchor.set(0.5)
   *    options.acceleration is not perfect as it doesn't know the velocity of the target. It adds acceleration
   *    to the start of movement and deceleration to the end of movement when the target is stopped.
   *    To cancel the follow, use: `viewport.plugins.remove('follow')`
   *
   * @fires 'moved' event
   *
   * @param {PIXI.DisplayObject} target to follow
   * @param {IFollowOptions} [options]
   * @param {number} [options.speed=0] - to follow in pixels/frame (0=teleport to location)
   * @param {number} [options.acceleration] - set acceleration to accelerate and decelerate at this rate; speed
   *   cannot be 0 to use acceleration
   * @param {number} [options.radius] - radius (in world coordinates) of center circle where movement is allowed
   *   without moving the viewport     * @returns {Viewport} this
   * @returns {Viewport} this
   */
  follow(e, n) {
    return this.plugins.add("follow", new S0(this, e, n)), this;
  }
  /**
   * Zoom using mouse wheel
   *
   * NOTE: the default event listener for 'wheel' event is the options.events.domElement.
   *
   * @param {IWheelOptions} [options]
   * @param {number} [options.percent=0.1] - percent to scroll with each spin
   * @param {number} [options.smooth] - smooth the zooming by providing the number of frames to zoom between wheel spins
   * @param {boolean} [options.interrupt=true] - stop smoothing with any user input on the viewport
   * @param {boolean} [options.reverse] - reverse the direction of the scroll
   * @param {PIXI.Point} [options.center] - place this point at center during zoom instead of current mouse position
   * @param {number} [options.lineHeight=20] - scaling factor for non-DOM_DELTA_PIXEL scrolling events
   * @param {('all'|'x'|'y')} [options.axis=all] - axis to zoom
   * @return {Viewport} this
   */
  wheel(e) {
    return this.plugins.add("wheel", new L0(this, e)), this;
  }
  /**
   * Animate the position and/or scale of the viewport
   * To set the zoom level, use: (1) scale, (2) scaleX and scaleY, or (3) width and/or height
   * @param {object} options
   * @param {number} [options.time=1000] - time to animate
   * @param {PIXI.Point} [options.position=viewport.center] - position to move viewport
   * @param {number} [options.width] - desired viewport width in world pixels (use instead of scale;
   *  aspect ratio is maintained if height is not provided)
   * @param {number} [options.height] - desired viewport height in world pixels (use instead of scale;
   *  aspect ratio is maintained if width is not provided)
   * @param {number} [options.scale] - scale to change zoom (scale.x = scale.y)
   * @param {number} [options.scaleX] - independently change zoom in x-direction
   * @param {number} [options.scaleY] - independently change zoom in y-direction
   * @param {(function|string)} [options.ease=linear] - easing function to use
   * @param {function} [options.callbackOnComplete]
   * @param {boolean} [options.removeOnInterrupt] removes this plugin if interrupted by any user input
   * @returns {Viewport} this
   */
  animate(e) {
    return this.plugins.add("animate", new h0(this, e)), this;
  }
  /**
   * Enable clamping of zoom to constraints
   *
   * The minWidth/Height settings are how small the world can get (as it would appear on the screen)
   * before clamping. The maxWidth/maxHeight is how larger the world can scale (as it would appear on
   * the screen) before clamping.
   *
   * For example, if you have a world size of 1000 x 1000 and a screen size of 100 x 100, if you set
   * minWidth/Height = 100 then the world will not be able to zoom smaller than the screen size (ie,
   * zooming out so it appears smaller than the screen). Similarly, if you set maxWidth/Height = 100
   * the world will not be able to zoom larger than the screen size (ie, zooming in so it appears
   * larger than the screen).
   *
   * @param {object} [options]
   * @param {number} [options.minWidth] - minimum width
   * @param {number} [options.minHeight] - minimum height
   * @param {number} [options.maxWidth] - maximum width
   * @param {number} [options.maxHeight] - maximum height
   * @param {number} [options.minScale] - minimum scale
   * @param {number} [options.maxScale] - minimum scale
   * @return {Viewport} this
   */
  clampZoom(e) {
    return this.plugins.add("clamp-zoom", new y0(this, e)), this;
  }
  /**
   * Scroll viewport when mouse hovers near one of the edges or radius-distance from center of screen.
   *
   * NOTES: fires 'moved' event; there's a known bug where the mouseEdges does not work properly with "windowed" viewports
   *
   * @param {IMouseEdgesOptions} [options]
   * @param {number} [options.radius] - distance from center of screen in screen pixels
   * @param {number} [options.distance] - distance from all sides in screen pixels
   * @param {number} [options.top] - alternatively, set top distance (leave unset for no top scroll)
   * @param {number} [options.bottom] - alternatively, set bottom distance (leave unset for no top scroll)
   * @param {number} [options.left] - alternatively, set left distance (leave unset for no top scroll)
   * @param {number} [options.right] - alternatively, set right distance (leave unset for no top scroll)
   * @param {number} [options.speed=8] - speed in pixels/frame to scroll viewport
   * @param {boolean} [options.reverse] - reverse direction of scroll
   * @param {boolean} [options.noDecelerate] - don't use decelerate plugin even if it's installed
   * @param {boolean} [options.linear] - if using radius, use linear movement (+/- 1, +/- 1) instead of angled
   *   movement (Math.cos(angle from center), Math.sin(angle from center))
   * @param {boolean} [options.allowButtons] allows plugin to continue working even when there's a mousedown event
   */
  mouseEdges(e) {
    return this.plugins.add("mouse-edges", new C0(this, e)), this;
  }
  /** Pause viewport (including animation updates such as decelerate) */
  get pause() {
    return !!this._pause;
  }
  set pause(e) {
    this._pause = e, this.lastViewport = null, this.moving = !1, this.zooming = !1, e && this.input.pause();
  }
  /**
   * Move the viewport so the bounding box is visible
   *
   * @param x - left
   * @param y - top
   * @param width
   * @param height
   * @param resizeToFit - Resize the viewport so the box fits within the viewport
   */
  ensureVisible(e, n, s, o, a) {
    a && (s > this.worldScreenWidth || o > this.worldScreenHeight) && (this.fit(!0, s, o), this.emit("zoomed", { viewport: this, type: "ensureVisible" }));
    let i = !1;
    e < this.left ? (this.left = e, i = !0) : e + s > this.right && (this.right = e + s, i = !0), n < this.top ? (this.top = n, i = !0) : n + o > this.bottom && (this.bottom = n + o, i = !0), i && this.emit("moved", { viewport: this, type: "ensureVisible" });
  }
};
/*! Fast Average Color | © 2025 Denis Seleznev | MIT License | https://github.com/fast-average-color/fast-average-color */
function U0(t) {
  var e = t.toString(16);
  return e.length === 1 ? "0" + e : e;
}
function Lu(t) {
  return "#" + t.map(U0).join("");
}
function F0(t) {
  var e = (t[0] * 299 + t[1] * 587 + t[2] * 114) / 1e3;
  return e < 128;
}
function B0(t) {
  return t ? q0(t) ? t : [t] : [];
}
function q0(t) {
  return Array.isArray(t[0]);
}
function bl(t, e, n) {
  for (var s = 0; s < n.length; s++)
    if (H0(t, e, n[s]))
      return !0;
  return !1;
}
function H0(t, e, n) {
  switch (n.length) {
    case 3:
      if (W0(t, e, n))
        return !0;
      break;
    case 4:
      if (G0(t, e, n))
        return !0;
      break;
    case 5:
      if (Z0(t, e, n))
        return !0;
      break;
    default:
      return !1;
  }
}
function W0(t, e, n) {
  return t[e + 3] !== 255 || t[e] === n[0] && t[e + 1] === n[1] && t[e + 2] === n[2];
}
function G0(t, e, n) {
  return t[e + 3] && n[3] ? t[e] === n[0] && t[e + 1] === n[1] && t[e + 2] === n[2] && t[e + 3] === n[3] : t[e + 3] === n[3];
}
function aa(t, e, n) {
  return t >= e - n && t <= e + n;
}
function Z0(t, e, n) {
  var s = n[0], o = n[1], a = n[2], i = n[3], r = n[4], c = t[e + 3], u = aa(c, i, r);
  return i ? !!(!c && u || aa(t[e], s, r) && aa(t[e + 1], o, r) && aa(t[e + 2], a, r) && u) : u;
}
var K0 = 24;
function X0(t, e, n) {
  for (var s = {}, o = n.dominantDivider || K0, a = n.ignoredColor, i = n.step, r = [0, 0, 0, 0, 0], c = 0; c < e; c += i) {
    var u = t[c], d = t[c + 1], m = t[c + 2], _ = t[c + 3];
    if (!(a && bl(t, c, a))) {
      var g = Math.round(u / o) + "," + Math.round(d / o) + "," + Math.round(m / o);
      s[g] ? s[g] = [
        s[g][0] + u * _,
        s[g][1] + d * _,
        s[g][2] + m * _,
        s[g][3] + _,
        s[g][4] + 1
      ] : s[g] = [u * _, d * _, m * _, _, 1], r[4] < s[g][4] && (r = s[g]);
    }
  }
  var v = r[0], z = r[1], h = r[2], y = r[3], w = r[4];
  return y ? [
    Math.round(v / y),
    Math.round(z / y),
    Math.round(h / y),
    Math.round(y / w)
  ] : n.defaultColor;
}
function Q0(t, e, n) {
  for (var s = 0, o = 0, a = 0, i = 0, r = 0, c = n.ignoredColor, u = n.step, d = 0; d < e; d += u) {
    var m = t[d + 3], _ = t[d] * m, g = t[d + 1] * m, v = t[d + 2] * m;
    c && bl(t, d, c) || (s += _, o += g, a += v, i += m, r++);
  }
  return i ? [
    Math.round(s / i),
    Math.round(o / i),
    Math.round(a / i),
    Math.round(i / r)
  ] : n.defaultColor;
}
function J0(t, e, n) {
  for (var s = 0, o = 0, a = 0, i = 0, r = 0, c = n.ignoredColor, u = n.step, d = 0; d < e; d += u) {
    var m = t[d], _ = t[d + 1], g = t[d + 2], v = t[d + 3];
    c && bl(t, d, c) || (s += m * m * v, o += _ * _ * v, a += g * g * v, i += v, r++);
  }
  return i ? [
    Math.round(Math.sqrt(s / i)),
    Math.round(Math.sqrt(o / i)),
    Math.round(Math.sqrt(a / i)),
    Math.round(i / r)
  ] : n.defaultColor;
}
function Du(t) {
  return uo(t, "defaultColor", [0, 0, 0, 0]);
}
function uo(t, e, n) {
  return t[e] === void 0 ? n : t[e];
}
var ju = 10, Kr = 100;
function Y0(t) {
  return t.search(/\.svg(\?|$)/i) !== -1;
}
function ey(t) {
  if (Up(t)) {
    var e = t.naturalWidth, n = t.naturalHeight;
    return !t.naturalWidth && Y0(t.src) && (e = n = Kr), {
      width: e,
      height: n
    };
  }
  return ny(t) ? {
    width: t.videoWidth,
    height: t.videoHeight
  } : Bp(t) ? {
    width: t.codedWidth,
    height: t.codedHeight
  } : {
    width: t.width,
    height: t.height
  };
}
function Nu(t) {
  return sy(t) ? "canvas" : ty(t) ? "offscreencanvas" : Bp(t) ? "videoframe" : oy(t) ? "imagebitmap" : t.src;
}
function Up(t) {
  return typeof HTMLImageElement < "u" && t instanceof HTMLImageElement;
}
var Fp = typeof OffscreenCanvas < "u";
function ty(t) {
  return Fp && t instanceof OffscreenCanvas;
}
function ny(t) {
  return typeof HTMLVideoElement < "u" && t instanceof HTMLVideoElement;
}
function Bp(t) {
  return typeof VideoFrame < "u" && t instanceof VideoFrame;
}
function sy(t) {
  return typeof HTMLCanvasElement < "u" && t instanceof HTMLCanvasElement;
}
function oy(t) {
  return typeof ImageBitmap < "u" && t instanceof ImageBitmap;
}
function ay(t, e) {
  var n = uo(e, "left", 0), s = uo(e, "top", 0), o = uo(e, "width", t.width), a = uo(e, "height", t.height), i = o, r = a;
  if (e.mode === "precision")
    return {
      srcLeft: n,
      srcTop: s,
      srcWidth: o,
      srcHeight: a,
      destWidth: i,
      destHeight: r
    };
  var c;
  return o > a ? (c = o / a, i = Kr, r = Math.round(i / c)) : (c = a / o, r = Kr, i = Math.round(r / c)), (i > o || r > a || i < ju || r < ju) && (i = o, r = a), {
    srcLeft: n,
    srcTop: s,
    srcWidth: o,
    srcHeight: a,
    destWidth: i,
    destHeight: r
  };
}
var iy = typeof window > "u";
function ry() {
  return iy ? Fp ? new OffscreenCanvas(1, 1) : null : document.createElement("canvas");
}
var ly = "FastAverageColor: ";
function xn(t) {
  return Error(ly + t);
}
function ro(t, e) {
  e || console.error(t);
}
var cy = (
  /** @class */
  (function() {
    function t() {
      this.canvas = null, this.ctx = null;
    }
    return t.prototype.getColorAsync = function(e, n) {
      if (!e)
        return Promise.reject(xn("call .getColorAsync() without resource"));
      if (typeof e == "string") {
        if (typeof Image > "u")
          return Promise.reject(xn("resource as string is not supported in this environment"));
        var s = new Image();
        return s.crossOrigin = n && n.crossOrigin || "", s.src = e, this.bindImageEvents(s, n);
      } else {
        if (Up(e) && !e.complete)
          return this.bindImageEvents(e, n);
        var o = this.getColor(e, n);
        return o.error ? Promise.reject(o.error) : Promise.resolve(o);
      }
    }, t.prototype.getColor = function(e, n) {
      n = n || {};
      var s = Du(n);
      if (!e) {
        var o = xn("call .getColor() without resource");
        return ro(o, n.silent), this.prepareResult(s, o);
      }
      var a = ey(e), i = ay(a, n);
      if (!i.srcWidth || !i.srcHeight || !i.destWidth || !i.destHeight) {
        var o = xn('incorrect sizes for resource "'.concat(Nu(e), '"'));
        return ro(o, n.silent), this.prepareResult(s, o);
      }
      if (!this.canvas && (this.canvas = ry(), !this.canvas)) {
        var o = xn("OffscreenCanvas is not supported in this browser");
        return ro(o, n.silent), this.prepareResult(s, o);
      }
      if (!this.ctx) {
        if (this.ctx = this.canvas.getContext("2d", { willReadFrequently: !0 }), !this.ctx) {
          var o = xn("Canvas Context 2D is not supported in this browser");
          return ro(o, n.silent), this.prepareResult(s);
        }
        this.ctx.imageSmoothingEnabled = !1;
      }
      this.canvas.width = i.destWidth, this.canvas.height = i.destHeight;
      try {
        this.ctx.clearRect(0, 0, i.destWidth, i.destHeight), this.ctx.drawImage(e, i.srcLeft, i.srcTop, i.srcWidth, i.srcHeight, 0, 0, i.destWidth, i.destHeight);
        var r = this.ctx.getImageData(0, 0, i.destWidth, i.destHeight).data;
        return this.prepareResult(this.getColorFromArray4(r, n));
      } catch (c) {
        var o = xn("security error (CORS) for resource ".concat(Nu(e), `.
Details: https://developer.mozilla.org/en/docs/Web/HTML/CORS_enabled_image`));
        return ro(o, n.silent), n.silent || console.error(c), this.prepareResult(s, o);
      }
    }, t.prototype.getColorFromArray4 = function(e, n) {
      n = n || {};
      var s = 4, o = e.length, a = Du(n);
      if (o < s)
        return a;
      var i = o - o % s, r = (n.step || 1) * s, c;
      switch (n.algorithm || "sqrt") {
        case "simple":
          c = Q0;
          break;
        case "sqrt":
          c = J0;
          break;
        case "dominant":
          c = X0;
          break;
        default:
          throw xn("".concat(n.algorithm, " is unknown algorithm"));
      }
      return c(e, i, {
        defaultColor: a,
        ignoredColor: B0(n.ignoredColor),
        step: r,
        dominantDivider: n.dominantDivider
      });
    }, t.prototype.prepareResult = function(e, n) {
      var s = e.slice(0, 3), o = [e[0], e[1], e[2], e[3] / 255], a = F0(e);
      return {
        value: [e[0], e[1], e[2], e[3]],
        rgb: "rgb(" + s.join(",") + ")",
        rgba: "rgba(" + o.join(",") + ")",
        hex: Lu(s),
        hexa: Lu(e),
        isDark: a,
        isLight: !a,
        error: n
      };
    }, t.prototype.destroy = function() {
      this.canvas && (this.canvas.width = 1, this.canvas.height = 1, this.canvas = null), this.ctx = null;
    }, t.prototype.bindImageEvents = function(e, n) {
      var s = this;
      return new Promise(function(o, a) {
        var i = function() {
          u();
          var d = s.getColor(e, n);
          d.error ? a(d.error) : o(d);
        }, r = function() {
          u(), a(xn('Error loading image "'.concat(e.src, '"')));
        }, c = function() {
          u(), a(xn('Image "'.concat(e.src, '" loading aborted')));
        }, u = function() {
          e.removeEventListener("load", i), e.removeEventListener("error", r), e.removeEventListener("abort", c);
        };
        e.addEventListener("load", i), e.addEventListener("error", r), e.addEventListener("abort", c);
      });
    }, t;
  })()
), uy = Object.defineProperty, dy = (t, e, n) => e in t ? uy(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, rn = (t, e, n) => dy(t, typeof e != "symbol" ? e + "" : e, n);
const wl = st("designer-core.apiClient", () => {
  const t = N(), e = N("2024-07-15"), n = N(), s = N(rp());
  return { acceptLanguage: n, apiVersion: e, baseUrl: t, sessionId: s };
});
function py() {
  const { acceptLanguage: t, apiVersion: e, baseUrl: n, sessionId: s } = D(wl());
  return {
    beforeRequest: (o) => ({
      ...o,
      headers: {
        // eslint-disable-next-line @typescript-eslint/no-misused-spread
        ...o.headers,
        "Accept-Language": t.value,
        "X-Api-Version": e.value,
        "X-Tab-Session-Id": s.value
      },
      prefixUrl: n.value,
      timeout: 3e4
    }),
    enabled: A(() => !!(n.value && t.value)),
    key: [n, e, t]
  };
}
let Xr;
function my(t) {
  Xr = t;
}
const xl = tp(
  {
    headers: { "Content-Type": "application/json" },
    onValidationError: (t) => Xr == null ? void 0 : Xr(t)
  },
  [py]
), hy = xl.mutation(
  ({ token: t, userExternalIdentifier: e }) => ({
    headers: { "X-Designer-Token": t },
    json: {
      designer_token: t,
      external_identifier: e
    },
    method: "post",
    url: "auth/login"
  }),
  {
    input: B({
      token: U(),
      userExternalIdentifier: U()
    }),
    output: B({
      expire_date: O(),
      token_string: U(),
      user_id: O()
    })
  }
), fy = xl.mutation(
  (t) => ({
    headers: { Authorization: `Bearer ${t}` },
    method: "post",
    url: "auth/token/refresh"
  }),
  {
    input: U(),
    output: B({
      expire_date: O(),
      token_string: U(),
      user_id: O()
    })
  }
), _y = vt({ refresh: fy }), vy = vt({ login: hy, token: _y }), To = st("designer-core.token", () => {
  const t = N(), e = N(), n = N(), s = N(!1), {
    data: o,
    error: a,
    mutate: i,
    reset: r
  } = yt(ce.auth.login.use()), c = N();
  re(() => {
    o.value && (c.value = o.value);
  });
  const {
    data: u,
    error: d,
    mutate: m,
    reset: _
  } = yt(ce.auth.token.refresh.use()), g = N();
  re(() => {
    u.value && (g.value = u.value);
  });
  const v = A(
    () => t.value ?? g.value ?? c.value
  );
  function z() {
    e.value = void 0, c.value = void 0, g.value = void 0, r(), _();
  }
  re(() => {
    !e.value || t.value || (n.value ? i({
      token: e.value,
      userExternalIdentifier: n.value
    }) : m(e.value));
  }), re(() => {
    !a.value || !e.value || t.value || m(e.value);
  });
  const { idle: h } = cd(1440 * 60 * 1e3);
  return re(() => {
    !d.value && !h.value || t.value || (s.value = !0, z());
  }), re((y) => {
    if (!v.value || t.value) return;
    s.value = !1;
    const w = setTimeout(
      () => {
        if (!v.value) throw new Error("tokenData not set");
        m(v.value.token_string);
      },
      v.value.expire_date * 1e3 - 60 * 1e3 - Date.now()
    );
    y(() => {
      clearTimeout(w);
    });
  }), {
    initialToken: e,
    isSessionExpired: Tn(s),
    logout: z,
    manualTokenData: t,
    tokenData: v,
    userExternalIdentifier: n
  };
}), qp = xl.use(() => {
  const { tokenData: t, userExternalIdentifier: e } = D(To());
  return {
    beforeRequest: (n) => ({
      ...n,
      headers: {
        // eslint-disable-next-line @typescript-eslint/no-misused-spread
        ...n.headers,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        Authorization: `Bearer ${t.value.token_string}`,
        "X-App-User": e.value
      }
    }),
    enabled: A(() => {
      var n;
      return !!((n = t.value) != null && n.token_string);
    }),
    key: A(() => {
      var n;
      return (n = t.value) == null ? void 0 : n.user_id;
    })
  };
}), We = qp;
var Cs = /* @__PURE__ */ ((t) => (t.Black = "Black", t.BlackItalic = "Black Italic", t.Bold = "Bold", t.BoldItalic = "Bold Italic", t.DemiBold = "Demi Bold", t.DemiBoldItalic = "Demi Bold Italic", t.Italic = "Italic", t.Light = "Light", t.Medium = "Medium", t.Normal = "Normal", t.Regular = "Regular", t))(Cs || {});
const gy = B({
  id: O(),
  description: U(),
  display_name: U(),
  handle: U(),
  is_digitizable: Wt(),
  is_using_color_picker: Wt(),
  preview_url: U(),
  production_type: B({
    id: O(),
    handle: U()
  })
}), ky = B({
  id: O(),
  code: U(),
  custom_attributes: U().array().nullable()
}), yy = B({
  id: O(),
  name: U(),
  code: U(),
  thickness: U().nullable()
}), xr = B({
  id: O(),
  blue: O(),
  display_name: U(),
  external_identifier: U().nullable(),
  green: O(),
  is_customer_logo_color: Wt(),
  is_standard: Wt(),
  production_methods: B({ id: O() }).array(),
  red: O()
}), Hp = _l("color_details_type", [
  B({
    color_details: ky,
    color_details_type: at("manual-color-details")
  }).merge(xr),
  B({
    color_details: yy,
    color_details_type: at("embroidery-color-details")
  }).merge(xr),
  B({ color_details: bo(), color_details_type: bo() }).merge(xr)
]), by = B({
  id: O(),
  name: U(),
  display_name: U(),
  family_name: U(),
  font_url: U().nullable(),
  group_handle: U(),
  letter_case_set: Kn([
    at("upper-and-lowercase"),
    at("only-uppercase")
  ]),
  max: O(),
  min: O(),
  preview_url: U().nullable(),
  production_methods: B({ id: O() }).array(),
  style: un(Cs)
}), wy = We.query(() => ({ url: "configurations/app" }), {
  output: B({
    colors: Hp.array(),
    fonts: by.array(),
    productionMethods: gy.array()
  })
}), xy = vt({ get: wy }), $y = B({
  id: O(),
  customer_upload: B({
    allowed_logo_file_types: rt(U()),
    dpi: O(),
    max_file_size_mb: O(),
    min_dimension: O()
  }).nullable(),
  description: U(),
  display_name: U(),
  handle: U(),
  is_digitizable: Wt(),
  is_using_color_picker: Wt(),
  preview_url: U(),
  production_type: B({
    id: O(),
    handle: U()
  })
}), zy = We.query(
  () => ({ url: "configurations/designer" }),
  {
    output: B({
      settings: B({
        attributes: B({
          company_name: U().nullable(),
          phone: U().nullable()
        }),
        is_internal: Wt(),
        production_methods: $y.array().optional(),
        // for now optional as not online available
        settings: B({
          customization_positioning_mode: U(),
          include_tax: Wt(),
          locale: U(),
          units: B({
            currency: U(),
            length: U()
          })
        })
      })
    })
  }
), Sy = vt({ get: zy }), Ay = vt({ app: xy, designer: Sy }), Cy = We.query(
  (t) => ({ searchParams: { filter: t }, url: "customer-logos/count" }),
  {
    input: B({ production_method: rt(O()) }).partial().optional(),
    output: O(),
    responseTransformer: async (t) => (await t.json()).count
  }
);
function Io(t) {
  return B({
    data: t.array(),
    links: B({
      first: U().nullable(),
      last: U().nullable(),
      next: U().nullable(),
      prev: U().nullable()
    }),
    meta: B({
      next_cursor: U().nullable(),
      path: U(),
      per_page: O(),
      prev_cursor: U().nullable()
    })
  });
}
var Fs = /* @__PURE__ */ ((t) => (t.INNER = "inner", t.OUTER = "outer", t))(Fs || {}), ks = /* @__PURE__ */ ((t) => (t.BOTTOM_CENTER = "bc", t.BOTTOM_LEFT = "bl", t.BOTTOM_RIGHT = "br", t.LEFT_BOTTOM = "lb", t.LEFT_CENTER = "lc", t.LEFT_TOP = "lt", t.RIGHT_BOTTOM = "rb", t.RIGHT_CENTER = "rc", t.RIGHT_TOP = "rt", t.TOP_CENTER = "tc", t.TOP_LEFT = "tl", t.TOP_RIGHT = "tr", t))(ks || {});
const $l = B({
  id: O(),
  name: U(),
  base_logo_id: O().nullable(),
  color_assignments: B({
    id: O(),
    apply_to: at("fill"),
    blue: O(),
    color: Hp.nullable(),
    created_at: U().datetime({ offset: !0 }),
    green: O(),
    is_color_picker: Wt().nullable(),
    red: O(),
    updated_at: U().datetime({ offset: !0 })
  }).array(),
  created_at: U().datetime({ offset: !0 }),
  design_settings: B({
    next_element_alignment: B({
      anchor_type: at(Fs.OUTER),
      anchor_value: un(ks),
      offset: B({ x: O(), y: O() }),
      rotation: O()
    })
  }),
  external_identifier: U().nullable(),
  height: O().nullable(),
  is_customer_logo: Wt(),
  is_editable: Wt(),
  is_scaleable: Wt(),
  max_height: O().nullable(),
  max_width: O().nullable(),
  min_height: O().nullable(),
  min_width: O().nullable(),
  preview_url: U().nullable(),
  production_method: B({ id: O() }),
  production_type: B({ id: O() }),
  texts: rg().array(),
  updated_at: U().datetime({ offset: !0 }),
  width: O().nullable()
}), Py = We.query(
  (t) => ({ url: `logos/${t.toString()}` }),
  {
    input: O(),
    output: $l
  }
), zl = B({
  id: O(),
  name: U().nullable(),
  created_at: U().datetime({ offset: !0 }),
  logo: $l,
  updated_at: U().datetime({ offset: !0 })
}), My = We.infiniteQuery(
  (t, e) => ({
    searchParams: { cursor: e, filter: t },
    url: "customer-logos"
  }),
  {
    getNextPageParam: (t) => t.meta.next_cursor,
    // eslint-disable-next-line unicorn/no-null
    initialPageParam: null,
    input: B({ production_method: rt(O()) }).partial().optional(),
    onSuccess: ({ output: t }) => {
      const e = lt();
      for (const n of t.data) {
        e.setQueryData(
          ce.customerLogos.get.getQueryKey(n.id),
          n
        );
        const s = n.logo;
        e.setQueryData(
          ce.logos.get.getQueryKey(s.id),
          s
        );
      }
    },
    output: Io(zl)
  }
), Ty = We.query(
  (t) => ({
    url: `customer-logos/${t.toString()}`
  }),
  {
    input: O(),
    onSuccess: ({ output: t }) => {
      const e = lt(), n = t.logo;
      e.setQueryData(
        ce.logos.get.getQueryKey(n.id),
        n
      );
    },
    output: zl
  }
);
function Iy(t, e) {
  if (e && e.pages[0])
    return {
      ...e,
      pages: [
        {
          ...e.pages[0],
          data: [t, ...e.pages[0].data]
        },
        ...e.pages.slice(1)
      ]
    };
}
function Wp({ id: t, name: e }, n) {
  if (n)
    return {
      ...n,
      pages: n.pages.map((s) => ({
        ...s,
        data: s.data.map(
          (o) => o.id === t ? {
            ...o,
            name: e
          } : o
        )
      }))
    };
}
const Ey = We.mutation(
  (t) => ({
    json: { ...t, id: void 0 },
    method: "patch",
    url: `customer-logos/${t.id.toString()}`
  }),
  {
    input: B({ id: O(), name: U() }),
    onSuccess: ({ output: t }) => {
      lt().setQueriesData(
        { queryKey: ce.customerLogos.list.getQueryKey() },
        (e) => Wp(t, e)
      );
    },
    output: zl
  }
), Oy = We.mutation(
  ({ path: t, production_method_id: e }) => ({
    json: {
      path: t,
      production_method: {
        id: e
      }
    },
    method: "post",
    url: "customer-logos"
  }),
  {
    input: B({ path: U(), production_method_id: O() }),
    output: O(),
    responseTransformer: async (t) => {
      const e = await t;
      return Number.parseInt(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        e.headers.get("x-identifier")
      );
    }
  }
), Ry = We.mutation(
  (t) => ({
    json: t,
    method: "post",
    url: "customer-logos/temporary-upload-url"
  }),
  {
    input: B({ content_type: U(), file_name: U() }),
    output: B({
      path: U(),
      url: U()
    })
  }
), Ly = vt({
  count: Cy,
  get: Ty,
  list: My,
  patch: Ey,
  post: Oy,
  temporaryUploadUrl: Ry
}), Dy = We.query(
  (t) => ({ searchParams: { filter: t }, url: "designs/favored/count" }),
  {
    input: B({ production_method: rt(O()) }).partial().optional(),
    output: O(),
    responseTransformer: async (t) => (await t.json()).count
  }
);
function Gp(t, e) {
  if (e) {
    if (e.pages.some(
      (n) => n.data.some((s) => s.id === t.id)
    )) {
      Sl(t, e);
      return;
    }
    if (e.pages[0])
      return {
        ...e,
        pages: [
          {
            ...e.pages[0],
            data: [t, ...e.pages[0].data]
          },
          ...e.pages.slice(1)
        ]
      };
  }
}
function Zp(t, e) {
  if (e)
    return {
      ...e,
      pages: e.pages.map((n) => ({
        ...n,
        data: n.data.filter((s) => s.id !== t)
      }))
    };
}
function Sl({ id: t, name: e }, n) {
  if (n)
    return {
      ...n,
      pages: n.pages.map((s) => ({
        ...s,
        data: s.data.map(
          (o) => o.id === t ? {
            ...o,
            name: e
          } : o
        )
      }))
    };
}
const jy = We.mutation(
  (t) => ({ method: "delete", url: `designs/favored/${t.toString()}` }),
  {
    input: O(),
    onSuccess: ({ input: t }) => {
      const e = lt();
      e.setQueriesData(
        { queryKey: ce.designs.favored.list.getQueryKey() },
        (n) => Zp(t, n)
      ), e.invalidateQueries({
        queryKey: ce.designs.favored.count.getQueryKey()
      });
    },
    output: B({ message: U() })
  }
);
var us = /* @__PURE__ */ ((t) => (t.CENTER = "center", t.LEFT = "left", t.RIGHT = "right", t))(us || {});
const Kp = Kn([
  B({
    id: O(),
    color: B({
      id: O()
    })
  }),
  B({
    id: O(),
    blue: O(),
    color: bo().optional(),
    green: O(),
    red: O()
  })
]), Ny = B({
  dimension: B({ height: O(), width: O() }).optional(),
  resource: B({
    id: O(),
    name: U(),
    color_assignments: Kp.array(),
    created_at: U().datetime({ offset: !0 }),
    design_settings: B({
      next_element_alignment: B({
        anchor_type: at(Fs.OUTER),
        anchor_value: un(ks),
        offset: B({ x: O(), y: O() }),
        rotation: O()
      })
    }),
    external_identifier: U().nullable(),
    height: O(),
    is_customer_logo: Wt(),
    max_height: O(),
    max_width: O(),
    min_height: O(),
    min_width: O(),
    origin: Kn([
      at("merchant-upload"),
      at("customer-upload"),
      at("customer-logo")
    ]),
    preview_url: U().nullable(),
    production_method: B({ id: O() }),
    production_type: B({ id: O(), handle: U() }),
    updated_at: U().datetime({ offset: !0 }),
    width: O()
  }),
  resource_type: at("logo")
}), Vy = B({
  resource: B({
    lines: rt(
      B({
        bending_radius: O(),
        color_assignments: Xn([Kp]),
        font: B({ id: O() }),
        font_size: O(),
        horizontal_alignment: un(us),
        offset: O(),
        order_column: O(),
        padding_bottom: O(),
        value: U()
      })
    ),
    preview_url: U().nullable(),
    production_method: B({ id: O() })
  }),
  resource_type: at("text")
}), Uy = B({ elements: rt(vl(() => Fy)) }), Xp = _l("resource_type", [
  Ny,
  Vy
]).and(Uy), Fy = Xp.and(
  B({
    alignment: B({
      anchor_type: at(Fs.OUTER),
      anchor_value: un(ks),
      offset: B({ x: O(), y: O() })
    })
  })
), Eo = B({
  id: O(),
  name: U().nullable(),
  created_at: U().datetime({ offset: !0 }),
  elements: Xn([Xp]),
  height: O(),
  preview_url: U(),
  production_method: B({ id: O() }),
  updated_at: U().datetime({ offset: !0 }),
  width: O()
}), By = We.query(
  (t) => ({ url: `designs/favored/${t.toString()}` }),
  {
    input: O(),
    output: Eo
  }
), qy = We.infiniteQuery(
  (t, e) => ({
    searchParams: { cursor: e, filter: t },
    url: "designs/favored"
  }),
  {
    getNextPageParam: (t) => t.meta.next_cursor,
    // eslint-disable-next-line unicorn/no-null
    initialPageParam: null,
    input: B({ production_method: rt(O()) }).partial().optional(),
    onSuccess: ({ output: t }) => {
      const e = lt();
      for (const n of t.data)
        e.setQueryData(
          ce.designs.favored.get.getQueryKey(n.id),
          n
        );
    },
    output: Io(Eo)
  }
), Hy = We.mutation(
  ({ id: t, name: e }) => ({
    json: { name: e },
    method: "patch",
    url: `designs/favored/${t.toString()}`
  }),
  {
    input: B({ id: O(), name: U() }),
    onSuccess: ({ output: t }) => {
      lt().setQueriesData(
        { queryKey: ce.designs.favored.list.getQueryKey() },
        (e) => Sl(t, e)
      );
    },
    output: Eo
  }
), Wy = B({
  dimension: B({ height: O(), width: O() }).optional(),
  resource: B({
    id: O(),
    color_assignments: Kn([
      B({
        id: O(),
        color: B({
          id: O()
        })
      }),
      B({
        id: O(),
        blue: O(),
        color: bo().optional(),
        green: O(),
        red: O()
      })
    ]).array(),
    production_method: B({ id: O() })
  }),
  resource_type: at("logo")
}), Gy = B({
  resource: B({
    lines: rt(
      B({
        bending_radius: O(),
        color_assignments: Xn([
          Kn([
            B({
              color: B({
                id: O()
              })
            }),
            B({
              blue: O(),
              color: bo().optional(),
              green: O(),
              red: O()
            })
          ])
        ]),
        font: B({ id: O() }),
        font_size: O(),
        horizontal_alignment: un(us),
        offset: O(),
        order_column: O(),
        padding_bottom: O(),
        value: U()
      })
    ),
    production_method: B({ id: O() })
  }),
  resource_type: at("text")
}), Zy = B({ elements: rt(vl(() => Ky)) }), Bs = _l("resource_type", [
  Wy,
  Gy
]).and(Zy), Ky = Bs.and(
  B({
    alignment: B({
      anchor_type: at(Fs.OUTER),
      anchor_value: un(ks),
      offset: B({ x: O(), y: O() }),
      rotation: O()
    })
  })
), Xy = qp.query(
  (t) => ({ json: t, method: "post", url: "designs/preview" }),
  {
    input: B({
      elements: Xn([Bs]),
      production_method: B({ id: O() })
    }),
    output: B({
      content: U(),
      height: O(),
      width: O()
    })
  }
), Qy = We.mutation(
  (t) => ({ json: t, method: "post", url: "designs/favored" }),
  {
    input: B({
      name: U().optional(),
      elements: Xn([Bs]),
      production_method: B({ id: O() })
    }),
    onSuccess: ({ input: t, output: e }) => {
      const n = lt();
      n.setQueriesData(
        {
          queryKey: ce.designs.favored.list.getQueryKey({
            production_method: [e.production_method.id]
          })
        },
        (s) => Gp(e, s)
      ), n.invalidateQueries({
        queryKey: ce.designs.favored.count.getQueryKey({
          production_method: [t.production_method.id]
        })
      });
    },
    output: Eo
  }
), Jy = vt({
  count: Dy,
  delete: jy,
  get: By,
  list: qy,
  patch: Hy,
  post: Qy
}), Yy = vt({ favored: Jy, preview: Xy });
function Qp() {
  const t = lt(), e = ce.favorites.variants.list.getQueryKey(), n = ce.designs.favored.list.getQueryKey();
  function s(o) {
    t.setQueriesData(
      {
        queryKey: e
      },
      (a) => {
        if (a)
          return {
            ...a,
            pages: a.pages.map((i) => ({
              ...i,
              data: i.data.filter(
                (r) => r.id !== o
              )
            }))
          };
      }
    ), t.setQueriesData(
      {
        queryKey: n
      },
      (a) => {
        if (a)
          return {
            ...a,
            pages: a.pages.map((i) => ({
              ...i,
              data: i.data.filter(
                (r) => r.id !== o
              )
            }))
          };
      }
    );
  }
  return {
    deleteFavorite: s
  };
}
const e2 = We.mutation(
  (t) => ({ method: "delete", url: `favorites/${t.toString()}` }),
  {
    input: O(),
    onSuccess: ({ input: t }) => {
      const { deleteFavorite: e } = Qp();
      e(t);
    }
  }
), Jp = Kn([
  at("merchant-sketch"),
  at("customer-sketch"),
  at("ordered")
]);
var qs = /* @__PURE__ */ ((t) => (t.BOTTOM_CENTER = "bc", t.BOTTOM_LEFT = "bl", t.BOTTOM_RIGHT = "br", t.CENTER_CENTER = "cc", t.CENTER_LEFT = "cl", t.CENTER_RIGHT = "cr", t.TOP_CENTER = "tc", t.TOP_LEFT = "tl", t.TOP_RIGHT = "tr", t))(qs || {});
function t2(t) {
  switch (t) {
    case 0:
      return "tc";
    case 45:
      return "tr";
    case 90:
      return "cr";
    case 135:
      return "br";
    case 180:
      return "bc";
    case 225:
      return "bl";
    case 270:
      return "cl";
    case 315:
      return "tl";
    default:
      return;
  }
}
function Rs(t) {
  switch (t) {
    case "b":
    case "r":
      return 1;
    case "c":
      return 0.5;
    default:
      return 0;
  }
}
function n2(t) {
  switch (t) {
    case "bc":
      return 180;
    case "bl":
      return 225;
    case "br":
      return 135;
    case "cl":
      return 270;
    case "cr":
      return 90;
    case "tc":
      return 0;
    case "tl":
      return 315;
    case "tr":
      return 45;
    default:
      return;
  }
}
const Yp = B({
  id: O(),
  description: U(),
  display_name: U(),
  handle: U(),
  preview_url: U(),
  production_type: B({ id: O(), handle: U() })
}), s2 = B({
  id: O(),
  name: U(),
  handle: U()
}), Vu = B({
  id: O(),
  annotations: B({
    id: O(),
    created_at: U(),
    description: U(),
    handle: U(),
    updated_at: U()
  }).array(),
  blacklisted_variants: O().array(),
  direction: O(),
  localized_height: O(),
  localized_width: O(),
  order_column: O(),
  position: un(qs),
  positioning_area_identifier: s2.nullable(),
  positioning_area_identifier_handle: U().nullable(),
  production_method: Yp,
  rotation: O(),
  view_type_handle: U(),
  x: O(),
  y: O()
}), o2 = B({
  customizations: B({
    id: O(),
    background_color: U(),
    calculation_type: U(),
    calculation_value: O(),
    created_at: U().datetime({ offset: !0 }),
    design: Eo,
    hash: U(),
    height: O(),
    order: O(),
    position: un(qs),
    positioningArea: Vu,
    price: U(),
    rotation: O(),
    updated_at: U().datetime({ offset: !0 }),
    width: O(),
    x: O(),
    y: O()
  }).array(),
  display_name: U(),
  handle: U(),
  image_urls: B({
    md: U(),
    sm: U(),
    xl: U()
  }),
  long_display_name: U(),
  mockup_urls: B({
    md: U().nullable(),
    sm: U().nullable(),
    xl: U().nullable()
  }),
  positioning_areas: Vu.array(),
  production_areas: B({
    id: O(),
    points: B({ x: O(), y: O() }).array(),
    production_method: Yp,
    view_type_handle: U()
  }).array(),
  scalefactor: O(),
  short_display_name: U()
}), Ja = B({
  id: O(),
  name: U(),
  attributes: B({
    name: Kn([at("color"), at("size")]),
    handle: U(),
    value: U()
  }).array(),
  base: B({
    id: O(),
    external_identifier: U().nullable()
  }),
  collection_name: Kn([at("custom"), at("catalogue")]),
  created_at: U().datetime({ offset: !0 }),
  external_identifier: U().nullable(),
  id_hash: U(),
  origin: B({
    code: U(),
    external_identifier: U().nullable()
  }),
  product_id: O(),
  state: U(),
  updated_at: U().datetime({ offset: !0 }),
  views: o2.array()
}), a2 = We.query(
  (t) => ({ url: `variants/cached/variant-id/${t.toString()}` }),
  {
    input: O(),
    onSuccess: ({ output: t }) => {
      const e = lt();
      for (const n of t.views)
        for (const { design: s } of n.customizations)
          e.setQueryData(
            ce.designs.favored.get.getQueryKey(s.id),
            s
          );
    },
    output: Ja
  }
), em = B({
  id: O(),
  collection_name: Jp,
  created_at: U(),
  filter_date: U(),
  id_hash: U(),
  is_active: Wt(),
  resource: Ja,
  resource_type: at("variant"),
  updated_at: U()
}), i2 = We.query(
  (t) => ({ url: `favorites/variants/${t.toString()}` }),
  {
    input: O(),
    onSuccess: ({ output: t }) => {
      const e = lt();
      e.setQueryData(
        ce.variants.get.getQueryKey(t.resource.id),
        t.resource
      ), t.resource.external_identifier && e.setQueryData(
        ce.variants.getByExternalIdentifier.getQueryKey(
          t.resource.external_identifier
        ),
        t.resource
      );
      for (const n of t.resource.views)
        for (const { design: s } of n.customizations)
          e.setQueryData(
            ce.designs.favored.get.getQueryKey(s.id),
            s
          );
    },
    output: em
  }
), r2 = We.infiniteQuery(
  (t, e) => ({
    searchParams: {
      ...t,
      cursor: e
    },
    url: "favorites/variants"
  }),
  {
    getNextPageParam: (t) => t.meta.next_cursor,
    // eslint-disable-next-line unicorn/no-null
    initialPageParam: null,
    input: B({
      filter: B({
        collection_name: Jp,
        filter_date_equals: ss(),
        filter_date_max: ss(),
        filter_date_min: ss()
      }).partial().optional()
    }).optional(),
    onSuccess: ({ output: t }) => {
      const e = lt();
      for (const n of t.data) {
        e.setQueryData(
          ce.favorites.variants.get.getQueryKey(
            n.id
          ),
          n
        ), e.setQueryData(
          ce.variants.get.getQueryKey(
            n.resource.id
          ),
          n.resource
        ), n.resource.external_identifier && e.setQueryData(
          ce.variants.getByExternalIdentifier.getQueryKey(
            n.resource.external_identifier
          ),
          n.resource
        );
        for (const s of n.resource.views)
          for (const { design: o } of s.customizations)
            e.setQueryData(
              ce.designs.favored.get.getQueryKey(
                o.id
              ),
              o
            );
      }
    },
    output: Io(em)
  }
), l2 = We.mutation(
  (t) => ({
    // ToDo Request fix from backend for removing this header
    headers: {
      accept: "application/json"
    },
    json: t,
    method: "post",
    url: "favorites/variants"
  }),
  {
    input: B({
      resource: B({
        id: O(),
        views: rt(
          B({
            customizations: rt(
              B({
                design: B({
                  elements: Xn([Bs]),
                  production_method: B({
                    id: O()
                  })
                }),
                order: O(),
                position: un(qs),
                positioning_area: B({
                  id: O()
                }),
                rotation: O(),
                x: O(),
                y: O()
              })
            ),
            handle: U()
          })
        )
      })
    }),
    output: O(),
    responseTransformer: async (t) => {
      const e = await t;
      return Number.parseInt(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        e.headers.get("x-identifier")
      );
    }
  }
), c2 = vt({ get: i2, list: r2, post: l2 }), u2 = vt({ delete: e2, variants: c2 }), d2 = We.query(
  (t) => ({ searchParams: { filter: t }, url: "logos/categories" }),
  {
    input: B({ production_method: rt(O()) }).partial().optional(),
    output: B({
      id: O(),
      name: U(),
      left: O(),
      logos: O().array(),
      parent_id: O().nullable(),
      right: O()
    }).array()
  }
), p2 = vt({ list: d2 }), m2 = B({
  node: B({
    id: O(),
    name: U(),
    entries_count: O()
  })
}), tm = m2.extend({
  children: vl(() => tm).array()
}), h2 = We.query(
  () => ({ method: "get", url: "logos/category-tree" }),
  { output: tm.array() }
), f2 = vt({ get: h2 }), _2 = We.query(
  (t) => ({ searchParams: { filter: t }, url: "logos/count" }),
  {
    input: B({
      name: U(),
      "categories.id": rt(O()),
      name_or_tags: U(),
      production_method: rt(O()),
      tags: U()
    }).partial().optional(),
    output: O(),
    responseTransformer: async (t) => (await t.json()).count
  }
), v2 = We.infiniteQuery(
  (t, e) => ({
    searchParams: {
      cursor: e,
      filter: t
    },
    url: "logos"
  }),
  {
    getNextPageParam: (t) => t.meta.next_cursor,
    // eslint-disable-next-line unicorn/no-null
    initialPageParam: null,
    input: B({
      id: O(),
      name: U(),
      "categories.id": rt(O()),
      created_at_max: ss(),
      created_at_min: ss(),
      name_or_tags: U(),
      production_method: rt(O()),
      tags: U(),
      updated_at_max: ss(),
      updated_at_min: ss()
    }).partial().optional(),
    onSuccess: ({ output: t }) => {
      const e = lt();
      for (const n of t.data)
        e.setQueryData(
          ce.logos.get.getQueryKey(n.id),
          n
        );
    },
    output: Io($l)
  }
), g2 = vt({ categories: p2, categoryTree: f2, count: _2, get: Py, list: v2 }), k2 = We.query(
  (t) => ({
    json: { items: t },
    method: "post",
    url: "prices"
  }),
  {
    input: rt(
      B({
        quantity: O(),
        variant: B({ id: O() })
      })
    ),
    output: B({
      items: B({
        prices: B({
          calculation_quantity: O(),
          model_id: O(),
          model_type: U(),
          price: O(),
          pricing: B({
            calculate_from: O(),
            calculation_type: U(),
            scaled_prices: B({
              from_a_number_of: O(),
              price: O()
            }).array()
          }),
          single_unit_price: O()
        }).array(),
        quantity: O(),
        variant: B({
          id: O()
        })
      }).array()
    })
  }
), y2 = vt({ getByItems: k2 }), b2 = We.query(
  (t) => ({ url: `products/${t.toString()}/color-variants` }),
  {
    input: O(),
    output: B({
      color_handle: U(),
      color_name: U(),
      color_preview_url: U(),
      image_url: U(),
      size_variants: B({
        id: O(),
        external_identifier: U(),
        product_size_label_id: O().nullable(),
        product_size_label_name: U().nullable(),
        product_sizes: rt(
          B({
            id: O(),
            oder_column: O(),
            product_size_scale_id: O(),
            product_size_scale_name: U(),
            value: U()
          })
        ),
        size_handle: U(),
        size_name: U(),
        size_order_column: O()
      }).array()
    }).array()
  }
), w2 = vt({ list: b2 }), x2 = We.infiniteQuery(
  (t, e) => ({
    searchParams: { ...t, page: e },
    url: "products"
  }),
  {
    getNextPageParam: (t) => {
      if (!(t.meta.current_page >= t.meta.to))
        return t.meta.current_page + 1;
    },
    initialPageParam: 1,
    input: B({ per_page: O() }).partial().optional(),
    output: B({
      data: B({
        id: O(),
        created_at: U(),
        description: U(),
        is_test: O(),
        title: U(),
        updated_at: U(),
        variants: O().array()
      }).array(),
      links: B({
        first: U().nullable(),
        last: U().nullable(),
        next: U().nullable(),
        prev: U().nullable()
      }),
      meta: B({
        current_page: O(),
        current_page_url: U(),
        from: O(),
        path: U(),
        per_page: O(),
        to: O()
      })
    })
  }
), $2 = vt({ colorVariants: w2, list: x2 }), z2 = We.query(
  (t) => ({
    url: `variants/cached/external-identifier/${encodeURIComponent(t)}`
  }),
  {
    input: U(),
    onSuccess: ({ output: t }) => {
      const e = lt();
      for (const n of t.views)
        for (const { design: s } of n.customizations)
          e.setQueryData(
            ce.designs.favored.get.getQueryKey(s.id),
            s
          );
    },
    output: Ja
  }
), S2 = We.infiniteQuery(
  (t) => ({ searchParams: { filter: t }, url: "variants" }),
  {
    getNextPageParam: (t) => t.meta.next_cursor,
    // eslint-disable-next-line unicorn/no-null
    initialPageParam: null,
    input: B({
      id: O().or(rt(O())),
      collection_name: U(),
      external_identifier: U()
    }).partial().optional(),
    onSuccess: ({ output: t }) => {
      const e = lt();
      for (const n of t.data) {
        e.setQueryData(
          ce.variants.get.getQueryKey(n.id),
          n
        ), n.external_identifier && e.setQueryData(
          ce.variants.getByExternalIdentifier.getQueryKey(
            n.external_identifier
          ),
          n
        );
        for (const s of n.views)
          for (const { design: o } of s.customizations)
            e.setQueryData(
              ce.designs.favored.get.getQueryKey(
                o.id
              ),
              o
            );
      }
    },
    output: Io(Ja)
  }
), A2 = We.query(
  (t) => ({ url: `variants/${t.toString()}/pdf-download` }),
  {
    input: O(),
    output: ig(Blob).and(
      ip((t) => t.type === "application/pdf")
    ),
    responseTransformer: (t) => t.blob()
  }
), C2 = We.mutation(
  /**
   * Creates a pdf preview of a custom variant.
   *
   * @param baseId id of the variant that the new one is based on
   * @param views array of views defining the variants content
   *
   * @returns id of the created variant which is used for the pdf.
   *   The created variant needs to be rendered first before it can be retrieved.
   *   A pusher event is emitted when the rendering is done.
   */
  ({ baseId: t, views: e }) => ({
    // ToDo Request fix from backend for removing this header
    headers: {
      accept: "application/json"
    },
    json: { views: e },
    method: "post",
    timeout: !1,
    url: `variants/${t.toString()}/design-for-pdf-download`
  }),
  {
    input: B({
      baseId: O(),
      views: rt(
        B({
          customizations: rt(
            B({
              design: B({
                elements: Xn([Bs]),
                production_method: B({
                  id: O()
                })
              }),
              order: O(),
              position: un(qs),
              positioning_area: B({
                id: O()
              }),
              rotation: O(),
              x: O(),
              y: O()
            })
          ),
          handle: U()
        })
      )
    }),
    output: O(),
    responseTransformer: async (t) => {
      const e = await t;
      return Number.parseInt(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        e.headers.get("x-identifier")
      );
    }
  }
), P2 = vt({ getByVariantId: A2, postForDownload: C2 }), M2 = We.mutation(
  /**
   * Creates a new custom variant
   *
   * @param baseId id of the variant that the new one is based on
   * @param views array of views defining the variants content
   *
   * @returns id of the created variant.
   *   The created variant needs to be rendered first before it can be retrieved.
   *   A pusher event is emitted when the rendering is done
   */
  ({ baseId: t, views: e }) => ({
    // ToDo Request fix from backend for removing this header
    headers: {
      accept: "application/json"
    },
    json: { views: e },
    method: "post",
    url: `variants/${t.toString()}/design`
  }),
  {
    input: B({
      baseId: O(),
      views: rt(
        B({
          customizations: rt(
            B({
              design: B({
                elements: Xn([Bs]),
                production_method: B({
                  id: O()
                })
              }),
              order: O(),
              position: un(qs),
              positioning_area: B({
                id: O()
              }),
              rotation: O(),
              x: O(),
              y: O()
            })
          ),
          handle: U()
        })
      )
    }),
    output: O(),
    responseTransformer: async (t) => {
      const e = await t;
      return Number.parseInt(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        e.headers.get("x-identifier")
      );
    }
  }
), T2 = We.query(
  (t) => ({ url: `variants/${t.toString()}/preview-html` }),
  { input: O(), output: U() }
), I2 = vt({ getByVariantId: T2 }), E2 = vt({
  get: a2,
  getByExternalIdentifier: z2,
  list: S2,
  pdf: P2,
  post: M2,
  previewHtml: I2
}), ce = vt(
  {
    auth: vy,
    configurations: Ay,
    customerLogos: Ly,
    designs: Yy,
    favorites: u2,
    logos: g2,
    prices: y2,
    products: $2,
    variants: E2
  },
  "designer-api"
), Al = st("designer-core.pusher", () => {
  const { tokenData: t } = D(To()), { sessionId: e } = D(wl()), n = N(), s = N(), o = N(), a = N(), i = A(() => {
    if (!(s.value === void 0 || o.value === void 0))
      return {
        appKey: s.value,
        cluster: o.value
      };
  }), { connected: r, connectionStatus: c, pusher: u } = s0(
    i,
    a
  ), d = A(() => {
    var w;
    if (n.value && (w = t.value) != null && w.user_id)
      return [
        n.value,
        "smake-designer-api",
        t.value.user_id
      ].join("-");
  }), {
    channel: m,
    isSubscribed: _,
    subcription: g
  } = Ou(u, d), v = A(() => {
    if (d.value)
      return [d.value, e.value].join("-");
  }), {
    channel: z,
    isSubscribed: h,
    subcription: y
  } = Ou(u, v);
  return {
    appKey: s,
    channelPrefix: n,
    channelSession: z,
    channelSessionIsSubscibed: h,
    channelSessionName: v,
    channelSessionSubscription: y,
    channelUser: m,
    channelUserIsSubscribed: _,
    channelUserName: d,
    channelUserSubscription: g,
    cluster: o,
    connected: r,
    connectionStatus: c,
    onError: a,
    pusher: u
  };
});
function Dt(t, e) {
  const { channelUser: n } = D(Al());
  Ip(n, t, e);
}
function en(t) {
  const e = En();
  return C(t, e);
}
function O2() {
  const t = lt(), e = ce.customerLogos.list.getQueryKey(), n = en(
    (a) => t.fetchQuery({
      ...ce.customerLogos.get.use(a),
      retry: !1,
      staleTime: 1 / 0
    })
  ), s = en(
    (a) => ce.customerLogos.list.getQueryKey({
      production_method: [a]
    })
  );
  Dt("customerLogo.updated", (a) => {
    t.setQueriesData(
      {
        queryKey: e
      },
      (i) => Wp(a, i)
    );
  }), Dt("customerLogo.completed", async ({ id: a }) => {
    const i = await n(a);
    t.setQueriesData(
      {
        queryKey: s(
          i.logo.production_method.id
        )
      },
      (r) => Iy(i, r)
    ), await t.invalidateQueries({
      queryKey: o(
        i.logo.production_method.id
      )
    });
  });
  const o = en(
    (a) => ce.customerLogos.count.getQueryKey({
      production_method: [a]
    })
  );
}
function R2(t) {
  const e = lt();
  Dt(
    "customVariant.deleteFromArchive.completed",
    ({ id: s }) => {
      const o = ce.favorites.variants.list.getQueryKey({
        filter: {
          collection_name: "customer-sketch"
        }
      });
      e.setQueryData(
        o,
        (a) => a && {
          ...a,
          pages: a.pages.map((i) => ({
            ...i,
            data: i.data.filter(
              (r) => r.id !== s
            )
          }))
        }
      );
    }
  ), Dt(
    "customVariant.customizationsCompletedAfterAssignedToArchive",
    async ({ id: s }) => {
      try {
        const o = await n(s), a = ce.favorites.variants.list.getQueryKey({
          filter: {
            collection_name: "customer-sketch"
          }
        }), i = e.getQueryData(
          a
        );
        if (!i) return;
        if (i.pages.some(
          (r) => r.data.some((c) => c.id === s)
        )) {
          e.setQueryData(
            a,
            (r) => {
              if (r)
                return {
                  ...r,
                  pages: r.pages.map((c) => ({
                    ...c,
                    data: c.data.map(
                      (u) => u.id === s ? o : u
                    )
                  }))
                };
            }
          );
          return;
        }
        e.setQueryData(
          a,
          (r) => {
            if (r != null && r.pages[0])
              return {
                ...r,
                pages: [
                  {
                    ...r.pages[0],
                    data: [
                      o,
                      ...r.pages[0].data
                    ]
                  },
                  ...r.pages.slice(1)
                ]
              };
          }
        );
      } catch (o) {
        t && t(o);
      }
    }
  );
  const n = en(
    (s) => e.fetchQuery(ce.favorites.variants.get.use(s))
  );
}
function L2(t) {
  const e = lt();
  Dt(
    "favorite.deleted",
    async ({ resource_id: a, resource_type: i }) => {
      if (i === "design") {
        e.setQueriesData(
          { queryKey: s() },
          (r) => Zp(a, r)
        );
        try {
          await e.invalidateQueries({
            queryKey: o()
          });
        } catch (r) {
          t && t(r);
        }
      }
    }
  ), Dt("favoredDesign.updated", (a) => {
    e.setQueriesData(
      { queryKey: s() },
      (i) => Sl(a, i)
    );
  }), Dt(
    "favorite.created",
    async ({ resource_id: a, resource_type: i }) => {
      if (i === "design")
        try {
          const r = await n(a);
          e.setQueriesData(
            {
              queryKey: s([
                r.production_method.id
              ])
            },
            (c) => Gp(r, c)
          ), await e.invalidateQueries({
            queryKey: o()
          });
        } catch (r) {
          t && t(r);
        }
    }
  );
  const n = en((a) => {
    const i = ce.designs.favored.get.use(a);
    return e.fetchQuery(i);
  }), s = en(
    (a) => a === void 0 ? ce.designs.favored.list.getQueryKey() : ce.designs.favored.list.getQueryKey({
      production_method: a
    })
  ), o = en(() => ce.designs.favored.count.getQueryKey());
}
function D2(t) {
  const e = lt(), n = ce.favorites.variants.list.getQueryKey({
    filter: { collection_name: "customer-sketch" }
  });
  Dt("favorite.rendered", async ({ id: a }) => {
    try {
      const i = await o(a), r = e.getQueryData(
        n
      );
      if (!r) return;
      if (r.pages.some(
        (c) => c.data.some((u) => u.id === a)
      )) {
        e.setQueryData(
          n,
          (c) => {
            if (c)
              return {
                ...c,
                pages: c.pages.map((u) => ({
                  ...u,
                  data: u.data.map(
                    (d) => d.id === a ? i : d
                  )
                }))
              };
          }
        );
        return;
      }
      e.setQueryData(
        n,
        (c) => {
          if (c != null && c.pages[0])
            return {
              ...c,
              pages: [
                {
                  ...c.pages[0],
                  data: [i, ...c.pages[0].data]
                },
                ...c.pages.slice(1)
              ]
            };
        }
      );
    } catch (i) {
      t && t(i);
    }
  });
  const { deleteFavorite: s } = Qp();
  Dt("favorite.deleted", ({ id: a, resource_type: i }) => {
    i === "variant" && s(a);
  }), Dt("favorite.updated", async ({ id: a }) => {
    try {
      const i = await o(a), r = e.getQueryData(
        n
      );
      if (!r) return;
      if (r.pages.some(
        (c) => c.data.some((u) => u.id === a)
      )) {
        e.setQueryData(
          n,
          (c) => {
            if (c)
              return {
                ...c,
                pages: c.pages.map((u) => ({
                  ...u,
                  data: u.data.map(
                    (d) => d.id === a ? i : d
                  )
                }))
              };
          }
        );
        return;
      }
      e.setQueryData(
        n,
        (c) => {
          if (c != null && c.pages[0])
            return {
              ...c,
              pages: [
                {
                  ...c.pages[0],
                  data: [i, ...c.pages[0].data]
                },
                ...c.pages.slice(1)
              ]
            };
        }
      );
    } catch (i) {
      t && t(i);
    }
  }), Dt("favorite.created", async ({ id: a, resource_type: i }) => {
    if (i === "variant")
      try {
        const r = await o(a), c = e.getQueryData(
          n
        );
        if (!c) return;
        if (c.pages.some(
          (u) => u.data.some((d) => d.id === r.id)
        )) {
          e.setQueryData(
            n,
            (u) => {
              if (u)
                return {
                  ...u,
                  pages: u.pages.map((d) => ({
                    ...d,
                    data: d.data.map(
                      (m) => m.id === a ? r : m
                    )
                  }))
                };
            }
          );
          return;
        }
        e.setQueryData(
          n,
          (u) => {
            if (u != null && u.pages[0])
              return {
                ...u,
                pages: [
                  {
                    ...u.pages[0],
                    data: [r, ...u.pages[0].data]
                  },
                  ...u.pages.slice(1)
                ]
              };
          }
        );
      } catch (r) {
        t && t(r);
      }
  });
  const o = en((a) => {
    const i = ce.favorites.variants.get.use(a);
    return e.fetchQuery(i);
  });
}
function j2(t) {
  O2(), D2(t), L2(t), R2(t);
}
class Ma extends Error {
}
function Ft(t, e) {
  const n = id(t);
  if (!n)
    throw new Error(`injection "${String(t)}" not found`);
  return n;
}
const Uu = 4095, $r = {};
function Cl(t, e) {
  const n = A(
    () => !!an(t) && !an(e == null ? void 0 : e.disabled)
  ), s = A(() => {
    const a = an(e == null ? void 0 : e.placeholder);
    if (a)
      return ds(N2(a));
  }), o = bt({
    enabled: n,
    placeholderData: s,
    queryFn: async () => (
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      ds(await cc.load(an(t)))
    ),
    queryKey: ["pixi.js-asset", t],
    staleTime: 1 / 0
  });
  return re(() => {
    const a = an(t);
    n.value || !a || cc.backgroundLoad(a);
  }), o;
}
function N2({ height: t, radius: e, width: n }) {
  const s = Math.min(Uu / n, Uu / t, 1);
  n = Math.round(n * s), t = Math.round(t * s), e = Math.round(e * s);
  const o = `${n.toString()}x${t.toString()}|${e.toString()}}`;
  if (!(o in $r)) {
    const a = document.createElement("canvas");
    a.width = n, a.height = t;
    const i = a.getContext("2d");
    if (!i) throw new Error("Canvas context couldn't be created");
    i.fillStyle = "#ffffff", i.roundRect(0, 0, n, t, e), i.fill(), $r[o] = gd.from(a);
  }
  return $r[o];
}
var ze = /* @__PURE__ */ ((t) => (t.ANCHOR = "ANCHOR", t.LOGO = "LOGO", t.TEXT = "TEXT", t))(ze || {});
function Qr(t, e) {
  var n, s, o, a, i, r, c, u, d, m, _;
  let g = { max: 1 / 0, min: -1 / 0 };
  switch (t.type) {
    case ze.ANCHOR: {
      const v = Qr(
        t.parent,
        e
      );
      g = {
        max: Math.min(g.max, v.max),
        min: Math.max(g.min, v.min)
      };
      for (const z of t.children) {
        const h = Qr(
          z.value,
          e
        );
        g = {
          max: Math.min(g.max, h.max),
          min: Math.max(g.min, h.min)
        };
      }
      break;
    }
    case ze.LOGO:
      t.size && (g = {
        max: Math.min(
          g.max,
          (((s = (n = e.logo) == null ? void 0 : n.size) == null ? void 0 : s.max) ?? 1 / 0) / t.size.width,
          (((a = (o = e.logo) == null ? void 0 : o.size) == null ? void 0 : a.max) ?? 1 / 0) / t.size.height
        ),
        min: Math.max(
          g.min,
          (((r = (i = e.logo) == null ? void 0 : i.size) == null ? void 0 : r.min) ?? -1 / 0) / t.size.width,
          (((u = (c = e.logo) == null ? void 0 : c.size) == null ? void 0 : u.min) ?? -1 / 0) / t.size.height
        )
      });
      break;
    case ze.TEXT:
      for (const v of t.lines) {
        const z = (_ = (m = (d = e.text) == null ? void 0 : d.size) == null ? void 0 : m.find(
          ({ fontId: h }) => h === v.fontId
        )) == null ? void 0 : _.bounds;
        z && (g = {
          max: Math.min(
            g.max,
            (z.max ?? 1 / 0) / v.size
          ),
          min: Math.max(
            g.min,
            (z.min ?? -1 / 0) / v.size
          )
        });
      }
      break;
  }
  return g;
}
function Pl(t, e, n) {
  const s = U2(n, [
    { x: -e.x, y: -e.y },
    { x: t.width - e.x, y: -e.y },
    { x: -e.x, y: t.height - e.y },
    { x: t.width - e.x, y: t.height - e.y }
  ]), o = s.map(({ x: i }) => i), a = s.map(({ y: i }) => i);
  return {
    bottom: Math.max(...a),
    left: Math.min(...o),
    right: Math.max(...o),
    top: Math.min(...a)
  };
}
function Ta({ x: t, y: e }, { x: n, y: s }) {
  return Math.hypot(t - n, e - s);
}
function _n(t, e, n) {
  return Math.min(Math.max(t, e), n);
}
function zr(t, e, n, s) {
  return (e - t) * (1 - Math.exp(-0.1 * n));
}
function Ya(t) {
  return (t % 360 + 360) % 360;
}
function V2(t) {
  return t * (180 / Math.PI);
}
function U2(t, e) {
  const n = F2(t), s = Math.cos(n), o = Math.sin(n);
  return e.map(({ x: a, y: i }) => ({
    x: a * s - i * o,
    y: a * o + i * s
  }));
}
function Fu(t, e, n, s) {
  const { x: o, y: a } = t;
  if (typeof e == "number") {
    const r = o + zr(o, e, n);
    return t.set(r), Math.abs(r - e);
  }
  const i = {
    x: o + zr(o, e.x, n),
    y: a + zr(a, e.y, n)
  };
  return t.copyFrom(i), Ta(i, e);
}
function F2(t) {
  return t * Math.PI / 180;
}
function Jr(t) {
  switch (t.type) {
    case ze.ANCHOR:
      return Jr(t.parent) && t.children.every(({ value: e }) => Jr(e));
    case ze.LOGO:
      return !!t.size;
    case ze.TEXT:
      return !0;
  }
}
const Hs = Symbol("designer_core"), Ml = Symbol("view"), Ws = Symbol("positioning_area"), nm = Symbol("positioning_area_design"), Tl = Symbol("design");
function Yr(t, e, n) {
  var s, o, a, i, r, c, u, d, m, _, g, v;
  switch (t.type) {
    case ze.ANCHOR:
      Yr(t.parent, e, n);
      for (const z of t.children)
        Yr(z.value, e, n);
      break;
    case ze.LOGO:
      if (t.size) {
        const { max: z = 1 / 0, min: h = 0 } = ((s = n == null ? void 0 : n.logo) == null ? void 0 : s.size) ?? {}, { height: y, width: w } = t.size, P = _n(
          e,
          Math.max(h / w, h / y),
          Math.min(z / w, z / y)
        );
        t.size.width *= P, t.size.height *= P;
      }
      break;
    case ze.TEXT:
      for (const z of t.lines) {
        z.offsetLeft && (z.offsetLeft = _n(
          z.offsetLeft * e,
          ((a = (o = n == null ? void 0 : n.text) == null ? void 0 : o.offsetLeft) == null ? void 0 : a.min) ?? -1 / 0,
          ((r = (i = n == null ? void 0 : n.text) == null ? void 0 : i.offsetLeft) == null ? void 0 : r.max) ?? 1 / 0
        )), z.paddingBottom = _n(
          z.paddingBottom * e,
          ((u = (c = n == null ? void 0 : n.text) == null ? void 0 : c.paddingBottom) == null ? void 0 : u.min) ?? -1 / 0,
          ((m = (d = n == null ? void 0 : n.text) == null ? void 0 : d.paddingBottom) == null ? void 0 : m.max) ?? 1 / 0
        );
        const h = (v = (g = (_ = n == null ? void 0 : n.text) == null ? void 0 : _.size) == null ? void 0 : g.find(
          ({ fontId: y }) => y === z.fontId
        )) == null ? void 0 : v.bounds;
        z.size = _n(
          z.size * e,
          (h == null ? void 0 : h.min) ?? 0,
          (h == null ? void 0 : h.max) ?? 1 / 0
        );
      }
      break;
  }
}
const B2 = {
  name: "loadCdnTextures",
  config: {
    crossOrigin: "anonymous",
    preferCreateImageBitmap: !0,
    preferWorkers: !0
  },
  extension: {
    name: "loadCdnTextures",
    priority: kf.High,
    type: fd.LoadParser
  },
  // @ts-expect-error: It's like that in the source
  async load(t, e, n) {
    var s, o;
    let a;
    globalThis.createImageBitmap && (s = this.config) != null && s.preferCreateImageBitmap ? a = this.config.preferWorkers && await lc.isImageBitmapSupported() ? await lc.loadImageBitmap(t, e) : await jf(t, e) : a = await new Promise((r) => {
      a = new Image(), a.crossOrigin = this.config.crossOrigin, a.src = t, a.complete ? r(a) : a.addEventListener("load", () => {
        r(a);
      });
    });
    const i = new Nf({
      alphaMode: "premultiply-alpha-on-upload",
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      resolution: ((o = e.data) == null ? void 0 : o.resolution) || Vf(t),
      resource: a,
      ...e.data
    });
    return Uf(i, n, t);
  },
  test(t) {
    return /^https:\/\/cdn\.(.+\.)?smake\./.test(t);
  },
  unload(t) {
    t.destroy(!0);
  }
}, q2 = {
  AnimatedSprite: { createElement: (t) => new Of(t) },
  BitmapText: { createElement: (t) => new Ef(t) },
  Container: { createElement: (t) => new hd(t) },
  Graphics: { createElement: (t) => new If(t) },
  HtmlText: { createElement: (t) => new Tf(t) },
  Mesh: { createElement: (t) => new Mf(t) },
  MeshPlane: { createElement: (t) => new Pf(t) },
  MeshRope: { createElement: (t) => new Cf(t) },
  MeshSimple: { createElement: (t) => new Af(t) },
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  NineSlicePlane: { createElement: (t) => new Sf(t) },
  NineSliceSprite: { createElement: (t) => new zf(t) },
  ParticleContainer: {
    createElement: (t) => new $f(t)
  },
  PerspectiveMesh: { createElement: (t) => new xf(t) },
  RenderContainer: { createElement: (t) => new wf(t) },
  RenderLayer: { createElement: (t) => new bf(t) },
  Sprite: { createElement: (t) => new vd(t) },
  Text: { createElement: (t) => new _d(t) },
  TilingSprite: { createElement: (t) => new yf(t) }
};
function H2() {
  const t = new vd(gd.EMPTY);
  return t.visible = !1, t.renderable = !1, t;
}
function W2(t) {
  const e = {};
  for (const [n, s] of Object.entries(t))
    e[sd(n)] = s;
  return e;
}
function Bu(t, e) {
  if (!(t instanceof Df)) {
    ad("Text is only supported with Text or BitmapText elements");
    return;
  }
  t.text = e;
}
function G2(t) {
  return t.charAt(0).toLowerCase() + t.slice(1);
}
const sm = {};
function Z2(t, e) {
  sm[t] = e;
}
const { createApp: K2, render: Iie } = Xh({
  createComment: H2,
  // @ts-expect-error: No way found to fix this
  createElement(t, e, n, s) {
    const o = c0(t), a = l0(o) ? q2[o] : sm[o];
    if (!a) throw new Error(`Unknown element ${t}`);
    return ds(
      a.createElement(
        // @ts-expect-error: We just have to assume the types are correct
        W2(s ?? {})
      )
    );
  },
  createText(t) {
    return new _d({ text: t });
  },
  insert(t, e, n) {
    if (n) {
      e.addChildAt(t, e.getChildIndex(n));
      return;
    }
    e.addChild(t);
  },
  nextSibling(t) {
    const e = t.parent.getChildIndex(t);
    return t.parent.children.length <= e + 1 ? (
      // eslint-disable-next-line unicorn/no-null
      null
    ) : t.parent.getChildAt(e + 1);
  },
  parentNode(t) {
    return t.parent;
  },
  patchProp(t, e, n, s) {
    if (e = sd(e), e.startsWith("on")) {
      const o = G2(e.slice(2));
      if (n !== null)
        if (Array.isArray(n))
          for (const a of n)
            t.off(o, a);
        else
          t.off(o, n);
      if (Array.isArray(s))
        for (const a of s)
          t.on(o, a);
      else
        t.on(o, s);
      return;
    }
    if (!t[`_vp_skip_first_set_${e}`]) {
      t[`_vp_skip_first_set_${e}`] = !0;
      return;
    }
    t[e] = s;
  },
  remove(t) {
    t.destroy();
  },
  setElementText: Bu,
  setText: Bu
});
Rf.add({ ref: B2, type: fd.LoadParser });
const om = Symbol(
  "vue_pixi_application"
);
function X2(t) {
  let e = !1, n;
  return (...s) => {
    n = s, !e && (e = !0, requestAnimationFrame(() => {
      e = !1, t(...n), n = void 0;
    }));
  };
}
const Q2 = J({
  props: [
    "preference",
    "webgpu",
    "webgl",
    "skipExtensionImports",
    "manageImports",
    "backgroundColor",
    "background",
    "backgroundAlpha",
    "clearBeforeRender",
    "width",
    "height",
    "canvas",
    "view",
    "autoDensity",
    "resolution",
    "antialias",
    "depth",
    "multiView",
    "hello",
    "textureGCActive",
    "textureGCAMaxIdle",
    "textureGCCheckCountMax",
    "eventMode",
    "eventFeatures",
    "failIfMajorPerformanceCaveat",
    "roundPixels",
    "bezierSmoothness",
    "useBackBuffer",
    "context",
    "powerPreference",
    "premultipliedAlpha",
    "preserveDrawingBuffer",
    "preferWebGLVersion",
    "forceFallbackAdapter",
    "resizeTo",
    "autoStart",
    "sharedTicker"
  ],
  setup(t, { expose: e, slots: n }) {
    const s = N(), o = new Lf(), a = N(!1), i = A(() => {
      const v = {};
      for (const [z, h] of Object.entries(t))
        h !== void 0 && (v[z] = h);
      return v;
    });
    globalThis.__PIXI_DEVTOOLS__ = {
      app: o,
      pixi: vf
    };
    const r = K2(
      J(() => () => {
        var v;
        return (v = n.default) == null ? void 0 : v.call(n);
      })
    ), c = { app: o, canvas: s, isInitialized: a };
    ps(om, c), e(c);
    const u = En(), d = u.appContext.app;
    r.config.globalProperties = d.config.globalProperties, Object.assign(r._context, d._context), r._context.provides = u.provides, r.mount(o.stage);
    function m(v, z, h) {
      const y = o.renderer, w = v * h, P = z * h;
      if (y instanceof Ff) {
        const M = y.gpu.device.limits.maxTextureDimension2D;
        y.resolution = Math.min(
          h,
          h * Math.min(
            Math.min(w, M) / w,
            Math.min(P, M) / P
          )
        ), y.resize(v, z);
      } else y instanceof Bf && (y.resolution = h, y.resize(v, z), y.resolution = Math.min(
        h,
        h * Math.min(
          y.gl.drawingBufferWidth / w,
          y.gl.drawingBufferHeight / P
        )
      ));
      o.render();
    }
    const _ = X2(m);
    function g(v, z) {
      const h = Object.keys(t).filter((y) => v[y] !== z[y]);
      (h.includes("width") || h.includes("height") || h.includes("resolution")) && _(
        z.width ?? 1,
        z.height ?? 1,
        z.resolution ?? 1
      );
      for (const y of h)
        if (!["height", "resolution", "width"].includes(y)) {
          if (y in o.renderer) {
            o.renderer[y] = z[y];
            continue;
          }
          if (y in o) {
            o[y] = z[y];
            continue;
          }
          ad(`Couldn't update app according to prop ${y}`);
        }
    }
    return it(i, (v, z) => {
      a.value && g(z, v);
    }), od(async () => {
      const v = {
        ...i.value,
        height: 1,
        resolution: 1,
        width: 1
      };
      await o.init({
        ...v,
        canvas: s.value
      }), g(v, i.value), a.value = !0;
    }), al(() => {
      r.unmount(), o.destroy();
    }), () => Qh("canvas", { ref: s });
  }
});
function Ps(t, e) {
  const n = (e == null ? void 0 : e.ticker) ?? J2();
  re((s) => {
    const o = n.value;
    !o || !an((e == null ? void 0 : e.enabled) ?? !0) || (o.add(t, e == null ? void 0 : e.context, e == null ? void 0 : e.priority), s(() => {
      o.remove(t, e == null ? void 0 : e.context);
    }));
  });
}
function J2() {
  const { app: t, isInitialized: e } = Ft(om);
  return A(() => e.value ? t.ticker : void 0);
}
const Y2 = ["texture", "width", "height", "alpha", "tint"], am = /* @__PURE__ */ J({
  __name: "DesignPreview",
  setup(t) {
    const {
      error: e,
      fetchStatus: n,
      isPlaceholderData: s,
      placeholderColor: o,
      size: a,
      texture: i
    } = Ft(Tl), r = A(() => n.value === "fetching"), c = N(1);
    return Ps(
      (u) => {
        c.value = Math.sin(u.lastTime / 1e3 * Math.PI) * 0.25 + 0.5;
      },
      { enabled: r }
    ), (u, d) => l(i) && l(a) ? ($(), I("PixiSprite", {
      key: 0,
      label: "DesignPreview",
      texture: l(i),
      width: l(a).width,
      height: l(a).height,
      alpha: l(e) ? 0.5 : r.value ? c.value : 1,
      tint: l(e) ? 16711680 : l(s) ? l(o) : void 0
    }, null, 8, Y2)) : Q("", !0);
  }
}), eb = ["angle", "scale", "position", "pivot"], tb = ["context"], nb = ["context", "x", "y", "cursor"], sb = ["context", "x", "y"], ob = ["context", "x", "y"], ab = /* @__PURE__ */ J({
  __name: "DesignControls",
  props: {
    deleteable: { type: Boolean },
    deleteIcon: {},
    designBounds: { default: void 0 },
    hidden: { type: Boolean },
    padding: { default: 3 },
    resizeable: { type: Boolean },
    resizeIcon: {},
    rotateable: { type: Boolean },
    rotateIcon: {},
    rotateStep: { default: void 0 },
    rotationControlLength: { default: 15 }
  },
  setup(t) {
    const e = t, {
      deleteable: n,
      deleteIcon: s,
      designBounds: o,
      hidden: a,
      padding: i,
      resizeable: r,
      resizeIcon: c,
      rotateable: u,
      rotateIcon: d,
      rotateStep: m,
      rotationControlLength: _
    } = we(e), { data: g } = Ft(nm), { size: v, texture: z } = Ft(Tl), { data: h } = Ft(Ws), { worldScale: y } = Ft(Hs), w = N(), P = N(0), M = N(1), E = N(1), R = A(() => M.value * E.value), j = A(() => y.value * R.value), V = A(
      () => v.value ? { x: v.value.width / 2, y: v.value.height / 2 } : void 0
    ), X = new fa();
    re(() => {
      if (X.clear(), a.value || !v.value) return;
      const ie = i.value;
      X.rect(
        -ie,
        -ie,
        v.value.width + ie * 2,
        v.value.height + ie * 2
      ), u.value && X.moveTo(v.value.width / 2, -ie).lineTo(
        v.value.width / 2,
        -ie - _.value
      ), X.stroke({
        alignment: 0,
        color: 11717887,
        width: 1 / j.value
      });
    });
    function Z(ie) {
      const ve = A(() => {
        const fe = Math.min(20 / ie.value.width, 20 / ie.value.height);
        return {
          height: ie.value.height * fe,
          width: ie.value.width * fe
        };
      }), ut = A(
        () => `data:image/svg+xml;base64,${btoa(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${ie.value.width.toString()} ${ie.value.height.toString()}" width="${(ve.value.width * 2).toString()}px" height="${(ve.value.height * 2).toString()}px"><path d="${ie.value.path}"/></svg>`)}`
      ), { data: ot } = Cl(ut), Ve = new fa();
      return re(() => {
        if (Ve.clear(), a.value || !ot.value) return;
        const fe = {
          height: ve.value.height / j.value * 10,
          width: ve.value.width / j.value * 10
        };
        Ve.circle(0, 0, 15 / j.value * 10).fill({ color: 16777215 }).stroke({
          alignment: 0,
          color: 0,
          width: 1 / j.value * 10
        }).texture(
          ot.value,
          16777215,
          -fe.width / 2,
          -fe.height / 2,
          fe.width,
          fe.height
        );
      }), Ve;
    }
    const ae = Z(d), K = Z(s), te = Z(c), ue = N();
    function Ce(ie) {
      ie.stopPropagation(), h.value.designs = h.value.designs.filter(
        (ve) => ve !== g.value
      );
    }
    function ne(ie) {
      if (!ue.value) return;
      ie.stopPropagation(), ue.value = void 0;
      let ve = P.value;
      m.value && (ve = Math.round(ve / m.value) * m.value), g.value.rotation = Ya(
        g.value.rotation + ve
      ), P.value = 0;
    }
    function ee(ie) {
      if (!w.value || !V.value || !ue.value) return;
      const { x: ve, y: ut } = V.value, { x: ot, y: Ve } = ue.value, { x: fe, y: Xe } = w.value.parent.worldTransform.applyInverse(
        ie.global
      );
      if (ot === fe && Ve === Xe) {
        P.value = 0;
        return;
      }
      const Ue = ot - ve, Ye = Ve - ut, dt = fe - ve, wt = Xe - ut, pt = Math.acos(
        (Ue * dt + Ye * wt) / (Math.hypot(Ue, Ye) * Math.hypot(dt, wt))
      );
      P.value = V2(
        Ue * wt - Ye * dt < 0 ? 2 * Math.PI - pt : pt
      );
    }
    function G(ie) {
      w.value && (ie.stopPropagation(), ue.value = w.value.parent.worldTransform.applyInverse(
        ie.global
      ), ee(ie));
    }
    const oe = A(
      () => !a.value && r.value && Jr(g.value.design)
    ), _e = A(() => o.value ? Qr(
      g.value.design,
      o.value
    ) : { max: 1 / 0, min: -1 / 0 }), de = N();
    function $e(ie) {
      de.value && (ie.stopPropagation(), de.value = void 0, M.value !== 1 && (Yr(
        g.value.design,
        M.value,
        o.value
      ), E.value = M.value, M.value = 1));
    }
    function Ze(ie) {
      if (!w.value || !V.value || !de.value) return;
      const { x: ve, y: ut } = w.value.parent.worldTransform.applyInverse(
        ie.global
      );
      M.value = _n(
        Math.sqrt(
          (Math.pow(V.value.x - ve, 2) + Math.pow(V.value.y - ut, 2)) / de.value
        ),
        _e.value.min,
        _e.value.max
      );
    }
    function Pe(ie) {
      if (!w.value || !V.value) return;
      ie.stopPropagation();
      const { x: ve, y: ut } = w.value.parent.worldTransform.applyInverse(
        ie.global
      );
      de.value = Math.pow(V.value.x - ve, 2) + Math.pow(V.value.y - ut, 2), Ze(ie);
    }
    return it(z, () => {
      E.value = 1;
    }), (ie, ve) => ($(), I("PixiContainer", {
      ref_key: "container",
      ref: w,
      label: "DesignControls",
      angle: P.value,
      scale: R.value,
      position: V.value,
      pivot: V.value
    }, [
      St(ie.$slots, "default", {}, () => [
        b(am)
      ]),
      l(a) ? Q("", !0) : ($(), I("PixiGraphics", {
        key: 0,
        label: "DesignControls_Border",
        context: l(X)
      }, null, 8, tb)),
      !l(a) && l(v) && l(u) ? ($(), I("PixiGraphics", {
        key: 1,
        label: "DesignControls_Rotate",
        context: l(ae),
        x: l(v).width / 2,
        y: -l(i) - l(_),
        scale: 0.1,
        "event-mode": "static",
        cursor: ue.value ? "grabbing" : "grab",
        onPointerdown: G,
        onGlobalpointermove: ee,
        onPointerup: ne,
        onPointerupoutside: ne,
        onPointercancel: ne
      }, null, 40, nb)) : Q("", !0),
      !l(a) && l(v) && l(n) ? ($(), I("PixiGraphics", {
        key: 2,
        label: "DesignControls_Delete",
        context: l(K),
        x: -l(i),
        y: l(v).height + l(i),
        scale: 0.1,
        "event-mode": "static",
        cursor: "pointer",
        onPointerdown: Ce
      }, null, 40, sb)) : Q("", !0),
      oe.value && l(v) ? ($(), I("PixiGraphics", {
        key: 3,
        label: "DesignControls_Resize",
        context: l(te),
        x: l(v).width + l(i),
        y: l(v).height + l(i),
        scale: 0.1,
        "event-mode": "static",
        cursor: "nwse-resize",
        onPointerdown: Pe,
        onGlobalpointermove: Ze,
        onPointerup: $e,
        onPointerupoutside: $e,
        onPointercancel: $e
      }, null, 40, ob)) : Q("", !0)
    ], 8, eb));
  }
});
function ib(t) {
  let e;
  function n(o) {
    e = o.global.clone();
  }
  function s(o) {
    !e || Ta(o.global, e) > 10 || t(o);
  }
  return { onPointerdown: n, onPointerup: s };
}
const im = st(
  "designer-core.designerCore",
  () => {
    const { pixelRatio: t } = nf();
    return { devicePixelRatio: t };
  }
);
function Sr({ x: t, y: e }, n, s) {
  return {
    x: (s.x + s.width / 2 - t) / n,
    y: (s.y + s.height / 2 - e) / n
  };
}
function ia({ x: t, y: e }, n, s) {
  return {
    x: s.x + s.width / 2 - t * n,
    y: s.y + s.height / 2 - e * n
  };
}
const rb = {
  axis: "all",
  factor: 1,
  noDrag: !1,
  percent: 1,
  position: void 0
};
class lb extends Ht {
  /**
   * This is called by {@link Viewport.pinch}.
   */
  constructor(e, n = {}) {
    super(e), rn(this, "active", !1), rn(this, "options"), rn(this, "pinching", !1), rn(this, "lastCenter"), rn(this, "moved", !1), this.options = Object.assign({}, rb, n);
  }
  down() {
    return this.parent.input.count() >= 2 ? (this.active = !0, !0) : !1;
  }
  isAxisX() {
    return ["all", "x"].includes(this.options.axis);
  }
  isAxisY() {
    return ["all", "y"].includes(this.options.axis);
  }
  move(e) {
    if (this.paused || !this.active)
      return !1;
    const n = e.global.x, s = e.global.y, o = this.parent.input.touches;
    if (o.length >= 2) {
      const a = o[0], i = o[1], r = a.last && i.last ? Math.sqrt(
        Math.pow(i.last.x - a.last.x, 2) + Math.pow(i.last.y - a.last.y, 2)
      ) : void 0;
      if (a.id === e.pointerId ? a.last = { data: e, x: n, y: s } : i.id === e.pointerId && (i.last = { data: e, x: n, y: s }), r) {
        let c;
        const u = new $t(
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          a.last.x + (i.last.x - a.last.x) / 2,
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          a.last.y + (i.last.y - a.last.y) / 2
        );
        this.options.position || (c = this.parent.toLocal(u));
        let d = Math.sqrt(
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          Math.pow(i.last.x - a.last.x, 2) + // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          Math.pow(i.last.y - a.last.y, 2)
        );
        d = d === 0 ? d = 1e-10 : d;
        const m = (1 - r / d) * this.options.percent * (this.isAxisX() ? this.parent.scale.x : this.parent.scale.y);
        this.isAxisX() && (this.parent.scale.x += m), this.isAxisY() && (this.parent.scale.y += m), this.parent.emit("zoomed", {
          center: u,
          type: "pinch",
          viewport: this.parent
        });
        const _ = this.parent.plugins.get("clamp-zoom", !0);
        if (_ && _.clamp(), this.options.position)
          this.options.position();
        else {
          const g = this.parent.toGlobal(c);
          this.parent.x += (u.x - g.x) * this.options.factor, this.parent.y += (u.y - g.y) * this.options.factor, this.parent.emit("moved", {
            type: "pinch",
            viewport: this.parent
          });
        }
        !this.options.noDrag && this.lastCenter && (this.parent.x += (u.x - this.lastCenter.x) * this.options.factor, this.parent.y += (u.y - this.lastCenter.y) * this.options.factor, this.parent.emit("moved", {
          type: "pinch",
          viewport: this.parent
        })), this.lastCenter = u, this.moved = !0;
      } else this.pinching || (this.parent.emit("pinch-start", this.parent), this.pinching = !0);
      return !0;
    }
    return !1;
  }
  up() {
    return this.pinching && this.parent.input.touches.length <= 1 ? (this.active = !1, this.lastCenter = void 0, this.pinching = !1, this.moved = !1, this.parent.emit("pinch-end", this.parent), !0) : !1;
  }
}
const cb = {
  axis: "all",
  interrupt: !0,
  keyToPress: void 0,
  lineHeight: 20,
  percent: 0.1,
  position: void 0,
  reverse: !1,
  smooth: !1,
  trackpadPinch: !1,
  wheelZoom: !0
};
class ub extends Ht {
  /**
   * This is called by {@link Viewport.wheel}.
   */
  constructor(e, n = {}) {
    super(e), rn(this, "options"), rn(this, "keyIsPressed"), rn(this, "smoothing"), rn(this, "smoothingCenter"), rn(this, "smoothingCount"), this.options = Object.assign({}, cb, n), this.keyIsPressed = !1, this.options.keyToPress && this.handleKeyPresses(this.options.keyToPress);
  }
  down() {
    return this.options.interrupt && (this.smoothing = void 0), !1;
  }
  update() {
    if (this.smoothing) {
      const e = this.smoothingCenter, n = this.smoothing;
      let s;
      this.options.position || (s = this.parent.toLocal(e)), this.isAxisX() && (this.parent.scale.x += n.x), this.isAxisY() && (this.parent.scale.y += n.y), this.parent.emit("zoomed", {
        type: "wheel",
        viewport: this.parent
      });
      const o = this.parent.plugins.get("clamp-zoom", !0);
      if (o && o.clamp(), this.options.position)
        this.options.position();
      else {
        const a = this.parent.toGlobal(s);
        this.parent.x += e.x - a.x, this.parent.y += e.y - a.y;
      }
      this.parent.emit("moved", { type: "wheel", viewport: this.parent }), this.smoothingCount++, this.options.smooth && // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      this.smoothingCount >= this.options.smooth && (this.smoothing = void 0);
    }
  }
  wheel(e) {
    if (this.paused || !this.checkKeyPress())
      return !1;
    if (e.ctrlKey && this.options.trackpadPinch)
      this.pinch(e);
    else if (this.options.wheelZoom) {
      const n = this.parent.input.getPointerPosition(e), s = (this.options.reverse ? -1 : 1) * -e.deltaY * (e.deltaMode ? this.options.lineHeight : 1) / 500, o = Math.pow(2, (1 + this.options.percent) * s);
      if (this.options.smooth) {
        const a = {
          x: this.smoothing ? this.smoothing.x * // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          (this.options.smooth - this.smoothingCount) : 0,
          y: this.smoothing ? this.smoothing.y * // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          (this.options.smooth - this.smoothingCount) : 0
        };
        this.smoothing = {
          x: ((this.parent.scale.x + a.x) * o - this.parent.scale.x) / this.options.smooth,
          y: ((this.parent.scale.y + a.y) * o - this.parent.scale.y) / this.options.smooth
        }, this.smoothingCount = 0, this.smoothingCenter = n;
      } else {
        let a;
        this.options.position || (a = this.parent.toLocal(n)), this.isAxisX() && (this.parent.scale.x *= o), this.isAxisY() && (this.parent.scale.y *= o), this.parent.emit("zoomed", {
          type: "wheel",
          viewport: this.parent
        });
        const i = this.parent.plugins.get("clamp-zoom", !0);
        if (i && i.clamp(), this.options.position)
          this.options.position();
        else {
          const r = this.parent.toGlobal(a);
          this.parent.x += n.x - r.x, this.parent.y += n.y - r.y;
        }
      }
      this.parent.emit("moved", { type: "wheel", viewport: this.parent }), this.parent.emit("wheel-start", {
        event: e,
        viewport: this.parent
      });
    }
    return !this.parent.options.passiveWheel;
  }
  checkKeyPress() {
    return !this.options.keyToPress || this.keyIsPressed;
  }
  /**
   * Handles keypress events and set the keyIsPressed boolean accordingly
   *
   * @param {array} codes - key codes that can be used to trigger zoom event
   */
  handleKeyPresses(e) {
    globalThis.addEventListener("keydown", (n) => {
      e.includes(n.code) && (this.keyIsPressed = !0);
    }), globalThis.addEventListener("keyup", (n) => {
      e.includes(n.code) && (this.keyIsPressed = !1);
    });
  }
  isAxisX() {
    return ["all", "x"].includes(this.options.axis);
  }
  isAxisY() {
    return ["all", "y"].includes(this.options.axis);
  }
  pinch(e) {
    if (this.paused)
      return;
    const n = this.parent.input.getPointerPosition(e), s = -e.deltaY * (e.deltaMode ? this.options.lineHeight : 1) / 200, o = Math.pow(2, (1 + this.options.percent) * s);
    let a;
    this.options.position || (a = this.parent.toLocal(n)), this.isAxisX() && (this.parent.scale.x *= o), this.isAxisY() && (this.parent.scale.y *= o), this.parent.emit("zoomed", { type: "wheel", viewport: this.parent });
    const i = this.parent.plugins.get("clamp-zoom", !0);
    if (i && i.clamp(), this.options.position)
      this.options.position();
    else {
      const r = this.parent.toGlobal(a);
      this.parent.x += n.x - r.x, this.parent.y += n.y - r.y;
    }
    this.parent.emit("moved", { type: "wheel", viewport: this.parent }), this.parent.emit("wheel-start", {
      event: e,
      viewport: this.parent
    });
  }
}
const db = {
  stage: void 0
};
class pb extends Ht {
  constructor(e, n = {}) {
    super(e), rn(this, "options"), rn(this, "last"), this.options = Object.assign({}, db, n), this.update();
  }
  move() {
    return this.update(), !1;
  }
  reset() {
    this.update();
  }
  update() {
    if (this.paused) return;
    let e, n;
    const s = this.options.stage;
    s ? (e = _n(
      this.parent.x,
      -this.parent.screenWorldWidth + s.x,
      s.x + s.width
    ), n = _n(
      this.parent.y,
      -this.parent.screenWorldHeight + s.y,
      s.y + s.height
    )) : (e = _n(
      this.parent.x,
      -this.parent.screenWorldWidth,
      this.parent.screenWidth
    ), n = _n(
      this.parent.y,
      -this.parent.screenWorldHeight,
      this.parent.screenHeight
    )), this.parent.position.set(e, n);
  }
}
const mb = ["text"], hb = ["context"], fb = /* @__PURE__ */ J({
  __name: "DebugInfo",
  props: {
    stage: {}
  },
  setup(t) {
    const e = t, { stage: n } = we(e), s = N(0);
    let o = 0, a = Date.now();
    Ps(() => {
      if (o === 0) {
        const r = Date.now(), c = r - a;
        a = r, s.value = 3e4 / c;
      }
      o = (o + 1) % 30;
    });
    const i = new fa();
    return re(() => {
      i.clear(), n.value && i.rect(
        n.value.x,
        n.value.y,
        n.value.width,
        n.value.height
      ).stroke({ alignment: 0, color: 16711935, width: 5 });
    }), (r, c) => ($(), I(me, null, [
      x("PixiText", {
        text: `FPS: ${Math.round(s.value * 100) / 100}`,
        style: { fontSize: 20 }
      }, null, 8, mb),
      x("PixiGraphics", { context: l(i) }, null, 8, hb)
    ], 64));
  }
}), _b = ["events", "screen-width", "screen-height", "world-width", "world-height"], Oo = /* @__PURE__ */ J({
  __name: "DesignerCore",
  props: {
    clampZoom: {},
    debug: { type: Boolean },
    draggable: { type: Boolean },
    stage: {}
  },
  emits: ["click", "update:zoom"],
  setup(t, { expose: e, emit: n }) {
    const s = t, { clampZoom: o, debug: a, draggable: i, stage: r } = we(s), c = n, u = N(), d = N(), m = N(), _ = A(() => {
      var ee;
      return (ee = u.value) == null ? void 0 : ee.canvas;
    }), g = N(), v = N([]), z = N([]), {
      onPointerdown: h,
      onPointerup: y
    } = ib((ee) => {
      c("click", ee);
    }), { devicePixelRatio: w } = D(im()), P = N({ height: 5, width: 5 });
    re((ee) => {
      if (!_.value) return;
      const G = new ResizeObserver(([oe]) => {
        var _e;
        oe && (P.value = (_e = oe.devicePixelContentBoxSize) != null && _e[0] ? {
          height: Math.max(
            oe.devicePixelContentBoxSize[0].blockSize / w.value,
            5
          ),
          width: Math.max(
            oe.devicePixelContentBoxSize[0].inlineSize / w.value,
            5
          )
        } : {
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          height: Math.max(oe.contentBoxSize[0].blockSize, 5),
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          width: Math.max(oe.contentBoxSize[0].inlineSize, 5)
        });
      });
      try {
        G.observe(_.value, {
          box: "device-pixel-content-box"
        });
      } catch {
        G.observe(_.value, { box: "content-box" });
      }
      ee(() => {
        G.disconnect();
      });
    });
    const M = A(() => {
      var ee, G;
      const oe = r.value ?? P.value;
      return {
        height: Math.max(oe.height, 5),
        width: Math.max(oe.width, 5),
        x: ((ee = r.value) == null ? void 0 : ee.x) ?? 0,
        y: ((G = r.value) == null ? void 0 : G.y) ?? 0
      };
    });
    it(M, (ee, G) => {
      const oe = d.value;
      if (!oe) return;
      const _e = Math.min(ee.height, ee.width) / Math.min(G.height, G.width) * oe.scale.x;
      te(
        ia(
          Sr(oe.position, oe.scale.x, G),
          _e,
          ee
        ),
        _e,
        !1
      );
    });
    const E = A(
      () => g.value ? Math.min(
        M.value.width / g.value.width,
        M.value.height / g.value.height
      ) : 1
    ), R = A(
      () => o.value ? {
        max: o.value.max * E.value,
        min: o.value.min * E.value
      } : void 0
    ), j = A(
      () => {
        var ee;
        return (ee = u.value) != null && ee.isInitialized ? u.value.app.ticker : void 0;
      }
    ), V = N(1);
    Ps(
      () => {
        var ee;
        V.value = ((ee = d.value) == null ? void 0 : ee.scale.x) ?? 1;
      },
      { ticker: j }
    );
    const X = N();
    Ps(
      ({ deltaTime: ee }) => {
        const G = X.value;
        if (!G) return;
        const oe = d.value;
        if (!oe) return;
        const { scale: _e } = oe;
        Fu(
          _e,
          G,
          ee
        ) < 1e-3 && (_e.set(G), X.value = void 0);
      },
      { enabled: () => !!(X.value && d.value), ticker: j }
    );
    const Z = N();
    Ps(
      ({ deltaTime: ee }) => {
        const G = Z.value;
        if (!G) return;
        const oe = d.value;
        if (!oe) return;
        const { position: _e } = oe;
        Fu(
          _e,
          G,
          ee
        ) < 0.5 && (_e.set(G.x, G.y), Z.value = void 0);
      },
      {
        enabled: () => !!(Z.value && d.value),
        ticker: j
      }
    );
    const ae = A(
      () => X.value !== void 0 || Z.value !== void 0
    );
    function K({ height: ee, width: G, x: oe, y: _e }, de = !0) {
      const $e = M.value, Ze = R.value, Pe = _n(
        Math.min($e.width / G, $e.height / ee),
        (Ze == null ? void 0 : Ze.min) ?? 0,
        (Ze == null ? void 0 : Ze.max) ?? 1 / 0
      );
      te(
        ia({ x: G / 2 + oe, y: ee / 2 + _e }, Pe, $e),
        Pe,
        de
      );
    }
    function te(ee, G, oe = !0) {
      if (oe)
        X.value = G, Z.value = ee;
      else {
        const _e = d.value;
        if (!_e) throw new Error("Viewport not initialized yet");
        _e.scale.set(G), _e.position.set(ee.x, ee.y);
      }
    }
    function ue(ee, G = !0) {
      const oe = d.value;
      if (!oe) return;
      const _e = M.value, de = R.value, $e = _n(
        ee * E.value,
        (de == null ? void 0 : de.min) ?? 0,
        (de == null ? void 0 : de.max) ?? 1 / 0
      );
      te(
        ia(
          Sr(oe.position, oe.scale.x, _e),
          $e,
          _e
        ),
        $e,
        G
      );
    }
    re(() => {
      c(
        "update:zoom",
        (X.value ?? V.value) / E.value
      );
    }), re(() => {
      const ee = d.value;
      if (!ee) return;
      ee.drag({ wheel: !1 }).decelerate({ friction: 0.9 }).clampZoom({});
      const G = ee.plugins;
      G.add(
        "wheel",
        new ub(ee, { smooth: 10 })
      ), G.add("pinch", new lb(ee)), G.add("clamp", new pb(ee));
    }), re(() => {
      const ee = d.value;
      if (!ee) return;
      const G = ee.plugins.get("clamp");
      G && (G.options.stage = { ...M.value });
    }), re(() => {
      const ee = d.value;
      if (!ee) return;
      const G = ee.plugins, oe = G.get("wheel"), _e = G.get("pinch"), de = G.get("clamp-zoom");
      R.value ? (oe == null || oe.resume(), _e == null || _e.resume(), de && (de.options.minScale = R.value.min, de.options.maxScale = R.value.max, de.resume())) : (oe == null || oe.pause(), _e == null || _e.pause(), de && (de.pause(), de.options.minScale = null, de.options.maxScale = null));
    }), re(() => {
      const ee = d.value;
      if (!ee) return;
      const G = ee.plugins, oe = G.get("wheel"), _e = G.get("pinch"), de = G.get("drag");
      if (i.value)
        de == null || de.resume(), oe && (oe.options.position = void 0), _e && (_e.options.position = void 0, _e.options.noDrag = !1);
      else {
        let $e = function() {
          const Pe = d.value;
          if (!Pe) return;
          const { x: ie, y: ve } = ia(
            Ze,
            Pe.scale.x,
            M.value
          );
          Pe.position.set(ie, ve);
        };
        de == null || de.pause();
        const Ze = Sr(
          ee.position,
          ee.scale.x,
          M.value
        );
        oe && (oe.options.position = $e), _e && (_e.options.position = $e, _e.options.noDrag = !0);
      }
    });
    function Ce(ee) {
      h(ee), Z.value = void 0, X.value = void 0;
    }
    function ne() {
      Z.value = void 0, X.value = void 0;
    }
    return ps(Hs, {
      clampScale: R,
      fetching: z,
      rendering: v,
      scaleMultiplier: E,
      setPosition: K,
      topLayer: m,
      worldScale: V,
      worldSize: g
    }), e({ canvas: _, setPosition: K, setZoom: ue }), (ee, G) => ($(), q(l(Q2), {
      ref_key: "appData",
      ref: u,
      "background-color": 16777215,
      width: P.value.width,
      height: P.value.height,
      resolution: l(w),
      "data-animating": ae.value,
      "data-rendering": v.value.length > 0,
      "data-fetching": z.value.length > 0,
      preference: "webgl",
      "power-preference": "low-power",
      "preserve-drawing-buffer": !0,
      legacy: !0,
      "auto-density": !1,
      antialias: !0
    }, {
      default: C(() => {
        var oe, _e, de;
        return [
          (oe = u.value) != null && oe.isInitialized && P.value ? ($(), I("PixiViewport", {
            key: 0,
            ref_key: "viewport",
            ref: d,
            events: u.value.app.renderer.events,
            "allow-preserve-drag-outside": !0,
            "passive-wheel": !1,
            "stop-propagation": !0,
            "screen-width": P.value.width,
            "screen-height": P.value.height,
            "world-width": (_e = g.value) == null ? void 0 : _e.width,
            "world-height": (de = g.value) == null ? void 0 : de.height,
            onPointerdown: Ce,
            onPointerup: G[0] || (G[0] = //@ts-ignore
            (...$e) => l(y) && l(y)(...$e)),
            onWheel: ne
          }, [
            St(ee.$slots, "default"),
            x("PixiRenderLayer", {
              ref_key: "topLayer",
              ref: m
            }, null, 512)
          ], 40, _b)) : Q("", !0),
          l(a) ? ($(), q(fb, {
            key: 1,
            stage: M.value
          }, null, 8, ["stage"])) : Q("", !0)
        ];
      }),
      _: 3
    }, 8, ["width", "height", "resolution", "data-animating", "data-rendering", "data-fetching"]));
  }
}), vb = ["position", "event-mode", "cursor"], gb = /* @__PURE__ */ J({
  __name: "Draggable",
  props: {
    disabled: { type: Boolean }
  },
  emits: ["update:point"],
  setup(t, { emit: e }) {
    const n = t, { disabled: s } = we(n), o = e, a = N(), i = N(), r = N(), c = A(() => {
      if (!r.value || !i.value || !a.value)
        return { x: 0, y: 0 };
      const _ = a.value.parent.worldTransform.applyInverse(
        r.value
      );
      return {
        x: _.x - i.value.x,
        y: _.y - i.value.y
      };
    });
    re(() => {
      o("update:point", r.value);
    });
    function u(_) {
      i.value && (_ == null || _.stopPropagation(), i.value = void 0, r.value = void 0);
    }
    function d(_) {
      s.value || !r.value || r.value.copyFrom(_.global);
    }
    function m(_) {
      s.value || !a.value || (_.stopPropagation(), i.value = a.value.worldTransform.applyInverse(_.global), r.value = _.global.clone(), d(_));
    }
    return it(s, () => {
      s.value && u();
    }), (_, g) => ($(), I("PixiContainer", {
      ref_key: "container",
      ref: a,
      label: "Draggable",
      position: c.value,
      "event-mode": l(s) ? "passive" : "static",
      cursor: r.value ? "grabbing" : "grab",
      onPointerdown: m,
      onGlobalpointermove: d,
      onPointerup: u,
      onPointerupoutside: u,
      onPointercancel: u
    }, [
      St(_.$slots, "default")
    ], 40, vb));
  }
});
function kb(t, e, n, s) {
  let o = 0, a = 0;
  for (let i = 0; i < e.length; i++) {
    const r = e[i], c = e[(i + 1) % e.length], u = c.x - r.x, d = c.y - r.y, m = Math.hypot(u, d), _ = { x: u / m, y: d / m };
    let g = 0;
    for (t.moveTo(
      r.x + a * _.x,
      r.y + a * _.y
    ); g <= m; )
      g += a + (o > 0 ? o : n), g > m ? (o = g - m, g = m) : o = 0, t.lineTo(
        r.x + g * _.x,
        r.y + g * _.y
      ), g += s, g > m && o === 0 ? a = g - m : (a = 0, t.moveTo(
        r.x + g * _.x,
        r.y + g * _.y
      ));
  }
}
const yb = ["x", "y", "pivot", "angle"], bb = ["context"], wb = ["resolution", "text", "position"], Ro = /* @__PURE__ */ J({
  __name: "PositioningArea",
  props: {
    data: {},
    fillColor: { default: () => new Uint8Array([0, 0, 0, 0]) },
    hidden: { type: Boolean },
    strokeColor: { default: 4605510 }
  },
  setup(t) {
    const e = t, { data: n, fillColor: s, hidden: o, strokeColor: a } = we(e), { devicePixelRatio: i } = D(im()), { clampScale: r, scaleMultiplier: c, worldScale: u } = Ft(Hs), d = A(
      () => r.value ? 7 / c.value : 14 / u.value
    ), m = A(
      () => r.value ? 5 / c.value : 10 / u.value
    ), _ = A(
      () => r.value ? Math.max(2 / c.value, 1 / u.value) : 4 / u.value
    ), g = new fa();
    re(() => {
      g.clear(), !o.value && (kb(
        g,
        [
          { x: 0, y: 0 },
          { x: n.value.width, y: 0 },
          { x: n.value.width, y: n.value.height },
          { x: 0, y: n.value.height }
        ],
        d.value,
        m.value
      ), g.stroke({
        alignment: 1,
        color: a.value,
        width: _.value
      }), g.rect(0, 0, n.value.width, n.value.height).fill({ color: s.value }));
    });
    const v = A(() => ({
      x: n.value.width * // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      Rs(n.value.position[1]),
      y: n.value.height * // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      Rs(n.value.position[0])
    })), z = A(
      () => Math.max(16 / c.value, 12 / u.value)
    ), h = A(
      () => {
        var w;
        return Math.min(
          i.value * Math.max(((w = r.value) == null ? void 0 : w.max) ?? u.value, 1),
          // fontSize * textResolution should be capped at 3500 because otherwise
          // the designer starts to lag, trying to render very large texts
          3500 / z.value
        );
      }
    ), y = A(() => ({
      x: n.value.width / 2,
      y: n.value.height / 2
    }));
    return ps(Ws, { data: n }), (w, P) => ($(), I("PixiContainer", {
      label: "PositioningArea",
      x: l(n).x,
      y: l(n).y,
      pivot: v.value,
      angle: l(n).rotation
    }, [
      x("PixiGraphics", {
        label: "PositioningArea_Graphics",
        context: l(g)
      }, null, 8, bb),
      l(n).handle && l(n).designs.length === 0 && !l(o) ? ($(), I("PixiText", {
        key: 0,
        resolution: h.value,
        text: l(n).handle,
        style: Kt({
          fill: l(a),
          fontSize: z.value,
          fontWeight: "600",
          trim: !0
        }),
        position: y.value,
        anchor: {
          x: 0.5,
          y: 0.5
        }
      }, null, 12, wb)) : Q("", !0),
      St(w.$slots, "default")
    ], 8, yb));
  }
}), Ia = { height: 580, width: 520 };
function ys(t) {
  return t.elements.length > 0 ? {
    children: t.elements.map((e) => ({
      anchor: e.alignment.anchor_value,
      offset: {
        x: e.alignment.offset.x,
        y: e.alignment.offset.y
      },
      value: ys(e)
    })),
    parent: qu(t),
    type: ze.ANCHOR
  } : qu(t);
}
function Il(t) {
  let e;
  return t.width !== null && t.height !== null && t.min_width !== null && t.min_height !== null && t.max_width !== null && t.max_height !== null && t.min_width < t.max_width && t.min_height < t.max_height && (e = { height: t.height, width: t.width }), {
    colorAssignments: t.color_assignments.map((n) => ({
      id: n.id,
      color: n.color ? { id: n.color.id } : {
        blue: n.blue,
        green: n.green,
        red: n.red
      }
    })),
    logoId: t.id,
    size: e,
    type: ze.LOGO
  };
}
function rm(t, e) {
  return {
    id: t.id,
    designs: e.customizations.filter(
      (n) => n.positioningArea.id === t.id
    ).map((n) => ({
      design: ys(
        n.design.elements[0]
      ),
      rotation: n.rotation - t.rotation
    })),
    handle: t.positioning_area_identifier_handle ?? void 0,
    height: t.localized_height,
    position: t.position,
    productionMethodId: t.production_method.id,
    rotation: t.rotation,
    width: t.localized_width,
    x: t.x / e.scalefactor,
    y: t.y / e.scalefactor
  };
}
function El(t) {
  return {
    handle: t.handle,
    height: Ia.height / t.scalefactor,
    imageUrl: t.image_urls.xl,
    positioningAreas: [...t.positioning_areas].sort((e, n) => e.order_column - n.order_column).map(
      (e) => rm(e, t)
    ),
    width: Ia.width / t.scalefactor
  };
}
function Ls({
  design: t,
  productionMethodId: e
}) {
  switch (t.type) {
    case ze.ANCHOR:
      return {
        ...Ls({
          design: t.parent,
          productionMethodId: e
        }),
        elements: t.children.map((n) => ({
          ...Ls({
            design: n.value,
            productionMethodId: e
          }),
          alignment: {
            anchor_type: Fs.OUTER,
            anchor_value: n.anchor,
            offset: { x: n.offset.x, y: n.offset.y },
            rotation: 0
          }
        }))
      };
    case ze.LOGO:
      return {
        dimension: t.size,
        elements: [],
        resource: {
          id: t.logoId,
          color_assignments: t.colorAssignments.map(
            ({ id: n, color: s }) => "id" in s ? { id: n, color: { id: s.id } } : {
              id: n,
              blue: s.blue,
              green: s.green,
              red: s.red
            }
          ),
          production_method: { id: e }
        },
        resource_type: "logo"
      };
    case ze.TEXT:
      return {
        elements: [],
        resource: {
          lines: t.lines.map((n) => ({
            bending_radius: n.bendingRadius,
            color_assignments: [
              "id" in n.color ? { color: { id: n.color.id } } : {
                blue: n.color.blue,
                green: n.color.green,
                red: n.color.red
              }
            ],
            font: { id: n.fontId },
            font_size: n.size,
            horizontal_alignment: n.horizontalAlignment,
            offset: n.offsetLeft,
            order_column: 1,
            padding_bottom: n.paddingBottom,
            value: n.text
          })),
          production_method: { id: e }
        },
        resource_type: "text"
      };
  }
}
function lm(t) {
  return {
    customizations: t.positioningAreas.filter((e) => !!e.id).flatMap(
      (e) => e.designs.flatMap((n) => ({
        design: {
          elements: [
            Ls({
              design: n.design,
              productionMethodId: e.productionMethodId
            })
          ],
          production_method: {
            id: e.productionMethodId
          }
        },
        order: 0,
        position: xb(
          e,
          n
        ),
        positioning_area: {
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          id: e.id
        },
        rotation: n.rotation + e.rotation,
        x: Math.round(
          Ia.width / t.width * e.x
        ),
        y: Math.round(
          Ia.height / t.height * e.y
        )
      }))
    ),
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    handle: t.handle
  };
}
function qu(t) {
  return t.resource_type === "text" ? {
    lines: t.resource.lines.map((e) => {
      const n = e.color_assignments[0];
      return {
        bendingRadius: e.bending_radius,
        color: n.color ? { id: n.color.id } : {
          blue: n.blue,
          green: n.green,
          red: n.red
        },
        fontId: e.font.id,
        horizontalAlignment: e.horizontal_alignment,
        offsetLeft: e.offset,
        paddingBottom: e.padding_bottom,
        size: e.font_size,
        text: e.value
      };
    }),
    type: ze.TEXT
  } : {
    colorAssignments: t.resource.color_assignments.map(
      (e) => ({
        id: e.id,
        color: e.color ? { id: e.color.id } : {
          blue: e.blue,
          green: e.green,
          red: e.red
        }
      })
    ),
    logoId: t.resource.id,
    size: t.dimension ? {
      height: t.dimension.height,
      width: t.dimension.width
    } : void 0,
    type: ze.LOGO
  };
}
function xb(t, e) {
  const n = n2(
    t.position
  );
  return n === void 0 ? t.position : t2(
    Ya(
      n - e.rotation
    )
  ) ?? t.position;
}
function Ea(t) {
  switch (t.type) {
    case ze.ANCHOR: {
      const e = Ea(t.parent);
      if (!e)
        throw new Error(
          "Normalized parent of anchor design is undefined"
        );
      const n = t.children.map((s) => {
        const o = Ea(s.value);
        return o ? { ...s, value: o } : void 0;
      }).filter((s) => s !== void 0);
      return n.length === 0 ? e : {
        children: n,
        parent: e,
        type: ze.ANCHOR
      };
    }
    case ze.LOGO:
      return t;
    case ze.TEXT: {
      const e = {
        lines: t.lines.map((n) => ({ ...n, text: n.text.trim() })).filter((n) => n.text),
        type: ze.TEXT
      };
      return e.lines.length === 0 ? void 0 : e;
    }
  }
}
function ei(t, e) {
  const n = A(
    () => t.value ? Ea(t.value.design) : void 0
  ), s = A(() => (e == null ? void 0 : e.value) ?? !0), o = A(() => {
    if (!t.value || !n.value) return;
    const g = t.value.productionMethodId;
    return {
      elements: [
        Ls({
          design: n.value,
          productionMethodId: g
        })
      ],
      production_method: { id: g }
    };
  }), a = ce.designs.preview.use(
    o
  ), {
    data: i,
    error: r,
    fetchStatus: c,
    status: u
  } = bt({
    ...a,
    enabled: A(() => !!o.value && s.value),
    queryFn: sf(a.queryFn, 1e3, {
      rejectOnCancel: !0
    }),
    retry: !1,
    staleTime: 1 / 0
  }), d = N(i.value);
  re(() => {
    i.value && (d.value = i.value);
  });
  const m = A(() => {
    if (d.value)
      return {
        height: d.value.height,
        width: d.value.width
      };
  }), _ = A(() => {
    var g;
    const v = (g = d.value) == null ? void 0 : g.content;
    return v != null && v.startsWith("https://") ? v : v ? `data:image/jpeg;base64,${v}` : void 0;
  });
  return {
    error: r,
    fetchStatus: c,
    imageUrl: _,
    normalizedDesign: n,
    size: m,
    status: u
  };
}
function $b(t, e) {
  const n = id(Hs), {
    error: s,
    fetchStatus: o,
    imageUrl: a,
    normalizedDesign: i,
    size: r,
    status: c
  } = ei(t), {
    data: u,
    error: d,
    fetchStatus: m,
    isPlaceholderData: _,
    status: g
  } = Cl(a, {
    placeholder: A(() => {
      var h;
      const y = an(e);
      if (!y || !r.value) return;
      const w = Math.max(
        ((h = n == null ? void 0 : n.clampScale.value) == null ? void 0 : h.max) ?? (n == null ? void 0 : n.worldScale.value) ?? 1,
        1
      );
      return {
        height: r.value.height * w,
        radius: y.radius * w,
        width: r.value.width * w
      };
    })
  }), v = A(
    () => c.value === "success" ? g.value : c.value
  ), z = A(
    () => o.value === "idle" ? m.value : o.value
  );
  return {
    error: A(
      () => s.value ?? d.value ?? void 0
    ),
    fetchStatus: z,
    isPlaceholderData: _,
    normalizedDesign: i,
    size: r,
    status: v,
    texture: u
  };
}
const zb = ["angle", "pivot", "position"], Lo = /* @__PURE__ */ J({
  __name: "PositioningAreaDesign",
  props: {
    data: {},
    placeholder: {}
  },
  emits: ["update:boundingBox", "update:error", "update:fetchStatus", "update:size", "update:status"],
  setup(t, { emit: e }) {
    const n = t, { data: s, placeholder: o } = we(n), a = e, { data: i } = Ft(Ws), { error: r, fetchStatus: c, isPlaceholderData: u, size: d, status: m, texture: _ } = $b(
      A(() => ({
        design: s.value.design,
        productionMethodId: i.value.productionMethodId
      })),
      o
    );
    re(() => {
      a("update:error", r.value);
    }), re(() => {
      a("update:fetchStatus", c.value);
    }), re(() => {
      a("update:size", d.value);
    }), re(() => {
      a("update:status", m.value);
    });
    const g = A(
      () => d.value ? {
        x: d.value.width / 2,
        y: d.value.height / 2
      } : void 0
    ), v = A(
      () => d.value && g.value ? Pl(d.value, g.value, s.value.rotation) : void 0
    );
    re(() => {
      a("update:boundingBox", v.value);
    });
    const z = A(() => {
      if (!v.value) return;
      const h = i.value.position[1], y = i.value.position[0], w = i.value.width * Rs(h), P = i.value.height * Rs(y);
      let M = 0;
      h === "l" ? M = v.value.left : h === "r" && (M = v.value.right);
      let E = 0;
      return y === "t" ? E = v.value.top : y === "b" && (E = v.value.bottom), {
        x: w - M,
        y: P - E
      };
    });
    return ps(Tl, {
      error: r,
      fetchStatus: c,
      isPlaceholderData: u,
      placeholderColor: A(() => {
        var h;
        return (h = o.value) == null ? void 0 : h.color;
      }),
      size: d,
      status: m,
      texture: _
    }), ps(nm, { data: s }), (h, y) => g.value && z.value ? ($(), I("PixiContainer", {
      key: 0,
      label: "PositioningAreaDesign",
      angle: l(s).rotation,
      pivot: g.value,
      position: z.value
    }, [
      St(h.$slots, "default", {}, () => [
        b(am)
      ])
    ], 8, zb)) : Q("", !0);
  }
}), Sb = /* @__PURE__ */ J({
  __name: "TopLayerTeleport",
  props: {
    disabled: { type: Boolean }
  },
  setup(t) {
    const e = t, { disabled: n } = we(e), { topLayer: s } = Ft(Hs), o = N();
    return re((a) => {
      const i = s.value, r = o.value;
      n.value || !i || !r || (i.attach(r), a(() => {
        i.detach(r);
      }));
    }), (a, i) => ($(), I("PixiContainer", {
      ref_key: "container",
      ref: o,
      label: "TopLayerTeleport"
    }, [
      St(a.$slots, "default")
    ], 512));
  }
}), Ab = ["texture", "width", "height", "alpha", "tint"], Do = /* @__PURE__ */ J({
  __name: "View",
  props: {
    data: {},
    hidden: { type: Boolean },
    initialPosition: {},
    placeholder: {}
  },
  setup(t) {
    const e = t, { data: n, hidden: s, initialPosition: o, placeholder: a } = we(e), { clampScale: i, setPosition: r, worldScale: c, worldSize: u } = Ft(Hs);
    re(() => {
      s.value || (u.value = {
        height: n.value.height,
        width: n.value.width
      });
    });
    function d() {
      s.value || r(
        o.value ?? {
          height: n.value.height,
          width: n.value.width,
          x: 0,
          y: 0
        },
        !1
      );
    }
    od(d), it(s, d);
    const {
      data: m,
      isFetching: _,
      isPlaceholderData: g
    } = Cl(
      A(() => n.value.imageUrl),
      {
        disabled: s,
        placeholder: A(() => {
          var h;
          if (!a.value) return;
          const y = Math.max(
            ((h = i.value) == null ? void 0 : h.max) ?? c.value,
            1
          );
          return {
            height: n.value.height * y,
            radius: a.value.radius * y,
            width: n.value.width * y
          };
        })
      }
    ), v = N(1);
    Ps(
      (h) => {
        v.value = Math.sin(h.lastTime / 1e3 * Math.PI) * 0.25 + 0.5;
      },
      { enabled: _ }
    );
    const z = N();
    return ps(Ml, { container: z, data: n, texture: m }), (h, y) => {
      var w;
      return l(s) ? Q("", !0) : ($(), I("PixiContainer", {
        key: 0,
        ref_key: "container",
        ref: z,
        label: "View"
      }, [
        x("PixiSprite", {
          label: "View_Sprite",
          texture: l(m),
          width: l(n).width,
          height: l(n).height,
          alpha: l(_) ? v.value : 1,
          tint: l(g) ? (w = l(a)) == null ? void 0 : w.color : void 0
        }, null, 8, Ab),
        St(h.$slots, "default")
      ], 512));
    };
  }
});
function Cb(t) {
  const e = _t(t);
  return bt({
    enabled: A(() => !!e.value),
    queryFn: () => new Promise((n, s) => {
      const o = new Image();
      o.addEventListener("load", () => {
        n(o);
      }), o.addEventListener("error", s), o.crossOrigin = "Anonymous", o.src = e.value;
    }),
    queryKey: ["image", e],
    retry: !1,
    staleTime: 1 / 0
  });
}
function Pb(t, e, n) {
  const s = [], o = new Map(
    t.colors.map((i) => [i.id, i])
  ), a = t.productionMethods.find(
    (i) => i.id === n
  );
  for (const i of e) {
    const r = Mb(i, o, a);
    s.push({
      color: i,
      status: r
    });
  }
  return s;
}
function Mb(t, e, n) {
  var s;
  return n ? "id" in t ? (s = e.get(t.id)) != null && s.production_methods.some(
    (o) => o.id === n.id
  ) ? "valid" : "color_not_found" : n.is_using_color_picker ? "valid" : "rgb_not_supported" : "color_not_found";
}
function Tb(t, e, n) {
  var s;
  const o = /* @__PURE__ */ new Set();
  for (const a of e)
    (s = t.fonts.find((i) => i.id === a)) != null && s.production_methods.find(
      (i) => i.id === n
    ) || o.add(a);
  return o;
}
function Ib(t, e) {
  const n = [], s = new Map(
    t.fonts.map((o) => [o.id, o])
  );
  for (const { fontId: o, size: a } of e) {
    const i = s.get(o), r = Eb(a, i);
    n.push({
      fontId: o,
      size: a,
      status: r
    });
  }
  return n;
}
function Eb(t, e) {
  return e ? t < (e.min ?? 0) ? "too_small" : t > (e.max ?? 1 / 0) ? "too_large" : "valid" : "font_not_found";
}
function Oa(t, e, n) {
  const s = e.map(({ fontId: d }) => d), o = Tb(
    t,
    s,
    n
  ), a = e.map(({ fontId: d, size: m }) => ({ fontId: d, size: m })), i = Ib(t, a), r = e.map(({ color: d }) => d), c = Pb(
    t,
    r,
    n
  ), u = [];
  for (const [d, m] of e.entries()) {
    const _ = {};
    o.has(m.fontId) && (_.font = "not_available");
    const g = i[d];
    (g == null ? void 0 : g.status) !== "valid" && (_.size = g == null ? void 0 : g.status);
    const v = c[d];
    (v == null ? void 0 : v.status) !== "valid" && (_.color = v == null ? void 0 : v.status), Object.keys(_).length > 0 && u.push({
      invalidProperties: _,
      textLine: m
    });
  }
  return u;
}
function gs(t, e) {
  const {
    data: n,
    fetchStatus: s,
    status: o
  } = bt(ce.configurations.app.get.use()), a = _t(t), i = _t(e), r = A(() => {
    if (n.value && a.value !== void 0 && i.value !== void 0)
      return Oa(
        n.value,
        a.value,
        i.value
      );
  });
  return {
    allTextLinesSupported: A(() => {
      if (r.value)
        return r.value.length === 0;
    }),
    fetchStatus: s,
    status: o,
    unsupportedTextLines: r
  };
}
function Ob(t) {
  const e = _t(t), n = lt(), s = en(
    (u) => n.fetchQuery({
      ...ce.customerLogos.get.use(u),
      retry: !1,
      staleTime: 1 / 0
    })
  ), { mutateAsync: o } = yt(
    ce.customerLogos.temporaryUploadUrl.use()
  ), { mutateAsync: a } = yt(
    ce.customerLogos.post.use()
  );
  let i;
  const r = {};
  Dt("customerLogo.completed", ({ id: u }) => {
    r[u] = "completed", (i == null ? void 0 : i.pendingCustomerLogoId) === u && (i.resolve(), i = void 0);
  }), Dt("customerLogo.failed", ({ id: u, message: d }) => {
    if (r[u] = "failed", (i == null ? void 0 : i.pendingCustomerLogoId) === u) {
      switch (d) {
        case "SVG logo contains images.":
          i.reject(
            e.value.ERROR_SVG_CONTAINS_IMAGE
          );
          break;
        case "SVG logo contains texts.":
          i.reject(
            e.value.ERROR_SVG_CONTAINS_TEXT
          );
          break;
        default:
          i.reject(e.value.ERROR_UNEXPECTED);
      }
      i = void 0;
    }
  });
  async function c({
    file: u,
    productionMethodId: d
  }) {
    const { path: m, url: _ } = await o({
      content_type: u.type,
      file_name: u.name
    });
    await Rb(_, u);
    try {
      const g = await a({
        path: m,
        production_method_id: d
      });
      if (g in r) {
        if (r[g] === "failed")
          throw new Error("Failed to render customer logo");
      } else {
        const { promise: v, reject: z, resolve: h } = Promise.withResolvers();
        i = {
          pendingCustomerLogoId: g,
          reject: z,
          resolve: h
        }, await v;
      }
      return await s(g);
    } catch (g) {
      throw g instanceof Hn ? g : typeof g == "string" ? new Ma(g) : new Ma(
        e.value.ERROR_UNEXPECTED
      );
    }
  }
  return { mutationFn: c };
}
function Rb(t, e) {
  return Ud.put(t, {
    body: e,
    timeout: !1
  });
}
function Ol(t, e) {
  const n = A(
    () => {
      var a;
      return ((a = t.value) == null ? void 0 : a.type) === ze.LOGO ? t.value.logoId : void 0;
    }
  ), s = ce.logos.get.use(n), { data: o } = bt({
    ...s,
    enabled: A(
      () => s.enabled.value && !!n.value
    ),
    retry: !1,
    staleTime: 1 / 0
  });
  return A(() => {
    var a;
    switch ((a = t.value) == null ? void 0 : a.type) {
      case ze.LOGO: {
        const i = t.value.size ?? o.value;
        if (i != null && i.width && i.height)
          return { height: i.height, width: i.width };
        break;
      }
      case ze.TEXT:
        return {
          height: 10 / e.value,
          width: 30 / e.value
        };
    }
    return {
      height: 30 / e.value,
      width: 30 / e.value
    };
  });
}
function Lb(t) {
  if (t.type === ze.LOGO)
    return t;
  if (t.type === ze.ANCHOR && t.parent.type === ze.LOGO)
    return t.parent;
}
function Rl(t) {
  const e = _t(t);
  return A(() => {
    if (e.value)
      return Lb(e.value);
  });
}
function Ms(t) {
  var e;
  if (t.type === ze.TEXT)
    return t;
  if (t.type === ze.ANCHOR && ((e = t.children[0]) == null ? void 0 : e.value.type) === ze.TEXT)
    return t.children[0].value;
}
function jo(t) {
  const e = _t(t);
  return A(() => {
    if (e.value)
      return Ms(e.value);
  });
}
function No(t, e) {
  const n = e ?? Ft(Ws).data;
  return A(() => {
    if (!t.value || !n.value) return !1;
    const { height: s, width: o } = n.value, { bottom: a, left: i, right: r, top: c } = t.value;
    return r - i > o || a - c > s;
  });
}
const cm = Symbol("nearest_positioning_areas");
function Db(t, e, n) {
  const {
    filter: s = (v, z) => v.productionMethodId === z.productionMethodId && (z.designs.length === 0 || v === z),
    minDistance: o = 10,
    onMove: a
  } = n ?? {}, { container: i, data: r } = Ft(Ml), { data: c } = Ft(Ws), u = Ft(cm), d = N();
  it(e, (v) => {
    d.value = v ? { ...v } : void 0;
  });
  const m = A(
    () => e.value && d.value && Ta(e.value, d.value) < o
  ), _ = A(() => {
    if (!e.value || !i.value) return;
    if (m.value)
      return c.value;
    const v = c.value, z = i.value.worldTransform;
    let h, y = 1 / 0;
    for (const w of r.value.positioningAreas) {
      if (!s(v, w)) continue;
      const P = Ta(
        e.value,
        z.apply(w)
      );
      P < y && (h = w, y = P);
    }
    return h;
  }), g = Jh();
  it(_, (v, z) => {
    g.value = z;
  }), re(() => {
    const v = g.value, z = c.value;
    if (_.value || !v || z === v)
      return;
    a == null || a(z, v);
    const h = t.value;
    z.designs = z.designs.filter(
      (y) => y !== h
    ), v.designs.push(h);
  }), re((v) => {
    const z = _.value;
    if (!z) return;
    const h = t.value;
    u.value.push({
      positioningArea: z,
      positioningAreaDesign: h
    }), v(() => {
      u.value = u.value.filter(
        ({ positioningAreaDesign: y }) => y !== h
      );
    });
  });
}
function jb() {
  const t = N([]);
  return ps(cm, t), t;
}
function Nb() {
  const { data: t } = Ft(Ws);
  return t;
}
function um([t, e, n]) {
  return t /= 255, e /= 255, n /= 255, t = t <= 0.04045 ? t / 12.92 : Math.pow((t + 0.055) / 1.055, 2.4), e = e <= 0.04045 ? e / 12.92 : Math.pow((e + 0.055) / 1.055, 2.4), n = n <= 0.04045 ? n / 12.92 : Math.pow((n + 0.055) / 1.055, 2.4), t * 0.2126 + e * 0.7152 + n * 0.0722;
}
const Vb = 0.179129;
function Ll(t) {
  return um(t) >= Vb;
}
function Vo(t, e = 0) {
  const n = Pl(
    t,
    {
      x: t.width * // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      Rs(t.position[1]),
      y: t.height * // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      Rs(t.position[0])
    },
    t.rotation
  );
  return n.left -= e, n.top -= e, n.right += e, n.bottom += e, {
    height: n.bottom - n.top,
    width: n.right - n.left,
    x: t.x + n.left,
    y: t.y + n.top
  };
}
const Ub = new cy();
function Gs(t, e) {
  const { image: n, view: s } = Fb(e), o = A(
    () => t.value ? Vo(t.value) : void 0
  ), a = A(() => {
    if (!s.value || !o.value || !n.value || !("width" in n.value) || !("height" in n.value)) return;
    const i = {
      x: n.value.width / s.value.width,
      y: n.value.height / s.value.height
    };
    return Ub.getColor(n.value, {
      algorithm: "dominant",
      height: o.value.height * i.y,
      ignoredColor: [0, 0, 0, 0],
      left: o.value.x * i.x,
      top: o.value.y * i.y,
      width: o.value.width * i.x
    }).value;
  });
  return {
    averageColor: a,
    isLight: A(
      () => Ll(
        a.value ?? [255, 255, 255]
      )
    )
  };
}
function Fb(t) {
  if (t)
    return {
      image: Cb(A(() => {
        var s;
        return (s = t.value) == null ? void 0 : s.imageUrl;
      })).data,
      view: t
    };
  const { data: e, texture: n } = Ft(Ml);
  return {
    image: A(
      () => {
        var s;
        return (s = n.value) == null ? void 0 : s.source.resource;
      }
    ),
    view: e
  };
}
function Bb() {
  const { mutateAsync: t } = yt(
    ce.designs.favored.post.use()
  ), { mutateAsync: e } = yt(
    ce.designs.favored.delete.use()
  );
  async function n({
    id: s,
    favoriteDesign: o
  }) {
    const a = await t(o);
    return await e(s), a;
  }
  return { mutationFn: n };
}
const qb = "UNEXPECTED_FAVORITE_VARIANT_RENDERING_FAILED";
function Hb() {
  let t;
  const { mutateAsync: e } = yt(
    ce.favorites.variants.post.use()
  ), n = lt(), s = en(
    (a) => n.fetchQuery({
      ...ce.favorites.variants.get.use(a),
      retry: !1,
      staleTime: 1 / 0
    })
  );
  Dt("favorite.rendered", ({ id: a, resource_id: i }) => {
    (t == null ? void 0 : t.pendingFavoriteVariantId) === i && t.resolve(a);
  }), Dt("favorite.failed", ({ resource_id: a, resource_type: i }) => {
    i === "variant" && (t == null ? void 0 : t.pendingFavoriteVariantId) === a && t.reject();
  });
  async function o(a) {
    const i = await e(a), { promise: r, reject: c, resolve: u } = Promise.withResolvers();
    t = {
      pendingFavoriteVariantId: i,
      reject: c,
      resolve: u
    };
    try {
      const d = await r;
      return await s(d);
    } catch {
      throw new Ma(
        qb
      );
    }
  }
  return { mutationFn: o };
}
function Wb() {
  const { mutateAsync: t } = yt(
    Hb()
  ), { mutateAsync: e } = yt(
    ce.favorites.delete.use()
  );
  async function n({
    favoriteVariantIdToDelete: s,
    favoriteVariantToCreate: o
  }) {
    const a = await t(o);
    return await e(s), a;
  }
  return { mutationFn: n };
}
function dm(t, e) {
  const { channelSession: n } = D(Al());
  Ip(n, t, e);
}
const Gb = {
  install() {
    Z2("Viewport", {
      createElement: (t) => new V0(t)
    });
  }
};
function Zb(...t) {
  return t.flatMap((e) => e.resource_type === "text" ? e.resource.lines.flatMap(
    (n) => n.color_assignments
  ) : e.resource.color_assignments);
}
function Dl(t) {
  const e = [t];
  return e.push(
    ...t.elements.flatMap((n) => Dl(n))
  ), e;
}
const Ar = /* @__PURE__ */ new WeakMap();
let Kb = 0;
function ft(t) {
  return Ar.has(t) || Ar.set(t, ++Kb), Ar.get(t);
}
const jt = st("layout", () => {
  const t = N(), e = N(!0);
  return { rootElement: t, showLayout: e };
}), tt = st("configuration", () => {
  const { data: t, status: e } = bt({
    ...ce.configurations.app.get.use(),
    retry: !1,
    staleTime: 1 / 0
  }), { data: n } = bt({
    ...ce.configurations.designer.get.use(),
    retry: !1,
    staleTime: 1 / 0
  });
  return { appConfiguration: t, designerConfiguration: n, status: e };
}), Qt = st("variant", () => {
  const t = N();
  re(() => {
    kd("variant-id", t.value);
  });
  const e = ce.variants.get.use(t), n = ce.variants.getByExternalIdentifier.use(
    t
  ), { data: s, fetchStatus: o, status: a, suspense: i } = bt(
    A(
      () => typeof t.value == "number" ? {
        ...e,
        retry: !1,
        staleTime: 1 / 0
      } : {
        ...n,
        enabled: A(
          () => n.enabled.value && typeof t.value == "string"
        ),
        retry: !1,
        staleTime: 1 / 0
      }
    )
  );
  return {
    data: s,
    fetchStatus: o,
    status: a,
    suspense: i,
    variantId: t
  };
}), sn = st("view", () => {
  const { data: t } = D(Qt()), e = N([]), n = N(0);
  return re(() => {
    t.value && (e.value = t.value.views.map((s) => El(s)), n.value = 0);
  }), {
    data: e,
    selectedViewIndex: n
  };
});
function Xb(t, e) {
  const n = /* @__PURE__ */ new Set();
  for (const s of t)
    e.has(s) && n.add(s);
  return n;
}
const Je = st("productionMethod", () => {
  const t = N(), { data: e } = D(sn()), { data: n } = D(Qt()), s = A(() => {
    if (n.value)
      return new Set(
        e.value.flatMap(
          (c) => c.positioningAreas.filter(
            (u) => u.designs.length > 0
          ).map((u) => u.productionMethodId)
        )
      );
  }), o = A(() => {
    if (n.value)
      return new Set(
        e.value.flatMap(
          (c) => c.positioningAreas.map(
            (u) => u.productionMethodId
          )
        )
      );
  }), { appConfiguration: a } = D(tt()), i = A(() => {
    if (a.value !== void 0)
      return new Set(
        a.value.productionMethods.map((c) => c.id).sort(
          (c, u) => c - u
        )
      );
  }), r = A(() => {
    if (i.value !== void 0 && o.value !== void 0)
      return Xb(
        o.value,
        i.value
      );
  });
  return re(() => {
    r.value !== void 0 && (t.value !== void 0 && r.value.has(
      t.value
    ) || s.value !== void 0 && (t.value = s.value.values().next().value, t.value !== void 0) || (t.value = r.value.values().next().value));
  }), {
    activatedProductionMethodIds: i,
    availableProductionMethodIds: r,
    designsProductionMethodIds: s,
    selectedProductionMethodId: t
  };
}), Qb = {
  key: 0,
  class: "smake:pointer-events-auto smake:flex smake:min-h-14 smake:w-full smake:max-w-md smake:flex-col smake:overflow-hidden smake:rounded-lg smake:border smake:border-secondary-2 smake:bg-secondary-3 smake:data-[swipe=cancel]:translate-y-0 smake:data-[swipe=cancel]:duration-200 smake:data-[swipe=end]:hidden smake:data-[swipe=move]:translate-y-(--radix-toast-swipe-move-y)"
}, Jb = { class: "smake:flex smake:grow smake:items-center smake:justify-between smake:gap-2 smake:p-2" }, Yb = { class: "smake:flex smake:grow smake:justify-center" }, ew = { key: 0 }, pm = /* @__PURE__ */ J({
  __name: "Toast",
  props: /* @__PURE__ */ Ae({
    type: {}
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Ae(["closed"], ["update:open"]),
  setup(t, { emit: e }) {
    const n = t, { type: s } = we(n), o = e, a = Ne(t, "open");
    a.value || o("closed");
    const i = {
      error: {
        class: "smake:text-danger",
        icon: ["fak", "icon-ciconfig-alert-warning"]
      },
      info: {
        class: "smake:text-info",
        icon: ["fak", "icon-ciconfig-alert-warning"]
      },
      success: {
        class: "smake:text-success",
        icon: ["fak", "icon-ciconfig-alert-check"]
      }
    }, r = A(() => i[s.value]), c = A(() => s.value === "success" ? 3e3 : -1);
    function u(d) {
      s.value === "error" && d.stopImmediatePropagation();
    }
    return (d, m) => {
      const _ = xe("FontAwesomeIcon");
      return $(), q(l(Zf), {
        open: a.value,
        "onUpdate:open": m[2] || (m[2] = (g) => a.value = g),
        duration: c.value,
        "as-child": "",
        onPointerdown: rs(u, ["left"])
      }, {
        default: C(({ remaining: g }) => [
          b(De, {
            "enter-active-class": "smake:motion-preset-rebound-down smake:motion-duration-75",
            "leave-active-class": "smake:duration-300",
            "leave-to-class": "smake:opacity-0",
            appear: "",
            onAfterLeave: m[1] || (m[1] = (v) => o("closed"))
          }, {
            default: C(() => [
              a.value ? ($(), I("li", Qb, [
                x("div", Jb, [
                  b(_, Na({ class: "smake:h-5" }, r.value, { "fixed-width": "" }), null, 16),
                  x("div", Yb, [
                    St(d.$slots, "default")
                  ]),
                  l(s) === "info" ? ($(), I("button", {
                    key: 0,
                    type: "button",
                    onClick: m[0] || (m[0] = (v) => a.value = !1)
                  }, [
                    b(_, {
                      icon: ["fak", "icon-x"],
                      "fixed-width": "",
                      class: "smake:h-3.5 smake:text-secondary-1"
                    })
                  ])) : Q("", !0)
                ]),
                l(s) === "success" ? ($(), I("div", ew, [
                  x("div", {
                    class: "smake:h-0.5 smake:bg-success",
                    style: Kt(`width: ${g / c.value * 100}%;`)
                  }, null, 4)
                ])) : Q("", !0)
              ])) : Q("", !0)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 3
      }, 8, ["open", "duration"]);
    };
  }
}), ln = /* @__PURE__ */ J({
  __name: "TextToast",
  props: /* @__PURE__ */ Ae({
    text: {},
    type: {}
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Ae(["closed"], ["update:open"]),
  setup(t, { emit: e }) {
    const n = e, s = Ne(t, "open");
    return (o, a) => ($(), q(pm, {
      open: s.value,
      "onUpdate:open": a[0] || (a[0] = (i) => s.value = i),
      type: o.type,
      onClosed: a[1] || (a[1] = (i) => n("closed"))
    }, {
      default: C(() => [
        he(L(o.text), 1)
      ]),
      _: 1
    }, 8, ["open", "type"]));
  }
}), mm = st("toast", () => ({
  toasts: N([])
}));
function Rn() {
  const { toasts: t } = D(mm()), e = N([]);
  function n(o, ...[a]) {
    const { id: i, input: r = {}, removeOnUnmount: c = !0 } = a ?? {};
    let u = i ? t.value.find((d) => d.id === i) : void 0;
    return u ? () => {
      u.open = !1;
    } : (u = rd({
      id: i,
      component: ds(o),
      input: r,
      open: !0
    }), t.value.push(u), c && e.value.push(u), () => {
      u.open = !1;
    });
  }
  function s(o) {
    const a = t.value.find((i) => i.id === o);
    a && (a.open = !1);
  }
  return En() && al(() => {
    for (const o of e.value)
      o.open = !1;
  }), {
    close: s,
    open: n
  };
}
function tw(t) {
  const { data: e } = D(Qt());
  return A(
    () => {
      var s;
      return (s = e.value) == null ? void 0 : s.views.flatMap((o) => o.positioning_areas).find(
        (o) => o.id === t.value
      );
    }
  );
}
function nw(t) {
  const e = tw(t), n = A(() => {
    var c;
    return (c = e.value) == null ? void 0 : c.annotations;
  }), { close: s, open: o } = Rn(), a = N([]);
  it(n, () => {
    r(), i();
  });
  function i() {
    if (n.value)
      for (const c of n.value) {
        const u = Symbol(
          `annotation-${c.id.toString()}`
        );
        a.value.push(u), o(ln, {
          id: u,
          input: {
            text: c.description,
            type: "info"
          },
          removeOnUnmount: !0
        });
      }
  }
  function r() {
    for (const c of a.value)
      s(c);
    a.value = [];
  }
}
const Sn = st("designer", () => {
  const t = N(), e = N(), n = N(1), s = A({
    get: () => n.value,
    set: (r) => {
      var c;
      (c = t.value) == null || c.setZoom(r);
    }
  }), o = N(!1), a = N(), i = N(!1);
  return {
    designerCore: t,
    hidePositioningAreas: o,
    highlightEmptyPositioningAreas: i,
    readOnlyZoom: n,
    selectedPositioningAreaDesign: a,
    stage: e,
    zoom: s
  };
}), dn = st("designEditDialog", () => {
  const { designerCore: t } = D(Sn()), { data: e, selectedViewIndex: n } = D(sn()), { showLayout: s } = D(jt()), o = N(!1), a = N(), i = N(), r = N();
  nw(A(() => {
    var g;
    return (g = a.value) == null ? void 0 : g.id;
  }));
  const c = A({
    get: () => !!a.value && !o.value,
    set: (g) => {
      if (g)
        throw new Error(
          "To open the DesignEditDialog the positioningArea needs to be set"
        );
      a.value = void 0, i.value = void 0;
    }
  });
  re(() => {
    !a.value || !i.value || a.value.designs.includes(i.value) || (i.value = void 0);
  }), it(
    [a, i],
    ([g, v], [z, h]) => {
      z !== void 0 && (v === h || g === z) || (r.value = Wn(v));
    }
  ), it(
    i,
    (g, v) => {
      g || !v || (c.value = !1);
    }
  ), it([c, a], ([g, v]) => {
    if (s.value = !g, d(), _(), g) {
      u(v);
      return;
    }
    const z = e.value[n.value];
    m(z);
  });
  const { start: u, stop: d } = ic(
    (g) => {
      var v;
      g && ((v = t.value) == null || v.setPosition(
        Vo(g)
      ));
    },
    10
  ), { start: m, stop: _ } = ic(async (g) => {
    var v;
    await ol(), g && ((v = t.value) == null || v.setPosition({
      height: g.height,
      width: g.width,
      x: 0,
      y: 0
    }));
  }, 50);
  return {
    forceClose: o,
    open: c,
    positioningArea: a,
    positioningAreaDesign: i,
    positioningAreaDesignBackup: r
  };
}), nn = st("dialog", () => {
  const t = N([]), e = N(!1), n = N();
  function s(o) {
    o.resolve(), t.value = t.value.filter((a) => a !== o);
  }
  return {
    dialogs: t,
    dialogsRoot: n,
    hideAllDialogs: e,
    removeDialog: s
  };
}), Cr = Symbol("chooseAPositioningAreaToast"), Pr = Symbol(
  "noEmptyPositioningAreaOnCurrentView"
), Xt = st(
  "selectPositioningArea",
  () => {
    const { close: t, open: e } = Rn(), { t: n } = ct(), { highlightEmptyPositioningAreas: s } = D(Sn()), { hideAllDialogs: o } = D(nn()), { forceClose: a } = D(dn()), { data: i, selectedViewIndex: r } = D(sn()), { selectedProductionMethodId: c } = D(
      Je()
    ), u = A(() => {
      const y = i.value[r.value];
      return y === void 0 ? !1 : y.positioningAreas.some((w) => w.productionMethodId !== c.value ? !1 : w.designs.length === 0);
    }), d = N(!1), {
      cancel: m,
      confirm: _,
      onCancel: g,
      onConfirm: v,
      onReveal: z,
      reveal: h
    } = of(d);
    return re(() => {
      o.value = d.value, a.value = d.value;
    }), z(() => {
      s.value = !0;
    }), re(() => {
      if (s.value) {
        if (u.value) {
          t(Pr), e(ln, {
            id: Cr,
            input: {
              text: n("choose_a_positioning_area"),
              type: "info"
            }
          });
          return;
        }
        t(Cr), e(ln, {
          id: Pr,
          input: {
            text: n("all_positioning_areas_are_occupied"),
            type: "info"
          }
        });
        return;
      }
      t(Cr), t(Pr);
    }), g(() => {
      s.value = !1;
    }), v(() => {
      s.value = !1;
    }), {
      cancelSelectingPositioningArea: m,
      isSelectingPositioningArea: Tn(d),
      selectPositioningArea: _,
      waitForSelectingPositioningArea: h
    };
  }
), ti = st(
  "variantChangeEvent",
  () => {
    const { dialogs: t } = D(nn()), { open: e } = D(
      dn()
    ), n = N(!1), s = N(!1);
    return {
      isADialogOpen: A(
        () => t.value.length > 0 || e.value || n.value || s.value
      ),
      isFileUploadDialogOpen: s,
      isProductColorChangeDialogOpen: n
    };
  }
), Zs = st("props", () => {
  const t = N(), e = N(), n = N(), s = N();
  return {
    availableVariants: t,
    customerLogoUploadInfo: e,
    termsOfServiceLink: n,
    uploadHelpLink: s
  };
});
function hm(t) {
  return new Promise((e, n) => {
    const s = new Image();
    s.addEventListener("load", () => {
      e(s);
    }), s.addEventListener("error", n), s.crossOrigin = "Anonymous", s.src = t;
  });
}
async function sw(t) {
  return Promise.all(t.map((e) => hm(e)));
}
function ow(t) {
  const e = _t(t);
  return bt({
    enabled: A(() => !!e.value),
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    queryFn: () => hm(e.value),
    queryKey: ["image", e],
    retry: !1,
    staleTime: 1 / 0
  });
}
const aw = ["src", "data-state"], iw = ["data-state"], on = /* @__PURE__ */ J({
  __name: "Image",
  props: {
    src: {}
  },
  setup(t) {
    const e = t, { src: n } = we(e), { status: s } = ow(n);
    return (o, a) => ($(), q(De, {
      "enter-active-class": "smake:duration-300 smake:ease-out",
      "enter-from-class": "smake:opacity-0",
      "leave-active-class": "smake:hidden"
    }, {
      default: C(() => [
        l(s) === "success" ? ($(), I("img", {
          key: 0,
          src: l(n),
          "data-state": l(s)
        }, null, 8, aw)) : ($(), I("div", {
          key: 1,
          "data-state": l(s)
        }, null, 8, iw))
      ]),
      _: 1
    }));
  }
}), rw = { class: "smake:absolute smake:inset-y-0 smake:right-0 smake:flex smake:w-120 smake:max-w-full smake:flex-col smake:overflow-y-auto smake:bg-secondary-3 smake:p-10 smake:shadow-[0_0_15px_0_rgba(0,0,0,.25)]" }, lw = { class: "smake:grid smake:grid-cols-auto-fill-14 smake:gap-4" }, cw = ["disabled", "onClick"], uw = /* @__PURE__ */ J({
  __name: "ChangeProductColorDialogContent",
  emits: ["close"],
  setup(t, { emit: e }) {
    const n = e, s = Qt(), { data: o, fetchStatus: a, variantId: i } = D(s), { data: r } = D(sn()), { availableVariants: c } = D(Zs()), u = A(() => {
      var h;
      return (h = o.value) == null ? void 0 : h.product_id;
    }), d = ce.products.colorVariants.list.use(
      u
    ), { data: m, isPending: _ } = bt({
      ...d,
      enabled: A(
        () => d.enabled.value && !!u.value
      ),
      retry: !1,
      staleTime: 1 / 0
    }), g = A(
      () => {
        var h;
        return c.value ? (h = m.value) == null ? void 0 : h.filter(
          ({ size_variants: y }) => y.some(
            ({ id: w, external_identifier: P }) => (
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              c.value.some(
                (M) => typeof M == "number" ? M === w : M === P
              )
            )
          )
        ) : m.value;
      }
    ), v = A(() => {
      var y, w, P;
      const h = (w = (y = o.value) == null ? void 0 : y.attributes.find(
        (M) => M.name === "color"
      )) == null ? void 0 : w.handle;
      return (P = g.value) == null ? void 0 : P.find(
        ({ color_handle: M }) => M === h
      );
    });
    async function z(h) {
      var w;
      if (h === ((w = o.value) == null ? void 0 : w.base.id)) {
        n("close");
        return;
      }
      const y = r.value;
      i.value = h, await s.suspense();
      for (const P of r.value)
        for (const M of P.positioningAreas)
          M.id && M.designs.push(
            ...y.flatMap(
              (E) => E.positioningAreas.filter(({ id: R }) => R === M.id).flatMap(({ designs: R }) => R)
            )
          );
      n("close");
    }
    return (h, y) => ($(), I("div", rw, [
      b(l(At), { class: "smake:mb-10 smake:text-lg smake:font-semibold smake:uppercase" }, {
        default: C(() => [
          he(L(h.$t("product_colors")), 1)
        ]),
        _: 1
      }),
      x("div", lw, [
        l(_) ? ($(), I(me, { key: 0 }, Se(14, (w) => x("div", {
          key: w,
          class: "smake:flex smake:animate-pulse smake:flex-col smake:items-center smake:gap-2"
        }, [...y[0] || (y[0] = [
          x("div", { class: "smake:rounded-full smake:border smake:border-transparent smake:p-1" }, [
            x("div", { class: "smake:size-12 smake:rounded-full smake:bg-secondary-2" })
          ], -1),
          x("div", { class: "smake:h-3 smake:w-10 smake:rounded smake:bg-secondary-2" }, null, -1)
        ])])), 64)) : Q("", !0),
        ($(!0), I(me, null, Se(g.value, (w) => ($(), I("button", {
          key: w.color_handle,
          class: "smake:flex smake:flex-col smake:items-center smake:gap-2 smake:disabled:grayscale-[80%]",
          disabled: l(a) === "fetching",
          onClick: (P) => z(w.size_variants[0].id)
        }, [
          x("div", {
            class: ke([
              "smake:rounded-full smake:border smake:p-1",
              w === v.value ? "smake:border-black" : "smake:border-transparent"
            ])
          }, [
            b(on, {
              src: w.color_preview_url,
              class: "smake:size-12 smake:rounded-full smake:data-[state=pending]:animate-pulse smake:data-[state=pending]:bg-secondary-2"
            }, null, 8, ["src"])
          ], 2),
          x("div", null, L(w.color_name), 1)
        ], 8, cw))), 128))
      ])
    ]));
  }
}), dw = { class: "smake:text-xs" }, Hu = /* @__PURE__ */ J({
  __name: "ChangeProductColor",
  setup(t) {
    const { rootElement: e } = D(jt()), { fetchStatus: n } = D(Qt()), { isSelectingPositioningArea: s } = D(
      Xt()
    ), { isProductColorChangeDialogOpen: o } = D(
      ti()
    ), { selectedProductionMethodId: a } = D(Je());
    function i(r) {
      n.value === "fetching" && r.preventDefault();
    }
    return (r, c) => ($(), q(l(Ct), {
      open: l(o),
      "onUpdate:open": c[1] || (c[1] = (u) => Lt(o) ? o.value = u : null)
    }, {
      default: C(() => [
        b(l(yd), {
          type: "button",
          "data-testid": "ChangeProductColor",
          class: "smake:pointer-events-auto smake:flex smake:flex-col smake:items-center smake:gap-2 smake:disabled:opacity-50",
          disabled: l(s) || l(a) === void 0
        }, {
          default: C(() => [
            c[2] || (c[2] = x("div", { class: "smake:size-16 smake:rounded-full smake:bg-[conic-gradient(red,yellow,lime,aqua,blue,magenta,red)]" }, null, -1)),
            x("div", dw, L(r.$t("product_colors")), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        b(l(Pt), { to: l(e) }, {
          default: C(() => [
            b(De, {
              appear: "",
              "enter-active-class": "smake:duration-300 smake:ease-out",
              "enter-from-class": "smake:opacity-0",
              "leave-active-class": "smake:duration-200 smake:ease-in",
              "leave-to-class": "smake:opacity-0"
            }, {
              default: C(() => [
                b(l(Mt), { class: "smake:fixed smake:inset-0 smake:bg-black/40" })
              ]),
              _: 1
            }),
            b(De, {
              appear: "",
              "enter-active-class": "smake:duration-300 smake:ease-out",
              "enter-from-class": "smake:-right-120",
              "leave-active-class": "smake:duration-200 smake:ease-in",
              "leave-to-class": "smake:-right-120"
            }, {
              default: C(() => [
                b(l(Tt), {
                  "as-child": "",
                  onInteractOutside: i,
                  onEscapeKeyDown: i
                }, {
                  default: C(() => [
                    b(uw, {
                      onClose: c[0] || (c[0] = (u) => o.value = !1)
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _: 1
    }, 8, ["open"]));
  }
});
function ni() {
  const { data: t } = D(sn());
  return A(() => t.value.filter(
    (n) => n.positioningAreas.some(
      (s) => s.designs.length > 0
    ) && !!n.handle
  ).map((n) => lm(n)));
}
const fm = st("saveAndContinue", () => {
  const t = ni(), { data: e } = D(Qt()), n = A(() => !!s.value), s = A(
    () => {
      if (e.value && t.value.length !== 0)
        return {
          baseId: e.value.id,
          views: t.value
        };
    }
  ), o = N(), { isPending: a, mutate: i } = yt({
    ...ce.variants.post.use(),
    onSuccess(d) {
      o.value = d;
    }
  }), r = A(
    () => a.value || o.value
  );
  function c() {
    s.value && i(s.value);
  }
  const u = N();
  return dm(
    "customVariant.customizations.completed",
    ({ id: d }) => {
      o.value === d && e.value && u.value && u.value({
        id: d,
        base: {
          id: e.value.base.id,
          external_identifier: e.value.base.external_identifier
        },
        external_identifier: e.value.external_identifier
      });
    }
  ), {
    canSaveAndContinue: n,
    isPending: r,
    onContinue: u,
    saveAndContinue: c
  };
}), Wu = /* @__PURE__ */ J({
  __name: "ButtonIcon",
  props: {
    spin: { type: Boolean },
    type: {}
  },
  setup(t) {
    return (e, n) => {
      const s = xe("FontAwesomeIcon");
      return $(), q(s, {
        class: ke([{
          "smake:animate-spin": e.spin
        }, "smake:h-4.75 smake:max-w-4.75"]),
        "fixed-width": e.type[0] === "fak",
        icon: e.type
      }, null, 8, ["class", "fixed-width", "icon"]);
    };
  }
}), _m = /* @__PURE__ */ J({
  __name: "ButtonShape",
  props: {
    asChild: { type: Boolean },
    as: { default: "button" },
    disabled: { type: Boolean },
    size: { default: "default" },
    type: {}
  },
  setup(t) {
    const e = t, { disabled: n, type: s } = we(e), o = A(
      () => n.value ? "disabled" : s.value
    );
    return (a, i) => ($(), q(l(Kf), {
      as: a.as,
      "as-child": a.asChild,
      disabled: l(n),
      class: ke(["smake:flex smake:items-center smake:justify-center smake:gap-3 smake:rounded-[50px] smake:text-xs smake:font-medium", {
        // Sizes
        "smake:min-h-7.5 smake:px-5 smake:py-1.25": a.size === "small",
        "smake:min-h-12 smake:px-7.5 smake:py-1.5": a.size === "default",
        "smake:min-h-14.5 smake:px-8.75 smake:py-4 smake:leading-1.75": a.size === "big",
        // Colors
        "smake:bg-black smake:text-white": o.value === "active",
        "smake:border smake:border-secondary-3 smake:bg-secondary-3 smake:text-black smake:hover:bg-secondary-2": o.value === "secondary",
        "smake:border smake:border-secondary-2 smake:bg-transparent smake:text-black smake:hover:border-black": o.value === "subordinate",
        "smake:border smake:border-primary-1 smake:bg-primary-1 smake:text-white smake:hover:bg-primary-2": o.value === "primary",
        "smake:border smake:border-white smake:bg-white smake:text-black": o.value === "other",
        "smake:border smake:border-secondary-2 smake:bg-transparent smake:text-secondary-2": o.value === "disabled"
      }])
    }, {
      default: C(() => [
        St(a.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "as-child", "disabled", "class"]));
  }
}), pw = { key: 1 }, et = /* @__PURE__ */ J({
  __name: "BaseButton",
  props: {
    disabled: { type: Boolean, default: !1 },
    icon: { default: void 0 },
    size: { default: "default" },
    text: { default: void 0 },
    type: {}
  },
  setup(t) {
    const e = t, { disabled: n, icon: s } = we(e), o = A(() => {
      if (s.value)
        return s.value.position ? s.value.position : "before";
    });
    return (a, i) => ($(), q(_m, {
      as: "button",
      disabled: l(n),
      size: a.size,
      type: a.type
    }, {
      default: C(() => [
        o.value === "before" ? ($(), q(Wu, {
          key: 0,
          type: l(s).type,
          spin: l(s).spin
        }, null, 8, ["type", "spin"])) : Q("", !0),
        a.text ? ($(), I("div", pw, L(a.text), 1)) : Q("", !0),
        o.value === "after" ? ($(), q(Wu, {
          key: 2,
          type: l(s).type,
          spin: l(s).spin
        }, null, 8, ["type", "spin"])) : Q("", !0)
      ]),
      _: 1
    }, 8, ["disabled", "size", "type"]));
  }
}), mw = { key: 0 }, hw = /* @__PURE__ */ J({
  __name: "Continue",
  setup(t) {
    const e = fm(), { saveAndContinue: n } = e, { canSaveAndContinue: s, isPending: o } = D(e);
    return (a, i) => {
      const r = xe("FontAwesomeIcon");
      return $(), q(et, {
        class: "smake:px-8 smake:py-4",
        "data-testid": "Continue",
        type: "primary",
        disabled: !l(s) || !!l(o),
        text: l(o) ? void 0 : a.$t("continue"),
        icon: l(o) ? {
          type: ["fal", "spinner"],
          spin: !0
        } : void 0,
        onClick: i[0] || (i[0] = (c) => l(n)())
      }, {
        default: C(() => [
          l(o) ? ($(), q(r, {
            key: 1,
            class: "smake:h-7 smake:animate-spin",
            icon: ["fal", "spinner"]
          })) : ($(), I("div", mw, L(a.$t("continue")), 1))
        ]),
        _: 1
      }, 8, ["disabled", "text", "icon"]);
    };
  }
});
function pn() {
  const { dialogs: t } = D(nn()), e = N([]);
  function n(s, ...[o = {}]) {
    const { input: a = {}, removeOnUnmount: i = !0 } = o, { promise: r, resolve: c } = Promise.withResolvers(), u = rd({
      component: ds(s),
      input: a,
      open: !0,
      resolve: c
    });
    return t.value.push(u), i && e.value.push(u), r;
  }
  return En() && al(() => {
    for (const s of e.value)
      s.open = !1;
  }), { open: n };
}
function vm() {
  const { data: t } = D(Qt());
  return (e) => {
    if (t.value) {
      for (const n of t.value.views)
        for (const s of n.positioning_areas)
          if (s.id === e)
            return s;
    }
  };
}
function gm(t) {
  return t === Cs.Italic || t === Cs.BoldItalic || t === Cs.BlackItalic || t === Cs.DemiBoldItalic;
}
function wo(t, e, n) {
  return Math.min(Math.max(t, e), n);
}
function km(t, e) {
  const { appConfiguration: n } = D(tt());
  function s() {
    var u;
    const i = ((u = n.value) == null ? void 0 : u.colors.filter(
      ({ production_methods: d }) => d.some(
        ({ id: m }) => m === t.value
      )
    )) ?? [];
    let r, c = e.value ? 1 / 0 : -1 / 0;
    for (const d of i) {
      const m = um([
        d.red,
        d.green,
        d.blue
      ]);
      e.value ? c > m && (c = m, r = d) : c < m && (c = m, r = d);
    }
    if (!r) throw new Error("No color found");
    return r;
  }
  function o() {
    var r;
    const i = (r = n.value) == null ? void 0 : r.fonts.filter(
      ({ production_methods: c, style: u }) => !gm(u) && c.some(
        ({ id: d }) => d === t.value
      )
    ).sort((c, u) => c.family_name < u.family_name ? -1 : c.family_name > u.family_name ? 1 : 0)[0];
    if (!i) throw new Error("No font found");
    return i;
  }
  function a() {
    const i = o();
    return {
      bendingRadius: 0,
      color: { id: s().id },
      fontId: i.id,
      horizontalAlignment: us.LEFT,
      offsetLeft: 0,
      paddingBottom: 2,
      size: wo(10, i.min, i.max),
      text: ""
    };
  }
  return a;
}
const jl = {
  dtf: ["fak", "icon-easytransfer"],
  embroidery: ["fak", "icon-direkteinstickung"]
}, fw = {
  dtf: "production_method_summary_dtf",
  embroidery: "production_method_summary_embroidery"
};
function It(t) {
  const e = af(t), { t: n } = ct(), { availableProductionMethodIds: s, selectedProductionMethodId: o } = D(Je()), a = A(() => o.value === e.value), i = A(() => s.value === void 0 || e.value === void 0 ? !1 : s.value.has(
    e.value
  )), { appConfiguration: r, designerConfiguration: c } = D(
    tt()
  ), u = A(() => {
    var h;
    return (h = r.value) == null ? void 0 : h.productionMethods.find(
      ({ id: y }) => y === e.value
    );
  }), d = A(() => {
    var h, y;
    return (y = (h = c.value) == null ? void 0 : h.settings.production_methods) == null ? void 0 : y.find(
      ({ id: w }) => w === e.value
    );
  }), m = A(() => {
    if (!u.value) return;
    const h = fw[u.value.handle];
    if (h)
      return n(h);
  }), _ = A(() => {
    if (u.value)
      return jl[u.value.handle];
  }), g = A(
    () => {
      var h;
      return !!((h = d.value) != null && h.customer_upload);
    }
  ), v = A(
    () => {
      var h, y;
      return (y = (h = d.value) == null ? void 0 : h.customer_upload) == null ? void 0 : y.allowed_logo_file_types;
    }
  ), z = A(
    () => {
      var h, y;
      return (y = (h = d.value) == null ? void 0 : h.customer_upload) == null ? void 0 : y.max_file_size_mb;
    }
  );
  return {
    allowedExtensions: v,
    icon: _,
    isAvailableOnCurrentVariant: i,
    isCustomerLogoUploadEnabled: g,
    isSelected: a,
    maxFileSizeMb: z,
    productionMethod: u,
    shortDescription: m
  };
}
var Rt = /* @__PURE__ */ ((t) => (t.CUSTOMER_LOGO_UPLOAD = "featureFlagCustomerLogoUpload", t))(Rt || {});
const _w = ["disabled"], vw = { class: "smake:grow smake:text-left smake:font-semibold" }, ha = /* @__PURE__ */ J({
  __name: "AddComponentButton",
  props: {
    icon: {},
    loading: { type: Boolean },
    primary: { type: Boolean },
    text: {}
  },
  setup(t) {
    return (e, n) => {
      const s = xe("FontAwesomeIcon");
      return $(), I("button", {
        class: ke(["smake:group smake:flex smake:min-h-30 smake:items-center smake:justify-between smake:gap-6 smake:rounded-2xl smake:border smake:border-secondary-2 smake:px-8 smake:py-4 smake:duration-100 smake:enabled:hover:bg-secondary-3", { "smake:animate-pulse smake:bg-secondary-3": e.loading }]),
        disabled: e.loading,
        type: "button"
      }, [
        e.loading ? Q("", !0) : ($(), I(me, { key: 0 }, [
          x("div", {
            class: ke(["smake:flex smake:items-center smake:justify-center smake:rounded-full smake:p-3.75", {
              "smake:bg-primary-1 smake:text-white": e.primary,
              "smake:bg-secondary-3 smake:text-black smake:group-hover:bg-white/70": !e.primary
            }])
          }, [
            b(s, {
              icon: e.icon,
              "fixed-width": "",
              class: "smake:size-5"
            }, null, 8, ["icon"])
          ], 2),
          x("div", vw, L(e.text), 1),
          x("div", null, [
            b(s, {
              class: "smake:h-4",
              icon: ["fal", "plus"]
            })
          ])
        ], 64))
      ], 10, _w);
    };
  }
});
function gw(t, e) {
  const { t: n } = ct(), s = _t(e), o = _t(t), a = A(() => {
    if (o.value instanceof Ma)
      return o.value;
  }), i = A(() => {
    if (o.value instanceof Hn)
      return o.value;
  }), r = A(() => {
    var _;
    if (((_ = i.value) == null ? void 0 : _.response.status) === 422)
      return i.value;
  }), { data: c } = bt({
    enabled: A(() => !!r.value),
    queryFn: () => {
      var _;
      return (_ = r.value) == null ? void 0 : _.response.json();
    },
    queryKey: [r]
  }), u = A(() => {
    var _;
    if (o.value)
      return a.value ? a.value.message : r.value ? (_ = c.value) == null ? void 0 : _.message : s.value ?? n("boot_error.unexpected");
  }), d = A(() => {
    var _;
    return (_ = c.value) == null ? void 0 : _.errors;
  }), m = A(() => {
    var _;
    return (_ = i.value) == null ? void 0 : _.response.status;
  });
  return {
    fieldMessages: d,
    message: u,
    statusCode: m
  };
}
const ym = $_({ prefix: "smake" }), Re = /* @__PURE__ */ J({
  inheritAttrs: !1,
  __name: "Button",
  props: {
    type: {}
  },
  setup(t) {
    return (e, n) => ($(), I("button", Na({ ...e.$attrs, class: void 0 }, {
      type: "button",
      class: l(ym)(
        "smake:flex smake:items-center smake:justify-center smake:gap-2 smake:rounded-full smake:p-2 smake:text-[14px] smake:duration-150 smake:disabled:opacity-50",
        e.type === "outline" && "smake:border smake:border-secondary-2 smake:bg-white smake:enabled:hover:border-black",
        e.type === "primary" && "smake:bg-primary-1 smake:text-white smake:enabled:hover:bg-primary-2",
        e.type === "secondary" && "smake:bg-secondary-3 smake:enabled:hover:bg-secondary-2",
        e.type === "white" && "smake:bg-white smake:enabled:hover:bg-secondary-2",
        e.$attrs.class
      )
    }), [
      St(e.$slots, "default")
    ], 16));
  }
}), kw = /* @__PURE__ */ J({
  __name: "PositioningArea",
  props: {
    activeProductionMethodId: {},
    data: {}
  },
  setup(t) {
    const e = t, { activeProductionMethodId: n, data: s } = we(e), { isLight: o } = Gs(s), a = A(() => [1, 1, 1, 0.5]), i = A(() => {
      if (r.value)
        return a.value;
    }), r = A(() => s.value.designs.length === 0);
    return (c, u) => ($(), q(l(Ro), {
      data: l(s),
      hidden: l(s).productionMethodId !== l(n),
      "stroke-color": l(o) ? 4605510 : 14474460,
      "fill-color": i.value
    }, {
      default: C(() => [
        ($(!0), I(me, null, Se(l(s).designs, (d) => ($(), q(l(Lo), {
          key: l(ft)(d),
          data: d,
          "production-method-id": l(s).productionMethodId
        }, null, 8, ["data", "production-method-id"]))), 128))
      ]),
      _: 1
    }, 8, ["data", "hidden", "stroke-color", "fill-color"]));
  }
}), yw = { class: "smake:relative" }, bw = /* @__PURE__ */ J({
  __name: "ProductionMethodViewsPreview",
  props: /* @__PURE__ */ Ae({
    productionMethodId: {}
  }, {
    selectedViewIndex: {
      required: !0
    },
    selectedViewIndexModifiers: {}
  }),
  emits: ["update:selectedViewIndex"],
  setup(t) {
    const { data: e } = D(sn()), n = Ne(t, "selectedViewIndex");
    function s() {
      n.value = (n.value + 1) % e.value.length;
    }
    function o() {
      n.value = (n.value - 1 + e.value.length) % e.value.length;
    }
    return (a, i) => {
      const r = xe("FontAwesomeIcon");
      return $(), I("div", yw, [
        b(l(Oo), { class: "smake:size-full" }, {
          default: C(() => [
            ($(!0), I(me, null, Se(l(e), (c, u) => ($(), q(l(Do), {
              key: l(ft)(c),
              data: c,
              hidden: u !== n.value
            }, {
              default: C(() => [
                ($(!0), I(me, null, Se(c.positioningAreas, (d) => ($(), q(kw, {
                  key: l(ft)(d),
                  data: d,
                  "active-production-method-id": a.productionMethodId
                }, null, 8, ["data", "active-production-method-id"]))), 128))
              ]),
              _: 2
            }, 1032, ["data", "hidden"]))), 128))
          ]),
          _: 1
        }),
        b(Re, {
          type: "secondary",
          class: "smake:absolute smake:top-1/2 smake:left-0 smake:size-12 smake:translate-x-1/2 smake:-translate-y-1/2",
          onClick: o
        }, {
          default: C(() => [
            b(r, {
              class: "smake:size-full",
              icon: ["fal", "chevron-left"]
            })
          ]),
          _: 1
        }),
        b(Re, {
          type: "secondary",
          class: "smake:absolute smake:top-1/2 smake:right-0 smake:size-12 smake:-translate-x-1/2 smake:-translate-y-1/2",
          onClick: s
        }, {
          default: C(() => [
            b(r, {
              class: "smake:size-full",
              icon: ["fal", "chevron-right"]
            })
          ]),
          _: 1
        })
      ]);
    };
  }
}), ww = { class: "smake:absolute smake:top-1/2 smake:left-1/2 smake:mx-auto smake:flex smake:h-fit smake:max-h-full smake:w-170 smake:max-w-full smake:-translate-x-1/2 smake:-translate-y-1/2 smake:flex-col smake:gap-6 smake:rounded-3xl smake:bg-white smake:p-4" }, xw = { class: "smake:flex smake:items-start smake:justify-between smake:gap-2" }, $w = { class: "smake:flex smake:grow smake:flex-col smake:gap-4 smake:bg-white" }, zw = { class: "smake:flex smake:items-center smake:gap-3 smake:rounded-xl smake:border smake:border-secondary-2 smake:p-3" }, Sw = { class: "smake:font-semibold" }, Aw = { class: "smake:leading-6" }, Cw = { class: "smake:font-semibold" }, Pw = { class: "smake:h-full" }, Mw = { class: "smake:flex smake:justify-between smake:gap-5" }, Tw = /* @__PURE__ */ J({
  __name: "ChangeProductionMethodDialouge",
  props: /* @__PURE__ */ Ae({
    targetProductionMethodId: {}
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Ae(["closed", "resolve"], ["update:open"]),
  setup(t, { emit: e }) {
    const n = e, s = Ne(t, "open"), o = t, { targetProductionMethodId: a } = we(o), { rootElement: i } = D(jt()), { appConfiguration: r } = D(tt()), { selectedProductionMethodId: c } = D(Je()), u = A(
      () => {
        var z;
        return (z = r.value) == null ? void 0 : z.productionMethods.find(
          (h) => h.id === c.value
        );
      }
    ), d = A(
      () => {
        var z;
        return (z = r.value) == null ? void 0 : z.productionMethods.find(
          (h) => h.id === a.value
        );
      }
    ), m = A(() => {
      if (d.value)
        return jl[d.value.handle];
    }), { selectedViewIndex: _ } = D(sn()), g = N(_.value);
    function v() {
      _.value = g.value, n("resolve", !0);
    }
    return (z, h) => ($(), q(l(Ct), {
      open: s.value,
      "onUpdate:open": h[2] || (h[2] = (y) => s.value = y)
    }, {
      default: C(() => [
        b(l(Pt), { to: l(i) }, {
          default: C(() => [
            b(De, {
              appear: "",
              "enter-active-class": "smake:duration-300 smake:ease-out",
              "enter-from-class": "smake:opacity-0",
              "leave-active-class": "smake:duration-200 smake:ease-in",
              "leave-to-class": "smake:opacity-0",
              onAfterLeave: h[0] || (h[0] = (y) => n("closed"))
            }, {
              default: C(() => [
                b(l(Mt), { class: "smake:fixed smake:inset-0 smake:bg-black/40" })
              ]),
              _: 1
            }),
            b(De, {
              appear: "",
              "enter-active-class": "smake:duration-300 smake:ease-out",
              "enter-from-class": "smake:scale-95 smake:opacity-0",
              "leave-active-class": "smake:duration-200 smake:ease-in",
              "leave-to-class": "smake:scale-95 smake:opacity-0"
            }, {
              default: C(() => [
                b(l(Tt), { "as-child": "" }, {
                  default: C(() => {
                    var y, w;
                    return [
                      x("div", ww, [
                        x("div", xw, [
                          b(l(At), { class: "smake:flex smake:items-center smake:gap-3 smake:text-2xl smake:font-bold smake:uppercase" }, {
                            default: C(() => {
                              var P;
                              return [
                                m.value ? ($(), q(l(is), {
                                  key: 0,
                                  icon: m.value,
                                  "fixed-width": "",
                                  class: "smake:size-6"
                                }, null, 8, ["icon"])) : Q("", !0),
                                he(" " + L((P = d.value) == null ? void 0 : P.display_name) + " " + L(z.$t("icon")), 1)
                              ];
                            }),
                            _: 1
                          }),
                          b(l(zt), { class: "smake:-mt-2 smake:-mr-2 smake:rounded-full smake:border smake:border-secondary-2 smake:p-2 smake:duration-150 smake:hover:bg-secondary-3" }, {
                            default: C(() => [
                              b(l(is), {
                                icon: ["fak", "icon-x"],
                                "fixed-width": "",
                                class: "smake:size-3"
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        x("div", $w, [
                          x("div", zw, [
                            b(l(is), {
                              icon: ["fal", "circle-exclamation"],
                              "fixed-width": "",
                              class: "smake:size-6"
                            }),
                            x("div", Sw, L(z.$t("change_production_method_info", {
                              fromProductionMethod: (y = u.value) == null ? void 0 : y.display_name
                            })), 1)
                          ]),
                          x("div", Aw, L(z.$t(
                            "to_place_motif_change_production_method",
                            {
                              toProductionMethod: (w = d.value) == null ? void 0 : w.display_name
                            }
                          )), 1),
                          x("div", Cw, L(z.$t(
                            "preview_of_possibile_positioning_areas"
                          )) + ": ", 1),
                          x("div", Pw, [
                            b(bw, {
                              "selected-view-index": g.value,
                              "onUpdate:selectedViewIndex": h[1] || (h[1] = (P) => g.value = P),
                              "production-method-id": l(a)
                            }, null, 8, ["selected-view-index", "production-method-id"])
                          ])
                        ]),
                        x("div", Mw, [
                          b(l(zt), null, {
                            default: C(() => [
                              b(Re, {
                                class: "smake:grow smake:px-4 smake:py-3",
                                type: "outline"
                              }, {
                                default: C(() => [
                                  he(L(z.$t("abort")), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          b(l(zt), null, {
                            default: C(() => [
                              b(Re, {
                                class: "smake:grow smake:px-4 smake:py-3",
                                type: "primary",
                                onClick: v
                              }, {
                                default: C(() => {
                                  var P;
                                  return [
                                    he(L(z.$t("change_to_x", {
                                      x: (P = d.value) == null ? void 0 : P.display_name
                                    })), 1)
                                  ];
                                }),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ];
                  }),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _: 1
    }, 8, ["open"]));
  }
});
function Iw() {
  const t = lt(), e = en(
    (s) => t.fetchQuery({
      ...ce.logos.get.use(s),
      retry: !1,
      staleTime: 1 / 0
    })
  );
  async function n(s, o) {
    const a = Ra(s), i = Ra(o), r = i.find(
      (g) => g.type === ze.LOGO
    ), c = i.find(
      (g) => g.type === ze.TEXT
    );
    if (o.type === ze.ANCHOR) return o;
    const u = a.find(
      (g) => g.type === ze.LOGO
    ), d = a.find(
      (g) => g.type === ze.TEXT
    ), m = c ?? d, _ = r ?? u;
    if (_ !== void 0 && m !== void 0) {
      const g = Wn(await e(_.logoId));
      return {
        children: [
          {
            anchor: g.design_settings.next_element_alignment.anchor_value,
            offset: g.design_settings.next_element_alignment.offset,
            value: m
          }
        ],
        parent: _,
        type: ze.ANCHOR
      };
    }
    if (m)
      return m;
    if (_)
      return _;
    throw new Error("Design Merge Failed. Invalid data");
  }
  return {
    merge: n
  };
}
function Ra(t) {
  return t.type === ze.ANCHOR ? [
    ...Ra(t.parent),
    ...t.children.flatMap((e) => Ra(e.value))
  ] : [t];
}
function Ew() {
  const t = lt(), e = en(
    (s) => t.fetchQuery({
      ...ce.logos.get.use(s),
      retry: !1,
      staleTime: 1 / 0
    })
  );
  async function n(s, o) {
    const a = await e(s.logoId);
    if (a.width === null || a.height === null || a.min_width === null || a.max_width === null || a.min_height === null || a.max_height === null || a.min_width >= a.max_width || a.min_height >= a.max_height)
      return s;
    const i = Math.min(
      wo(
        Math.min(
          o.width / a.width,
          o.height / a.height
        ),
        Math.max(
          a.min_width / a.width,
          a.min_height / a.height
        ),
        Math.min(
          a.max_width / a.width,
          a.max_height / a.height
        )
      ),
      1
    );
    return s.size = {
      height: a.height * i,
      width: a.width * i
    }, s;
  }
  return {
    resize: n
  };
}
const si = st(
  "placeDesignToPositioningArea",
  () => {
    const { waitForSelectingPositioningArea: t } = Xt(), { open: e } = pn(), {
      positioningArea: n,
      positioningAreaDesign: s
    } = D(dn()), { selectedPositioningAreaDesign: o } = D(Sn()), { selectedProductionMethodId: a } = D(
      Je()
    ), { resize: i } = Ew(), { merge: r } = Iw(), c = vm();
    async function u(d, m) {
      var z;
      let _ = m == null ? void 0 : m.positioningArea, g = m == null ? void 0 : m.mergePostioningAreaDesign;
      if (_ && _.productionMethodId !== d.productionMethodId && (_ = void 0, g = void 0), !_ || d.productionMethodId !== a.value) {
        if (d.productionMethodId !== a.value && !await e(
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
          Tw,
          {
            input: {
              targetProductionMethodId: d.productionMethodId
            }
          }
        ))
          return "aborted-production-method-change";
        const h = a.value;
        if (a.value = d.productionMethodId, _ = (await t()).data, !_)
          return a.value = h, "aborted-positioning-area-selection";
      }
      n.value = _, g || (s.value = void 0);
      const v = d.design.type === ze.LOGO ? await i(d.design, _) : d.design;
      return g ? g.design = await r(
        g.design,
        v
      ) : (g = {
        design: v,
        rotation: ((z = c(_.id)) == null ? void 0 : z.direction) ?? 0
      }, _.designs.push(g), o.value = g), s.value = g, "success";
    }
    return {
      placeDesign: u
    };
  }
), bs = (t, e) => {
  const n = t.__vccOpts || t;
  for (const [s, o] of e)
    n[s] = o;
  return n;
}, Ow = {}, Rw = {
  id: "Ebene_2",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18.89 14.34"
};
function Lw(t, e) {
  return $(), I("svg", Rw, [...e[0] || (e[0] = [
    ld('<g id="Ebene_1-2"><g id="Gruppe_32181"><g id="Gruppe_1731"><path fill="currentColor" d="M16.21.23c-.18-.16-.4-.24-.65-.23-.24.01-.46.12-.62.3l-5.87,6.63-2.82-2.82c-.35-.35-.92-.35-1.27,0-.35.35-.35.92,0,1.27l3.5,3.5c.17.17.4.26.64.26h.02s0,0,0,0c.25,0,.48-.12.65-.3l6.51-7.34c.33-.37.3-.94-.08-1.27Z"></path><path id="Pfad_1400" fill="currentColor" d="M18,7.65c-.49,0-.88.39-.88.88v3.15c0,.5-.42.9-.92.9H2.67c-.5,0-.9-.4-.91-.9v-3.15c0-.49-.39-.88-.88-.88s-.88.39-.88.88v3.16c.01,1.47,1.2,2.65,2.66,2.65h13.53c.71.03,1.4-.25,1.89-.77.51-.5.8-1.18.8-1.89v-3.16c0-.49-.39-.88-.88-.88"></path></g></g></g>', 1)
  ])]);
}
const Dw = /* @__PURE__ */ bs(Ow, [["render", Lw]]), jw = {}, Nw = {
  id: "Ebene_2",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26.06 22.13"
};
function Vw(t, e) {
  return $(), I("svg", Nw, [...e[0] || (e[0] = [
    x("g", { id: "Ebene_1-2" }, [
      x("path", {
        fill: "currentColor",
        d: "M23.85,3.99h-10.6l-3.33-3.27c-.47-.46-1.09-.72-1.75-.72H2.49C1.12,0,0,1.12,0,2.49v17.43c0,1.21.99,2.2,2.2,2.2h21.65c1.21,0,2.2-.99,2.2-2.2V6.19c0-1.21-.99-2.2-2.2-2.2ZM1.8,2.49c0-.38.31-.69.69-.69h5.69c.18,0,.36.07.49.2l2.02,1.99H1.8v-1.5ZM24.26,19.93c0,.22-.18.4-.4.4H2.2c-.22,0-.4-.18-.4-.4V5.79h22.05c.22,0,.4.18.4.4v13.73Z"
      }),
      x("path", {
        fill: "currentColor",
        d: "M9.92,18.46c-.15,0-.29-.05-.41-.13-.22-.16-.32-.42-.28-.68l.53-3.1-2.25-2.2c-.19-.19-.26-.46-.18-.72.08-.25.3-.44.56-.48l3.11-.45,1.39-2.82c.24-.48,1.02-.48,1.26,0l1.39,2.82,3.11.45c.26.04.48.22.56.48.08.25.01.53-.18.72l-2.25,2.2.53,3.1c.04.26-.06.53-.28.68-.22.16-.5.18-.74.05l-2.79-1.46-2.79,1.46c-.1.05-.21.08-.33.08ZM13.03,15.42c.11,0,.22.03.33.08l1.86.98-.35-2.07c-.04-.23.04-.46.2-.62l1.5-1.46-2.08-.3c-.23-.03-.43-.18-.53-.38l-.93-1.88-.93,1.88c-.1.21-.3.35-.53.38l-2.08.3,1.5,1.46c.17.16.24.39.2.62l-.35,2.07,1.86-.98c.1-.05.21-.08.33-.08Z"
      })
    ], -1)
  ])]);
}
const Uw = /* @__PURE__ */ bs(jw, [["render", Vw]]), Fw = { class: "smake:flex smake:grow smake:flex-col smake:items-center smake:gap-1 smake:font-semibold" }, Bw = {
  key: 0,
  class: "smake:text-xs"
}, qw = /* @__PURE__ */ J({
  __name: "SelectItem",
  props: {
    productionMethodId: {}
  },
  setup(t) {
    const e = t, { productionMethodId: n } = we(e), { isAvailableOnCurrentVariant: s, productionMethod: o, shortDescription: a } = It(n);
    return (i, r) => l(o) ? ($(), q(l(bd), {
      key: 0,
      disabled: !l(s),
      value: l(o).id.toString(),
      class: ke(["smake:flex smake:items-center smake:gap-2 smake:rounded-full smake:border smake:border-secondary-2 smake:p-1 smake:pr-3 smake:duration-150 smake:enabled:cursor-pointer smake:enabled:hover:border-black smake:data-[state=checked]:border-black smake:data-[state=checked]:bg-black smake:data-[state=checked]:text-white", {
        "smake:text-slate-400 smake:grayscale-[98%]": !l(s)
      }])
    }, {
      default: C(() => [
        b(on, {
          src: l(o).preview_url,
          class: "smake:size-12 smake:rounded-full smake:object-cover smake:data-[state=pending]:animate-pulse smake:data-[state=pending]:bg-secondary-2"
        }, null, 8, ["src"]),
        x("div", Fw, [
          b(l(wd), null, {
            default: C(() => [
              he(L(l(o).display_name), 1)
            ]),
            _: 1
          }),
          l(a) ? ($(), I("span", Bw, L(l(a)), 1)) : Q("", !0)
        ])
      ]),
      _: 1
    }, 8, ["disabled", "value", "class"])) : Q("", !0);
  }
}), Hw = {
  key: 0,
  class: "smake:rounded-full smake:bg-secondary-3 smake:p-1.5"
}, bm = /* @__PURE__ */ J({
  __name: "ProductionMethodSelect",
  props: /* @__PURE__ */ Ae({
    disabled: { type: Boolean }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = Ne(t, "modelValue"), n = t, { disabled: s } = we(n), o = A({
      get: () => e.value.toString(),
      set: (u) => {
        e.value = Number.parseInt(u);
      }
    }), { icon: a, productionMethod: i } = It(e), { rootElement: r } = D(jt()), { activatedProductionMethodIds: c } = D(
      Je()
    );
    return (u, d) => {
      const m = xe("FontAwesomeIcon");
      return $(), q(l(xd), {
        modelValue: o.value,
        "onUpdate:modelValue": d[0] || (d[0] = (_) => o.value = _),
        disabled: l(s)
      }, {
        default: C(() => [
          b(l($d), { "as-child": "" }, {
            default: C(() => [
              b(Re, {
                type: "outline",
                class: "smake:grow smake:p-1 smake:pr-2 smake:@sm:grow-0"
              }, {
                default: C(() => [
                  l(a) ? ($(), I("div", Hw, [
                    b(m, {
                      icon: l(a),
                      "fixed-width": "",
                      class: "smake:size-4.5"
                    }, null, 8, ["icon"])
                  ])) : Q("", !0),
                  l(i) ? ($(), q(l(zd), {
                    key: 1,
                    class: "smake:grow smake:p-1.5"
                  }, {
                    default: C(() => [
                      he(L(l(i).display_name), 1)
                    ]),
                    _: 1
                  })) : Q("", !0),
                  b(l(Xf), null, {
                    default: C(() => [
                      b(m, {
                        icon: ["fal", "chevron-down"],
                        class: "smake:h-4"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          b(l(Sd), { to: l(r) }, {
            default: C(() => [
              b(l(Ad), {
                class: "smake:rounded-3xl smake:bg-white smake:p-4 smake:shadow-[0_0_15px_0_rgba(0,0,0,0.25)]",
                position: "popper",
                "side-offset": 8,
                align: "center"
              }, {
                default: C(() => [
                  b(l(Cd), { class: "smake:flex smake:flex-col smake:gap-2" }, {
                    default: C(() => [
                      ($(!0), I(me, null, Se(l(c), (_) => ($(), q(qw, {
                        key: _,
                        "production-method-id": _
                      }, null, 8, ["production-method-id"]))), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _: 1
      }, 8, ["modelValue", "disabled"]);
    };
  }
}), ho = /* @__PURE__ */ J({
  __name: "VariantTabsTrigger",
  props: {
    selectedValue: {},
    value: {}
  },
  setup(t) {
    const e = t, { selectedValue: n, value: s } = we(e), o = A(() => n.value === s.value);
    return (a, i) => ($(), q(l(Pd), {
      value: l(s),
      "as-child": ""
    }, {
      default: C(() => [
        b(_m, {
          type: o.value ? "active" : "subordinate"
        }, {
          default: C(() => [
            St(a.$slots, "default")
          ]),
          _: 3
        }, 8, ["type"])
      ]),
      _: 3
    }, 8, ["value"]));
  }
}), Ww = { class: "smake:absolute smake:inset-x-5 smake:top-1/2 smake:mx-auto smake:flex smake:h-fit smake:max-h-full smake:max-w-100 smake:-translate-y-1/2 smake:flex-col smake:gap-4 smake:overflow-y-auto smake:rounded-3xl smake:bg-white smake:p-4" }, Gw = { class: "smake:flex smake:items-start smake:justify-between smake:gap-2" }, Zw = { class: "smake:font-bold smake:text-primary-1" }, Kw = { class: "smake:flex smake:flex-col smake:items-center smake:justify-between smake:gap-5" }, Xw = {
  key: 0,
  class: "smake:w-full smake:rounded-lg smake:border smake:border-danger smake:p-2 smake:text-danger"
}, Qw = { class: "smake:w-full smake:flex-col" }, Jw = ["disabled"], Yw = {
  key: 0,
  class: "smake:flex smake:flex-col smake:justify-start smake:gap-2 smake:p-1 smake:text-xs smake:font-bold smake:text-danger"
}, e3 = { class: "smake:flex smake:w-full smake:flex-col smake:gap-4 smake:@md:flex-row" }, wm = /* @__PURE__ */ J({
  __name: "RenameDialog",
  props: /* @__PURE__ */ Ae({
    name: {},
    error: {},
    image: {},
    mutationStatus: {}
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Ae(["closed", "rename", "resolve"], ["update:open"]),
  setup(t, { emit: e }) {
    const n = e, s = Ne(t, "open"), o = t, a = o.name, { dialogsRoot: i } = D(nn()), { error: r, mutationStatus: c } = we(o), u = A(() => c.value === "pending");
    function d(w) {
      u.value || w.preventDefault();
    }
    const m = N(), _ = N(a);
    re(() => {
      c.value === "success" && (s.value = !1);
    });
    const { t: g } = ct();
    function v() {
      if (_.value === o.name) {
        s.value = !1;
        return;
      }
      n("rename", _.value);
    }
    const { data: z } = bt({
      enabled: A(() => !!r.value),
      queryFn: () => {
        if (r.value instanceof Hn)
          return r.value.response.json();
      },
      queryKey: [r]
    }), h = A(() => {
      if (!(!r.value || r.value instanceof Hn && r.value.response.status === 422))
        return g("boot_error.unexpected");
    }), y = A(() => {
      var w;
      if (!(!r.value || !(r.value instanceof Hn) || r.value.response.status !== 422))
        return (w = z.value) == null ? void 0 : w.errors.name;
    });
    return (w, P) => {
      const M = xe("I18nT"), E = xe("FontAwesomeIcon");
      return $(), q(l(Ct), {
        open: s.value,
        "onUpdate:open": P[3] || (P[3] = (R) => s.value = R)
      }, {
        default: C(() => [
          b(l(Pt), { to: l(i) }, {
            default: C(() => [
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:opacity-0",
                onAfterLeave: P[0] || (P[0] = (R) => n("closed"))
              }, {
                default: C(() => [
                  b(l(Mt), { class: "smake:fixed smake:inset-0 smake:bg-black/40" })
                ]),
                _: 1
              }),
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:scale-95 smake:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:scale-95 smake:opacity-0"
              }, {
                default: C(() => [
                  b(l(Tt), {
                    "as-child": "",
                    onInteractOutside: d,
                    onEscapeKeyDown: d
                  }, {
                    default: C(() => [
                      x("div", Ww, [
                        x("div", Gw, [
                          b(l(At), null, {
                            default: C(() => [
                              b(M, {
                                keypath: "do_you_want_to_rename",
                                tag: "span",
                                class: "smake:align-middle"
                              }, {
                                name: C(() => [
                                  x("span", Zw, L(l(a)), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          b(l(zt), { class: "smake:-mt-2 smake:-mr-2 smake:rounded-full smake:border smake:border-secondary-2 smake:p-2 smake:duration-150 smake:hover:bg-secondary-3" }, {
                            default: C(() => [
                              b(E, {
                                icon: ["fak", "icon-x"],
                                "fixed-width": "",
                                class: "smake:size-3"
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        x("div", Kw, [
                          b(on, {
                            class: "smake:aspect-square smake:w-80 smake:rounded-3xl smake:bg-secondary-3 smake:object-contain smake:p-4 smake:data-[state=pending]:animate-pulse smake:data-[state=pending]:rounded-md smake:data-[state=pending]:bg-secondary-2",
                            src: w.image
                          }, null, 8, ["src"]),
                          h.value && !y.value ? ($(), I("div", Xw, L(h.value), 1)) : Q("", !0),
                          x("div", Qw, [
                            mt(x("input", {
                              ref_key: "newNameInput",
                              ref: m,
                              "onUpdate:modelValue": P[1] || (P[1] = (R) => _.value = R),
                              type: "text",
                              maxlength: 60,
                              class: ke([
                                "smake:w-full smake:rounded-md smake:border smake:px-4 smake:py-3 smake:outline-none smake:focus:border-black smake:disabled:cursor-not-allowed smake:disabled:text-secondary-2",
                                y.value ? "border-danger" : "border-secondary-2"
                              ]),
                              placeholder: "Text einfügen",
                              disabled: u.value,
                              onKeydown: la(v, ["enter"])
                            }, null, 42, Jw), [
                              [vn, _.value]
                            ]),
                            y.value ? ($(), I("div", Yw, [
                              ($(!0), I(me, null, Se(y.value, (R) => ($(), I("div", { key: R }, L(R), 1))), 128))
                            ])) : Q("", !0)
                          ]),
                          x("div", e3, [
                            b(Re, {
                              type: "outline",
                              disabled: u.value,
                              class: "smake:flex-grow",
                              onClick: P[2] || (P[2] = (R) => s.value = !1)
                            }, {
                              default: C(() => [
                                he(L(w.$t("abort")), 1)
                              ]),
                              _: 1
                            }, 8, ["disabled"]),
                            b(Re, {
                              type: "primary",
                              disabled: _.value.length === 0 || u.value,
                              class: "smake:flex smake:flex-grow smake:items-center smake:gap-2",
                              onClick: v
                            }, {
                              default: C(() => [
                                b(E, {
                                  class: "smake:h-5",
                                  icon: ["fal", "save"]
                                }),
                                he(" " + L(w.$t("save")), 1)
                              ]),
                              _: 1
                            }, 8, ["disabled"])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _: 1
      }, 8, ["open"]);
    };
  }
}), Gu = /* @__PURE__ */ J({
  __name: "Tooltip",
  setup(t) {
    return (e, n) => ($(), q(l(Qf), {
      disabled: e.$slots.tooltip === void 0,
      "delay-duration": 0
    }, {
      default: C(() => [
        b(l(Jf), null, {
          default: C(() => [
            b(l(Yf), {
              as: "div",
              class: "smake:cursor-default"
            }, {
              default: C(() => [
                St(e.$slots, "default")
              ]),
              _: 3
            }),
            b(l(e_), null, {
              default: C(() => [
                b(l(t_), {
                  class: "smake:data-[state=delayed-open]:data-[side=top]:animate-slideDownAndFade smake:data-[state=delayed-open]:data-[side=right]:animate-slideLeftAndFade smake:data-[state=delayed-open]:data-[side=left]:animate-slideRightAndFade smake:data-[state=delayed-open]:data-[side=bottom]:animate-slideUpAndFade shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] will-change-[transform,opacity] smake:rounded smake:bg-white smake:px-3.75 smake:py-2.5 smake:text-[15px] smake:leading-none smake:select-none",
                  "side-offset": 5
                }, {
                  default: C(() => [
                    St(e.$slots, "tooltip"),
                    b(l(n_), {
                      class: "smake:fill-white",
                      width: 8
                    })
                  ]),
                  _: 3
                })
              ]),
              _: 3
            })
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["disabled"]));
  }
});
function Zu(t, e) {
  return t.length > e ? `${t.slice(0, e)}…` : t;
}
const t3 = { class: "smake:flex smake:h-full smake:flex-col smake:overflow-clip smake:rounded-3xl smake:border smake:border-secondary-2" }, n3 = { class: "smake:flex smake:justify-center smake:pt-1 smake:pb-2" }, s3 = { class: "smake:flex smake:grow smake:flex-col smake:gap-2 smake:px-4 smake:py-4 smake:text-center" }, o3 = { class: "smake:flex smake:flex-col smake:gap-2" }, a3 = { class: "smake:font-bold" }, i3 = { class: "smake:text-xs" }, r3 = { class: "smake:flex smake:flex-wrap smake:justify-center smake:gap-2" }, l3 = {
  key: 0,
  class: "smake:size-4 smake:rounded-full smake:bg-[radial-gradient(#fff_15%,transparent_60%),conic-gradient(red,yellow,lime,aqua,blue,magenta,red)]"
}, c3 = { class: "smake:grow smake:text-xs smake:text-danger" }, u3 = { class: "smake:flex smake:flex-col smake:gap-3" }, xm = /* @__PURE__ */ J({
  __name: "SelectionCard",
  props: {
    name: {},
    colorAssignments: {},
    deletable: { type: Boolean },
    externalIdentifier: {},
    height: {},
    image: {},
    needsRepair: { type: Boolean },
    productionMethodId: {},
    width: {}
  },
  emits: ["delete", "rename", "repair", "select"],
  setup(t, { emit: e }) {
    const n = t, { colorAssignments: s, productionMethodId: o } = we(n), { appConfiguration: a, designerConfiguration: i } = D(
      tt()
    ), r = A(() => {
      var h;
      return (h = a.value) == null ? void 0 : h.colors;
    }), c = A(
      () => {
        var h;
        return (h = i.value) == null ? void 0 : h.settings.settings.units;
      }
    ), { decimalFormat: u } = Xa(), { locale: d } = ct();
    function m(h) {
      if (h !== void 0)
        return u(h, d.value, 2);
    }
    const _ = A(() => s.value.length === 0), g = A(() => s.value.map((y) => {
      var w;
      if (y.color) {
        const P = (w = r.value) == null ? void 0 : w.find(
          (M) => y.color.id === M.id
        );
        return P ? {
          blue: P.blue,
          green: P.green,
          red: P.red
        } : void 0;
      }
      return {
        blue: y.blue,
        green: y.green,
        red: y.red
      };
    }).filter((y) => !!y).reduce((y, w) => (y.some((P) => Gr(P, w)) || y.push(w), y), [])), { icon: v } = It(o), z = e;
    return (h, y) => {
      var w;
      return $(), I("div", t3, [
        x("div", {
          class: ke(["smake:relative smake:cursor-pointer smake:p-8", {
            "smake:bg-danger/50": h.needsRepair,
            "smake:bg-secondary-3": !h.needsRepair
          }])
        }, [
          h.deletable ? ($(), I("button", {
            key: 0,
            class: "smake:absolute smake:top-3 smake:right-3 smake:flex smake:aspect-square smake:w-10 smake:items-center smake:justify-center smake:rounded-full smake:bg-white smake:p-2 smake:hover:text-secondary-1",
            type: "button",
            onClick: y[0] || (y[0] = (P) => z("delete"))
          }, [
            b(l(is), {
              class: "smake:h-4",
              icon: ["fak", "icon-remove"],
              "fixed-width": ""
            })
          ])) : Q("", !0),
          l(v) ? ($(), q(l(is), {
            key: 1,
            class: "smake:absolute smake:top-4 smake:left-4 smake:h-4",
            icon: l(v),
            "fixed-width": ""
          }, null, 8, ["icon"])) : Q("", !0),
          h.needsRepair ? ($(), q(l(is), {
            key: 2,
            class: "smake:absolute smake:bottom-4 smake:left-4 smake:h-6 smake:rounded-full smake:bg-danger smake:text-white",
            icon: ["fal", "circle-exclamation"]
          })) : Q("", !0),
          b(on, {
            src: h.image,
            class: "smake:aspect-square smake:w-full smake:rounded-2xl smake:object-contain smake:data-[state=pending]:animate-pulse smake:data-[state=pending]:bg-secondary-2"
          }, null, 8, ["src"]),
          x("div", n3, [
            h.externalIdentifier ? ($(), q(Gu, {
              key: 0,
              class: "smake:text-sm"
            }, Er({
              default: C(() => [
                he(" #" + L(l(Zu)(h.externalIdentifier, 15)) + " ", 1)
              ]),
              _: 2
            }, [
              h.externalIdentifier.length > 15 ? {
                name: "tooltip",
                fn: C(() => [
                  he(" #" + L(h.externalIdentifier), 1)
                ]),
                key: "0"
              } : void 0
            ]), 1024)) : Q("", !0)
          ])
        ], 2),
        x("div", s3, [
          x("div", o3, [
            b(Gu, null, Er({
              default: C(() => [
                x("div", a3, L(l(Zu)(h.name, 60)), 1)
              ]),
              _: 2
            }, [
              h.name.length > 60 ? {
                name: "tooltip",
                fn: C(() => [
                  he(L(h.name), 1)
                ]),
                key: "0"
              } : void 0
            ]), 1024),
            x("span", i3, L(m(h.width)) + " x " + L(m(h.height)) + " " + L((w = c.value) == null ? void 0 : w.length), 1)
          ]),
          x("div", r3, [
            _.value ? ($(), I("div", l3)) : Q("", !0),
            ($(!0), I(me, null, Se(g.value, (P) => ($(), I("div", {
              key: l(ft)(P),
              class: ke([
                "smake:aspect-square smake:w-4 smake:rounded-full smake:border",
                l(Ll)([P.red, P.green, P.blue]) ? "smake:border-secondary-2" : "smake:border-transparent"
              ]),
              style: Kt({
                backgroundColor: `rgb(${P.red},${P.green},${P.blue})`
              })
            }, null, 6))), 128))
          ]),
          x("div", c3, [
            St(h.$slots, "repair-label")
          ]),
          x("div", u3, [
            b(et, {
              disabled: h.needsRepair,
              type: "secondary",
              icon: {
                type: ["fal", "plus"]
              },
              size: "small",
              text: h.$t("choose"),
              onClick: y[1] || (y[1] = (P) => z("select"))
            }, null, 8, ["disabled", "text"]),
            h.needsRepair ? ($(), q(et, {
              key: 0,
              type: "primary",
              icon: {
                type: ["fal", "rotate-reverse"]
              },
              size: "small",
              text: h.$t("update"),
              onClick: y[2] || (y[2] = (P) => z("repair"))
            }, null, 8, ["text"])) : ($(), q(et, {
              key: 1,
              type: "subordinate",
              icon: {
                type: ["fak", "icon-edit"]
              },
              size: "small",
              text: h.$t("rename"),
              onClick: y[3] || (y[3] = (P) => z("rename"))
            }, null, 8, ["text"]))
          ])
        ])
      ]);
    };
  }
}), d3 = /* @__PURE__ */ J({
  __name: "CustomerLogoCard",
  props: {
    customerLogo: {}
  },
  emits: ["select"],
  setup(t, { emit: e }) {
    const n = t, { customerLogo: s } = we(n), o = e, a = N(!1), {
      error: i,
      mutate: r,
      reset: c,
      status: u
    } = yt({
      ...ce.customerLogos.patch.use(),
      onSuccess: () => a.value = !1
    });
    re(() => {
      a.value || c();
    });
    const d = A(
      () => s.value.name ?? s.value.logo.name
    ), m = A(() => s.value.logo.preview_url ?? void 0);
    return (_, g) => ($(), I(me, null, [
      b(xm, {
        name: d.value,
        "external-identifier": l(s).logo.external_identifier ?? void 0,
        image: m.value,
        width: l(s).logo.width ?? void 0,
        height: l(s).logo.height ?? void 0,
        "color-assignments": l(s).logo.color_assignments,
        "show-rainbow-icon": l(s).logo.color_assignments.length === 0,
        "production-method-id": l(s).logo.production_method.id,
        onRename: g[0] || (g[0] = (v) => a.value = !0),
        onSelect: g[1] || (g[1] = (v) => o("select"))
      }, null, 8, ["name", "external-identifier", "image", "width", "height", "color-assignments", "show-rainbow-icon", "production-method-id"]),
      b(wm, {
        open: a.value,
        "onUpdate:open": g[2] || (g[2] = (v) => a.value = v),
        name: d.value,
        image: m.value,
        error: l(i) ?? void 0,
        "mutation-status": l(u),
        onRename: g[3] || (g[3] = (v) => l(r)({ id: l(s).id, name: v }))
      }, null, 8, ["open", "name", "image", "error", "mutation-status"])
    ], 64));
  }
}), p3 = {}, m3 = {
  id: "Ebene_2",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18.41 17.09"
};
function h3(t, e) {
  return $(), I("svg", m3, [...e[0] || (e[0] = [
    x("g", { id: "Ebene_1-2" }, [
      x("path", {
        id: "Pfad_1021",
        fill: "currentColor",
        d: "M9.76.21c-.32-.28-.79-.28-1.12,0l-3.34,2.86c-.38.29-.45.83-.16,1.2.29.38.83.45,1.2.16.03-.02.05-.04.07-.06l1.92-1.64v7.67c.02.47.41.85.89.83.45-.02.81-.38.83-.83V2.72l1.92,1.64c.35.32.9.29,1.21-.07s.29-.9-.07-1.21c0,0-.02-.02-.03-.02L9.76.21Z"
      }),
      x("path", {
        id: "Pfad_1022",
        fill: "currentColor",
        d: "M17.54,10.56c-.47,0-.86.38-.86.86h0v3.07c0,.49-.4.88-.89.88H2.6c-.48,0-.88-.39-.89-.87v-3.08c-.02-.47-.41-.85-.89-.83-.45.02-.81.38-.83.83v3.08c.01,1.43,1.17,2.58,2.6,2.59h13.18c.69.03,1.37-.25,1.85-.75.49-.48.77-1.15.78-1.84v-3.08c0-.47-.38-.86-.86-.86,0,0,0,0,0,0Z"
      })
    ], -1)
  ])]);
}
const oi = /* @__PURE__ */ bs(p3, [["render", h3]]), f3 = { class: "smake:flex smake:items-center smake:justify-center smake:rounded-full smake:bg-primary-1 smake:p-4 smake:text-white" }, _3 = { class: "smake:text-center smake:font-semibold" }, v3 = /* @__PURE__ */ J({
  __name: "CustomerLogoUploadCard",
  props: {
    positioningArea: {},
    positioningAreaDesign: {},
    productionMethodId: {}
  },
  emits: ["placed"],
  setup(t, { emit: e }) {
    const n = t, { productionMethodId: s } = we(n), { isCustomerLogoUploadEnabled: o } = It(s), a = e, i = N(!1);
    return (r, c) => l(o) ? ($(), I(me, { key: 0 }, [
      x("button", {
        class: "smake:flex smake:min-h-95 smake:flex-col smake:items-center smake:justify-center smake:gap-4 smake:rounded-3xl smake:border smake:border-secondary-2",
        onClick: c[0] || (c[0] = (u) => i.value = !0)
      }, [
        x("div", f3, [
          b(oi, { class: "smake:size-8" })
        ]),
        x("div", _3, L(r.$t("upload_file")), 1)
      ]),
      b(Uo, {
        open: i.value,
        "onUpdate:open": c[1] || (c[1] = (u) => i.value = u),
        "production-method-id": l(s),
        "positioning-area": r.positioningArea,
        "positioning-area-design": r.positioningAreaDesign,
        onResolve: c[2] || (c[2] = (u) => a("placed"))
      }, null, 8, ["open", "production-method-id", "positioning-area", "positioning-area-design"])
    ], 64)) : Q("", !0);
  }
}), g3 = { class: "smake:grid smake:grid-cols-auto-fill-38 smake:gap-4 smake:overflow-y-auto smake:@sm:grid-cols-auto-fill-45" }, k3 = {
  key: 0,
  class: "smake:-mt-8 smake:flex smake:grow smake:items-center smake:justify-center smake:text-lg"
}, y3 = { class: "smake:max-w-md smake:text-center smake:text-secondary-1 smake:italic" }, b3 = /* @__PURE__ */ J({
  __name: "CustomerLogoSelection",
  props: {
    positioningArea: {},
    positioningAreaDesign: {},
    productionMethodId: {}
  },
  emits: ["customer-logo-selected", "upload-placed"],
  setup(t, { emit: e }) {
    const n = e, s = t, { productionMethodId: o } = we(s), { isCustomerLogoUploadEnabled: a, productionMethod: i } = It(o), { customerLogoUploadInfo: r } = D(Zs()), { t: c } = ct(), u = A(() => ({
      production_method: [o.value]
    })), {
      data: d,
      fetchNextPage: m,
      hasNextPage: _,
      isFetching: g,
      status: v
    } = js({
      ...ce.customerLogos.list.use(u),
      select: (y) => y.pages.flatMap((w) => w.data),
      staleTime: 60 * 1e3
    });
    function z() {
      return v.value === "pending" ? !0 : _.value;
    }
    async function h() {
      v.value !== "pending" && await m();
    }
    return (y, w) => {
      var P, M, E;
      return $(), I(me, null, [
        mt(($(), I("div", g3, [
          b(v3, {
            "production-method-id": l(o),
            "positioning-area": y.positioningArea,
            "positioning-area-design": y.positioningAreaDesign,
            onPlaced: w[0] || (w[0] = (R) => n("upload-placed"))
          }, null, 8, ["production-method-id", "positioning-area", "positioning-area-design"]),
          l(g) || (P = l(d)) != null && P.length ? ($(!0), I(me, { key: 0 }, Se(l(d), (R) => ($(), I("div", {
            key: R.id
          }, [
            b(d3, {
              "customer-logo": R,
              onSelect: (j) => n("customer-logo-selected", l(Wn)(R))
            }, null, 8, ["customer-logo", "onSelect"])
          ]))), 128)) : Q("", !0),
          ($(!0), I(me, null, Se(l(g) ? 3 : 0, (R) => ($(), I("div", {
            key: R,
            class: "smake:min-h-95 smake:animate-pulse smake:rounded-3xl smake:bg-secondary-3"
          }))), 128))
        ])), [
          [l($o), [h, { distance: 350, canLoadMore: z }]]
        ]),
        !l(a) && !l(g) && (((M = l(d)) == null ? void 0 : M.length) ?? 0) === 0 ? ($(), I("div", k3, [
          x("span", y3, L(l(c)("no_customer_logos_for_production_method", {
            productionMethod: (E = l(i)) == null ? void 0 : E.display_name
          })) + " " + L(l(r)) + " " + L(y.$t("otherwise_change_personalization_type_top_right")), 1)
        ])) : Q("", !0)
      ], 64);
    };
  }
}), w3 = {}, x3 = { class: "smake:relative smake:flex smake:min-w-79 smake:shrink-0 smake:flex-col smake:gap-4 smake:overflow-hidden smake:rounded-2xl smake:border smake:border-secondary-2 smake:p-4" };
function $3(t, e) {
  return $(), I("div", x3, [
    St(t.$slots, "default")
  ]);
}
const Nl = /* @__PURE__ */ bs(w3, [["render", $3]]);
function ai(t, e, n) {
  const s = _t(n == null ? void 0 : n.min), o = _t(n == null ? void 0 : n.max), a = _t(n == null ? void 0 : n.step), i = N(
    typeof t.value == "number" ? ra(t.value, a.value) : ""
  );
  it(t, (c) => {
    var d;
    const u = (d = e.value) == null ? void 0 : d.getRootNode();
    !(u instanceof Document || u instanceof ShadowRoot) || u.activeElement === e.value || (i.value = typeof c == "number" ? ra(c, a.value) : "");
  }), it(i, (c) => {
    t.value = typeof c == "number" ? ra(c, a.value, s.value, o.value) : n != null && n.optional ? void 0 : 0;
  });
  function r() {
    i.value = typeof t.value == "number" ? ra(t.value, a.value) : "";
  }
  return { inputValue: i, onBlur: r };
}
function ra(t, e, n, s) {
  return e !== void 0 && (t = Number(
    (Math.round(t / e) * e).toFixed(
      Math.ceil(-Math.log10(e))
    )
  )), n !== void 0 && (t = Math.max(t, n)), s !== void 0 && (t = Math.min(t, s)), t;
}
const z3 = ["disabled"], S3 = ["min", "max", "step", "disabled"], A3 = ["disabled"], fo = /* @__PURE__ */ J({
  __name: "NumberInput",
  props: /* @__PURE__ */ Ae({
    disabled: { type: Boolean },
    invalid: { type: Boolean },
    max: {},
    min: {},
    step: {}
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = t, { max: n, min: s, step: o } = we(e), a = Ne(t, "modelValue"), i = N(), { inputValue: r, onBlur: c } = ai(a, i, { max: n, min: s, step: o });
    return (u, d) => {
      const m = xe("FontAwesomeIcon");
      return $(), I("div", {
        class: ke(["smake:flex smake:divide-x smake:divide-secondary-2 smake:overflow-hidden smake:rounded-full smake:border smake:duration-150 smake:focus-within:border-black", {
          "smake:border-secondary-2": !u.invalid,
          "smake:border-danger": u.invalid
        }])
      }, [
        x("button", {
          class: "smake:p-3.5 smake:duration-150 smake:enabled:hover:opacity-60 smake:disabled:opacity-50",
          type: "button",
          disabled: l(s) !== void 0 && (l(o) !== void 0 ? a.value - l(s) < l(o) : a.value <= l(s)) || u.disabled,
          onClick: d[0] || (d[0] = (_) => a.value -= l(s) !== void 0 ? Math.min(1, a.value - l(s)) : 1)
        }, [
          b(m, {
            class: "smake:size-4",
            icon: ["fal", "minus"]
          })
        ], 8, z3),
        mt(x("input", {
          ref_key: "input",
          ref: i,
          "onUpdate:modelValue": d[1] || (d[1] = (_) => Lt(r) ? r.value = _ : null),
          class: "smake:appearance-textfield smake:w-full smake:min-w-8 smake:text-center smake:text-sm smake:font-semibold smake:outline-hidden smake:disabled:opacity-50",
          type: "number",
          min: l(s),
          max: l(n),
          step: l(o),
          disabled: u.disabled,
          onBlur: d[2] || (d[2] = //@ts-ignore
          (..._) => l(c) && l(c)(..._))
        }, null, 40, S3), [
          [vn, l(r)]
        ]),
        x("button", {
          class: "smake:p-3.5 smake:duration-150 smake:enabled:hover:opacity-60 smake:disabled:opacity-50",
          type: "button",
          disabled: l(n) !== void 0 && (l(o) !== void 0 ? l(n) - a.value < l(o) : a.value >= l(n)) || u.disabled,
          onClick: d[3] || (d[3] = (_) => a.value += l(n) !== void 0 ? Math.min(1, l(n) - a.value) : 1)
        }, [
          b(m, {
            class: "smake:size-4",
            icon: ["fal", "plus"]
          })
        ], 8, A3)
      ], 2);
    };
  }
});
function C3(t) {
  const e = _t(t), { appConfiguration: n } = D(tt());
  return A(() => {
    if (!n.value || !e.value) return;
    const s = n.value.fonts.find(
      ({ id: o }) => {
        var a;
        return o === ((a = e.value) == null ? void 0 : a.fontId);
      }
    );
    if (s)
      return { max: s.max, min: s.min };
  });
}
const La = {
  anchor: { offset: { max: 50, min: -50 } },
  text: {
    offsetLeft: { max: 100, min: 0 },
    paddingBottom: { max: 100, min: 2 }
  }
}, el = st("favoriteColors", () => {
  const { userExternalIdentifier: t } = D(To()), e = rf(
    `smake-designer-favorite-colors-hex-${t.value ?? ""}`,
    []
  ), n = A(
    () => e.value.map((o) => Za(o)).filter((o) => o !== void 0)
  );
  function s(o) {
    const a = Lp(o);
    e.value.includes(a) && (e.value = e.value.filter(
      (i) => i !== a
    )), e.value.unshift(a), !(e.value.length <= 20) && e.value.pop();
  }
  return {
    add: s,
    colors: Tn(n)
  };
}), P3 = /* @__PURE__ */ J({
  __name: "ColorAreaHue",
  props: {
    modelValue: { required: !0 },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(t) {
    const e = Ne(t, "modelValue"), n = Ds("hueArea"), { pressed: s } = ud({ target: n }), { elementX: o, elementY: a } = dd(n);
    it(
      [a, o, s],
      () => {
        s.value && r(a.value);
      },
      { immediate: !0 }
    );
    const i = A(() => n.value ? {
      top: `${((1 - e.value.hue / 360) * n.value.clientHeight).toString()}px`
    } : void 0);
    function r(c) {
      if (!n.value) return;
      const d = (1 - Or(c / n.value.clientHeight, 0, 1)) * 360;
      e.value = { ...e.value, hue: d };
    }
    return (c, u) => ($(), I("div", {
      ref_key: "hueArea",
      ref: n,
      class: ke(["smake:relative smake:h-full smake:w-5.5 smake:touch-none smake:rounded-full smake:bg-[linear-gradient(0deg,red,yellow,lime,aqua,blue,magenta,red)]", {
        "smake:cursor-grabbing": l(s),
        "smake:cursor-pointer": !l(s)
      }])
    }, [
      x("div", {
        class: "smake:pointer-events-none smake:absolute smake:h-5 smake:w-5 smake:-translate-y-1/2 smake:rounded-full smake:border-2 smake:border-white",
        style: Kt(i.value)
      }, null, 4)
    ], 2));
  }
}), M3 = /* @__PURE__ */ J({
  __name: "ColorAreaSaturartionValue",
  props: {
    modelValue: { required: !0 },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(t) {
    const e = Ne(t, "modelValue"), n = Ds("colorArea");
    function s(c, u) {
      if (!n.value) return;
      const d = Or(c / n.value.clientWidth, 0, 1), m = Or(u / n.value.clientHeight, 0, 1);
      e.value = {
        ...e.value,
        saturation: d * 100,
        value: (1 - m) * 100
      };
    }
    const { pressed: o } = ud({ target: n }), { elementX: a, elementY: i } = dd(n);
    it(
      [i, a, o],
      () => {
        o.value && s(a.value, i.value);
      },
      { immediate: !0 }
    );
    const r = A(() => {
      if (!n.value) return;
      const c = e.value.saturation / 100 * n.value.clientWidth, u = (1 - e.value.value / 100) * n.value.clientHeight;
      return {
        left: `${c.toString()}px`,
        top: `${u.toString()}px`
      };
    });
    return (c, u) => ($(), I("div", {
      ref_key: "colorArea",
      ref: n,
      class: ke(["smake:relative smake:h-full smake:w-full smake:touch-none smake:rounded-md smake:bg-[linear-gradient(0deg,#000,transparent),linear-gradient(90deg,#fff,hsla(0,0%,100%,0))]", {
        "smake:cursor-grabbing": l(o),
        "smake:cursor-pointer": !l(o)
      }]),
      style: Kt({
        backgroundColor: `hsl(${e.value.hue}deg,100%, 50%)`
      })
    }, [
      x("div", {
        class: "smake:pointer-events-none smake:absolute smake:h-5 smake:w-5 smake:-translate-x-1/2 smake:-translate-y-1/2 smake:rounded-full smake:border-2 smake:border-white",
        style: Kt(r.value),
        colorSelectorStyle: ""
      }, null, 4)
    ], 6));
  }
}), T3 = /* @__PURE__ */ J({
  __name: "ColorButton",
  props: {
    color: {}
  },
  setup(t) {
    const e = t, { color: n } = we(e), { colorRGB: s } = Ka(n), o = A(
      () => Ll([
        s.value.red,
        s.value.green,
        s.value.blue
      ])
    );
    return (a, i) => ($(), I("button", {
      class: ke(["smake:flex smake:aspect-square smake:w-10 smake:items-center smake:justify-center smake:rounded-full smake:border", {
        "smake:border-secondary-2": o.value,
        "smake:border-transparent": !o.value
      }]),
      style: Kt({
        backgroundColor: `rgb(${l(s).red}, ${l(s).green}, ${l(s).blue}) !important`
      })
    }, null, 6));
  }
}), I3 = { class: "smake:flex smake:flex-col smake:gap-2" }, E3 = { class: "smake:text-sm smake:font-semibold" }, O3 = { class: "smake:grid smake:grid-cols-6 smake:gap-2" }, R3 = /* @__PURE__ */ J({
  __name: "ColorFavorites",
  props: {
    modelValue: { required: !0 },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(t) {
    const { add: e } = el(), { colors: n } = D(el()), s = Ne(t, "modelValue");
    function o() {
      e({ ...s.value });
    }
    return (a, i) => {
      const r = xe("FontAwesomeIcon");
      return $(), I("div", I3, [
        x("div", E3, L(a.$t("recently_used")), 1),
        x("div", O3, [
          b(Re, {
            type: "secondary",
            class: "smake:flex smake:aspect-square smake:w-10 smake:items-center smake:justify-center smake:p-1",
            onClick: o
          }, {
            default: C(() => [
              b(r, {
                icon: ["fal", "plus"],
                class: "smake:h-3"
              })
            ]),
            _: 1
          }),
          ($(!0), I(me, null, Se(l(n), (c) => ($(), q(T3, {
            key: l(ft)(c),
            class: "smake:flex smake:aspect-square smake:w-8 smake:items-center smake:justify-center smake:rounded-full",
            color: c,
            onClick: (u) => s.value = { ...c }
          }, null, 8, ["color", "onClick"]))), 128))
        ])
      ]);
    };
  }
}), L3 = ["min", "max", "step"], as = /* @__PURE__ */ J({
  __name: "NumberInput",
  props: /* @__PURE__ */ Ae({
    max: {},
    min: {},
    step: {}
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t, { expose: e }) {
    const n = t, { max: s, min: o, step: a } = lf(n), i = Ne(t, "modelValue"), r = N(), { focused: c } = pd(r), { inputValue: u, onBlur: d } = ai(i, r, { max: s, min: o, step: a });
    return e({
      focused: c
    }), (m, _) => mt(($(), I("input", {
      ref_key: "input",
      ref: r,
      "onUpdate:modelValue": _[0] || (_[0] = (g) => Lt(u) ? u.value = g : null),
      class: "smake:appearance-textfield smake:h-full smake:w-12 smake:rounded smake:border smake:border-secondary-2 smake:px-2 smake:focus:border-secondary-1",
      min: l(o),
      max: l(s),
      step: l(a),
      type: "number",
      onBlur: _[1] || (_[1] = //@ts-ignore
      (...g) => l(d) && l(d)(...g))
    }, null, 40, L3)), [
      [vn, l(u)]
    ]);
  }
}), D3 = { class: "smake:flex smake:w-full smake:gap-2" }, j3 = /* @__PURE__ */ J({
  __name: "ColorInputCmyk",
  props: {
    modelValue: { required: !0 },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(t) {
    const e = Ne(t, "modelValue"), { colorCMYK: n } = Ka(e);
    return (s, o) => ($(), I("div", D3, [
      b(as, {
        "model-value": l(n).cyan,
        min: 0,
        max: 100,
        step: 1,
        "onUpdate:modelValue": o[0] || (o[0] = (a) => n.value = { ...l(n), cyan: a })
      }, null, 8, ["model-value"]),
      b(as, {
        "model-value": l(n).magenta,
        min: 0,
        max: 100,
        step: 1,
        "onUpdate:modelValue": o[1] || (o[1] = (a) => n.value = { ...l(n), magenta: a })
      }, null, 8, ["model-value"]),
      b(as, {
        "model-value": l(n).yellow,
        min: 0,
        max: 100,
        step: 1,
        "onUpdate:modelValue": o[2] || (o[2] = (a) => n.value = { ...l(n), yellow: a })
      }, null, 8, ["model-value"]),
      b(as, {
        "model-value": l(n).key,
        min: 0,
        max: 100,
        step: 1,
        "onUpdate:modelValue": o[3] || (o[3] = (a) => n.value = { ...l(n), key: a })
      }, null, 8, ["model-value"])
    ]));
  }
}), N3 = /* @__PURE__ */ J({
  __name: "ColorInputHex",
  props: {
    modelValue: { required: !0 },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(t) {
    const e = Ne(t, "modelValue"), { colorHex: n } = Ka(e), s = N(n.value), o = A({
      get() {
        return i.value ? s.value : n.value.replace("#", "");
      },
      set(u) {
        n.value = "#" + u, s.value = u;
      }
    }), a = Ds("input"), { focused: i } = pd(a), r = A(() => Za("#" + s.value) !== void 0);
    function c(u) {
      var m;
      u.preventDefault();
      const d = (m = u.clipboardData) == null ? void 0 : m.getData("text").replace("#", "");
      d && (o.value = d);
    }
    return re(() => {
      i.value || (s.value = n.value.replace("#", ""));
    }), (u, d) => ($(), I("div", {
      class: ke(["smake:flex smake:items-center smake:gap-2 smake:overflow-clip smake:rounded smake:border smake:px-2", {
        "smake:border-danger": !r.value,
        "smake:border-secondary-2": r.value
      }])
    }, [
      d[1] || (d[1] = x("div", { class: "smake:-ml-2 smake:flex smake:h-full smake:items-center smake:bg-secondary-3 smake:px-2" }, " # ", -1)),
      mt(x("input", {
        ref_key: "input",
        ref: a,
        "onUpdate:modelValue": d[0] || (d[0] = (m) => o.value = m),
        class: "smake:w-full smake:focus:outline-hidden",
        maxlength: "6",
        onPaste: c
      }, null, 544), [
        [vn, o.value]
      ])
    ], 2));
  }
}), V3 = { class: "smake:flex smake:w-full smake:gap-2" }, U3 = /* @__PURE__ */ J({
  __name: "ColorInputRgb",
  props: {
    modelValue: { required: !0 },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(t) {
    const e = Ne(t, "modelValue"), { colorRGB: n } = Ka(e);
    return (s, o) => ($(), I("div", V3, [
      b(as, {
        "model-value": l(n).red,
        min: 0,
        max: 255,
        step: 1,
        "onUpdate:modelValue": o[0] || (o[0] = (a) => n.value = { ...l(n), red: a })
      }, null, 8, ["model-value"]),
      b(as, {
        "model-value": l(n).green,
        min: 0,
        max: 255,
        step: 1,
        "onUpdate:modelValue": o[1] || (o[1] = (a) => n.value = { ...l(n), green: a })
      }, null, 8, ["model-value"]),
      b(as, {
        "model-value": l(n).blue,
        min: 0,
        max: 255,
        step: 1,
        "onUpdate:modelValue": o[2] || (o[2] = (a) => n.value = { ...l(n), blue: a })
      }, null, 8, ["model-value"])
    ]));
  }
}), F3 = { class: "smake:flex smake:gap-2" }, B3 = /* @__PURE__ */ J({
  __name: "ColorInput",
  props: {
    modelValue: { required: !0 },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(t) {
    const e = Ne(t, "modelValue"), n = {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      cmyk: j3,
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      hex: N3,
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      rgb: U3
    }, s = Object.keys(
      n
    ), o = N(s[2]), { rootElement: a } = D(jt());
    return (i, r) => {
      const c = xe("Icon");
      return $(), I("div", F3, [
        b(l(xd), {
          modelValue: o.value,
          "onUpdate:modelValue": r[0] || (r[0] = (u) => o.value = u)
        }, {
          default: C(() => [
            b(l($d), {
              class: "smake:inline-flex smake:h-8.75 smake:w-25 smake:items-center smake:justify-between smake:gap-1.25 smake:rounded smake:border smake:border-secondary-2 smake:px-1.25 smake:outline-hidden",
              "aria-label": "Customise options"
            }, {
              default: C(() => [
                b(l(zd), { placeholder: "Select a mode" })
              ]),
              _: 1
            }),
            b(l(Sd), { to: l(a) }, {
              default: C(() => [
                b(l(Ad), { class: "smake:data-[side=top]:animate-slideDownAndFade smake:data-[side=right]:animate-slideLeftAndFade smake:data-[side=bottom]:animate-slideUpAndFade smake:data-[side=left]:animate-slideRightAndFade smake:z-100 smake:rounded smake:border smake:border-secondary-2 smake:bg-white smake:will-change-[opacity,transform]" }, {
                  default: C(() => [
                    b(l(Cd), null, {
                      default: C(() => [
                        ($(!0), I(me, null, Se(l(s), (u, d) => ($(), q(l(bd), {
                          key: d,
                          class: "smake:relative smake:flex smake:h-6.25 smake:items-center smake:rounded-[3px] smake:px-4 smake:py-4 smake:select-none smake:data-highlighted:bg-secondary-3 smake:data-highlighted:outline-hidden",
                          value: u
                        }, {
                          default: C(() => [
                            b(l(wd), null, {
                              default: C(() => [
                                he(L(u.toUpperCase()), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["value"]))), 128))
                      ]),
                      _: 1
                    }),
                    b(l(s_), { class: "smake:flex smake:h-6.25 smake:cursor-default smake:items-center smake:justify-center smake:bg-white" }, {
                      default: C(() => [
                        b(c, { icon: "radix-icons:chevron-down" })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        o.value ? ($(), q(il(n[o.value]), {
          key: 0,
          modelValue: e.value,
          "onUpdate:modelValue": r[1] || (r[1] = (u) => e.value = u),
          class: "smake:w-full"
        }, null, 8, ["modelValue"])) : Q("", !0)
      ]);
    };
  }
}), q3 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAADm5AAA5uQH05n92AAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAs1JREFUaIHd2r9rFEEUwPHvJNHmKg1qECxEELvkjIlCRKz8I4Q0iiCmiNgqFqKFjWBxiRiToKSMPyCFAa20FFJpo6ZQIiLGhOBFVGKexe7Gvbv9dbtvb+d88Jq7m7n3uXmzO7mcERFsDGPMAWAEOAXsBzaBReApUBGRpZoBImJVAga4CvwGJCR/AKM144ouvA7RCdyPANTnLesgLuJBEwgvz1oDSbES/qwCPV1pNqJmGGM6gWlgOOUUJeCCcT+RQkIB4cVCbhBjzG7gPDAAbAAvgAkRqbrPayEA1vLq+SFgmcZ+XgQOkX5jh++THBDHge8Rb/oFeKKIEOCNamsZY3qA10C32qTJ4naH8oQjtB6xAYxpQ44pz5ckborIW23IH+X54mIW51yGNuSl8nxR8RA4LSKbgO4RBdgBLKF7RQrKWWBbzXvncPntJfgekhsiL0iHu+wtQ6hDcP4oGm81QhVSJEIN4rbTZE6IuTiECiQBYhU4A3xLCfkEHMwVkhAx4L72cAbMO6CUC6QZhG9MFsyoOiQNwjd2OCXkkSrERdyLQRwJGZvlZjmnBsmI6MuAEOCKCqRgxFdgV2ZIzojHRF8AqsCJ2BoVECsZENPu/GWc+0X988tJELGQViB8r98JXAbmgWfANWBP4taPQBhgLKadBkPG9rp9HTZ2yo/QyP8CEQhpR0QDJCOiryhEDUQBEbWxc0XUQ+5EFLIC9NuK2IIAl9oZ4dbCXmA9op3CTrHWIDzIjRQrUbYJ4UEWAgr5GbES1iE8yFpAMZWUiMkiECJCF7Cdxlitf8AYUwae45yJgmIKOCfed7EFxHsaP9kPQLdvJfqJPmoXthL+1poIKe4jcB2o4OwZaxEe5CjOD1bCCo1KKxAi/26IM+2M8ENKwKsmEHdtQmxBfJiZmDZbBy4WXXRQNvx72hgziPNd7UlgH/DLvbLNA+Mi8hkL4y9wbQOjiqne7QAAAABJRU5ErkJggg==", H3 = /* @__PURE__ */ J({
  __name: "EyeDropper",
  emits: ["selected"],
  setup(t, { emit: e }) {
    const { isSupported: n, open: s, sRGBHex: o } = cf(), a = e;
    return re(() => {
      o.value.length !== 0 && a("selected", o.value);
    }), (i, r) => l(n) ? ($(), q(Re, {
      key: 0,
      type: "secondary",
      class: "smake:aspect-square smake:h-8 smake:cursor-pointer smake:rounded-full smake:bg-secondary-3 smake:p-1",
      onClick: l(s)
    }, {
      default: C(() => [...r[0] || (r[0] = [
        x("img", {
          src: q3,
          class: "smake:aspect-square smake:w-4",
          alt: ""
        }, null, -1)
      ])]),
      _: 1
    }, 8, ["onClick"])) : Q("", !0);
  }
}), W3 = { class: "smake:flex smake:w-79.5 smake:flex-col smake:justify-center smake:gap-4 smake:@sm:w-87.5" }, G3 = { class: "smake:flex smake:h-64 smake:gap-4 smake:px-2" }, Z3 = { class: "smake:flex smake:items-center smake:gap-3" }, K3 = /* @__PURE__ */ J({
  __name: "ColorPicker",
  props: {
    modelValue: { required: !0 },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(t) {
    const e = Ne(t, "modelValue"), { colorHSV: n } = J1(e);
    function s(o) {
      const a = Za(o);
      a && (n.value = a);
    }
    return (o, a) => ($(), I("div", W3, [
      x("div", G3, [
        b(P3, {
          modelValue: l(n),
          "onUpdate:modelValue": a[0] || (a[0] = (i) => Lt(n) ? n.value = i : null)
        }, null, 8, ["modelValue"]),
        b(M3, {
          modelValue: l(n),
          "onUpdate:modelValue": a[1] || (a[1] = (i) => Lt(n) ? n.value = i : null)
        }, null, 8, ["modelValue"])
      ]),
      x("div", Z3, [
        b(H3, { onSelected: s }),
        b(B3, {
          modelValue: l(n),
          "onUpdate:modelValue": a[2] || (a[2] = (i) => Lt(n) ? n.value = i : null)
        }, null, 8, ["modelValue"])
      ]),
      b(R3, {
        modelValue: l(n),
        "onUpdate:modelValue": a[3] || (a[3] = (i) => Lt(n) ? n.value = i : null)
      }, null, 8, ["modelValue"])
    ]));
  }
}), X3 = { class: "smake:flex smake:grow smake:flex-col smake:gap-2.5 smake:bg-white" }, Q3 = { class: "smake:flex smake:grow smake:justify-between smake:gap-6" }, J3 = { class: "smake:flex smake:items-center smake:gap-2" }, Y3 = /* @__PURE__ */ J({
  __name: "ColorPickerButton",
  props: {
    modelValue: { required: !0 },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(t) {
    const e = Ne(t, "modelValue"), { rootElement: n } = D(jt()), { appConfiguration: s } = D(tt()), { add: o } = el(), a = N({ blue: 0, green: 0, red: 255 });
    re(() => {
      var c;
      if ("id" in e.value) {
        const u = (c = s.value) == null ? void 0 : c.colors.find(
          ({ id: d }) => "id" in e.value && e.value.id === d
        );
        if (!u) return;
        a.value = {
          blue: u.blue,
          green: u.green,
          red: u.red
        };
      } else
        a.value = { ...e.value };
    });
    const i = N(!1);
    function r() {
      o(Po(a.value)), i.value = !1, e.value = a.value;
    }
    return (c, u) => {
      const d = xe("FontAwesomeIcon");
      return $(), q(l(Md), {
        open: i.value,
        "onUpdate:open": u[2] || (u[2] = (m) => i.value = m)
      }, {
        default: C(() => [
          b(l(Td), { class: "smake:flex smake:flex-col smake:items-center smake:gap-2 smake:text-xs" }, {
            default: C(() => [
              x("div", {
                class: ke([
                  "smake:rounded-full smake:border smake:p-1",
                  "id" in e.value ? "smake:border-transparent" : "smake:border-black"
                ])
              }, [...u[3] || (u[3] = [
                x("div", { class: "smake:relative smake:size-12 smake:rounded-full smake:bg-[conic-gradient(red,yellow,lime,aqua,blue,magenta,red)]" }, [
                  x("div", { class: "smake:absolute smake:inset-1/2 smake:size-6 smake:-translate-1/2 smake:rounded-full smake:bg-white" })
                ], -1)
              ])], 2),
              he(" " + L(c.$t("custom")), 1)
            ]),
            _: 1
          }),
          b(l(Id), { to: l(n) }, {
            default: C(() => [
              b(l(Ed), {
                class: "smake:z-50 smake:rounded-2xl smake:border smake:border-secondary-1 smake:bg-white smake:p-5",
                side: "bottom",
                align: "start",
                onInteractOutside: u[1] || (u[1] = (m) => m.preventDefault())
              }, {
                default: C(() => [
                  x("div", X3, [
                    x("div", Q3, [
                      x("div", {
                        class: "smake:aspect-square smake:h-10 smake:rounded-full smake:border smake:border-secondary-2",
                        style: Kt({
                          backgroundColor: `rgb(${a.value.red},${a.value.green},${a.value.blue})`
                        })
                      }, null, 4),
                      x("div", J3, [
                        u[4] || (u[4] = x("div", { class: "grow" }, null, -1)),
                        b(Re, {
                          class: "smake:flex smake:items-center smake:gap-2 smake:text-xs",
                          type: "primary",
                          onClick: r
                        }, {
                          default: C(() => [
                            he(L(c.$t("select_color")) + " ", 1),
                            b(d, {
                              class: "smake:h-3",
                              icon: ["fal", "check"]
                            })
                          ]),
                          _: 1
                        }),
                        b(l(Od), { "as-child": "" }, {
                          default: C(() => [
                            b(Re, {
                              type: "secondary",
                              class: "smake:flex smake:aspect-square smake:items-center smake:justify-center smake:p-3"
                            }, {
                              default: C(() => [
                                b(d, {
                                  class: "smake:h-3",
                                  icon: ["fak", "icon-x"],
                                  "fixed-width": ""
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    b(K3, {
                      modelValue: a.value,
                      "onUpdate:modelValue": u[0] || (u[0] = (m) => a.value = m)
                    }, null, 8, ["modelValue"]),
                    b(l(o_), {
                      class: "smake:size-5 smake:-translate-y-2.5 smake:rotate-45 smake:border-r smake:border-b smake:border-secondary-1 smake:bg-white",
                      as: "div"
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _: 1
      }, 8, ["open"]);
    };
  }
}), e6 = { class: "smake:absolute smake:inset-0 smake:z-10 smake:flex smake:flex-col smake:gap-4 smake:overflow-y-auto smake:bg-white smake:p-4" }, t6 = { class: "smake:grid smake:grid-cols-auto-fill-15.5 smake:gap-4" }, n6 = ["onClick"], s6 = {
  key: 1,
  class: "smake:border-secondary-2"
}, o6 = { class: "smake:grid smake:grid-cols-auto-fill-15.5 smake:gap-4" }, a6 = ["onClick"], i6 = /* @__PURE__ */ J({
  __name: "ColorSelection",
  props: /* @__PURE__ */ Ae({
    productionMethodId: {}
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = t, { productionMethodId: n } = we(e), s = Ne(t, "modelValue"), { appConfiguration: o } = D(tt()), a = A(
      () => {
        var u, d;
        return (d = (u = o.value) == null ? void 0 : u.productionMethods.find(
          ({ id: m }) => m === n.value
        )) == null ? void 0 : d.is_using_color_picker;
      }
    ), i = A(
      () => {
        var u;
        return ((u = o.value) == null ? void 0 : u.colors.filter(
          (d) => d.production_methods.some(
            ({ id: m }) => m === n.value
          )
        )) ?? [];
      }
    ), r = A(
      () => i.value.filter((u) => u.is_customer_logo_color)
    ), c = A(
      () => i.value.filter((u) => u.is_standard)
    );
    return (u, d) => ($(), I("div", e6, [
      r.value.length > 0 ? ($(), I(me, { key: 0 }, [
        he(L(u.$t("colors")) + ": ", 1),
        x("div", t6, [
          ($(!0), I(me, null, Se(r.value, (m) => ($(), I("button", {
            key: m.id,
            type: "button",
            class: "smake:flex smake:flex-col smake:items-center smake:gap-2 smake:text-xs",
            onClick: (_) => s.value = { id: m.id }
          }, [
            x("div", {
              class: ke([
                "smake:rounded-full smake:border smake:p-1",
                "id" in s.value && s.value.id === m.id ? "smake:border-black" : "smake:border-transparent"
              ])
            }, [
              x("div", {
                class: "smake:size-12 smake:rounded-full smake:border smake:border-secondary-2",
                style: Kt({
                  backgroundColor: `rgb(${m.red}, ${m.green}, ${m.blue})`
                })
              }, null, 4)
            ], 2),
            he(" " + L(m.display_name), 1)
          ], 8, n6))), 128))
        ])
      ], 64)) : Q("", !0),
      r.value.length > 0 && c.value.length > 0 ? ($(), I("hr", s6)) : Q("", !0),
      c.value.length > 0 ? ($(), I(me, { key: 2 }, [
        he(L(u.$t("standard_colors")) + ": ", 1),
        x("div", o6, [
          a.value ? ($(), q(Y3, {
            key: 0,
            modelValue: s.value,
            "onUpdate:modelValue": d[0] || (d[0] = (m) => s.value = m)
          }, null, 8, ["modelValue"])) : Q("", !0),
          ($(!0), I(me, null, Se(c.value, (m) => ($(), I("button", {
            key: m.id,
            type: "button",
            class: "smake:flex smake:flex-col smake:items-center smake:gap-2 smake:text-xs",
            onClick: (_) => s.value = { id: m.id }
          }, [
            x("div", {
              class: ke([
                "smake:rounded-full smake:border smake:p-1",
                "id" in s.value && s.value.id === m.id ? "smake:border-black" : "smake:border-transparent"
              ])
            }, [
              x("div", {
                class: "smake:size-12 smake:rounded-full smake:border smake:border-secondary-2",
                style: Kt({
                  backgroundColor: `rgb(${m.red}, ${m.green}, ${m.blue})`
                })
              }, null, 4)
            ], 2),
            he(" " + L(m.display_name), 1)
          ], 8, a6))), 128))
        ])
      ], 64)) : Q("", !0)
    ]));
  }
}), r6 = ["title"], tl = /* @__PURE__ */ J({
  __name: "ColorInput",
  props: /* @__PURE__ */ Ae({
    disabled: { type: Boolean },
    issue: {},
    productionMethodId: {},
    showName: { type: Boolean }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = Ne(t, "modelValue"), { appConfiguration: n } = D(tt()), { t: s } = ct(), o = N(!1), a = A(() => {
      var u;
      if (!("id" in e.value)) return;
      const { id: c } = e.value;
      return (u = n.value) == null ? void 0 : u.colors.find(({ id: d }) => d === c);
    }), i = A(() => {
      var c;
      return ((c = a.value) == null ? void 0 : c.display_name) ?? s("custom");
    }), r = A(() => "id" in e.value ? a.value : e.value);
    return (c, u) => {
      const d = xe("FontAwesomeIcon");
      return $(), I(me, null, [
        b(Re, {
          type: "outline",
          disabled: c.disabled,
          class: ke(["smake:disabled:opacity-100", { "smake:border-danger": c.issue }]),
          onClick: u[0] || (u[0] = (m) => o.value = !0)
        }, {
          default: C(() => [
            x("div", {
              class: "smake:size-7 smake:shrink-0 smake:rounded-full smake:border smake:border-secondary-2 smake:duration-150",
              style: Kt({
                backgroundColor: r.value ? `rgb(${r.value.red}, ${r.value.green}, ${r.value.blue})` : void 0
              })
            }, null, 4),
            c.showName ? ($(), I("div", {
              key: 0,
              class: "smake:grow smake:overflow-hidden smake:text-start smake:text-ellipsis smake:whitespace-nowrap",
              title: i.value
            }, L(i.value), 9, r6)) : Q("", !0),
            c.disabled ? Q("", !0) : ($(), q(d, {
              key: 1,
              class: "smake:mx-1 smake:size-5 smake:shrink-0",
              icon: ["fal", "chevron-right"]
            }))
          ]),
          _: 1
        }, 8, ["disabled", "class"]),
        b(De, {
          appear: "",
          "enter-active-class": "smake:duration-300 smake:ease-out",
          "enter-from-class": "smake:opacity-0",
          "leave-active-class": "smake:duration-200 smake:ease-in",
          "leave-to-class": "smake:opacity-0"
        }, {
          default: C(() => [
            o.value ? ($(), q(i6, {
              key: 0,
              modelValue: e.value,
              "onUpdate:modelValue": [
                u[1] || (u[1] = (m) => e.value = m),
                u[2] || (u[2] = (m) => o.value = !1)
              ],
              "production-method-id": c.productionMethodId
            }, null, 8, ["modelValue", "production-method-id"])) : Q("", !0)
          ]),
          _: 1
        })
      ], 64);
    };
  }
}), l6 = { class: "smake:flex smake:flex-1 smake:flex-col smake:items-start smake:gap-1" }, c6 = { class: "smake:flex smake:w-full smake:justify-between" }, u6 = { class: "smake:text-xs smake:font-semibold smake:uppercase" }, d6 = { class: "smak:items-center smake:flex smake:gap-1 smake:overflow-hidden smake:rounded-full smake:border smake:border-secondary-2 smake:px-2 smake:text-xs smake:font-bold smake:duration-150 smake:focus-within:border-black" }, p6 = /* @__PURE__ */ J({
  __name: "BendingRadiusInput",
  props: {
    modelValue: { required: !0 },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(t) {
    const e = Ne(t, "modelValue"), n = N(), { inputValue: s, onBlur: o } = ai(e, n, {
      max: 100,
      min: -100,
      step: 5
    });
    return (a, i) => ($(), I("div", l6, [
      x("div", c6, [
        x("span", u6, L(a.$t("bend_text_line")), 1),
        x("div", d6, [
          mt(x("input", {
            ref_key: "numberInput",
            ref: n,
            "onUpdate:modelValue": i[0] || (i[0] = (r) => Lt(s) ? s.value = r : null),
            class: "smake:appearance-textfield smake:w-7 smake:text-right smake:outline-hidden",
            type: "number",
            max: "100",
            min: "-100",
            step: "5",
            onBlur: i[1] || (i[1] = //@ts-ignore
            (...r) => l(o) && l(o)(...r))
          }, null, 544), [
            [vn, l(s)]
          ]),
          i[3] || (i[3] = x("div", null, "%", -1))
        ])
      ]),
      mt(x("input", {
        "onUpdate:modelValue": i[2] || (i[2] = (r) => e.value = r),
        class: "smake:my-1.5 smake:h-1 smake:w-full smake:appearance-none smake:rounded-full smake:bg-secondary-3 smake:[&::-webkit-slider-thumb]:h-4 smake:[&::-webkit-slider-thumb]:w-4 smake:[&::-webkit-slider-thumb]:cursor-ew-resize smake:[&::-webkit-slider-thumb]:appearance-none smake:[&::-webkit-slider-thumb]:rounded-full smake:[&::-webkit-slider-thumb]:border-2 smake:[&::-webkit-slider-thumb]:border-solid smake:[&::-webkit-slider-thumb]:border-black smake:[&::-webkit-slider-thumb]:bg-white smake:[&::-webkit-slider-thumb]:duration-150 smake:hover:[&::-webkit-slider-thumb]:bg-secondary-3",
        type: "range",
        max: "100",
        min: "-100",
        step: "5"
      }, null, 512), [
        [
          vn,
          e.value,
          void 0,
          { number: !0 }
        ]
      ])
    ]));
  }
}), m6 = { class: "smake:absolute smake:inset-0 smake:z-10 smake:flex smake:flex-col smake:gap-4 smake:overflow-y-auto smake:bg-white smake:p-4" }, h6 = ["value"], f6 = ["onClick"], _6 = {
  key: 1,
  class: "smake:text-xl smake:font-semibold"
}, v6 = {
  key: 2,
  class: "smake:mb-1 smake:text-sm smake:font-semibold"
}, g6 = {
  key: 0,
  class: "smake:text-xs smake:text-secondary-1"
}, k6 = /* @__PURE__ */ J({
  __name: "FontSelection",
  props: /* @__PURE__ */ Ae({
    productionMethodId: {}
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Ae(["close"], ["update:modelValue"]),
  setup(t, { emit: e }) {
    const n = t, { productionMethodId: s } = we(n), o = e, a = Ne(t, "modelValue"), { appConfiguration: i } = D(tt()), r = A(() => {
      var d;
      return (d = i.value) == null ? void 0 : d.fonts;
    }), c = A(
      () => {
        var d;
        return Object.values(
          Object.groupBy(
            ((d = r.value) == null ? void 0 : d.filter(
              (m) => m.production_methods.some(
                ({ id: _ }) => _ === s.value
              )
            )) ?? [],
            ({ family_name: m }) => m
          )
        ).map((m) => (m == null ? void 0 : m.find((_) => !gm(_.style))) ?? (m == null ? void 0 : m[0])).filter((m) => m !== void 0).sort((m, _) => m.family_name < _.family_name ? -1 : m.family_name > _.family_name ? 1 : 0);
      }
    ), u = A(() => c.value.some(
      (d) => d.letter_case_set === "only-uppercase"
    ));
    return (d, m) => ($(), I("div", m6, [
      ($(!0), I(me, null, Se(c.value, (_) => ($(), I("label", {
        key: _.id,
        class: "smake:relative"
      }, [
        mt(x("input", {
          "onUpdate:modelValue": m[0] || (m[0] = (g) => a.value = g),
          class: "smake:peer smake:absolute smake:appearance-none",
          type: "radio",
          name: "fontId",
          value: _.id
        }, null, 8, h6), [
          [po, a.value]
        ]),
        x("div", {
          class: "smake:flex smake:items-center smake:justify-center smake:gap-0.5 smake:rounded-full smake:border smake:border-secondary-2 smake:p-2 smake:duration-150 smake:peer-checked:bg-secondary-2 smake:peer-focus-visible:outline-2 smake:peer-focus-visible:outline-blue-700 smake:peer-enabled:cursor-pointer smake:peer-disabled:opacity-50 smake:hover:peer-enabled:border-black",
          onClick: () => {
            _.id === a.value && o("close");
          }
        }, [
          _.preview_url ? ($(), q(on, {
            key: 0,
            src: _.preview_url,
            class: "smake:h-6 smake:data-[state=pending]:w-28 smake:data-[state=pending]:animate-pulse smake:data-[state=pending]:rounded-md smake:data-[state=pending]:bg-secondary-2"
          }, null, 8, ["src"])) : ($(), I("span", _6, L(_.display_name), 1)),
          _.letter_case_set === "only-uppercase" ? ($(), I("span", v6, " * ")) : Q("", !0)
        ], 8, f6)
      ]))), 128)),
      m[1] || (m[1] = x("div", { class: "smake:-mt-4 smake:grow" }, null, -1)),
      u.value ? ($(), I("div", g6, " * " + L(d.$t("only_uppercase")), 1)) : Q("", !0)
    ]));
  }
}), y6 = { class: "smake:flex smake:grow smake:flex-col smake:items-start smake:gap-1" }, b6 = { class: "smake:grow smake:rounded-full smake:bg-secondary-3 smake:p-1 smake:text-xs smake:font-medium" }, w6 = /* @__PURE__ */ J({
  __name: "FontInput",
  props: /* @__PURE__ */ Ae({
    issue: {},
    productionMethodId: {}
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = Ne(t, "modelValue"), { appConfiguration: n } = D(tt()), s = N(!1), o = A(
      () => {
        var a;
        return (a = n.value) == null ? void 0 : a.fonts.find(({ id: i }) => i === e.value);
      }
    );
    return (a, i) => {
      const r = xe("FontAwesomeIcon");
      return $(), I(me, null, [
        x("div", y6, [
          x("span", {
            class: ke(["smake:flex smake:items-center smake:gap-1 smake:text-xs smake:font-bold smake:uppercase", { "smake:text-danger": a.issue }])
          }, [
            a.issue ? ($(), q(r, {
              key: 0,
              icon: ["fak", "icon-ciconfig-alert-warning"],
              "fixed-width": "",
              class: "smake:size-4"
            })) : Q("", !0),
            he(" " + L(a.$t("font")), 1)
          ], 2),
          b(Re, {
            type: "outline",
            class: ke(["smake:w-full", { "smake:border-danger": a.issue }]),
            onClick: i[0] || (i[0] = (c) => s.value = !0)
          }, {
            default: C(() => {
              var c;
              return [
                x("div", b6, L(((c = o.value) == null ? void 0 : c.family_name) ?? a.$t("select_font")), 1),
                b(r, {
                  class: "smake:mx-1 smake:size-5",
                  icon: ["fal", "chevron-right"]
                })
              ];
            }),
            _: 1
          }, 8, ["class"])
        ]),
        b(De, {
          appear: "",
          "enter-active-class": "smake:duration-300 smake:ease-out",
          "enter-from-class": "smake:opacity-0",
          "leave-active-class": "smake:duration-200 smake:ease-in",
          "leave-to-class": "smake:opacity-0"
        }, {
          default: C(() => [
            s.value ? ($(), q(k6, {
              key: 0,
              modelValue: e.value,
              "onUpdate:modelValue": [
                i[1] || (i[1] = (c) => e.value = c),
                i[2] || (i[2] = (c) => s.value = !1)
              ],
              "production-method-id": a.productionMethodId,
              onClose: i[3] || (i[3] = (c) => s.value = !1)
            }, null, 8, ["modelValue", "production-method-id"])) : Q("", !0)
          ]),
          _: 1
        })
      ], 64);
    };
  }
}), x6 = { class: "smake:flex smake:gap-4" }, $6 = { class: "smake:flex smake:flex-col smake:items-start smake:gap-1" }, z6 = { class: "smake:flex smake:gap-4" }, S6 = { class: "smake:flex smake:flex-1 smake:flex-col smake:items-start smake:gap-1" }, A6 = { class: "smake:flex smake:flex-1 smake:flex-col smake:items-start smake:gap-1" }, C6 = { class: "smake:text-xs smake:font-bold smake:uppercase" }, P6 = { class: "smake:flex smake:gap-4" }, M6 = { class: "smake:flex smake:flex-1 smake:flex-col smake:items-start smake:gap-1" }, T6 = { class: "smake:text-xs smake:font-bold smake:uppercase" }, I6 = { class: "smake:flex smake:gap-2" }, E6 = { class: "smake:relative" }, O6 = ["value"], R6 = { class: "smake:group smake:cursor-pointer smake:rounded smake:bg-secondary-3 smake:p-3 smake:duration-150 smake:peer-checked:bg-black smake:peer-focus-visible:outline-2 smake:peer-focus-visible:outline-blue-700 smake:hover:bg-secondary-2 smake:hover:peer-checked:bg-black/80" }, L6 = { class: "smake:relative" }, D6 = ["value"], j6 = { class: "smake:group smake:cursor-pointer smake:rounded smake:bg-secondary-3 smake:p-3 smake:duration-150 smake:peer-checked:bg-black smake:peer-focus-visible:outline-2 smake:peer-focus-visible:outline-blue-700 smake:hover:bg-secondary-2 smake:hover:peer-checked:bg-black/80" }, N6 = { class: "smake:relative" }, V6 = ["value"], U6 = { class: "smake:group smake:cursor-pointer smake:rounded smake:bg-secondary-3 smake:p-3 smake:duration-150 smake:peer-checked:bg-black smake:peer-focus-visible:outline-2 smake:peer-focus-visible:outline-blue-700 smake:hover:bg-secondary-2 smake:hover:peer-checked:bg-black/80" }, F6 = { class: "smake:flex smake:flex-1 smake:flex-col smake:items-start smake:gap-1" }, B6 = { class: "smake:text-xs smake:font-bold smake:uppercase" }, q6 = /* @__PURE__ */ J({
  __name: "TextLine",
  props: {
    data: {},
    issues: {},
    productionMethodId: {}
  },
  setup(t) {
    const e = t, { data: n, productionMethodId: s } = we(e), { offsetLeft: o, paddingBottom: a } = La.text, { appConfiguration: i } = D(tt()), r = A(
      () => {
        var u;
        return (u = i.value) == null ? void 0 : u.fonts.find(({ id: d }) => d === n.value.fontId);
      }
    );
    it(r, (u, d) => {
      !u || d || (n.value.size = wo(n.value.size, u.min, u.max));
    });
    const c = C3(n);
    return (u, d) => {
      var _, g, v, z, h, y, w, P, M;
      const m = xe("FontAwesomeIcon");
      return $(), I(me, null, [
        x("div", x6, [
          b(w6, {
            modelValue: l(n).fontId,
            "onUpdate:modelValue": d[0] || (d[0] = (E) => l(n).fontId = E),
            issue: (_ = u.issues) == null ? void 0 : _.font,
            "production-method-id": l(s)
          }, null, 8, ["modelValue", "issue", "production-method-id"]),
          x("div", $6, [
            x("span", {
              class: ke(["smake:flex smake:items-center smake:gap-1 smake:text-xs smake:font-bold smake:uppercase", { "smake:text-danger": (g = u.issues) == null ? void 0 : g.color }])
            }, [
              (v = u.issues) != null && v.color ? ($(), q(m, {
                key: 0,
                icon: ["fak", "icon-ciconfig-alert-warning"],
                "fixed-width": "",
                class: "smake:size-4"
              })) : Q("", !0),
              he(" " + L(u.$t("color")), 1)
            ], 2),
            b(tl, {
              modelValue: l(n).color,
              "onUpdate:modelValue": d[1] || (d[1] = (E) => l(n).color = E),
              issue: (z = u.issues) == null ? void 0 : z.color,
              "production-method-id": l(s)
            }, null, 8, ["modelValue", "issue", "production-method-id"])
          ])
        ]),
        x("div", z6, [
          x("div", S6, [
            x("span", {
              class: ke(["smake:flex smake:items-center smake:gap-1 smake:text-xs smake:font-semibold smake:uppercase", { "smake:text-danger": l(c) && ((h = u.issues) == null ? void 0 : h.size) }])
            }, [
              l(c) && ((y = u.issues) != null && y.size) ? ($(), q(m, {
                key: 0,
                icon: ["fak", "icon-ciconfig-alert-warning"],
                "fixed-width": "",
                class: "smake:size-4"
              })) : Q("", !0),
              he(" " + L(u.$t("size")), 1)
            ], 2),
            b(fo, {
              modelValue: l(n).size,
              "onUpdate:modelValue": d[2] || (d[2] = (E) => l(n).size = E),
              class: "smake:w-full",
              invalid: l(c) && !!((w = u.issues) != null && w.size),
              disabled: !l(c),
              min: (P = l(c)) == null ? void 0 : P.min,
              max: (M = l(c)) == null ? void 0 : M.max,
              step: 1
            }, null, 8, ["modelValue", "invalid", "disabled", "min", "max"])
          ]),
          x("div", A6, [
            x("span", C6, L(u.$t("line_height")), 1),
            b(fo, {
              modelValue: l(n).paddingBottom,
              "onUpdate:modelValue": d[3] || (d[3] = (E) => l(n).paddingBottom = E),
              class: "smake:w-full",
              min: l(a).min,
              max: l(a).max,
              step: 1
            }, null, 8, ["modelValue", "min", "max"])
          ])
        ]),
        x("div", P6, [
          x("div", M6, [
            x("span", T6, L(u.$t("align")), 1),
            x("div", I6, [
              x("label", E6, [
                mt(x("input", {
                  "onUpdate:modelValue": d[4] || (d[4] = (E) => l(n).horizontalAlignment = E),
                  class: "smake:peer smake:absolute smake:appearance-none",
                  type: "radio",
                  name: "horizontalAlignment",
                  value: l(us).LEFT
                }, null, 8, O6), [
                  [po, l(n).horizontalAlignment]
                ]),
                x("div", R6, [
                  b(m, {
                    class: "smake:h-5.5 smake:duration-150 smake:group-peer-checked:text-white",
                    icon: ["fal", "align-left"]
                  })
                ])
              ]),
              x("label", L6, [
                mt(x("input", {
                  "onUpdate:modelValue": d[5] || (d[5] = (E) => l(n).horizontalAlignment = E),
                  class: "smake:peer smake:absolute smake:appearance-none",
                  type: "radio",
                  name: "horizontalAlignment",
                  value: l(us).CENTER
                }, null, 8, D6), [
                  [po, l(n).horizontalAlignment]
                ]),
                x("div", j6, [
                  b(m, {
                    class: "smake:h-5.5 smake:duration-150 smake:group-peer-checked:text-white",
                    icon: ["fal", "align-center"]
                  })
                ])
              ]),
              x("label", N6, [
                mt(x("input", {
                  "onUpdate:modelValue": d[6] || (d[6] = (E) => l(n).horizontalAlignment = E),
                  class: "smake:peer smake:absolute smake:appearance-none",
                  type: "radio",
                  name: "horizontalAlignment",
                  value: l(us).RIGHT
                }, null, 8, V6), [
                  [po, l(n).horizontalAlignment]
                ]),
                x("div", U6, [
                  b(m, {
                    class: "smake:h-5.5 smake:duration-150 smake:group-peer-checked:text-white",
                    icon: ["fal", "align-right"]
                  })
                ])
              ])
            ])
          ]),
          x("div", F6, [
            x("span", B6, L(u.$t("offset_left")), 1),
            b(fo, {
              modelValue: l(n).offsetLeft,
              "onUpdate:modelValue": d[7] || (d[7] = (E) => l(n).offsetLeft = E),
              class: "smake:w-full",
              min: l(o).min,
              max: l(o).max,
              step: 1
            }, null, 8, ["modelValue", "min", "max"])
          ])
        ]),
        b(p6, {
          modelValue: l(n).bendingRadius,
          "onUpdate:modelValue": d[8] || (d[8] = (E) => l(n).bendingRadius = E)
        }, null, 8, ["modelValue"])
      ], 64);
    };
  }
}), H6 = { class: "smake:flex smake:justify-between" }, W6 = { class: "smake:text-sm smake:font-bold smake:uppercase" }, G6 = ["onUpdate:modelValue", "onFocus", "onKeydown"], Z6 = ["disabled"], Vl = /* @__PURE__ */ J({
  __name: "TextComponent",
  props: {
    canDeleteAllLines: { type: Boolean },
    data: {},
    deletable: { type: Boolean },
    initialSelectedLine: {},
    isLight: { type: Boolean },
    productionMethodId: {}
  },
  emits: ["delete"],
  setup(t, { emit: e }) {
    const n = t, { data: s, initialSelectedLine: o, isLight: a, productionMethodId: i } = we(n), r = e, c = km(i, a), { unsupportedTextLines: u } = gs(
      A(() => s.value.lines),
      i
    ), d = N({}), m = N(o.value);
    re(() => {
      m.value && s.value.lines.includes(m.value) || (s.value.lines[0] ? m.value = s.value.lines[0] : r("delete"));
    });
    async function _(y) {
      var M;
      if (s.value.lines.length > 8) return;
      const w = s.value.lines[y], P = w ? { ...Wn(w), text: "" } : c();
      s.value.lines.splice(y + 1, 0, P), await ol(), (M = d.value[ft(s.value.lines[y + 1])]) == null || M.focus();
    }
    function g() {
      const y = m.value;
      if (y)
        for (const w of s.value.lines)
          w !== y && (w.bendingRadius = y.bendingRadius, w.color = { ...y.color }, w.fontId = y.fontId, w.horizontalAlignment = y.horizontalAlignment, w.paddingBottom = y.paddingBottom, w.size = y.size);
    }
    function v() {
      var w;
      if (!m.value) return;
      const y = s.value.lines[(s.value.lines.indexOf(m.value) + 1) % s.value.lines.length];
      y && ((w = d.value[ft(y)]) == null || w.focus());
    }
    function z() {
      var w;
      if (!m.value) return;
      const y = s.value.lines[(s.value.lines.indexOf(m.value) - 1 + s.value.lines.length) % s.value.lines.length];
      y && ((w = d.value[ft(y)]) == null || w.focus());
    }
    function h(y) {
      if (y === m.value) {
        const w = s.value.lines.indexOf(y), P = s.value.lines[w - 1] ?? s.value.lines[w + 1];
        m.value = P;
      }
      s.value.lines = s.value.lines.filter((w) => w !== y);
    }
    return (y, w) => {
      const P = xe("FontAwesomeIcon");
      return $(), q(Nl, { "data-testid": "TextComponent" }, {
        default: C(() => {
          var M, E;
          return [
            x("div", H6, [
              x("h3", W6, L(y.$t("texts")), 1),
              y.deletable ? ($(), q(Re, {
                key: 0,
                type: "secondary",
                onClick: w[0] || (w[0] = (R) => r("delete"))
              }, {
                default: C(() => [
                  b(P, {
                    class: "smake:size-5",
                    icon: ["fak", "icon-remove"],
                    "fixed-width": ""
                  })
                ]),
                _: 1
              })) : Q("", !0)
            ]),
            b(Yh, {
              tag: "div",
              class: "smake:relative smake:flex smake:flex-col smake:gap-2",
              "enter-active-class": "smake:duration-300",
              "enter-from-class": "smake:translate-x-8 smake:opacity-0",
              "leave-active-class": "smake:duration-200",
              "leave-to-class": "smake:translate-x-8 smake:opacity-0",
              "move-class": "smake:duration-300"
            }, {
              default: C(() => [
                ($(!0), I(me, null, Se(l(s).lines, (R, j) => {
                  var V;
                  return $(), I("div", {
                    key: l(ft)(R),
                    class: ke([
                      "smake:m-px smake:flex smake:items-center smake:overflow-hidden smake:rounded-md smake:border smake:duration-150 smake:focus-within:outline",
                      m.value === R ? "smake:border-black" : "smake:border-secondary-2"
                    ])
                  }, [
                    (V = l(u)) != null && V.some(
                      ({ textLine: X }) => X === R
                    ) ? ($(), q(P, {
                      key: 0,
                      icon: ["fak", "icon-ciconfig-alert-warning"],
                      class: "smake:ml-2 smake:size-4 smake:text-danger",
                      "fixed-width": ""
                    })) : Q("", !0),
                    mt(x("input", {
                      ref_for: !0,
                      ref: (X) => {
                        X === null ? delete d.value[l(ft)(R)] : d.value[l(ft)(R)] = X;
                      },
                      "onUpdate:modelValue": (X) => R.text = X,
                      "data-testId": "TextInput",
                      class: "smake:h-11 smake:min-w-0 smake:grow smake:p-2 smake:outline-hidden",
                      type: "text",
                      onFocus: (X) => m.value = R,
                      onKeydown: [
                        la(rs(v, ["exact", "prevent"]), ["tab"]),
                        la(rs(z, ["shift", "exact", "prevent"]), ["tab"]),
                        la(rs((X) => _(j), ["prevent"]), ["enter"])
                      ]
                    }, null, 40, G6), [
                      [vn, R.text]
                    ]),
                    y.canDeleteAllLines || l(s).lines.length > 1 ? ($(), q(Re, {
                      key: 1,
                      type: "secondary",
                      class: "smake:mr-2",
                      onClick: (X) => h(R)
                    }, {
                      default: C(() => [
                        b(P, {
                          class: "smake:size-3",
                          icon: ["fak", "icon-x"],
                          "fixed-width": ""
                        })
                      ]),
                      _: 1
                    }, 8, ["onClick"])) : Q("", !0)
                  ], 2);
                }), 128))
              ]),
              _: 1
            }),
            x("button", {
              class: "smake:flex smake:items-center smake:justify-center smake:gap-2 smake:text-xs smake:duration-150 smake:enabled:hover:opacity-60 smake:disabled:opacity-50",
              disabled: l(s).lines.length > 8,
              onClick: w[1] || (w[1] = (R) => _(l(s).lines.length - 1))
            }, [
              b(P, {
                class: "smake:size-8 smake:rounded-full smake:bg-black smake:p-1.5 smake:text-white",
                icon: ["fal", "plus"]
              }),
              he(" " + L(y.$t("add_text_line")), 1)
            ], 8, Z6),
            m.value ? ($(), q(q6, {
              key: l(ft)(m.value),
              data: m.value,
              issues: (E = (M = l(u)) == null ? void 0 : M.find(
                ({ textLine: R }) => R === m.value
              )) == null ? void 0 : E.invalidProperties,
              "production-method-id": l(i)
            }, null, 8, ["data", "issues", "production-method-id"])) : Q("", !0),
            b(et, {
              type: "secondary",
              size: "small",
              text: y.$t("apply_to_all_lines"),
              onClick: g
            }, null, 8, ["text"])
          ];
        }),
        _: 1
      });
    };
  }
}), K6 = { class: "smake:absolute smake:inset-0 smake:top-16 smake:mx-auto smake:flex smake:w-320 smake:max-w-full smake:flex-col smake:gap-4 smake:rounded-3xl smake:rounded-b-none smake:bg-white smake:p-4.5 smake:@sm:inset-12 smake:@sm:max-w-[calc(100%-96px)] smake:@sm:rounded-b-3xl smake:@md:p-9" }, X6 = { class: "smake:flex smake:items-center smake:justify-between smake:gap-2" }, $m = /* @__PURE__ */ J({
  __name: "Dialog",
  props: /* @__PURE__ */ Ae({
    preventClose: { type: Boolean },
    title: {}
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Ae(["closed"], ["update:open"]),
  setup(t, { emit: e }) {
    const n = t, { preventClose: s } = we(n), o = e, a = Ne(t, "open"), { rootElement: i } = D(jt());
    function r(c) {
      s.value && c.preventDefault();
    }
    return (c, u) => {
      const d = xe("FontAwesomeIcon");
      return $(), q(l(Ct), {
        open: a.value,
        "onUpdate:open": u[1] || (u[1] = (m) => a.value = m)
      }, {
        default: C(() => [
          b(l(Pt), { to: l(i) }, {
            default: C(() => [
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:opacity-0",
                onAfterLeave: u[0] || (u[0] = (m) => o("closed"))
              }, {
                default: C(() => [
                  b(l(Mt), { class: "smake:fixed smake:inset-0 smake:bg-black/40" })
                ]),
                _: 1
              }),
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:translate-y-full smake:@sm:translate-y-0 smake:@sm:scale-95 smake:@sm:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:translate-y-full smake:@sm:translate-y-0 smake:@sm:scale-95 smake:@sm:opacity-0"
              }, {
                default: C(() => [
                  b(l(Tt), {
                    "as-child": "",
                    onInteractOutside: r,
                    onEscapeKeyDown: r
                  }, {
                    default: C(() => [
                      x("div", K6, [
                        x("div", X6, [
                          b(l(At), { class: "smake:text-xl smake:font-bold smake:uppercase" }, {
                            default: C(() => [
                              he(L(c.title), 1)
                            ]),
                            _: 1
                          }),
                          b(l(zt), {
                            class: "smake:-mt-2 smake:-mr-2 smake:rounded-full smake:border smake:border-secondary-2 smake:p-2 smake:duration-150 smake:enabled:hover:bg-secondary-3 smake:disabled:opacity-50",
                            disabled: l(s)
                          }, {
                            default: C(() => [
                              b(d, {
                                icon: ["fak", "icon-x"],
                                "fixed-width": "",
                                class: "smake:size-3"
                              })
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        u[2] || (u[2] = x("hr", { class: "smake:border smake:border-secondary-2" }, null, -1)),
                        St(c.$slots, "default")
                      ])
                    ]),
                    _: 3
                  })
                ]),
                _: 3
              })
            ]),
            _: 3
          }, 8, ["to"])
        ]),
        _: 3
      }, 8, ["open"]);
    };
  }
}), Q6 = { class: "smake:flex smake:flex-col smake:overflow-clip smake:rounded-xl smake:border smake:border-secondary-2" }, J6 = { class: "smake:bg-secondary-3 smake:p-4 smake:text-sm smake:font-bold smake:uppercase" }, Y6 = {
  key: 0,
  class: "smake:m-4 smake:flex smake:grow smake:flex-col smake:items-center smake:justify-center smake:gap-4 smake:rounded-xl smake:bg-secondary-3 smake:p-4 smake:text-center smake:text-sm smake:text-danger"
}, ex = Symbol("renderingFailedToast"), tx = /* @__PURE__ */ J({
  __name: "Preview",
  props: {
    productionDesign: {}
  },
  emits: ["status"],
  setup(t, { emit: e }) {
    const n = t, { productionDesign: s } = we(n), o = e, { t: a } = ct(), { open: i } = Rn(), r = jo(
      A(() => s.value.design)
    ), { allTextLinesSupported: c } = gs(
      A(() => {
        var _;
        return (_ = r.value) == null ? void 0 : _.lines;
      }),
      A(() => s.value.productionMethodId)
    ), { fetchStatus: u, imageUrl: d, status: m } = ei(
      s,
      A(() => c.value ?? !0)
    );
    return it(m, (_) => {
      _ === "error" && i(ln, {
        id: ex,
        input: {
          text: a("error_pusher_rendering_failed"),
          type: "info"
        }
      });
    }), re(() => {
      if (u.value === "fetching") {
        o("status", "pending");
        return;
      }
      if (c.value === !1) {
        o("status", "error");
        return;
      }
      o("status", m.value);
    }), (_, g) => {
      const v = xe("FontAwesomeIcon");
      return $(), I("div", Q6, [
        x("div", J6, L(_.$t("icon")), 1),
        l(c) === !1 ? ($(), I("div", Y6, [
          b(v, {
            icon: ["fak", "icon-ciconfig-alert-warning"],
            "fixed-width": "",
            class: "smake:size-7.5 smake:text-danger smake:@md:size-10"
          }),
          he(" " + L(_.$t("please_correct_the_highlighted_errors")), 1)
        ])) : ($(), I("div", {
          key: 1,
          class: ke(["smake:m-4 smake:flex smake:grow smake:items-center smake:justify-center smake:rounded-xl smake:bg-secondary-3 smake:p-4", {
            "smake:animate-pulse": l(m) === "pending" || l(u) === "fetching"
          }])
        }, [
          l(c) && l(d) ? ($(), q(on, {
            key: 0,
            src: l(d)
          }, null, 8, ["src"])) : Q("", !0)
        ], 2))
      ]);
    };
  }
}), nx = { class: "smake:flex smake:grow smake:flex-col smake:gap-4 smake:overflow-y-auto" }, sx = { class: "smake:text-sm" }, ox = { class: "smake:flex smake:grow smake:flex-col smake:gap-4 smake:@md:flex-row" }, ax = { class: "smake:flex smake:flex-col smake:justify-between smake:gap-4 smake:@max-md:justify-center smake:@sm:flex-row" }, ix = { class: "smake:flex smake:flex-col smake:gap-4 smake:@sm:flex-row" }, rx = /* @__PURE__ */ J({
  __name: "DesignRepairWizard",
  props: /* @__PURE__ */ Ae({
    id: {},
    name: {},
    productionDesign: {}
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Ae(["closed", "resolve"], ["update:open"]),
  setup(t, { emit: e }) {
    const n = t, { id: s, name: o, productionDesign: a } = we(n), i = e, r = Ne(t, "open"), { t: c } = ct(), { open: u } = Rn(), d = jo(
      A(() => a.value.design)
    ), { unsupportedTextLines: m } = gs(
      A(() => {
        var M;
        return (M = d.value) == null ? void 0 : M.lines;
      }),
      A(() => a.value.productionMethodId)
    ), _ = N("pending"), { mutateAsync: g, status: v } = yt({
      ...Bb(),
      onError: () => {
        u(ln, {
          input: {
            text: c("boot_error.unexpected"),
            type: "info"
          }
        });
      }
    }), z = N(!1);
    async function h(M) {
      z.value = !!M;
      const E = await g({
        id: s.value,
        favoriteDesign: {
          name: o.value,
          elements: [Ls(a.value)],
          production_method: {
            id: a.value.productionMethodId
          }
        }
      });
      i("resolve", { favoriteDesign: E, load: !!M }), r.value = !1;
    }
    const y = A(
      () => v.value === "pending" && !z.value
    ), w = A(
      () => v.value === "pending" && z.value
    ), P = A(
      () => _.value !== "success" || v.value === "pending"
    );
    return (M, E) => ($(), q($m, {
      open: r.value,
      "onUpdate:open": E[3] || (E[3] = (R) => r.value = R),
      title: M.$t("font_update"),
      "prevent-close": l(v) === "pending",
      onClosed: E[4] || (E[4] = (R) => i("closed"))
    }, {
      default: C(() => {
        var R, j;
        return [
          x("div", nx, [
            x("div", sx, L(M.$t("font_update_explanation")), 1),
            x("div", ox, [
              b(tx, {
                class: "smake:@md:flex-1",
                "production-design": l(a),
                onStatus: E[0] || (E[0] = (V) => _.value = V)
              }, null, 8, ["production-design"]),
              l(d) ? ($(), q(Vl, {
                key: 0,
                class: "smake:@md:flex-1",
                data: l(d),
                "production-method-id": l(a).productionMethodId,
                "initial-selected-line": (j = (R = l(m)) == null ? void 0 : R[0]) == null ? void 0 : j.textLine,
                "is-light": ""
              }, null, 8, ["data", "production-method-id", "initial-selected-line"])) : Q("", !0)
            ])
          ]),
          x("div", ax, [
            b(l(zt), { "as-child": "" }, {
              default: C(() => [
                b(et, {
                  class: "smake:@max-md:hidden",
                  icon: {
                    type: ["fak", "icon-x"]
                  },
                  type: "secondary",
                  disabled: l(v) === "pending",
                  text: M.$t("abort")
                }, null, 8, ["disabled", "text"])
              ]),
              _: 1
            }),
            x("div", ix, [
              b(et, {
                disabled: P.value,
                type: "secondary",
                icon: {
                  type: y.value ? ["fal", "spinner"] : ["fak", "icon-save"],
                  spin: y.value
                },
                text: M.$t("save"),
                onClick: E[1] || (E[1] = (V) => h())
              }, null, 8, ["disabled", "icon", "text"]),
              b(et, {
                disabled: P.value,
                type: "primary",
                icon: {
                  type: ["fal", w.value ? "spinner" : "check"],
                  spin: w.value
                },
                text: M.$t("save_and_load"),
                onClick: E[2] || (E[2] = (V) => h(!0))
              }, null, 8, ["disabled", "icon", "text"])
            ])
          ])
        ];
      }),
      _: 1
    }, 8, ["open", "title", "prevent-close"]));
  }
}), lx = { class: "smake:absolute smake:top-1/2 smake:left-1/2 smake:mx-auto smake:flex smake:h-fit smake:max-h-full smake:w-auto smake:max-w-150 smake:-translate-x-1/2 smake:-translate-y-1/2 smake:flex-col smake:gap-6 smake:rounded-3xl smake:bg-white smake:p-4" }, cx = { class: "smake:flex smake:items-start smake:justify-between smake:gap-2" }, ux = { class: "smake:flex smake:flex-col smake:justify-between smake:gap-5" }, dx = { class: "smake:flex smake:w-full smake:flex-col smake:gap-4 smake:@md:flex-row" }, px = /* @__PURE__ */ J({
  __name: "ConfirmReplacementDialog",
  props: {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  },
  emits: /* @__PURE__ */ Ae(["closed", "resolve"], ["update:open"]),
  setup(t, { emit: e }) {
    const n = e, s = Ne(t, "open"), { dialogsRoot: o } = D(nn());
    return (a, i) => {
      const r = xe("FontAwesomeIcon");
      return $(), q(l(Ct), {
        open: s.value,
        "onUpdate:open": i[3] || (i[3] = (c) => s.value = c)
      }, {
        default: C(() => [
          b(l(Pt), { to: l(o) }, {
            default: C(() => [
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:opacity-0",
                onAfterLeave: i[0] || (i[0] = (c) => n("closed"))
              }, {
                default: C(() => [
                  b(l(Mt), { class: "smake:fixed smake:inset-0 smake:bg-black/40" })
                ]),
                _: 1
              }),
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:scale-95 smake:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:scale-95 smake:opacity-0"
              }, {
                default: C(() => [
                  b(l(Tt), { "as-child": "" }, {
                    default: C(() => [
                      x("div", lx, [
                        x("div", cx, [
                          b(l(At), { class: "smake:flex smake:items-center smake:gap-2" }, {
                            default: C(() => [
                              b(r, {
                                class: "smake:size-4.5",
                                icon: ["fak", "icon-info"],
                                "fixed-width": ""
                              }),
                              x("div", null, L(a.$t(
                                "the_selected_design_will_replace_the_current_selection"
                              )), 1)
                            ]),
                            _: 1
                          }),
                          b(l(zt), { class: "smake:-mt-2 smake:-mr-2 smake:rounded-full smake:border smake:border-secondary-2 smake:p-2 smake:duration-150 smake:hover:bg-secondary-3" }, {
                            default: C(() => [
                              b(r, {
                                icon: ["fak", "icon-x"],
                                "fixed-width": "",
                                class: "smake:size-3"
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        x("div", ux, [
                          x("div", dx, [
                            b(Re, {
                              type: "outline",
                              class: "smake:flex-grow",
                              onClick: i[1] || (i[1] = (c) => s.value = !1)
                            }, {
                              default: C(() => [
                                he(L(a.$t("abort")), 1)
                              ]),
                              _: 1
                            }),
                            b(Re, {
                              type: "primary",
                              class: "smake:flex smake:flex-grow smake:items-center smake:gap-2",
                              onClick: i[2] || (i[2] = (c) => n("resolve", !0))
                            }, {
                              default: C(() => [
                                he(L(a.$t("replace")), 1)
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _: 1
      }, 8, ["open"]);
    };
  }
}), mx = { class: "smake:absolute smake:inset-x-5 smake:top-1/2 smake:mx-auto smake:flex smake:h-fit smake:max-h-full smake:max-w-100 smake:-translate-y-1/2 smake:flex-col smake:gap-4 smake:overflow-y-auto smake:rounded-3xl smake:bg-white smake:p-4" }, hx = { class: "smake:flex smake:items-start smake:justify-between smake:gap-2" }, fx = { class: "smake:font-bold smake:text-primary-1" }, _x = { class: "smake:flex smake:flex-col smake:items-center smake:gap-4" }, vx = ["src"], gx = {
  key: 0,
  class: "smake:w-full smake:rounded-lg smake:border smake:border-danger smake:p-2 smake:text-danger"
}, kx = { class: "smake:flex smake:w-full smake:flex-col smake:gap-4 smake:@md:flex-row" }, yx = /* @__PURE__ */ J({
  __name: "DeleteDialog",
  props: /* @__PURE__ */ Ae({
    name: {},
    error: {},
    image: {},
    mutationStatus: {}
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Ae(["closed", "delete", "resolve"], ["update:open"]),
  setup(t, { emit: e }) {
    const n = e, s = Ne(t, "open"), o = t, { mutationStatus: a } = we(o), { dialogsRoot: i } = D(nn()), r = A(() => a.value === "pending");
    function c(u) {
      r.value || u.preventDefault();
    }
    return (u, d) => {
      const m = xe("I18nT"), _ = xe("FontAwesomeIcon");
      return $(), q(l(Ct), {
        open: s.value,
        "onUpdate:open": d[3] || (d[3] = (g) => s.value = g)
      }, {
        default: C(() => [
          b(l(Pt), { to: l(i) }, {
            default: C(() => [
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:opacity-0",
                onAfterLeave: d[0] || (d[0] = (g) => n("closed"))
              }, {
                default: C(() => [
                  b(l(Mt), { class: "smake:fixed smake:inset-0 smake:bg-black/40" })
                ]),
                _: 1
              }),
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:scale-95 smake:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:scale-95 smake:opacity-0"
              }, {
                default: C(() => [
                  b(l(Tt), {
                    "as-child": "",
                    onInteractOutside: c,
                    onEscapeKeyDown: c
                  }, {
                    default: C(() => [
                      x("div", mx, [
                        x("div", hx, [
                          b(l(At), null, {
                            default: C(() => [
                              b(m, {
                                keypath: "are_you_sure_you_want_to_delete",
                                tag: "div"
                              }, {
                                deleteName: C(() => [
                                  x("span", fx, L(u.name), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          b(l(zt), { class: "smake:-mt-2 smake:-mr-2 smake:rounded-full smake:border smake:border-secondary-2 smake:p-2 smake:duration-150 smake:hover:bg-secondary-3" }, {
                            default: C(() => [
                              b(_, {
                                icon: ["fak", "icon-x"],
                                "fixed-width": "",
                                class: "smake:size-3"
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        x("div", _x, [
                          x("img", {
                            class: "smake:aspect-square smake:w-80 smake:rounded-3xl smake:bg-secondary-3 smake:object-contain smake:p-4",
                            src: u.image
                          }, null, 8, vx),
                          u.error ? ($(), I("div", gx, L(u.$t("boot_error.unexpected")), 1)) : Q("", !0),
                          x("div", kx, [
                            b(Re, {
                              type: "outline",
                              class: "smake:flex-grow",
                              disabled: r.value,
                              onClick: d[1] || (d[1] = (g) => s.value = !1)
                            }, {
                              default: C(() => [
                                he(L(u.$t("abort")), 1)
                              ]),
                              _: 1
                            }, 8, ["disabled"]),
                            b(Re, {
                              type: "primary",
                              class: "smake:flex smake:flex-grow smake:items-center smake:gap-2",
                              disabled: r.value,
                              onClick: d[2] || (d[2] = (g) => n("delete"))
                            }, {
                              default: C(() => [
                                b(_, {
                                  class: "smake:h-5",
                                  icon: ["fak", "icon-remove"],
                                  "fixed-width": ""
                                }),
                                he(" " + L(u.$t("delete")), 1)
                              ]),
                              _: 1
                            }, 8, ["disabled"])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _: 1
      }, 8, ["open"]);
    };
  }
}), bx = {
  key: 0,
  class: "smake:font-bold"
}, wx = /* @__PURE__ */ J({
  __name: "DesignFavoredCard",
  props: {
    design: {},
    isSelectConfirmationRequired: { type: Boolean }
  },
  emits: ["repair", "select"],
  setup(t, { emit: e }) {
    const n = t, { design: s } = we(n), o = e, a = A(() => ys(s.value.elements[0])), i = jo(a), { allTextLinesSupported: r } = gs(
      A(() => {
        var V;
        return (V = i.value) == null ? void 0 : V.lines;
      }),
      A(() => s.value.production_method.id)
    ), c = A(() => r.value === !1), u = N(!1), d = N(!1), m = N(!1), {
      error: _,
      mutate: g,
      reset: v,
      status: z
    } = yt({
      ...ce.designs.favored.patch.use(),
      onSuccess: () => u.value = !1
    }), {
      error: h,
      mutate: y,
      status: w
    } = yt({
      ...ce.designs.favored.delete.use(),
      onSuccess: () => d.value = !1
    });
    re(() => {
      u.value || v();
    });
    function P() {
      if (!n.isSelectConfirmationRequired) {
        o("select");
        return;
      }
      m.value = !0;
    }
    const M = A(
      () => Zb(...Dl(s.value.elements[0]))
    ), E = A(() => s.value.name ?? ""), R = A(() => s.value.preview_url);
    function j(V) {
      V && o("select");
    }
    return (V, X) => ($(), I(me, null, [
      b(xm, {
        name: E.value,
        image: R.value,
        width: l(s).width,
        height: l(s).height,
        "color-assignments": M.value,
        deletable: !0,
        "production-method-id": l(s).production_method.id,
        "needs-repair": c.value,
        onRename: X[0] || (X[0] = (Z) => u.value = !0),
        onDelete: X[1] || (X[1] = (Z) => d.value = !0),
        onSelect: P,
        onRepair: X[2] || (X[2] = (Z) => o("repair"))
      }, Er({ _: 2 }, [
        c.value ? {
          name: "repair-label",
          fn: C(() => [
            l(r) ? Q("", !0) : ($(), I("div", bx, L(V.$t("font_not_available")) + "! ", 1))
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["name", "image", "width", "height", "color-assignments", "production-method-id", "needs-repair"]),
      b(wm, {
        open: u.value,
        "onUpdate:open": X[3] || (X[3] = (Z) => u.value = Z),
        name: E.value,
        image: R.value,
        error: l(_) ?? void 0,
        "mutation-status": l(z),
        onRename: X[4] || (X[4] = (Z) => l(g)({ id: l(s).id, name: Z }))
      }, null, 8, ["open", "name", "image", "error", "mutation-status"]),
      b(yx, {
        open: d.value,
        "onUpdate:open": X[5] || (X[5] = (Z) => d.value = Z),
        name: E.value,
        image: R.value,
        "mutation-status": l(w),
        error: l(h) ?? void 0,
        onDelete: X[6] || (X[6] = (Z) => l(y)(l(s).id))
      }, null, 8, ["open", "name", "image", "mutation-status", "error"]),
      b(px, {
        open: m.value,
        "onUpdate:open": X[7] || (X[7] = (Z) => m.value = Z),
        onResolve: j
      }, null, 8, ["open"])
    ], 64));
  }
}), xx = {
  key: 1,
  class: "smake:-mt-8 smake:flex smake:h-full smake:grow smake:items-center smake:justify-center smake:text-lg"
}, $x = { class: "smake:max-w-md smake:text-center smake:text-secondary-1 smake:italic" }, zx = /* @__PURE__ */ J({
  __name: "DesignFavoredSelection",
  props: {
    isSelectConfirmationRequired: { type: Boolean },
    productionMethodId: {}
  },
  emits: ["design-selected"],
  setup(t, { emit: e }) {
    const n = t, { productionMethodId: s } = we(n), o = e, a = Ds("favoriteDesignsContainer"), { y: i } = md(a, { behavior: "smooth" }), { productionMethod: r } = It(s), { open: c } = pn(), u = A(
      () => ({
        production_method: [s.value]
      })
    ), {
      data: d,
      fetchNextPage: m,
      hasNextPage: _,
      isFetching: g,
      status: v
    } = js({
      ...ce.designs.favored.list.use(u),
      select: (w) => w.pages.flatMap((P) => P.data),
      staleTime: 1 / 0
    });
    function z() {
      return v.value === "pending" ? !0 : _.value;
    }
    async function h() {
      v.value !== "pending" && await m();
    }
    async function y(w) {
      const P = await c(rx, {
        input: {
          id: w.id,
          name: w.name ?? void 0,
          productionDesign: {
            design: ys(w.elements[0]),
            productionMethodId: w.production_method.id
          }
        }
      });
      P !== void 0 && (i.value = 0), P != null && P.load && o("design-selected", Wn(P.favoriteDesign));
    }
    return (w, P) => {
      var M, E;
      return l(g) || (M = l(d)) != null && M.length ? mt(($(), I("div", {
        key: 0,
        ref_key: "favoriteDesignsContainer",
        ref: a,
        class: "smake:grid smake:grid-cols-auto-fill-38 smake:gap-4 smake:overflow-y-auto smake:@sm:grid-cols-auto-fill-45"
      }, [
        ($(!0), I(me, null, Se(l(d), (R) => ($(), I("div", {
          key: R.id
        }, [
          b(wx, {
            design: R,
            "is-select-confirmation-required": w.isSelectConfirmationRequired,
            onSelect: (j) => o("design-selected", l(Wn)(R)),
            onRepair: (j) => y(R)
          }, null, 8, ["design", "is-select-confirmation-required", "onSelect", "onRepair"])
        ]))), 128)),
        ($(!0), I(me, null, Se(l(g) ? 3 : 0, (R) => ($(), I("div", {
          key: R,
          class: "smake:min-h-95 smake:animate-pulse smake:rounded-3xl smake:bg-secondary-3"
        }))), 128))
      ])), [
        [l($o), [h, { distance: 350, canLoadMore: z }]]
      ]) : ($(), I("div", xx, [
        x("div", $x, L(w.$t("no_designs", {
          productionMethod: (E = l(r)) == null ? void 0 : E.display_name
        })), 1)
      ]));
    };
  }
}), Sx = { class: "smake:absolute smake:inset-0 smake:top-16 smake:mx-auto smake:flex smake:w-320 smake:max-w-full smake:flex-col smake:gap-4 smake:rounded-3xl smake:rounded-b-none smake:bg-white smake:p-4 smake:@sm:inset-12 smake:@sm:max-w-[calc(100%-96px)] smake:@sm:rounded-b-3xl" }, Ax = { class: "smake:flex smake:items-start smake:justify-between smake:gap-2" }, Cx = { class: "smake:flex smake:flex-wrap smake:gap-2" }, Px = { class: "smake:text-nowrap smake:text-secondary-2" }, Mx = { class: "smake:text-nowrap smake:text-secondary-2" }, Ul = /* @__PURE__ */ J({
  __name: "CustomerDesignSelection",
  props: /* @__PURE__ */ Ae({
    initialProductionMethodId: {},
    intialTab: { default: "customer-logos" },
    positioningArea: { default: void 0 },
    positioningAreaDesign: { default: void 0 }
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Ae(["closed", "resolve"], ["update:open"]),
  setup(t, { emit: e }) {
    const n = e, s = Ne(t, "open"), o = t, {
      initialProductionMethodId: a,
      intialTab: i,
      positioningArea: r,
      positioningAreaDesign: c
    } = we(o), u = N(a.value);
    it(s, (P) => {
      P && (u.value = a.value);
    });
    const d = A(() => !c.value), { dialogsRoot: m } = D(nn()), { placeDesign: _ } = si();
    function g() {
      s.value = !1, n("resolve", !0);
    }
    async function v(P) {
      const M = Il(P.logo);
      await _(
        {
          design: M,
          productionMethodId: u.value
        },
        {
          mergePostioningAreaDesign: c.value,
          positioningArea: r.value
        }
      ) === "success" && g();
    }
    async function z(P) {
      const M = ys(P.elements[0]);
      await _(
        {
          design: M,
          productionMethodId: u.value
        },
        {
          mergePostioningAreaDesign: c.value,
          positioningArea: r.value
        }
      ) === "success" && (s.value = !1, n("resolve", !0));
    }
    const h = N(i.value), { data: y } = bt({
      ...ce.customerLogos.count.use(
        A(() => ({
          production_method: [u.value]
        }))
      ),
      retry: !1,
      staleTime: 1 / 0
    }), { data: w } = bt({
      ...ce.designs.favored.count.use(
        A(() => ({
          production_method: [u.value]
        }))
      ),
      retry: !1,
      staleTime: 1 / 0
    });
    return (P, M) => {
      const E = xe("FontAwesomeIcon");
      return $(), q(l(Ct), {
        open: s.value,
        "onUpdate:open": M[3] || (M[3] = (R) => s.value = R)
      }, {
        default: C(() => [
          b(l(Pt), { to: l(m) }, {
            default: C(() => [
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:opacity-0",
                onAfterLeave: M[0] || (M[0] = (R) => n("closed"))
              }, {
                default: C(() => [
                  b(l(Mt), { class: "smake:fixed smake:inset-0 smake:bg-black/40" })
                ]),
                _: 1
              }),
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:translate-y-full smake:@sm:translate-y-0 smake:@sm:scale-95 smake:@sm:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:translate-y-full smake:@sm:translate-y-0 smake:@sm:scale-95 smake:@sm:opacity-0"
              }, {
                default: C(() => [
                  b(l(Tt), { "as-child": "" }, {
                    default: C(() => [
                      x("div", Sx, [
                        x("div", Ax, [
                          b(l(At), { class: "smake:text-2xl smake:font-bold smake:uppercase" }, {
                            default: C(() => [
                              he(L(P.$t("logos_and_designs")), 1)
                            ]),
                            _: 1
                          }),
                          b(l(zt), { class: "smake:-mt-2 smake:-mr-2 smake:rounded-full smake:border smake:border-secondary-2 smake:p-2 smake:duration-150 smake:hover:bg-secondary-3" }, {
                            default: C(() => [
                              b(E, {
                                icon: ["fak", "icon-x"],
                                "fixed-width": "",
                                class: "smake:size-3"
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        b(l(rl), {
                          modelValue: h.value,
                          "onUpdate:modelValue": M[2] || (M[2] = (R) => h.value = R),
                          class: "smake:flex smake:grow smake:flex-col smake:gap-4 smake:overflow-hidden"
                        }, {
                          default: C(() => [
                            b(l(ll), { class: "smake:mb-4 smake:flex smake:flex-wrap smake:justify-between smake:gap-2" }, {
                              default: C(() => [
                                x("div", Cx, [
                                  b(ho, {
                                    "selected-value": h.value,
                                    text: P.$t("my_files"),
                                    value: "customer-logos"
                                  }, {
                                    default: C(() => [
                                      b(Dw, { class: "smake:size-3.5" }),
                                      he(" " + L(P.$t("my_files")) + " ", 1),
                                      x("span", Px, L(l(y)), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["selected-value", "text"]),
                                  b(ho, {
                                    "selected-value": h.value,
                                    text: P.$t("saved_designs"),
                                    value: "designs"
                                  }, {
                                    default: C(() => [
                                      b(Uw, { class: "smake:size-3.5" }),
                                      he(" " + L(P.$t("saved_designs")) + " ", 1),
                                      x("span", Mx, L(l(w)), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["selected-value", "text"])
                                ]),
                                b(bm, {
                                  modelValue: u.value,
                                  "onUpdate:modelValue": M[1] || (M[1] = (R) => u.value = R),
                                  disabled: !d.value
                                }, null, 8, ["modelValue", "disabled"])
                              ]),
                              _: 1
                            }),
                            b(l(mo), {
                              "as-child": "",
                              value: "customer-logos",
                              unmount: !1
                            }, {
                              default: C(() => [
                                b(b3, {
                                  "production-method-id": u.value,
                                  "positioning-area": l(r),
                                  "positioning-area-design": l(c),
                                  onCustomerLogoSelected: v,
                                  onUploadPlaced: g
                                }, null, 8, ["production-method-id", "positioning-area", "positioning-area-design"])
                              ]),
                              _: 1
                            }),
                            b(l(mo), {
                              value: "designs",
                              "as-child": "",
                              unmount: !1
                            }, {
                              default: C(() => [
                                b(zx, {
                                  "is-select-confirmation-required": l(c) !== void 0,
                                  "production-method-id": u.value,
                                  onDesignSelected: z
                                }, null, 8, ["is-select-confirmation-required", "production-method-id"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _: 1
      }, 8, ["open"]);
    };
  }
}), Tx = {}, Ix = {
  id: "Ebene_2",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 94.03 86.98"
};
function Ex(t, e) {
  return $(), I("svg", Ix, [...e[0] || (e[0] = [
    ld('<g id="Ebene_1-2"><g id="Icon_Image_Download"><g id="Pfad_1352"><path fill="currentColor" d="M68.6,86.98c-.61,0-1.22-.08-1.83-.25L5.05,69.81c-3.65-1-5.81-4.79-4.81-8.44l8.31-30.27c.22-.8,1.05-1.27,1.84-1.05.8.22,1.27,1.04,1.05,1.84L3.14,62.16c-.56,2.06.65,4.19,2.71,4.76l61.71,16.93c1,.27,2.04.14,2.94-.37.9-.51,1.54-1.34,1.82-2.34l3.71-13.55c.22-.8,1.04-1.27,1.84-1.05.8.22,1.27,1.04,1.05,1.84l-3.71,13.55c-.49,1.77-1.63,3.24-3.23,4.15-1.05.6-2.21.9-3.39.9Z"></path></g><g id="Pfad_1353"><path fill="currentColor" d="M34.73,27.91c-4.22,0-7.64-3.43-7.65-7.64,0-2.04.79-3.96,2.24-5.41,1.44-1.44,3.36-2.24,5.41-2.24,4.22,0,7.65,3.43,7.65,7.64h0s0,0,0,0c0,2.04-.79,3.96-2.24,5.41-1.44,1.44-3.36,2.24-5.41,2.24h0ZM34.73,15.62c-1.24,0-2.41.48-3.29,1.36-.88.88-1.36,2.04-1.36,3.28,0,2.56,2.08,4.64,4.65,4.64h0c2.56,0,4.64-2.08,4.64-4.65h0c0-2.56-2.08-4.64-4.64-4.64Z"></path></g><path fill="currentColor" d="M89.38,0H20.93c-2.56,0-4.64,2.08-4.64,4.64v53.71c0,2.56,2.08,4.64,4.64,4.64h68.46c2.56,0,4.64-2.08,4.64-4.64V4.64c0-2.56-2.08-4.64-4.64-4.64ZM20.93,3h68.46c.9,0,1.64.73,1.64,1.64v39.21l-20.35-20.35c-.56-.56-1.56-.56-2.12,0l-19.53,19.53-8.88-8.88c-.28-.28-.67-.44-1.07-.44-.4,0-.78.17-1.06.45l-18.71,19.2V4.64c0-.9.73-1.64,1.64-1.64ZM89.38,59.98H20.93c-.9,0-1.64-.73-1.64-1.64v-.68l19.8-20.32,8.87,8.87c.56.56,1.56.56,2.12,0l19.53-19.53,21.42,21.41v10.26c0,.9-.73,1.64-1.64,1.64Z"></path></g></g>', 1)
  ])]);
}
const Ox = /* @__PURE__ */ bs(Tx, [["render", Ex]]), Rx = { class: "smake:rounded-3xl smake:border-3 smake:border-dashed smake:border-secondary-2 smake:p-2" }, Lx = {
  key: 0,
  class: "smake:flex smake:grow smake:flex-col smake:items-center smake:justify-between"
}, Dx = { class: "smake:flex smake:grow smake:flex-col smake:items-center smake:justify-center smake:gap-4" }, jx = { class: "smake:relative" }, Nx = { class: "smake:absolute smake:-right-2.5 smake:bottom-2 smake:flex smake:size-5 smake:items-center smake:justify-center smake:rounded-full smake:bg-white smake:p-1 smake:@md:-right-5 smake:@md:bottom-4 smake:@md:size-10" }, Vx = { class: "smake:flex smake:items-center smake:justify-center smake:gap-2" }, Ux = { class: "smake:flex smake:flex-col smake:gap-2 smake:text-center smake:font-semibold smake:text-balance smake:text-primary-1" }, Fx = ["href"], Bx = { class: "smake:p-4 smake:text-center smake:leading-6" }, qx = ["href"], Hx = {
  key: 1,
  class: "smake:flex smake:w-full smake:flex-col smake:items-center smake:justify-center smake:gap-5"
}, Wx = { class: "smake:rounded-full smake:bg-black smake:p-4 smake:shadow-lg" }, Gx = { class: "smake:flex smake:flex-col smake:gap-2 smake:text-center smake:text-[14px] smake:font-thin" }, Zx = {
  key: 2,
  class: "smake:flex smake:grow smake:flex-col smake:items-center smake:gap-4 smake:p-5"
}, Kx = { class: "smake:flex smake:grow smake:items-center smake:justify-center" }, Xx = { class: "smake:flex smake:w-full smake:items-center smake:gap-4 smake:@max-lg:flex-col smake:@max-lg:items-center smake:@max-lg:text-center smake:@lg:justify-between" }, Qx = { class: "smake:flex smake:flex-col smake:gap-1" }, Jx = { class: "smake:font-semibold" }, Yx = { class: "smake:[overflow-wrap:normal]" }, e4 = /* @__PURE__ */ J({
  __name: "CustomerLogoDropzone",
  props: /* @__PURE__ */ Ae({
    accept: {},
    disabled: { type: Boolean },
    errors: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Ae(["reset"], ["update:modelValue"]),
  setup(t, { emit: e }) {
    var ae;
    function n(K) {
      return "id" in K;
    }
    const s = t, { accept: o, disabled: a, errors: i } = we(s), r = N();
    re(() => {
      r.value = i.value;
    });
    const { termsOfServiceLink: c, uploadHelpLink: u } = D(Zs()), d = A(() => {
      if (r.value) {
        if (r.value.fieldMessages) {
          const K = [];
          for (const [te, ue] of Object.entries(
            r.value.fieldMessages
          ))
            te === "content_type" || te === "path" || K.push(...ue);
          return K;
        }
        if (r.value.message)
          return [r.value.message];
      }
    }), m = A(
      () => {
        var K, te, ue, Ce;
        return !!((te = (K = r.value) == null ? void 0 : K.fieldMessages) != null && te.content_type) || !!((Ce = (ue = r.value) == null ? void 0 : ue.fieldMessages) != null && Ce.path);
      }
    ), _ = e, g = Ne(t, "modelValue"), { designerConfiguration: v } = D(tt()), z = A(
      () => {
        var K;
        return (K = v.value) == null ? void 0 : K.settings.settings.units.length;
      }
    ), { decimalFormat: h } = Xa(), { locale: y } = ct(), w = A(() => g.value === void 0 ? "empty" : n(g.value) ? "preview" : "processing"), P = A(() => {
      if (g.value && n(g.value))
        return {
          name: g.value.name ?? g.value.logo.name,
          height: h(
            g.value.logo.height ?? 0,
            y.value,
            2
          ),
          previewUrl: g.value.logo.preview_url ?? void 0,
          width: h(
            g.value.logo.width ?? 0,
            y.value,
            2
          )
        };
    });
    function M(K) {
      var te;
      return (te = o.value) != null && te.length ? o.value.some(
        (ue) => ue.startsWith(".") ? K.name.endsWith(ue) : K.type === ue
      ) : !0;
    }
    const E = Ds("dropArea"), { isOverDropZone: R } = uf(E, {
      multiple: !1,
      onDrop: (K) => {
        if (a.value) return;
        _("reset");
        let te = K == null ? void 0 : K[0];
        te && (M(te) || (te = void 0, r.value = {
          fieldMessages: {
            content_type: ["invalid"]
          }
        }), g.value = te);
      }
    }), j = A(() => !a.value && R.value), { onChange: V, open: X } = df({
      accept: (ae = o.value) == null ? void 0 : ae.join(","),
      multiple: !1
    });
    function Z() {
      _("reset"), X();
    }
    return V((K) => {
      if (!K) return;
      let te = K[0];
      te && (M(te) || (te = void 0, r.value = {
        fieldMessages: {
          content_type: ["invalid"]
        }
      }), g.value = te);
    }), (K, te) => {
      const ue = xe("FontAwesomeIcon");
      return $(), I("div", Rx, [
        x("div", {
          ref_key: "dropArea",
          ref: E,
          class: ke([{
            "smake:bg-secondary-3": !j.value,
            "smake:bg-secondary-2": j.value
          }, "smake:flex smake:h-full smake:rounded-3xl smake:p-3"])
        }, [
          w.value === "empty" ? ($(), I("div", Lx, [
            x("div", Dx, [
              x("div", jx, [
                b(Ox, { class: "smake:size-15 smake:@md:size-30" }),
                x("div", Nx, [
                  b(oi, { class: "smake:h-2.5 smake:@md:h-5" })
                ])
              ]),
              x("div", null, L(K.$t("drag_file_over_area")), 1),
              x("div", Vx, [
                x("div", {
                  class: ke(["smake:w-18 smake:border-t-2", {
                    "smake:border-t-secondary-2": !j.value,
                    "smake:border-t-secondary-3": j.value
                  }])
                }, null, 2),
                he(" " + L(K.$t("or")) + " ", 1),
                x("div", {
                  class: ke(["smake:w-18 smake:border-t-2", {
                    "smake:border-t-secondary-2": !j.value,
                    "smake:border-t-secondary-3": j.value
                  }])
                }, null, 2)
              ]),
              x("div", null, [
                b(et, {
                  type: "primary",
                  size: "small",
                  disabled: l(a),
                  text: K.$t("select_file"),
                  onClick: Z
                }, null, 8, ["disabled", "text"])
              ]),
              x("div", Ux, [
                ($(!0), I(me, null, Se(d.value, (Ce) => ($(), I("div", { key: Ce }, L(Ce), 1))), 128)),
                m.value ? ($(), q(l(uc), {
                  key: 0,
                  keypath: "upload_error_422_content_type",
                  tag: "span"
                }, {
                  here: C(() => [
                    x("a", {
                      class: "smake:font-bold smake:underline",
                      href: l(u),
                      target: "_blank"
                    }, L(K.$t("here")), 9, Fx)
                  ]),
                  _: 1
                })) : Q("", !0)
              ])
            ]),
            x("div", Bx, [
              b(l(uc), {
                keypath: "more_informations_about_upload",
                as: "div"
              }, {
                termsOfServiceLink: C(() => [
                  x("a", {
                    href: l(c),
                    target: "_blank",
                    class: "smake:underline"
                  }, L(K.$t("terms_of_service")), 9, qx)
                ]),
                _: 1
              })
            ])
          ])) : Q("", !0),
          w.value === "processing" ? ($(), I("div", Hx, [
            x("div", Wx, [
              b(ue, {
                class: "smake:size-5 smake:animate-spin smake:text-white",
                icon: ["fal", "spinner-third"]
              })
            ]),
            x("div", Gx, [
              x("div", null, L(K.$t("your_file_is_beeing_uploaded")), 1),
              x("div", null, L(K.$t("please_hold_on_for_a_moment")), 1)
            ])
          ])) : Q("", !0),
          P.value ? ($(), I("div", Zx, [
            x("div", Kx, [
              b(on, {
                class: "smake:size-100 smake:object-contain smake:data-[state=pending]:animate-pulse smake:data-[state=pending]:rounded-md smake:data-[state=pending]:bg-secondary-2",
                src: P.value.previewUrl
              }, null, 8, ["src"])
            ]),
            x("div", Xx, [
              x("div", Qx, [
                x("div", Jx, L(P.value.name), 1),
                x("div", Yx, L(P.value.width) + " x " + L(P.value.height) + " " + L(z.value), 1)
              ]),
              b(et, {
                size: "small",
                type: "subordinate",
                text: K.$t("upload_another_file"),
                onClick: Z
              }, null, 8, ["text"])
            ])
          ])) : Q("", !0)
        ], 2)
      ]);
    };
  }
}), t4 = { class: "smake:flex smake:size-45 smake:flex-col smake:items-center smake:justify-center smake:gap-5 smake:rounded-lg smake:bg-secondary-3 smake:p-4" }, n4 = /* @__PURE__ */ J({
  __name: "CustomerLogo",
  props: {
    data: {},
    disabled: { type: Boolean }
  },
  emits: ["selected"],
  setup(t, { emit: e }) {
    const n = e;
    return (s, o) => ($(), I("div", t4, [
      b(on, {
        class: "smake:size-2/3 smake:object-contain smake:data-[state=pending]:animate-pulse smake:data-[state=pending]:rounded-md smake:data-[state=pending]:bg-secondary-2",
        src: s.data.logo.preview_url ?? void 0
      }, null, 8, ["src"]),
      b(et, {
        type: "subordinate",
        size: "small",
        disabled: s.disabled,
        text: s.$t("choose"),
        onClick: o[0] || (o[0] = (a) => n("selected"))
      }, null, 8, ["disabled", "text"])
    ]));
  }
}), s4 = { class: "smake:hidden smake:flex-col smake:items-center smake:gap-5 smake:@md:flex" }, o4 = {
  key: 0,
  class: "smake:flex smake:size-45 smake:items-center smake:justify-center smake:rounded-lg smake:border-2 smake:border-secondary-3 smake:text-center smake:text-xs smake:text-balance smake:text-secondary-2 smake:italic"
}, a4 = /* @__PURE__ */ J({
  __name: "RecentCustomerLogoUploads",
  props: {
    disabled: { type: Boolean },
    productionMethodId: {}
  },
  emits: ["selected"],
  setup(t, { emit: e }) {
    const n = t, { productionMethodId: s } = we(n), o = e, { data: a } = js({
      ...ce.customerLogos.list.use(
        A(() => ({
          production_method: [s.value]
        }))
      ),
      select: (u) => u.pages.flatMap((d) => d.data)
    }), i = A(() => {
      var u;
      return (u = a.value) == null ? void 0 : u.slice(0, 3);
    }), r = A(() => {
      var u;
      return c.value ? 2 : 3 - (((u = i.value) == null ? void 0 : u.length) ?? 0);
    }), c = A(
      () => {
        var u;
        return (((u = i.value) == null ? void 0 : u.length) ?? 0) === 0;
      }
    );
    return (u, d) => {
      var m;
      return $(), I("div", s4, [
        x("span", {
          class: ke(["smake:text-sm smake:font-semibold", {
            "smake:text-secondary-2": (((m = l(a)) == null ? void 0 : m.length) ?? 0) === 0
          }])
        }, L(u.$t("recently_uploaded")) + ": ", 3),
        ($(!0), I(me, null, Se(i.value, (_) => ($(), q(n4, {
          key: _.id,
          data: _,
          disabled: u.disabled,
          onSelected: (g) => o("selected", _)
        }, null, 8, ["data", "disabled", "onSelected"]))), 128)),
        c.value ? ($(), I("div", o4, L(u.$t("currently_no_uploaded_files")), 1)) : Q("", !0),
        ($(!0), I(me, null, Se(r.value, (_) => ($(), I("div", {
          key: _,
          class: "smake:size-45 smake:rounded-lg smake:border-2 smake:border-secondary-3"
        }))), 128))
      ]);
    };
  }
}), i4 = { class: "smake:absolute smake:inset-x-5 smake:top-1/2 smake:mx-auto smake:flex smake:h-fit smake:max-h-full smake:max-w-150 smake:-translate-y-1/2 smake:flex-col smake:gap-4 smake:overflow-y-auto smake:rounded-3xl smake:bg-white smake:p-4" }, r4 = { class: "smake:flex smake:items-start smake:justify-between smake:gap-2" }, l4 = { class: "smake:flex smake:grow smake:gap-20 smake:text-[14px] smake:tracking-wider" }, c4 = { class: "smake:flex smake:justify-center smake:gap-5" }, u4 = /* @__PURE__ */ J({
  __name: "UploadConfirmationDialog",
  props: {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  },
  emits: /* @__PURE__ */ Ae(["closed", "resolve"], ["update:open"]),
  setup(t, { emit: e }) {
    const n = Ne(t, "open"), s = e, { dialogsRoot: o } = D(nn());
    return (a, i) => ($(), q(l(Ct), {
      open: n.value,
      "onUpdate:open": i[5] || (i[5] = (r) => n.value = r)
    }, {
      default: C(() => [
        b(l(Pt), { to: l(o) }, {
          default: C(() => [
            b(De, {
              appear: "",
              "enter-active-class": "smake:duration-300 smake:ease-out",
              "enter-from-class": "smake:opacity-0",
              "leave-active-class": "smake:duration-200 smake:ease-in",
              "leave-to-class": "smake:opacity-0",
              onAfterLeave: i[0] || (i[0] = (r) => s("closed"))
            }, {
              default: C(() => [
                b(l(Mt), { class: "smake:fixed smake:inset-0 smake:bg-black/40" })
              ]),
              _: 1
            }),
            b(De, {
              appear: "",
              "enter-active-class": "smake:duration-300 smake:ease-out",
              "enter-from-class": "smake:scale-95 smake:opacity-0",
              "leave-active-class": "smake:duration-200 smake:ease-in",
              "leave-to-class": "smake:scale-95 smake:opacity-0"
            }, {
              default: C(() => [
                b(l(Tt), {
                  "as-child": "",
                  onInteractOutside: i[3] || (i[3] = (r) => s("resolve", !1)),
                  onEscapeKeyDown: i[4] || (i[4] = (r) => s("resolve", !1))
                }, {
                  default: C(() => [
                    x("div", i4, [
                      x("div", r4, [
                        b(l(At), { class: "smake:text-2xl smake:font-bold smake:uppercase" }, {
                          default: C(() => [
                            he(L(a.$t("confirmation")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      i[6] || (i[6] = x("hr", { class: "smake:hidden smake:border smake:border-secondary-2 smake:@sm:block" }, null, -1)),
                      x("div", l4, L(a.$t("confirmation_description")), 1),
                      x("div", c4, [
                        b(et, {
                          type: "secondary",
                          text: a.$t("abort"),
                          onClick: i[1] || (i[1] = (r) => {
                            s("resolve", !1), n.value = !1;
                          })
                        }, null, 8, ["text"]),
                        b(et, {
                          type: "primary",
                          text: a.$t("confirm"),
                          onClick: i[2] || (i[2] = (r) => {
                            s("resolve", !0), n.value = !1;
                          })
                        }, null, 8, ["text"])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _: 1
    }, 8, ["open"]));
  }
}), d4 = {}, p4 = {
  id: "Ebene_2",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25.83 21.09"
};
function m4(t, e) {
  return $(), I("svg", p4, [...e[0] || (e[0] = [
    x("g", { id: "Ebene_1-2" }, [
      x("path", {
        fill: "currentColor",
        d: "M22.97,0H2.86C1.28,0,0,1.28,0,2.86v15.36c0,1.58,1.28,2.86,2.86,2.86h20.11c1.58,0,2.86-1.28,2.86-2.86V2.86c0-1.58-1.28-2.86-2.86-2.86ZM2.86,1.8h20.11c.59,0,1.06.48,1.06,1.06v10.79l-5.9-5.9c-.31-.31-.82-.31-1.13,0l-6.06,6.06-2.63-2.63c-.15-.15-.35-.23-.57-.23h0c-.21,0-.42.09-.57.24l-5.37,5.51V2.86c0-.59.48-1.06,1.06-1.06ZM22.97,19.29H2.86c-.38,0-.69-.21-.88-.5l5.77-5.91,2.62,2.62c.31.31.82.31,1.13,0l6.06-6.06,6.47,6.47v2.31c0,.59-.48,1.06-1.06,1.06Z"
      }),
      x("path", {
        fill: "currentColor",
        d: "M6.35,9.3c1.53,0,2.78-1.25,2.78-2.78s-1.25-2.78-2.78-2.78-2.78,1.25-2.78,2.78,1.25,2.78,2.78,2.78ZM6.35,5.35c.65,0,1.18.53,1.18,1.18s-.53,1.18-1.18,1.18-1.18-.53-1.18-1.18.53-1.18,1.18-1.18Z"
      })
    ], -1)
  ])]);
}
const h4 = /* @__PURE__ */ bs(d4, [["render", m4]]), f4 = {}, _4 = {
  id: "Ebene_2",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25.83 21.09"
};
function v4(t, e) {
  return $(), I("svg", _4, [...e[0] || (e[0] = [
    x("g", { id: "Ebene_1-2" }, [
      x("path", {
        fill: "currentColor",
        d: "M22.97,0H2.86C1.28,0,0,1.28,0,2.86v15.36c0,1.58,1.28,2.86,2.86,2.86h20.11c1.58,0,2.86-1.28,2.86-2.86V2.86c0-1.58-1.28-2.86-2.86-2.86ZM24.03,18.23c0,.59-.48,1.06-1.06,1.06H2.86c-.59,0-1.06-.48-1.06-1.06V2.86c0-.59.48-1.06,1.06-1.06h20.11c.59,0,1.06.48,1.06,1.06v15.36Z"
      }),
      x("path", {
        fill: "currentColor",
        d: "M17.66,5h-4.04c-.44,0-.8.36-.8.8s.36.8.8.8h2.11l-6.76,6.76v-2.11c0-.44-.36-.8-.8-.8s-.8.36-.8.8v4.04c0,.08.02.15.04.22,0,.03,0,.05.02.08.08.2.24.36.44.44.02,0,.04,0,.06.01.08.02.16.05.24.05h4.04c.44,0,.8-.36.8-.8s-.36-.8-.8-.8h-2.11l6.76-6.76v2.11c0,.44.36.8.8.8s.8-.36.8-.8v-4.04c0-.44-.36-.8-.8-.8Z"
      })
    ], -1)
  ])]);
}
const g4 = /* @__PURE__ */ bs(f4, [["render", v4]]), k4 = { class: "smake:flex smake:grow smake:flex-wrap smake:gap-4 smake:text-sm smake:font-semibold smake:@md:gap-8.75" }, y4 = {
  key: 0,
  class: "smake:flex smake:grow smake:items-center smake:gap-2"
}, b4 = { class: "smake:flex smake:size-12 smake:items-center smake:justify-center smake:rounded-full smake:border smake:border-secondary-2 smake:p-0.5" }, w4 = {
  key: 1,
  class: "smake:flex smake:grow smake:items-center smake:gap-2"
}, x4 = { class: "smake:flex smake:size-12 smake:items-center smake:justify-center smake:rounded-full smake:border smake:border-secondary-2 smake:p-0.5" }, $4 = /* @__PURE__ */ J({
  __name: "ValidationRules",
  props: {
    productionMethodId: {}
  },
  setup(t) {
    const e = t, { productionMethodId: n } = we(e), { allowedExtensions: s, maxFileSizeMb: o } = It(n);
    return (a, i) => ($(), I("div", k4, [
      l(o) ? ($(), I("div", y4, [
        x("div", b4, [
          b(g4, { class: "smake:size-5" })
        ]),
        x("div", null, L(a.$t("max_file_size")) + " " + L(l(o)) + " MB", 1)
      ])) : Q("", !0),
      l(s) ? ($(), I("div", w4, [
        x("div", x4, [
          b(h4, { class: "smake:size-5" })
        ]),
        x("div", null, [
          x("div", null, L(a.$t("supported_file_types")) + ":", 1),
          x("div", null, L(l(s).join(", ")), 1)
        ])
      ])) : Q("", !0)
    ]));
  }
}), z4 = { class: "smake:absolute smake:inset-x-0 smake:mx-auto smake:flex smake:max-h-[calc(100%-64px)] smake:max-w-320 smake:flex-col smake:gap-4 smake:overflow-y-auto smake:rounded-3xl smake:bg-white smake:p-6 smake:@max-md:bottom-0 smake:@max-md:rounded-b-none smake:@md:top-1/2 smake:@md:mt-4.5 smake:@md:max-h-[calc(100%-18px)] smake:@md:-translate-y-1/2" }, S4 = { class: "smake:flex smake:items-start smake:justify-between smake:gap-2" }, A4 = { class: "smake:mt-6 smake:flex smake:gap-20" }, C4 = { class: "smake:flex smake:grow smake:flex-col smake:gap-4" }, P4 = { class: "smake:flex smake:w-full smake:flex-wrap smake:items-center smake:justify-between smake:gap-4" }, M4 = ["href"], T4 = { class: "smake:mt-2 smake:flex smake:flex-col smake:justify-center smake:gap-5 smake:@md:flex-row" }, I4 = /* @__PURE__ */ J({
  __name: "FileUploadDialogContent",
  props: /* @__PURE__ */ Ae({
    positioningArea: {},
    positioningAreaDesign: {},
    productionMethodId: {}
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Ae(["resolve", "update:isUploadingCustomerLogo"], ["update:open"]),
  setup(t, { emit: e }) {
    const n = t, { positioningArea: s, positioningAreaDesign: o, productionMethodId: a } = we(n), i = e, { t: r } = ct(), c = Ne(t, "open"), { uploadHelpLink: u } = D(Zs()), { allowedExtensions: d } = It(a), m = N(), _ = A(
      () => m.value && "id" in m.value
    ), { selectedProductionMethodId: g } = D(Je()), v = N(!1), { placeDesign: z } = si();
    function h() {
      i("resolve", !0);
    }
    const { open: y } = pn();
    async function w(K) {
      const te = Il(K.logo);
      c.value = !1, await z(
        {
          design: te,
          productionMethodId: a.value
        },
        {
          mergePostioningAreaDesign: o.value,
          positioningArea: s.value
        }
      ) !== "success" && y(Uo, {
        input: {
          positioningArea: s.value,
          positioningAreaDesign: o.value,
          productionMethodId: a.value
        }
      }), h();
    }
    const P = Ob(
      A(() => ({
        ERROR_SVG_CONTAINS_IMAGE: r("upload_error_svg_contains_image"),
        ERROR_SVG_CONTAINS_TEXT: r("upload_error_svg_contains_text"),
        ERROR_UNEXPECTED: r("upload_error_unexpected")
      }))
    ), {
      error: M,
      isPending: E,
      mutate: R,
      reset: j
    } = yt({
      ...P,
      mutationFn: (K) => Wf(
        {
          name: "Customer Logo Upload",
          attributes: {
            "file.name": K.file.name,
            "file.size": K.file.size,
            "file.type": K.file.type
          },
          op: "customer-logo-upload"
        },
        async (te) => {
          try {
            const ue = await P.mutationFn(K);
            return te.setAttribute("customer-logo.id", ue.id), ue;
          } catch (ue) {
            throw te.setAttribute("error", String(ue)), ue;
          }
        }
      ),
      onError: () => {
        m.value = void 0;
      },
      onSuccess: (K) => {
        m.value = K;
      }
    });
    re(() => {
      i("update:isUploadingCustomerLogo", E.value);
    });
    const { fieldMessages: V, message: X } = gw(M), Z = N(!1);
    function ae(K) {
      if (!K) {
        m.value = void 0;
        return;
      }
      m.value instanceof File && R({
        file: m.value,
        productionMethodId: a.value
      });
    }
    return re(() => {
      m.value instanceof File && (Z.value = !0);
    }), (K, te) => {
      var Ce;
      const ue = xe("FontAwesomeIcon");
      return $(), I("div", z4, [
        x("div", S4, [
          b(l(At), { class: "smake:text-2xl smake:font-bold smake:uppercase" }, {
            default: C(() => [
              he(L(K.$t("upload_own_file")), 1)
            ]),
            _: 1
          }),
          b(l(zt), {
            class: "smake:-mt-2 smake:-mr-2 smake:rounded-full smake:border smake:border-secondary-2 smake:p-2 smake:duration-150 smake:enabled:hover:bg-secondary-3 smake:disabled:opacity-50",
            disabled: l(E)
          }, {
            default: C(() => [
              b(ue, {
                icon: ["fak", "icon-x"],
                "fixed-width": "",
                class: "smake:size-3"
              })
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        te[5] || (te[5] = x("hr", { class: "smake:border smake:border-secondary-2" }, null, -1)),
        x("div", A4, [
          b(a4, {
            "production-method-id": l(a),
            disabled: l(E),
            onSelected: w
          }, null, 8, ["production-method-id", "disabled"]),
          x("div", C4, [
            x("div", P4, [
              b($4, { "production-method-id": l(a) }, null, 8, ["production-method-id"]),
              x("a", {
                class: "smake:flex smake:items-center smake:justify-center smake:gap-2 smake:rounded-full smake:border-secondary-2 smake:bg-white smake:text-[14px] smake:duration-150 smake:enabled:hover:border-black smake:disabled:opacity-50 smake:@max-md:ml-3.75 smake:@max-md:underline smake:@md:border smake:@md:px-6 smake:@md:py-4",
                type: "outline",
                href: l(u),
                target: "_blank"
              }, [
                b(ue, {
                  class: "smake:h-5",
                  icon: ["fal", "circle-question"]
                }),
                he(" " + L(K.$t("help_for_upload")), 1)
              ], 8, M4)
            ]),
            b(e4, {
              modelValue: m.value,
              "onUpdate:modelValue": te[0] || (te[0] = (ne) => m.value = ne),
              class: "smake:grow",
              accept: (Ce = l(d)) == null ? void 0 : Ce.map((ne) => `.${ne}`),
              errors: {
                message: l(X),
                fieldMessages: l(V)
              },
              disabled: l(E),
              onReset: l(j)
            }, null, 8, ["modelValue", "accept", "errors", "disabled", "onReset"])
          ])
        ]),
        x("div", T4, [
          b(et, {
            type: "secondary",
            disabled: l(E),
            icon: {
              type: ["fak", "icon-ciconfig-archive"]
            },
            text: K.$t("show_own_files"),
            onClick: te[1] || (te[1] = (ne) => v.value = !0)
          }, null, 8, ["disabled", "text"]),
          b(et, {
            type: "primary",
            disabled: !_.value,
            icon: {
              type: ["fal", "check"]
            },
            text: K.$t("place_logo"),
            onClick: te[2] || (te[2] = (ne) => w(m.value))
          }, null, 8, ["disabled", "text"])
        ]),
        l(g) !== void 0 ? ($(), q(Ul, {
          key: 0,
          open: v.value,
          "onUpdate:open": te[3] || (te[3] = (ne) => v.value = ne),
          "initial-production-method-id": l(g),
          "positioning-area": l(s),
          "positioning-area-design": l(o),
          "intial-tab": "customer-logos",
          onResolve: h
        }, null, 8, ["open", "initial-production-method-id", "positioning-area", "positioning-area-design"])) : Q("", !0),
        b(u4, {
          open: Z.value,
          "onUpdate:open": te[4] || (te[4] = (ne) => Z.value = ne),
          onResolve: ae
        }, null, 8, ["open"])
      ]);
    };
  }
}), Uo = /* @__PURE__ */ J({
  __name: "FileUploadDialog",
  props: /* @__PURE__ */ Ae({
    positioningArea: {},
    positioningAreaDesign: {},
    productionMethodId: {}
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Ae(["closed", "resolve"], ["update:open"]),
  setup(t, { emit: e }) {
    const n = e, s = Ne(t, "open"), { dialogsRoot: o } = D(nn()), a = N(!1);
    function i(r) {
      a.value && r.preventDefault();
    }
    return (r, c) => ($(), q(l(Ct), {
      open: s.value,
      "onUpdate:open": c[4] || (c[4] = (u) => s.value = u)
    }, {
      default: C(() => [
        b(l(Pt), { to: l(o) }, {
          default: C(() => [
            b(De, {
              appear: "",
              "enter-active-class": "smake:duration-300 smake:ease-out",
              "enter-from-class": "smake:opacity-0",
              "leave-active-class": "smake:duration-200 smake:ease-in",
              "leave-to-class": "smake:opacity-0",
              onAfterLeave: c[0] || (c[0] = (u) => n("closed"))
            }, {
              default: C(() => [
                b(l(Mt), { class: "smake:fixed smake:inset-0 smake:bg-black/40" })
              ]),
              _: 1
            }),
            b(De, {
              appear: "",
              "enter-active-class": "smake:duration-300 smake:ease-out",
              "enter-from-class": "smake:translate-y-full smake:@sm:translate-y-0 smake:@sm:scale-95 smake:@sm:opacity-0",
              "leave-active-class": "smake:duration-200 smake:ease-in",
              "leave-to-class": "smake:translate-y-full smake:@sm:translate-y-0 smake:@sm:scale-95 smake:@sm:opacity-0"
            }, {
              default: C(() => [
                b(l(Tt), {
                  "as-child": "",
                  onInteractOutside: i,
                  onEscapeKeyDown: i
                }, {
                  default: C(() => [
                    b(I4, {
                      open: s.value,
                      "onUpdate:open": c[1] || (c[1] = (u) => s.value = u),
                      "positioning-area": r.positioningArea,
                      "positioning-area-design": r.positioningAreaDesign,
                      "production-method-id": r.productionMethodId,
                      onResolve: c[2] || (c[2] = (u) => n("resolve", u)),
                      "onUpdate:isUploadingCustomerLogo": c[3] || (c[3] = (u) => a.value = u)
                    }, null, 8, ["open", "positioning-area", "positioning-area-design", "production-method-id"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _: 1
    }, 8, ["open"]));
  }
}), E4 = /* @__PURE__ */ J({
  __name: "FileUploadButton",
  props: {
    positioningArea: {},
    positioningAreaDesign: {}
  },
  setup(t) {
    const { selectedProductionMethodId: e } = D(Je()), { isCustomerLogoUploadEnabled: n } = It(
      e
    ), s = N(!1);
    return (o, a) => ($(), q(l(ma), {
      name: l(Rt).CUSTOMER_LOGO_UPLOAD
    }, {
      default: C(() => [
        l(n) ? ($(), I(me, { key: 0 }, [
          b(ha, {
            icon: ["fal", "arrow-up-from-bracket"],
            text: o.$t("upload_file"),
            primary: "",
            "data-testid": "CustomerLogoUploadButton",
            onClick: a[0] || (a[0] = (i) => s.value = !0)
          }, null, 8, ["text"]),
          l(e) ? ($(), q(Uo, {
            key: 0,
            open: s.value,
            "onUpdate:open": a[1] || (a[1] = (i) => s.value = i),
            "production-method-id": l(e),
            "positioning-area": o.positioningArea,
            "positioning-area-design": o.positioningAreaDesign
          }, null, 8, ["open", "production-method-id", "positioning-area", "positioning-area-design"])) : Q("", !0)
        ], 64)) : Q("", !0)
      ]),
      _: 1
    }, 8, ["name"]));
  }
}), Ks = {
  cm: 10,
  in: 25.4,
  mm: 1
};
function Ts(t, e, n = []) {
  for (const s of t)
    if (e(s, n) || Ts(s.children, e, [...n, s]))
      return !0;
  return !1;
}
function Ku(t) {
  const e = [];
  return Ts(t, (n) => {
    e.push(...n.logos);
  }), new Set(e).size;
}
function zm(t, e = null) {
  const n = [];
  for (const s of t)
    s.parent_id === e && n.push({
      ...s,
      children: zm(t, s.id)
    });
  return n.sort((s, o) => s.left - o.left), n;
}
const ws = st("logos", () => {
  const { selectedProductionMethodId: t } = D(
    Je()
  ), e = N(), { animateHeight: n } = jp(e), s = N(!1), o = A({
    get: () => s.value,
    set: (j) => {
      j !== s.value && n(
        () => s.value = !s.value
      );
    }
  }), a = N([]), i = N(), r = N(t.value);
  re(() => {
    r.value === void 0 && (r.value = t.value);
  }), it(r, () => {
    a.value = [];
  });
  const c = N();
  pf(
    i,
    () => {
      var j;
      c.value = ((j = i.value) == null ? void 0 : j.trim()) ?? void 0;
    },
    {
      debounce: 300,
      maxWait: 700
    }
  );
  const u = ce.logos.categories.list.use(
    A(() => ({
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      production_method: [r.value]
    }))
  ), { data: d } = bt({
    ...u,
    enabled: A(
      () => u.enabled.value && r.value !== void 0
    ),
    retry: !1,
    staleTime: 1 / 0
  }), m = A(
    () => zm(d.value ?? [])
  ), _ = A(() => {
    const j = [];
    return Ts(m.value, (V) => {
      a.value.includes(V.id) && j.push(V);
    }), j;
  }), g = A(
    () => ({
      "categories.id": a.value,
      name_or_tags: c.value,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      production_method: [r.value]
    })
  ), { data: v, fetchStatus: z } = bt({
    ...ce.logos.count.use(g),
    retry: !1,
    staleTime: 1 / 0
  }), {
    data: h,
    fetchNextPage: y,
    fetchStatus: w,
    hasNextPage: P,
    status: M
  } = js({
    ...ce.logos.list.use(g),
    retry: !1,
    select: (j) => j.pages.flatMap((V) => V.data),
    staleTime: 1 / 0
  });
  function E() {
    a.value = [], i.value = void 0, r.value = t.value;
  }
  function R(j) {
    if (a.value.includes(j.id)) {
      a.value = a.value.filter(
        (Z) => Z !== j.id
      );
      return;
    }
    let V = [];
    Ts(m.value, (Z, ae) => Z.id === j.id ? (V = ae.map((K) => K.id), !0) : !1);
    const X = [];
    Ts(j.children, (Z) => {
      X.push(Z.id);
    }), a.value = a.value.filter(
      (Z) => !V.includes(Z) && !X.includes(Z)
    ), a.value.push(j.id), a.value.sort();
  }
  return {
    activeCategories: _,
    activeCategoryIds: a,
    activeProductionMethodId: r,
    categoriesTree: m,
    count: v,
    fetchNextPage: y,
    fetchStatus: w,
    fetchStatusCount: z,
    hasNextPage: P,
    logos: h,
    mobileSearchElement: e,
    mobileSearchOpen: o,
    normalizedSearchQuery: Tn(c),
    resetFilters: E,
    searchQuery: i,
    status: M,
    toggleCategory: R
  };
}), O4 = {
  key: 0,
  class: "smake:absolute smake:top-0 smake:right-0 smake:translate-x-1/4 smake:-translate-y-1/4 smake:rounded-full smake:border-2 smake:border-white smake:bg-black smake:px-1.5"
}, R4 = { class: "smake:grid smake:grid-cols-2 smake:gap-x-4 smake:gap-y-2 smake:p-6" }, L4 = { class: "smake:text-secondary-1" }, Sm = /* @__PURE__ */ J({
  __name: "Button",
  props: {
    data: {},
    depth: { default: 0 }
  },
  setup(t) {
    const e = t, { data: n } = we(e), s = ws(), { activeCategoryIds: o } = D(s), { rootElement: a } = D(jt()), i = A(
      () => o.value.includes(n.value.id)
    ), r = A(() => {
      const d = [];
      return Ts(n.value.children, (m) => {
        o.value.includes(m.id) && d.push(m);
      }), d;
    }), c = A(() => {
      const d = [...r.value];
      return i.value && d.push(n.value), d;
    });
    function u() {
      c.value.length > 0 || s.toggleCategory(n.value);
    }
    return (d, m) => {
      const _ = xe("FontAwesomeIcon"), g = xe("Button", !0);
      return d.depth === 0 ? ($(), I(me, { key: 0 }, [
        l(n).children.length === 0 ? ($(), q(Re, {
          key: 0,
          type: "outline",
          class: ke(["smake:px-6 smake:py-2.5", {
            "smake:bg-black smake:text-white smake:hover:bg-black/80": i.value
          }]),
          onClick: m[0] || (m[0] = (v) => l(s).toggleCategory(l(n)))
        }, {
          default: C(() => [
            he(L(l(n).name), 1)
          ]),
          _: 1
        }, 8, ["class"])) : ($(), q(l(Md), { key: 1 }, {
          default: C(() => [
            b(l(Td), { "as-child": "" }, {
              default: C(() => [
                b(Re, {
                  type: "outline",
                  class: ke(["smake:relative smake:px-6 smake:py-2.5", {
                    "smake:bg-black smake:text-white smake:hover:bg-black/80": c.value.length > 0
                  }])
                }, {
                  default: C(() => [
                    he(L(l(n).name) + " ", 1),
                    b(_, {
                      icon: ["fal", "chevron-down"],
                      class: "smake:size-4"
                    }),
                    r.value.length > 0 ? ($(), I("div", O4, L(r.value.length), 1)) : Q("", !0)
                  ]),
                  _: 1
                }, 8, ["class"])
              ]),
              _: 1
            }),
            b(l(Id), { to: l(a) }, {
              default: C(() => [
                b(l(Ed), {
                  class: "smake:flex smake:flex-col smake:rounded smake:bg-white smake:text-sm smake:shadow-[0px_0px_15px_0px_rgba(0,0,0,0.25)]",
                  align: "start",
                  "side-offset": 8
                }, {
                  default: C(() => [
                    x("div", R4, [
                      ($(!0), I(me, null, Se(l(n).children, (v) => ($(), q(g, {
                        key: v.id,
                        data: v,
                        depth: d.depth + 1
                      }, null, 8, ["data", "depth"]))), 128))
                    ]),
                    b(l(Od), { "as-child": "" }, {
                      default: C(() => [
                        b(Re, {
                          type: "primary",
                          class: "smake:rounded-none smake:text-sm",
                          onClick: u
                        }, {
                          default: C(() => [
                            he(L(d.$t("show_X_results", {
                              count: l(Ku)(
                                c.value.length === 0 ? [l(n)] : c.value
                              )
                            })), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _: 1
        }))
      ], 64)) : ($(), q(Re, {
        key: 1,
        type: "outline",
        class: ke(["smake:px-4 smake:py-1.5 smake:text-sm", {
          "smake:bg-black smake:text-white smake:hover:bg-black/80": i.value
        }]),
        onClick: m[1] || (m[1] = (v) => l(s).toggleCategory(l(n)))
      }, {
        default: C(() => [
          he(L(l(n).name) + " ", 1),
          x("span", L4, L(l(Ku)([l(n)])), 1)
        ]),
        _: 1
      }, 8, ["class"]));
    };
  }
}), D4 = { class: "smake:absolute smake:inset-0 smake:top-16 smake:flex smake:flex-col smake:gap-4 smake:rounded-3xl smake:rounded-b-none smake:bg-white smake:p-4" }, j4 = { class: "smake:flex smake:justify-end" }, N4 = { class: "smake:font-bold" }, V4 = { class: "smake:flex smake:flex-col smake:gap-2 smake:pb-2" }, U4 = { class: "smake:flex smake:shrink-0 smake:gap-2 smake:overflow-x-auto" }, F4 = ["onClick"], B4 = { class: "smake:rounded-full smake:bg-white smake:p-1 smake:text-black" }, q4 = { class: "smake:flex smake:gap-2" }, H4 = /* @__PURE__ */ J({
  __name: "Dialog",
  setup(t) {
    const { rootElement: e } = D(jt()), n = ws(), { activeCategories: s, activeCategoryIds: o, categoriesTree: a, count: i } = D(n), r = mf("(width >= 640px)"), c = N(!1);
    return re(() => {
      r.value && (c.value = !1);
    }), (u, d) => {
      const m = xe("FontAwesomeIcon");
      return l(a).length > 0 ? ($(), q(l(Ct), {
        key: 0,
        open: c.value,
        "onUpdate:open": d[2] || (d[2] = (_) => c.value = _)
      }, {
        default: C(() => [
          b(l(yd), { "as-child": "" }, {
            default: C(() => [
              b(Re, { type: "outline" }, {
                default: C(() => [
                  b(m, {
                    icon: ["fal", "sliders"],
                    class: "smake:h-5.5"
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          b(l(Pt), { to: l(e) }, {
            default: C(() => [
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:opacity-0"
              }, {
                default: C(() => [
                  b(l(Mt), { class: "smake:fixed smake:inset-0 smake:bg-black/40 smake:@sm:hidden" })
                ]),
                _: 1
              }),
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:translate-y-full",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:translate-y-full"
              }, {
                default: C(() => [
                  b(l(Tt), { "as-child": "" }, {
                    default: C(() => [
                      x("div", D4, [
                        x("div", j4, [
                          b(l(a_), { "as-child": "" }, {
                            default: C(() => [
                              b(l(At), null, {
                                default: C(() => [...d[3] || (d[3] = [
                                  he(" Filter ", -1)
                                ])]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          b(l(zt), { class: "smake:-mt-2 smake:-mr-2 smake:rounded-full smake:border smake:border-secondary-2 smake:p-2 smake:duration-150 smake:hover:bg-secondary-3" }, {
                            default: C(() => [
                              b(m, {
                                icon: ["fak", "icon-x"],
                                "fixed-width": "",
                                class: "smake:size-3"
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        b(l(i_), {
                          type: "single",
                          collapsible: "",
                          class: "smake:divide-y smake:divide-secondary-2 smake:overflow-y-auto smake:border-y smake:border-secondary-2"
                        }, {
                          default: C(() => [
                            ($(!0), I(me, null, Se(l(a).filter(
                              ({ children: _ }) => _.length > 0
                            ), (_) => ($(), q(l(r_), {
                              key: _.id,
                              value: _.id.toString()
                            }, {
                              default: C(() => [
                                b(l(l_), { class: "smake:flex" }, {
                                  default: C(() => [
                                    b(l(c_), { class: "smake:group smake:flex smake:flex-1 smake:justify-between smake:gap-2 smake:overflow-hidden smake:py-2" }, {
                                      default: C(() => [
                                        x("span", N4, L(_.name), 1),
                                        b(m, {
                                          icon: ["fal", "chevron-down"],
                                          class: "smake:h-4.5 smake:duration-250 smake:group-data-[state=open]:rotate-180"
                                        })
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024),
                                b(l(u_), { class: "smake:overflow-hidden smake:data-[state=closed]:animate-collapsibleClosed smake:data-[state=open]:animate-collapsibleOpen" }, {
                                  default: C(() => [
                                    x("div", V4, [
                                      ($(!0), I(me, null, Se(_.children, (g) => ($(), q(Sm, {
                                        key: g.id,
                                        data: g,
                                        depth: 1
                                      }, {
                                        default: C(() => [
                                          he(L(g.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["data"]))), 128))
                                    ])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["value"]))), 128))
                          ]),
                          _: 1
                        }),
                        d[5] || (d[5] = x("div", { class: "smake:-mt-4 smake:grow" }, null, -1)),
                        l(s).length > 0 ? ($(), I(me, { key: 0 }, [
                          x("div", U4, [
                            ($(!0), I(me, null, Se(l(s), (_) => ($(), I("button", {
                              key: _.id,
                              type: "button",
                              class: "smake:flex smake:shrink-0 smake:items-center smake:gap-2 smake:rounded-full smake:bg-black smake:p-1.5 smake:pl-3 smake:text-white",
                              onClick: (g) => l(n).toggleCategory(_)
                            }, [
                              he(L(_.name) + " ", 1),
                              x("div", B4, [
                                b(m, {
                                  icon: ["fak", "icon-x"],
                                  "fixed-width": "",
                                  class: "smake:size-3"
                                })
                              ])
                            ], 8, F4))), 128))
                          ]),
                          d[4] || (d[4] = x("hr", { class: "smake:border smake:border-secondary-2" }, null, -1))
                        ], 64)) : Q("", !0),
                        x("div", q4, [
                          l(s).length > 0 ? ($(), q(Re, {
                            key: 0,
                            type: "outline",
                            class: "smake:flex-1",
                            onClick: d[0] || (d[0] = (_) => o.value = [])
                          }, {
                            default: C(() => [
                              he(L(u.$t("clear_filters")), 1)
                            ]),
                            _: 1
                          })) : Q("", !0),
                          b(Re, {
                            type: "primary",
                            class: "smake:flex-1",
                            onClick: d[1] || (d[1] = (_) => c.value = !1)
                          }, {
                            default: C(() => [
                              he(L(u.$t("show_X_results", { count: l(i) })), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _: 1
      }, 8, ["open"])) : Q("", !0);
    };
  }
}), W4 = { class: "smake:hidden smake:@sm:contents" }, G4 = { class: "smake:contents smake:@sm:hidden" }, Z4 = /* @__PURE__ */ J({
  __name: "Categories",
  setup(t) {
    const { activeCategoryIds: e, categoriesTree: n } = D(ws());
    return (s, o) => {
      const a = xe("FontAwesomeIcon");
      return $(), I(me, null, [
        x("div", W4, [
          ($(!0), I(me, null, Se(l(n), (i) => ($(), q(Sm, {
            key: i.id,
            data: i
          }, null, 8, ["data"]))), 128)),
          l(e).length > 0 ? ($(), I(me, { key: 0 }, [
            o[1] || (o[1] = x("div", { class: "smake:h-11.5 smake:border smake:border-secondary-2" }, null, -1)),
            b(Re, {
              type: "outline",
              class: "smake:p-1 smake:pl-3",
              onClick: o[0] || (o[0] = (i) => e.value = [])
            }, {
              default: C(() => [
                he(L(s.$t("clear_filters")) + " ", 1),
                b(a, {
                  icon: ["fak", "icon-x"],
                  "fixed-width": "",
                  class: "smake:size-7 smake:rounded-full smake:bg-black smake:p-1.5 smake:text-white"
                })
              ]),
              _: 1
            })
          ], 64)) : Q("", !0)
        ]),
        x("div", G4, [
          b(H4)
        ])
      ], 64);
    };
  }
}), K4 = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3c!--%20Generator:%20$$$/GeneralStr/196=Adobe%20Illustrator%2027.6.0,%20SVG%20Export%20Plug-In%20.%20SVG%20Version:%206.00%20Build%200)%20--%3e%3csvg%20version='1.1'%20id='Ebene_1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20x='0px'%20y='0px'%20viewBox='0%200%2016%2016'%20style='enable-background:new%200%200%2016%2016;'%20xml:space='preserve'%3e%3cstyle%20type='text/css'%3e%20.st0{fill:%230F922E;}%20.st1{fill:%23FFCC00;}%20.st2{fill:%231E4583;}%20.st3{fill:%23E30613;}%20%3c/style%3e%3cg%20id='Gruppe_2314'%20transform='translate(-53%20-287.998)'%3e%3cpath%20id='Differenzmenge_8'%20class='st0'%20d='M61,304L61,304v-4c2.21,0,4-1.79,4-4h4C69,300.42,65.42,304,61,304z'/%3e%3cpath%20id='Differenzmenge_7'%20class='st1'%20d='M69,296h-4c0-2.21-1.79-4-4-4v-4C65.42,288.01,68.99,291.58,69,296z'/%3e%3cpath%20id='Differenzmenge_6'%20class='st2'%20d='M57,296h-4c0.01-4.42,3.58-7.99,8-8v4C58.79,292,57,293.79,57,296z'/%3e%3cpath%20id='Differenzmenge_5'%20class='st3'%20d='M61,304L61,304c-4.42,0-8-3.58-8-8h4c0,2.21,1.79,4,4,4V304z'/%3e%3c/g%3e%3c/svg%3e", X4 = { class: "smake:flex smake:h-full smake:flex-col smake:overflow-clip smake:rounded-3xl smake:border smake:border-secondary-2" }, Q4 = { class: "smake:flex smake:grow smake:flex-col smake:items-center smake:gap-1 smake:p-3 smake:text-center" }, J4 = { class: "smake:text-xs smake:font-bold" }, Y4 = { class: "smake:text-xs" }, e8 = { class: "smake:flex smake:items-center smake:gap-1 smake:text-xs" }, t8 = /* @__PURE__ */ J({
  __name: "Logo",
  props: {
    data: {}
  },
  emits: ["select"],
  setup(t, { emit: e }) {
    const n = t, { data: s } = we(n), o = e, { decimalFormat: a } = Xa(), { locale: i } = ct();
    function r(_) {
      if (_ !== void 0)
        return a(_, i.value, 2);
    }
    const { appConfiguration: c, designerConfiguration: u } = D(
      tt()
    ), d = A(
      () => {
        var _;
        return (_ = u.value) == null ? void 0 : _.settings.settings.units;
      }
    ), m = A(() => {
      var g;
      const _ = (g = c.value) == null ? void 0 : g.productionMethods.find(
        ({ id: v }) => v === s.value.production_method.id
      );
      if (_)
        return jl[_.handle];
    });
    return (_, g) => {
      var z;
      const v = xe("FontAwesomeIcon");
      return $(), I("div", X4, [
        x("div", {
          class: "smake:relative smake:cursor-pointer smake:bg-secondary-3 smake:p-6",
          onClick: g[0] || (g[0] = (h) => o("select"))
        }, [
          m.value ? ($(), q(v, {
            key: 0,
            icon: m.value,
            "fixed-width": "",
            class: "smake:absolute smake:top-3 smake:left-3 smake:h-4"
          }, null, 8, ["icon"])) : Q("", !0),
          b(on, {
            src: l(s).preview_url ?? void 0,
            class: "smake:aspect-square smake:w-full smake:object-contain smake:data-[state=pending]:animate-pulse smake:data-[state=pending]:bg-secondary-2"
          }, null, 8, ["src"])
        ]),
        x("div", Q4, [
          x("span", J4, L(l(s).name), 1),
          g[3] || (g[3] = x("div", { class: "smake:-mt-1 smake:grow" }, null, -1)),
          x("span", Y4, L(r(l(s).width ?? void 0)) + " x " + L(r(l(s).height ?? void 0)) + " " + L((z = d.value) == null ? void 0 : z.length), 1),
          x("div", e8, [
            g[2] || (g[2] = x("img", {
              src: K4,
              class: "smake:h-4"
            }, null, -1)),
            he(" " + L(_.$t(
              l(s).color_assignments.length === 1 ? "mono_colored" : "multi_colored"
            )), 1)
          ]),
          b(Re, {
            "data-testid": "Select",
            type: "secondary",
            class: "smake:mt-2 smake:w-full",
            onClick: g[1] || (g[1] = (h) => o("select"))
          }, {
            default: C(() => [
              b(v, {
                icon: ["fal", "plus"],
                class: "smake:h-4"
              }),
              he(" " + L(_.$t("choose")), 1)
            ]),
            _: 1
          })
        ])
      ]);
    };
  }
}), n8 = { class: "smake:mt-4 smake:flex smake:items-center smake:gap-2 smake:border-y smake:border-secondary-2 smake:pr-2 smake:duration-150 smake:focus-within:border-black" }, s8 = ["placeholder"], o8 = /* @__PURE__ */ J({
  __name: "MobileSearch",
  setup(t) {
    const { mobileSearchElement: e, mobileSearchOpen: n, searchQuery: s } = D(ws());
    return (o, a) => {
      const i = xe("FontAwesomeIcon");
      return $(), I("div", {
        ref_key: "mobileSearchElement",
        ref: e,
        class: ke(["smake:-mt-4 smake:shrink-0 smake:overflow-hidden smake:duration-150 smake:@sm:hidden", { "smake:h-0": !l(n) }])
      }, [
        x("div", n8, [
          mt(x("input", {
            "onUpdate:modelValue": a[0] || (a[0] = (r) => Lt(s) ? s.value = r : null),
            type: "text",
            placeholder: o.$t("search_logo"),
            class: "smake:grow smake:py-2.5 smake:pl-2 smake:outline-hidden"
          }, null, 8, s8), [
            [vn, l(s)]
          ]),
          b(i, {
            icon: ["fal", "magnifying-glass"],
            class: "smake:h-4"
          })
        ])
      ], 2);
    };
  }
}), a8 = { class: "smake:hidden smake:shrink-0 smake:items-center smake:gap-2 smake:overflow-hidden smake:rounded-xl smake:border smake:border-secondary-2 smake:pr-2 smake:duration-150 smake:focus-within:border-black smake:@sm:flex" }, i8 = ["placeholder"], r8 = /* @__PURE__ */ J({
  __name: "Search",
  setup(t) {
    const { mobileSearchOpen: e, searchQuery: n } = D(ws());
    return (s, o) => {
      const a = xe("FontAwesomeIcon");
      return $(), I(me, null, [
        x("div", a8, [
          mt(x("input", {
            "onUpdate:modelValue": o[0] || (o[0] = (i) => Lt(n) ? n.value = i : null),
            type: "text",
            placeholder: s.$t("search_logo"),
            class: "smake:w-40 smake:py-2.5 smake:pl-2 smake:outline-hidden"
          }, null, 8, i8), [
            [vn, l(n)]
          ]),
          b(a, {
            icon: ["fal", "magnifying-glass"],
            class: "smake:h-4"
          })
        ]),
        b(Re, {
          type: "outline",
          class: ke(["smake:@sm:hidden", {
            "smake:border-black smake:bg-black smake:text-white smake:hover:opacity-60": l(e)
          }]),
          onClick: o[1] || (o[1] = (i) => e.value = !l(e))
        }, {
          default: C(() => [
            b(a, {
              icon: ["fal", "magnifying-glass"],
              class: "smake:h-5.5"
            })
          ]),
          _: 1
        }, 8, ["class"])
      ], 64);
    };
  }
}), l8 = {
  "data-testid": "LogoSelection",
  class: "smake:absolute smake:inset-0 smake:top-16 smake:mx-auto smake:flex smake:w-320 smake:max-w-full smake:flex-col smake:gap-4 smake:rounded-3xl smake:rounded-b-none smake:bg-white smake:p-4 smake:@sm:inset-12 smake:@sm:max-w-[calc(100%-96px)] smake:@sm:rounded-b-3xl"
}, c8 = { class: "smake:flex smake:items-start smake:justify-between smake:gap-2" }, u8 = { class: "smake:flex smake:shrink-0 smake:flex-wrap smake:items-center smake:gap-2 smake:pt-1 smake:[overflow-wrap:normal]" }, d8 = { class: "smake:flex smake:grow smake:items-center smake:justify-end smake:gap-2" }, p8 = {
  key: 1,
  class: "smake:hidden smake:font-bold smake:@sm:block"
}, m8 = {
  key: 2,
  class: "smake:h-6 smake:w-16 smake:animate-pulse smake:rounded-full smake:bg-secondary-3"
}, h8 = { class: "smake:grid smake:grid-cols-auto-fill-38 smake:gap-4 smake:overflow-y-auto smake:@sm:grid-cols-auto-fill-45" }, Am = /* @__PURE__ */ J({
  __name: "LogoSelection",
  props: /* @__PURE__ */ Ae({
    initialProductionMethodId: {},
    positioningArea: {},
    positioningAreaDesign: {}
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Ae(["closed", "resolve"], ["update:open"]),
  setup(t, { emit: e }) {
    const n = e, s = Ne(t, "open"), o = t, { initialProductionMethodId: a, positioningArea: i, positioningAreaDesign: r } = we(o), { dialogsRoot: c } = D(nn()), u = ws(), {
      activeProductionMethodId: d,
      count: m,
      fetchStatus: _,
      hasNextPage: g,
      logos: v,
      status: z
    } = D(u);
    d.value = a.value;
    const h = A(() => !r.value);
    re(() => {
      s.value && u.resetFilters();
    });
    function y() {
      return z.value === "pending" ? !0 : g.value;
    }
    async function w() {
      z.value !== "pending" && await u.fetchNextPage();
    }
    const { placeDesign: P } = si();
    async function M(E) {
      if (d.value === void 0) return;
      const R = Il(E);
      await P(
        {
          design: R,
          productionMethodId: d.value
        },
        {
          mergePostioningAreaDesign: r.value,
          positioningArea: i.value
        }
      ) === "success" && (s.value = !1);
    }
    return (E, R) => {
      const j = xe("FontAwesomeIcon");
      return $(), q(l(Ct), {
        open: s.value,
        "onUpdate:open": R[2] || (R[2] = (V) => s.value = V)
      }, {
        default: C(() => [
          b(l(Pt), { to: l(c) }, {
            default: C(() => [
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:opacity-0",
                onAfterLeave: R[0] || (R[0] = (V) => n("closed"))
              }, {
                default: C(() => [
                  b(l(Mt), { class: "smake:fixed smake:inset-0 smake:bg-black/40" })
                ]),
                _: 1
              }),
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:translate-y-full smake:@sm:translate-y-0 smake:@sm:scale-95 smake:@sm:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:translate-y-full smake:@sm:translate-y-0 smake:@sm:scale-95 smake:@sm:opacity-0"
              }, {
                default: C(() => [
                  b(l(Tt), { "as-child": "" }, {
                    default: C(() => [
                      x("div", l8, [
                        x("div", c8, [
                          b(l(At), { class: "smake:text-2xl smake:font-bold smake:uppercase" }, {
                            default: C(() => [
                              he(L(E.$t("icon_database")), 1)
                            ]),
                            _: 1
                          }),
                          b(l(zt), { class: "smake:-mt-2 smake:-mr-2 smake:rounded-full smake:border smake:border-secondary-2 smake:p-2 smake:duration-150 smake:hover:bg-secondary-3" }, {
                            default: C(() => [
                              b(j, {
                                icon: ["fak", "icon-x"],
                                "fixed-width": "",
                                class: "smake:size-3"
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        b(l(d_), { class: "smake:hidden smake:@sm:block" }, {
                          default: C(() => [
                            he(L(E.$t("icon_database_description")), 1)
                          ]),
                          _: 1
                        }),
                        R[3] || (R[3] = x("hr", { class: "smake:hidden smake:border smake:border-secondary-2 smake:@sm:block" }, null, -1)),
                        x("div", u8, [
                          b(Z4),
                          b(r8),
                          x("div", d8, [
                            l(d) ? ($(), q(bm, {
                              key: 0,
                              modelValue: l(d),
                              "onUpdate:modelValue": R[1] || (R[1] = (V) => Lt(d) ? d.value = V : null),
                              disabled: !h.value
                            }, null, 8, ["modelValue", "disabled"])) : Q("", !0),
                            l(m) !== void 0 ? ($(), I("span", p8, L(l(m) ?? 0) + " " + L(E.$t("icon", l(m) ?? 0)), 1)) : ($(), I("span", m8))
                          ])
                        ]),
                        b(o8),
                        mt(($(), I("div", h8, [
                          ($(!0), I(me, null, Se(l(v), (V) => ($(), I("div", {
                            key: V.id
                          }, [
                            b(t8, {
                              "data-testid": `Logo-${V.id}`,
                              data: V,
                              onSelect: (X) => M(V)
                            }, null, 8, ["data-testid", "data", "onSelect"])
                          ]))), 128)),
                          ($(!0), I(me, null, Se(l(_) === "fetching" ? 3 : 0, (V) => ($(), I("div", {
                            key: V,
                            class: "smake:h-80 smake:animate-pulse smake:rounded-3xl smake:bg-secondary-3"
                          }))), 128))
                        ])), [
                          [l($o), [
                            w,
                            { distance: 350, canLoadMore: y }
                          ]]
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _: 1
      }, 8, ["open"]);
    };
  }
}), f8 = { class: "smake:flex smake:flex-col smake:gap-1" }, _8 = { class: "smake:flex smake:justify-between" }, v8 = { class: "smake:text-xs smake:font-semibold smake:uppercase" }, g8 = { class: "smake:overflow-hidden smake:rounded-full smake:border smake:border-secondary-2 smake:px-2 smake:text-xs smake:font-bold smake:duration-150 smake:focus-within:border-black" }, k8 = ["min", "max"], y8 = ["min", "max"], b8 = /* @__PURE__ */ J({
  __name: "OffsetInput",
  props: {
    child: {}
  },
  setup(t) {
    const e = t, { child: n } = we(e), s = La.anchor.offset, { designerConfiguration: o } = D(tt()), a = A(
      () => {
        var d;
        return Ks[((d = o.value) == null ? void 0 : d.settings.settings.units.length) ?? "mm"] ?? 1;
      }
    ), i = A({
      get: () => {
        switch (n.value.anchor[0]) {
          case "b":
            return n.value.offset.y * a.value;
          case "l":
            return -n.value.offset.x * a.value;
          case "r":
            return n.value.offset.x * a.value;
          case "t":
            return -n.value.offset.y * a.value;
          default:
            return 0;
        }
      },
      set: (d) => {
        switch (n.value.anchor[0]) {
          case "b":
            n.value.offset.y = d / a.value;
            break;
          case "l":
            n.value.offset.x = -d / a.value;
            break;
          case "r":
            n.value.offset.x = d / a.value;
            break;
          case "t":
            n.value.offset.y = -d / a.value;
            break;
        }
      }
    }), r = N(), { inputValue: c, onBlur: u } = ai(i, r, {
      max: s.max,
      min: s.min,
      step: 1
    });
    return (d, m) => ($(), I("div", f8, [
      x("div", _8, [
        x("span", v8, L(d.$t("distance_motif_text")), 1),
        x("div", g8, [
          mt(x("input", {
            ref_key: "numberInput",
            ref: r,
            "onUpdate:modelValue": m[0] || (m[0] = (_) => Lt(c) ? c.value = _ : null),
            class: "smake:appearance-textfield smake:w-full smake:text-right smake:outline-hidden",
            type: "number",
            min: l(s).min,
            max: l(s).max,
            step: "1",
            onBlur: m[1] || (m[1] = //@ts-ignore
            (..._) => l(u) && l(u)(..._))
          }, null, 40, k8), [
            [vn, l(c)]
          ])
        ])
      ]),
      mt(x("input", {
        "onUpdate:modelValue": m[2] || (m[2] = (_) => i.value = _),
        class: "smake:my-1.5 smake:h-1 smake:w-full smake:appearance-none smake:rounded-full smake:bg-secondary-3 smake:[&::-webkit-slider-thumb]:h-4 smake:[&::-webkit-slider-thumb]:w-4 smake:[&::-webkit-slider-thumb]:cursor-ew-resize smake:[&::-webkit-slider-thumb]:appearance-none smake:[&::-webkit-slider-thumb]:rounded-full smake:[&::-webkit-slider-thumb]:border-2 smake:[&::-webkit-slider-thumb]:border-solid smake:[&::-webkit-slider-thumb]:border-black smake:[&::-webkit-slider-thumb]:bg-white smake:[&::-webkit-slider-thumb]:duration-150 smake:hover:[&::-webkit-slider-thumb]:bg-secondary-3",
        type: "range",
        min: l(s).min,
        max: l(s).max,
        step: "1"
      }, null, 8, y8), [
        [
          vn,
          i.value,
          void 0,
          { number: !0 }
        ]
      ])
    ]));
  }
}), w8 = { class: "smake:grid smake:grid-cols-[1fr_auto_1fr] smake:items-center smake:gap-x-2 smake:gap-y-1" }, x8 = { class: "smake:text-xs smake:font-semibold smake:uppercase" }, $8 = { class: "smake:text-xs smake:font-semibold smake:uppercase" }, z8 = /* @__PURE__ */ J({
  __name: "SizeInput",
  props: {
    bounds: {},
    disabled: { type: Boolean },
    ratio: {},
    size: {}
  },
  setup(t) {
    const e = t, { bounds: n, ratio: s, size: o } = we(e), a = A({
      get: () => o.value.width,
      set: (r) => {
        o.value.width = r, o.value.height = r / s.value;
      }
    }), i = A({
      get: () => o.value.height,
      set: (r) => {
        o.value.height = r, o.value.width = r * s.value;
      }
    });
    return (r, c) => {
      var d, m, _, g, v, z, h, y;
      const u = xe("FontAwesomeIcon");
      return $(), I("div", w8, [
        x("span", x8, L(r.$t("width_abbreviation")), 1),
        c[2] || (c[2] = x("div", null, null, -1)),
        x("span", $8, L(r.$t("height_abbreviation")), 1),
        b(fo, {
          modelValue: a.value,
          "onUpdate:modelValue": c[0] || (c[0] = (w) => a.value = w),
          min: (m = (d = l(n)) == null ? void 0 : d.min) == null ? void 0 : m.width,
          max: (g = (_ = l(n)) == null ? void 0 : _.max) == null ? void 0 : g.width,
          step: 0.1,
          disabled: r.disabled
        }, null, 8, ["modelValue", "min", "max", "disabled"]),
        b(u, {
          icon: ["fal", "link"],
          class: "smake:size-6 smake:text-secondary-1"
        }),
        b(fo, {
          modelValue: i.value,
          "onUpdate:modelValue": c[1] || (c[1] = (w) => i.value = w),
          min: (z = (v = l(n)) == null ? void 0 : v.min) == null ? void 0 : z.height,
          max: (y = (h = l(n)) == null ? void 0 : h.max) == null ? void 0 : y.height,
          step: 0.1,
          disabled: r.disabled
        }, null, 8, ["modelValue", "min", "max", "disabled"])
      ]);
    };
  }
}), S8 = { class: "smake:flex smake:justify-between" }, A8 = { class: "smake:text-sm smake:font-bold smake:uppercase" }, C8 = {
  class: "smake:grid smake:grid-cols-[auto_1fr_1fr_1fr_auto] smake:place-items-center smake:gap-2",
  style: {
    gridTemplateAreas: '". tl tc tr .""lt preview preview preview rt""lc preview preview preview rc""lb preview preview preview rb"". bl bc br rotate"'
  }
}, P8 = ["value"], M8 = { class: "smake:group smake:size-8 smake:cursor-pointer smake:rounded-md smake:border smake:border-secondary-2 smake:p-1.5 smake:duration-150 smake:peer-checked:border-black smake:peer-checked:bg-black smake:peer-checked:text-white smake:peer-focus-visible:outline-2 smake:peer-focus-visible:outline-blue-700 smake:peer-not-checked:hover:bg-secondary-3 smake:peer-checked:hover:opacity-60" }, T8 = { class: "smake:flex smake:justify-center" }, I8 = { class: "smake:grid smake:w-full smake:grid-cols-2 smake:gap-4" }, E8 = { class: "smake:mt-4 smake:grid smake:grid-cols-2 smake:gap-4" }, O8 = { class: "smake:group-data-[state=open]:hidden" }, R8 = { class: "smake:group-data-[state=closed]:hidden" }, L8 = /* @__PURE__ */ J({
  __name: "LogoComponent",
  props: {
    data: {}
  },
  setup(t) {
    const e = t, { data: n } = we(e), { positioningArea: s, positioningAreaDesign: o } = D(
      dn()
    ), { selectedProductionMethodId: a } = D(Je()), { data: i } = D(sn()), { open: r } = pn(), { designerConfiguration: c } = D(tt()), u = A(
      () => {
        var M;
        return Ks[((M = c.value) == null ? void 0 : M.settings.settings.units.length) ?? "mm"] ?? 1;
      }
    ), d = A(() => {
      if (s.value)
        return i.value.find(
          (M) => (
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            M.positioningAreas.includes(s.value)
          )
        );
    }), { isLight: m } = Gs(s, d), _ = N(), g = No(_, s), { data: v } = bt({
      ...ce.logos.get.use(A(() => n.value.logoId)),
      retry: !1,
      staleTime: 1 / 0
    });
    async function z() {
      var M;
      if (a.value !== void 0 && s.value !== void 0) {
        if ((M = v.value) != null && M.is_customer_logo) {
          await r(Ul, {
            input: {
              initialProductionMethodId: a.value,
              positioningArea: s.value,
              positioningAreaDesign: o.value
            }
          });
          return;
        }
        await r(Am, {
          input: {
            initialProductionMethodId: a.value,
            positioningArea: s.value,
            positioningAreaDesign: o.value
          }
        });
      }
    }
    function h() {
      var M, E;
      if (s.value)
        if (((M = o.value) == null ? void 0 : M.design.type) === ze.ANCHOR) {
          const R = (E = o.value.design.children[0]) == null ? void 0 : E.value;
          if ((R == null ? void 0 : R.type) !== ze.TEXT)
            throw new Error(
              "Expected first child of anchor design to be text design"
            );
          o.value.design = R;
        } else
          s.value.designs = s.value.designs.filter(
            (R) => R !== o.value
          ), o.value = void 0;
    }
    function y() {
      o.value && (o.value.rotation = Ya(
        o.value.rotation + 90
      ));
    }
    function w() {
      var j;
      if (((j = o.value) == null ? void 0 : j.design.type) !== ze.ANCHOR) return;
      const M = o.value.design.children[0], E = Math.max(
        Math.abs(M.offset.x),
        Math.abs(M.offset.y)
      ), R = M.anchor[0];
      M.offset = {
        x: R === "l" ? -E : R === "r" ? E : 0,
        y: R === "t" ? -E : R === "b" ? E : 0
      };
    }
    const P = A(() => v.value ? v.value.is_scaleable : !0);
    return (M, E) => {
      const R = xe("FontAwesomeIcon");
      return $(), q(Nl, { "data-testid": "LogoComponent" }, {
        default: C(() => {
          var j, V, X, Z;
          return [
            x("div", S8, [
              x("h3", A8, L(M.$t("icon")), 1),
              b(Re, {
                type: "secondary",
                onClick: h
              }, {
                default: C(() => [
                  b(R, {
                    class: "smake:size-5",
                    icon: ["fak", "icon-remove"],
                    "fixed-width": ""
                  })
                ]),
                _: 1
              })
            ]),
            x("div", C8, [
              d.value && l(s) ? ($(), q(l(Oo), {
                key: 0,
                class: "smake:aspect-square smake:w-full smake:rounded-md",
                style: { gridArea: "preview" }
              }, {
                default: C(() => [
                  b(l(Do), {
                    data: d.value,
                    "initial-position": l(Vo)(
                      l(s),
                      10 / u.value
                    )
                  }, {
                    default: C(() => [
                      b(l(Ro), {
                        data: l(s),
                        "stroke-color": l(g) ? 16711680 : l(m) ? 4605510 : 14474460
                      }, {
                        default: C(() => [
                          l(o) ? ($(), q(l(Lo), {
                            key: 0,
                            data: l(o),
                            "onUpdate:boundingBox": E[0] || (E[0] = (ae) => _.value = ae)
                          }, null, 8, ["data"])) : Q("", !0)
                        ]),
                        _: 1
                      }, 8, ["data", "stroke-color"])
                    ]),
                    _: 1
                  }, 8, ["data", "initial-position"])
                ]),
                _: 1
              })) : Q("", !0),
              ((j = l(o)) == null ? void 0 : j.design.type) === l(ze).ANCHOR ? ($(!0), I(me, { key: 1 }, Se(l(ks), (ae) => ($(), I("label", {
                key: ae,
                style: Kt({ gridArea: ae })
              }, [
                mt(x("input", {
                  "onUpdate:modelValue": [
                    E[1] || (E[1] = (K) => l(o).design.children[0].anchor = K),
                    w
                  ],
                  class: "smake:peer smake:absolute smake:appearance-none",
                  type: "radio",
                  name: "outerAnchorPoint",
                  value: ae
                }, null, 8, P8), [
                  [
                    po,
                    l(o).design.children[0].anchor
                  ]
                ]),
                x("div", M8, [
                  b(R, {
                    icon: ["fak", "icon-text-alignment"],
                    "fixed-width": "",
                    class: "smake:size-4.5 smake:group-peer-not-checked:hidden"
                  })
                ])
              ], 4))), 128)) : Q("", !0),
              x("button", {
                type: "button",
                class: ke(["smake:z-0 smake:rounded-md smake:bg-secondary-3 smake:p-1.75 smake:duration-150 smake:hover:bg-secondary-2", {
                  "smake:-mt-8 smake:-ml-8": ((V = l(o)) == null ? void 0 : V.design.type) !== l(ze).ANCHOR
                }]),
                style: { gridArea: "rotate" },
                onClick: y
              }, [
                b(R, {
                  icon: ["fal", "rotate-right"],
                  class: "smake:size-4.5"
                })
              ], 2)
            ]),
            x("div", T8, [
              b(Re, {
                type: "secondary",
                class: "smake:px-4 smake:text-sm",
                onClick: z
              }, {
                default: C(() => {
                  var ae;
                  return [
                    he(L(M.$t(
                      (ae = l(v)) != null && ae.is_customer_logo ? "choose_logo" : "choose_icon"
                    )), 1)
                  ];
                }),
                _: 1
              })
            ]),
            ((X = l(o)) == null ? void 0 : X.design.type) === l(ze).ANCHOR ? ($(), q(b8, {
              key: 0,
              child: l(o).design.children[0]
            }, null, 8, ["child"])) : Q("", !0),
            b(l(p_), { class: "smake:flex smake:flex-col smake:items-center smake:gap-4" }, {
              default: C(() => [
                x("div", I8, [
                  ($(!0), I(me, null, Se(l(n).colorAssignments.slice(0, 4), (ae, K) => {
                    var te;
                    return $(), I("div", {
                      key: ae.id,
                      class: "smake:flex smake:flex-col smake:gap-2"
                    }, [
                      he(L(M.$t("color")) + " " + L(K + 1) + " ", 1),
                      b(tl, {
                        modelValue: ae.color,
                        "onUpdate:modelValue": (ue) => ae.color = ue,
                        "show-name": "",
                        disabled: !(((te = l(v)) == null ? void 0 : te.is_editable) ?? !0),
                        "production-method-id": l(a)
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "production-method-id"])
                    ]);
                  }), 128))
                ]),
                l(n).colorAssignments.length > 4 ? ($(), q(l(m_), {
                  key: 0,
                  class: "smake:-mt-4 smake:w-full smake:overflow-hidden smake:data-[state=closed]:animate-collapsibleClosed smake:data-[state=open]:animate-collapsibleOpen"
                }, {
                  default: C(() => [
                    x("div", E8, [
                      ($(!0), I(me, null, Se(l(n).colorAssignments.slice(4), (ae, K) => {
                        var te;
                        return $(), I("div", {
                          key: ae.id,
                          class: "smake:flex smake:flex-col smake:gap-2"
                        }, [
                          he(L(M.$t("color")) + " " + L(K + 5) + " ", 1),
                          b(tl, {
                            modelValue: ae.color,
                            "onUpdate:modelValue": (ue) => ae.color = ue,
                            "show-name": "",
                            disabled: !(((te = l(v)) == null ? void 0 : te.is_editable) ?? !0),
                            "production-method-id": l(a)
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "production-method-id"])
                        ]);
                      }), 128))
                    ])
                  ]),
                  _: 1
                })) : Q("", !0),
                l(n).colorAssignments.length > 4 ? ($(), q(l(h_), {
                  key: 1,
                  "as-child": ""
                }, {
                  default: C(() => [
                    b(Re, {
                      type: "secondary",
                      class: "smake:group smake:px-4"
                    }, {
                      default: C(() => [
                        x("span", O8, L(M.$t("more_colors")), 1),
                        x("span", R8, L(M.$t("fewer_colors")), 1),
                        b(R, {
                          icon: ["fal", "chevron-down"],
                          class: "smake:h-4.5 smake:duration-250 smake:group-data-[state=open]:rotate-180"
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })) : Q("", !0)
              ]),
              _: 1
            }),
            l(n).size ? ($(), q(z8, {
              key: 1,
              size: l(n).size,
              disabled: !P.value,
              ratio: (Z = l(v)) != null && Z.width && l(v).height ? l(v).width / l(v).height : l(n).size.width / l(n).size.height,
              bounds: l(v) ? {
                min: l(v).min_width && l(v).min_height ? {
                  width: l(v).min_width,
                  height: l(v).min_height
                } : void 0,
                max: l(v).max_width && l(v).max_height ? {
                  width: l(v).max_width,
                  height: l(v).max_height
                } : void 0
              } : void 0
            }, null, 8, ["size", "disabled", "ratio", "bounds"])) : Q("", !0)
          ];
        }),
        _: 1
      });
    };
  }
}), D8 = { class: "smake:text-sm smake:font-bold smake:uppercase" }, j8 = { class: "smake:relative" }, N8 = /* @__PURE__ */ J({
  __name: "Preview",
  setup(t) {
    const { positioningArea: e, positioningAreaDesign: n } = D(
      dn()
    ), { data: s } = D(sn()), { designerConfiguration: o } = D(tt()), a = A(
      () => {
        var _;
        return Ks[((_ = o.value) == null ? void 0 : _.settings.settings.units.length) ?? "mm"] ?? 1;
      }
    ), i = Ol(
      A(() => {
        var _;
        return (_ = n.value) == null ? void 0 : _.design;
      }),
      a
    ), r = A(() => {
      if (e.value)
        return s.value.find(
          (_) => (
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            _.positioningAreas.includes(e.value)
          )
        );
    }), { isLight: c } = Gs(e, r), u = N(), d = No(u, e);
    function m() {
      n.value && (n.value.rotation = Ya(
        n.value.rotation + 90
      ));
    }
    return (_, g) => {
      const v = xe("FontAwesomeIcon");
      return $(), q(Nl, null, {
        default: C(() => [
          x("h3", D8, L(_.$t("preview")), 1),
          x("div", j8, [
            r.value && l(e) ? ($(), q(l(Oo), {
              key: 0,
              class: "smake:aspect-square smake:w-full smake:rounded-md"
            }, {
              default: C(() => [
                b(l(Do), {
                  data: r.value,
                  "initial-position": l(Vo)(
                    l(e),
                    10 / a.value
                  )
                }, {
                  default: C(() => [
                    b(l(Ro), {
                      data: l(e),
                      "stroke-color": l(d) ? 16711680 : l(c) ? 4605510 : 14474460
                    }, {
                      default: C(() => [
                        l(n) ? ($(), q(l(Lo), {
                          key: 0,
                          data: l(n),
                          placeholder: {
                            color: 13948116,
                            radius: 6 / a.value,
                            ...l(i)
                          },
                          "onUpdate:boundingBox": g[0] || (g[0] = (z) => u.value = z)
                        }, null, 8, ["data", "placeholder"])) : Q("", !0)
                      ]),
                      _: 1
                    }, 8, ["data", "stroke-color"])
                  ]),
                  _: 1
                }, 8, ["data", "initial-position"])
              ]),
              _: 1
            })) : Q("", !0),
            x("button", {
              type: "button",
              class: "smake:absolute smake:-right-2 smake:-bottom-2 smake:rounded-md smake:bg-secondary-3 smake:p-1.75 smake:duration-150 smake:hover:bg-secondary-2",
              onClick: m
            }, [
              b(v, {
                icon: ["fal", "rotate-right"],
                class: "smake:size-4.5"
              })
            ])
          ])
        ]),
        _: 1
      });
    };
  }
}), V8 = { class: "smake:font-bold" }, U8 = /* @__PURE__ */ J({
  __name: "SavedDesignSuccesfullyToast",
  props: /* @__PURE__ */ Ae({
    name: {}
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Ae(["closed"], ["update:open"]),
  setup(t, { emit: e }) {
    const n = e, s = Ne(t, "open");
    return (o, a) => {
      const i = xe("I18nT");
      return $(), q(pm, {
        open: s.value,
        "onUpdate:open": a[0] || (a[0] = (r) => s.value = r),
        type: "success",
        onClosed: a[1] || (a[1] = (r) => n("closed"))
      }, {
        default: C(() => [
          b(i, {
            keypath: "saved_design_successfully",
            tag: "span"
          }, {
            name: C(() => [
              x("span", V8, L(o.name), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["open"]);
    };
  }
}), F8 = { class: "smake:flex smake:justify-between" }, B8 = { class: "smake:text-lg smake:font-semibold" }, q8 = /* @__PURE__ */ J({
  __name: "SavePositioningAreaDesignButton",
  emits: ["saved"],
  setup(t, { emit: e }) {
    const n = e, { positioningArea: s, positioningAreaDesign: o } = D(
      dn()
    ), a = A(
      () => o.value ? Ea(o.value.design) : void 0
    ), { t: i } = ct(), r = N(!1), c = A(() => {
      var y;
      return (y = o.value) == null ? void 0 : y.design;
    });
    it(
      c,
      () => {
        r.value = !1;
      },
      {
        deep: !0
      }
    );
    const u = A(
      () => a.value !== void 0 && s.value !== void 0
    ), d = A(
      () => u.value ? i("new_design") : i("new_customization")
    ), { open: m } = Rn();
    async function _(y) {
      return y instanceof Hn && y.response.status === 422 ? (await y.response.json()).message : i("boot_error.unexpected");
    }
    const { isPending: g, mutate: v } = yt({
      ...ce.designs.favored.post.use(),
      onError: async (y) => {
        m(ln, {
          input: {
            text: await _(y),
            type: "info"
          }
        });
      },
      onSuccess: (y) => {
        y.name && (m(U8, {
          input: {
            name: y.name
          }
        }), r.value = !0, n("saved"));
      }
    }), z = A(() => g.value || r.value);
    function h() {
      if (a.value === void 0 || s.value === void 0) return;
      const y = Ls({
        design: a.value,
        productionMethodId: s.value.productionMethodId
      });
      v({
        elements: [y],
        production_method: { id: s.value.productionMethodId }
      });
    }
    return (y, w) => ($(), I("div", F8, [
      x("h2", B8, L(d.value), 1),
      u.value ? ($(), q(et, {
        key: 0,
        type: "subordinate",
        disabled: z.value,
        text: y.$t("save"),
        size: "small",
        icon: l(g) ? {
          type: ["fal", "spinner"],
          spin: !0
        } : void 0,
        onClick: h
      }, null, 8, ["disabled", "text", "icon"])) : Q("", !0)
    ]));
  }
}), H8 = { class: "smake:flex smake:grow smake:flex-col smake:gap-4 smake:overflow-y-auto smake:bg-white smake:p-4 smake:@sm:rounded-lg" }, W8 = {
  key: 6,
  class: "smake:flex smake:grow smake:flex-col smake:items-center smake:justify-end smake:gap-4 smake:text-secondary-1"
}, G8 = { class: "smake:text-center smake:whitespace-pre-line" }, Z8 = { class: "smake:flex smake:justify-center smake:gap-4 smake:px-4 smake:pb-4 smake:@sm:p-0" }, K8 = /* @__PURE__ */ J({
  __name: "DesignEditDialog",
  setup(t) {
    const {
      open: e,
      positioningArea: n,
      positioningAreaDesign: s,
      positioningAreaDesignBackup: o
    } = D(dn()), { selectedPositioningAreaDesign: a } = D(Sn()), i = A(
      () => {
        var G;
        return (G = n.value) == null ? void 0 : G.productionMethodId;
      }
    ), r = A(() => {
      var G;
      return (G = s.value) == null ? void 0 : G.design;
    }), c = jo(r), u = Rl(r), { fetchStatus: d, normalizedDesign: m, size: _, status: g } = ei(
      A(() => {
        if (i.value !== void 0 && r.value !== void 0)
          return {
            design: r.value,
            productionMethodId: i.value
          };
      })
    ), { data: v } = D(sn()), z = A(
      () => v.value.find(
        (G) => (
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          G.positioningAreas.includes(n.value)
        )
      )
    ), h = vm(), { open: y } = pn(), { isLight: w } = Gs(n, z), P = km(i, w), { hasAccess: M } = Mo(), { isCustomerLogoUploadEnabled: E } = It(i), { customerLogoUploadInfo: R } = D(Zs()), j = A(
      () => _.value && s.value ? Pl(
        _.value,
        { x: 0, y: 0 },
        s.value.rotation
      ) : void 0
    ), V = No(j, n), X = ce.logos.get.use(
      A(() => {
        var G;
        return (G = u.value) == null ? void 0 : G.logoId;
      })
    ), { data: Z, status: ae } = bt({
      ...X,
      enabled: A(
        () => X.enabled.value && !!u.value
      ),
      retry: !1,
      staleTime: 1 / 0
    });
    re(() => {
      !c.value || c.value.lines.length > 0 || Ce();
    });
    async function K(G) {
      i.value !== void 0 && n.value !== void 0 && await y(Ul, {
        input: {
          initialProductionMethodId: i.value,
          intialTab: G,
          positioningArea: n.value,
          positioningAreaDesign: s.value
        }
      });
    }
    async function te() {
      i.value !== void 0 && n.value !== void 0 && await y(Am, {
        input: {
          initialProductionMethodId: i.value,
          positioningArea: n.value,
          positioningAreaDesign: s.value
        }
      });
    }
    function ue() {
      var oe, _e;
      if (!n.value) return;
      const G = {
        lines: [P()],
        type: ze.TEXT
      };
      if (((oe = s.value) == null ? void 0 : oe.design.type) === ze.LOGO)
        s.value.design = {
          children: [
            Z.value ? {
              anchor: Z.value.design_settings.next_element_alignment.anchor_value,
              offset: {
                ...Z.value.design_settings.next_element_alignment.offset
              },
              value: G
            } : {
              anchor: ks.BOTTOM_CENTER,
              offset: { x: 0, y: 5 },
              value: G
            }
          ],
          parent: s.value.design,
          type: ze.ANCHOR
        };
      else {
        const de = {
          design: G,
          rotation: ((_e = h(n.value.id)) == null ? void 0 : _e.direction) ?? 0
        };
        n.value.designs.push(de), s.value = de, a.value = de;
      }
    }
    function Ce() {
      var G;
      n.value && (((G = s.value) == null ? void 0 : G.design.type) === ze.ANCHOR ? s.value.design = s.value.design.parent : (n.value.designs = n.value.designs.filter(
        (oe) => oe !== s.value
      ), s.value = void 0));
    }
    function ne() {
      n.value && (n.value.designs = n.value.designs.filter(
        (G) => G !== s.value
      ), o.value && n.value.designs.push(
        o.value
      )), a.value = void 0, e.value = !1;
    }
    function ee() {
      s.value && m.value && (s.value.design = m.value), a.value = void 0, e.value = !1;
    }
    return (G, oe) => {
      const _e = xe("FontAwesomeIcon");
      return $(), q(De, {
        appear: "",
        "enter-active-class": "smake:duration-300 smake:ease-out",
        "enter-from-class": "smake:translate-x-full",
        "leave-active-class": "smake:duration-200 smake:ease-in smake:absolute smake:inset-y-0 smake:right-0",
        "leave-to-class": "smake:translate-x-full"
      }, {
        default: C(() => {
          var de, $e;
          return [
            l(n) ? ($(), I("div", {
              key: 0,
              "data-testid": "designEditDialog",
              class: ke(["smake:pointer-events-auto smake:flex smake:w-full smake:max-w-full smake:flex-col smake:gap-4 smake:bg-secondary-3 smake:shadow-[0_0_15px_0_rgba(0,0,0,.25)] smake:@sm:w-120 smake:@sm:p-4", { "smake:hidden": !l(e) }])
            }, [
              x("div", H8, [
                b(q8, {
                  onSaved: oe[0] || (oe[0] = (Ze) => K("designs"))
                }),
                l(u) ? ($(), q(L8, {
                  key: 0,
                  data: l(u)
                }, null, 8, ["data"])) : l(m) ? ($(), q(N8, { key: 1 })) : Q("", !0),
                l(c) ? ($(), q(Vl, {
                  key: 2,
                  "can-delete-all-lines": "",
                  deletable: "",
                  data: l(c),
                  "is-light": l(w),
                  "production-method-id": i.value,
                  onDelete: Ce
                }, null, 8, ["data", "is-light", "production-method-id"])) : Q("", !0),
                b(E4, {
                  "positioning-area": l(n),
                  "positioning-area-design": l(s)
                }, null, 8, ["positioning-area", "positioning-area-design"]),
                !l(u) || l(ae) === "pending" || !((de = l(Z)) != null && de.is_customer_logo) ? ($(), q(ha, {
                  key: 3,
                  icon: ["fak", "icon-design-logo"],
                  text: G.$t("logos_and_designs"),
                  loading: l(u) && l(ae) === "pending",
                  "data-testid": "AddCustomerLogoOrDesignButton",
                  onClick: oe[1] || (oe[1] = (Ze) => K("customer-logos"))
                }, null, 8, ["text", "loading"])) : Q("", !0),
                !l(u) || l(ae) === "pending" || ($e = l(Z)) != null && $e.is_customer_logo ? ($(), q(ha, {
                  key: 4,
                  icon: ["fak", "icon-design-database"],
                  text: G.$t("icon_database"),
                  loading: l(u) && l(ae) === "pending",
                  "data-testid": "AddLogoComponentButton",
                  onClick: te
                }, null, 8, ["text", "loading"])) : Q("", !0),
                l(c) ? Q("", !0) : ($(), q(ha, {
                  key: 5,
                  icon: ["fak", "icon-design-text"],
                  text: G.$t("texts"),
                  "data-testid": "AddTextComponentButton",
                  onClick: ue
                }, null, 8, ["text"])),
                l(R) && (!l(M)(l(Rt).CUSTOMER_LOGO_UPLOAD) || !l(E)) ? ($(), I("div", W8, [
                  b(_e, {
                    icon: ["fak", "icon-info"],
                    "fixed-width": "",
                    class: "smake:size-7"
                  }),
                  x("span", G8, L(l(R)), 1)
                ])) : Q("", !0)
              ]),
              x("div", Z8, [
                b(et, {
                  type: "other",
                  text: G.$t("abort"),
                  icon: {
                    type: ["fal", "chevron-left"]
                  },
                  onClick: ne
                }, null, 8, ["text"]),
                b(et, {
                  type: "primary",
                  "data-testid": "PlaceButton",
                  disabled: l(g) !== "success" || l(d) !== "idle" || l(m) === void 0 || l(V),
                  text: G.$t("place"),
                  onClick: ee
                }, null, 8, ["disabled", "text"])
              ])
            ], 2)) : Q("", !0)
          ];
        }),
        _: 1
      });
    };
  }
});
function X8(t) {
  const { appConfiguration: e } = D(tt()), n = A(
    () => {
      if (e.value)
        return e.value.fonts.map((c) => ({
          bounds: { max: c.max, min: c.min },
          fontId: c.id
        }));
    }
  ), s = Rl(t), o = A(() => {
    var c;
    return (c = s.value) == null ? void 0 : c.logoId;
  }), a = ce.logos.get.use(o), { data: i } = bt({
    ...a,
    enabled: A(
      () => a.enabled.value && !!o.value
    ),
    retry: !1,
    staleTime: 1 / 0
  }), r = A(() => {
    if (i.value)
      return {
        max: Math.min(
          i.value.max_width ?? 1 / 0,
          i.value.max_height ?? 1 / 0
        ),
        min: Math.max(
          i.value.min_width ?? 0,
          i.value.min_height ?? 0
        )
      };
  });
  return A(() => ({
    anchor: La.anchor,
    logo: { size: r.value },
    text: {
      ...La.text,
      size: n.value
    }
  }));
}
const Q8 = Symbol("renderingFailedToast"), J8 = /* @__PURE__ */ J({
  __name: "PositioningAreaDesign",
  props: /* @__PURE__ */ Ae({
    data: {},
    productionMethodId: {}
  }, {
    invalidDesigns: {
      required: !0
    },
    invalidDesignsModifiers: {}
  }),
  emits: ["update:invalidDesigns"],
  setup(t) {
    const e = t, { data: n, productionMethodId: s } = we(e), o = Ne(t, "invalidDesigns"), { close: a, open: i } = Rn(), { t: r } = ct(), { designerConfiguration: c } = D(tt()), { hidePositioningAreas: u, selectedPositioningAreaDesign: d } = D(Sn()), {
      forceClose: m,
      open: _,
      positioningArea: g,
      positioningAreaDesign: v
    } = D(dn()), z = Nb(), h = A(() => n.value.design), { selectedProductionMethodId: y } = D(Je()), w = A(
      () => s.value === y.value
    ), P = A(
      () => {
        var Pe;
        return Ks[((Pe = c.value) == null ? void 0 : Pe.settings.settings.units.length) ?? "mm"] ?? 1;
      }
    ), M = Ol(h, P), E = N(), R = N("idle"), j = N("pending");
    it([R, j], ([Pe, ie]) => {
      Pe === "idle" && (ie === "success" ? E.value = Wn(n.value.design) : ie === "error" && (i(ln, {
        id: Q8,
        input: {
          text: r("error_pusher_rendering_failed"),
          type: "info"
        }
      }), E.value && (n.value.design = E.value)));
    });
    const V = N(), X = No(V), Z = Symbol("elemtOutsidePlacementAreaToast");
    re(() => {
      if (X.value) {
        i(ln, {
          id: Z,
          input: {
            text: r("element_outside_placement_area"),
            type: "error"
          }
        });
        return;
      }
      a(Z);
    }), re((Pe) => {
      if (!X.value) return;
      const ie = n.value;
      o.value.push(ie), Pe(() => {
        o.value = o.value.filter(
          (ve) => ve !== ie
        );
      });
    });
    const ae = N();
    Db(n, ae, {
      onMove: (Pe, ie) => {
        v.value === n.value && (g.value = ie);
      }
    });
    const K = N(!1);
    re((Pe) => {
      ae.value && (m.value = !0, K.value = u.value, u.value = !1, Pe(() => {
        m.value = !1, u.value = K.value;
      }));
    });
    function te(Pe, ie) {
      const ve = z_({
        iconName: ie,
        prefix: Pe
      }).icon;
      return {
        height: ve[1],
        path: ve[4],
        width: ve[0]
      };
    }
    const ue = te("fal", "arrow-rotate-right"), Ce = te("fak", "icon-remove"), ne = te("fak", "resize"), { isSelectingPositioningArea: ee } = D(
      Xt()
    );
    function G() {
      d.value = n.value, m.value = !0, g.value = z.value, v.value = n.value;
    }
    const oe = Rl(h), _e = ce.logos.get.use(
      A(() => {
        var Pe;
        return (Pe = oe.value) == null ? void 0 : Pe.logoId;
      })
    ), { data: de } = bt({
      ..._e,
      enabled: A(() => _e.enabled.value && !!oe.value),
      retry: !1,
      staleTime: 1 / 0
    }), $e = A(() => j.value === "pending" ? !1 : de.value ? de.value.is_scaleable : !0), Ze = X8(h);
    return (Pe, ie) => ($(), q(l(Sb), {
      disabled: !ae.value && l(d) !== l(n)
    }, {
      default: C(() => [
        b(l(gb), {
          disabled: !w.value || l(ee) || l(_) && l(v) !== l(n),
          "onUpdate:point": ie[3] || (ie[3] = (ve) => ae.value = ve),
          onPointerdown: G
        }, {
          default: C(() => [
            b(l(Lo), {
              data: l(n),
              placeholder: {
                color: 13948116,
                radius: 6 / P.value,
                ...l(M)
              },
              "onUpdate:boundingBox": ie[0] || (ie[0] = (ve) => V.value = ve),
              "onUpdate:fetchStatus": ie[1] || (ie[1] = (ve) => R.value = ve),
              "onUpdate:status": ie[2] || (ie[2] = (ve) => j.value = ve)
            }, {
              default: C(() => [
                b(l(ab), {
                  "rotate-icon": l(ue),
                  "delete-icon": l(Ce),
                  "resize-icon": l(ne),
                  rotateable: "",
                  deleteable: "",
                  resizeable: $e.value,
                  "rotate-step": 90,
                  hidden: l(n) !== l(d),
                  "design-bounds": l(Ze),
                  padding: 3 / P.value,
                  "rotation-control-length": 15 / P.value
                }, null, 8, ["rotate-icon", "delete-icon", "resize-icon", "resizeable", "hidden", "design-bounds", "padding", "rotation-control-length"])
              ]),
              _: 1
            }, 8, ["data", "placeholder"])
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _: 1
    }, 8, ["disabled"]));
  }
}), Y8 = /* @__PURE__ */ J({
  __name: "PositioningArea",
  props: {
    data: {},
    isNearestPositioningArea: { type: Boolean }
  },
  setup(t) {
    const e = t, { data: n, isNearestPositioningArea: s } = we(e), {
      hidePositioningAreas: o,
      highlightEmptyPositioningAreas: a,
      selectedPositioningAreaDesign: i
    } = D(Sn()), { selectPositioningArea: r } = Xt(), { isSelectingPositioningArea: c } = D(
      Xt()
    ), { selectedProductionMethodId: u } = D(Je()), {
      open: d,
      positioningArea: m,
      positioningAreaDesign: _
    } = D(dn()), { isLight: g } = Gs(n), v = N([]), z = A(
      () => n.value.productionMethodId !== u.value || !c.value && n.value.designs.length > 1 || c.value && n.value.designs.length > 0 || d.value && m.value !== n.value
    );
    function h(E) {
      if (E.stopPropagation(), i.value = void 0, c.value) {
        r(n.value);
        return;
      }
      if (m.value = n.value, n.value.designs.length === 1) {
        _.value = n.value.designs[0], i.value = n.value.designs[0];
        return;
      }
      _.value = void 0;
    }
    const y = A(() => [1, 1, 1, 0.5]), w = A(() => {
      if (P.value)
        return y.value;
    }), P = A(() => !!(s.value || a.value && M.value)), M = A(() => n.value.designs.length === 0);
    return (E, R) => ($(), q(l(Ro), {
      data: l(n),
      hidden: l(n).productionMethodId !== l(u) || l(o) || l(d) && l(m) !== l(n),
      "stroke-color": v.value.length > 0 ? 16711680 : l(g) ? 4605510 : 14474460,
      "fill-color": w.value,
      "event-mode": z.value ? "passive" : "static",
      cursor: "pointer",
      onPointerdown: h
    }, {
      default: C(() => [
        ($(!0), I(me, null, Se(l(n).designs, (j) => ($(), q(J8, {
          key: l(ft)(j),
          "invalid-designs": v.value,
          "onUpdate:invalidDesigns": R[0] || (R[0] = (V) => v.value = V),
          data: j,
          "production-method-id": l(n).productionMethodId
        }, null, 8, ["invalid-designs", "data", "production-method-id"]))), 128))
      ]),
      _: 1
    }, 8, ["data", "hidden", "stroke-color", "fill-color", "event-mode"]));
  }
}), e5 = /* @__PURE__ */ J({
  __name: "Designer",
  setup(t) {
    const { data: e, selectedViewIndex: n } = D(sn()), { designerCore: s, readOnlyZoom: o, selectedPositioningAreaDesign: a, stage: i } = D(Sn()), { designerConfiguration: r } = D(tt()), c = A(
      () => {
        var _;
        return Ks[((_ = r.value) == null ? void 0 : _.settings.settings.units.length) ?? "mm"] ?? 1;
      }
    ), u = jb();
    function d() {
      a.value = void 0;
    }
    function m(_) {
      o.value = _;
    }
    return (_, g) => ($(), q(l(Oo), {
      ref_key: "designerCore",
      ref: s,
      "clamp-zoom": { min: 1, max: 2.5 },
      draggable: "",
      stage: l(i),
      onClick: d,
      "onUpdate:zoom": m
    }, {
      default: C(() => [
        ($(!0), I(me, null, Se(l(e), (v, z) => ($(), q(l(Do), {
          key: l(ft)(v),
          data: v,
          hidden: z !== l(n),
          placeholder: { color: 15856113, radius: 6 / c.value }
        }, {
          default: C(() => [
            ($(!0), I(me, null, Se(v.positioningAreas, (h) => ($(), q(Y8, {
              key: l(ft)(h),
              data: h,
              "is-nearest-positioning-area": l(u).some(
                ({ positioningArea: y }) => y === h
              )
            }, null, 8, ["data", "is-nearest-positioning-area"]))), 128))
          ]),
          _: 2
        }, 1032, ["data", "hidden", "placeholder"]))), 128))
      ]),
      _: 1
    }, 8, ["stage"]));
  }
}), t5 = /* @__PURE__ */ J({
  __name: "Dialogs",
  setup(t) {
    const { dialogs: e, dialogsRoot: n, hideAllDialogs: s } = D(nn()), { removeDialog: o } = nn();
    function a(i, r) {
      r || i.resolve();
    }
    return (i, r) => mt(($(), I("div", {
      ref_key: "dialogsRoot",
      ref: n
    }, [
      ($(!0), I(me, null, Se(l(e), (c) => ($(), q(il(c.component), Na({
        key: l(ft)(c)
      }, { ref_for: !0 }, c.input, {
        open: c.open,
        "onUpdate:open": [(u) => c.open = u, (u) => a(c, u)],
        onClosed: (u) => l(o)(c),
        onResolve: c.resolve
      }), null, 16, ["open", "onUpdate:open", "onClosed", "onResolve"]))), 128))
    ], 512)), [
      [ef, !l(s)]
    ]);
  }
}), n5 = st("saveAndDownloadPdf", () => {
  const t = lt(), { data: e } = D(Qt()), n = A(() => !!o.value), s = ni(), o = A(() => {
    if (e.value && s.value.length !== 0)
      return {
        baseId: e.value.id,
        views: s.value
      };
  }), a = N(), { mutate: i } = yt({
    ...ce.variants.pdf.postForDownload.use(),
    // TOdo add toast
    onError: (m) => {
      u.value = !1;
    },
    onMutate: () => u.value = !0,
    onSuccess(m) {
      a.value = m;
    }
  });
  function r() {
    o.value && i(o.value);
  }
  const c = en(
    (m) => t.fetchQuery({
      ...ce.variants.pdf.getByVariantId.use(m),
      retry: !1,
      staleTime: 1 / 0
    })
  );
  dm(
    "customVariant.customizationsCompletedForPDFDownload",
    async ({ id: m, name: _, id_hash: g }) => {
      if (a.value === m) {
        try {
          a.value = void 0, await d(m, `Design ID ${g} - ${_}.pdf`);
        } catch {
        }
        u.value = !1;
      }
    }
  );
  const u = N(!1);
  async function d(m, _) {
    const g = await c(m), v = URL.createObjectURL(g), z = document.createElement("a");
    z.href = v, z.download = _, z.click();
  }
  return {
    canDownload: n,
    download: r,
    isPending: u
  };
}), s5 = ["disabled"], o5 = { class: "smake:flex smake:aspect-square smake:h-16 smake:items-center smake:justify-center smake:gap-2 smake:rounded-full smake:border smake:border-secondary-2 smake:bg-white smake:p-2 smake:duration-150 smake:group-enabled:group-hover:border-black" }, a5 = { class: "smake:text-xs" }, i5 = /* @__PURE__ */ J({
  __name: "DownloadPdf",
  setup(t) {
    const e = n5(), { download: n } = e, { canDownload: s, isPending: o } = D(e), { selectedProductionMethodId: a } = D(Je()), i = A(
      () => !s.value || o.value || a.value === void 0
    );
    return (r, c) => {
      const u = xe("FontAwesomeIcon");
      return $(), I("button", {
        type: "button",
        "data-testid": "DownloadPdf",
        class: "smake:group smake:pointer-events-auto smake:flex smake:flex-col smake:items-center smake:gap-2 smake:disabled:opacity-50",
        disabled: i.value,
        onClick: c[0] || (c[0] = //@ts-ignore
        (...d) => l(n) && l(n)(...d))
      }, [
        x("div", o5, [
          l(o) ? ($(), q(u, {
            key: 0,
            class: "smake:h-7 smake:animate-spin",
            icon: ["fal", "spinner"]
          })) : ($(), q(u, {
            key: 1,
            icon: ["fak", "download"],
            "fixed-width": "",
            class: "smake:h-7"
          }))
        ]),
        x("div", a5, L(r.$t("pdf_download")), 1)
      ], 8, s5);
    };
  }
}), r5 = { key: 0 }, l5 = { class: "smake:rounded-full smake:bg-secondary-3 smake:p-3" }, c5 = /* @__PURE__ */ J({
  __name: "FileUploadDialogButton",
  setup(t) {
    const { selectedProductionMethodId: e } = D(Je()), { isFileUploadDialogOpen: n } = D(ti()), { isCustomerLogoUploadEnabled: s } = It(
      e
    );
    return (o, a) => l(s) ? ($(), I("div", r5, [
      x("button", {
        "data-testid": "FileUploadDialogButton",
        type: "button",
        class: "smake:pointer-events-auto smake:flex smake:w-50 smake:flex-col smake:items-center smake:justify-center smake:gap-2 smake:rounded-2xl smake:border smake:border-secondary-2 smake:bg-white smake:p-3 smake:py-5 smake:text-sm smake:font-medium smake:duration-150 smake:hover:border-black smake:disabled:opacity-50",
        onClick: a[0] || (a[0] = (i) => n.value = !0)
      }, [
        x("div", l5, [
          b(oi, { class: "smake:size-5" })
        ]),
        he(" " + L(o.$t("upload_file")), 1)
      ]),
      l(e) ? ($(), q(Uo, {
        key: 0,
        open: l(n),
        "onUpdate:open": a[1] || (a[1] = (i) => Lt(n) ? n.value = i : null),
        "production-method-id": l(e)
      }, null, 8, ["open", "production-method-id"])) : Q("", !0)
    ])) : Q("", !0);
  }
}), u5 = { key: 0 }, d5 = { class: "smake:pointer-events-auto smake:flex smake:flex-col smake:items-center smake:justify-center smake:gap-2" }, p5 = { class: "smake:text-center smake:text-xs" }, m5 = /* @__PURE__ */ J({
  __name: "FileUploadDialogButtonMobile",
  setup(t) {
    const { selectedProductionMethodId: e } = D(Je()), { isCustomerLogoUploadEnabled: n } = It(
      e
    ), { isFileUploadDialogOpen: s } = D(ti());
    return (o, a) => l(n) ? ($(), I("div", u5, [
      x("div", d5, [
        b(Re, {
          "data-testid": "FileUploadDialogButton",
          class: "smake:size-16",
          type: "secondary",
          disabled: l(e) === void 0,
          onClick: a[0] || (a[0] = (i) => s.value = !0)
        }, {
          default: C(() => [
            b(oi, { class: "smake:size-5" })
          ]),
          _: 1
        }, 8, ["disabled"]),
        x("div", p5, L(o.$t("upload_file")), 1)
      ]),
      l(e) ? ($(), q(Uo, {
        key: 0,
        open: l(s),
        "onUpdate:open": a[1] || (a[1] = (i) => Lt(s) ? s.value = i : null),
        "production-method-id": l(e)
      }, null, 8, ["open", "production-method-id"])) : Q("", !0)
    ])) : Q("", !0);
  }
}), h5 = ["disabled"], f5 = {
  key: 0,
  class: "smake:text-xs"
}, Mr = /* @__PURE__ */ J({
  __name: "HidePositioningAreas",
  props: {
    hideLabel: { type: Boolean }
  },
  setup(t) {
    const { hidePositioningAreas: e } = D(Sn()), { isSelectingPositioningArea: n } = D(
      Xt()
    ), { selectedProductionMethodId: s } = D(Je());
    return (o, a) => {
      const i = xe("FontAwesomeIcon");
      return $(), I("button", {
        "data-testid": "HidePositioningAreas",
        type: "button",
        class: "smake:group smake:pointer-events-auto smake:flex smake:flex-col smake:items-center smake:gap-2 smake:disabled:opacity-50",
        disabled: l(n) || l(s) === void 0,
        onClick: a[0] || (a[0] = (r) => e.value = !l(e))
      }, [
        x("div", {
          class: ke(["smake:size-16 smake:rounded-full smake:border smake:border-secondary-1 smake:p-4 smake:duration-150 smake:group-enabled:group-hover:border-black smake:group-enabled:group-hover:bg-white", { "smake:bg-black": !l(e) }])
        }, [
          b(i, {
            class: ke(["smake:h-full smake:duration-150 smake:group-enabled:group-hover:text-black", { "smake:text-white": !l(e) }]),
            icon: ["fak", "icon-ciconfig-areaonoff"],
            "fixed-width": ""
          }, null, 8, ["class"])
        ], 2),
        o.hideLabel ? Q("", !0) : ($(), I("div", f5, L(l(e) ? o.$t("show_areas") : o.$t("hide_areas")), 1))
      ], 8, h5);
    };
  }
});
function nl(t) {
  const e = _t(t), { data: n, fetchNextPage: s, fetchStatus: o, hasNextPage: a, status: i } = js({
    ...ce.favorites.variants.list.use(
      A(
        () => ({
          filter: {
            collection_name: e.value
          }
        })
      )
    ),
    retry: !1,
    select: (r) => r.pages.flatMap((c) => c.data),
    staleTime: 1 / 0
  });
  return {
    data: n,
    fetchNextPage: s,
    fetchStatus: o,
    hasNextPage: a,
    status: i
  };
}
const Da = st("cartVariantsStore", () => {
  const t = N(), e = ce.variants.list.use(
    A(() => ({
      id: t.value
    }))
  ), { data: n, fetchNextPage: s, fetchStatus: o, hasNextPage: a, status: i } = js({
    ...e,
    enabled: A(
      () => {
        var c;
        return e.enabled.value && (((c = t.value) == null ? void 0 : c.length) ?? 0) > 0;
      }
    ),
    retry: !1,
    select: (c) => c.pages.flatMap((u) => u.data),
    staleTime: 1 / 0
  }), r = A(
    () => {
      var c;
      return (((c = t.value) == null ? void 0 : c.length) ?? 0) > 0 && i.value === "pending";
    }
  );
  return {
    cartItemIds: t,
    data: n,
    fetchNextPage: s,
    fetchStatus: o,
    hasNextPage: a,
    isPending: r,
    status: i
  };
}), sl = st(
  "favoriteDesignCreateStatus",
  () => {
    const t = N(/* @__PURE__ */ new Set());
    function e(s) {
      t.value.add(s);
    }
    const n = A(
      () => t.value.size > 0
    );
    return Dt("favorite.rendered", ({ resource_id: s }) => {
      t.value.delete(s);
    }), {
      hasVariantsInRendering: n,
      waitForRendering: e
    };
  }
), Fl = /* @__PURE__ */ J({
  __name: "CustomizationPreview",
  props: {
    data: {},
    size: { default: "default" }
  },
  setup(t) {
    return (e, n) => ($(), I("div", {
      class: ke(["smake:flex smake:items-center smake:justify-center smake:rounded-lg", {
        "smake:size-16 smake:@sm:size-20": e.size === "default",
        "smake:size-16 smake:@sm:size-25": e.size === "large"
      }]),
      style: Kt(`background-color: ${e.data.background_color}`)
    }, [
      e.data.design.preview_url ? ($(), q(on, {
        key: 0,
        src: e.data.design.preview_url,
        class: "smake:aspect-square smake:object-contain smake:p-2 smake:data-[state=pending]:animate-pulse smake:data-[state=pending]:bg-secondary-2",
        style: Kt({
          rotate: `${e.data.rotation}deg`
        })
      }, null, 8, ["src", "style"])) : Q("", !0)
    ], 6));
  }
}), _5 = { class: "smake:aspect-square smake:h-4 smake:cursor-default smake:rounded-full smake:border smake:border-black smake:bg-white smake:outline-none smake:hover:bg-slate-50 smake:focus:shadow-black" }, v5 = { class: "smake:relative smake:h-full smake:w-full" }, g5 = { class: "smake:self-end" }, k5 = {
  key: 0,
  class: "smake:absolute smake:top-1 smake:right-1 smake:m-0.75 smake:flex smake:aspect-square smake:h-8 smake:items-center smake:justify-center smake:rounded-full smake:bg-secondary-3"
}, y5 = {
  key: 1,
  class: "smake:absolute smake:inset-0 smake:bg-secondary-1/50"
}, b5 = /* @__PURE__ */ J({
  __name: "PositioningAreaDesignPreviewRadio",
  props: {
    customization: {},
    disabled: { type: Boolean }
  },
  emits: ["showVariantDetails"],
  setup(t, { emit: e }) {
    const n = t, { customization: s } = we(n), o = A(
      () => s.value.positioningArea.production_method.id
    ), { icon: a } = It(o), i = A(
      () => ys(s.value.design.elements[0])
    ), r = jo(i), { allTextLinesSupported: c } = gs(
      A(() => {
        var _;
        return (_ = r.value) == null ? void 0 : _.lines;
      }),
      o
    ), u = A(() => c.value === !1), d = e;
    function m() {
      d("showVariantDetails");
    }
    return (_, g) => {
      const v = xe("FontAwesomeIcon");
      return $(), q(l(f_), {
        class: ke(["smake:relative smake:flex smake:justify-between smake:gap-2 smake:rounded-md smake:border smake:border-white smake:p-2 smake:@md:border-secondary-1", {
          "grayscale-[50%] smake:opacity-80": _.disabled,
          "smake:bg-white": !u.value,
          "smake:bg-danger/50": u.value
        }]),
        value: l(s).id.toString(),
        disabled: _.disabled
      }, {
        default: C(() => [
          x("div", _5, [
            b(l(__), { class: "smake:relative smake:flex smake:size-full smake:items-center smake:justify-center smake:after:block smake:after:aspect-square smake:after:h-2 smake:after:rounded-[50%] smake:after:bg-black smake:after:content-['']" })
          ]),
          x("div", v5, [
            b(Fl, {
              data: l(s),
              size: "large"
            }, null, 8, ["data"]),
            u.value ? ($(), q(v, {
              key: 0,
              class: "smake:absolute smake:top-1 smake:left-1 smake:h-4.5 smake:rounded-full smake:bg-danger smake:text-white smake:@md:top-2.5 smake:@md:left-2.5",
              icon: ["fal", "circle-exclamation"]
            })) : Q("", !0)
          ]),
          x("div", g5, [
            x("button", {
              type: "button",
              onClick: rs(m, ["stop"])
            }, [
              b(v, {
                class: ke(["smake:h-4 smake:text-secondary-1", {
                  "smake:text-secondary-1": !u.value,
                  "smake:text-white": u.value
                }]),
                icon: ["fal", "up-right-and-down-left-from-center"]
              }, null, 8, ["class"])
            ])
          ]),
          l(a) ? ($(), I("div", k5, [
            b(v, {
              "fixed-width": "",
              class: "smake:h-4",
              icon: l(a)
            }, null, 8, ["icon"])
          ])) : Q("", !0),
          _.disabled ? ($(), I("div", y5)) : Q("", !0)
        ]),
        _: 1
      }, 8, ["class", "value", "disabled"]);
    };
  }
}), w5 = { class: "smake:absolute smake:inset-x-0 smake:mx-auto smake:flex smake:max-w-150 smake:flex-col smake:gap-4 smake:overflow-y-auto smake:rounded-3xl smake:bg-white smake:p-6 smake:@max-md:bottom-0 smake:@max-md:max-h-[calc(100%-64px)] smake:@max-md:rounded-b-none smake:@md:top-1/2 smake:@md:max-h-[calc(100%-80px)] smake:@md:-translate-y-1/2" }, x5 = { class: "smake:flex smake:items-start smake:justify-between smake:gap-2" }, $5 = { class: "smake:uppercase" }, z5 = { class: "smake:font-bold" }, S5 = { class: "smake:relative smake:mt-3 smake:items-center smake:justify-between smake:bg-white" }, A5 = { class: "smake:mt-10 smake:w-full" }, C5 = { class: "smake:relative smake:flex" }, P5 = { class: "smake:absolute smake:top-0 smake:left-0 smake:flex smake:h-full smake:w-20 smake:items-center smake:justify-center" }, M5 = { class: "smake:absolute smake:top-0 smake:right-0 smake:flex smake:h-full smake:w-20 smake:items-center smake:justify-center" }, T5 = { key: 0 }, I5 = {
  key: 0,
  class: "smake:my-6 smake:border smake:border-t-1 smake:border-secondary-2"
}, E5 = { class: "smake:flex smake:flex-col" }, O5 = { class: "smake:text-[14px] smake:font-bold" }, R5 = {
  key: 0,
  class: "smake:text-[12px] smake:font-bold"
}, L5 = {
  key: 1,
  class: "smake:text-[12px] smake:font-bold"
}, D5 = { class: "smake:text-[12px] smake:text-secondary-2" }, j5 = { key: 0 }, N5 = /* @__PURE__ */ J({
  __name: "VariantPreviewDialog",
  props: /* @__PURE__ */ Ae({
    initialViewIndex: {},
    variant: {}
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Ae(["closed"], ["update:open"]),
  setup(t, { emit: e }) {
    const { locale: n, t: s } = ct(), o = Xa(), { rootElement: a } = D(jt()), i = N(), { animateHeight: r } = jp(i), c = Ne(t, "open"), { appConfiguration: u, designerConfiguration: d } = D(
      tt()
    );
    function m(Z) {
      var ae;
      return (ae = u.value) == null ? void 0 : ae.productionMethods.find(
        (K) => K.id === Z
      );
    }
    const _ = t, { initialViewIndex: g, variant: v } = we(_), z = N(
      v.value.views[g.value] ? g.value : 0
    ), h = A(() => v.value.views[z.value]), y = A(
      () => {
        var Z;
        return ((Z = h.value) == null ? void 0 : Z.customizations.length) ?? 0;
      }
    ), w = N(y.value > 0);
    it(y, async () => {
      await r(() => w.value = y.value > 0);
    });
    function P() {
      if (z.value === v.value.views.length - 1) {
        z.value = 0;
        return;
      }
      if (z.value === 0) {
        z.value = 1;
        return;
      }
      z.value = z.value + 1;
    }
    function M() {
      if (z.value === 0) {
        z.value = v.value.views.length - 1;
        return;
      }
      z.value = z.value - 1;
    }
    const E = e;
    function R(Z) {
      return o.decimalFormat(
        Z.width * Z.height,
        n.value
      );
    }
    const j = A(() => v.value.views.map((Z) => "xl" in Z.mockup_urls && Z.mockup_urls.xl ? Z.mockup_urls.xl : "md" in Z.mockup_urls && Z.mockup_urls.md ? Z.mockup_urls.md : Z.image_urls.xl));
    re(() => {
      sw(j.value);
    });
    const V = A(() => {
      if (h.value)
        return "xl" in h.value.mockup_urls && h.value.mockup_urls.xl ? h.value.mockup_urls.xl : "md" in h.value.mockup_urls && h.value.mockup_urls.md ? h.value.mockup_urls.md : h.value.image_urls.xl;
    }), X = A(() => {
      var Z;
      return (Z = d.value) == null ? void 0 : Z.settings.settings.units;
    });
    return (Z, ae) => {
      const K = xe("FontAwesomeIcon");
      return $(), q(l(Ct), {
        open: c.value,
        "onUpdate:open": ae[1] || (ae[1] = (te) => c.value = te)
      }, {
        default: C(() => [
          b(l(Pt), { to: l(a) }, {
            default: C(() => [
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:opacity-0",
                onAfterLeave: ae[0] || (ae[0] = (te) => E("closed"))
              }, {
                default: C(() => [
                  b(l(Mt), { class: "smake:fixed smake:inset-0 smake:bg-black/40" })
                ]),
                _: 1
              }),
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:translate-y-full smake:@sm:translate-y-0 smake:@sm:scale-95 smake:@sm:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:translate-y-full smake:@sm:translate-y-0 smake:@sm:scale-95 smake:@sm:opacity-0"
              }, {
                default: C(() => [
                  b(l(Tt), { "as-child": "" }, {
                    default: C(() => [
                      x("div", w5, [
                        x("div", x5, [
                          b(l(At), { class: "smake:text-xl" }, {
                            default: C(() => {
                              var te;
                              return [
                                x("div", $5, L(l(s)("views_preview_headlide")), 1),
                                x("div", z5, L((te = h.value) == null ? void 0 : te.display_name), 1)
                              ];
                            }),
                            _: 1
                          }),
                          b(l(zt), { class: "smake:-mt-2 smake:-mr-2 smake:rounded-full smake:border smake:border-secondary-2 smake:p-2 smake:duration-150 smake:hover:bg-secondary-3" }, {
                            default: C(() => [
                              b(K, {
                                icon: ["fak", "icon-x"],
                                "fixed-width": "",
                                class: "smake:size-3"
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        x("div", S5, [
                          x("div", A5, [
                            x("div", C5, [
                              V.value !== void 0 ? ($(), q(on, {
                                key: 0,
                                src: V.value,
                                class: "smake:aspect-square smake:w-full smake:rounded-2xl smake:object-contain smake:data-[state=pending]:animate-pulse smake:data-[state=pending]:bg-secondary-2"
                              }, null, 8, ["src"])) : Q("", !0),
                              x("div", P5, [
                                b(Re, {
                                  type: "secondary",
                                  class: "smake:absolute smake:size-16 smake:rounded-full smake:bg-secondary-3 smake:p-4",
                                  onClick: M
                                }, {
                                  default: C(() => [
                                    b(K, {
                                      icon: ["fal", "chevron-left"],
                                      class: "smake:size-6"
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              x("div", M5, [
                                b(Re, {
                                  type: "secondary",
                                  class: "smake:absolute smake:size-16 smake:rounded-full smake:bg-secondary-3 smake:p-4",
                                  onClick: P
                                }, {
                                  default: C(() => [
                                    b(K, {
                                      icon: ["fal", "chevron-right"],
                                      class: "smake:size-6"
                                    })
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            h.value ? ($(), I("div", T5, [
                              h.value.customizations.length > 0 ? ($(), I("hr", I5)) : Q("", !0),
                              x("div", {
                                ref_key: "customizationPreviews",
                                ref: i
                              }, [
                                x("div", {
                                  class: ke(["smake:flex smake:flex-col smake:gap-5", {
                                    "smake:hidden": !w.value
                                  }])
                                }, [
                                  ($(!0), I(me, null, Se(h.value.customizations, (te) => {
                                    var ue, Ce, ne;
                                    return $(), I("div", {
                                      key: te.id,
                                      class: "smake:flex smake:gap-4"
                                    }, [
                                      b(Fl, { data: te }, null, 8, ["data"]),
                                      x("div", E5, [
                                        x("div", O5, L((ue = m(
                                          te.design.production_method.id
                                        )) == null ? void 0 : ue.display_name), 1),
                                        ($(!0), I(me, null, Se(l(Dl)(
                                          te.design.elements[0]
                                        ), (ee) => ($(), I(me, {
                                          key: l(ft)(
                                            ee
                                          )
                                        }, [
                                          ee.resource_type === "logo" ? ($(), I("div", R5, L(l(s)(
                                            ee.resource.is_customer_logo ? "logos" : "icon"
                                          )) + ": " + L(ee.resource.name), 1)) : Q("", !0),
                                          ee.resource_type === "text" ? ($(), I("div", L5, L(l(s)("texts")) + ": " + L(ee.resource.lines.map(
                                            (G) => G.value
                                          ).join(" ")), 1)) : Q("", !0)
                                        ], 64))), 128)),
                                        x("div", D5, [
                                          he(L(R(
                                            te
                                          )) + " " + L((Ce = X.value) == null ? void 0 : Ce.length) + "² ", 1),
                                          (ne = te.positioningArea) != null && ne.positioning_area_identifier ? ($(), I("span", j5, " | " + L(te.positioningArea.positioning_area_identifier.name) + " (" + L(te.positioningArea.positioning_area_identifier.handle) + ") ", 1)) : Q("", !0)
                                        ])
                                      ])
                                    ]);
                                  }), 128))
                                ], 2)
                              ], 512)
                            ])) : Q("", !0)
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _: 1
      }, 8, ["open"]);
    };
  }
}), V5 = { class: "smake:flex smake:w-full smake:flex-col smake:items-center smake:gap-3 smake:rounded-3xl smake:bg-secondary-3 smake:p-5" }, U5 = { class: "smake:flex smake:w-full smake:items-start smake:justify-between" }, F5 = { class: "smake:flex smake:flex-col smake:items-center smake:justify-center smake:gap-2" }, B5 = { class: "smake:text-xs" }, q5 = { class: "smake:text-center smake:text-lg smake:font-bold" }, H5 = { class: "smake:size-10" }, W5 = {
  key: 0,
  class: "smake:text-center smake:text-xs smake:text-danger"
}, G5 = {
  key: 0,
  class: "smake:flex smake:items-center smake:gap-2 smake:font-medium"
}, Z5 = { class: "smake:mt-3 smake:flex smake:grow smake:flex-col smake:items-center smake:justify-end smake:gap-4" }, Cm = /* @__PURE__ */ J({
  __name: "VariantCard",
  props: {
    disableRepair: { type: Boolean },
    variant: {}
  },
  emits: ["repair", "startSelectingPositioningArea", "variantChanged"],
  setup(t, { emit: e }) {
    const n = t, { disableRepair: s, variant: o } = we(n), a = e, { t: i } = ct(), { open: r } = pn(), c = Qt(), { variantId: u } = D(c), { availableProductionMethodIds: d } = D(
      Je()
    );
    function m(ne) {
      r(N5, {
        input: { initialViewIndex: ne, variant: o.value }
      });
    }
    const _ = A(
      () => o.value.views.map((ne) => El(ne))
    ), g = A(
      () => new Date(o.value.created_at).toLocaleDateString("de", {
        dateStyle: "medium"
      })
    ), v = A(
      () => _.value.flatMap(
        (ne) => ne.positioningAreas.flatMap(
          (ee) => ee.designs
        )
      )
    ), z = N(), h = A({
      get: () => {
        var ne;
        return (ne = y.value) == null ? void 0 : ne.customization.id.toString();
      },
      set: (ne) => z.value = ne
    }), y = A(() => {
      var _e;
      if (d.value === void 0) return;
      const ne = o.value.views.flatMap((de) => de.customizations).filter(
        (de) => {
          var $e;
          return ($e = d.value) == null ? void 0 : $e.has(
            de.positioningArea.production_method.id
          );
        }
      ), ee = ne.find(
        (de) => de.id.toString() === z.value
      ) ?? ne.at(0), G = o.value.views.find(
        (de) => de.customizations.flatMap(($e) => $e.id).includes((ee == null ? void 0 : ee.id) ?? 0)
      );
      if (!ee || !G) return;
      const oe = (_e = rm(
        ee.positioningArea,
        G
      ).designs.at(0)) == null ? void 0 : _e.design;
      if (oe)
        return {
          customization: ee,
          design: oe
        };
    }), { placeDesign: w } = si();
    async function P() {
      if (!y.value) return;
      await w({
        design: y.value.design,
        productionMethodId: y.value.customization.positioningArea.production_method.id
      }) === "aborted-positioning-area-selection" && r(ii);
    }
    const M = A(
      () => v.value.flatMap(
        (ne) => {
          var ee;
          return ((ee = Ms(ne.design)) == null ? void 0 : ee.lines) ?? [];
        }
      )
    ), E = A(
      () => {
        var ne;
        return (ne = y.value) == null ? void 0 : ne.customization.positioningArea.production_method.id;
      }
    ), { allTextLinesSupported: R } = gs(M, E), j = A(() => {
      var ne;
      return y.value ? ((ne = Ms(y.value.design)) == null ? void 0 : ne.lines) ?? [] : [];
    }), { allTextLinesSupported: V } = gs(
      j,
      E
    ), { appConfiguration: X } = D(tt()), Z = A(() => {
      if (X.value)
        return o.value.views.flatMap((ne) => ne.customizations).some((ne) => {
          var G;
          const ee = (G = Ms(
            ys(ne.design.elements[0])
          )) == null ? void 0 : G.lines;
          return ee ? Oa(
            X.value,
            ee,
            ne.design.production_method.id
          ).length > 0 : !1;
        });
    }), ae = A(
      () => V.value === !1
    );
    async function K() {
      u.value = o.value.id, await c.suspense(), a("variantChanged");
    }
    const { isSelectingPositioningArea: te } = D(
      Xt()
    );
    re(() => {
      te.value && a("startSelectingPositioningArea");
    });
    const ue = A(() => {
      const ne = !y.value || ae.value, ee = Z.value && s.value || !Z.value ? "primary" : "other";
      return {
        disabled: ne,
        type: ee
      };
    }), Ce = A(() => {
      const ne = Z.value ? () => {
        a("repair");
      } : K, ee = !!Z.value && s.value, G = Z.value && !s.value ? i("update_article_with_designs") : i("archive_fetch_variant_with_customizations"), oe = ue.value.type === "primary" ? "other" : "primary";
      return {
        action: ne,
        disabled: ee,
        text: G,
        type: oe
      };
    });
    return (ne, ee) => {
      const G = xe("FontAwesomeIcon");
      return $(), I("div", V5, [
        x("div", U5, [
          ee[1] || (ee[1] = x("div", { class: "smake:size-10" }, null, -1)),
          x("div", F5, [
            x("div", B5, L(g.value) + " | #" + L(l(o).id_hash), 1),
            x("div", q5, L(l(o).name), 1)
          ]),
          x("div", H5, [
            St(ne.$slots, "header-right")
          ])
        ]),
        b(l(v_), {
          modelValue: h.value,
          "onUpdate:modelValue": ee[0] || (ee[0] = (oe) => h.value = oe),
          class: "smake:flex smake:w-full smake:flex-wrap smake:justify-center smake:gap-4"
        }, {
          default: C(() => [
            ($(!0), I(me, null, Se(l(o).views, (oe, _e) => ($(), I(me, {
              key: l(ft)(oe)
            }, [
              ($(!0), I(me, null, Se(oe.customizations, (de) => {
                var $e;
                return $(), q(b5, {
                  key: de.id,
                  customization: de,
                  disabled: !(($e = l(d)) != null && $e.has(
                    de.positioningArea.production_method.id
                  )),
                  onShowVariantDetails: (Ze) => m(_e)
                }, null, 8, ["customization", "disabled", "onShowVariantDetails"]);
              }), 128))
            ], 64))), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        Z.value ? ($(), I("div", W5, [
          l(R) === !1 ? ($(), I("div", G5, [
            b(G, {
              class: "smake:h-6 smake:rounded-full smake:text-danger",
              icon: ["fak", "icon-ciconfig-alert-warning"],
              "fixed-width": ""
            }),
            he(" " + L(ne.$t("at_least_one_motiv_is_not_available")), 1)
          ])) : Q("", !0)
        ])) : Q("", !0),
        x("div", Z5, [
          b(et, {
            type: ue.value.type,
            size: "small",
            disabled: ue.value.disabled,
            text: ne.$t("archive_fetch_selected_customization"),
            onClick: P
          }, null, 8, ["type", "disabled", "text"]),
          b(et, {
            type: Ce.value.type,
            size: "small",
            disabled: Ce.value.disabled,
            text: Ce.value.text,
            onClick: Ce.value.action
          }, null, 8, ["type", "disabled", "text", "onClick"])
        ])
      ]);
    };
  }
}), K5 = { class: "smake:grid smake:grid-cols-auto-fill-80 smake:gap-4 smake:overflow-y-auto smake:@sm:grid-cols-auto-fill-97" }, X5 = /* @__PURE__ */ J({
  __name: "CartVariantsTabsContent",
  emits: ["startSelectingPositioningArea", "variantChanged"],
  setup(t, { emit: e }) {
    const n = e, { fetchNextPage: s } = Da(), { data: o, fetchStatus: a, hasNextPage: i } = D(Da());
    function r() {
      return a.value === "fetching" ? !0 : i.value;
    }
    async function c() {
      a.value !== "fetching" && await s();
    }
    return (u, d) => mt(($(), I("div", K5, [
      ($(!0), I(me, null, Se(l(o), (m) => ($(), q(Cm, {
        key: m.id,
        variant: m,
        "is-deletable": "",
        "disable-repair": "",
        onVariantChanged: d[0] || (d[0] = (_) => n("variantChanged")),
        onStartSelectingPositioningArea: d[1] || (d[1] = (_) => n("startSelectingPositioningArea"))
      }, null, 8, ["variant"]))), 128)),
      l(a) === "fetching" ? ($(), I(me, { key: 0 }, [
        d[2] || (d[2] = x("div", { class: "smake:h-96 smake:animate-pulse smake:rounded-3xl smake:bg-secondary-3 smake:px-5 smake:py-8" }, null, -1)),
        d[3] || (d[3] = x("div", { class: "smake:h-96 smake:animate-pulse smake:rounded-3xl smake:bg-secondary-3 smake:px-5 smake:py-8" }, null, -1))
      ], 64)) : Q("", !0)
    ])), [
      [l($o), [c, { distance: 350, canLoadMore: r }]]
    ]);
  }
}), Q5 = Symbol("renderingFailedToast"), Xu = Symbol(
  "elementOutsidePlacementAreaToast"
), J5 = /* @__PURE__ */ J({
  __name: "Preview",
  props: {
    positioningArea: {},
    positioningAreaDesign: {},
    view: {}
  },
  emits: ["isInvalid", "isLight"],
  setup(t, { emit: e }) {
    const n = t, { positioningArea: s, positioningAreaDesign: o, view: a } = we(n), i = e, { t: r } = ct(), { close: c, open: u } = Rn(), { designerConfiguration: d } = D(tt()), m = A(
      () => {
        var w;
        return Ks[((w = d.value) == null ? void 0 : w.settings.settings.units.length) ?? "mm"] ?? 1;
      }
    ), { isLight: _ } = Gs(s, a), g = N(), v = No(g, s), z = Ol(
      A(() => o.value.design),
      m
    ), h = N("idle"), y = N("pending");
    return it([h, y], ([w, P]) => {
      P === "error" && w === "idle" && u(ln, {
        id: Q5,
        input: {
          text: r("error_pusher_rendering_failed"),
          type: "info"
        }
      });
    }), re(() => {
      if (v.value) {
        u(ln, {
          id: Xu,
          input: {
            text: r("element_outside_placement_area"),
            type: "error"
          }
        });
        return;
      }
      c(Xu);
    }), re(() => {
      i("isInvalid", v.value);
    }), re(() => {
      i("isLight", _.value);
    }), (w, P) => ($(), q(l(Oo), null, {
      default: C(() => [
        b(l(Do), {
          data: l(a),
          "initial-position": l(Vo)(
            l(s),
            10 / m.value
          )
        }, {
          default: C(() => [
            b(l(Ro), {
              data: l(s),
              "stroke-color": l(v) ? 16711680 : l(_) ? 4605510 : 14474460
            }, {
              default: C(() => [
                b(l(Lo), {
                  data: l(o),
                  placeholder: {
                    color: 13948116,
                    radius: 6 / m.value,
                    ...l(z)
                  },
                  "onUpdate:boundingBox": P[0] || (P[0] = (M) => g.value = M),
                  "onUpdate:fetchStatus": P[1] || (P[1] = (M) => h.value = M),
                  "onUpdate:status": P[2] || (P[2] = (M) => y.value = M)
                }, null, 8, ["data", "placeholder"])
              ]),
              _: 1
            }, 8, ["data", "stroke-color"])
          ]),
          _: 1
        }, 8, ["data", "initial-position"])
      ]),
      _: 1
    }));
  }
}), Y5 = { class: "smake:flex smake:flex-col smake:gap-4 smake:@md:flex-row" }, e$ = { class: "smake:flex smake:flex-col smake:overflow-clip smake:rounded-xl smake:border smake:border-secondary-2 smake:@md:flex-1" }, t$ = { class: "smake:bg-secondary-3 smake:p-4 smake:text-sm" }, n$ = { class: "smake:font-bold smake:uppercase" }, s$ = {
  key: 0,
  class: "smake:m-4 smake:flex smake:grow smake:flex-col smake:items-center smake:justify-center smake:gap-4 smake:rounded-xl smake:bg-secondary-3 smake:p-4 smake:text-center smake:text-sm smake:text-danger"
}, o$ = {
  key: 1,
  class: "smake:grow smake:p-4"
}, a$ = /* @__PURE__ */ J({
  __name: "InvalidTextDesign",
  props: {
    name: {},
    index: {},
    length: {},
    positioningArea: {},
    positioningAreaDesign: {},
    textDesign: {},
    unsupportedTextLines: {},
    view: {}
  },
  emits: ["status"],
  setup(t, { emit: e }) {
    const n = t, { positioningArea: s, positioningAreaDesign: o, unsupportedTextLines: a } = we(n), i = e, r = N(!0), c = N(!1), { fetchStatus: u, status: d } = ei(
      A(() => ({
        design: o.value.design,
        productionMethodId: s.value.productionMethodId
      })),
      A(() => a.value.length === 0)
    ), m = A(() => u.value === "fetching" ? "pending" : a.value.length > 0 || c.value ? "error" : d.value);
    return re(() => {
      i("status", m.value);
    }), (_, g) => {
      var z, h;
      const v = xe("FontAwesomeIcon");
      return $(), I("div", Y5, [
        x("div", e$, [
          x("div", t$, [
            x("span", n$, L(_.$t("icon")) + " " + L(_.index + 1) + "/" + L(_.length) + ": ", 1),
            he(" " + L(_.name), 1)
          ]),
          l(a).length > 0 ? ($(), I("div", s$, [
            b(v, {
              icon: ["fak", "icon-ciconfig-alert-warning"],
              "fixed-width": "",
              class: "smake:size-7.5 smake:text-danger smake:@md:size-10"
            }),
            he(" " + L(_.$t("please_correct_the_highlighted_errors")), 1)
          ])) : ($(), I("div", o$, [
            b(J5, {
              class: "smake:size-full smake:rounded-xl",
              view: _.view,
              "positioning-area": l(s),
              "positioning-area-design": l(o),
              onIsInvalid: g[0] || (g[0] = (y) => c.value = y),
              onIsLight: g[1] || (g[1] = (y) => r.value = y)
            }, null, 8, ["view", "positioning-area", "positioning-area-design"])
          ]))
        ]),
        b(Vl, {
          class: "smake:@md:flex-1",
          "is-light": r.value,
          data: _.textDesign,
          "production-method-id": l(s).productionMethodId,
          "initial-selected-line": (h = (z = l(a)) == null ? void 0 : z[0]) == null ? void 0 : h.textLine
        }, null, 8, ["is-light", "data", "production-method-id", "initial-selected-line"])
      ]);
    };
  }
}), i$ = { class: "smake:flex smake:grow smake:flex-col smake:gap-4 smake:overflow-y-auto" }, r$ = { class: "smake:text-sm" }, l$ = { class: "smake:flex smake:flex-col smake:justify-between smake:gap-4 smake:@max-md:justify-center smake:@sm:flex-row" }, c$ = {
  key: 2,
  class: "smake:flex smake:flex-col smake:gap-4 smake:@sm:flex-row"
}, u$ = /* @__PURE__ */ J({
  __name: "VariantRepairWizard",
  props: /* @__PURE__ */ Ae({
    id: {},
    variant: {}
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Ae(["closed", "resolve"], ["update:open"]),
  setup(t, { emit: e }) {
    const n = t, { id: s, variant: o } = we(n), a = e, i = Ne(t, "open"), { appConfiguration: r } = D(tt()), { t: c } = ct(), { open: u } = Rn(), d = N([]), m = N(0);
    re(() => {
      d.value = Wn(o.value.views), m.value = 0;
    });
    const _ = A(() => r.value ? o.value.views.flatMap(
      (j, V) => j.positioningAreas.flatMap(
        (X, Z) => X.designs.map(
          (ae, K) => {
            const te = Ms(
              ae.design
            );
            if (!(!te || Oa(
              r.value,
              te.lines,
              X.productionMethodId
            ).length === 0))
              return {
                positioningAreaDesignIndex: K,
                positioningAreaIndex: Z,
                viewIndex: V
              };
          }
        )
      )
    ).filter(
      (j) => j !== void 0
    ) : []), g = A(() => r.value ? _.value.map(
      ({ positioningAreaDesignIndex: j, positioningAreaIndex: V, viewIndex: X }) => {
        const Z = d.value[X], ae = (
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          Z.positioningAreas[V]
        ), K = (
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          ae.designs[j]
        ), te = Ms(K.design), ue = Oa(
          r.value,
          te.lines,
          ae.productionMethodId
        );
        return {
          positioningArea: ae,
          positioningAreaDesign: K,
          textDesign: te,
          unsupportedTextLines: ue,
          view: Z
        };
      }
    ) : []), v = A(() => g.value[m.value]), z = N("pending"), { mutateAsync: h, status: y } = yt({
      ...Wb(),
      onError: () => {
        u(ln, {
          input: {
            text: c("boot_error.unexpected"),
            type: "info"
          }
        });
      }
    }), w = N(!1);
    async function P(j) {
      w.value = !!j;
      const V = await h({
        favoriteVariantIdToDelete: s.value,
        favoriteVariantToCreate: {
          resource: {
            id: o.value.id,
            views: d.value.map((X) => lm(X))
          }
        }
      });
      a("resolve", { favoriteVariant: V, load: !!j }), i.value = !1;
    }
    const M = A(
      () => y.value === "pending" && !w.value
    ), E = A(
      () => y.value === "pending" && w.value
    ), R = A(
      () => z.value !== "success" || y.value === "pending"
    );
    return (j, V) => ($(), q($m, {
      open: i.value,
      "onUpdate:open": V[5] || (V[5] = (X) => i.value = X),
      title: j.$t("font_update"),
      "prevent-close": l(y) === "pending",
      onClosed: V[6] || (V[6] = (X) => a("closed"))
    }, {
      default: C(() => [
        x("div", i$, [
          x("div", r$, L(j.$t("font_update_explanation")), 1),
          v.value ? ($(), q(a$, {
            key: m.value,
            class: "smake:grow",
            index: m.value,
            length: g.value.length,
            name: l(o).name,
            view: v.value.view,
            "positioning-area": v.value.positioningArea,
            "positioning-area-design": v.value.positioningAreaDesign,
            "text-design": v.value.textDesign,
            "unsupported-text-lines": v.value.unsupportedTextLines,
            onStatus: V[0] || (V[0] = (X) => z.value = X)
          }, null, 8, ["index", "length", "name", "view", "positioning-area", "positioning-area-design", "text-design", "unsupported-text-lines"])) : Q("", !0)
        ]),
        x("div", l$, [
          m.value === 0 ? ($(), q(l(zt), {
            key: 0,
            "as-child": ""
          }, {
            default: C(() => [
              b(et, {
                class: "smake:@max-md:hidden",
                type: "secondary",
                text: j.$t("abort"),
                icon: {
                  type: ["fak", "icon-x"]
                },
                disabled: l(y) === "pending"
              }, null, 8, ["text", "disabled"])
            ]),
            _: 1
          })) : ($(), q(et, {
            key: 1,
            type: "secondary",
            disabled: l(y) === "pending",
            icon: {
              type: ["fal", "chevron-left"]
            },
            text: j.$t("back"),
            onClick: V[1] || (V[1] = (X) => m.value -= 1)
          }, null, 8, ["disabled", "text"])),
          m.value + 1 === g.value.length ? ($(), I("div", c$, [
            b(et, {
              type: "secondary",
              disabled: R.value,
              icon: {
                type: M.value ? ["fal", "spinner"] : ["fak", "icon-save"],
                spin: M.value
              },
              text: j.$t("save"),
              onClick: V[2] || (V[2] = (X) => P())
            }, null, 8, ["disabled", "icon", "text"]),
            b(et, {
              type: "primary",
              icon: {
                type: ["fal", E.value ? "spinner" : "check"],
                spin: E.value
              },
              disabled: R.value,
              text: j.$t("save_and_load"),
              onClick: V[3] || (V[3] = (X) => P(!0))
            }, null, 8, ["icon", "disabled", "text"])
          ])) : ($(), q(et, {
            key: 3,
            type: "primary",
            disabled: z.value !== "success",
            text: j.$t("next_motif"),
            icon: {
              type: ["fal", "chevron-right"],
              position: "after"
            },
            onClick: V[4] || (V[4] = (X) => m.value += 1)
          }, null, 8, ["disabled", "text"]))
        ])
      ]),
      _: 1
    }, 8, ["open", "title", "prevent-close"]));
  }
}), d$ = { class: "smake:absolute smake:top-1/2 smake:left-1/2 smake:mx-auto smake:flex smake:h-fit smake:max-h-full smake:w-auto smake:max-w-150 smake:-translate-x-1/2 smake:-translate-y-1/2 smake:flex-col smake:gap-6 smake:rounded-3xl smake:bg-white smake:p-4" }, p$ = { class: "smake:flex smake:items-start smake:justify-between smake:gap-2" }, m$ = { class: "smake:font-bold smake:text-primary-1" }, h$ = { class: "smake:relative smake:mt-3 smake:items-center smake:justify-between smake:bg-white" }, f$ = { class: "smake:flex smake:justify-center smake:gap-5" }, _$ = { class: "smake:flex smake:flex-wrap smake:justify-between smake:gap-5" }, v$ = { key: 1 }, g$ = /* @__PURE__ */ J({
  __name: "VariantDeleteDialog",
  props: /* @__PURE__ */ Ae({
    apiVariant: {}
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Ae(["closed"], ["update:open"]),
  setup(t, { emit: e }) {
    const n = Ne(t, "open"), s = e, { rootElement: o } = D(jt()), { t: a } = ct(), i = t, { apiVariant: r } = we(i), { isPending: c, mutate: u } = yt(
      ce.favorites.delete.use()
    );
    function d(m) {
      c.value && m.preventDefault();
    }
    return (m, _) => {
      const g = xe("I18nT"), v = xe("FontAwesomeIcon");
      return $(), q(l(Ct), {
        open: n.value,
        "onUpdate:open": _[2] || (_[2] = (z) => n.value = z)
      }, {
        default: C(() => [
          b(l(Pt), { to: l(o) }, {
            default: C(() => [
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:opacity-0",
                onAfterLeave: _[0] || (_[0] = (z) => s("closed"))
              }, {
                default: C(() => [
                  b(l(Mt), { class: "smake:fixed smake:inset-0 smake:bg-black/40" })
                ]),
                _: 1
              }),
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:scale-95 smake:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:scale-95 smake:opacity-0"
              }, {
                default: C(() => [
                  b(l(Tt), {
                    "as-child": "",
                    onInteractOutside: d,
                    onEscapeKeyDown: d
                  }, {
                    default: C(() => [
                      x("div", d$, [
                        x("div", p$, [
                          b(l(At), null, {
                            default: C(() => [
                              b(g, {
                                keypath: "are_you_sure_you_want_to_delete",
                                tag: "div"
                              }, {
                                deleteName: C(() => [
                                  x("span", m$, L(l(r).resource.name), 1)
                                ]),
                                default: C(() => [
                                  _[3] || (_[3] = he(" > ", -1))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          b(l(zt), { class: "smake:-mt-2 smake:-mr-2 smake:rounded-full smake:border smake:border-secondary-2 smake:p-2 smake:duration-150 smake:hover:bg-secondary-3" }, {
                            default: C(() => [
                              b(v, {
                                icon: ["fak", "icon-x"],
                                "fixed-width": "",
                                class: "smake:size-3"
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        x("div", h$, [
                          x("div", f$, [
                            ($(!0), I(me, null, Se(l(r).resource.views, (z) => ($(), I(me, {
                              key: l(ft)(z)
                            }, [
                              ($(!0), I(me, null, Se(z.customizations, (h) => ($(), q(Fl, {
                                key: h.id,
                                data: h
                              }, null, 8, ["data"]))), 128))
                            ], 64))), 128))
                          ])
                        ]),
                        x("div", _$, [
                          b(l(zt), { "as-child": "" }, {
                            default: C(() => [
                              b(Re, {
                                class: "smake:grow",
                                type: "outline"
                              }, {
                                default: C(() => [
                                  he(L(l(a)("abort")), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          b(Re, {
                            class: "smake:grow",
                            type: "primary",
                            disabled: l(c),
                            onClick: _[1] || (_[1] = (z) => l(u)(l(r).id))
                          }, {
                            default: C(() => [
                              l(c) ? ($(), q(v, {
                                key: 0,
                                class: "smake:h-6 smake:animate-spin",
                                icon: ["fal", "spinner"]
                              })) : ($(), I("span", v$, L(l(a)("delete")), 1))
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _: 1
      }, 8, ["open"]);
    };
  }
}), k$ = /* @__PURE__ */ J({
  __name: "FavoriteVariantCard",
  props: {
    favoriteVariant: {}
  },
  emits: ["repair", "startSelectingPositioningArea", "variantChanged"],
  setup(t, { emit: e }) {
    const n = t, { favoriteVariant: s } = we(n), o = e;
    function a() {
      i(g$, {
        input: { apiVariant: s.value }
      });
    }
    const { open: i } = pn();
    return (r, c) => {
      const u = xe("FontAwesomeIcon");
      return $(), q(Cm, {
        variant: l(s).resource,
        onVariantChanged: c[0] || (c[0] = (d) => o("variantChanged")),
        onStartSelectingPositioningArea: c[1] || (c[1] = (d) => o("startSelectingPositioningArea")),
        onRepair: c[2] || (c[2] = (d) => o("repair"))
      }, {
        "header-right": C(() => [
          b(Re, {
            type: "secondary",
            class: "smake:flex smake:size-7.5 smake:items-center smake:justify-center smake:rounded-full smake:bg-white smake:disabled:cursor-not-allowed",
            onClick: a
          }, {
            default: C(() => [
              b(u, {
                class: "smake:h-7",
                icon: ["fak", "icon-remove"],
                "fixed-width": ""
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["variant"]);
    };
  }
}), Qu = /* @__PURE__ */ J({
  __name: "VariantCollectionTabsContent",
  props: {
    collectionName: {}
  },
  emits: ["startSelectingPositioningArea", "variantChanged"],
  setup(t, { emit: e }) {
    const n = t, { collectionName: s } = we(n), o = e, a = Ds(
      "favoriteVariantCardsContainer"
    ), { y: i } = md(a, { behavior: "smooth" }), { data: r, fetchNextPage: c, fetchStatus: u, hasNextPage: d } = nl(s), { open: m } = pn(), _ = Qt(), { variantId: g } = D(_);
    function v() {
      return u.value === "fetching" ? !0 : d.value;
    }
    async function z() {
      u.value !== "fetching" && await c();
    }
    async function h(y) {
      const w = await m(u$, {
        input: {
          id: y.id,
          variant: {
            id: y.resource.id,
            name: y.resource.name,
            views: y.resource.views.map(
              (P) => El(P)
            )
          }
        }
      });
      w !== void 0 && (i.value = 0), w != null && w.load && (g.value = w.favoriteVariant.resource.id, await _.suspense(), o("variantChanged"));
    }
    return (y, w) => mt(($(), I("div", {
      ref_key: "favoriteVariantCardsContainer",
      ref: a,
      class: "smake:grid smake:grid-cols-auto-fill-80 smake:gap-4 smake:overflow-y-auto smake:@sm:grid-cols-auto-fill-97"
    }, [
      ($(!0), I(me, null, Se(l(r), (P) => ($(), q(k$, {
        key: P.id,
        "favorite-variant": P,
        "is-deletable": "",
        onVariantChanged: w[0] || (w[0] = (M) => o("variantChanged")),
        onStartSelectingPositioningArea: w[1] || (w[1] = (M) => o("startSelectingPositioningArea")),
        onRepair: (M) => h(P)
      }, null, 8, ["favorite-variant", "onRepair"]))), 128)),
      l(u) === "fetching" ? ($(), I(me, { key: 0 }, [
        w[2] || (w[2] = x("div", { class: "smake:h-96 smake:animate-pulse smake:rounded-3xl smake:bg-secondary-3 smake:px-5 smake:py-8" }, null, -1)),
        w[3] || (w[3] = x("div", { class: "smake:h-96 smake:animate-pulse smake:rounded-3xl smake:bg-secondary-3 smake:px-5 smake:py-8" }, null, -1))
      ], 64)) : Q("", !0)
    ])), [
      [l($o), [z, { distance: 350, canLoadMore: v }]]
    ]);
  }
}), y$ = { class: "smake:absolute smake:inset-0 smake:top-16 smake:mx-auto smake:flex smake:w-420 smake:max-w-full smake:flex-col smake:gap-4 smake:rounded-3xl smake:rounded-b-none smake:bg-white smake:p-4 smake:@sm:inset-12 smake:@sm:max-w-[calc(100%-96px)] smake:@sm:rounded-b-3xl" }, b$ = { class: "smake:flex smake:items-start smake:justify-between smake:gap-2" }, w$ = {
  key: 0,
  class: "smake:flex smake:gap-2"
}, x$ = {
  key: 0,
  class: "smake:mb-4 smake:animate-pulse smake:rounded-3xl smake:bg-secondary-3 smake:px-5 smake:py-8 smake:@md:bg-white"
}, ii = /* @__PURE__ */ J({
  __name: "VariantsDialog",
  props: /* @__PURE__ */ Ae({
    defaultTab: { default: "customer-sketch" }
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Ae(["closed"], ["update:open"]),
  setup(t, { emit: e }) {
    const n = Ne(t, "open"), s = t, o = e, { defaultTab: a } = we(s), i = N(a.value), { rootElement: r } = D(jt()), { t: c } = ct(), { data: u, isPending: d } = D(
      Da()
    ), m = A(() => {
      var E;
      return (((E = u.value) == null ? void 0 : E.length) ?? 0) > 0;
    }), { data: _, status: g } = nl("merchant-sketch"), v = A(
      () => {
        var E;
        return (((E = _.value) == null ? void 0 : E.length) ?? 0) > 0;
      }
    ), { status: z } = nl("customer-sketch"), h = A(
      () => d.value || g.value === "pending" || z.value === "pending"
    );
    function y(E) {
      E.preventDefault();
      const R = E.target;
      !(R instanceof HTMLElement) || R.closest("[data-radix-popper-content-wrapper]");
    }
    function w() {
      n.value = !1;
    }
    function P() {
      n.value = !1;
    }
    const { hasVariantsInRendering: M } = D(
      sl()
    );
    return (E, R) => {
      const j = xe("FontAwesomeIcon");
      return $(), q(l(Ct), {
        open: n.value,
        "onUpdate:open": R[2] || (R[2] = (V) => n.value = V)
      }, {
        default: C(() => [
          b(l(Pt), { to: l(r) }, {
            default: C(() => [
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:opacity-0",
                onAfterLeave: R[0] || (R[0] = (V) => o("closed"))
              }, {
                default: C(() => [
                  b(l(Mt), { class: "smake:fixed smake:inset-0 smake:bg-black/40" })
                ]),
                _: 1
              }),
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:translate-y-full smake:@sm:translate-y-0 smake:@sm:scale-95 smake:@sm:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:translate-y-full smake:@sm:translate-y-0 smake:@sm:scale-95 smake:@sm:opacity-0"
              }, {
                default: C(() => [
                  b(l(Tt), {
                    "as-child": "",
                    onInteractOutside: y
                  }, {
                    default: C(() => [
                      x("div", y$, [
                        x("div", b$, [
                          b(l(At), { class: "smake:text-2xl smake:font-bold smake:uppercase" }, {
                            default: C(() => [
                              he(L(E.$t("my_customizations")), 1)
                            ]),
                            _: 1
                          }),
                          b(l(zt), { class: "smake:-mt-2 smake:-mr-2 smake:rounded-full smake:border smake:border-secondary-2 smake:p-2 smake:duration-150 smake:hover:bg-secondary-3" }, {
                            default: C(() => [
                              b(j, {
                                icon: ["fak", "icon-x"],
                                "fixed-width": "",
                                class: "smake:size-3"
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        h.value ? ($(), I("div", w$, [
                          ($(), I(me, null, Se(2, (V) => x("div", {
                            key: V,
                            class: "smake:h-10.75 smake:w-64 smake:max-w-1/2 smake:animate-pulse smake:rounded-full smake:bg-secondary-3"
                          })), 64))
                        ])) : Q("", !0),
                        b(l(rl), {
                          modelValue: i.value,
                          "onUpdate:modelValue": R[1] || (R[1] = (V) => i.value = V),
                          class: "smake:flex smake:grow smake:flex-col smake:gap-4 smake:overflow-hidden"
                        }, {
                          default: C(() => [
                            [m.value, v.value].some(
                              (V) => V === !0
                            ) && !h.value ? ($(), q(l(ll), {
                              key: 0,
                              class: "smake:flex smake:flex-wrap smake:gap-2"
                            }, {
                              default: C(() => [
                                m.value ? ($(), q(ho, {
                                  key: 0,
                                  value: "cart",
                                  "selected-value": i.value
                                }, {
                                  default: C(() => [
                                    he(L(E.$t("currently_in_cart")), 1)
                                  ]),
                                  _: 1
                                }, 8, ["selected-value"])) : Q("", !0),
                                b(ho, {
                                  "selected-value": i.value,
                                  value: "customer-sketch"
                                }, {
                                  default: C(() => [
                                    he(L(E.$t("saved")), 1)
                                  ]),
                                  _: 1
                                }, 8, ["selected-value"]),
                                v.value ? ($(), q(ho, {
                                  key: 1,
                                  "selected-value": i.value,
                                  value: "merchant-sketch"
                                }, {
                                  default: C(() => [
                                    he(L(E.$t("sketches")), 1)
                                  ]),
                                  _: 1
                                }, 8, ["selected-value"])) : Q("", !0)
                              ]),
                              _: 1
                            })) : Q("", !0),
                            b(l(mo), {
                              "as-child": "",
                              value: "cart",
                              unmount: !1
                            }, {
                              default: C(() => [
                                b(X5, {
                                  onVariantChanged: P,
                                  onStartSelectingPositioningArea: w
                                }, null, 8, ["onStartSelectingPositioningArea"])
                              ]),
                              _: 1
                            }),
                            b(l(mo), {
                              value: "customer-sketch",
                              "as-child": "",
                              unmount: !1
                            }, {
                              default: C(() => [
                                l(M) ? ($(), I("div", x$, L(l(c)("archive_new_entry_soon_available")), 1)) : Q("", !0),
                                b(Qu, {
                                  "collection-name": "customer-sketch",
                                  onVariantChanged: P,
                                  onStartSelectingPositioningArea: w
                                }, null, 8, ["onStartSelectingPositioningArea"])
                              ]),
                              _: 1
                            }),
                            b(l(mo), {
                              value: "merchant-sketch",
                              "as-child": "",
                              unmount: !1
                            }, {
                              default: C(() => [
                                b(Qu, {
                                  "collection-name": "merchant-sketch",
                                  onVariantChanged: P,
                                  onStartSelectingPositioningArea: w
                                }, null, 8, ["onStartSelectingPositioningArea"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _: 1
      }, 8, ["open"]);
    };
  }
}), $$ = { class: "smake:absolute smake:top-1/2 smake:left-1/2 smake:mx-auto smake:flex smake:h-fit smake:max-h-full smake:w-auto smake:max-w-120 smake:-translate-x-1/2 smake:-translate-y-1/2 smake:flex-col smake:gap-6 smake:rounded-3xl smake:bg-white smake:p-4" }, z$ = { class: "smake:flex smake:items-start smake:justify-between smake:gap-2" }, S$ = { class: "smake:@md:hidden" }, A$ = { class: "smake:hidden smake:@md:inline" }, C$ = /* @__PURE__ */ J({
  __name: "MerchantSketchVariantAddedDialog",
  props: {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  },
  emits: /* @__PURE__ */ Ae(["closed"], ["update:open"]),
  setup(t, { emit: e }) {
    const n = e, s = Ne(t, "open"), { rootElement: o } = D(jt()), { open: a } = pn();
    async function i() {
      s.value = !1, await a(ii, {
        input: { defaultTab: "merchant-sketch" },
        removeOnUnmount: !1
      });
    }
    return (r, c) => {
      const u = xe("FontAwesomeIcon");
      return $(), q(l(Ct), {
        open: s.value,
        "onUpdate:open": c[1] || (c[1] = (d) => s.value = d)
      }, {
        default: C(() => [
          b(l(Pt), { to: l(o) }, {
            default: C(() => [
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:opacity-0",
                onAfterLeave: c[0] || (c[0] = (d) => n("closed"))
              }, {
                default: C(() => [
                  b(l(Mt), { class: "smake:fixed smake:inset-0 smake:bg-black/40" })
                ]),
                _: 1
              }),
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:scale-95 smake:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:scale-95 smake:opacity-0"
              }, {
                default: C(() => [
                  b(l(Tt), { "as-child": "" }, {
                    default: C(() => [
                      x("div", $$, [
                        x("div", z$, [
                          b(l(At), { class: "smake:text-xl smake:font-bold" }, {
                            default: C(() => [
                              he(L(r.$t("new_sketch")), 1)
                            ]),
                            _: 1
                          }),
                          b(l(zt), { class: "smake:-mt-2 smake:-mr-2 smake:rounded-full smake:border smake:border-secondary-2 smake:p-2 smake:duration-150 smake:hover:bg-secondary-3" }, {
                            default: C(() => [
                              b(u, {
                                icon: ["fak", "icon-x"],
                                "fixed-width": "",
                                class: "smake:size-3"
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        x("span", S$, L(r.$t("merchant_sketch_variant_added", {
                          buttonName: r.$t("archive")
                        })), 1),
                        x("span", A$, L(r.$t("merchant_sketch_variant_added", {
                          buttonName: r.$t("my_customizations")
                        })), 1),
                        b(Re, {
                          type: "primary",
                          class: "smake:px-4 smake:py-3",
                          onClick: i
                        }, {
                          default: C(() => [
                            he(L(r.$t("show_sketches")), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _: 1
      }, 8, ["open"]);
    };
  }
}), xo = st(
  "productionMethodSelection",
  () => {
    const { availableProductionMethodIds: t, designsProductionMethodIds: e } = D(Je()), n = N(!1), s = N(!1), o = N(!1);
    re(() => {
      e.value !== void 0 && t.value !== void 0 && (n.value || (n.value = !0, t.value.size !== 1 && e.value.size !== 1 && (s.value = !0)));
    });
    const a = A(
      () => s.value || o.value
    );
    function i() {
      s.value = !1, o.value = !1;
    }
    return {
      closeAllProductionMethodSelections: i,
      isAProductionMethodSelectionOpen: a,
      isProductionMethodSelectionCompactOpen: o,
      isProductionMethodSelectionOpen: s
    };
  }
), P$ = ["disabled"], M$ = { class: "smake:flex smake:flex-col smake:items-center smake:justify-center smake:gap-0.5" }, T$ = { class: "smake:font-bold" }, I$ = {
  key: 0,
  class: "smake:text-sm"
}, E$ = /* @__PURE__ */ J({
  __name: "SelectButton",
  props: {
    productionMethodId: {}
  },
  setup(t) {
    const e = t, { productionMethodId: n } = we(e), {
      isAvailableOnCurrentVariant: s,
      isSelected: o,
      productionMethod: a,
      shortDescription: i
    } = It(n);
    return (r, c) => l(a) ? ($(), I("button", {
      key: 0,
      class: ke(["smake:flex smake:items-center smake:justify-between smake:gap-8 smake:rounded-full smake:border smake:px-1 smake:py-1 smake:hover:border-black smake:focus:border-black smake:disabled:border-secondary-2 smake:disabled:text-secondary-2 smake:disabled:hover:bg-white", {
        "smake:border-black smake:bg-black smake:text-white": l(o),
        "smake:border-secondary-2": !l(o),
        "smake:text-slate-400 smake:grayscale-[98%]": !l(s)
      }]),
      disabled: !l(s)
    }, [
      b(on, {
        src: l(a).preview_url,
        class: "smake:size-16 smake:rounded-full smake:object-cover smake:data-[state=pending]:animate-pulse smake:data-[state=pending]:bg-secondary-2"
      }, null, 8, ["src"]),
      x("div", M$, [
        x("div", T$, L(l(a).display_name), 1),
        l(i) ? ($(), I("div", I$, L(l(i)), 1)) : Q("", !0)
      ]),
      c[0] || (c[0] = x("div", null, null, -1))
    ], 10, P$)) : Q("", !0);
  }
}), O$ = { class: "smake:absolute smake:inset-x-0 smake:top-20 smake:mx-auto smake:flex smake:max-w-fit smake:flex-col smake:gap-6 smake:rounded-3xl smake:bg-white smake:p-4" }, R$ = { class: "smake:flex smake:items-start smake:justify-between smake:gap-2" }, L$ = { class: "smake:flex smake:flex-col smake:gap-4" }, D$ = /* @__PURE__ */ J({
  __name: "CompactDialog",
  setup(t) {
    const { rootElement: e } = D(jt()), { activatedProductionMethodIds: n, selectedProductionMethodId: s } = D(Je()), {
      isProductionMethodSelectionCompactOpen: o,
      isProductionMethodSelectionOpen: a
    } = D(xo());
    function i(u) {
      u.preventDefault();
      const d = u.target;
      !(d instanceof HTMLElement) || d.closest("[data-radix-popper-content-wrapper]");
    }
    function r() {
      o.value = !1, a.value = !0;
    }
    function c(u) {
      s.value = u, o.value = !1;
    }
    return (u, d) => {
      const m = xe("FontAwesomeIcon");
      return $(), q(l(Ct), {
        open: l(o),
        "onUpdate:open": d[0] || (d[0] = (_) => Lt(o) ? o.value = _ : null)
      }, {
        default: C(() => [
          b(l(Pt), { to: l(e) }, {
            default: C(() => [
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:opacity-0"
              }, {
                default: C(() => [
                  b(l(Mt), { class: "smake:fixed smake:inset-0 smake:bg-black/40" })
                ]),
                _: 1
              }),
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:scale-95 smake:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:scale-98 smake:opacity-0 smake:-translate-y-5 "
              }, {
                default: C(() => [
                  b(l(Tt), {
                    "as-child": "",
                    onInteractOutside: i
                  }, {
                    default: C(() => [
                      x("div", O$, [
                        x("div", R$, [
                          b(l(At), { class: "smake:text-xl smake:font-bold smake:tracking-wider smake:uppercase" }, {
                            default: C(() => [
                              he(L(u.$t("choose_production_method")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        x("div", L$, [
                          ($(!0), I(me, null, Se(l(n), (_) => ($(), q(E$, {
                            key: _,
                            "production-method-id": _,
                            onClick: (g) => c(_)
                          }, null, 8, ["production-method-id", "onClick"]))), 128))
                        ]),
                        b(Re, {
                          type: "secondary",
                          class: "smake:flex smake:justify-center smake:gap-3 smake:py-3 smake:font-semibold",
                          onClick: r
                        }, {
                          default: C(() => [
                            he(L(u.$t("go_to_production_method_overview")) + " ", 1),
                            b(m, {
                              icon: ["fal", "chevron-right"],
                              class: "smake:size-5"
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _: 1
      }, 8, ["open"]);
    };
  }
}), j$ = { class: "smake:relative smake:flex smake:h-full smake:flex-col smake:overflow-clip smake:rounded-3xl" }, N$ = { class: "relative rounded-t-3xl bg-secondary-2" }, V$ = {
  key: 0,
  class: "smake:absolute smake:top-3 smake:left-3 smake:flex smake:size-10 smake:items-center smake:justify-center smake:rounded-full smake:bg-white smake:p-1"
}, U$ = { class: "smake:flex smake:grow smake:flex-col smake:items-center smake:gap-5 smake:bg-secondary-3 smake:p-4 smake:px-6 smake:text-center smake:[overflow-wrap:anywhere]" }, F$ = { class: "smake:mt-4 smake:text-xl smake:font-bold" }, B$ = { class: "smake:flex smake:min-h-24 smake:w-full smake:flex-col smake:items-start smake:justify-start smake:gap-2 smake:text-left smake:text-sm" }, q$ = { class: "smake:flex smake:items-center smake:gap-3" }, H$ = { class: "smake:flex smake:size-4 smake:items-center smake:justify-center smake:rounded-full smake:bg-white smake:text-xs smake:text-success" }, W$ = { class: "smake:flex smake:items-center smake:gap-3" }, G$ = { class: "smake:flex smake:size-4 smake:items-center smake:justify-center smake:rounded-full smake:bg-white smake:text-xs smake:text-success" }, Z$ = { class: "smake:flex smake:items-center smake:gap-3" }, K$ = { class: "smake:flex smake:size-4 smake:items-center smake:justify-center smake:rounded-full smake:bg-white smake:text-xs smake:text-success" }, X$ = { class: "smake:mx-2 smake:flex smake:w-full smake:flex-col smake:divide-y smake:divide-secondary-2 smake:rounded-2xl smake:bg-white smake:px-4 smake:py-1 smake:text-sm" }, Q$ = { class: "smake:grid smake:grid-cols-2 smake:items-center smake:py-3" }, J$ = { class: "smake:font-bold" }, Y$ = { class: "smake:grid smake:grid-cols-2 smake:items-center smake:py-3" }, e7 = { class: "smake:font-bold" }, t7 = { class: "smake:grid smake:grid-cols-2 smake:items-center smake:py-3" }, n7 = { class: "smake:font-bold" }, s7 = { class: "smake:grid smake:grid-cols-2 smake:items-center smake:py-3" }, o7 = { class: "smake:font-bold" }, a7 = {
  key: 0,
  class: "smake:flex smake:w-full smake:items-center smake:justify-center smake:rounded-b-3xl smake:bg-secondary-3 smake:p-6"
}, i7 = {
  key: 1,
  class: "smake:absolute smake:inset-0 smake:flex smake:items-center smake:justify-center smake:bg-gray-800/20"
}, r7 = { class: "text-center smake:mx-10 smake:rounded-3xl smake:bg-white smake:px-6 smake:py-3 smake:text-black smake:shadow" }, l7 = /* @__PURE__ */ J({
  __name: "SelectCard",
  props: {
    productionMethodId: {}
  },
  emits: ["select"],
  setup(t, { emit: e }) {
    const { t: n } = ct(), s = e, o = t, { productionMethodId: a } = we(o), { icon: i, isAvailableOnCurrentVariant: r, productionMethod: c } = It(a), { activatedProductionMethodIds: u } = D(
      Je()
    );
    return (d, m) => {
      var g;
      const _ = xe("FontAwesomeIcon");
      return l(c) ? ($(), I("div", {
        key: 0,
        class: ke({
          "smake:text-slate-400 smake:grayscale-[98%]": !l(r)
        })
      }, [
        x("div", j$, [
          x("div", N$, [
            b(on, {
              class: "smake:h-40 smake:w-full smake:object-cover smake:data-[state=pending]:animate-pulse smake:data-[state=pending]:bg-secondary-2",
              src: l(c).preview_url
            }, null, 8, ["src"]),
            l(i) ? ($(), I("div", V$, [
              b(_, {
                class: "smake:size-6",
                icon: l(i),
                "fixed-width": ""
              }, null, 8, ["icon"])
            ])) : Q("", !0)
          ]),
          x("div", U$, [
            x("div", F$, L(l(c).display_name), 1),
            x("div", B$, [
              x("div", q$, [
                x("div", H$, [
                  b(_, {
                    class: "smake:size-4",
                    icon: ["fal", "check"]
                  })
                ]),
                x("div", null, L(d.$t(`${l(c).handle}_selling_point_1`)), 1)
              ]),
              x("div", W$, [
                x("div", G$, [
                  b(_, {
                    class: "smake:size-4",
                    icon: ["fal", "check"]
                  })
                ]),
                x("div", null, L(d.$t(`${l(c).handle}_selling_point_2`)), 1)
              ]),
              x("div", Z$, [
                x("div", K$, [
                  b(_, {
                    class: "smake:size-4",
                    icon: ["fal", "check"]
                  })
                ]),
                x("div", null, L(d.$t(`${l(c).handle}_selling_point_3`)), 1)
              ])
            ]),
            x("div", X$, [
              x("div", Q$, [
                x("div", J$, L(d.$t("look")), 1),
                x("div", null, L(d.$t(`${l(c).handle}_look`)), 1)
              ]),
              x("div", Y$, [
                x("div", e7, L(d.$t("washablility")), 1),
                x("div", null, L(d.$t(`${l(c).handle}_washability`)), 1)
              ]),
              x("div", t7, [
                x("div", n7, L(d.$t("minimum_quantity")), 1),
                x("div", null, L(d.$t("from_one_piece")), 1)
              ]),
              x("div", s7, [
                x("div", o7, L(d.$t("textiles")), 1),
                x("div", null, L(d.$t(`${l(c).handle}_textiles`)), 1)
              ])
            ])
          ]),
          (((g = l(u)) == null ? void 0 : g.size) ?? 0) > 1 ? ($(), I("div", a7, [
            b(Re, {
              "data-testid": `selectProductionMethod-${l(a)}`,
              type: "primary",
              class: "smake:grow smake:p-3 smake:text-xs",
              disabled: !l(r),
              onClick: m[0] || (m[0] = (v) => s("select"))
            }, {
              default: C(() => [
                he(L(l(n)("continue_with_x", {
                  x: l(c).display_name
                })), 1)
              ]),
              _: 1
            }, 8, ["data-testid", "disabled"])
          ])) : Q("", !0),
          l(r) ? Q("", !0) : ($(), I("div", i7, [
            x("div", r7, L(d.$t("production_method_not_available_for_variant")), 1)
          ]))
        ])
      ], 2)) : Q("", !0);
    };
  }
}), c7 = {
  "data-testid": "ProductionMethodSelectionExpandedDialog",
  class: "smake:absolute smake:inset-x-0 smake:top-20 smake:mx-auto smake:flex smake:max-h-[calc(100%-80px)] smake:w-md smake:max-w-full smake:flex-col smake:gap-4 smake:overflow-y-auto smake:rounded-3xl smake:bg-white smake:p-6 smake:@max-md:rounded-b-none"
}, u7 = { class: "smake:flex smake:items-start smake:justify-between smake:gap-2" }, d7 = /* @__PURE__ */ J({
  __name: "ExpandedDialog",
  setup(t) {
    const { rootElement: e } = D(jt()), { activatedProductionMethodIds: n, selectedProductionMethodId: s } = D(Je()), { isProductionMethodSelectionOpen: o } = D(
      xo()
    ), { closeAllProductionMethodSelections: a } = xo();
    function i(c) {
      c.preventDefault();
      const u = c.target;
      !(u instanceof HTMLElement) || u.closest("[data-radix-popper-content-wrapper]");
    }
    function r(c) {
      s.value = c, a();
    }
    return (c, u) => ($(), q(l(Ct), {
      open: l(o),
      "onUpdate:open": u[0] || (u[0] = (d) => Lt(o) ? o.value = d : null)
    }, {
      default: C(() => [
        b(l(Pt), { to: l(e) }, {
          default: C(() => [
            b(De, {
              appear: "",
              "enter-active-class": "smake:duration-300 smake:ease-out",
              "enter-from-class": "smake:opacity-0",
              "leave-active-class": "smake:duration-200 smake:ease-in",
              "leave-to-class": "smake:opacity-0"
            }, {
              default: C(() => [
                b(l(Mt), { class: "smake:fixed smake:inset-0 smake:bg-black/40" })
              ]),
              _: 1
            }),
            b(De, {
              appear: "",
              "enter-active-class": "smake:duration-300 smake:ease-out",
              "enter-from-class": "smake:scale-95 smake:opacity-0",
              "leave-active-class": "smake:duration-200 smake:ease-in",
              "leave-to-class": "smake:scale-98 smake:opacity-0 smake:-translate-y-5 "
            }, {
              default: C(() => [
                b(l(Tt), {
                  "as-child": "",
                  onInteractOutside: i
                }, {
                  default: C(() => {
                    var d;
                    return [
                      x("div", c7, [
                        x("div", u7, [
                          b(l(At), { class: "smake:text-xl smake:font-bold smake:tracking-wider smake:uppercase" }, {
                            default: C(() => [
                              he(L(c.$t("choose_production_method")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        x("div", {
                          class: ke(["smake:flex smake:shrink-0 smake:gap-6 smake:bg-white smake:@max-md:flex-col smake:@md:overflow-x-auto", {
                            "smake:justify-center": ((d = l(n)) == null ? void 0 : d.size) === 1
                          }])
                        }, [
                          ($(!0), I(me, null, Se(l(n), (m) => ($(), q(l7, {
                            key: m,
                            class: "smake:shrink-0 smake:@md:basis-[calc(50%-12px)]",
                            "production-method-id": m,
                            onSelect: (_) => r(m)
                          }, null, 8, ["production-method-id", "onSelect"]))), 128))
                        ], 2)
                      ])
                    ];
                  }),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _: 1
    }, 8, ["open"]));
  }
}), p7 = {
  key: 1,
  class: "smake:size-4 smake:animate-pulse smake:rounded-full smake:bg-secondary-2"
}, m7 = {
  key: 2,
  class: "smake:text-xs smake:uppercase"
}, h7 = {
  key: 3,
  class: "smake:h-4 smake:w-30 smake:animate-pulse smake:rounded-lg smake:bg-secondary-2"
}, f7 = {
  key: 5,
  class: "smake:size-4 smake:animate-pulse smake:rounded-full smake:bg-secondary-2"
}, _7 = /* @__PURE__ */ J({
  __name: "ProductionMethodSelection",
  setup(t) {
    const { activatedProductionMethodIds: e, selectedProductionMethodId: n } = D(Je()), s = A(() => {
      var v;
      return (v = r.value) == null ? void 0 : v.productionMethods.find(
        ({ id: z }) => z === n.value
      );
    }), {
      isAProductionMethodSelectionOpen: o,
      isProductionMethodSelectionCompactOpen: a
    } = D(xo()), { closeAllProductionMethodSelections: i } = xo(), { appConfiguration: r, status: c } = D(tt()), { icon: u, productionMethod: d } = It(
      n
    ), m = A(() => {
      var v;
      return ((v = e.value) == null ? void 0 : v.size) === 1 ? ["fak", "icon-info"] : o.value ? ["fal", "chevron-up"] : ["fal", "chevron-down"];
    }), _ = A(() => {
      var v;
      return (v = s.value) == null ? void 0 : v.display_name;
    });
    function g() {
      if (o.value) {
        i();
        return;
      }
      a.value = !0;
    }
    return (v, z) => {
      const h = xe("FontAwesomeIcon");
      return $(), I(me, null, [
        b(Re, {
          type: "outline",
          "data-testid": "ProductionMethodSelection",
          class: ke(["smake:pointer-events-auto smake:gap-3 smake:p-4 smake:@max-md:min-w-1/2", {
            "smake:z-10 smake:border-black": l(o)
          }]),
          onClick: g
        }, {
          default: C(() => [
            l(u) ? ($(), q(h, {
              key: 0,
              icon: l(u),
              "fixed-width": "",
              class: "smake:h-4"
            }, null, 8, ["icon"])) : l(d) ? Q("", !0) : ($(), I("div", p7)),
            _.value ? ($(), I("span", m7, L(_.value), 1)) : ($(), I("span", h7)),
            l(c) !== "pending" ? ($(), q(h, {
              key: 4,
              class: "smake:h-4",
              icon: m.value
            }, null, 8, ["icon"])) : ($(), I("div", f7))
          ]),
          _: 1
        }, 8, ["class"]),
        b(d7),
        b(D$)
      ], 64);
    };
  }
}), v7 = ["disabled"], g7 = { class: "smake:flex smake:aspect-square smake:h-16 smake:items-center smake:justify-center smake:gap-2 smake:rounded-full smake:border smake:border-secondary-2 smake:bg-white smake:p-2 smake:duration-150 smake:group-enabled:group-hover:border-black" }, k7 = {
  key: 0,
  class: "smake:text-xs"
}, Ju = /* @__PURE__ */ J({
  __name: "SaveVariantAsFavorite",
  props: {
    hideLabel: { type: Boolean }
  },
  setup(t) {
    const { t: e } = ct(), { selectedProductionMethodId: n } = D(Je()), s = ni(), { data: o } = D(Qt()), a = A(() => {
      if (o.value && s.value.length !== 0)
        return {
          resource: {
            id: o.value.id,
            views: s.value
          }
        };
    });
    function i() {
      a.value && m(a.value);
    }
    const { open: r } = Rn(), { waitForRendering: c } = sl(), { hasVariantsInRendering: u } = D(
      sl()
    ), { isPending: d, mutate: m } = yt({
      ...ce.favorites.variants.post.use(),
      onSuccess(v) {
        r(ln, {
          input: {
            text: e("archived_variant_successfully"),
            type: "success"
          }
        }), c(v);
      }
    }), { isSelectingPositioningArea: _ } = D(
      Xt()
    ), g = A(() => d.value || !a.value || u.value || _.value || n.value === void 0);
    return (v, z) => {
      const h = xe("FontAwesomeIcon");
      return $(), I("button", {
        type: "button",
        "data-testid": "SaveVariantAsFavorite",
        class: "smake:group smake:pointer-events-auto smake:flex smake:flex-col smake:items-center smake:gap-2 smake:disabled:opacity-50",
        disabled: g.value,
        onClick: i
      }, [
        x("div", g7, [
          l(d) || l(u) ? ($(), q(h, {
            key: 0,
            class: "smake:h-7 smake:animate-spin",
            icon: ["fal", "spinner"]
          })) : ($(), q(h, {
            key: 1,
            icon: ["fak", "icon-save"],
            "fixed-width": "",
            class: "smake:h-7"
          }))
        ]),
        v.hideLabel ? Q("", !0) : ($(), I("div", k7, L(v.$t("save_variant")), 1))
      ], 8, v7);
    };
  }
}), y7 = { class: "smake:absolute smake:top-1/2 smake:left-1/2 smake:mx-auto smake:flex smake:h-fit smake:max-h-full smake:w-auto smake:max-w-150 smake:-translate-x-1/2 smake:-translate-y-1/2 smake:flex-col smake:gap-6 smake:rounded-3xl smake:bg-white smake:p-4" }, b7 = { class: "smake:flex smake:items-start smake:justify-between smake:gap-2" }, w7 = {
  key: 0,
  class: "smake:animate-pulse"
}, x7 = { key: 1 }, $7 = /* @__PURE__ */ J({
  __name: "SessionExpiredDialog",
  setup(t) {
    const { isSessionExpired: e } = D(To()), { dialogsRoot: n } = D(nn()), s = N(!0), { start: o, stop: a } = hf(3e4, {
      callback: () => s.value = !1,
      controls: !0
    });
    function i() {
      s.value = !0, o();
    }
    return re(() => {
      e.value && i(), a();
    }), (r, c) => {
      const u = xe("FontAwesomeIcon");
      return $(), q(l(Ct), { open: l(e) }, {
        default: C(() => [
          b(l(Pt), { to: l(n) }, {
            default: C(() => [
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:opacity-0"
              }, {
                default: C(() => [
                  b(l(Mt), { class: "smake:fixed smake:inset-0 smake:bg-black/40" })
                ]),
                _: 1
              }),
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:scale-95 smake:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:scale-95 smake:opacity-0"
              }, {
                default: C(() => [
                  b(l(Tt), {
                    "as-child": "",
                    onInteractOutside: c[0] || (c[0] = rs(() => {
                    }, ["prevent"])),
                    onEscapeKeyDown: c[1] || (c[1] = rs(() => {
                    }, ["prevent"]))
                  }, {
                    default: C(() => [
                      x("div", y7, [
                        x("div", b7, [
                          b(l(At), { class: "smake:flex smake:items-center smake:gap-2 smake:text-2xl smake:font-bold smake:uppercase" }, {
                            default: C(() => [
                              b(u, {
                                class: "smake:text-danger",
                                icon: [
                                  "fak",
                                  "icon-ciconfig-alert-warning"
                                ],
                                "fixed-width": ""
                              }),
                              x("div", null, L(r.$t("session_expired")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        s.value ? ($(), I("div", w7, L(r.$t("trying_to_reconnect_session")), 1)) : ($(), I("div", x7, L(r.$t("session_expired_description")), 1))
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _: 1
      }, 8, ["open"]);
    };
  }
}), z7 = ["disabled"], S7 = { class: "smake:rounded-full smake:bg-primary-1 smake:p-3" }, A7 = /* @__PURE__ */ J({
  __name: "ShowEmptyPositioningAreas",
  setup(t) {
    const { cancelSelectingPositioningArea: e, waitForSelectingPositioningArea: n } = Xt(), { isSelectingPositioningArea: s } = D(
      Xt()
    ), { selectedProductionMethodId: o } = D(Je()), { positioningArea: a } = D(dn());
    async function i() {
      if (s.value) {
        e();
        return;
      }
      const c = await n();
      a.value = c.data;
    }
    const { hasAccess: r } = Mo();
    return (c, u) => {
      const d = xe("FontAwesomeIcon");
      return $(), I("button", {
        "data-testid": "ShowEmptyPositioningAreas",
        disabled: l(o) === void 0,
        type: "button",
        class: ke(["smake:pointer-events-auto smake:flex smake:flex-col smake:items-center smake:justify-center smake:gap-2 smake:rounded-2xl smake:border smake:border-secondary-2 smake:bg-white smake:font-medium smake:duration-150 smake:hover:border-black smake:disabled:opacity-50", {
          "smake:w-50 smake:p-3 smake:py-5 smake:text-sm": l(r)(
            l(Rt).CUSTOMER_LOGO_UPLOAD
          ),
          "smake:size-40 smake:p-5 smake:text-xs": !l(r)(
            l(Rt).CUSTOMER_LOGO_UPLOAD
          )
        }]),
        onClick: u[0] || (u[0] = (m) => i())
      }, [
        x("div", S7, [
          b(d, {
            class: ke(["smake:size-5 smake:text-white smake:transition-all", { "smake:rotate-45": l(s) }]),
            icon: ["fal", "plus"]
          }, null, 8, ["class"])
        ]),
        x("div", null, L(l(s) ? c.$t("abort") : c.$t("new_customization")), 1)
      ], 10, z7);
    };
  }
}), C7 = ["disabled"], P7 = { class: "smake:rounded-full smake:bg-primary-2 smake:p-6 smake:text-white smake:enabled:group-hover:bg-primary-1" }, M7 = { class: "smake:text-xs smake:font-bold" }, T7 = /* @__PURE__ */ J({
  __name: "ShowEmptyPositioningAreasMobile",
  setup(t) {
    const { cancelSelectingPositioningArea: e, waitForSelectingPositioningArea: n } = Xt(), { isSelectingPositioningArea: s } = D(
      Xt()
    ), { selectedProductionMethodId: o } = D(Je()), { positioningArea: a } = D(dn());
    async function i() {
      if (s.value) {
        e();
        return;
      }
      const r = await n();
      a.value = r.data;
    }
    return (r, c) => {
      const u = xe("FontAwesomeIcon");
      return $(), I("button", {
        class: "smake:group smake:pointer-events-auto smake:flex smake:flex-col smake:items-center smake:gap-2 smake:disabled:opacity-50",
        disabled: l(o) === void 0,
        onClick: i
      }, [
        x("div", P7, [
          b(u, {
            class: ke(["smake:size-10 smake:transition-all", { "smake:rotate-45": l(s) }]),
            icon: ["fal", "plus"]
          }, null, 8, ["class"])
        ]),
        x("div", M7, L(l(s) ? r.$t("abort") : r.$t("new_customization")), 1)
      ], 8, C7);
    };
  }
}), I7 = /* @__PURE__ */ J({
  __name: "Stage",
  setup(t) {
    const { data: e, selectedViewIndex: n } = D(sn()), { stage: s } = D(Sn()), { showLayout: o } = D(jt()), { open: a } = D(dn()), i = N(), r = N();
    function c() {
      const m = i.value;
      if (!m) return;
      const {
        offsetLeft: _,
        offsetParent: g,
        offsetTop: v
      } = m;
      g instanceof HTMLElement && (r.value = g);
      const { height: z, width: h } = m.getBoundingClientRect();
      s.value = { height: z, width: h, x: _, y: v };
    }
    rc(i, c), rc(r, c);
    function u() {
      n.value = (n.value + 1) % e.value.length;
    }
    function d() {
      n.value = (n.value - 1 + e.value.length) % e.value.length;
    }
    return (m, _) => {
      const g = xe("FontAwesomeIcon");
      return $(), I("div", {
        ref_key: "stageElement",
        ref: i,
        "data-testid": "stage",
        class: ke(
          l(ym)(
            "smake:relative smake:min-w-14",
            l(o) && "smake:mx-7",
            l(a) && "smake:absolute smake:inset-0 smake:@sm:relative"
          )
        )
      }, [
        x("button", {
          type: "button",
          class: ke(["smake:pointer-events-auto smake:absolute smake:top-1/2 smake:left-0 smake:size-14 smake:-translate-x-1/2 smake:-translate-y-1/2 smake:rounded-full smake:bg-secondary-3 smake:p-3 smake:duration-150 smake:hover:bg-secondary-2", { "smake:hidden": !l(o) }]),
          onClick: d
        }, [
          b(g, {
            class: "smake:size-full",
            icon: ["fal", "chevron-left"]
          })
        ], 2),
        x("button", {
          type: "button",
          class: ke(["smake:pointer-events-auto smake:absolute smake:top-1/2 smake:right-0 smake:size-14 smake:translate-x-1/2 smake:-translate-y-1/2 smake:rounded-full smake:bg-secondary-3 smake:p-3 smake:duration-150 smake:hover:bg-secondary-2", { "smake:hidden": !l(o) }]),
          onClick: u
        }, [
          b(g, {
            class: "smake:size-full",
            icon: ["fal", "chevron-right"]
          })
        ], 2)
      ], 2);
    };
  }
}), E7 = /* @__PURE__ */ J({
  __name: "Toasts",
  setup(t) {
    const { toasts: e } = D(mm());
    function n(s) {
      e.value = e.value.filter((o) => o !== s);
    }
    return (s, o) => ($(!0), I(me, null, Se(l(e), (a) => ($(), q(il(a.component), Na({
      key: l(ft)(a)
    }, { ref_for: !0 }, a.input, {
      open: a.open,
      "onUpdate:open": (i) => a.open = i,
      onClosed: (i) => n(a)
    }), null, 16, ["open", "onUpdate:open", "onClosed"]))), 128));
  }
}), O7 = ["disabled"], R7 = { class: "smake:rounded-full smake:bg-secondary-3 smake:p-3" }, L7 = /* @__PURE__ */ J({
  __name: "OpenVariantsDialog",
  setup(t) {
    const { isSelectingPositioningArea: e } = D(
      Xt()
    ), { selectedProductionMethodId: n } = D(Je()), { hasAccess: s } = Mo(), { open: o } = pn();
    async function a() {
      await o(ii);
    }
    return (i, r) => {
      const c = xe("FontAwesomeIcon");
      return $(), I("button", {
        type: "button",
        "data-testid": "OpenVariantsDialog",
        class: ke(["smake:pointer-events-auto smake:flex smake:flex-col smake:items-center smake:justify-center smake:gap-2 smake:rounded-2xl smake:border smake:border-secondary-2 smake:bg-white smake:font-medium smake:duration-150 smake:hover:border-black smake:disabled:opacity-50", {
          "smake:w-50 smake:p-3 smake:py-5 smake:text-sm": l(s)(
            l(Rt).CUSTOMER_LOGO_UPLOAD
          ),
          "smake:size-40 smake:p-3 smake:text-xs": !l(s)(
            l(Rt).CUSTOMER_LOGO_UPLOAD
          )
        }]),
        disabled: l(e) || l(n) === void 0,
        onClick: a
      }, [
        x("div", R7, [
          b(c, {
            class: "smake:h-5",
            icon: ["fak", "icon-ciconfig-archive"],
            "fixed-width": ""
          })
        ]),
        x("div", null, L(i.$t("my_customizations")), 1)
      ], 10, O7);
    };
  }
}), D7 = /* @__PURE__ */ J({
  __name: "OpenVariantsDialogMobile",
  setup(t) {
    const { selectedProductionMethodId: e } = D(Je()), { isSelectingPositioningArea: n } = D(
      Xt()
    ), { open: s } = pn();
    async function o() {
      await s(ii);
    }
    return (a, i) => ($(), q(et, {
      type: "subordinate",
      disabled: l(n) || l(e) === void 0,
      text: a.$t("archive"),
      icon: {
        type: ["fak", "icon-ciconfig-archive"]
      },
      onClick: o
    }, null, 8, ["disabled", "text"]));
  }
}), j7 = {
  key: 1,
  class: "smake:flex smake:justify-center"
}, N7 = { class: "smake:flex smake:border-t-2 smake:border-secondary-2" }, V7 = /* @__PURE__ */ J({
  __name: "ViewTabs",
  setup(t) {
    const { selectedViewIndex: e } = D(sn()), { data: n } = D(Qt());
    return (s, o) => {
      var a;
      return (a = l(n)) != null && a.views ? ($(), q(l(rl), {
        key: 0,
        modelValue: l(e),
        "onUpdate:modelValue": o[0] || (o[0] = (i) => Lt(e) ? e.value = i : null),
        class: "smake:flex smake:justify-center"
      }, {
        default: C(() => [
          b(l(ll), { class: "smake:relative smake:border-t-2 smake:border-secondary-2" }, {
            default: C(() => {
              var i;
              return [
                b(l(g_), { class: "smake:absolute smake:-top-0.5 smake:left-0 smake:h-0.5 smake:w-(--radix-tabs-indicator-size) smake:translate-x-(--radix-tabs-indicator-position) smake:bg-secondary-1 smake:transition-[width,transform] smake:duration-300" }),
                ($(!0), I(me, null, Se((i = l(n)) == null ? void 0 : i.views, (r, c) => ($(), q(l(Pd), {
                  key: l(ft)(r),
                  class: "smake:pointer-events-auto smake:px-2 smake:py-1 smake:text-xs",
                  value: c
                }, {
                  default: C(() => [
                    he(L(r.display_name), 1)
                  ]),
                  _: 2
                }, 1032, ["value"]))), 128))
              ];
            }),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])) : ($(), I("div", j7, [
        x("div", N7, [
          ($(), I(me, null, Se(4, (i) => x("div", {
            key: i,
            class: "smake:mx-2 smake:my-1 smake:h-4 smake:w-8 smake:rounded-full smake:bg-secondary-2 smake:text-xs"
          })), 64))
        ])
      ]));
    };
  }
}), U7 = { class: "smake:group smake:pointer-events-auto smake:flex smake:flex-col smake:items-center smake:gap-2" }, F7 = { class: "smake:size-16 smake:rounded-full smake:border smake:border-secondary-2 smake:bg-white smake:p-4 smake:group-focus-within:hidden smake:group-hover:hidden" }, B7 = { class: "smake:absolute smake:size-px smake:flex-col smake:items-center smake:gap-2 smake:rounded-full smake:border smake:border-secondary-3 smake:bg-secondary-3 smake:p-4 smake:[clip-path:inset(50%)] smake:[clip:rect(0_0_0_0)] smake:group-focus-within:static smake:group-focus-within:flex smake:group-focus-within:h-auto smake:group-focus-within:w-16 smake:group-focus-within:[clip-path:none] smake:group-focus-within:[clip:auto] smake:group-hover:static smake:group-hover:flex smake:group-hover:h-auto smake:group-hover:w-16 smake:group-hover:[clip-path:none] smake:group-hover:[clip:auto]" }, q7 = { class: "smake:text-xs" }, Tr = 1, Ir = 2.5, H7 = /* @__PURE__ */ J({
  __name: "Zoom",
  setup(t) {
    const { zoom: e } = D(Sn()), n = A({
      get: () => [e.value],
      set: ([s]) => {
        e.value = s;
      }
    });
    return (s, o) => {
      const a = xe("FontAwesomeIcon");
      return $(), I("div", U7, [
        x("div", F7, [
          b(a, {
            class: "smake:w-full",
            "fixed-width": "",
            icon: ["fak", "icon-zoom-in"]
          })
        ]),
        x("div", B7, [
          x("button", {
            type: "button",
            tabindex: "-1",
            onClick: o[0] || (o[0] = (i) => e.value = l(wo)(l(e) + 0.1, Tr, Ir))
          }, [
            b(a, {
              class: "smake:w-full",
              "fixed-width": "",
              icon: ["fak", "icon-zoom-in"]
            })
          ]),
          b(l(k_), {
            modelValue: n.value,
            "onUpdate:modelValue": o[1] || (o[1] = (i) => n.value = i),
            class: "smake:relative smake:flex smake:h-50 smake:w-5 smake:touch-none smake:flex-col smake:items-center smake:select-none",
            max: Ir,
            min: Tr,
            step: 0.01,
            orientation: "vertical"
          }, {
            default: C(() => [
              b(l(y_), { class: "smake:relative smake:w-1 smake:grow smake:rounded-full smake:bg-white" }),
              b(l(b_), {
                class: "smake:block smake:size-5 smake:rounded-full smake:bg-black smake:shadow-[0_2px_10px] smake:shadow-black smake:hover:bg-gray-800 smake:focus:shadow-[0_0_0_5px] smake:focus:shadow-slate-400 smake:focus:outline-hidden",
                "aria-label": s.$t("zoom")
              }, null, 8, ["aria-label"])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          x("button", {
            type: "button",
            tabindex: "-1",
            onClick: o[2] || (o[2] = (i) => e.value = l(wo)(l(e) - 0.1, Tr, Ir))
          }, [
            b(a, {
              class: "smake:w-full",
              "fixed-width": "",
              icon: ["fak", "icon-zoom-out"]
            })
          ])
        ]),
        x("div", q7, L(s.$t("zoom")), 1)
      ]);
    };
  }
});
function W7(t) {
  const {
    activeCategories: e,
    activeProductionMethodId: n,
    count: s,
    fetchStatus: o,
    fetchStatusCount: a,
    normalizedSearchQuery: i
  } = D(ws()), r = A(
    () => e.value.map((u) => u.name)
  ), { productionMethod: c } = It(n);
  re(() => {
    o.value !== "fetching" && a.value !== "fetching" && (!i.value && r.value.length === 0 || c.value && s.value !== void 0 && t({
      categorieNames: r.value,
      productionMethodHandle: c.value.handle,
      query: i.value,
      resultCount: s.value
    }));
  });
}
function G7(t) {
  const { data: e } = D(Qt()), n = ni(), { isADialogOpen: s } = D(ti());
  re(() => {
    if (s.value) {
      t();
      return;
    }
    if (!e.value) {
      t();
      return;
    }
    if (n.value.length === 0) {
      t();
      return;
    }
    t({
      id: e.value.id,
      views: n.value
    });
  });
}
function Z7(t) {
  const e = {};
  for (const n in t) {
    const s = _t(t, n);
    e[n] = A(() => K7(s.value));
  }
  return e;
}
function K7(t) {
  if (typeof t != "string") return t;
  try {
    return JSON.parse(t);
  } catch {
    return t;
  }
}
const X7 = {
  id: "designer-strauss",
  "data-testid": "designer",
  class: "smake:@container smake:h-full smake:text-[16px] smake:[overflow-wrap:anywhere]"
}, Q7 = { class: "smake:pointer-events-none smake:absolute smake:inset-0 smake:flex" }, J7 = { class: "smake:flex smake:grow smake:flex-col" }, Y7 = { class: "smake:flex smake:grow smake:justify-center" }, e9 = { class: "smake:flex smake:w-full smake:grow smake:flex-col smake:gap-4" }, t9 = { class: "smake:flex smake:w-full smake:grow smake:gap-4" }, n9 = { class: "smake:flex smake:grow smake:flex-col smake:gap-4" }, s9 = { class: "smake:flex smake:max-w-288 smake:grow smake:items-center smake:justify-center smake:gap-5 smake:@md:justify-end smake:@md:px-10" }, o9 = /* @__PURE__ */ J({
  __name: "App.ce",
  props: {
    apiBaseUrl: { type: String },
    apiToken: { type: String },
    availableVariants: { type: String },
    cartItemIds: { type: String },
    customerLogoUploadInfo: { type: String },
    debug: { type: String },
    featureFlagCustomerLogoUpload: { type: String },
    locale: { type: String },
    pusherAppKey: { type: String },
    pusherChannelPrefix: { type: String },
    pusherCluster: { type: String },
    termsOfServiceLink: { type: String },
    uploadHelpLink: { type: String },
    userExternalIdentifier: { type: String },
    variantId: { type: [Number, String] }
  },
  emits: ["custom-variant-created", "search-statistics", "session-expired", "variant-changed"],
  setup(t, { emit: e }) {
    const n = e, s = t, {
      apiBaseUrl: o,
      apiToken: a,
      availableVariants: i,
      cartItemIds: r,
      customerLogoUploadInfo: c,
      debug: u,
      featureFlagCustomerLogoUpload: d,
      locale: m,
      pusherAppKey: _,
      pusherChannelPrefix: g,
      pusherCluster: v,
      termsOfServiceLink: z,
      uploadHelpLink: h,
      userExternalIdentifier: y,
      variantId: w
    } = Z7(s), { locale: P } = ct(), { acceptLanguage: M, baseUrl: E } = D(wl()), {
      initialToken: R,
      isSessionExpired: j,
      tokenData: V,
      userExternalIdentifier: X
    } = D(To()), { variantId: Z } = D(Qt()), {
      availableVariants: ae,
      customerLogoUploadInfo: K,
      termsOfServiceLink: te,
      uploadHelpLink: ue
    } = D(Zs()), { rootElement: Ce, showLayout: ne } = D(jt()), { cartItemIds: ee } = D(Da()), { designerConfiguration: G } = D(tt());
    re(() => {
      E.value = o.value, kd("api-base-url", o.value);
    }), re(() => {
      const fe = m.value;
      M.value = fe, P.value = fe;
    }), re(() => {
      X.value = y.value;
    }), re(() => {
      R.value = a.value;
    }), re(() => {
      j.value && n("session-expired");
    }), re(() => {
      var fe;
      Gf({ id: (fe = V.value) == null ? void 0 : fe.user_id });
    }), re(() => {
      Z.value = w.value;
    }), re(() => {
      ae.value = i.value;
    }), re(() => {
      K.value = c.value;
    }), re(() => {
      ee.value = r.value;
    }), re(() => {
      te.value = z.value;
    }), re(() => {
      ue.value = h.value;
    });
    const { appKey: oe, channelPrefix: _e, cluster: de } = D(Al());
    re(() => {
      oe.value = _.value;
    }), re(() => {
      de.value = v.value;
    }), re(() => {
      _e.value = g.value;
    }), j2((fe) => {
      console.error(fe);
    });
    const { onContinue: $e } = D(fm());
    $e.value = (fe) => {
      n("custom-variant-created", fe);
    };
    const { giveAccessToFeature: Ze, hasAccess: Pe, removeAccessFromFeature: ie } = Mo();
    re(() => {
      if (d.value === !0) {
        Ze(Rt.CUSTOMER_LOGO_UPLOAD);
        return;
      }
      ie(Rt.CUSTOMER_LOGO_UPLOAD);
    }), W7((fe) => {
      n("search-statistics", {
        category_names: fe.categorieNames,
        production_method_handle: fe.productionMethodHandle,
        query: fe.query,
        result_count: fe.resultCount
      });
    });
    const { selectedProductionMethodId: ve } = D(Je()), { isCustomerLogoUploadEnabled: ut } = It(
      ve
    );
    re(() => {
      u.value && console.debug(
        "%c Designer-Strauss Version: 5.5.5",
        "color: #93d50a"
      );
    }), G7((fe) => {
      n("variant-changed", fe);
    });
    const ot = A(
      () => {
        var fe;
        return ((fe = G.value) == null ? void 0 : fe.settings.is_internal) ?? !1;
      }
    ), { open: Ve } = pn();
    return Dt("favorite.rendered", ({ collection_name: fe }) => {
      fe === "merchant-sketch" && Ve(C$);
    }), (fe, Xe) => ($(), q(l(w_), { "swipe-direction": "up" }, {
      default: C(() => [
        x("div", X7, [
          x("div", {
            ref_key: "rootElement",
            ref: Ce,
            class: ke(["smake:relative smake:h-full smake:overflow-hidden", {
              "smake:min-h-160": !ot.value,
              "smake:@md:min-h-193": !ot.value,
              "smake:min-h-150": ot.value,
              "smake:@md:min-h-183": !ot.value
            }])
          }, [
            b(e5, { class: "smake:absolute smake:inset-0 smake:size-full" }),
            x("div", Q7, [
              x("div", J7, [
                x("div", Y7, [
                  x("div", {
                    class: ke(["smake:flex smake:w-full smake:max-w-288", { "smake:m-6": l(ne) }])
                  }, [
                    x("div", e9, [
                      x("div", {
                        class: ke(["smake:inset-x-0 smake:flex smake:w-full smake:justify-center", { "smake:hidden": !l(ne) }])
                      }, [
                        b(_7),
                        b(l(ma), {
                          name: l(Rt).CUSTOMER_LOGO_UPLOAD
                        }, {
                          default: C(() => [
                            l(ut) ? ($(), q(Mr, {
                              key: 0,
                              "hide-label": "",
                              class: ke([{
                                "smake:block smake:@md:hidden": l(ne),
                                "smake:hidden": !l(ne)
                              }, "smake:absolute smake:top-21 smake:left-4"])
                            }, null, 8, ["class"])) : Q("", !0)
                          ]),
                          _: 1
                        }, 8, ["name"]),
                        b(Ju, {
                          "hide-label": "",
                          class: ke([{
                            "smake:block smake:@md:hidden": l(ne),
                            "smake:hidden": !l(ne)
                          }, "smake:absolute smake:top-21 smake:right-4"])
                        }, null, 8, ["class"])
                      ], 2),
                      x("div", t9, [
                        x("div", {
                          class: ke(["smake:hidden smake:flex-col smake:justify-end smake:gap-4 smake:@md:grow", {
                            "smake:@md:flex": l(ne),
                            "smake:max-w-50": l(Pe)(
                              l(Rt).CUSTOMER_LOGO_UPLOAD
                            ),
                            "smake:max-w-40": !l(Pe)(
                              l(Rt).CUSTOMER_LOGO_UPLOAD
                            )
                          }])
                        }, [
                          b(H7),
                          b(Hu),
                          b(Mr)
                        ], 2),
                        x("div", n9, [
                          b(I7, { class: "smake:grow" }),
                          b(V7, {
                            class: ke({
                              "smake:hidden": !l(ne)
                            })
                          }, null, 8, ["class"]),
                          x("div", {
                            class: ke(["smake:mt-4 smake:flex smake:items-end smake:justify-evenly smake:gap-3 smake:@md:hidden", {
                              "smake:hidden": !l(ne)
                            }])
                          }, [
                            b(Hu),
                            b(T7),
                            b(l(ma), {
                              name: l(Rt).CUSTOMER_LOGO_UPLOAD
                            }, {
                              default: C(() => [
                                b(m5)
                              ]),
                              _: 1
                            }, 8, ["name"]),
                            !l(Pe)(
                              l(Rt).CUSTOMER_LOGO_UPLOAD
                            ) || !l(ut) ? ($(), q(Mr, { key: 0 })) : Q("", !0)
                          ], 2)
                        ]),
                        x("div", {
                          class: ke(["smake:hidden smake:flex-col smake:justify-center smake:gap-4", {
                            "smake:@md:flex": l(ne),
                            "smake:max-w-50": l(Pe)(
                              l(Rt).CUSTOMER_LOGO_UPLOAD
                            ),
                            "smake:max-w-40": !l(Pe)(
                              l(Rt).CUSTOMER_LOGO_UPLOAD
                            )
                          }])
                        }, [
                          b(A7),
                          b(l(ma), {
                            name: l(Rt).CUSTOMER_LOGO_UPLOAD
                          }, {
                            default: C(() => [
                              b(c5)
                            ]),
                            _: 1
                          }, 8, ["name"]),
                          b(L7),
                          Xe[0] || (Xe[0] = x("div", { class: "smake:-mt-4 smake:grow" }, null, -1)),
                          b(Ju),
                          b(i5)
                        ], 2)
                      ])
                    ])
                  ], 2)
                ]),
                x("div", {
                  class: ke(["smake:pointer-events-auto smake:flex smake:justify-center smake:rounded-t-2xl smake:bg-white smake:px-6 smake:py-3 smake:shadow-[0px_0px_15px_0px_rgba(0,0,0,0.15)]", {
                    "smake:hidden": !l(ne),
                    "smake:@md:hidden": ot.value
                  }])
                }, [
                  x("div", s9, [
                    b(D7, { class: "smake:@md:hidden" }),
                    ot.value ? Q("", !0) : ($(), q(hw, { key: 0 }))
                  ])
                ], 2)
              ]),
              b(K8),
              b($7)
            ]),
            b(t5),
            b(E7),
            b(l(x_), { class: "smake:pointer-events-none smake:absolute smake:inset-x-0 smake:top-3 smake:z-10 smake:flex smake:flex-col smake:items-center smake:gap-3" })
          ], 2)
        ])
      ]),
      _: 1
    }));
  }
}), a9 = "zrušit", i9 = "Přidat logo", r9 = "Přidat text", l9 = "Přidat řádek", c9 = "do objednávky", u9 = "zarovnat", d9 = "Na tomto pohledu není volné umístění.", p9 = "použít", m9 = "Použít pro všechny řádky", h9 = "Archiv", f9 = "Načíst vybraný motiv", _9 = "Načíst produkt včetně personalizace", v9 = "Nový záznam v archivu bude brzy k dispozici.", g9 = "Vaše personalizace byla úspěšně uložena.", k9 = "Opravdu chcete smazat { deleteName }?", y9 = "Alespoň jeden motiv již není k dispozici!", b9 = "zpět", w9 = "Ohnout text", x9 = { authentication: "Autentizace selhala.", headline: "Při spuštění konfigurátoru došlo k chybě.", unexpected: "Neočekávaná chyba", variant_not_found: "Požadovaná varianta nebyla nalezena." }, $9 = "Nacházíte se na ploše pro {fromProductionMethod}.", z9 = "přepnout na {x}", S9 = "vybrat", A9 = "Vyberte prosím plochu pro umístění.", C9 = "Vybrat jiný motiv", P9 = "Vybrat jiné logo", M9 = "Vybrat typ personalizace", T9 = "smazat všechny filtry", I9 = "Barva", E9 = "Barvy", O9 = "potvrdit", R9 = "Potvrzení", L9 = "Nahráním požadované personalizace potvrzujete, že jste oprávněni nechat personalizaci aplikovat na textil, zejména že personalizace neporušuje práva třetích stran (ochranné známky, autorská práva, designová práva apod.) ani obecné (zejména trestní) zákony. Pokud bychom byli z důvodu vaší konfigurace postaveni před nároky třetích stran nebo zákona, jste povinni nás od všech nároků a škod v této souvislosti osvobodit.", D9 = "pokračovat s {x}", j9 = "Pozor: Neuložené návrhy budou při otevření návrhů ztraceny.", N9 = "Aktuálně v košíku", V9 = "Dosud nebyly nahrány žádné soubory", U9 = "Individuální", F9 = "Typ motivu", B9 = "Personalizace", q9 = "Design|Designy", H9 = "Vzdálenost motivu/textu (v mm)", W9 = "Chcete přejmenovat {name}?", G9 = "Přetáhněte soubor přímo do pole", Z9 = "živé barvy, rozmanitost", K9 = "výrazný digitální tisk", X9 = "ideální pro velké potisky", Q9 = "flexibilní ve velikosti a barvách", J9 = "pro vybrané textilie a všechny základy", Y9 = "Praní v pračce do 40˚C", ez = "Prvek je mimo oblast umístění.", tz = "elegantní, jemné", nz = "velmi kvalitní a trvanlivá výšivka", sz = "možné pro mnoho produktů", oz = "mnoho motivů a barev nití", az = "všechny textilie, včetně silně namáhaných výrobků", iz = "lze prát na vysoké teploty, včetně průmyslového praní", rz = "Archivace varianty se nezdařila. Zkuste to prosím znovu.", lz = "Uložení varianty se nezdařilo. Zkuste to prosím znovu.", cz = "Při načítání došlo k chybě.", uz = "Při zobrazování změn došlo k chybě. Zkuste to prosím (později) znovu.", dz = "Při načítání varianty došlo k neočekávané chybě. Zkuste to prosím (později) znovu nebo vytvořte novou personalizaci.", pz = "Při mazání archivované varianty došlo k chybě. Zkuste to prosím znovu.", mz = "méně barev", hz = "Písmo", fz = "Písmo není k dispozici", _z = "Aktualizace písma", vz = "Některá písma již nejsou k dispozici. Vyberte prosím jiné:", gz = "od 1 ks", kz = "Přehled personalizací", yz = "Výška (v cm)", bz = "Nápověda k nahrání souboru", wz = "zde", xz = "Skrýt plochy", $z = "Motiv|Motivy", zz = "Databáze motivů", Sz = "Vyberte motiv z naší stále rostoucí databáze motivů. Poté máte možnost motiv upravit dle vlastních představ.", Az = "Vložit text", Cz = "kurzíva", Pz = "k", Mz = "Vzdálenost dole", Tz = "načítání", Iz = "Logo|Loga", Ez = "Loga & designy", Oz = "Vzhled", Rz = "Velikost souboru: max.", Lz = "Byl dosažen maximální počet řádků.", Dz = 'Pod "{buttonName}" jsou pro vás připraveny nové návrhy.', jz = "Minimální množství", Nz = "jednobarevné", Vz = "další barvy", Uz = "Pro použití „CI Configurator MYDESIGN“ platí následující {termsOfServiceLink}.", Fz = "vícebarevné", Bz = "Moje personalizace", qz = "Moje soubory", Hz = "Moje loga", Wz = "Nová personalizace", Gz = "Nový design", Zz = "Nový návrh", Kz = "další motiv", Xz = "Ve vašem účtu zatím nejsou žádná loga pro {productionMethod}. Chcete-li si nechat logo nahrát od nás, kontaktujte nás na: {contact}. Jinak můžete vpravo nahoře změnit typ personalizace.", Qz = "Ve vašem zákaznickém účtu nejsou aktuálně uložena žádná loga pro {productionMethod}.", Jz = "Ve vašem účtu zatím nejsou žádné designy pro {productionMethod}.", Yz = "Pro vaše aktuální filtrování zatím nejsou žádné motivy pro {productionMethod}.", eS = "Odsazení vlevo", tS = "Pouze velká písmena", nS = "nebo", sS = "Případně můžete změnit typ personalizace vpravo nahoře.", oS = "Stáhnout PDF", aS = "umístit", iS = "Umístit motiv", rS = "Prosím, opravte označená pole, aby se zobrazil váš motiv.", lS = "Prosím, chvíli strpení.", cS = "Náhled", uS = "Náhled možných ploch pro umístění", dS = "Cena", pS = "Změnit barvu produktu", mS = "Typ personalizace", hS = "Tento typ personalizace není pro tento produkt možný.", fS = "výrazný digitální tisk", _S = "velmi kvalitní a trvanlivá výšivka", vS = "Množství", gS = "Nedávno nahrané", kS = "Nedávno použité", yS = "přejmenovat", bS = "nahradit", wS = "uložit", xS = "uložit & načíst", $S = "Uložit personalizaci", zS = "Uloženo", SS = "Váš design byl úspěšně uložen pod názvem {name}.", AS = "Uložené designy", CS = "Hledat motiv", PS = "Vybrat barvu", MS = "Vybrat soubor", TS = "Vybrat písmo", IS = "Relace vypršela", ES = "Vaše relace vypršela. Obnovte stránku pro další použití konfigurátoru.", OS = "Zobrazit {count} výsledek|Zobrazit {count} výsledky", RS = "Zobrazit plochy", LS = "Zobrazit moje soubory", DS = "Zobrazit návrhy", jS = "Velikost", NS = "Velikost (v cm)", VS = "Návrhy", US = "Standardní barvy", FS = "Podporované formáty souborů", BS = "Podmínky užívání", qS = "Textilie", HS = "Text", WS = "Vybraný design nahradí vaši aktuální volbu", GS = "Tuto akci nelze vrátit zpět.", ZS = "Chcete-li umístit požadovaný motiv, změňte typ personalizace na {toProductionMethod}. Poté můžete vybrat vhodnou plochu.", KS = "Probíhá pokus o obnovení relace.", XS = "aktualizovat", QS = "Aktualizovat položku včetně personalizace", JS = "Nahrát další soubor", YS = "Váš soubor nesplňuje technické požadavky. Nahrajte prosím jiný formát souboru. Další informace naleznete {here}.", eA = "Nahrání není možné – váš SVG soubor obsahuje obrázkové prvky. Odstraňte prosím vložené obrázky a soubor nahrajte znovu.", tA = "Nahrání není možné – váš SVG soubor obsahuje nevložené písmo. Převěďte prosím písmo na křivky a soubor nahrajte znovu.", nA = "Nahrání selhalo – došlo k neočekávané chybě. Zkuste to prosím znovu nebo použijte jiný formát souboru.", sA = "Nahrát soubor", oA = "Nahrát vlastní soubor", aA = "Nahrané soubory", iA = "Vaše personalizace od", rA = "Možnost praní", lA = "Šířka (v cm)", cA = "Váš soubor se právě nahrává...", uA = "Zoom", dA = {
  abort: a9,
  add_logo: i9,
  add_text: r9,
  add_text_line: l9,
  add_to_cart: c9,
  align: u9,
  all_positioning_areas_are_occupied: d9,
  apply: p9,
  apply_to_all_lines: m9,
  archive: h9,
  archive_fetch_selected_customization: f9,
  archive_fetch_variant_with_customizations: _9,
  archive_new_entry_soon_available: v9,
  archived_variant_successfully: g9,
  are_you_sure_you_want_to_delete: k9,
  at_least_one_motiv_is_not_available: y9,
  back: b9,
  bend_text_line: w9,
  boot_error: x9,
  change_production_method_info: $9,
  change_to_x: z9,
  choose: S9,
  choose_a_positioning_area: A9,
  choose_icon: C9,
  choose_logo: P9,
  choose_production_method: M9,
  clear_filters: T9,
  color: I9,
  colors: E9,
  confirm: O9,
  confirmation: R9,
  confirmation_description: L9,
  continue: "pokračovat",
  continue_with_x: D9,
  current_edited_customization_will_be_aborted: j9,
  currently_in_cart: N9,
  currently_no_uploaded_files: V9,
  custom: U9,
  customization_type: F9,
  customizations: B9,
  delete: "smazat",
  designs: q9,
  distance_motif_text: H9,
  do_you_want_to_rename: W9,
  drag_file_over_area: G9,
  dtf_look: Z9,
  dtf_selling_point_1: K9,
  dtf_selling_point_2: X9,
  dtf_selling_point_3: Q9,
  dtf_textiles: J9,
  dtf_washability: Y9,
  element_outside_placement_area: ez,
  embroidery_look: tz,
  embroidery_selling_point_1: nz,
  embroidery_selling_point_2: sz,
  embroidery_selling_point_3: oz,
  embroidery_textiles: az,
  embroidery_washability: iz,
  error_failed_to_archive_variant: rz,
  error_failed_to_save_variant: lz,
  error_loading: cz,
  error_pusher_rendering_failed: uz,
  error_pusher_rendering_failed_while_loading_variant: dz,
  error_while_deleting_archive_variant: pz,
  fewer_colors: mz,
  font: hz,
  font_not_available: fz,
  font_update: _z,
  font_update_explanation: vz,
  from_one_piece: gz,
  go_to_production_method_overview: kz,
  height_abbreviation: yz,
  help_for_upload: bz,
  here: wz,
  hide_areas: xz,
  icon: $z,
  icon_database: zz,
  icon_database_description: Sz,
  insert_text: Az,
  italic: Cz,
  italic_short: Pz,
  line_height: Mz,
  loading: Tz,
  logos: Iz,
  logos_and_designs: Ez,
  look: Oz,
  max_file_size: Rz,
  maximum_number_of_lines: Lz,
  merchant_sketch_variant_added: Dz,
  minimum_quantity: jz,
  mono_colored: Nz,
  more_colors: Vz,
  more_informations_about_upload: Uz,
  multi_colored: Fz,
  my_customizations: Bz,
  my_files: qz,
  my_logos: Hz,
  new: "nové",
  new_customization: Wz,
  new_design: Gz,
  new_sketch: Zz,
  next_motif: Kz,
  no_customer_logos: Xz,
  no_customer_logos_for_production_method: Qz,
  no_designs: Jz,
  no_motifs: Yz,
  offset_left: eS,
  only_uppercase: tS,
  or: nS,
  otherwise_change_personalization_type_top_right: sS,
  pdf_download: oS,
  place: aS,
  place_logo: iS,
  please_correct_the_highlighted_errors: rS,
  please_hold_on_for_a_moment: lS,
  preview: cS,
  preview_of_possibile_positioning_areas: uS,
  price: dS,
  product_colors: pS,
  production_method: mS,
  production_method_not_available_for_variant: hS,
  production_method_summary_dtf: fS,
  production_method_summary_embroidery: _S,
  quantity: vS,
  recently_uploaded: gS,
  recently_used: kS,
  rename: yS,
  replace: bS,
  save: wS,
  save_and_load: xS,
  save_variant: $S,
  saved: zS,
  saved_design_successfully: SS,
  saved_designs: AS,
  search_logo: CS,
  select_color: PS,
  select_file: MS,
  select_font: TS,
  session_expired: IS,
  session_expired_description: ES,
  show_X_results: OS,
  show_areas: RS,
  show_own_files: LS,
  show_sketches: DS,
  size: jS,
  size_in_unit: NS,
  sketches: VS,
  standard_colors: US,
  supported_file_types: FS,
  terms_of_service: BS,
  textiles: qS,
  texts: HS,
  the_selected_design_will_replace_the_current_selection: WS,
  this_action_can_not_be_undone: GS,
  to_place_motif_change_production_method: ZS,
  trying_to_reconnect_session: KS,
  update: XS,
  update_article_with_designs: QS,
  upload_another_file: JS,
  upload_error_422_content_type: YS,
  upload_error_svg_contains_image: eA,
  upload_error_svg_contains_text: tA,
  upload_error_unexpected: nA,
  upload_file: sA,
  upload_own_file: oA,
  uploads: aA,
  views_preview_headlide: iA,
  washablility: rA,
  width_abbreviation: lA,
  your_file_is_beeing_uploaded: cA,
  zoom: uA
}, pA = "annullér", mA = "Tilføj logo", hA = "Tilføj tekst", fA = "Tilføj linje", _A = "til bestilling", vA = "justér", gA = "Ingen ledig placeringsflade på denne visning.", kA = "anvend", yA = "Anvend på alle linjer", bA = "Arkiv", wA = "Indlæs valgt motiv", xA = "Indlæs produkt inkl. tilpasning", $A = "En ny arkivpost er snart tilgængelig.", zA = "Din tilpasning blev gemt korrekt.", SA = "Vil du virkelig slette { deleteName }?", AA = "Mindst ét motiv er ikke længere tilgængeligt!", CA = "tilbage", PA = "Bøj tekst", MA = { authentication: "Godkendelse mislykkedes.", headline: "Der opstod en fejl ved opstart af konfiguratoren.", unexpected: "Uventet fejl", variant_not_found: "Den ønskede variant blev ikke fundet." }, TA = "Du er i øjeblikket på en placeringsflade for {fromProductionMethod}.", IA = "skift til {x}", EA = "vælg", OA = "Vælg venligst en placeringsflade.", RA = "Vælg andet motiv", LA = "Vælg andet logo", DA = "Vælg personaliseringstype", jA = "ryd alle filtre", NA = "Farve", VA = "Farver", UA = "bekræft", FA = "Bekræftelse", BA = "Ved at uploade den ønskede tilpasning bekræfter du, at du har ret til at få tilpasningen på tekstiler, især at tilpasningen ikke krænker navne- og varemærkerettigheder, designrettigheder, ophavsrettigheder eller andre tredjepartsrettigheder samt generelle (især strafferetlige) love. Skulle vi blive gjort ansvarlige på grund af din konfiguration for overtrædelse af tredjemands rettigheder eller lovgivning, er du forpligtet til at friholde os for alle krav og skader i denne forbindelse.", qA = "fortsæt med {x}", HA = "Bemærk: Ugemte designs vil gå tabt ved åbning af udkast.", WA = "Aktuelt i kurven", GA = "Der er endnu ikke uploadet nogen filer", ZA = "Individuel", KA = "Motivtype", XA = "Tilpasninger", QA = "Design|Designs", JA = "Afstand motiv/tekst (i mm)", YA = "Vil du omdøbe {name}?", eC = "Træk fil direkte til feltet", tC = "farvestrålende, alsidig", nC = "udtryksfuld digitaltransfer", sC = "optimal til store tryk", oC = "fleksibel i størrelser og farver", aC = "til udvalgte tekstiler og alle basisprodukter", iC = "Maskinvask op til 40˚C", rC = "Elementet er uden for placeringsfladen.", lC = "elegant, detaljeret", cC = "meget høj kvalitet og holdbart broderi", uC = "muligt for mange produkter", dC = "mange motiver og forskellige garnfarver", pC = "alle tekstiler, også kraftigt brugte produkter", mC = "kan vaskes ved høj temperatur, også industrivask", hC = "Arkivering af varianten mislykkedes. Prøv venligst igen.", fC = "Gemning af varianten mislykkedes. Prøv venligst igen.", _C = "Der opstod en fejl under indlæsning.", vC = "Der opstod en fejl under visning af ændringerne. Prøv venligst igen (senere).", gC = "Der opstod en uventet fejl under indlæsning af varianten. Prøv igen (senere) eller opret en ny tilpasning.", kC = "Der opstod en fejl under sletning af arkiv-varianten. Prøv venligst igen.", yC = "færre farver", bC = "Skrifttype", wC = "Skrifttype ikke tilgængelig", xC = "Opdatering af skrifttype", $C = "Nogle skrifttyper er ikke længere tilgængelige. Vælg venligst en anden:", zC = "fra 1 stk.", SC = "Til personaliseringsoversigt", AC = "Højde (i cm)", CC = "Hjælp til fil-upload", PC = "her", MC = "Skjul flader", TC = "Motiv|Motiver", IC = "Motivdatabase", EC = "Vælg et motiv fra vores stadigt voksende motivdatabase. Herefter kan du tilpasse dit motiv.", OC = "Indsæt tekst", RC = "kursiv", LC = "k", DC = "Afstand nederst", jC = "indlæser", NC = "Logo|Logoer", VC = "Logoer & designs", UC = "Udseende", FC = "Filstørrelse: maks.", BC = "Det maksimale antal linjer er nået.", qC = 'Nye udkast er gjort tilgængelige under "{buttonName}".', HC = "Minimum antal", WC = "enkeltfarvet", GC = "flere farver", ZC = "Følgende {termsOfServiceLink} gælder for brug af „CI Configurator MYDESIGN“.", KC = "flerfarvet", XC = "Mine tilpasninger", QC = "Mine filer", JC = "Mine logoer", YC = "Ny tilpasning", eP = "Nyt design", tP = "Nyt udkast", nP = "næste motiv", sP = "Der er endnu ingen logoer for {productionMethod} tilføjet til din konto. Vil du have os til at tilføje dit logo? Kontakt os på: {contact}. Ellers kan du skifte personaliseringstype øverst til højre.", oP = "Der er i øjeblikket ingen logoer til {productionMethod} gemt på din kundekonto.", aP = "Der er endnu ingen designs for {productionMethod} tilføjet til din konto.", iP = "Der er endnu ingen motiver for {productionMethod} med den aktuelle filtrering.", rP = "Indrykning til venstre", lP = "Kun store bogstaver", cP = "eller", uP = "Ellers kan du skifte personaliseringstype øverst til højre.", dP = "PDF-download", pP = "placer", mP = "Placer motiv", hP = "Ret venligst de markerede felter for at vise dit motiv.", fP = "Vent venligst et øjeblik.", _P = "Forhåndsvisning", vP = "Forhåndsvisning af mulige placeringsflader", gP = "Pris", kP = "Skift produktfarve", yP = "Personaliseringstype", bP = "Denne personaliseringstype er ikke mulig for dette produkt.", wP = "udtryksfuld digitaltransfer", xP = "meget høj kvalitet og holdbart broderi", $P = "Antal", zP = "Senest uploadet", SP = "Senest brugt", AP = "omdøb", CP = "erstat", PP = "gem", MP = "gem & indlæs", TP = "Gem tilpasning", IP = "Gemt", EP = "Dit design blev gemt under navnet {name}.", OP = "Gemte designs", RP = "Søg motiv", LP = "Vælg farve", DP = "Vælg fil", jP = "Vælg skrifttype", NP = "Session udløbet", VP = "Din session er udløbet. Genindlæs siden for at fortsætte med at bruge konfiguratoren.", UP = "Vis {count} resultat|Vis {count} resultater", FP = "Vis flader", BP = "Vis mine filer", qP = "Se udkast", HP = "Størrelse", WP = "Størrelse (i cm)", GP = "Udkast", ZP = "Standardfarver", KP = "Understøttede filformater", XP = "Brugsbetingelser", QP = "Tekstiler", JP = "Tekst", YP = "Det valgte design vil erstatte dit nuværende valg", eM = "Denne handling kan ikke fortrydes.", tM = "For at placere det ønskede motiv skal du skifte personaliseringstype til {toProductionMethod}. Derefter kan du vælge en egnet placeringsflade.", nM = "Forsøger at genoprette sessionen.", sM = "opdater", oM = "Opdater artikel inklusive personalisering", aM = "Upload en fil mere", iM = "Din fil opfylder ikke de tekniske krav. Upload venligst et andet filformat. Du kan finde flere oplysninger {here}.", rM = "Upload ikke mulig – din SVG-fil indeholder billed-elementer. Fjern indlejrede billeder og upload filen igen.", lM = "Upload ikke mulig – din SVG-fil indeholder ikke-integrerede skrifttyper. Konverter skrifttyper til stier og upload filen igen.", cM = "Upload mislykkedes – der opstod en uventet fejl. Prøv igen eller brug et andet filformat.", uM = "Upload fil", dM = "Upload egen fil", pM = "Uploads", mM = "Din tilpasning fra", hM = "Vaskeegnethed", fM = "Bredde (i cm)", _M = "Din fil uploades...", vM = "Zoom", gM = {
  abort: pA,
  add_logo: mA,
  add_text: hA,
  add_text_line: fA,
  add_to_cart: _A,
  align: vA,
  all_positioning_areas_are_occupied: gA,
  apply: kA,
  apply_to_all_lines: yA,
  archive: bA,
  archive_fetch_selected_customization: wA,
  archive_fetch_variant_with_customizations: xA,
  archive_new_entry_soon_available: $A,
  archived_variant_successfully: zA,
  are_you_sure_you_want_to_delete: SA,
  at_least_one_motiv_is_not_available: AA,
  back: CA,
  bend_text_line: PA,
  boot_error: MA,
  change_production_method_info: TA,
  change_to_x: IA,
  choose: EA,
  choose_a_positioning_area: OA,
  choose_icon: RA,
  choose_logo: LA,
  choose_production_method: DA,
  clear_filters: jA,
  color: NA,
  colors: VA,
  confirm: UA,
  confirmation: FA,
  confirmation_description: BA,
  continue: "fortsæt",
  continue_with_x: qA,
  current_edited_customization_will_be_aborted: HA,
  currently_in_cart: WA,
  currently_no_uploaded_files: GA,
  custom: ZA,
  customization_type: KA,
  customizations: XA,
  delete: "slet",
  designs: QA,
  distance_motif_text: JA,
  do_you_want_to_rename: YA,
  drag_file_over_area: eC,
  dtf_look: tC,
  dtf_selling_point_1: nC,
  dtf_selling_point_2: sC,
  dtf_selling_point_3: oC,
  dtf_textiles: aC,
  dtf_washability: iC,
  element_outside_placement_area: rC,
  embroidery_look: lC,
  embroidery_selling_point_1: cC,
  embroidery_selling_point_2: uC,
  embroidery_selling_point_3: dC,
  embroidery_textiles: pC,
  embroidery_washability: mC,
  error_failed_to_archive_variant: hC,
  error_failed_to_save_variant: fC,
  error_loading: _C,
  error_pusher_rendering_failed: vC,
  error_pusher_rendering_failed_while_loading_variant: gC,
  error_while_deleting_archive_variant: kC,
  fewer_colors: yC,
  font: bC,
  font_not_available: wC,
  font_update: xC,
  font_update_explanation: $C,
  from_one_piece: zC,
  go_to_production_method_overview: SC,
  height_abbreviation: AC,
  help_for_upload: CC,
  here: PC,
  hide_areas: MC,
  icon: TC,
  icon_database: IC,
  icon_database_description: EC,
  insert_text: OC,
  italic: RC,
  italic_short: LC,
  line_height: DC,
  loading: jC,
  logos: NC,
  logos_and_designs: VC,
  look: UC,
  max_file_size: FC,
  maximum_number_of_lines: BC,
  merchant_sketch_variant_added: qC,
  minimum_quantity: HC,
  mono_colored: WC,
  more_colors: GC,
  more_informations_about_upload: ZC,
  multi_colored: KC,
  my_customizations: XC,
  my_files: QC,
  my_logos: JC,
  new: "ny",
  new_customization: YC,
  new_design: eP,
  new_sketch: tP,
  next_motif: nP,
  no_customer_logos: sP,
  no_customer_logos_for_production_method: oP,
  no_designs: aP,
  no_motifs: iP,
  offset_left: rP,
  only_uppercase: lP,
  or: cP,
  otherwise_change_personalization_type_top_right: uP,
  pdf_download: dP,
  place: pP,
  place_logo: mP,
  please_correct_the_highlighted_errors: hP,
  please_hold_on_for_a_moment: fP,
  preview: _P,
  preview_of_possibile_positioning_areas: vP,
  price: gP,
  product_colors: kP,
  production_method: yP,
  production_method_not_available_for_variant: bP,
  production_method_summary_dtf: wP,
  production_method_summary_embroidery: xP,
  quantity: $P,
  recently_uploaded: zP,
  recently_used: SP,
  rename: AP,
  replace: CP,
  save: PP,
  save_and_load: MP,
  save_variant: TP,
  saved: IP,
  saved_design_successfully: EP,
  saved_designs: OP,
  search_logo: RP,
  select_color: LP,
  select_file: DP,
  select_font: jP,
  session_expired: NP,
  session_expired_description: VP,
  show_X_results: UP,
  show_areas: FP,
  show_own_files: BP,
  show_sketches: qP,
  size: HP,
  size_in_unit: WP,
  sketches: GP,
  standard_colors: ZP,
  supported_file_types: KP,
  terms_of_service: XP,
  textiles: QP,
  texts: JP,
  the_selected_design_will_replace_the_current_selection: YP,
  this_action_can_not_be_undone: eM,
  to_place_motif_change_production_method: tM,
  trying_to_reconnect_session: nM,
  update: sM,
  update_article_with_designs: oM,
  upload_another_file: aM,
  upload_error_422_content_type: iM,
  upload_error_svg_contains_image: rM,
  upload_error_svg_contains_text: lM,
  upload_error_unexpected: cM,
  upload_file: uM,
  upload_own_file: dM,
  uploads: pM,
  views_preview_headlide: mM,
  washablility: hM,
  width_abbreviation: fM,
  your_file_is_beeing_uploaded: _M,
  zoom: vM
}, kM = "abbrechen", yM = "Logo hinzufügen", bM = "Text hinzufügen", wM = "Zeile hinzufügen", xM = "zur Bestellung", $M = "ausrichten", zM = "Keine freie Platzierungsfläche auf dieser Ansicht.", SM = "anwenden", AM = "Für alle Zeilen übernehmen", CM = "Archiv", PM = "Ausgewähltes Motiv laden", MM = "Artikel inklusive Personalisierung laden", TM = "Ein neuer Archiv-Eintrag ist in Kürze verfügbar.", IM = "Ihre Personalisierung wurde erfolgreich gespeichert.", EM = "Möchten Sie { deleteName } wirklich löschen?", OM = "mindestens ein Motiv ist nicht mehr verfügbar!", RM = "zurück", LM = "Text krümmen", DM = { authentication: "Die Authentifizierung ist fehlgeschlagen.", headline: "Beim Starten des Konfigurators ist ein Fehler aufgetreten.", unexpected: "Unerwarteter Fehler", variant_not_found: "Die gewünschte Variante wurde nicht gefunden." }, jM = "Sie befinden sich aktuell auf einer Platzierungsfläche für {fromProductionMethod}.", NM = "zu {x} wechseln", VM = "auswählen", UM = "Bitte wählen Sie eine Platzierungsfläche.", FM = "Anderes Motiv auswählen", BM = "Anderes Logo auswählen", qM = "Personalisierungsart wählen", HM = "alle Filter löschen", WM = "Farbe", GM = "Farben", ZM = "bestätigen", KM = "Bestätigung", XM = "Mit dem Hochladen der gewünschten Personalisierung bestätigen Sie, dass Sie befugt sind, die Personalisierung auf Textilien anbringen zu lassen, insbesondere, dass die Personalisierung nicht gegen Namens- und Markenrechte, Designrechte, Urheberrechte oder sonstige Rechte Dritter ebenso wie gegen allgemeine (insbesondere strafrechtliche) Gesetze verstößt. Sollten wir wegen der von Ihnen vorgenommenen Konfiguration aufgrund der Verletzung von Rechten Dritter oder allgemeiner Gesetze in Anspruch genommen werden, so sind Sie verpflichtet, uns von sämtlichen Ansprüchen und Schäden in diesem Zusammenhang freizustellen.", QM = "mit {x} fortfahren", JM = "Hinweis: Ungespeicherte Designs gehen beim Aufruf der Entwürfe leider verloren.", YM = "Aktuell im Warenkorb", eT = "Bisher wurden keine Dateien hochgeladen", tT = "Individuell", nT = "Motivart", sT = "Personalisierungen", oT = "Design|Designs", aT = "Abstand Motiv/Text (in mm)", iT = "Möchten Sie {name} umbenennen?", rT = "Datei direkt ins Feld ziehen", lT = "farbbrillant, vielfältig", cT = "ausdrucksstarker Digitaltransfer", uT = "optimal für große Aufdrucke", dT = "flexibel in Größen & Farben", pT = "für ausgewählte Textilien & alle Basics", mT = "Maschinenwäsche bis 40˚C", hT = "Element ist außerhalb der Platzierungsfläche.", fT = "edel, filigran", _T = "sehr hochwertiger & langlebiger Stick", vT = "möglich für eine große Zahl an Artikeln", gT = "viele Motive & verschiedene Garnfarben", kT = "alle Textilien, auch stark beanspruchte Artikel", yT = "heiß waschbar, auch Industriewäsche", bT = "Das Archivieren der Variante ist fehlgeschlagen. Bitte versuchen Sie es erneut.", wT = "Das Speichern der Variante ist fehlgeschlagen. Bitte versuchen Sie es erneut.", xT = "Es ist ein Fehler beim Laden aufgetreten.", $T = "Es ist ein Fehler beim Darstellen der Änderungen aufgetreten. Bitte versuchen Sie es (später) erneut.", zT = "Beim Laden der Variante kam es zu einem unerwarteten Fehler. Bitte versuchen Sie es (später) erneut oder erstellen Sie eine neue Personalisierung.", ST = "Beim Löschen der Archiv-Variante ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.", AT = "weniger Farben", CT = "Schrift", PT = "Schrift nicht verfügbar", MT = "Schriftaktualisierung", TT = "Einige Schriften sind nicht mehr verfügbar. Wählen Sie bitte eine andere aus:", IT = "ab 1 Stück", ET = "Zur Personalisierungsübersicht", OT = "Höhe (in cm)", RT = "Hilfe zum Datei-Upload", LT = "hier", DT = "Flächen ausblenden", jT = "Motiv|Motive", NT = "Motivdatenbank", VT = "Wählen Sie ein Motiv aus unserer stetig wachsenden Motivdatenbank aus. Anschließend haben Sie die Möglichkeit Ihr Motiv zu individualisieren.", UT = "Text einfügen", FT = "kursiv", BT = "k", qT = "Abstand unten", HT = "laden", WT = "Logo|Logos", GT = "Logos & Designs", ZT = "Look", KT = "Dateigröße: max.", XT = "Die maximale Zeilenanzahl ist erreicht.", QT = 'Unter "{buttonName}" wurden neue Entwürfe für Sie bereitgestellt.', JT = "Mindestmenge", YT = "einfarbig", eI = "weitere Farben", tI = "Für die Nutzung des „CI Configurator MYDESIGN“ gelten folgende {termsOfServiceLink}.", nI = "mehrfarbig", sI = "Meine Personalisierungen", oI = "Meine Dateien", aI = "Meine Logos", iI = "Neue Personalisierung", rI = "Neues Design", lI = "Neuer Entwurf", cI = "nächstes Motiv", uI = "In Ihrem Kundenkonto sind aktuell noch keine Logos für {productionMethod} hinterlegt.", dI = "In Ihrem Kundenkonto sind aktuell noch keine Designs für {productionMethod} hinterlegt.", pI = "Für Ihre aktuelle Filterung sind aktuell noch keine {productionMethod}-Motive hinterlegt.", mI = "Einzug links", hI = "Nur Großbuchstaben", fI = "oder", _I = "Ansonsten können Sie oben rechts die Personalisierungsart wechseln.", vI = "PDF-Download", gI = "platzieren", kI = "Motiv platzieren", yI = "Bitte korrigieren Sie die markierten Felder, um ihr Motiv anzuzeigen.", bI = "Bitte haben Sie einen Augenblick Geduld.", wI = "Vorschau", xI = "Vorschau der möglichen Platzierungsflächen", $I = "Preis", zI = "Artikelfarbe ändern", SI = "Personalisierungsart", AI = "Personalisierungsart auf diesem Artikel leider nicht möglich.", CI = "ausdrucksstarker Digitaltransfer", PI = "sehr hochwertiger & langlebiger Stick", MI = "Menge", TI = "Zuletzt hochgeladen", II = "Zuletzt verwendet", EI = "umbenennen", OI = "ersetzen", RI = "speichern", LI = "speichern & laden", DI = "Personalisierung speichern", jI = "Gespeichert", NI = "Ihr Design wurde erfolgreich unter dem Namen {name} gespeichert.", VI = "Gespeicherte Designs", UI = "Motiv suchen", FI = "Farbe auswählen", BI = "Datei auswählen", qI = "Schrift wählen", HI = "Sitzung abgelaufen", WI = "Ihre Sitzung ist abgelaufen. Bitte laden Sie die Seite erneut, um den Konfigurator weiter nutzen zu können.", GI = "{count} Ergebnis anzeigen|{count} Ergebnisse anzeigen", ZI = "Flächen einblenden", KI = "Meine Dateien anzeigen", XI = "Entwürfe jetzt ansehen", QI = "Größe", JI = "Größe (in cm)", YI = "Entwürfe", eE = "Standardfarben", tE = "Mögliche Dateiformate", nE = "Nutzungsbedingungen", sE = "Textilien", oE = "Text", aE = "Das ausgewählte Design wird Ihre aktuelle Auswahl ersetzen", iE = "Diese Aktion kann nicht rückgängig gemacht werden.", rE = "Um das gewünschte Motiv zu platzieren, wechseln Sie bitte die Personalisierungsart zu {toProductionMethod}. Im Anschluss können Sie eine passende Platzierungsfläche auswählen.", lE = "Es wird versucht, Ihre Sitzung wiederherzustellen.", cE = "aktualisieren", uE = "Artikel inklusive Personalisierung aktualisieren", dE = "weitere Datei hochladen", pE = "Ihre Datei erfüllt leider nicht die technischen Anforderungen. Bitte laden Sie ein anderes Dateiformat hoch. Weitere Informationen finden Sie {here}.", mE = "Upload nicht möglich – Ihre SVG-Datei enthält Bildelemente. Bitte entfernen Sie eingebettete Bilder und laden Sie die Datei erneut hoch.", hE = "Upload nicht möglich – Ihre SVG-Datei enthält nicht eingebettete Schriften. Bitte wandeln Sie enthaltene Schriften in Pfade um und laden Sie die Datei erneut hoch.", fE = "Upload fehlgeschlagen – ein unerwarteter Fehler ist aufgetreten. Bitte probieren Sie es erneut oder verwenden Sie ein anderes Dateiformat.", _E = "Datei hochladen", vE = "Eigene Datei Hochladen", gE = "Uploads", kE = "Ihre Personalisierung von", yE = "Waschbarkeit", bE = "Breite (in cm)", wE = "Ihre Datei wird gerade hochgeladen...", xE = "Zoom", $E = {
  abort: kM,
  add_logo: yM,
  add_text: bM,
  add_text_line: wM,
  add_to_cart: xM,
  align: $M,
  all_positioning_areas_are_occupied: zM,
  apply: SM,
  apply_to_all_lines: AM,
  archive: CM,
  archive_fetch_selected_customization: PM,
  archive_fetch_variant_with_customizations: MM,
  archive_new_entry_soon_available: TM,
  archived_variant_successfully: IM,
  are_you_sure_you_want_to_delete: EM,
  at_least_one_motiv_is_not_available: OM,
  back: RM,
  bend_text_line: LM,
  boot_error: DM,
  change_production_method_info: jM,
  change_to_x: NM,
  choose: VM,
  choose_a_positioning_area: UM,
  choose_icon: FM,
  choose_logo: BM,
  choose_production_method: qM,
  clear_filters: HM,
  color: WM,
  colors: GM,
  confirm: ZM,
  confirmation: KM,
  confirmation_description: XM,
  continue: "weiter",
  continue_with_x: QM,
  current_edited_customization_will_be_aborted: JM,
  currently_in_cart: YM,
  currently_no_uploaded_files: eT,
  custom: tT,
  customization_type: nT,
  customizations: sT,
  delete: "löschen",
  designs: oT,
  distance_motif_text: aT,
  do_you_want_to_rename: iT,
  drag_file_over_area: rT,
  dtf_look: lT,
  dtf_selling_point_1: cT,
  dtf_selling_point_2: uT,
  dtf_selling_point_3: dT,
  dtf_textiles: pT,
  dtf_washability: mT,
  element_outside_placement_area: hT,
  embroidery_look: fT,
  embroidery_selling_point_1: _T,
  embroidery_selling_point_2: vT,
  embroidery_selling_point_3: gT,
  embroidery_textiles: kT,
  embroidery_washability: yT,
  error_failed_to_archive_variant: bT,
  error_failed_to_save_variant: wT,
  error_loading: xT,
  error_pusher_rendering_failed: $T,
  error_pusher_rendering_failed_while_loading_variant: zT,
  error_while_deleting_archive_variant: ST,
  fewer_colors: AT,
  font: CT,
  font_not_available: PT,
  font_update: MT,
  font_update_explanation: TT,
  from_one_piece: IT,
  go_to_production_method_overview: ET,
  height_abbreviation: OT,
  help_for_upload: RT,
  here: LT,
  hide_areas: DT,
  icon: jT,
  icon_database: NT,
  icon_database_description: VT,
  insert_text: UT,
  italic: FT,
  italic_short: BT,
  line_height: qT,
  loading: HT,
  logos: WT,
  logos_and_designs: GT,
  look: ZT,
  max_file_size: KT,
  maximum_number_of_lines: XT,
  merchant_sketch_variant_added: QT,
  minimum_quantity: JT,
  mono_colored: YT,
  more_colors: eI,
  more_informations_about_upload: tI,
  multi_colored: nI,
  my_customizations: sI,
  my_files: oI,
  my_logos: aI,
  new: "neu",
  new_customization: iI,
  new_design: rI,
  new_sketch: lI,
  next_motif: cI,
  no_customer_logos_for_production_method: uI,
  no_designs: dI,
  no_motifs: pI,
  offset_left: mI,
  only_uppercase: hI,
  or: fI,
  otherwise_change_personalization_type_top_right: _I,
  pdf_download: vI,
  place: gI,
  place_logo: kI,
  please_correct_the_highlighted_errors: yI,
  please_hold_on_for_a_moment: bI,
  preview: wI,
  preview_of_possibile_positioning_areas: xI,
  price: $I,
  product_colors: zI,
  production_method: SI,
  production_method_not_available_for_variant: AI,
  production_method_summary_dtf: CI,
  production_method_summary_embroidery: PI,
  quantity: MI,
  recently_uploaded: TI,
  recently_used: II,
  rename: EI,
  replace: OI,
  save: RI,
  save_and_load: LI,
  save_variant: DI,
  saved: jI,
  saved_design_successfully: NI,
  saved_designs: VI,
  search_logo: UI,
  select_color: FI,
  select_file: BI,
  select_font: qI,
  session_expired: HI,
  session_expired_description: WI,
  show_X_results: GI,
  show_areas: ZI,
  show_own_files: KI,
  show_sketches: XI,
  size: QI,
  size_in_unit: JI,
  sketches: YI,
  standard_colors: eE,
  supported_file_types: tE,
  terms_of_service: nE,
  textiles: sE,
  texts: oE,
  the_selected_design_will_replace_the_current_selection: aE,
  this_action_can_not_be_undone: iE,
  to_place_motif_change_production_method: rE,
  trying_to_reconnect_session: lE,
  update: cE,
  update_article_with_designs: uE,
  upload_another_file: dE,
  upload_error_422_content_type: pE,
  upload_error_svg_contains_image: mE,
  upload_error_svg_contains_text: hE,
  upload_error_unexpected: fE,
  upload_file: _E,
  upload_own_file: vE,
  uploads: gE,
  views_preview_headlide: kE,
  washablility: yE,
  width_abbreviation: bE,
  your_file_is_beeing_uploaded: wE,
  zoom: xE
}, zE = "Cancel", SE = "Add logo", AE = "Add text", CE = "Add row", PE = "Add to cart", ME = "Align", TE = "No free positioning area on this screen.", IE = "Apply", EE = "Use for all rows", OE = "Archive", RE = "Load selected motif", LE = "Load item including personalisation", DE = "A new archive entry will be available shortly.", jE = "Your personalisation has been successfully saved.", NE = "Do you really want to delete {deleteName}?", VE = "At least one design is no longer available!", UE = "back", FE = "Bend text", BE = { authentication: "Authentication has failed.", headline: "An error occurred when starting the Designer.", unexpected: "Unexpected error", variant_not_found: "The desired variant was not found." }, qE = "You are currently on a placement area for {fromProductionMethod}.", HE = "Switch to {x}", WE = "select", GE = "Please select a positioning area.", ZE = "Select another design", KE = "Select a different logo", XE = "Choose production type", QE = "Clear all filters", JE = "Colour", YE = "Colours", eO = "confirm", tO = "Confirmation", nO = "By uploading the desired personalization, you confirm that you are authorized to have the personalization applied to textiles, in particular that the personalization does not violate name and trademark rights, design rights, copyrights, or other third-party rights, as well as general (especially criminal) laws. Should we be held liable due to the configuration you have made because of infringement of third-party rights or general laws, you are obliged to indemnify us against all claims and damages in this context.", sO = "continue with {x}", oO = "Note: Unsaved designs will unfortunately be lost when you access the drafts.", aO = "Currently in Cart", iO = "No files uploaded so far", rO = "Custom", lO = "Customization type", cO = "Personalisations", uO = "Designs|Designs", dO = "Spacing between motif/text", pO = "Do you want to rename {name}?", mO = "Drag file directly into the field", hO = "bright, versatile", fO = "expressive digital transfer printing", _O = "optimal for large prints", vO = "flexible in size and colours", gO = "for selected fabrics & all basics", kO = "Machine washable up to 40 °C", yO = "Element is outside the positioning area.", bO = "elegant, delicate", wO = "very high-quality & durable embroidery", xO = "possible for a large number of articles", $O = "many motifs & different thread colours", zO = "all textiles, even heavily used ones", SO = "hot washable, even industrial laundry", AO = "Archiving of the variants failed. Please try again.", CO = "Saving of the variants failed. Please try again.", PO = "An error occurred during loading.", MO = "An error occurred when showing the changes. Please try again (later).", TO = "An unexpected error occurred when loading the variant. Please try again (later) or create a new personalisation.", IO = "An error occurred when deleting the archive variant. Please try again.", EO = "fewer colours", OO = "Font", RO = "Font not available", LO = "Font update", DO = "Some fonts are no longer available. Please choose another one:", jO = "from 1 piece", NO = "to the personalisation overview", VO = "Height (in cm)", UO = "Help with file upload", FO = "here", BO = "Hide areas", qO = "Motif|Motifs", HO = "Motif database", WO = "Select a design from our continuously growing design database. Then you will have the opportunity to customise your design.", GO = "Insert text", ZO = "Italic", KO = "i", XO = "Spacing below", QO = "Loading", JO = "Logo|Logos", YO = "Logos & designs", eR = "Look", tR = "File size: max.", nR = "The maximum number of rows has been reached.", sR = 'Under "{buttonName}" new drafts have been provided for you.', oR = "Minimum quantity", aR = "Single-colour", iR = "More colours", rR = 'The following {termsOfServiceLink} to the use of the "CI Configurator MYDESIGN."', lR = "Multi-colour", cR = "My Personalisations", uR = "My files", dR = "My logos", pR = "New personalisation", mR = "New design", hR = "New draft", fR = "next design", _R = "There are currently no logos stored in your customer account for {productionMethod}. Would you like us to save your logo? Please contact us at: {contact}. Alternatively, you can switch the personalisation type in the top-right corner.", vR = "There are currently no logos stored in your customer account for {productionMethod}.", gR = "There are currently no designs stored in your customer account for {productionMethod}.", kR = "No motifs could be found for your current filter selection.", yR = "Indent left", bR = "Only upper case characters", wR = "or", xR = "Otherwise, you can switch the personalization type in the top right.", $R = "PDF download", zR = "Place", SR = "Place design", AR = "Please correct the marked fields to display your motif.", CR = "Please hold on for a moment.", PR = "Preview", MR = "Preview of possible placement areas", TR = "Price", IR = "Change product colour", ER = "Production type", OR = "Unfortunately, this type of personalisation is not possible on this item.", RR = "expressive digital transfer printing", LR = "very high-quality & durable embroidery", DR = "Quantity", jR = "Recently uploaded", NR = "Recently used", VR = "rename", UR = "replace", FR = "Save", BR = "save & load", qR = "Save personalisation", HR = "Saved", WR = "Your design has been successfully saved under the name {name}.", GR = "Saved designs", ZR = "Search motif", KR = "select colour", XR = "Select file", QR = "Select font", JR = "Session expired", YR = "Your session has expired. Please reload the page to continue using the designer.", eL = "Show {count} result|Show {count} results", tL = "Show areas", nL = "Show my files", sL = "View drafts now", oL = "Size", aL = "Size (in cm)", iL = "Drafts", rL = "Standard colours", lL = "Supported file formats", cL = "terms of use", uL = "Textiles", dL = "Text", pL = "The selected design will replace your current selection.", mL = "This action cannot be undone.", hL = "To position the desired motif, please switch the personalisation type to {toProductionMethod}. You can then select a suitable placement area.", fL = "An attempt is made to restore your session.", _L = "update", vL = "Update item including personalization", gL = "Upload another file", kL = "Unfortunately, your file does not meet the technical requirements. Please upload a different file format. You can find more information {here}.", yL = "Upload failed – Your SVG file contains image elements. Please remove embedded images and upload the file again.", bL = "Upload failed – Your SVG file contains non-converted text. Please convert all fonts to outlines and upload the file again.", wL = "Upload failed – An unexpected error occurred. Please try again or use a different file format.", xL = "Upload file", $L = "Upload own file", zL = "Uploads", SL = "Your personalisation from the", AL = "Washability", CL = "Width (in cm)", PL = "Your file is being uploaded...", ML = "Zoom", TL = {
  abort: zE,
  add_logo: SE,
  add_text: AE,
  add_text_line: CE,
  add_to_cart: PE,
  align: ME,
  all_positioning_areas_are_occupied: TE,
  apply: IE,
  apply_to_all_lines: EE,
  archive: OE,
  archive_fetch_selected_customization: RE,
  archive_fetch_variant_with_customizations: LE,
  archive_new_entry_soon_available: DE,
  archived_variant_successfully: jE,
  are_you_sure_you_want_to_delete: NE,
  at_least_one_motiv_is_not_available: VE,
  back: UE,
  bend_text_line: FE,
  boot_error: BE,
  change_production_method_info: qE,
  change_to_x: HE,
  choose: WE,
  choose_a_positioning_area: GE,
  choose_icon: ZE,
  choose_logo: KE,
  choose_production_method: XE,
  clear_filters: QE,
  color: JE,
  colors: YE,
  confirm: eO,
  confirmation: tO,
  confirmation_description: nO,
  continue: "Continue",
  continue_with_x: sO,
  current_edited_customization_will_be_aborted: oO,
  currently_in_cart: aO,
  currently_no_uploaded_files: iO,
  custom: rO,
  customization_type: lO,
  customizations: cO,
  delete: "Delete",
  designs: uO,
  distance_motif_text: dO,
  do_you_want_to_rename: pO,
  drag_file_over_area: mO,
  dtf_look: hO,
  dtf_selling_point_1: fO,
  dtf_selling_point_2: _O,
  dtf_selling_point_3: vO,
  dtf_textiles: gO,
  dtf_washability: kO,
  element_outside_placement_area: yO,
  embroidery_look: bO,
  embroidery_selling_point_1: wO,
  embroidery_selling_point_2: xO,
  embroidery_selling_point_3: $O,
  embroidery_textiles: zO,
  embroidery_washability: SO,
  error_failed_to_archive_variant: AO,
  error_failed_to_save_variant: CO,
  error_loading: PO,
  error_pusher_rendering_failed: MO,
  error_pusher_rendering_failed_while_loading_variant: TO,
  error_while_deleting_archive_variant: IO,
  fewer_colors: EO,
  font: OO,
  font_not_available: RO,
  font_update: LO,
  font_update_explanation: DO,
  from_one_piece: jO,
  go_to_production_method_overview: NO,
  height_abbreviation: VO,
  help_for_upload: UO,
  here: FO,
  hide_areas: BO,
  icon: qO,
  icon_database: HO,
  icon_database_description: WO,
  insert_text: GO,
  italic: ZO,
  italic_short: KO,
  line_height: XO,
  loading: QO,
  logos: JO,
  logos_and_designs: YO,
  look: eR,
  max_file_size: tR,
  maximum_number_of_lines: nR,
  merchant_sketch_variant_added: sR,
  minimum_quantity: oR,
  mono_colored: aR,
  more_colors: iR,
  more_informations_about_upload: rR,
  multi_colored: lR,
  my_customizations: cR,
  my_files: uR,
  my_logos: dR,
  new: "new",
  new_customization: pR,
  new_design: mR,
  new_sketch: hR,
  next_motif: fR,
  no_customer_logos: _R,
  no_customer_logos_for_production_method: vR,
  no_designs: gR,
  no_motifs: kR,
  offset_left: yR,
  only_uppercase: bR,
  or: wR,
  otherwise_change_personalization_type_top_right: xR,
  pdf_download: $R,
  place: zR,
  place_logo: SR,
  please_correct_the_highlighted_errors: AR,
  please_hold_on_for_a_moment: CR,
  preview: PR,
  preview_of_possibile_positioning_areas: MR,
  price: TR,
  product_colors: IR,
  production_method: ER,
  production_method_not_available_for_variant: OR,
  production_method_summary_dtf: RR,
  production_method_summary_embroidery: LR,
  quantity: DR,
  recently_uploaded: jR,
  recently_used: NR,
  rename: VR,
  replace: UR,
  save: FR,
  save_and_load: BR,
  save_variant: qR,
  saved: HR,
  saved_design_successfully: WR,
  saved_designs: GR,
  search_logo: ZR,
  select_color: KR,
  select_file: XR,
  select_font: QR,
  session_expired: JR,
  session_expired_description: YR,
  show_X_results: eL,
  show_areas: tL,
  show_own_files: nL,
  show_sketches: sL,
  size: oL,
  size_in_unit: aL,
  sketches: iL,
  standard_colors: rL,
  supported_file_types: lL,
  terms_of_service: cL,
  textiles: uL,
  texts: dL,
  the_selected_design_will_replace_the_current_selection: pL,
  this_action_can_not_be_undone: mL,
  to_place_motif_change_production_method: hL,
  trying_to_reconnect_session: fL,
  update: _L,
  update_article_with_designs: vL,
  upload_another_file: gL,
  upload_error_422_content_type: kL,
  upload_error_svg_contains_image: yL,
  upload_error_svg_contains_text: bL,
  upload_error_unexpected: wL,
  upload_file: xL,
  upload_own_file: $L,
  uploads: zL,
  views_preview_headlide: SL,
  washablility: AL,
  width_abbreviation: CL,
  your_file_is_beeing_uploaded: PL,
  zoom: ML
}, IL = "Annuler", EL = "Ajouter un logo", OL = "Ajouter du texte", RL = "Ajouter une ligne", LL = "Vers la commande", DL = "Aligner", jL = "Pas de surface de placement libre sur cette affichage.", NL = "Appliquer", VL = "Reprendre pour toutes les lignes", UL = "Archive", FL = "Charger un motif sélectionné", BL = "Charger l'article avec la personnalisation", qL = "Une nouvelle entrée d'archive sera bientôt disponible.", HL = "Votre personnalisation a été sauvegardée avec succès.", WL = "Voulez-vous vraiment supprimer {deleteName}?", GL = "Au moins un motif n’est plus disponible !", ZL = "retour", KL = "Courber le texte", XL = { authentication: "L'authentification a échoué.", headline: "Une erreur est survenue lors du lancement du designer.", unexpected: "Erreur inattendue", variant_not_found: "La variante souhaitée n'a pas été trouvée." }, QL = "Vous vous trouvez actuellement sur un emplacement de {fromProductionMethod}.", JL = "Passer à {x}", YL = "Sélectionner", eD = "Veuillez sélectionner une surface de placement.", tD = "Sélectionner un autre motif", nD = "Sélectionner un autre logo", sD = "Sélectionner le type de personnalisation", oD = "Supprimer tous les filtres", aD = "Couleur", iD = "Couleurs", rD = "confirmer", lD = "Confirmation", cD = "En téléchargeant la personnalisation souhaitée, vous confirmez que vous êtes autorisé à faire apposer la personnalisation sur des textiles, en particulier que cette personnalisation ne viole pas les droits de nom et de marque, les droits de design, les droits d'auteur ou autres droits de tiers, ainsi que les lois générales (notamment pénales). Si nous étions tenus responsables en raison de la configuration que vous avez effectuée pour violation des droits de tiers ou des lois générales, vous êtes tenu de nous indemniser pour toutes les réclamations et dommages y afférents.", uD = "poursuivre avec {x}", dD = "Remarque: Les designs non enregistrés seront malheureusement perdus lors de la consultation des projets.", pD = "Actuellement dans le panier", mD = "Aucun fichier n'a encore été téléchargé", hD = "Individuel", fD = "Type de motif", _D = "Personnalisations", vD = "Design|Designs", gD = "Distance motif/texte", kD = "Voulez-vous renommer {name}?", yD = "Glisser le fichier directement dans le champ", bD = "brillance des couleurs, polyvalence", wD = "impression par transfert digital expressive", xD = "idéal pour les grandes impressions", $D = "tailles et couleurs flexibles", zD = "pour une sélection de textiles et tous les basiques", SD = "Lavage en machine jusqu’à 40 °C", AD = "L'élément est en-dehors de la surface de placement.", CD = "élégance, discrétion", PD = "Broderie de très haute qualité et durable", MD = "possible pour un grand nombre d'articles", TD = "de nombreux motifs et différentes couleurs de fils", ID = "tous les textiles, même les plus usagés", ED = "lavable très chaud, y compris avec un lavage industriel", OD = "L'archivage de la variante a échoué. Veuillez réessayer.", RD = "L'enregistrement de la variante a échoué. Veuillez réessayer.", LD = "Une erreur est survenue lors du chargement.", DD = "Une erreur est survenue lors de l'affichage des modifications. Veuillez essayer une nouvelle fois (plus tard).", jD = "Une erreur inattendue est survenue lors du chargement de la variante. Veuillez essayer une nouvelle fois (plus tard) ou créez une nouvelle personnalisation.", ND = "Une erreur est survenue lors de la suppression de la variante d'archive. Veuillez réessayer.", VD = "moins de couleurs", UD = "Police", FD = "Police non disponible", BD = "Mise à jour de la police", qD = "Certaines polices ne sont plus disponibles. Veuillez en sélectionner une autre :", HD = "partir de 1 pièce", WD = "Vers l'aperçu de la personnalisation", GD = "Hauteur (en cm)", ZD = "Aide au Téléversement", KD = "ici", XD = "Masquer les surfaces", QD = "Motif|Motifs", JD = "Base de données de motifs", YD = "Sélectionnez un motif dans notre base de données de motifs en développement constant. Vous aurez ensuite la possibilité de personnaliser votre motif.", ej = "Insérer un texte", tj = "Italique", nj = "i", sj = "Distance en bas", oj = "Charger", aj = "Logo|Logos", ij = "Logos & designs", rj = "Style", lj = "Taille du fichier : max.", cj = "Le nombre maximum de lignes est atteint.", uj = "Dans «{buttonName}» de nouveaux projets ont été mis à disposition pour vous.", dj = "Quantité minimum", pj = "uni", mj = "Autres couleurs", hj = "Les {termsOfServiceLink} suivantes s’appliquent à l’utilisation du « CI Configurator MYDESIGN ».", fj = "multicolore", _j = "Mes personnalisations", vj = "Mes fichiers", gj = "Mes logos", kj = "Nouvelle personnalisation", yj = "Nouveau design", bj = "Nouveau projet", wj = "motif suivant", xj = "Votre compte client ne contient actuellement pas de logos enregistrés pour {productionMethod}. Vous souhaitez faire enregistrer votre logo par nos services ? Alors veuillez nous contacter sur : {contact}. Sinon, vous pouvez changer le type de personnalisation en haut à droite.", $j = "Aucun logo n’est actuellement enregistré dans votre compte client pour {productionMethod}.", zj = "Votre compte client ne contient actuellement pas de designs {productionMethod}.", Sj = "Aucun motif n’a malheureusement pu être trouvé pour votre filtre actuel.", Aj = "Justifier à gauche", Cj = "Majuscules uniquement", Pj = "ou", Mj = "Sinon, vous pouvez changer le type de personnalisation en haut à droite.", Tj = "Téléchargement PDF", Ij = "Positionner", Ej = "Placer le motif", Oj = "Veuillez corriger les champs marqués pour afficher votre motif.", Rj = "Merci de patienter un instant.", Lj = "Aperçu", Dj = "Aperçu des emplacements possibles", jj = "Prix", Nj = "Modifier la couleur de l'article", Vj = "Type de personnalisation", Uj = "Le type de personnalisation sur cet article n'est malheureusement pas possible.", Fj = "impression par transfert digital expressive", Bj = "Broderie de très haute qualité et durable", qj = "Quantité", Hj = "Récemment téléchargé", Wj = "Récemment utilisé", Gj = "Renommer", Zj = "remplacer", Kj = "Enregistrer", Xj = "enregistrer & charger", Qj = "Enregistrer la personnalisation", Jj = "Enregistré", Yj = "Votre design a été enregistré avec succès sous le nom {name}.", eN = "Designs enregistrés", tN = "Rechercher un motif", nN = "Choisir la couleur", sN = "Sélectionner un fichier", oN = "Choisir une police", aN = "Session expirée", iN = "Votre session est expirée. Veuillez recharger la page pour pouvoir continuer à utiliser l'outil de conception.", rN = "Afficher {count} résultat|Afficher {count} résultats", lN = "Afficher les surfaces", cN = "Afficher mes fichiers", uN = "Consulter les projets maintenant", dN = "Taille", pN = "TAILLE (en cm)", mN = "Projets", hN = "Couleurs standard", fN = "Formats de fichiers pris en charge", _N = "conditions d’utilisation", vN = "Textiles", gN = "Texte", kN = "Le design sélectionné remplacera votre sélection actuelle.", yN = "Cette action ne pourra pas être annulée.", bN = "Pour placer le motif souhaité, veuillez changer le type de personnalisation pour {toProductionMethod}. Vous pouvez ensuite choisir un emplacement correspondant.", wN = "Une tentative de restauration de votre session est en cours", xN = "mettre à jour", $N = "Mettre à jour l’article, personnalisation incluse", zN = "Télécharger un autre fichier", SN = "Malheureusement, votre fichier ne répond pas aux exigences techniques. Veuillez télécharger un autre format de fichier. Vous trouverez plus d’informations {here}.", AN = "Échec du téléchargement – Votre fichier SVG contient des éléments d’image. Veuillez supprimer les images intégrées et téléverser le fichier à nouveau.", CN = "Échec du téléchargement – Votre fichier SVG contient des polices non converties. Veuillez convertir les polices en tracés avant de téléverser le fichier à nouveau.", PN = "Échec du téléchargement – Une erreur inattendue est survenue. Veuillez réessayer ou utiliser un autre format de fichier.", MN = "Télécharger un fichier", TN = "Télécharger son propre fichier", IN = "Téléchargements", EN = "Votre personnalisation à", ON = "Lavabilité", RN = "Largeur (en cm)", LN = "Votre fichier est en cours de téléchargement...", DN = "Zoom", jN = {
  abort: IL,
  add_logo: EL,
  add_text: OL,
  add_text_line: RL,
  add_to_cart: LL,
  align: DL,
  all_positioning_areas_are_occupied: jL,
  apply: NL,
  apply_to_all_lines: VL,
  archive: UL,
  archive_fetch_selected_customization: FL,
  archive_fetch_variant_with_customizations: BL,
  archive_new_entry_soon_available: qL,
  archived_variant_successfully: HL,
  are_you_sure_you_want_to_delete: WL,
  at_least_one_motiv_is_not_available: GL,
  back: ZL,
  bend_text_line: KL,
  boot_error: XL,
  change_production_method_info: QL,
  change_to_x: JL,
  choose: YL,
  choose_a_positioning_area: eD,
  choose_icon: tD,
  choose_logo: nD,
  choose_production_method: sD,
  clear_filters: oD,
  color: aD,
  colors: iD,
  confirm: rD,
  confirmation: lD,
  confirmation_description: cD,
  continue: "Suite",
  continue_with_x: uD,
  current_edited_customization_will_be_aborted: dD,
  currently_in_cart: pD,
  currently_no_uploaded_files: mD,
  custom: hD,
  customization_type: fD,
  customizations: _D,
  delete: "Supprimer",
  designs: vD,
  distance_motif_text: gD,
  do_you_want_to_rename: kD,
  drag_file_over_area: yD,
  dtf_look: bD,
  dtf_selling_point_1: wD,
  dtf_selling_point_2: xD,
  dtf_selling_point_3: $D,
  dtf_textiles: zD,
  dtf_washability: SD,
  element_outside_placement_area: AD,
  embroidery_look: CD,
  embroidery_selling_point_1: PD,
  embroidery_selling_point_2: MD,
  embroidery_selling_point_3: TD,
  embroidery_textiles: ID,
  embroidery_washability: ED,
  error_failed_to_archive_variant: OD,
  error_failed_to_save_variant: RD,
  error_loading: LD,
  error_pusher_rendering_failed: DD,
  error_pusher_rendering_failed_while_loading_variant: jD,
  error_while_deleting_archive_variant: ND,
  fewer_colors: VD,
  font: UD,
  font_not_available: FD,
  font_update: BD,
  font_update_explanation: qD,
  from_one_piece: HD,
  go_to_production_method_overview: WD,
  height_abbreviation: GD,
  help_for_upload: ZD,
  here: KD,
  hide_areas: XD,
  icon: QD,
  icon_database: JD,
  icon_database_description: YD,
  insert_text: ej,
  italic: tj,
  italic_short: nj,
  line_height: sj,
  loading: oj,
  logos: aj,
  logos_and_designs: ij,
  look: rj,
  max_file_size: lj,
  maximum_number_of_lines: cj,
  merchant_sketch_variant_added: uj,
  minimum_quantity: dj,
  mono_colored: pj,
  more_colors: mj,
  more_informations_about_upload: hj,
  multi_colored: fj,
  my_customizations: _j,
  my_files: vj,
  my_logos: gj,
  new: "nouveau",
  new_customization: kj,
  new_design: yj,
  new_sketch: bj,
  next_motif: wj,
  no_customer_logos: xj,
  no_customer_logos_for_production_method: $j,
  no_designs: zj,
  no_motifs: Sj,
  offset_left: Aj,
  only_uppercase: Cj,
  or: Pj,
  otherwise_change_personalization_type_top_right: Mj,
  pdf_download: Tj,
  place: Ij,
  place_logo: Ej,
  please_correct_the_highlighted_errors: Oj,
  please_hold_on_for_a_moment: Rj,
  preview: Lj,
  preview_of_possibile_positioning_areas: Dj,
  price: jj,
  product_colors: Nj,
  production_method: Vj,
  production_method_not_available_for_variant: Uj,
  production_method_summary_dtf: Fj,
  production_method_summary_embroidery: Bj,
  quantity: qj,
  recently_uploaded: Hj,
  recently_used: Wj,
  rename: Gj,
  replace: Zj,
  save: Kj,
  save_and_load: Xj,
  save_variant: Qj,
  saved: Jj,
  saved_design_successfully: Yj,
  saved_designs: eN,
  search_logo: tN,
  select_color: nN,
  select_file: sN,
  select_font: oN,
  session_expired: aN,
  session_expired_description: iN,
  show_X_results: rN,
  show_areas: lN,
  show_own_files: cN,
  show_sketches: uN,
  size: dN,
  size_in_unit: pN,
  sketches: mN,
  standard_colors: hN,
  supported_file_types: fN,
  terms_of_service: _N,
  textiles: vN,
  texts: gN,
  the_selected_design_will_replace_the_current_selection: kN,
  this_action_can_not_be_undone: yN,
  to_place_motif_change_production_method: bN,
  trying_to_reconnect_session: wN,
  update: xN,
  update_article_with_designs: $N,
  upload_another_file: zN,
  upload_error_422_content_type: SN,
  upload_error_svg_contains_image: AN,
  upload_error_svg_contains_text: CN,
  upload_error_unexpected: PN,
  upload_file: MN,
  upload_own_file: TN,
  uploads: IN,
  views_preview_headlide: EN,
  washablility: ON,
  width_abbreviation: RN,
  your_file_is_beeing_uploaded: LN,
  zoom: DN
}, NN = "mégse", VN = "Logó hozzáadása", UN = "Szöveg hozzáadása", FN = "Sor hozzáadása", BN = "a rendeléshez", qN = "igazítás", HN = "Nincs szabad elhelyezési terület ezen a nézeten.", WN = "alkalmaz", GN = "Alkalmazás minden sorra", ZN = "Archívum", KN = "Kiválasztott motívum betöltése", XN = "Termék betöltése személyre szabással", QN = "Egy új archív bejegyzés hamarosan elérhető lesz.", JN = "A személyre szabás sikeresen mentve.", YN = "Valóban törölni szeretné: { deleteName }?", eV = "Legalább egy minta már nem érhető el!", tV = "vissza", nV = "Szöveg hajlítása", sV = { authentication: "A hitelesítés sikertelen.", headline: "Hiba történt a konfigurátor indításakor.", unexpected: "Váratlan hiba", variant_not_found: "A kívánt variáns nem található." }, oV = "Jelenleg a(z) {fromProductionMethod} elhelyezési területén van.", aV = "váltás erre: {x}", iV = "választ", rV = "Kérem válasszon elhelyezési területet.", lV = "Másik motívum választása", cV = "Másik logó választása", uV = "Személyre szabás módjának kiválasztása", dV = "összes szűrő törlése", pV = "Szín", mV = "Színek", hV = "megerősít", fV = "Megerősítés", _V = "A kívánt személyre szabás feltöltésével megerősíti, hogy jogosult arra, hogy a személyre szabást textíliákra alkalmazzák, különösen hogy a személyre szabás nem sért név- és márkajogokat, formatervezési mintákat, szerzői jogokat vagy más harmadik fél jogokat, valamint általános (különösen büntetőjogi) törvényeket. Ha a konfiguráció miatt harmadik fél igényt vagy kártérítést támaszt, Ön köteles minket minden ilyen igénytől és kártól mentesíteni.", vV = "folytatás ezzel: {x}", gV = "Figyelem: a nem mentett tervek elvesznek a vázlatok megnyitásakor.", kV = "Jelenleg a kosárban", yV = "Eddig nem töltött fel fájlt", bV = "Egyedi", wV = "Motívum típusa", xV = "Személyre szabások", $V = "Design|Designok", zV = "Motívum/szöveg távolság (mm-ben)", SV = "Át szeretné nevezni ezt: {name}?", AV = "Fájl közvetlen húzása a mezőre", CV = "élénk színek, sokféleség", PV = "kifejező digitális transzfer", MV = "optimális nagy nyomatokhoz", TV = "rugalmas méretekben és színekben", IV = "kiválasztott textíliákhoz és minden alapdarabhoz", EV = "Mosógépben mosható 40˚C-ig", OV = "Az elem az elhelyezési területen kívül van.", RV = "elegáns, finom", LV = "nagyon kiváló minőségű és tartós hímzés", DV = "sokféle termékhez elérhető", jV = "sok motívum és fonalszín", NV = "minden textíliához, beleértve az erősen igénybevetteket is", VV = "magas hőfokon is mosható, ipari mosásban is", UV = "A variáns archiválása nem sikerült. Próbálja újra.", FV = "A variáns mentése nem sikerült. Próbálja újra.", BV = "Hiba történt a betöltés során.", qV = "Hiba történt a változások megjelenítésekor. Próbálja meg később.", HV = "A variáns betöltése közben váratlan hiba történt. Próbálja meg később, vagy hozzon létre új személyre szabást.", WV = "Hiba történt az archív variáns törlésekor. Próbálja újra.", GV = "kevesebb szín", ZV = "Betűtípus", KV = "A betűtípus nem érhető el", XV = "Betűtípus frissítése", QV = "Néhány betűtípus már nem érhető el. Kérjük, válassz másikat:", JV = "már 1 darabtól", YV = "Személyre szabás áttekintése", eU = "Magasság (cm-ben)", tU = "Feltöltési súgó", nU = "itt", sU = "Területek elrejtése", oU = "Motívum|Motívumok", aU = "Motívum-adatbázis", iU = "Válasszon motívumot folyamatosan bővülő motívum-adatbázisunkból. Ezután testre szabhatja a motívumot.", rU = "Szöveg beillesztése", lU = "dőlt", cU = "d", uU = "Alsó térköz", dU = "betöltés", pU = "Logó|Logók", mU = "Logók & designok", hU = "Megjelenés", fU = "Fájlméret: max.", _U = "Elérte a maximális sorszámot.", vU = 'Új vázlatok elérhetők a(z) "{buttonName}" alatt.', gU = "Minimális mennyiség", kU = "egyszínű", yU = "további színek", bU = "A „CI Configurator MYDESIGN” használatára a következő {termsOfServiceLink} vonatkozik.", wU = "többszínű", xU = "Saját személyre szabások", $U = "Saját fájlok", zU = "Saját logók", SU = "Új személyre szabás", AU = "Új design", CU = "Új vázlat", PU = "következő minta", MU = "Fiókjában jelenleg nincs logó ehhez: {productionMethod}. Szeretné, hogy feltöltsük a logóját? Lépjen kapcsolatba velünk: {contact}. Vagy válthat személyre szabási módot jobb felül.", TU = "Jelenleg nincsenek a(z) {productionMethod} számára elmentett logók az ügyfélfiókodban.", IU = "Fiókjában jelenleg nincs design ehhez: {productionMethod}.", EU = "A jelenlegi szűréshez nincs motívum ehhez: {productionMethod}.", OU = "Bal behúzás", RU = "Csak nagybetűk", LU = "vagy", DU = "Ellenkező esetben a jobb felső sarokban átválthatod a testreszabás típusát.", jU = "PDF letöltése", NU = "elhelyez", VU = "Motívum elhelyezése", UU = "Kérjük, javítsa a megjelölt mezőket a motívum megjelenítéséhez.", FU = "Kérem, várjon egy pillanatot.", BU = "Előnézet", qU = "Lehetséges elhelyezési területek előnézete", HU = "Ár", WU = "Termékszín megváltoztatása", GU = "Személyre szabás módja", ZU = "Ez a személyre szabás ezen a terméken nem lehetséges.", KU = "kifejező digitális transzfer", XU = "nagyon kiváló minőségű és tartós hímzés", QU = "Mennyiség", JU = "Legutóbb feltöltött", YU = "Legutóbb használt", eF = "átnevez", tF = "cserél", nF = "mentés", sF = "mentés & betöltés", oF = "Személyre szabás mentése", aF = "Elmentve", iF = "A design sikeresen elmentve ezen a néven: {name}.", rF = "Elmentett designok", lF = "Motívum keresése", cF = "Szín kiválasztása", uF = "Fájl kiválasztása", dF = "Betűtípus kiválasztása", pF = "A munkamenet lejárt", mF = "A munkamenete lejárt. Frissítse az oldalt a konfigurátor folytatásához.", hF = "{count} találat megjelenítése|{count} találat megjelenítése", fF = "Területek megjelenítése", _F = "Saját fájlok megjelenítése", vF = "Vázlatok megtekintése", gF = "Méret", kF = "Méret (cm-ben)", yF = "Vázlatok", bF = "Standard színek", wF = "Támogatott fájltípusok", xF = "Felhasználási feltételek", $F = "Textíliák", zF = "Szöveg", SF = "A kiválasztott design lecseréli az aktuális választást", AF = "Ez a művelet nem vonható vissza.", CF = "A kívánt motívum elhelyezéséhez válasszon másik személyre szabási módot: {toProductionMethod}. Ezután választhat megfelelő területet.", PF = "Munkamenet visszaállítása folyamatban.", MF = "frissítés", TF = "Termék frissítése a testreszabással együtt", IF = "További fájl feltöltése", EF = "A fájl nem felel meg a technikai követelményeknek. Töltsön fel másik fájlformátumot. További információk {here}.", OF = "Feltöltés nem lehetséges – az SVG fájl képelemeket tartalmaz. Távolítsa el a beágyazott képeket és töltse fel újra a fájlt.", RF = "Feltöltés nem lehetséges – az SVG fájl nem beágyazott betűtípusokat tartalmaz. Alakítsa a betűket görbékké, majd töltse fel újra a fájlt.", LF = "A feltöltés sikertelen – váratlan hiba történt. Próbálja újra vagy válasszon másik fájlformátumot.", DF = "Fájl feltöltése", jF = "Saját fájl feltöltése", NF = "Feltöltések", VF = "Személyre szabása innen:", UF = "Moshatóság", FF = "Szélesség (cm-ben)", BF = "A fájl feltöltése folyamatban...", qF = "Zoom", HF = {
  abort: NN,
  add_logo: VN,
  add_text: UN,
  add_text_line: FN,
  add_to_cart: BN,
  align: qN,
  all_positioning_areas_are_occupied: HN,
  apply: WN,
  apply_to_all_lines: GN,
  archive: ZN,
  archive_fetch_selected_customization: KN,
  archive_fetch_variant_with_customizations: XN,
  archive_new_entry_soon_available: QN,
  archived_variant_successfully: JN,
  are_you_sure_you_want_to_delete: YN,
  at_least_one_motiv_is_not_available: eV,
  back: tV,
  bend_text_line: nV,
  boot_error: sV,
  change_production_method_info: oV,
  change_to_x: aV,
  choose: iV,
  choose_a_positioning_area: rV,
  choose_icon: lV,
  choose_logo: cV,
  choose_production_method: uV,
  clear_filters: dV,
  color: pV,
  colors: mV,
  confirm: hV,
  confirmation: fV,
  confirmation_description: _V,
  continue: "folytatás",
  continue_with_x: vV,
  current_edited_customization_will_be_aborted: gV,
  currently_in_cart: kV,
  currently_no_uploaded_files: yV,
  custom: bV,
  customization_type: wV,
  customizations: xV,
  delete: "törlés",
  designs: $V,
  distance_motif_text: zV,
  do_you_want_to_rename: SV,
  drag_file_over_area: AV,
  dtf_look: CV,
  dtf_selling_point_1: PV,
  dtf_selling_point_2: MV,
  dtf_selling_point_3: TV,
  dtf_textiles: IV,
  dtf_washability: EV,
  element_outside_placement_area: OV,
  embroidery_look: RV,
  embroidery_selling_point_1: LV,
  embroidery_selling_point_2: DV,
  embroidery_selling_point_3: jV,
  embroidery_textiles: NV,
  embroidery_washability: VV,
  error_failed_to_archive_variant: UV,
  error_failed_to_save_variant: FV,
  error_loading: BV,
  error_pusher_rendering_failed: qV,
  error_pusher_rendering_failed_while_loading_variant: HV,
  error_while_deleting_archive_variant: WV,
  fewer_colors: GV,
  font: ZV,
  font_not_available: KV,
  font_update: XV,
  font_update_explanation: QV,
  from_one_piece: JV,
  go_to_production_method_overview: YV,
  height_abbreviation: eU,
  help_for_upload: tU,
  here: nU,
  hide_areas: sU,
  icon: oU,
  icon_database: aU,
  icon_database_description: iU,
  insert_text: rU,
  italic: lU,
  italic_short: cU,
  line_height: uU,
  loading: dU,
  logos: pU,
  logos_and_designs: mU,
  look: hU,
  max_file_size: fU,
  maximum_number_of_lines: _U,
  merchant_sketch_variant_added: vU,
  minimum_quantity: gU,
  mono_colored: kU,
  more_colors: yU,
  more_informations_about_upload: bU,
  multi_colored: wU,
  my_customizations: xU,
  my_files: $U,
  my_logos: zU,
  new: "új",
  new_customization: SU,
  new_design: AU,
  new_sketch: CU,
  next_motif: PU,
  no_customer_logos: MU,
  no_customer_logos_for_production_method: TU,
  no_designs: IU,
  no_motifs: EU,
  offset_left: OU,
  only_uppercase: RU,
  or: LU,
  otherwise_change_personalization_type_top_right: DU,
  pdf_download: jU,
  place: NU,
  place_logo: VU,
  please_correct_the_highlighted_errors: UU,
  please_hold_on_for_a_moment: FU,
  preview: BU,
  preview_of_possibile_positioning_areas: qU,
  price: HU,
  product_colors: WU,
  production_method: GU,
  production_method_not_available_for_variant: ZU,
  production_method_summary_dtf: KU,
  production_method_summary_embroidery: XU,
  quantity: QU,
  recently_uploaded: JU,
  recently_used: YU,
  rename: eF,
  replace: tF,
  save: nF,
  save_and_load: sF,
  save_variant: oF,
  saved: aF,
  saved_design_successfully: iF,
  saved_designs: rF,
  search_logo: lF,
  select_color: cF,
  select_file: uF,
  select_font: dF,
  session_expired: pF,
  session_expired_description: mF,
  show_X_results: hF,
  show_areas: fF,
  show_own_files: _F,
  show_sketches: vF,
  size: gF,
  size_in_unit: kF,
  sketches: yF,
  standard_colors: bF,
  supported_file_types: wF,
  terms_of_service: xF,
  textiles: $F,
  texts: zF,
  the_selected_design_will_replace_the_current_selection: SF,
  this_action_can_not_be_undone: AF,
  to_place_motif_change_production_method: CF,
  trying_to_reconnect_session: PF,
  update: MF,
  update_article_with_designs: TF,
  upload_another_file: IF,
  upload_error_422_content_type: EF,
  upload_error_svg_contains_image: OF,
  upload_error_svg_contains_text: RF,
  upload_error_unexpected: LF,
  upload_file: DF,
  upload_own_file: jF,
  uploads: NF,
  views_preview_headlide: VF,
  washablility: UF,
  width_abbreviation: FF,
  your_file_is_beeing_uploaded: BF,
  zoom: qF
}, WF = "annulla", GF = "Aggiungi logo", ZF = "Aggiungi testo", KF = "Aggiungi riga", XF = "aggiungi all’ordine", QF = "allinea", JF = "Nessuna area di posizionamento libera in questa vista.", YF = "applica", eB = "Applica a tutte le righe", tB = "Archivio", nB = "Carica motivo selezionato", sB = "Carica articolo con personalizzazione", oB = "Una nuova voce d’archivio sarà presto disponibile.", aB = "La tua personalizzazione è stata salvata con successo.", iB = "Vuoi davvero eliminare { deleteName }?", rB = "Almeno una grafica non è più disponibile!", lB = "indietro", cB = "Curva il testo", uB = { authentication: "Autenticazione fallita.", headline: "Si è verificato un errore all’avvio del configuratore.", unexpected: "Errore inatteso", variant_not_found: "La variante richiesta non è stata trovata." }, dB = "Sei attualmente nell’area di posizionamento per {fromProductionMethod}.", pB = "passa a {x}", mB = "scegli", hB = "Seleziona un’area di posizionamento.", fB = "Scegli un altro motivo", _B = "Scegli un altro logo", vB = "Scegli il tipo di personalizzazione", gB = "cancella tutti i filtri", kB = "Colore", yB = "Colori", bB = "conferma", wB = "Conferma", xB = "Caricando la personalizzazione desiderata, confermi di essere autorizzato a far applicare la personalizzazione sui tessuti, in particolare che la personalizzazione non viola diritti su nomi e marchi, diritti di design, diritti d’autore o altri diritti di terzi nonché leggi generali (in particolare penali). Se dovessimo essere chiamati in causa a causa della configurazione da te effettuata per violazione di diritti di terzi o di leggi generali, sarai obbligato a risarcirci da tutte le richieste e i danni connessi.", $B = "continua con {x}", zB = "Attenzione: i design non salvati andranno persi aprendo i bozzetti.", SB = "Attualmente nel carrello", AB = "Nessun file caricato finora", CB = "Personalizzato", PB = "Tipo di motivo", MB = "Personalizzazioni", TB = "Design|Design", IB = "Distanza motivo/testo (in mm)", EB = "Vuoi rinominare {name}?", OB = "Trascina il file direttamente nel campo", RB = "colori vivaci, versatilità", LB = "transfer digitale espressivo", DB = "ottimale per stampe di grandi dimensioni", jB = "flessibile per dimensioni e colori", NB = "per tessuti selezionati e tutti i basici", VB = "Lavaggio in lavatrice fino a 40˚C", UB = "L’elemento è fuori dall’area di posizionamento.", FB = "raffinato, delicato", BB = "ricamo di altissima qualità e durata", qB = "possibile per molti articoli", HB = "molti motivi e colori di filato", WB = "tutti i tessuti, anche prodotti molto usati", GB = "lavabile ad alte temperature, anche industrialmente", ZB = "Archiviazione della variante non riuscita. Riprova.", KB = "Salvataggio della variante non riuscito. Riprova.", XB = "Si è verificato un errore durante il caricamento.", QB = "Errore nella visualizzazione delle modifiche. Riprova più tardi.", JB = "Errore imprevisto durante il caricamento della variante. Riprova più tardi o crea una nuova personalizzazione.", YB = "Errore nell’eliminazione della variante archiviata. Riprova.", eq = "meno colori", tq = "Carattere", nq = "Font non disponibile", sq = "Aggiornamento font", oq = "Alcuni font non sono più disponibili. Selezionane un altro:", aq = "da 1 pezzo", iq = "Vai alla panoramica personalizzazione", rq = "Altezza (in cm)", lq = "Aiuto per il caricamento file", cq = "qui", uq = "Nascondi aree", dq = "Motivo|Motivi", pq = "Database motivi", mq = "Scegli un motivo dal nostro database in continua crescita. Poi puoi personalizzare il tuo motivo.", hq = "Inserisci testo", fq = "corsivo", _q = "c", vq = "Spaziatura inferiore", gq = "caricamento", kq = "Logo|Loghi", yq = "Loghi & design", bq = "Aspetto", wq = "Dimensione file: max.", xq = "Raggiunto il numero massimo di righe.", $q = 'Nuovi bozzetti disponibili in "{buttonName}".', zq = "Quantità minima", Sq = "monocolore", Aq = "altri colori", Cq = "Si applicano le seguenti {termsOfServiceLink} per l’uso di „CI Configurator MYDESIGN“.", Pq = "multicolore", Mq = "Le mie personalizzazioni", Tq = "I miei file", Iq = "I miei loghi", Eq = "Nuova personalizzazione", Oq = "Nuovo design", Rq = "Nuovo bozzetto", Lq = "grafica successiva", Dq = "Nessun logo per {productionMethod} ancora presente nel tuo account. Vuoi che aggiungiamo il tuo logo? Contattaci: {contact}. Oppure cambia tipo di personalizzazione in alto a destra.", jq = "Nel Suo account cliente al momento non sono presenti loghi per {productionMethod}.", Nq = "Nessun design per {productionMethod} ancora presente nel tuo account.", Vq = "Nessun motivo per {productionMethod} corrispondente ai filtri attuali.", Uq = "Rientro a sinistra", Fq = "Solo lettere maiuscole", Bq = "oppure", qq = "In caso contrario, può cambiare il tipo di personalizzazione in alto a destra.", Hq = "Download PDF", Wq = "posiziona", Gq = "Posiziona motivo", Zq = "Corregga i campi contrassegnati per visualizzare il suo motivo.", Kq = "Attendere un attimo.", Xq = "Anteprima", Qq = "Anteprima delle aree di posizionamento possibili", Jq = "Prezzo", Yq = "Cambia colore articolo", eH = "Tipo di personalizzazione", tH = "Tipo di personalizzazione non possibile su questo prodotto.", nH = "transfer digitale espressivo", sH = "ricamo di altissima qualità e durata", oH = "Quantità", aH = "Caricato di recente", iH = "Usato di recente", rH = "rinomina", lH = "sostituisci", cH = "salva", uH = "salva & carica", dH = "Salva personalizzazione", pH = "Salvato", mH = "Il tuo design è stato salvato con il nome {name}.", hH = "Design salvati", fH = "Cerca motivo", _H = "Seleziona colore", vH = "Seleziona file", gH = "seleziona font", kH = "Sessione scaduta", yH = "La tua sessione è scaduta. Ricarica la pagina per continuare a utilizzare il configuratore.", bH = "Mostra {count} risultato|Mostra {count} risultati", wH = "Mostra aree", xH = "Mostra i miei file", $H = "Visualizza bozzetti", zH = "Dimensione", SH = "Dimensione (in cm)", AH = "Bozzetti", CH = "Colori standard", PH = "Formati di file supportati", MH = "Condizioni d’uso", TH = "Tessili", IH = "Testo", EH = "Il design selezionato sostituirà la selezione attuale", OH = "Questa azione non può essere annullata.", RH = "Per posizionare il motivo desiderato, cambia il tipo di personalizzazione in {toProductionMethod}. Poi potrai selezionare un’area adatta.", LH = "Tentativo di ripristino sessione.", DH = "aggiorna", jH = "aggiorna il prodotto, personalizzazione inclusa", NH = "Carica un altro file", VH = "Il file non soddisfa i requisiti tecnici. Carica un altro formato. Maggiori informazioni {here}.", UH = "Caricamento non possibile – il file SVG contiene elementi immagine. Rimuovi le immagini incorporate e carica di nuovo.", FH = "Caricamento non possibile – il file SVG contiene font non incorporati. Converti i font in tracciati e carica di nuovo.", BH = "Caricamento non riuscito – si è verificato un errore imprevisto. Riprova o usa un altro formato.", qH = "Carica file", HH = "Carica file proprio", WH = "Caricamenti", GH = "La tua personalizzazione di", ZH = "Lavabilità", KH = "Larghezza (in cm)", XH = "Il file è in fase di caricamento...", QH = "Zoom", JH = {
  abort: WF,
  add_logo: GF,
  add_text: ZF,
  add_text_line: KF,
  add_to_cart: XF,
  align: QF,
  all_positioning_areas_are_occupied: JF,
  apply: YF,
  apply_to_all_lines: eB,
  archive: tB,
  archive_fetch_selected_customization: nB,
  archive_fetch_variant_with_customizations: sB,
  archive_new_entry_soon_available: oB,
  archived_variant_successfully: aB,
  are_you_sure_you_want_to_delete: iB,
  at_least_one_motiv_is_not_available: rB,
  back: lB,
  bend_text_line: cB,
  boot_error: uB,
  change_production_method_info: dB,
  change_to_x: pB,
  choose: mB,
  choose_a_positioning_area: hB,
  choose_icon: fB,
  choose_logo: _B,
  choose_production_method: vB,
  clear_filters: gB,
  color: kB,
  colors: yB,
  confirm: bB,
  confirmation: wB,
  confirmation_description: xB,
  continue: "continua",
  continue_with_x: $B,
  current_edited_customization_will_be_aborted: zB,
  currently_in_cart: SB,
  currently_no_uploaded_files: AB,
  custom: CB,
  customization_type: PB,
  customizations: MB,
  delete: "elimina",
  designs: TB,
  distance_motif_text: IB,
  do_you_want_to_rename: EB,
  drag_file_over_area: OB,
  dtf_look: RB,
  dtf_selling_point_1: LB,
  dtf_selling_point_2: DB,
  dtf_selling_point_3: jB,
  dtf_textiles: NB,
  dtf_washability: VB,
  element_outside_placement_area: UB,
  embroidery_look: FB,
  embroidery_selling_point_1: BB,
  embroidery_selling_point_2: qB,
  embroidery_selling_point_3: HB,
  embroidery_textiles: WB,
  embroidery_washability: GB,
  error_failed_to_archive_variant: ZB,
  error_failed_to_save_variant: KB,
  error_loading: XB,
  error_pusher_rendering_failed: QB,
  error_pusher_rendering_failed_while_loading_variant: JB,
  error_while_deleting_archive_variant: YB,
  fewer_colors: eq,
  font: tq,
  font_not_available: nq,
  font_update: sq,
  font_update_explanation: oq,
  from_one_piece: aq,
  go_to_production_method_overview: iq,
  height_abbreviation: rq,
  help_for_upload: lq,
  here: cq,
  hide_areas: uq,
  icon: dq,
  icon_database: pq,
  icon_database_description: mq,
  insert_text: hq,
  italic: fq,
  italic_short: _q,
  line_height: vq,
  loading: gq,
  logos: kq,
  logos_and_designs: yq,
  look: bq,
  max_file_size: wq,
  maximum_number_of_lines: xq,
  merchant_sketch_variant_added: $q,
  minimum_quantity: zq,
  mono_colored: Sq,
  more_colors: Aq,
  more_informations_about_upload: Cq,
  multi_colored: Pq,
  my_customizations: Mq,
  my_files: Tq,
  my_logos: Iq,
  new: "nuovo",
  new_customization: Eq,
  new_design: Oq,
  new_sketch: Rq,
  next_motif: Lq,
  no_customer_logos: Dq,
  no_customer_logos_for_production_method: jq,
  no_designs: Nq,
  no_motifs: Vq,
  offset_left: Uq,
  only_uppercase: Fq,
  or: Bq,
  otherwise_change_personalization_type_top_right: qq,
  pdf_download: Hq,
  place: Wq,
  place_logo: Gq,
  please_correct_the_highlighted_errors: Zq,
  please_hold_on_for_a_moment: Kq,
  preview: Xq,
  preview_of_possibile_positioning_areas: Qq,
  price: Jq,
  product_colors: Yq,
  production_method: eH,
  production_method_not_available_for_variant: tH,
  production_method_summary_dtf: nH,
  production_method_summary_embroidery: sH,
  quantity: oH,
  recently_uploaded: aH,
  recently_used: iH,
  rename: rH,
  replace: lH,
  save: cH,
  save_and_load: uH,
  save_variant: dH,
  saved: pH,
  saved_design_successfully: mH,
  saved_designs: hH,
  search_logo: fH,
  select_color: _H,
  select_file: vH,
  select_font: gH,
  session_expired: kH,
  session_expired_description: yH,
  show_X_results: bH,
  show_areas: wH,
  show_own_files: xH,
  show_sketches: $H,
  size: zH,
  size_in_unit: SH,
  sketches: AH,
  standard_colors: CH,
  supported_file_types: PH,
  terms_of_service: MH,
  textiles: TH,
  texts: IH,
  the_selected_design_will_replace_the_current_selection: EH,
  this_action_can_not_be_undone: OH,
  to_place_motif_change_production_method: RH,
  trying_to_reconnect_session: LH,
  update: DH,
  update_article_with_designs: jH,
  upload_another_file: NH,
  upload_error_422_content_type: VH,
  upload_error_svg_contains_image: UH,
  upload_error_svg_contains_text: FH,
  upload_error_unexpected: BH,
  upload_file: qH,
  upload_own_file: HH,
  uploads: WH,
  views_preview_headlide: GH,
  washablility: ZH,
  width_abbreviation: KH,
  your_file_is_beeing_uploaded: XH,
  zoom: QH
}, YH = "annuleren", eW = "Logo toevoegen", tW = "Tekst toevoegen", nW = "Regel toevoegen", sW = "aan winkelwagen toevoegen", oW = "uitlijnen", aW = "Geen vrije plaatsingsgebieden op deze weergave.", iW = "toepassen", rW = "Op alle regels toepassen", lW = "Archief", cW = "Geselecteerde aanpassing laden", uW = "Artikel inclusief personalisatie laden", dW = "Een nieuw archief-item is binnenkort beschikbaar.", pW = "Uw personalisatie is succesvol opgeslagen.", mW = "Weet u zeker dat u {deleteName} wilt verwijderen?", hW = "Minstens één ontwerp is niet meer beschikbaar!", fW = "terug", _W = "Tekst buigen", vW = { authentication: "De authenticatie is mislukt.", headline: "Er is een fout opgetreden bij het starten van de configurator.", unexpected: "Onverwachte fout", variant_not_found: "De gewenste variant is niet gevonden." }, gW = "U bevindt zich momenteel op een plaatsingsgebied voor {fromProductionMethod}.", kW = "overschakelen naar {x}", yW = "kiezen", bW = "Selecteer een plaatsingsgebied.", wW = "Ander motief selecteren", xW = "Ander logo selecteren", $W = "Personalisatieoptie kiezen", zW = "alle filters wissen", SW = "Kleur", AW = "Kleuren", CW = "bevestigen", PW = "Bevestiging", MW = "Door de gewenste personalisatie te uploaden bevestigt u dat u gemachtigd bent om de personalisatie op textiel te laten aanbrengen, in het bijzonder dat de personalisatie geen inbreuk maakt op naam- en merkrechten, ontwerprechten, auteursrechten of andere rechten van derden, evenals op algemene (vooral strafrechtelijke) wetten. Mocht ons aansprakelijk worden gesteld vanwege de door u aangebrachte configuratie wegens schending van rechten van derden of algemene wetten, dan bent u verplicht ons te vrijwaren van alle aanspraken en schade in dit verband.", TW = "doorgaan met {x}", IW = "Opmerking: Niet-opgeslagen ontwerpen gaan verloren bij het openen van de ontwerpen.", EW = "Momenteel in winkelwagen", OW = "Er zijn nog geen bestanden geüpload", RW = "Aangepast", LW = "Motieftype", DW = "Personalisaties", jW = "Ontwerp|Ontwerpen", NW = "Afstand Motief/Tekst (in mm)", VW = "Wilt u {name} hernoemen?", UW = "Sleep bestand direct in het veld", FW = "kleurkrachtig, divers", BW = "expressieve digitale transfer", qW = "optimaal voor grote prints", HW = "flexibel in maten & kleuren", WW = "voor geselecteerde textiel & alle basics", GW = "Machinewas tot 40˚C", ZW = "Element bevindt zich buiten het plaatsingsgebied.", KW = "elegant, filigraan", XW = "zeer hoogwaardige & duurzame borduring", QW = "mogelijk voor een groot aantal artikelen", JW = "veel motieven & verschillende kleuren garen", YW = "alle textiel, ook sterk belaste artikelen", eG = "heet wasbaar, ook industrieel wassen", tG = "Het archiveren van de variant is mislukt. Probeer het opnieuw.", nG = "Het opslaan van de variant is mislukt. Probeer het opnieuw.", sG = "Er is een fout opgetreden bij het laden.", oG = "Er is een fout opgetreden bij het weergeven van de wijzigingen. Probeer het later opnieuw.", aG = "Bij het laden van de variant is een onverwachte fout opgetreden. Probeer het later opnieuw of maak een nieuwe personalisatie.", iG = "Er is een fout opgetreden bij het verwijderen van de archiefvariant. Probeer het opnieuw.", rG = "minder kleuren", lG = "Lettertype", cG = "Lettertype niet beschikbaar", uG = "Lettertype-update", dG = "Sommige lettertypen zijn niet meer beschikbaar. Kies alstublieft een ander:", pG = "vanaf 1 stuk", mG = "Naar personalisatieoverzicht", hG = "Hoogte (in cm)", fG = "Hulp bij uploaden", _G = "hier", vG = "gebieden verbergen", gG = "Motief|Motieven", kG = "Motiefdatabase", yG = "Kies een motief uit onze steeds groeiende motiefdatabase. Vervolgens kunt u uw motief personaliseren.", bG = "Tekst invoegen", wG = "cursief", xG = "c", $G = "Afstand onder", zG = "laden", SG = "Logo|Logo's", AG = "Logo's & Ontwerpen", CG = "Uiterlijk", PG = "Bestandsgrootte: max.", MG = "Het maximale aantal regels is bereikt.", TG = 'Onder "{buttonName}" zijn nieuwe ontwerpen voor u beschikbaar gesteld.', IG = "Minimale hoeveelheid", EG = "eenvoudig", OG = "meer kleuren", RG = 'De volgende {termsOfServiceLink} zijn van toepassing op het gebruik van de "CI Configurator MYDESIGN."', LG = "veelkleurig", DG = "Mijn personalisaties", jG = "Mijn bestanden", NG = "Mijn logo's", VG = "Nieuwe personalisatie", UG = "Nieuw ontwerp", FG = "Nieuw ontwerp", BG = "volgend ontwerp", qG = "Er zijn momenteel geen logo's in uw klantenaccount voor {productionMethod} opgeslagen. Wilt u uw logo door ons laten opslaan? Neem dan contact met ons op via: {contact}. U kunt anders de personaliseringsoptie bovenaan rechts wijzigen.", HG = "Er zijn momenteel geen logo’s voor {productionMethod} opgeslagen in uw klantaccount.", WG = "Er zijn momenteel geen ontwerpen in uw klantenaccount voor {productionMethod} opgeslagen.", GG = "Voor uw huidige filter zijn momenteel geen {productionMethod}-motieven opgeslagen.", ZG = "Inspringen links", KG = "Alleen hoofdletters", XG = "of", QG = "U kunt anders rechtsboven het personalisatietype wijzigen.", JG = "PDF-download", YG = "plaatsen", eZ = "Motief plaatsen", tZ = "Corrigeer alstublieft de gemarkeerde velden om uw motief weer te geven.", nZ = "Een ogenblik geduld alstublieft.", sZ = "Voorbeeld", oZ = "Voorbeeld van mogelijke plaatsingsgebieden", aZ = "Prijs", iZ = "Artikelkleur wijzigen", rZ = "Productiemethode", lZ = "Productiemethode op dit artikel helaas niet mogelijk.", cZ = "expressieve digitale transfer", uZ = "zeer hoogwaardige & duurzame borduur", dZ = "Hoeveelheid", pZ = "Recent geüpload", mZ = "Recent gebruikt", hZ = "hernoemen", fZ = "vervangen", _Z = "opslaan", vZ = "opslaan & laden", gZ = "Personalisatie opslaan", kZ = "Opgeslagen", yZ = "Uw ontwerp is succesvol opgeslagen onder de naam {name}.", bZ = "Opgeslagen ontwerpen", wZ = "Motief zoeken", xZ = "Kleur selecteren", $Z = "Bestand selecteren", zZ = "Lettertype kiezen", SZ = "Sessie verlopen", AZ = "Uw sessie is verlopen. Herlaad de pagina om de configurator verder te kunnen gebruiken.", CZ = "{count} resultaat tonen|{count} resultaten tonen", PZ = "gebieden tonen", MZ = "Mijn bestanden weergeven", TZ = "Ontwerpen nu bekijken", IZ = "Grootte", EZ = "Grootte (in cm)", OZ = "Ontwerpen", RZ = "Standaardkleuren", LZ = "Ondersteunde bestandsformaten", DZ = "gebruiksvoorwaarden", jZ = "Textiel", NZ = "Tekst", VZ = "Het geselecteerde ontwerp vervangt uw huidige selectie", UZ = "Deze actie kan niet ongedaan worden gemaakt.", FZ = "Om het gewenste motief te plaatsen, moet u de personalisatieoptie wijzigen naar {toProductionMethod}. Daarna kunt u een geschikt plaatsingsgebied kiezen.", BZ = "Proberen de sessie te herstellen.", qZ = "bijwerken", HZ = "Artikel inclusief personalisatie bijwerken", WZ = "Nog een bestand uploaden", GZ = "Helaas voldoet uw bestand niet aan de technische vereisten. Upload alstublieft een ander bestandsformaat. Meer informatie vindt u {here}.", ZZ = "Upload mislukt – Uw SVG-bestand bevat afbeeldingselementen. Verwijder de ingesloten afbeeldingen en upload het bestand opnieuw.", KZ = "Upload mislukt – Uw SVG-bestand bevat niet-omgezette lettertypes. Zet alle tekst om naar contouren en upload het bestand opnieuw.", XZ = "Upload mislukt – Er is een onverwachte fout opgetreden. Probeer het opnieuw of gebruik een ander bestandsformaat.", QZ = "Bestand uploaden", JZ = "Eigen bestand uploaden", YZ = "Uploads", eK = "Uw personalisatie van", tK = "Wasbaarheid", nK = "Breedte (in cm)", sK = "Uw bestand wordt momenteel geüpload...", oK = "Zoom", aK = {
  abort: YH,
  add_logo: eW,
  add_text: tW,
  add_text_line: nW,
  add_to_cart: sW,
  align: oW,
  all_positioning_areas_are_occupied: aW,
  apply: iW,
  apply_to_all_lines: rW,
  archive: lW,
  archive_fetch_selected_customization: cW,
  archive_fetch_variant_with_customizations: uW,
  archive_new_entry_soon_available: dW,
  archived_variant_successfully: pW,
  are_you_sure_you_want_to_delete: mW,
  at_least_one_motiv_is_not_available: hW,
  back: fW,
  bend_text_line: _W,
  boot_error: vW,
  change_production_method_info: gW,
  change_to_x: kW,
  choose: yW,
  choose_a_positioning_area: bW,
  choose_icon: wW,
  choose_logo: xW,
  choose_production_method: $W,
  clear_filters: zW,
  color: SW,
  colors: AW,
  confirm: CW,
  confirmation: PW,
  confirmation_description: MW,
  continue: "doorgaan",
  continue_with_x: TW,
  current_edited_customization_will_be_aborted: IW,
  currently_in_cart: EW,
  currently_no_uploaded_files: OW,
  custom: RW,
  customization_type: LW,
  customizations: DW,
  delete: "verwijderen",
  designs: jW,
  distance_motif_text: NW,
  do_you_want_to_rename: VW,
  drag_file_over_area: UW,
  dtf_look: FW,
  dtf_selling_point_1: BW,
  dtf_selling_point_2: qW,
  dtf_selling_point_3: HW,
  dtf_textiles: WW,
  dtf_washability: GW,
  element_outside_placement_area: ZW,
  embroidery_look: KW,
  embroidery_selling_point_1: XW,
  embroidery_selling_point_2: QW,
  embroidery_selling_point_3: JW,
  embroidery_textiles: YW,
  embroidery_washability: eG,
  error_failed_to_archive_variant: tG,
  error_failed_to_save_variant: nG,
  error_loading: sG,
  error_pusher_rendering_failed: oG,
  error_pusher_rendering_failed_while_loading_variant: aG,
  error_while_deleting_archive_variant: iG,
  fewer_colors: rG,
  font: lG,
  font_not_available: cG,
  font_update: uG,
  font_update_explanation: dG,
  from_one_piece: pG,
  go_to_production_method_overview: mG,
  height_abbreviation: hG,
  help_for_upload: fG,
  here: _G,
  hide_areas: vG,
  icon: gG,
  icon_database: kG,
  icon_database_description: yG,
  insert_text: bG,
  italic: wG,
  italic_short: xG,
  line_height: $G,
  loading: zG,
  logos: SG,
  logos_and_designs: AG,
  look: CG,
  max_file_size: PG,
  maximum_number_of_lines: MG,
  merchant_sketch_variant_added: TG,
  minimum_quantity: IG,
  mono_colored: EG,
  more_colors: OG,
  more_informations_about_upload: RG,
  multi_colored: LG,
  my_customizations: DG,
  my_files: jG,
  my_logos: NG,
  new: "nieuw",
  new_customization: VG,
  new_design: UG,
  new_sketch: FG,
  next_motif: BG,
  no_customer_logos: qG,
  no_customer_logos_for_production_method: HG,
  no_designs: WG,
  no_motifs: GG,
  offset_left: ZG,
  only_uppercase: KG,
  or: XG,
  otherwise_change_personalization_type_top_right: QG,
  pdf_download: JG,
  place: YG,
  place_logo: eZ,
  please_correct_the_highlighted_errors: tZ,
  please_hold_on_for_a_moment: nZ,
  preview: sZ,
  preview_of_possibile_positioning_areas: oZ,
  price: aZ,
  product_colors: iZ,
  production_method: rZ,
  production_method_not_available_for_variant: lZ,
  production_method_summary_dtf: cZ,
  production_method_summary_embroidery: uZ,
  quantity: dZ,
  recently_uploaded: pZ,
  recently_used: mZ,
  rename: hZ,
  replace: fZ,
  save: _Z,
  save_and_load: vZ,
  save_variant: gZ,
  saved: kZ,
  saved_design_successfully: yZ,
  saved_designs: bZ,
  search_logo: wZ,
  select_color: xZ,
  select_file: $Z,
  select_font: zZ,
  session_expired: SZ,
  session_expired_description: AZ,
  show_X_results: CZ,
  show_areas: PZ,
  show_own_files: MZ,
  show_sketches: TZ,
  size: IZ,
  size_in_unit: EZ,
  sketches: OZ,
  standard_colors: RZ,
  supported_file_types: LZ,
  terms_of_service: DZ,
  textiles: jZ,
  texts: NZ,
  the_selected_design_will_replace_the_current_selection: VZ,
  this_action_can_not_be_undone: UZ,
  to_place_motif_change_production_method: FZ,
  trying_to_reconnect_session: BZ,
  update: qZ,
  update_article_with_designs: HZ,
  upload_another_file: WZ,
  upload_error_422_content_type: GZ,
  upload_error_svg_contains_image: ZZ,
  upload_error_svg_contains_text: KZ,
  upload_error_unexpected: XZ,
  upload_file: QZ,
  upload_own_file: JZ,
  uploads: YZ,
  views_preview_headlide: eK,
  washablility: tK,
  width_abbreviation: nK,
  your_file_is_beeing_uploaded: sK,
  zoom: oK
}, iK = "anuluj", rK = "Dodaj logo", lK = "Dodaj tekst", cK = "Dodaj linię", uK = "do zamówienia", dK = "wyrównaj", pK = "Brak wolnych pól rozmieszczenia na tym widoku.", mK = "zastosuj", hK = "Zastosuj do wszystkich linii", fK = "Archiwum", _K = "Załaduj wybrany motyw", vK = "Załaduj produkt z personalizacją", gK = "Nowy wpis do archiwum będzie wkrótce dostępny.", kK = "Twoja personalizacja została pomyślnie zapisana.", yK = "Czy na pewno chcesz usunąć { deleteName }?", bK = "Co najmniej jeden motyw nie jest już dostępny!", wK = "wróć", xK = "Wygnij tekst", $K = { authentication: "Uwierzytelnianie nie powiodło się.", headline: "Wystąpił błąd podczas uruchamiania konfiguratora.", unexpected: "Nieoczekiwany błąd", variant_not_found: "Nie znaleziono wybranego wariantu." }, zK = "Aktualnie znajdujesz się na polu dla {fromProductionMethod}.", SK = "zmień na {x}", AK = "wybierz", CK = "Wybierz pole rozmieszczenia.", PK = "Wybierz inny motyw", MK = "Wybierz inne logo", TK = "Wybierz typ personalizacji", IK = "usuń wszystkie filtry", EK = "Kolor", OK = "Kolory", RK = "potwierdź", LK = "Potwierdzenie", DK = "Przesyłając wybraną personalizację, potwierdzasz, że masz prawo do umieszczenia personalizacji na tekstyliach, w szczególności, że personalizacja nie narusza praw do nazw i znaków towarowych, praw autorskich, praw do wzorów ani innych praw osób trzecich ani ogólnie obowiązującego prawa. Jeśli z powodu dokonanej przez Ciebie konfiguracji zostaniemy pociągnięci do odpowiedzialności z tytułu naruszenia praw osób trzecich lub przepisów prawa, jesteś zobowiązany do zwolnienia nas z wszelkich roszczeń i szkód z tym związanych.", jK = "kontynuuj z {x}", NK = "Uwaga: niezapisane projekty zostaną utracone podczas otwierania szkiców.", VK = "Aktualnie w koszyku", UK = "Nie przesłano jeszcze żadnych plików", FK = "Indywidualny", BK = "Typ motywu", qK = "Personalizacje", HK = "Projekt|Projekty", WK = "Odstęp motyw/tekst (w mm)", GK = "Czy chcesz zmienić nazwę {name}?", ZK = "Przeciągnij plik bezpośrednio do pola", KK = "żywe kolory, różnorodność", XK = "wyrazisty druk cyfrowy", QK = "optymalny dla dużych nadruków", JK = "elastyczność w rozmiarach i kolorach", YK = "dla wybranych tekstyliów i wszystkich podstawowych produktów", eX = "Pranie w pralce do 40˚C", tX = "Element znajduje się poza polem rozmieszczenia.", nX = "elegancki, delikatny", sX = "bardzo wysokiej jakości i trwały haft", oX = "możliwe dla wielu produktów", aX = "wiele motywów i różnych kolorów nici", iX = "wszystkie tekstylia, także intensywnie użytkowane produkty", rX = "można prać w wysokich temperaturach, także w pralniach przemysłowych", lX = "Nie udało się zarchiwizować wariantu. Spróbuj ponownie.", cX = "Nie udało się zapisać wariantu. Spróbuj ponownie.", uX = "Wystąpił błąd podczas ładowania.", dX = "Wystąpił błąd podczas renderowania zmian. Spróbuj ponownie (później).", pX = "Podczas ładowania wariantu wystąpił nieoczekiwany błąd. Spróbuj ponownie (później) lub utwórz nową personalizację.", mX = "Wystąpił błąd podczas usuwania wariantu z archiwum. Spróbuj ponownie.", hX = "mniej kolorów", fX = "Czcionka", _X = "Czcionka niedostępna", vX = "Aktualizacja czcionki", gX = "Niektóre czcionki nie są już dostępne. Proszę wybrać inną:", kX = "od 1 szt.", yX = "Przegląd personalizacji", bX = "Wysokość (w cm)", wX = "Pomoc dotycząca przesyłania plików", xX = "tutaj", $X = "Ukryj pola", zX = "Motyw|Motywy", SX = "Baza motywów", AX = "Wybierz motyw z naszej stale rosnącej bazy motywów. Następnie możesz spersonalizować swój motyw.", CX = "Wstaw tekst", PX = "kursywa", MX = "k", TX = "Odstęp na dole", IX = "ładowanie", EX = "Logo|Logotypy", OX = "Logotypy i projekty", RX = "Wygląd", LX = "Maks. rozmiar pliku:", DX = "Osiągnięto maksymalną liczbę linii.", jX = 'Nowe szkice są dostępne pod "{buttonName}".', NX = "Minimalna ilość", VX = "jednokolorowe", UX = "więcej kolorów", FX = "Do korzystania z „CI Configurator MYDESIGN” obowiązują następujące {termsOfServiceLink}.", BX = "wielokolorowe", qX = "Moje personalizacje", HX = "Moje pliki", WX = "Moje logotypy", GX = "Nowa personalizacja", ZX = "Nowy projekt", KX = "Nowy szkic", XX = "następny motyw", QX = "W Twoim koncie klienta nie zapisano jeszcze żadnych logotypów dla {productionMethod}. Chcesz, abyśmy zapisali Twoje logo? Skontaktuj się z nami: {contact}. Możesz również zmienić typ personalizacji w prawym górnym rogu.", JX = "Na Twoim koncie klienta nie ma obecnie zapisanych żadnych logo dla {productionMethod}.", YX = "W Twoim koncie klienta nie zapisano jeszcze żadnych projektów dla {productionMethod}.", eQ = "Dla Twojego aktualnego filtrowania nie zapisano jeszcze żadnych motywów dla {productionMethod}.", tQ = "Wcięcie z lewej", nQ = "Tylko wielkie litery", sQ = "lub", oQ = "W przeciwnym razie możesz zmienić rodzaj personalizacji w prawym górnym rogu.", aQ = "Pobierz PDF", iQ = "umieść", rQ = "Umieść motyw", lQ = "Proszę poprawić oznaczone pola, aby wyświetlić swój motyw.", cQ = "Proszę czekać.", uQ = "Podgląd", dQ = "Podgląd możliwych pól rozmieszczenia", pQ = "Cena", mQ = "Zmień kolor produktu", hQ = "Typ personalizacji", fQ = "Ten typ personalizacji nie jest możliwy dla tego produktu.", _Q = "wyrazisty druk cyfrowy", vQ = "bardzo wysokiej jakości i trwały haft", gQ = "Ilość", kQ = "Ostatnio przesłane", yQ = "Ostatnio używane", bQ = "zmień nazwę", wQ = "zamień", xQ = "zapisz", $Q = "zapisz & wczytaj", zQ = "Zapisz personalizację", SQ = "Zapisano", AQ = "Twój projekt został pomyślnie zapisany pod nazwą {name}.", CQ = "Zapisane projekty", PQ = "Szukaj motywu", MQ = "Wybierz kolor", TQ = "Wybierz plik", IQ = "Wybierz czcionkę", EQ = "Sesja wygasła", OQ = "Twoja sesja wygasła. Odśwież stronę, aby kontynuować korzystanie z konfiguratora.", RQ = "Pokaż {count} wynik|Pokaż {count} wyniki", LQ = "Pokaż pola", DQ = "Pokaż moje pliki", jQ = "Zobacz szkice", NQ = "Rozmiar", VQ = "Rozmiar (w cm)", UQ = "Szkice", FQ = "Kolory standardowe", BQ = "Obsługiwane formaty plików", qQ = "Warunki korzystania", HQ = "Tekstylia", WQ = "Tekst", GQ = "Wybrany projekt zastąpi Twój aktualny wybór", ZQ = "Tej akcji nie można cofnąć.", KQ = "Aby umieścić wybrany motyw, zmień typ personalizacji na {toProductionMethod}. Następnie możesz wybrać odpowiednie pole.", XQ = "Próba przywrócenia sesji.", QQ = "aktualizuj", JQ = "Zaktualizuj artykuł wraz z personalizacją", YQ = "Prześlij kolejny plik", eJ = "Twój plik nie spełnia wymogów technicznych. Prześlij inny format pliku. Więcej informacji znajdziesz {here}.", tJ = "Nie można przesłać – Twój plik SVG zawiera elementy graficzne. Usuń osadzone obrazy i prześlij plik ponownie.", nJ = "Nie można przesłać – Twój plik SVG zawiera nieosadzone czcionki. Zamień czcionki na krzywe i prześlij plik ponownie.", sJ = "Przesyłanie nie powiodło się – wystąpił nieoczekiwany błąd. Spróbuj ponownie lub użyj innego formatu pliku.", oJ = "Prześlij plik", aJ = "Prześlij własny plik", iJ = "Przesłane pliki", rJ = "Twoja personalizacja od", lJ = "Możliwość prania", cJ = "Szerokość (w cm)", uJ = "Twój plik jest właśnie przesyłany...", dJ = "Zoom", pJ = {
  abort: iK,
  add_logo: rK,
  add_text: lK,
  add_text_line: cK,
  add_to_cart: uK,
  align: dK,
  all_positioning_areas_are_occupied: pK,
  apply: mK,
  apply_to_all_lines: hK,
  archive: fK,
  archive_fetch_selected_customization: _K,
  archive_fetch_variant_with_customizations: vK,
  archive_new_entry_soon_available: gK,
  archived_variant_successfully: kK,
  are_you_sure_you_want_to_delete: yK,
  at_least_one_motiv_is_not_available: bK,
  back: wK,
  bend_text_line: xK,
  boot_error: $K,
  change_production_method_info: zK,
  change_to_x: SK,
  choose: AK,
  choose_a_positioning_area: CK,
  choose_icon: PK,
  choose_logo: MK,
  choose_production_method: TK,
  clear_filters: IK,
  color: EK,
  colors: OK,
  confirm: RK,
  confirmation: LK,
  confirmation_description: DK,
  continue: "kontynuuj",
  continue_with_x: jK,
  current_edited_customization_will_be_aborted: NK,
  currently_in_cart: VK,
  currently_no_uploaded_files: UK,
  custom: FK,
  customization_type: BK,
  customizations: qK,
  delete: "usuń",
  designs: HK,
  distance_motif_text: WK,
  do_you_want_to_rename: GK,
  drag_file_over_area: ZK,
  dtf_look: KK,
  dtf_selling_point_1: XK,
  dtf_selling_point_2: QK,
  dtf_selling_point_3: JK,
  dtf_textiles: YK,
  dtf_washability: eX,
  element_outside_placement_area: tX,
  embroidery_look: nX,
  embroidery_selling_point_1: sX,
  embroidery_selling_point_2: oX,
  embroidery_selling_point_3: aX,
  embroidery_textiles: iX,
  embroidery_washability: rX,
  error_failed_to_archive_variant: lX,
  error_failed_to_save_variant: cX,
  error_loading: uX,
  error_pusher_rendering_failed: dX,
  error_pusher_rendering_failed_while_loading_variant: pX,
  error_while_deleting_archive_variant: mX,
  fewer_colors: hX,
  font: fX,
  font_not_available: _X,
  font_update: vX,
  font_update_explanation: gX,
  from_one_piece: kX,
  go_to_production_method_overview: yX,
  height_abbreviation: bX,
  help_for_upload: wX,
  here: xX,
  hide_areas: $X,
  icon: zX,
  icon_database: SX,
  icon_database_description: AX,
  insert_text: CX,
  italic: PX,
  italic_short: MX,
  line_height: TX,
  loading: IX,
  logos: EX,
  logos_and_designs: OX,
  look: RX,
  max_file_size: LX,
  maximum_number_of_lines: DX,
  merchant_sketch_variant_added: jX,
  minimum_quantity: NX,
  mono_colored: VX,
  more_colors: UX,
  more_informations_about_upload: FX,
  multi_colored: BX,
  my_customizations: qX,
  my_files: HX,
  my_logos: WX,
  new: "nowe",
  new_customization: GX,
  new_design: ZX,
  new_sketch: KX,
  next_motif: XX,
  no_customer_logos: QX,
  no_customer_logos_for_production_method: JX,
  no_designs: YX,
  no_motifs: eQ,
  offset_left: tQ,
  only_uppercase: nQ,
  or: sQ,
  otherwise_change_personalization_type_top_right: oQ,
  pdf_download: aQ,
  place: iQ,
  place_logo: rQ,
  please_correct_the_highlighted_errors: lQ,
  please_hold_on_for_a_moment: cQ,
  preview: uQ,
  preview_of_possibile_positioning_areas: dQ,
  price: pQ,
  product_colors: mQ,
  production_method: hQ,
  production_method_not_available_for_variant: fQ,
  production_method_summary_dtf: _Q,
  production_method_summary_embroidery: vQ,
  quantity: gQ,
  recently_uploaded: kQ,
  recently_used: yQ,
  rename: bQ,
  replace: wQ,
  save: xQ,
  save_and_load: $Q,
  save_variant: zQ,
  saved: SQ,
  saved_design_successfully: AQ,
  saved_designs: CQ,
  search_logo: PQ,
  select_color: MQ,
  select_file: TQ,
  select_font: IQ,
  session_expired: EQ,
  session_expired_description: OQ,
  show_X_results: RQ,
  show_areas: LQ,
  show_own_files: DQ,
  show_sketches: jQ,
  size: NQ,
  size_in_unit: VQ,
  sketches: UQ,
  standard_colors: FQ,
  supported_file_types: BQ,
  terms_of_service: qQ,
  textiles: HQ,
  texts: WQ,
  the_selected_design_will_replace_the_current_selection: GQ,
  this_action_can_not_be_undone: ZQ,
  to_place_motif_change_production_method: KQ,
  trying_to_reconnect_session: XQ,
  update: QQ,
  update_article_with_designs: JQ,
  upload_another_file: YQ,
  upload_error_422_content_type: eJ,
  upload_error_svg_contains_image: tJ,
  upload_error_svg_contains_text: nJ,
  upload_error_unexpected: sJ,
  upload_file: oJ,
  upload_own_file: aJ,
  uploads: iJ,
  views_preview_headlide: rJ,
  washablility: lJ,
  width_abbreviation: cJ,
  your_file_is_beeing_uploaded: uJ,
  zoom: dJ
}, mJ = "zrušiť", hJ = "Pridať logo", fJ = "Pridať text", _J = "Pridať riadok", vJ = "do objednávky", gJ = "zarovnať", kJ = "Na tomto pohľade nie je voľné miesto na umiestnenie.", yJ = "použiť", bJ = "Použiť na všetky riadky", wJ = "Archív", xJ = "Načítať vybraný motív", $J = "Načítať produkt vrátane personalizácie", zJ = "Nový archívny záznam bude čoskoro k dispozícii.", SJ = "Vaša personalizácia bola úspešne uložená.", AJ = "Naozaj chcete odstrániť { deleteName }?", CJ = "Aspoň jeden motív už nie je dostupný!", PJ = "späť", MJ = "Ohniť text", TJ = { authentication: "Autentifikácia zlyhala.", headline: "Pri štarte konfigurátora došlo k chybe.", unexpected: "Neočakávaná chyba", variant_not_found: "Požadovaná varianta nebola nájdená." }, IJ = "Aktuálne sa nachádzate na ploche pre {fromProductionMethod}.", EJ = "prepnúť na {x}", OJ = "vybrať", RJ = "Prosím vyberte plochu na umiestnenie.", LJ = "Vybrať iný motív", DJ = "Vybrať iné logo", jJ = "Vybrať typ personalizácie", NJ = "zmazať všetky filtre", VJ = "Farba", UJ = "Farby", FJ = "potvrdiť", BJ = "Potvrdenie", qJ = "Nahraním požadovanej personalizácie potvrdzujete, že ste oprávnený dať personalizáciu aplikovať na textílie, najmä že personalizácia neporušuje práva tretích strán (ochranné známky, autorské práva, dizajnové práva a pod.) ani všeobecné (najmä trestnoprávne) zákony. Ak by sme boli z dôvodu vašej konfigurácie vystavení nárokom tretích strán alebo zákona, ste povinný nás od všetkých nárokov a škôd v tejto súvislosti oslobodiť.", HJ = "pokračovať s {x}", WJ = "Upozornenie: neuložené návrhy budú pri otvorení návrhov stratené.", GJ = "Aktuálne v košíku", ZJ = "Zatiaľ neboli nahrané žiadne súbory", KJ = "Individuálne", XJ = "Typ motívu", QJ = "Personalizácie", JJ = "Dizajn|Dizajny", YJ = "Vzdialenosť motív/text (v mm)", eY = "Chcete premenovať {name}?", tY = "Pretiahnite súbor priamo do poľa", nY = "živé farby, rôznorodosť", sY = "výrazná digitálna tlač", oY = "ideálne pre veľké potlače", aY = "flexibilné vo veľkostiach a farbách", iY = "pre vybrané textílie a všetky základné produkty", rY = "Pranie v práčke do 40˚C", lY = "Prvok je mimo plochy umiestnenia.", cY = "elegantné, jemné", uY = "veľmi kvalitná a trvácna výšivka", dY = "možné pre mnoho produktov", pY = "mnoho motívov a farieb nití", mY = "všetky textílie, aj silne namáhané produkty", hY = "možno prať na vysoké teploty, aj priemyselné pranie", fY = "Archivácia varianty zlyhala. Skúste to prosím znova.", _Y = "Uloženie varianty zlyhalo. Skúste to prosím znova.", vY = "Pri načítaní došlo k chybe.", gY = "Pri zobrazovaní zmien došlo k chybe. Skúste to prosím neskôr znova.", kY = "Pri načítaní varianty došlo k neočakávanej chybe. Skúste to neskôr znova alebo vytvorte novú personalizáciu.", yY = "Pri mazaní archivovanej varianty došlo k chybe. Skúste to znova.", bY = "menej farieb", wY = "Písmo", xY = "Písmo nie je k dispozícii", $Y = "Aktualizácia písma", zY = "Niektoré písma už nie sú k dispozícii. Vyberte prosím iné:", SY = "od 1 ks", AY = "Prehľad personalizácie", CY = "Výška (v cm)", PY = "Pomoc s nahrávaním súborov", MY = "tu", TY = "Skryť plochy", IY = "Motív|Motívy", EY = "Databáza motívov", OY = "Vyberte motív z našej stále rastúcej databázy motívov. Následne môžete motív individuálne upraviť.", RY = "Vložiť text", LY = "kurzíva", DY = "k", jY = "Vzdialenosť dolu", NY = "načítava sa", VY = "Logo|Logá", UY = "Logá & dizajny", FY = "Vzhľad", BY = "Max. veľkosť súboru:", qY = "Bol dosiahnutý maximálny počet riadkov.", HY = "Nové návrhy sú k dispozícii pod „{buttonName}“.", WY = "Minimálne množstvo", GY = "jednofarebné", ZY = "viac farieb", KY = "Pre používanie „CI Configurator MYDESIGN“ platia nasledujúce {termsOfServiceLink}.", XY = "viacfarebné", QY = "Moje personalizácie", JY = "Moje súbory", YY = "Moje logá", eee = "Nová personalizácia", tee = "Nový dizajn", nee = "Nový návrh", see = "ďalší motív", oee = "Vo vašom účte ešte nie sú žiadne logá pre {productionMethod}. Chcete, aby sme vaše logo pridali? Kontaktujte nás: {contact}. Alebo môžete zmeniť typ personalizácie vpravo hore.", aee = "Vo vašom zákazníckom účte momentálne nie sú uložené žiadne logá pre {productionMethod}.", iee = "Vo vašom účte ešte nie sú žiadne dizajny pre {productionMethod}.", ree = "Pre váš aktuálny filter nie sú žiadne motívy pre {productionMethod}.", lee = "Odsadenie vľavo", cee = "Len veľké písmená", uee = "alebo", dee = "Prípadne môžete zmeniť typ personalizácie vpravo hore.", pee = "Stiahnuť PDF", mee = "umiestniť", hee = "Umiestniť motív", fee = "Prosím, opravte označené polia, aby sa zobrazil váš motív.", _ee = "Prosím čakajte chvíľu.", vee = "Náhľad", gee = "Náhľad možných plôch na umiestnenie", kee = "Cena", yee = "Zmeniť farbu produktu", bee = "Typ personalizácie", wee = "Tento typ personalizácie nie je možný pre tento produkt.", xee = "výrazná digitálna tlač", $ee = "veľmi kvalitná a trvácna výšivka", zee = "Množstvo", See = "Nedávno nahrané", Aee = "Nedávno použité", Cee = "premenovať", Pee = "nahradiť", Mee = "uložiť", Tee = "uložiť & načítať", Iee = "Uložiť personalizáciu", Eee = "Uložené", Oee = "Váš dizajn bol úspešne uložený pod názvom {name}.", Ree = "Uložené dizajny", Lee = "Hľadať motív", Dee = "Vybrať farbu", jee = "Vybrať súbor", Nee = "Vybrať písmo", Vee = "Relácia vypršala", Uee = "Vaša relácia vypršala. Obnovte stránku, aby ste mohli pokračovať v používaní konfigurátora.", Fee = "Zobraziť {count} výsledok|Zobraziť {count} výsledky", Bee = "Zobraziť plochy", qee = "Zobraziť moje súbory", Hee = "Zobraziť návrhy", Wee = "Veľkosť", Gee = "Veľkosť (v cm)", Zee = "Návrhy", Kee = "Štandardné farby", Xee = "Podporované typy súborov", Qee = "Podmienky používania", Jee = "Textílie", Yee = "Text", ete = "Vybraný dizajn nahradí vašu aktuálnu voľbu", tte = "Túto akciu nemožno vrátiť späť.", nte = "Ak chcete umiestniť požadovaný motív, zmeňte typ personalizácie na {toProductionMethod}. Potom môžete vybrať vhodnú plochu.", ste = "Prebieha pokus o obnovenie relácie.", ote = "aktualizovať", ate = "Aktualizovať položku vrátane personalizácie", ite = "Nahrať ďalší súbor", rte = "Váš súbor nespĺňa technické požiadavky. Nahrajte iný formát súboru. Viac informácií nájdete {here}.", lte = "Nahrávanie nie je možné – váš SVG súbor obsahuje obrázkové prvky. Odstráňte vložené obrázky a nahrajte súbor znova.", cte = "Nahrávanie nie je možné – váš SVG súbor obsahuje nevložené písma. Preveďte písma na krivky a nahrajte súbor znova.", ute = "Nahrávanie zlyhalo – došlo k neočakávanej chybe. Skúste to znova alebo použite iný formát súboru.", dte = "Nahrať súbor", pte = "Nahrať vlastný súbor", mte = "Nahrané súbory", hte = "Vaša personalizácia od", fte = "Možnosť prania", _te = "Šírka (v cm)", vte = "Váš súbor sa práve nahráva...", gte = "Zoom", kte = {
  abort: mJ,
  add_logo: hJ,
  add_text: fJ,
  add_text_line: _J,
  add_to_cart: vJ,
  align: gJ,
  all_positioning_areas_are_occupied: kJ,
  apply: yJ,
  apply_to_all_lines: bJ,
  archive: wJ,
  archive_fetch_selected_customization: xJ,
  archive_fetch_variant_with_customizations: $J,
  archive_new_entry_soon_available: zJ,
  archived_variant_successfully: SJ,
  are_you_sure_you_want_to_delete: AJ,
  at_least_one_motiv_is_not_available: CJ,
  back: PJ,
  bend_text_line: MJ,
  boot_error: TJ,
  change_production_method_info: IJ,
  change_to_x: EJ,
  choose: OJ,
  choose_a_positioning_area: RJ,
  choose_icon: LJ,
  choose_logo: DJ,
  choose_production_method: jJ,
  clear_filters: NJ,
  color: VJ,
  colors: UJ,
  confirm: FJ,
  confirmation: BJ,
  confirmation_description: qJ,
  continue: "pokračovať",
  continue_with_x: HJ,
  current_edited_customization_will_be_aborted: WJ,
  currently_in_cart: GJ,
  currently_no_uploaded_files: ZJ,
  custom: KJ,
  customization_type: XJ,
  customizations: QJ,
  delete: "odstrániť",
  designs: JJ,
  distance_motif_text: YJ,
  do_you_want_to_rename: eY,
  drag_file_over_area: tY,
  dtf_look: nY,
  dtf_selling_point_1: sY,
  dtf_selling_point_2: oY,
  dtf_selling_point_3: aY,
  dtf_textiles: iY,
  dtf_washability: rY,
  element_outside_placement_area: lY,
  embroidery_look: cY,
  embroidery_selling_point_1: uY,
  embroidery_selling_point_2: dY,
  embroidery_selling_point_3: pY,
  embroidery_textiles: mY,
  embroidery_washability: hY,
  error_failed_to_archive_variant: fY,
  error_failed_to_save_variant: _Y,
  error_loading: vY,
  error_pusher_rendering_failed: gY,
  error_pusher_rendering_failed_while_loading_variant: kY,
  error_while_deleting_archive_variant: yY,
  fewer_colors: bY,
  font: wY,
  font_not_available: xY,
  font_update: $Y,
  font_update_explanation: zY,
  from_one_piece: SY,
  go_to_production_method_overview: AY,
  height_abbreviation: CY,
  help_for_upload: PY,
  here: MY,
  hide_areas: TY,
  icon: IY,
  icon_database: EY,
  icon_database_description: OY,
  insert_text: RY,
  italic: LY,
  italic_short: DY,
  line_height: jY,
  loading: NY,
  logos: VY,
  logos_and_designs: UY,
  look: FY,
  max_file_size: BY,
  maximum_number_of_lines: qY,
  merchant_sketch_variant_added: HY,
  minimum_quantity: WY,
  mono_colored: GY,
  more_colors: ZY,
  more_informations_about_upload: KY,
  multi_colored: XY,
  my_customizations: QY,
  my_files: JY,
  my_logos: YY,
  new: "nové",
  new_customization: eee,
  new_design: tee,
  new_sketch: nee,
  next_motif: see,
  no_customer_logos: oee,
  no_customer_logos_for_production_method: aee,
  no_designs: iee,
  no_motifs: ree,
  offset_left: lee,
  only_uppercase: cee,
  or: uee,
  otherwise_change_personalization_type_top_right: dee,
  pdf_download: pee,
  place: mee,
  place_logo: hee,
  please_correct_the_highlighted_errors: fee,
  please_hold_on_for_a_moment: _ee,
  preview: vee,
  preview_of_possibile_positioning_areas: gee,
  price: kee,
  product_colors: yee,
  production_method: bee,
  production_method_not_available_for_variant: wee,
  production_method_summary_dtf: xee,
  production_method_summary_embroidery: $ee,
  quantity: zee,
  recently_uploaded: See,
  recently_used: Aee,
  rename: Cee,
  replace: Pee,
  save: Mee,
  save_and_load: Tee,
  save_variant: Iee,
  saved: Eee,
  saved_design_successfully: Oee,
  saved_designs: Ree,
  search_logo: Lee,
  select_color: Dee,
  select_file: jee,
  select_font: Nee,
  session_expired: Vee,
  session_expired_description: Uee,
  show_X_results: Fee,
  show_areas: Bee,
  show_own_files: qee,
  show_sketches: Hee,
  size: Wee,
  size_in_unit: Gee,
  sketches: Zee,
  standard_colors: Kee,
  supported_file_types: Xee,
  terms_of_service: Qee,
  textiles: Jee,
  texts: Yee,
  the_selected_design_will_replace_the_current_selection: ete,
  this_action_can_not_be_undone: tte,
  to_place_motif_change_production_method: nte,
  trying_to_reconnect_session: ste,
  update: ote,
  update_article_with_designs: ate,
  upload_another_file: ite,
  upload_error_422_content_type: rte,
  upload_error_svg_contains_image: lte,
  upload_error_svg_contains_text: cte,
  upload_error_unexpected: ute,
  upload_file: dte,
  upload_own_file: pte,
  uploads: mte,
  views_preview_headlide: hte,
  washablility: fte,
  width_abbreviation: _te,
  your_file_is_beeing_uploaded: vte,
  zoom: gte
}, yte = "avbryt", bte = "Lägg till logotyp", wte = "Lägg till text", xte = "Lägg till rad", $te = "till beställning", zte = "justera", Ste = "Ingen ledig placeringsyta i denna vy.", Ate = "använd", Cte = "Tillämpa på alla rader", Pte = "Arkiv", Mte = "Ladda vald motiv", Tte = "Ladda artikel med anpassning", Ite = "En ny arkivpost blir snart tillgänglig.", Ete = "Din anpassning har sparats.", Ote = "Vill du verkligen radera { deleteName }?", Rte = "Minst ett motiv är inte längre tillgängligt!", Lte = "tillbaka", Dte = "Böj text", jte = { authentication: "Autentisering misslyckades.", headline: "Ett fel uppstod när konfiguratorn startades.", unexpected: "Oväntat fel", variant_not_found: "Den begärda varianten hittades inte." }, Nte = "Du befinner dig för närvarande på en placeringsyta för {fromProductionMethod}.", Vte = "växla till {x}", Ute = "välj", Fte = "Välj en placeringsyta.", Bte = "Välj annan motiv", qte = "Välj annan logotyp", Hte = "Välj anpassningstyp", Wte = "rensa alla filter", Gte = "Färg", Zte = "Färger", Kte = "bekräfta", Xte = "Bekräftelse", Qte = "Genom att ladda upp önskad anpassning bekräftar du att du har rätt att låta anpassningen appliceras på textilier, särskilt att anpassningen inte bryter mot namn- och varumärkesrättigheter, designrättigheter, upphovsrätter eller andra tredje parts rättigheter samt mot gällande lagar (särskilt straffrättsliga). Om vi skulle bli föremål för krav på grund av din konfiguration är du skyldig att hålla oss skadeslösa från alla krav och skador.", Jte = "fortsätt med {x}", Yte = "Observera: Osparade designer går förlorade när utkast öppnas.", ene = "Just nu i kundvagnen", tne = "Inga filer har laddats upp ännu", nne = "Individuell", sne = "Motivtyp", one = "Anpassningar", ane = "Design|Designer", ine = "Avstånd motiv/text (i mm)", rne = "Vill du byta namn på {name}?", lne = "Dra filen direkt till fältet", cne = "färgstark, mångsidig", une = "uttrycksfull digitaltransfer", dne = "optimal för stora tryck", pne = "flexibel i storlek och färg", mne = "för utvalda textilier och alla baskläder", hne = "Maskintvätt upp till 40˚C", fne = "Elementet är utanför placeringsytan.", _ne = "elegant, detaljrik", vne = "mycket högkvalitativ och hållbar brodyr", gne = "möjlig för många produkter", kne = "många motiv och olika garnfärger", yne = "alla textilier, även slitstarka produkter", bne = "tål hög tvätt, även industrtvätt", wne = "Arkivering av variant misslyckades. Försök igen.", xne = "Sparande av variant misslyckades. Försök igen.", $ne = "Ett fel uppstod vid laddning.", zne = "Ett fel uppstod vid visning av ändringarna. Försök igen senare.", Sne = "Ett oväntat fel uppstod vid laddning av varianten. Försök igen senare eller skapa en ny anpassning.", Ane = "Ett fel uppstod vid radering av arkiverad variant. Försök igen.", Cne = "färre färger", Pne = "Typsnitt", Mne = "Typsnitt ej tillgängligt", Tne = "Uppdatering av typsnitt", Ine = "Vissa typsnitt är inte längre tillgängliga. Välj ett annat:", Ene = "från 1 st", One = "Till översikt för anpassning", Rne = "Höjd (i cm)", Lne = "Hjälp med filuppladdning", Dne = "här", jne = "Dölj ytor", Nne = "Motiv|Motiv", Vne = "Motivdatabas", Une = "Välj ett motiv från vår ständigt växande motivdatabas. Därefter kan du anpassa ditt motiv.", Fne = "Infoga text", Bne = "kursiv", qne = "k", Hne = "Avstånd nedtill", Wne = "laddar", Gne = "Logotyp|Logotyper", Zne = "Logotyper & designer", Kne = "Utseende", Xne = "Filstorlek: max.", Qne = "Maximalt antal rader uppnått.", Jne = 'Nya utkast tillgängliga under "{buttonName}".', Yne = "Minsta antal", ese = "enfärgad", tse = "fler färger", nse = "Följande {termsOfServiceLink} gäller för användning av „CI Configurator MYDESIGN“.", sse = "flerfärgad", ose = "Mina anpassningar", ase = "Mina filer", ise = "Mina logotyper", rse = "Ny anpassning", lse = "Ny design", cse = "Nytt utkast", use = "nästa motiv", dse = "Det finns ännu inga logotyper för {productionMethod} på ditt konto. Vill du att vi lägger till din logotyp? Kontakta oss: {contact}. Du kan annars byta anpassningstyp uppe till höger.", pse = "Det finns för närvarande inga logotyper för {productionMethod} sparade i ditt kundkonto.", mse = "Det finns ännu inga designer för {productionMethod} på ditt konto.", hse = "Inga motiv för {productionMethod} med nuvarande filter.", fse = "Indrag vänster", _se = "Endast versaler", vse = "eller", gse = "Annars kan du byta typ av personalisering uppe till höger.", kse = "Ladda ner PDF", yse = "placera", bse = "Placera motiv", wse = "Vänligen vänta en stund.", xse = "Förhandsvisning", $se = "Förhandsvisning av möjliga placeringsytor", zse = "Pris", Sse = "Byt produktfärg", Ase = "Anpassningstyp", Cse = "Denna anpassningstyp är inte möjlig för denna artikel.", Pse = "uttrycksfull digitaltransfer", Mse = "mycket högkvalitativ och hållbar brodyr", Tse = "Antal", Ise = "Senast uppladdad", Ese = "Senast använd", Ose = "byt namn", Rse = "ersätt", Lse = "spara", Dse = "spara & ladda", jse = "Spara anpassning", Nse = "Sparad", Vse = "Din design har sparats under namnet {name}.", Use = "Sparade designer", Fse = "Sök motiv", Bse = "Välj färg", qse = "Välj fil", Hse = "Välj typsnitt", Wse = "Sessionen har gått ut", Gse = "Din session har gått ut. Ladda om sidan för att fortsätta använda konfiguratorn.", Zse = "Visa ytor", Kse = "Visa mina filer", Xse = "Visa utkast", Qse = "Visa {count} resultat|Visa {count} resultat", Jse = "Storlek", Yse = "Storlek (i cm)", eoe = "Utkast", toe = "Standardfärger", noe = "Stödda filformat", soe = "Användarvillkor", ooe = "Textilier", aoe = "Text", ioe = "Det valda designen ersätter ditt nuvarande val", roe = "Denna åtgärd kan inte ångras.", loe = "För att placera önskat motiv, byt anpassningstyp till {toProductionMethod}. Därefter kan du välja en passande placeringsyta.", coe = "Försöker återansluta sessionen.", uoe = "uppdatera", doe = "Uppdatera artikel inklusive personalisering", poe = "Ladda upp ytterligare en fil", moe = "Din fil uppfyller inte de tekniska kraven. Ladda upp ett annat filformat. Mer information finns {here}.", hoe = "Uppladdning inte möjlig – din SVG-fil innehåller bildelement. Ta bort inbäddade bilder och ladda upp filen igen.", foe = "Uppladdning inte möjlig – din SVG-fil innehåller ej inbäddade typsnitt. Omvandla typsnitt till banor och ladda upp filen igen.", _oe = "Uppladdning misslyckades – ett oväntat fel inträffade. Försök igen eller använd ett annat filformat.", voe = "Ladda upp fil", goe = "Ladda upp egen fil", koe = "Uppladdningar", yoe = "Din anpassning av", boe = "Tvättbarhet", woe = "Bredd (i cm)", xoe = "Din fil laddas upp...", $oe = "Zoom", zoe = "Korrigera de markerade fälten för att visa ditt motiv.", Soe = {
  abort: yte,
  add_logo: bte,
  add_text: wte,
  add_text_line: xte,
  add_to_cart: $te,
  align: zte,
  all_positioning_areas_are_occupied: Ste,
  apply: Ate,
  apply_to_all_lines: Cte,
  archive: Pte,
  archive_fetch_selected_customization: Mte,
  archive_fetch_variant_with_customizations: Tte,
  archive_new_entry_soon_available: Ite,
  archived_variant_successfully: Ete,
  are_you_sure_you_want_to_delete: Ote,
  at_least_one_motiv_is_not_available: Rte,
  back: Lte,
  bend_text_line: Dte,
  boot_error: jte,
  change_production_method_info: Nte,
  change_to_x: Vte,
  choose: Ute,
  choose_a_positioning_area: Fte,
  choose_icon: Bte,
  choose_logo: qte,
  choose_production_method: Hte,
  clear_filters: Wte,
  color: Gte,
  colors: Zte,
  confirm: Kte,
  confirmation: Xte,
  confirmation_description: Qte,
  continue: "fortsätt",
  continue_with_x: Jte,
  current_edited_customization_will_be_aborted: Yte,
  currently_in_cart: ene,
  currently_no_uploaded_files: tne,
  custom: nne,
  customization_type: sne,
  customizations: one,
  delete: "radera",
  designs: ane,
  distance_motif_text: ine,
  do_you_want_to_rename: rne,
  drag_file_over_area: lne,
  dtf_look: cne,
  dtf_selling_point_1: une,
  dtf_selling_point_2: dne,
  dtf_selling_point_3: pne,
  dtf_textiles: mne,
  dtf_washability: hne,
  element_outside_placement_area: fne,
  embroidery_look: _ne,
  embroidery_selling_point_1: vne,
  embroidery_selling_point_2: gne,
  embroidery_selling_point_3: kne,
  embroidery_textiles: yne,
  embroidery_washability: bne,
  error_failed_to_archive_variant: wne,
  error_failed_to_save_variant: xne,
  error_loading: $ne,
  error_pusher_rendering_failed: zne,
  error_pusher_rendering_failed_while_loading_variant: Sne,
  error_while_deleting_archive_variant: Ane,
  fewer_colors: Cne,
  font: Pne,
  font_not_available: Mne,
  font_update: Tne,
  font_update_explanation: Ine,
  from_one_piece: Ene,
  go_to_production_method_overview: One,
  height_abbreviation: Rne,
  help_for_upload: Lne,
  here: Dne,
  hide_areas: jne,
  icon: Nne,
  icon_database: Vne,
  icon_database_description: Une,
  insert_text: Fne,
  italic: Bne,
  italic_short: qne,
  line_height: Hne,
  loading: Wne,
  logos: Gne,
  logos_and_designs: Zne,
  look: Kne,
  max_file_size: Xne,
  maximum_number_of_lines: Qne,
  merchant_sketch_variant_added: Jne,
  minimum_quantity: Yne,
  mono_colored: ese,
  more_colors: tse,
  more_informations_about_upload: nse,
  multi_colored: sse,
  my_customizations: ose,
  my_files: ase,
  my_logos: ise,
  new: "ny",
  new_customization: rse,
  new_design: lse,
  new_sketch: cse,
  next_motif: use,
  no_customer_logos: dse,
  no_customer_logos_for_production_method: pse,
  no_designs: mse,
  no_motifs: hse,
  offset_left: fse,
  only_uppercase: _se,
  or: vse,
  otherwise_change_personalization_type_top_right: gse,
  pdf_download: kse,
  place: yse,
  place_logo: bse,
  please_hold_on_for_a_moment: wse,
  preview: xse,
  preview_of_possibile_positioning_areas: $se,
  price: zse,
  product_colors: Sse,
  production_method: Ase,
  production_method_not_available_for_variant: Cse,
  production_method_summary_dtf: Pse,
  production_method_summary_embroidery: Mse,
  quantity: Tse,
  recently_uploaded: Ise,
  recently_used: Ese,
  rename: Ose,
  replace: Rse,
  save: Lse,
  save_and_load: Dse,
  save_variant: jse,
  saved: Nse,
  saved_design_successfully: Vse,
  saved_designs: Use,
  search_logo: Fse,
  select_color: Bse,
  select_file: qse,
  select_font: Hse,
  session_expired: Wse,
  session_expired_description: Gse,
  show_areas: Zse,
  show_own_files: Kse,
  show_sketches: Xse,
  show_X_results: Qse,
  size: Jse,
  size_in_unit: Yse,
  sketches: eoe,
  standard_colors: toe,
  supported_file_types: noe,
  terms_of_service: soe,
  textiles: ooe,
  texts: aoe,
  the_selected_design_will_replace_the_current_selection: ioe,
  this_action_can_not_be_undone: roe,
  to_place_motif_change_production_method: loe,
  trying_to_reconnect_session: coe,
  update: uoe,
  update_article_with_designs: doe,
  upload_another_file: poe,
  upload_error_422_content_type: moe,
  upload_error_svg_contains_image: hoe,
  upload_error_svg_contains_text: foe,
  upload_error_unexpected: _oe,
  upload_file: voe,
  upload_own_file: goe,
  uploads: koe,
  views_preview_headlide: yoe,
  washablility: boe,
  width_abbreviation: woe,
  your_file_is_beeing_uploaded: xoe,
  zoom: $oe,
  please_correct_the_highlighted_errors: zoe
};
var Aoe = {
  prefix: "fal",
  iconName: "rotate-reverse",
  icon: [
    512,
    512,
    [],
    "e631",
    "M85.9 301.2c-2-7.6-8.6-13.2-16.5-13.2c-10 0-17.6 8.9-15.2 18.6C76.8 397 158.6 464 256 464c59.8 0 113.7-25.3 151.7-65.7L433.4 424c5.1 5.1 12.1 8 19.3 8c15.1 0 27.3-12.2 27.3-27.3L480 304c0-8.8-7.2-16-16-16l-100.7 0c-15.1 0-27.3 12.2-27.3 27.3c0 7.2 2.9 14.2 8 19.3l41 41C352.9 410.3 307 432 256 432c-81.6 0-150.2-55.5-170.1-130.8zM127 136.3C159.1 101.7 205 80 256 80c81.6 0 150.2 55.5 170.1 130.8c2 7.6 8.6 13.2 16.5 13.2c10 0 17.6-8.9 15.2-18.6C435.2 115 353.4 48 256 48c-59.8 0-113.7 25.3-151.7 65.7L78.6 88c-5.1-5.1-12.1-8-19.3-8C44.2 80 32 92.2 32 107.3L32 208c0 8.8 7.2 16 16 16l100.7 0c15.1 0 27.3-12.2 27.3-27.3c0-7.2-2.9-14.2-8-19.3l-41-41zM64 192l0-73.4L137.4 192 64 192zM448 320l0 73.4L374.6 320l73.4 0z"
  ]
}, Coe = {
  prefix: "fal",
  iconName: "arrow-rotate-right",
  icon: [
    512,
    512,
    [8635, "arrow-right-rotate", "arrow-rotate-forward", "redo"],
    "f01e",
    "M464 192c8.8 0 16-7.2 16-16l0-128c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 92.6C408.8 75.5 337.5 32 256 32C132.3 32 32 132.3 32 256s100.3 224 224 224c79.9 0 150-41.8 189.7-104.8c6.6-10.4-1.4-23.2-13.7-23.2c-6 0-11.4 3.2-14.7 8.2C383.1 413 323.6 448 256 448C150 448 64 362 64 256S150 64 256 64c71.1 0 133.1 38.6 166.3 96L336 160c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0z"
  ]
}, Poe = {
  prefix: "fal",
  iconName: "plus",
  icon: [
    448,
    512,
    [10133, 61543, "add"],
    "2b",
    "M240 64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 176L32 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l176 0 0 176c0 8.8 7.2 16 16 16s16-7.2 16-16l0-176 176 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-176 0 0-176z"
  ]
}, Moe = {
  prefix: "fal",
  iconName: "chevron-left",
  icon: [
    320,
    512,
    [9001],
    "f053",
    "M20.7 267.3c-6.2-6.2-6.2-16.4 0-22.6l192-192c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L54.6 256 235.3 436.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-192-192z"
  ]
}, Toe = {
  prefix: "fal",
  iconName: "spinner-third",
  icon: [
    512,
    512,
    [],
    "f3f4",
    "M463.9 376c7.6 4.4 17.5 1.8 21.4-6.1c17.1-34.3 26.7-73 26.7-113.9C512 120 405.9 8.8 272 .5c-8.8-.5-16 6.7-16 15.5s7.2 15.9 16 16.6C388.2 40.8 480 137.7 480 256c0 35.1-8.1 68.3-22.5 97.9c-3.9 8-1.3 17.7 6.4 22.1z"
  ]
}, Ioe = {
  prefix: "fal",
  iconName: "chevron-down",
  icon: [
    512,
    512,
    [],
    "f078",
    "M267.3 395.3c-6.2 6.2-16.4 6.2-22.6 0l-192-192c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L256 361.4 436.7 180.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-192 192z"
  ]
}, Eoe = {
  prefix: "fal",
  iconName: "rotate-right",
  icon: [
    512,
    512,
    ["redo-alt", "rotate-forward"],
    "f2f9",
    "M417.3 360.2c3.2-5 8.7-8.2 14.7-8.2c12.3 0 20.3 12.8 13.7 23.2C406 438.2 335.9 480 256 480C132.3 480 32 379.7 32 256S132.3 32 256 32c56.1 0 107.4 20.6 146.7 54.7L433.4 56c5.1-5.1 12.1-8 19.3-8C467.8 48 480 60.2 480 75.3L480 176c0 8.8-7.2 16-16 16l-100.7 0c-15.1 0-27.3-12.2-27.3-27.3c0-7.2 2.9-14.2 8-19.3l36-36C346.5 81.1 303.3 64 256 64C150 64 64 150 64 256s86 192 192 192c67.6 0 127.1-35 161.3-87.8zM448 86.6L374.6 160l73.4 0 0-73.4z"
  ]
}, Ooe = {
  prefix: "fal",
  iconName: "sliders",
  icon: [
    512,
    512,
    ["sliders-h"],
    "f1de",
    "M0 416c0 8.8 7.2 16 16 16l65.6 0c7.4 36.5 39.7 64 78.4 64s71-27.5 78.4-64L496 432c8.8 0 16-7.2 16-16s-7.2-16-16-16l-257.6 0c-7.4-36.5-39.7-64-78.4-64s-71 27.5-78.4 64L16 400c-8.8 0-16 7.2-16 16zm112 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM304 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm48-80c-38.7 0-71 27.5-78.4 64L16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l257.6 0c7.4 36.5 39.7 64 78.4 64s71-27.5 78.4-64l65.6 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-65.6 0c-7.4-36.5-39.7-64-78.4-64zM192 144a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm78.4-64C263 43.5 230.7 16 192 16s-71 27.5-78.4 64L16 80C7.2 80 0 87.2 0 96s7.2 16 16 16l97.6 0c7.4 36.5 39.7 64 78.4 64s71-27.5 78.4-64L496 112c8.8 0 16-7.2 16-16s-7.2-16-16-16L270.4 80z"
  ]
}, Roe = {
  prefix: "fal",
  iconName: "spinner",
  icon: [
    512,
    512,
    [],
    "f110",
    "M256 64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 480a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM64 256a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM0 256a48 48 0 1 1 96 0A48 48 0 1 1 0 256zm464 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM120.2 391.8A16 16 0 1 0 97.6 414.4a16 16 0 1 0 22.6-22.6zM75 437a48 48 0 1 1 67.9-67.9A48 48 0 1 1 75 437zM97.6 120.2a16 16 0 1 0 22.6-22.6A16 16 0 1 0 97.6 120.2zM142.9 75A48 48 0 1 1 75 142.9 48 48 0 1 1 142.9 75zM414.4 414.4a16 16 0 1 0 -22.6-22.6 16 16 0 1 0 22.6 22.6zm-45.3-45.3A48 48 0 1 1 437 437a48 48 0 1 1 -67.9-67.9z"
  ]
}, Yu = {
  prefix: "fal",
  iconName: "check",
  icon: [
    448,
    512,
    [10003, 10004],
    "f00c",
    "M443.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-272 272c-6.2 6.2-16.4 6.2-22.6 0l-144-144c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L160 361.4 420.7 100.7c6.2-6.2 16.4-6.2 22.6 0z"
  ]
}, Loe = {
  prefix: "fal",
  iconName: "trash-can",
  icon: [
    448,
    512,
    [61460, "trash-alt"],
    "f2ed",
    "M164.2 39.5L148.9 64l150.3 0L283.8 39.5c-2.9-4.7-8.1-7.5-13.6-7.5l-92.5 0c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6L336.9 64 384 64l32 0 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 336c0 44.2-35.8 80-80 80l-224 0c-44.2 0-80-35.8-80-80L32 96 16 96C7.2 96 0 88.8 0 80s7.2-16 16-16l16 0 32 0 47.1 0L137 22.6C145.8 8.5 161.2 0 177.7 0l92.5 0c16.6 0 31.9 8.5 40.7 22.6zM64 96l0 336c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-336L64 96zm80 80l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16s16 7.2 16 16z"
  ]
}, Doe = Loe, joe = {
  prefix: "fal",
  iconName: "up-right-and-down-left-from-center",
  icon: [
    512,
    512,
    ["expand-alt"],
    "f424",
    "M321 0c-18.2 0-33 14.8-33 33c0 8.7 3.5 17.1 9.7 23.3L325.4 84l-71.7 71.7c-15.6 15.6-15.6 40.9 0 56.6l46.1 46.1c15.6 15.6 40.9 15.6 56.6 0L428 186.6l27.7 27.7c6.2 6.2 14.6 9.7 23.3 9.7c18.2 0 33-14.8 33-33l0-159c0-17.7-14.3-32-32-32L321 0zm-1 33c0-.5 .4-1 1-1l159 0 0 159c0 .5-.4 1-1 1c-.3 0-.5-.1-.7-.3l-39-39c-6.2-6.2-16.4-6.2-22.6 0l-83 83c-3.1 3.1-8.2 3.1-11.3 0l-46.1-46.1c-3.1-3.1-3.1-8.2 0-11.3l83-83c3-3 4.7-7.1 4.7-11.3s-1.7-8.3-4.7-11.3l-39-39c-.2-.2-.3-.4-.3-.7zM32 512l159 0c18.2 0 33-14.8 33-33c0-8.7-3.5-17.1-9.7-23.3L186.6 428l71.7-71.7c15.6-15.6 15.6-40.9 0-56.6l-46.1-46.1c-15.6-15.6-40.9-15.6-56.6 0L84 325.4 56.3 297.7C50.1 291.5 41.7 288 33 288c-18.2 0-33 14.8-33 33L0 480c0 17.7 14.3 32 32 32zm160-33c0 .5-.4 1-1 1L32 480l0-159c0-.5 .4-1 1-1c.3 0 .5 .1 .7 .3l39 39c6.2 6.2 16.4 6.2 22.6 0l83-83c3.1-3.1 8.2-3.1 11.3 0l46.1 46.1c3.1 3.1 3.1 8.2 0 11.3l-83 83c-3 3-4.7 7.1-4.7 11.3s1.7 8.3 4.7 11.3l39 39c.2 .2 .3 .4 .3 .7z"
  ]
}, Noe = {
  prefix: "fal",
  iconName: "circle-question",
  icon: [
    512,
    512,
    [62108, "question-circle"],
    "f059",
    "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm168.7-86.2c6.5-24.6 28.7-41.8 54.2-41.8l57.1 0c35.5 0 64 29 64 64.3c0 24-13.4 46.2-34.9 57.2L272 268.3l0 19.7c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-29.5c0-6 3.4-11.5 8.7-14.3l45.8-23.4c10.7-5.4 17.5-16.6 17.5-28.7c0-17.8-14.4-32.3-32-32.3l-57.1 0c-10.9 0-20.5 7.4-23.2 17.9l-.2 .7c-2.2 8.5-11 13.7-19.5 11.4s-13.7-11-11.4-19.5l.2-.7zM232 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
  ]
}, Voe = {
  prefix: "fal",
  iconName: "link",
  icon: [
    640,
    512,
    [128279, "chain"],
    "f0c1",
    "M591.5 256c50-50 50-131 0-181s-131-50-181 0L387.9 97.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l22.6-22.6c37.5-37.5 98.3-37.5 135.8 0s37.5 98.3 0 135.8L444.3 357.9c-37.4 37.4-98.1 37.4-135.6 0c-35.6-35.6-37.6-92.6-4.7-130.6l5.3-6.1c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6l-5.3 6.1c-43.9 50.7-41.2 126.7 6.2 174.1c49.9 49.9 130.9 49.9 180.8 0L591.5 256zM48.5 256c-50 50-50 131 0 181s131 50 181 0l22.6-22.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-22.6 22.6c-37.5 37.5-98.3 37.5-135.8 0s-37.5-98.3 0-135.8L195.7 154.1c37.4-37.4 98.1-37.4 135.6 0c35.6 35.6 37.6 92.6 4.7 130.6l-5.3 6.1c-5.8 6.7-5.1 16.8 1.6 22.6s16.8 5.1 22.6-1.6l5.3-6.1c43.9-50.7 41.2-126.7-6.2-174.1C303.9 81.5 223 81.5 173 131.4L48.5 256z"
  ]
}, Uoe = {
  prefix: "fal",
  iconName: "circle-exclamation",
  icon: [
    512,
    512,
    ["exclamation-circle"],
    "f06a",
    "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-8.8 0-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128c0-8.8-7.2-16-16-16zm24 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
  ]
}, ed = {
  prefix: "fal",
  iconName: "arrow-up-from-bracket",
  icon: [
    448,
    512,
    [],
    "e09a",
    "M235.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L208 54.6 208 336c0 8.8 7.2 16 16 16s16-7.2 16-16l0-281.4L340.7 155.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-128-128zM32 336c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 44.2 35.8 80 80 80l288 0c44.2 0 80-35.8 80-80l0-96c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 26.5-21.5 48-48 48L80 480c-26.5 0-48-21.5-48-48l0-96z"
  ]
}, Foe = {
  prefix: "fal",
  iconName: "align-center",
  icon: [
    448,
    512,
    [],
    "f037",
    "M112 48c-8.8 0-16 7.2-16 16s7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L112 48zM16 176c-8.8 0-16 7.2-16 16s7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 176zM96 320c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-224 0c-8.8 0-16 7.2-16 16zM16 432c-8.8 0-16 7.2-16 16s7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 432z"
  ]
}, Boe = {
  prefix: "fal",
  iconName: "image",
  icon: [
    512,
    512,
    [],
    "f03e",
    "M64 64C46.3 64 32 78.3 32 96l0 233.4 67.7-67.7c15.6-15.6 40.9-15.6 56.6 0L224 329.4 355.7 197.7c15.6-15.6 40.9-15.6 56.6 0L480 265.4 480 96c0-17.7-14.3-32-32-32L64 64zM32 374.6L32 416c0 17.7 14.3 32 32 32l41.4 0 96-96-67.7-67.7c-3.1-3.1-8.2-3.1-11.3 0L32 374.6zM389.7 220.3c-3.1-3.1-8.2-3.1-11.3 0L150.6 448 448 448c17.7 0 32-14.3 32-32l0-105.4-90.3-90.3zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm160 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"
  ]
}, qoe = {
  prefix: "fal",
  iconName: "align-right",
  icon: [
    448,
    512,
    [],
    "f038",
    "M432 48c8.8 0 16 7.2 16 16s-7.2 16-16 16L176 80c-8.8 0-16-7.2-16-16s7.2-16 16-16l256 0zm0 128c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 208c-8.8 0-16-7.2-16-16s7.2-16 16-16l416 0zm16 144c0 8.8-7.2 16-16 16l-256 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l256 0c8.8 0 16 7.2 16 16zM432 432c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 464c-8.8 0-16-7.2-16-16s7.2-16 16-16l416 0z"
  ]
}, Hoe = {
  prefix: "fal",
  iconName: "chevron-right",
  icon: [
    320,
    512,
    [9002],
    "f054",
    "M299.3 244.7c6.2 6.2 6.2 16.4 0 22.6l-192 192c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L265.4 256 84.7 75.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l192 192z"
  ]
}, td = {
  prefix: "fal",
  iconName: "ellipsis-vertical",
  icon: [
    128,
    512,
    ["ellipsis-v"],
    "f142",
    "M64 384a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-160a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM96 96A32 32 0 1 0 32 96a32 32 0 1 0 64 0z"
  ]
}, Woe = {
  prefix: "fal",
  iconName: "chevron-up",
  icon: [
    512,
    512,
    [],
    "f077",
    "M244.7 116.7c6.2-6.2 16.4-6.2 22.6 0l192 192c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L256 150.6 75.3 331.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l192-192z"
  ]
}, Goe = {
  prefix: "fal",
  iconName: "align-left",
  icon: [
    448,
    512,
    [],
    "f036",
    "M16 48C7.2 48 0 55.2 0 64s7.2 16 16 16l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 48zm0 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 176zM0 320c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 304c-8.8 0-16 7.2-16 16zM16 432c-8.8 0-16 7.2-16 16s7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 432z"
  ]
}, Zoe = {
  prefix: "fal",
  iconName: "floppy-disk",
  icon: [
    448,
    512,
    [128190, 128426, "save"],
    "f0c7",
    "M32 96c0-17.7 14.3-32 32-32l0 96c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32l0-94.2c4.5 1.6 8.7 4.2 12.1 7.6l74.5 74.5c6 6 9.4 14.1 9.4 22.6L416 416c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96zM96 64l192 0 0 96L96 160l0-96zM0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-245.5c0-17-6.7-33.3-18.7-45.3L354.7 50.7c-12-12-28.3-18.7-45.3-18.7L64 32C28.7 32 0 60.7 0 96zM272 320a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-80a80 80 0 1 0 0 160 80 80 0 1 0 0-160z"
  ]
}, nd = Zoe, Koe = {
  prefix: "fal",
  iconName: "magnifying-glass",
  icon: [
    512,
    512,
    [128269, "search"],
    "f002",
    "M384 208A176 176 0 1 0 32 208a176 176 0 1 0 352 0zM343.3 366C307 397.2 259.7 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 51.7-18.8 99-50 135.3L507.3 484.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L343.3 366z"
  ]
}, Xoe = {
  prefix: "fal",
  iconName: "minus",
  icon: [
    448,
    512,
    [8211, 8722, 10134, "subtract"],
    "f068",
    "M432 256c0 8.8-7.2 16-16 16L32 272c-8.8 0-16-7.2-16-16s7.2-16 16-16l384 0c8.8 0 16 7.2 16 16z"
  ]
}, Qoe = {
  prefix: "fak",
  iconName: "tshirt-size",
  icon: [
    608,
    512,
    [],
    "e001",
    "M560.5 84.3L397.1 1.1s-10 11.4-15.8 17.2c-7.4 7.4-17.9 13.7-30.4 18.1-13.6 4.8-29.3 7.4-45.3 7.4-16 0-31.7-2.6-45.3-7.4-12.5-4.4-23-10.7-30.4-18.1-5.8-5.8-15.8-17.2-15.8-17.2L49.3 85c-7.2 3.6-12.7 9.9-15.2 17.6-2.5 7.7-1.8 16 1.9 23.1l46.5 89.8c5.3 10.3 15.8 16.2 26.7 16.2 4.6 0 9.2-1.1 13.6-3.3l38.8-19.7v26.2l.4.4c2.1 2.1 7.2 4.6 14.6 4.6s12.5-2.5 14.6-4.6l.4-.4v-75.2l-82.4 41.9-46.5-89.8 146-72.4c21.4 21.4 57.1 34.4 96.9 34.4 39.8 0 75.6-12.9 96.9-34.4l144.6 71.7-43.4 89.9-84.3-41.2V415c0 6.3-5.1 11.4-11.4 11.4H294.2v30h113.9c22.8 0 41.4-18.6 41.4-41.4V207.8l41.1 20.1c4.1 2 8.7 3.1 13.2 3.1 3.3 0 6.6-.5 9.8-1.6 7.5-2.6 13.7-8.1 17.2-15.3l43.4-89.8c7.1-14.9 1-32.7-13.7-40zM228.1 276.1l76.6 38-23 47.5-44.6-21.8v135.1c0 3.3-2.7 6-6 6H122.5c-3.3 0-6-2.7-6-6V339.8L72.8 362l-24.6-47.5 77.3-38.3c11.3 11.3 30.2 18.2 51.3 18.2 21.1-.1 40-6.9 51.3-18.3m-94.8-37.4l-98.4 48.9c-7.2 3.6-12.7 9.9-15.2 17.6-2.5 7.7-1.8 16 1.9 23.1l24.6 47.5C51.5 386.1 62 392 72.9 392c4.6 0 9.2-1.1 13.6-3.3v86.2c0 19.9 16.2 36 36 36h108.6c19.9 0 36-16.2 36-36v-87l1.4.7c4.1 2 8.7 3.1 13.2 3.1 3.3 0 6.6-.5 9.8-1.6 7.5-2.6 13.7-8.1 17.2-15.3l23-47.5c7.2-14.8 1.1-32.6-13.7-39.9l-97.7-48.5s-7.7 10.5-13.5 16.3c-4.3 4.3-14.8 9.4-30.1 9.4s-25.8-5.1-30.1-9.4c-5.6-6-13.3-16.5-13.3-16.5z"
  ]
}, Joe = {
  prefix: "fak",
  iconName: "icon-design-logo",
  icon: [
    512,
    512,
    [],
    "e023",
    "M398.4 215.4l-10.9 3.2c-.6 0-1 .3-1.6 .6c-.3 .6-.6 1.3-.6 1.9c-.3 10.6 0 21.1 1 31.7c0 1.6 .3 2.9 .6 4.5c.6 1 1 1.6 1.6 2.6c1.3 1.6 1.9 3.5 2.2 5.8c0 5.4-4.2 9.6-9.6 9.6s-9.6-4.2-9.6-9.6l0 0c0-2.2 .6-4.2 2.2-5.8c.6-.6 1.3-1.6 1.6-2.6c.3-1.3 .6-2.9 .3-4.5c.3-8.6 1-19.5 1-25c-.3-4.8-.3-9.9 .3-14.7c.3-3.8 3.8-6.7 7.7-6.1c.6 0 1.6 .3 2.2 .6c3.8 1.6 7.4 3.5 10.9 5.8l.6 .3c1.3 .6 .3 1.3 0 1.6l0 0zM381.1 337.3s-4.2 5.1-6.1 8c0 0-.3 .3-.6 .3h-15c-.3 0-.6-.3-.6-.6v-1.6c0-.3 0-.3 .3-.6l16-8 .3 0 .3 0c.6-.3 1-1.3 1-1.9c0-.3 0-.6 0-.6s-4.5-24-6.4-33.3c0-.6 .3-1.3 1-1c3.2 1 6.7 1.6 9.9 1.6c3.5 0 6.7-.6 9.9-1.6c.6 0 1 .3 1 1c-1.9 9.6-6.4 33.3-6.4 33.3c0 .3 0 .6 0 .6c0 .6 .3 1.6 1 1.9l.3 0 .3 0 16 8c.3 0 .3 .3 .3 .3v1.3c0 .3-.3 .6-.6 .6h-15.4c-.3 0-.3 0-.6-.3c-1.9-2.2-5.8-7.4-5.8-7.4m0-56.6c-8.6 0-15.4-7-15.4-15.4c0-3.5 1.3-6.7 3.2-9.3l0-.3 1-1.3 .3-.3-.3-.6 0 0c-2.9-7.4-7.7-13.8-13.8-18.6c-16 5.8-27.2 20.5-28.2 37.4c1.9 21.1 18.2 38.1 39 41c-1-4.8-1.6-9.3-2.6-13.8v0c-.3-2.2 .3-4.5 1.9-6.1s3.8-2.2 5.8-1.9c.3 0 .6 0 1 .3c2.6 .6 5.4 1.3 8 1.3s5.4-.3 8-1.3c.3 0 .6-.3 1-.3c2.2-.3 4.5 .3 5.8 1.9c1.6 1.6 2.2 3.8 1.9 6.1v0c-1 4.5-1.6 9.3-2.6 13.8c20.8-2.9 37.1-19.8 39-41c-1-17-12.2-32-28.2-37.8c-6.4 4.8-11.2 11.2-13.8 18.6l-.3 .6 .3 .6 1 1.3 0 .3c1.9 2.6 2.9 5.8 3.2 9c0 0 0 .3 0 .6c0 8-7 15-15.4 15l0 0zM512 192V176.6c0-14.7-10.2-27.2-24.3-30.4c0-2.9-.6-5.8-1.6-8.3c-3.2-12.2-10.9-22.1-21.8-28.5l-89.6-51.8 0 0c-15.7-11.8-43.2-7.7-61.4-8.3v.3c-6.4 0-12.8 3.5-16 9.6c-10.2 20.2-30.7 33-53.8 33s-43.5-12.8-53.8-33.3c-3.2-6.1-9.3-9.6-15.7-9.6v0c-17.9 .6-44.5-3.2-60.2 7.7L23.4 108.8c-10.9 6.4-18.6 16.3-21.8 28.5c-9.9 25.9 25.3 66.9 35.5 88.6c13.1 22.7 42.2 30.1 64.3 17V416c0 25.9 21.1 46.7 46.7 46.7h191c25.6 0 46.7-21.1 46.7-46.7v-36.8h48c1.9 15.4 15 27.5 31 27.5h15.7c17.3 0 31.4-14.1 31.4-31.4v-15.7c0-16-12.2-29.1-27.5-31V223c15.4-1.9 27.5-15 27.5-31zM350.4 416c0 6.4-5.1 11.5-11.2 11.5h-191c-6.4 0-11.5-5.1-11.5-11.5V212.2c-.3-8.6-7-17-16.3-17.3c-8.3-2.2-30.1 14.4-37.1 17.3c-5.1 3.2-12.5 1.3-15.7-4.2L37.1 154.9c-3.2-5.1-1.3-12.5 4.2-15.4c0 0 90.2-52.2 90.6-52.2l0 0c5.8-4.8 25-2.2 32-2.9c34.2 56.6 125.1 56.6 159.4 0c7.4 .6 26.2-1.9 32.6 2.9l0 0c0 .3 90.6 52.2 90.6 52.5c2.9 1.6 4.8 4.8 5.4 8c-9.6 4.5-16.6 13.8-18.2 24.6H328.3c-1.9-15.4-15-27.5-31-27.5H281.6c-17.3 0-31.4 14.1-31.4 31.4V192c0 16 12.2 29.1 27.5 31v105.3c-15.4 1.9-27.5 15-27.5 31V375c0 17.3 14.1 31.4 31.4 31.4h15.7c16 0 29.1-12.2 31-27.5h22.1c0 22.1 0 37.1 0 37.1zM281.6 200c-4.5 0-8-3.5-8-8V176.6c0-4.5 3.5-8 8-8h15.7c4.5 0 8 3.5 8 8V192c0 4.5-3.5 8-8 8H281.6zM305 359.7v15.7c0 4.5-3.5 8-8 8H281.6c-4.5 0-8-3.5-8-8v-15.7c0-4.5 3.5-8 8-8h15.7c4.2 0 7.7 3.5 7.7 8zm128.6-3.8H328.3c-1.9-14.1-12.8-25.3-27.2-27.2V223c14.1-1.9 25.3-12.8 27.2-27.2h105.3c1.9 14.1 12.8 25.3 27.2 27.2v105.3c-14.1 2.2-25.3 13.1-27.2 27.5zm54.7 3.8v15.7c0 4.5-3.5 8-8 8h-15.7c-4.5 0-8-3.5-8-8v-15.7c0-4.5 3.5-8 8-8h15.7c4.5 0 8 3.5 8 8zm-8-159.7h-15.7c-4.5 0-8-3.5-8-8V176.6c0-4.5 3.5-8 8-8h15.7c4.5 0 8 3.5 8 8V192c0 4.5-3.5 8-8 8z"
  ]
}, Yoe = {
  prefix: "fak",
  iconName: "icon-info",
  icon: [
    512,
    512,
    [],
    "e013",
    "M256 38.4A218 218 0 1 1 38.4 256 218 218 0 0 1 256 38.4M256 0A256 256 0 1 0 512 256 256 256 0 0 0 256 0zM256 172A25.6 25.6 0 0 1 256 121h.208a25.6 25.6 0 0 1 0 51.2zM256 400a21.3 21.3 0 0 1 -21.3-21.3v-.405c.043-5.77 .043-132 0-138v-.405a21.3 21.3 0 0 1 21.3-21.3c21.3 0 21.4 16.2 21.4 43l.021 47.6-.021 47.6C277 384 277 400 256 400z"
  ]
}, eae = {
  prefix: "fak",
  iconName: "tshirt-color",
  icon: [
    608,
    512,
    [],
    "e000",
    "M407 198.4c15.1 49.2 38.1 82 56.6 108.5 20.1 28.8 34.7 49.6 34.7 80.4 0 51.1-41 92.7-91.3 92.7s-91.3-41.6-91.3-92.7c0-30.7 14.6-51.6 34.8-80.5 18.5-26.5 41.4-59.4 56.5-108.4m0-30c-13.2 0-24.8 8.6-28.7 21.2-13.7 44.6-34.3 74.1-52.5 100.1-21.6 30.9-40.2 57.6-40.2 97.7C285.7 455 340.1 510 407 510s121.3-55 121.3-122.7c0-40.3-18.6-66.8-40.1-97.6-18.2-26-38.8-55.4-52.5-100.1-3.9-12.6-15.5-21.2-28.7-21.2zm153.5-84.1L397.1 1.1s-10 11.4-15.8 17.2c-7.4 7.4-17.9 13.7-30.4 18.1-13.6 4.8-29.3 7.4-45.3 7.4s-31.7-2.6-45.3-7.4c-12.5-4.4-23-10.7-30.4-18.1-5.8-5.8-15.8-17.2-15.8-17.2L49.3 85c-7.2 3.6-12.7 9.9-15.2 17.6-2.5 7.7-1.8 16 1.9 23.1l46.5 89.8c5.3 10.3 15.8 16.2 26.7 16.2 4.6 0 9.2-1.1 13.6-3.3l38.7-19.6V415c0 22.8 18.6 41.4 41.4 41.4h69.2c-4.8-9.5-8.6-19.5-11.4-30H203c-6.3 0-11.4-5.1-11.4-11.4V159.7l-82.4 41.9-46.5-89.8 146-72.4c21.4 21.4 57.1 34.4 96.9 34.4s75.6-12.9 96.9-34.4l144.6 71.7-43.4 89.9-38.9-19c4.9 15.7 10.8 29.4 17.3 41.7l8.6 4.2c4.1 2 8.7 3.1 13.2 3.1 3.3 0 6.6-.5 9.8-1.6 7.5-2.6 13.7-8.1 17.2-15.3l43.4-89.8c7-14.9.9-32.7-13.8-40zm-155 381.4c-8.5 0-34-2.2-53.3-26.6-21.5-27.3-18.9-52.9-18.9-52.9 0-18.1 29.8-20.3 29.8 3.8 0 0-.9 13.3 12.7 30.6 12.7 16.1 29.9 15.2 29.9 15.2 19.2-.1 19.2 29.9-.2 29.9z"
  ]
}, tae = {
  prefix: "fak",
  iconName: "icon-expander-clos",
  icon: [
    1024,
    512,
    [],
    "e00f",
    "M968 502a46 46 0 0 1 -30.6-11.7L507 108 76.7 490A46.1 46.1 0 0 1 15.5 421l461-410a46.2 46.2 0 0 1 61.3 0l461 410a46.1 46.1 0 0 1 -30.6 80.5z"
  ]
}, nae = {
  prefix: "fak",
  iconName: "icon-close-large",
  icon: [
    512,
    512,
    [],
    "e00b",
    "M256 9.31A247 247 0 1 1 9.31 256 247 247 0 0 1 256 9.31m0-9.31A256 256 0 1 0 512 256 256 256 0 0 0 256 0zM268 256l77.9-77.9A8.38 8.38 0 1 0 334 166l-77.9 77.9L178 166a8.38 8.38 0 1 0 -11.8 11.9l77.9 77.9L166 334a8.38 8.38 0 1 0 11.8 11.9l77.9-77.9 77.9 77.9A8.38 8.38 0 1 0 346 334z"
  ]
}, sae = {
  prefix: "fak",
  iconName: "icon-easytransfer",
  icon: [
    528,
    512,
    [],
    "e026",
    "M441.6 94.4a17.6 30.4 0 1 0 0 60.8 17.6 30.4 0 1 0 0-60.8zM520 124.8c0 70.4-33.6 124.8-78.4 124.8c-20.8 0-38.4-12.8-52.8-32c-4.8 65.6-11.2 160-11.2 185.6c-3.2 41.6-12.8 72-12.8 73.6c-8 25.6-27.2 33.6-36.8 33.6s-1.6 0-3.2 0H12.8c-4.8 0-9.6-3.2-11.2-8S0 491.2 3.2 488c16-19.2 28.8-91.2 28.8-139.2V88s-3.2-25.6 11.2-52.8c16-30.4 46.4-33.6 48-33.6h337.6c4.8-1.6 8-1.6 12.8-1.6C486.4 0 520 54.4 520 124.8zM366.4 166.4c-1.6-12.8-3.2-25.6-3.2-40c0-40 11.2-75.2 28.8-97.6H89.6c1.6 0-16 1.6-25.6 19.2c-9.6 20.8-8 40-8 40v262.4c0 38.4-8 97.6-22.4 134.4h288c6.4 0 14.4-6.4 17.6-16c0 0 9.6-28.8 11.2-67.2c3.2-35.2 12.8-188.8 16-235.2zm124.8-41.6c0-56-25.6-96-49.6-96s-49.6 40-49.6 96 25.6 96 49.6 96 49.6-40 49.6-96zm-270.4-6.4v91.2c0 3.2 3.2 6.4 6.4 6.4h91.2c3.2 0 6.4-3.2 6.4-6.4V118.4c0-3.2-3.2-6.4-6.4-6.4h-91.2c-4.8 0-6.4 3.2-6.4 6.4zM131.2 348.8a52.8 52.8 0 1 0 0 105.6 52.8 52.8 0 1 0 0-105.6zm6.4-174.4c1.6-1.6 4.8-1.6 4.8 0l54.4 92.8c0 1.6-1.6 4.8-3.2 4.8H88c-3.2 0-4.8-3.2-3.2-4.8l52.8-92.8 0 0zM297.6 288l25.6 44.8c1.6 1.6 1.6 4.8 1.6 6.4L299.2 384c-1.6 1.6-4.8 3.2-6.4 3.2H240c-3.2 0-4.8-1.6-6.4-3.2L208 339.2c-1.6-1.6-1.6-4.8 0-6.4l25.6-44.8c1.6-1.6 4.8-3.2 6.4-3.2h52.8c1.6 0 3.2 1.6 4.8 3.2z"
  ]
}, oae = {
  prefix: "fak",
  iconName: "icon-remove",
  icon: [
    448,
    512,
    [],
    "e014",
    "M420 79.8H311V68.1A68.1 68.1 0 0 0 243 0H198A68.1 68.1 0 0 0 129 68.1v11.7H21.3a21.3 21.3 0 1 0 0 42.7h12.6L64 451A61 61 0 0 0 125 512h192a60.6 60.6 0 0 0 61-59.1L407 122h12.4a21.3 21.3 0 0 0 0-42.7zM172 68.1A26 26 0 0 1 198 42.7H243a25.8 25.8 0 0 1 25.8 25.8v11.7H172zm163 384a18.8 18.8 0 0 1 -18.8 18.8h-192a19.2 19.2 0 0 1 -18.8-21.3L76.2 122H365zM220 180a16.4 16.4 0 0 0 -16.4 16.4v199a16.4 16.4 0 0 0 32.9 0V196A16.2 16.2 0 0 0 220 180zM272 196v199a16.4 16.4 0 0 0 32.9 0V196a16.4 16.4 0 0 0 -32.9 0zM153 180a16.4 16.4 0 0 0 -16.4 16.4v199a16.6 16.6 0 0 0 33.1 0V196A16.4 16.4 0 0 0 153 180z"
  ]
}, aae = {
  prefix: "fak",
  iconName: "upload",
  icon: [
    541,
    512,
    [],
    "e027",
    "M277.6 6c-9.1-8-22.5-8-31.9 0l-95 81.4c-10.8 8.2-12.8 23.6-4.6 34.1 8.2 10.8 23.6 12.8 34.1 4.6 .9-.6 1.4-1.1 2-1.7l54.6-46.6 0 218.2c.6 13.4 11.7 24.2 25.3 23.6 12.8-.6 23-10.8 23.6-23.6l0-218.5 54.6 46.6c10 9.1 25.6 8.2 34.4-2s8.2-25.6-2-34.4c0 0-.6-.6-.9-.6L277.6 6zM498.9 300.4c-13.4 0-24.5 10.8-24.5 24.5l0 0 0 87.3c0 13.9-11.4 25-25.3 25L74 437.2c-13.7 0-25-11.1-25.3-24.7l0-87.6c-.6-13.4-11.7-24.2-25.3-23.6-12.8 .6-23 10.8-23.6 23.6l0 87.6c.3 40.7 33.3 73.4 74 73.7l374.9 0c19.6 .9 39-7.1 52.6-21.3 13.9-13.7 21.9-32.7 22.2-52.3l0-87.6c0-13.4-10.8-24.5-24.5-24.5l0 0z"
  ]
}, iae = {
  prefix: "fak",
  iconName: "icon-expander-small-close",
  icon: [
    1110,
    512,
    [],
    "e011",
    "M1016 538a76.5 76.5 0 0 1 -48.6-17.4L546 176 126 520A76.8 76.8 0 1 1 28.5 401l469-384a76.7 76.7 0 0 1 97.3 0l469 384a76.8 76.8 0 0 1 -48.7 136z"
  ]
}, rae = {
  prefix: "fak",
  iconName: "icon-design-text",
  icon: [
    512,
    512,
    [],
    "e022",
    "M420.4 235.8l-33.5 0 0 92.9-13.7 0 0-92.9-33.4 0 0-11.2 80.5 0zm91.5-43.7V176.5c0-14.8-10.4-27.3-24.3-30.6c-.2-2.9-.6-5.7-1.6-8.3c-3.2-12.1-11-22.1-21.8-28.4l-89.7-51.8 0 0c-15.7-11.7-43.3-7.7-61.5-8.3v.2c-6.5 0-12.7 3.4-15.8 9.6c-10.2 20.5-30.8 33.3-53.8 33.3s-43.6-12.7-53.8-33.3c-3.1-6.2-9.3-9.6-15.8-9.6v-.2c-17.8 .6-44.4-3.2-60.3 7.6v0L23.4 108.9c-10.8 6.3-18.6 16.4-21.8 28.4c-10 25.8 25.4 67 35.4 88.5c13 22.7 42.3 30 64.3 16.9v173.2c0 25.8 21 46.8 46.8 46.8H339c25.8 0 46.7-21 46.7-46.8v-36.7h48c2 15.5 15.1 27.5 31 27.5h15.6c17.3 0 31.5-14.1 31.5-31.5v-15.6c0-16-12-29.1-27.5-31V223.2c15.5-2 27.5-15.1 27.5-31.1zM350.3 415.9c0 6.3-5.1 11.4-11.3 11.4H148.1c-6.3 0-11.4-5.1-11.4-11.4V212.2c-.4-8.9-7.1-17-16.3-17.4c-8.2-2.2-30.1 14.5-37.2 17.5c-5.2 3.2-12.5 1.2-15.5-4.2L37 155c-3.2-5.2-1.2-12.6 4.1-15.5c.1-.1 90.4-52.2 90.4-52.3l0 0c6.1-4.5 25.1-2.1 32.2-2.7c34.4 56.7 125.1 56.7 159.4 0c7.5 .6 26.3-2 32.6 2.9l0-.1c0 .4 90.5 52.3 90.7 52.5c3 1.7 4.8 4.7 5.3 8c-9.7 4.4-16.8 13.6-18.2 24.6H328.3c-2-15.5-15.1-27.5-31-27.5H281.6c-17.3 0-31.5 14.1-31.5 31.5v15.6c0 16 12 29.1 27.5 31.1v105.4c-15.5 2-27.5 15.1-27.5 31v15.6c0 17.3 14.1 31.5 31.5 31.5h15.6c16 0 29.1-12 31-27.5h22c0 21.7 0 36.7 0 36.7zM281.6 200c-4.4 0-7.9-3.5-7.9-7.9V176.5c0-4.4 3.5-7.9 7.9-7.9h15.6c4.4 0 7.9 3.5 7.9 7.9v15.6c0 4.4-3.5 7.9-7.9 7.9H281.6zm23.5 159.6v15.6c0 4.4-3.5 7.9-7.9 7.9H281.6c-4.4 0-7.9-3.5-7.9-7.9v-15.6c0-4.4 3.5-7.9 7.9-7.9h15.6c4.4 0 7.9 3.6 7.9 7.9zm128.6-4H328.3c-1.8-14.1-12.9-25.3-27.1-27.1V223.2c14.1-1.8 25.2-12.9 27.1-27.1h105.4c1.8 14.1 13 25.2 27.1 27.1v105.4c-14.1 1.8-25.2 12.9-27.1 27.1zm54.6 4v15.6c0 4.4-3.5 7.9-7.9 7.9h-15.6c-4.4 0-7.9-3.5-7.9-7.9v-15.6c0-4.4 3.5-7.9 7.9-7.9h15.6c4.3 0 7.9 3.6 7.9 7.9zM480.4 200h-15.6c-4.4 0-7.9-3.5-7.9-7.9V176.5c0-4.4 3.5-7.9 7.9-7.9h15.6c4.4 0 7.9 3.5 7.9 7.9v15.6c0 4.4-3.6 7.9-7.9 7.9z"
  ]
}, lae = {
  prefix: "fak",
  iconName: "download",
  icon: [
    640,
    512,
    [],
    "e020",
    "M315.8 8.1A23.8 23.8 0 0 0 296.2 31.5l0 212.3-53.1-45.6a23.8 23.8 0 0 0 -30.9 36.1l92.4 79.2a23.8 23.8 0 0 0 30.9 0l92.4-79.2a23.8 23.8 0 0 0 -30.9-36.1l-53.2 45.6 0-212.3A23.8 23.8 0 0 0 315.8 8.1zM89 323.6A23.8 23.8 0 0 0 65.3 347.3l0 85.3a72.2 72.2 0 0 0 71.9 71.6l365 0a66.3 66.3 0 0 0 51.1-20.8 71.5 71.5 0 0 0 21.5-50.9l0-85.2a23.8 23.8 0 0 0 -23.8-23.8 23.8 23.8 0 0 0 -23.8 23.8l0 85.1a24.6 24.6 0 0 1 -24.7 24.4l-365.2 0a24.5 24.5 0 0 1 -24.5-24.2l0-85.3A23.8 23.8 0 0 0 89 323.6z"
  ]
}, cae = {
  prefix: "fak",
  iconName: "size",
  icon: [
    606,
    512,
    [],
    "e028",
    "M534.6 0L66.6 0C29.8 0 0 29.8 0 66.6L0 424c0 36.8 29.8 66.6 66.6 66.6l468 0c36.8 0 66.6-29.8 66.6-66.6l0-357.5C601.1 29.8 571.3 0 534.6 0zm24.7 424.3c0 13.7-11.2 24.7-24.7 24.7l-468 0c-13.7 0-24.7-11.2-24.7-24.7l0-357.7c0-13.7 11.2-24.7 24.7-24.7l468 0c13.7 0 24.7 11.2 24.7 24.7l0 357.5zM411 116.4l-94 0c-10.2 0-18.6 8.4-18.6 18.6s8.4 18.6 18.6 18.6l49.1 0-157.3 157.3 0-49.1c0-10.2-8.4-18.6-18.6-18.6s-18.6 8.4-18.6 18.6l0 94c0 1.9 .5 3.5 .9 5.1 0 .7 0 1.2 .5 1.9 1.9 4.7 5.6 8.4 10.2 10.2 .5 0 .9 0 1.4 .2 1.9 .5 3.7 1.2 5.6 1.2l94 0c10.2 0 18.6-8.4 18.6-18.6s-8.4-18.6-18.6-18.6l-49.1 0 157.3-157.3 0 49.1c0 10.2 8.4 18.6 18.6 18.6s18.6-8.4 18.6-18.6l0-94c0-10.2-8.4-18.6-18.6-18.6z"
  ]
}, uae = {
  prefix: "fak",
  iconName: "icon-ciconfig-italic",
  icon: [
    501,
    512,
    [],
    "e00a",
    "M232 296l-13.9 12.1-5.8 33.5h-29.8l28.1-162h29.8l-15.4 88.1 5.8-6.26 33.9-33.9h38.2l-49.9 49 31.7 65.1h-32.7l-20.3-45.5z"
  ]
}, dae = {
  prefix: "fak",
  iconName: "images",
  icon: [
    560,
    512,
    [],
    "e02a",
    "M403.7 511.9c-3.6 0-7.2-.5-10.8-1.5L29.7 410.8C8.2 405-4.5 382.6 1.4 361.2L50.3 183c1.3-4.7 6.2-7.5 10.8-6.2 4.7 1.3 7.5 6.1 6.2 10.8L18.5 365.8c-3.3 12.1 3.8 24.7 15.9 28l363.2 99.6c5.9 1.6 12 .8 17.3-2.2s9.1-7.9 10.7-13.8l21.8-79.7c1.3-4.7 6.1-7.5 10.8-6.2s7.5 6.1 6.2 10.8l-21.8 79.7c-2.9 10.4-9.6 19.1-19 24.4-6.2 3.5-13 5.3-20 5.3zM204.4 164.3c-24.8 0-45-20.2-45-45 0-12 4.6-23.3 13.2-31.8 8.5-8.5 19.8-13.2 31.8-13.2 24.8 0 45 20.2 45 45l0 0 0 0c0 12-4.6 23.3-13.2 31.8-8.5 8.5-19.8 13.2-31.8 13.2l0 0zm0-72.3c-7.3 0-14.2 2.8-19.4 8s-8 12-8 19.3c0 15.1 12.2 27.3 27.4 27.3l0 0c15.1 0 27.3-12.2 27.3-27.4l0 0c0-15.1-12.2-27.3-27.3-27.3zM526 0L123.2 0C108.1 0 95.9 12.2 95.9 27.3l0 316.1c0 15.1 12.2 27.3 27.3 27.3l402.9 0c15.1 0 27.3-12.2 27.3-27.3l0-316.1C553.4 12.2 541.1 0 526.1 0zM123.2 17.7l402.9 0c5.3 0 9.7 4.3 9.7 9.7l0 230.8-119.8-119.8c-3.3-3.3-9.2-3.3-12.5 0L288.5 253.2 236.3 201c-1.6-1.6-3.9-2.6-6.3-2.6s-4.6 1-6.2 2.6l-110.1 113 0-286.7c0-5.3 4.3-9.7 9.7-9.7zM526 353l-402.8 0c-5.3 0-9.7-4.3-9.7-9.7l0-4 116.5-119.6 52.2 52.2c3.3 3.3 9.2 3.3 12.5 0l114.9-114.9 126.1 126 0 60.4c0 5.3-4.3 9.7-9.7 9.7z"
  ]
}, pae = {
  prefix: "fak",
  iconName: "resize",
  icon: [
    448,
    512,
    [],
    "e003",
    "M249.2 275.5c4.7-4.7 12.3-4.7 17 0L416 425.4V364c0-6.6 5.4-12 12-12h8c6.6 0 12 5.4 12 12v104c0 6.6-5.4 12-12 12H332c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h61.4L243.5 298.1c-4.7-4.7-4.7-12.3 0-17l5.7-5.6zM0 44v104c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12V86.6l149.9 149.9c4.7 4.7 12.3 4.7 17 0l5.7-5.7c4.7-4.7 4.7-12.3 0-17L54.6 64H116c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12H12C5.4 32 0 37.4 0 44z"
  ]
}, mae = {
  prefix: "fak",
  iconName: "icon-edit",
  icon: [
    512,
    512,
    [],
    "e00e",
    "M480 47.1 455 21.7a78.5 78.5 0 0 0 -108 0L317 51.1 48.7 320 48.6 320l-.158 .159a18.2 18.2 0 0 0 -4.32 7.32c-.093 .273-.352 .442-.432 .721L.71 478a18.6 18.6 0 0 0 23 23L174 458c.279-.079 .448-.338 .72-.432a18.2 18.2 0 0 0 7.33-4.32l.158-.159 .011-.011L451 185 480 155a76.6 76.6 0 0 0 0-108zM45.7 456l25.1-87.8L134 431zm123-42.3L88 333 330 90.6 411 172zM454 129l-16.3 16.3L357 64.3l16.2-16.3a40.4 40.4 0 0 1 55.7 0l25.4 25.4a39.4 39.4 0 0 1 0 55.7z"
  ]
}, hae = {
  prefix: "fak",
  iconName: "icon-design-database",
  icon: [
    512,
    512,
    [],
    "e021",
    "M492.8 364.8c-9.6 0-19.2-9.6-19.2-19.2V86.4c0-12.8-9.6-19.2-22.4-19.2H182.4c-9.6-3.2-19.2-9.6-19.2-19.2s9.6-19.2 19.2-19.2h272c28.8 0 57.6 25.6 57.6 54.4l0 262.4c0 9.6-9.6 19.2-19.2 19.2zM377.6 102.4h-320C25.6 102.4 0 128 0 160v265.6c0 32 25.6 57.6 57.6 57.6h320c32 0 57.6-25.6 57.6-57.6V160c0-32-25.6-57.6-57.6-57.6zM35.2 160c0-12.8 9.6-22.4 22.4-22.4h320c12.8 0 22.4 9.6 22.4 22.4v25.6H35.2V160zM400 220.8v121.6l-64-80c-3.2-3.2-9.6-6.4-12.8-6.4c-6.4 0-12.8 3.2-16 6.4L217.6 368l-70.4-64c-6.4-6.4-16-6.4-22.4 0l-89.6 70.4V220.8H400zM377.6 448h-320c-12.8 0-22.4-9.6-22.4-22.4v-3.2l99.2-80 73.6 64c3.2 3.2 9.6 6.4 12.8 3.2c6.4 0 9.6-3.2 12.8-6.4L320 304l76.8 99.2v22.4c3.2 12.8-6.4 22.4-19.2 22.4zm-176-150.4c-9.6 0-19.2-6.4-19.2-19.2c0-9.6 9.6-19.2 19.2-19.2s19.2 9.6 19.2 19.2c0 12.8-9.6 19.2-19.2 19.2zm0-28.8l0 9.6s0 0 0 0l0-9.6z"
  ]
}, fae = {
  prefix: "fak",
  iconName: "icon-size-small",
  icon: [
    237,
    512,
    [],
    "e016",
    "M119 190a41.4 41.4 0 1 0 -41.4-41.4A41.4 41.4 0 0 0 119 190zm0-68.5A27.2 27.2 0 1 1 91.5 148 27.2 27.2 0 0 1 119 121zM194 245a54.3 54.3 0 0 0 -7.26-29 35.1 35.1 0 0 0 -27.9-17.1 75.1 75.1 0 0 0 -17.8 2.31 107 107 0 0 1 -22.2 2.94 84.5 84.5 0 0 1 -22.3-2.93 74.1 74.1 0 0 0 -17.7-2.32 35.1 35.1 0 0 0 -27.9 17.1 54.2 54.2 0 0 0 -7.25 29c-.623 12.7-1.95 87.9-2.02 91.2a23 23 0 0 0 22.9 22.9 22.7 22.7 0 0 0 8.13-1.56c-.706 35.1-1.45 73.7-1.99 107a27.5 27.5 0 0 0 48.1 18.3A27.5 27.5 0 0 0 167 464c-.692-42.8-1.39-74.2-2.08-106l-.023-1.03a22.7 22.7 0 0 0 8.26 1.6 23 23 0 0 0 22.9-23.1C196 333 194 258 194 245zM173 345a8.75 8.75 0 0 1 -8.73-8.6c-.535-24.5-1.07-50.6-1.6-83.3a7.09 7.09 0 0 0 -7.08-6.98l-.115 .008a7.08 7.08 0 0 0 -6.97 7.2c.527 32.5 1.06 58.4 1.58 82.8-.002 .053-.031 .097-.031 .15 0 .145 .04 .279 .042 .424 .163 7.52 .327 14.9 .488 22.3 .7 31.4 1.39 62.8 2.08 105a13.4 13.4 0 1 1 -26.8 0V359a7.09 7.09 0 0 0 -14.2 0V464a13.4 13.4 0 0 1 -26.8 .115c.608-36.9 1.46-80.8 2.24-119a7.07 7.07 0 0 0 .377-2.18L88.8 253a7.08 7.08 0 0 0 -6.96-7.21l-.123-.008a7.09 7.09 0 0 0 -7.08 6.97L74.4 265c-.304 14.1-.881 41-1.53 72.7A8.68 8.68 0 0 1 55.5 336c.015-.777 1.38-78.2 2-90.7a41.1 41.1 0 0 1 5.03-22.1 21.3 21.3 0 0 1 16.5-10.6 59.9 59.9 0 0 1 14.2 2.02 120 120 0 0 0 25.2 3.24 119 119 0 0 0 25-3.25 63.2 63.2 0 0 1 14.4-2.02A21.3 21.3 0 0 1 174 224a41.2 41.2 0 0 1 5.04 22.1c.608 12.4 1.98 89.9 1.98 90.5A8.77 8.77 0 0 1 173 345z"
  ]
}, _ae = {
  prefix: "fak",
  iconName: "icon-ciconfig-alert-warning",
  icon: [
    512,
    512,
    [],
    "e01b",
    "M256 0A256 256 0 1 0 256 512A256 256 0 1 0 256 0zM256 398c-14.1 0-25.6-11.5-25.6-25.6s11.3-25.6 25.4-25.6h0c14.1 0 25.6 11.5 25.6 25.6s-11.5 25.6-25.6 25.6zM256 300c-11.7 0-21.3-9.6-21.3-21.3v-.427c0-5.76 0-132 0-138v-.427c0-11.7 9.6-21.3 21.3-21.3 21.3 0 21.3 16.2 21.3 42.9v95.1c0 26.9 0 42.9-21.3 42.9z"
  ]
}, vae = {
  prefix: "fak",
  iconName: "icon-zoom-in",
  icon: [
    512,
    512,
    [],
    "e01d",
    "M439.9 507.3c-16.3 0-30.3-7-41.9-18.6L230.4 321.2c-9.3-9.3-9.3-20.9 0-30.3s20.9-9.3 30.3 0l167.6 167.6c7 7 20.9 7 27.9 0s7-20.9 0-27.9L288.6 263c-7-9.3-7-20.9 0-30.3c9.3-7 20.9-7 27.9 0l167.6 167.6c23.3 23.3 23.3 62.8 0 86.1c-14 14-27.9 20.9-44.2 20.9M172.2 360.7l0 0C72.1 356.1-4.7 272.3 0 172.2S88.4-4.7 188.5 0c95.4 4.7 172.2 83.8 172.2 181.5c0 2.3 0 4.7 0 9.3c0 11.6-9.3 20.9-20.9 20.9s-20.9-9.3-20.9-20.9l0 0c0-2.3 0-4.7 0-7c0-76.8-62.8-139.6-139.6-139.6S39.6 107.1 39.6 183.9c0 74.5 58.2 135 132.7 137.3c11.6 0 20.9 9.3 20.9 20.9s-9.3 18.6-20.9 18.6m65.2-207.1H200.1V116.4c0-11.6-9.3-20.9-20.9-20.9s-20.9 9.3-20.9 20.9v37.2H121c-11.6 0-20.9 9.3-20.9 20.9s9.3 20.9 20.9 20.9h37.2v37.2c0 11.6 9.3 20.9 20.9 20.9s20.9-9.3 20.9-20.9l0 0V195.5h37.2c11.6 0 20.9-9.3 20.9-20.9s-9.3-20.9-20.9-20.9"
  ]
}, gae = {
  prefix: "fak",
  iconName: "smake",
  icon: [
    410,
    512,
    [],
    "e002",
    "M406.173 273.588c5.21 13.328 1.202 15.734-7.817 8.017-45.899-39.385-134.088-34.474-175.377 5.311-16.636 16.135-17.838 29.364-25.755 28.462-4.31-.502-4.41-6.815-3.408-14.532 12.227-94.503 183.695-100.716 212.357-27.258zM377.01 33.17c11.324 9.12 8.618 20.645 4.61 32.971-13.83 42.291-41.79 72.756-84.281 87.789-12.226 4.309-19.743.801-9.22-8.018 43.093-36.077 52.112-55.318 64.338-107.731 2.706-11.324 17.438-10.823 24.553-5.01zM268.377 18.44c-1.303-2.706-10.824-19.643 3.006-18.34 37.08 3.608 46.7 39.184 43.293 71.153-3.107 28.662-19.542 54.317-40.788 73.157-10.222 9.12-13.228 1.704-9.22-5.411 22.85-39.886 23.551-79.772 3.709-120.56zm-99.514-8.82c30.465-1.503 64.739 19.442 80.272 45.198 15.734 25.855 15.333 60.33 3.708 89.191-3.708 9.22-14.43 17.338-12.527 2.406 6.514-51.41-31.868-98.211-78.87-111.74-26.055-7.517-26.155-23.45 7.417-25.054zM12.026 381.42c44.195-3.809 87.788-24.854 115.448-45.198 11.224-8.217 15.132-4.51 9.921 7.316C122.363 377.311 75.562 420.704 33.672 419c-18.64-.802-51.51-34.975-21.646-37.58zm95.806 103.622c-25.455 3.107-69.45-15.132-28.862-34.474 37.981-18.139 60.53-56.622 72.355-97.51 4.109-14.23 16.035-20.944 17.838 9.621 2.606 43.293-8.819 115.95-61.331 122.363zm55.82-187.503c-5.813-38.182 2.004-77.466 42.49-100.816 16.637-9.621 15.033-14.03-1.703-11.525-43.994 6.514-78.87 32.77-89.091 74.86-11.325 47.002-41.59-8.918-26.657-38.382 23.55-46.3 72.455-49.807 115.047-54.417 16.535-1.804 2.806-8.919-6.414-12.927C144.41 131.382 79.67 139.5 52.112 197.524c-5.512 11.625-15.333 8.619-16.235-2.204-4.41-48.605 34.173-76.765 73.057-80.874 36.478-3.808 62.434 9.02 84.482 20.143 15.934 8.118 21.546 6.113.4-19.642-32.47-39.685-87.387-48.905-132.184-11.625-10.121 8.418-25.655 17.437-19.742-1.203 1.704-5.311 6.514-15.433 17.838-25.955 61.533-57.123 137.195-22.048 162.55 40.386 11.424 28.06 4.209 39.285 13.428 51.712 11.926 16.134 39.084 4.91 79.772 18.64 25.154 8.518 34.273 24.452 11.725 18.139-56.12-15.634-142.306 7.315-150.423 87.989-1.303 13.629-10.823 19.542-13.128 4.51zm87.287 187.002c-9.72 34.274-84.982 34.775-70.652 10.623 26.557-44.897 24.453-91.397 7.516-129.178-11.925-26.757-6.413-30.966 6.414-23.35 48.705 28.962 72.255 87.588 56.722 141.905zm158.54-128.877c-1.803 28.361-16.635 59.428-23.95 32.27-15.233-56.422-76.966-96.107-141.304-67.546-15.534 6.915-10.423 9.721 4.71 11.024 70.05 6.213 100.015 52.312 103.021 100.215 1.604 25.856-14.531 42.291-35.476 51.912-16.536 7.516-25.856 7.316-20.845-14.932 13.429-59.628-19.542-100.216-71.654-124.568-16.736-7.817-28.46-10.021 1.203-32.169 36.077-26.958 83.178-34.574 123.365-22.148 31.367 9.621 63.236 29.865 60.93 65.942z"
  ]
}, kae = {
  prefix: "fak",
  iconName: "icon-arrow-circle-grey-right",
  icon: [
    512,
    512,
    [],
    "e005",
    "M256 0A256 256 0 1 0 256 512A256 256 0 1 0 256 0zM228 352a10.2 10.2 0 0 1 -7.48-17.2l73.1-78.3-73.1-78.3a10.2 10.2 0 1 1 15-14l79.6 85.3a10.2 10.2 0 0 1 0 14l-79.6 85.3A10.2 10.2 0 0 1 228 352z"
  ]
}, yae = {
  prefix: "fak",
  iconName: "icon-save",
  icon: [
    512,
    512,
    [],
    "e01e",
    "m504.3 135.9L375 6.7C370.7 2.3 364.8 0 358.7 0H74.8C33.5 0 0 33.5 0 74.8v361.5C0 477.4 33.5 511 74.8 511h361.7c41.2 0 74.5-33.5 74.8-74.5V152.1c0-6.1-2.3-12-6.7-16.4zm-142.8 329H149.2V304.4h212.2v160.5zm103.4-28.4c0 15.9-12.8 28.4-28.7 28.4h-28.7V281.3c0-12.8-10.2-23-23-23H126.2c-12.8 0-23 10.2-23 23v183.6H74.5c-15.9 0-28.7-12.8-28.7-28.7V74.8c0-15.9 12.8-28.7 28.7-28.7h28.7v106c0 12.8 10.2 23 23 23h206.6c12.8 0 23-10.2 23-23s-10.2-23-23-23H149.2V46.1h199.9l115.7 115.7v274.7z"
  ]
}, bae = {
  prefix: "fak",
  iconName: "icon-close-medium",
  icon: [
    512,
    512,
    [],
    "e00c",
    "M256 11.4A245 245 0 1 1 11.4 256 245 245 0 0 1 256 11.4m0-11.4A256 256 0 1 0 512 256 256 256 0 0 0 256 0zM270 256l78.1-78.1A10.2 10.2 0 0 0 334 163l-78.1 78.1L178 163A10.2 10.2 0 0 0 163 178l78.1 78.1L163 334a10.2 10.2 0 1 0 14.5 14.5l78.1-78.1L334 349A10.2 10.2 0 0 0 349 334z"
  ]
}, wae = {
  prefix: "fak",
  iconName: "image",
  icon: [
    606,
    512,
    [],
    "e02b",
    "M534.6 0L66.6 0C29.8 0 0 29.8 0 66.6L0 424c0 36.8 29.8 66.6 66.6 66.6l468 0c36.8 0 66.6-29.8 66.6-66.6l0-357.5C601.1 29.8 571.3 0 534.6 0zM66.6 41.9l468 0c13.7 0 24.7 11.2 24.7 24.7l0 251.1-137.3-137.3c-7.2-7.2-19.1-7.2-26.3 0l-141 141-61.2-61.2c-3.5-3.5-8.1-5.4-13.3-5.4l0 0c-4.9 0-9.8 2.1-13.3 5.6l-125 128.2 0-322.1c0-13.7 11.2-24.7 24.7-24.7zm468 407l-468 0c-8.8 0-16.1-4.9-20.5-11.6l134.3-137.5 61 61c7.2 7.2 19.1 7.2 26.3 0l141-141 150.6 150.6 0 53.8c0 13.7-11.2 24.7-24.7 24.7zM147.8 216.4a64.7 64.7 0 1 0 0-129.4 64.7 64.7 0 1 0 0 129.4zm0-37a27.5 27.5 0 1 1 0-54.9 27.5 27.5 0 1 1 0 54.9z"
  ]
}, xae = {
  prefix: "fak",
  iconName: "icon-ciconfig-bar-arrow",
  icon: [
    512,
    512,
    [],
    "e008",
    "M256 0C115 0 0 115 0 256s115 256 256 256 256-115 256-256h0C512 115 397 0 256 0h0zM223 370c-4.78 0-9.9-1.71-13.7-5.12-8.53-7.51-9.22-20.5-1.37-29l72-79.9-72-79.9c-7.51-8.53-6.83-21.5 1.37-29 8.19-7.51 21.2-6.83 29 1.37l84.3 93.5c7.17 7.85 7.17 19.5 0 27.3l-84.3 93.5c-4.1 4.44-9.56 6.83-15.4 6.83z"
  ]
}, $ae = {
  prefix: "fak",
  iconName: "icon-x",
  icon: [
    512,
    512,
    [],
    "e01a",
    "M306 260l204-204A32.9 32.9 0 0 0 463 9.64L260 213 56.2 9.64A32.9 32.9 0 0 0 9.64 56.2L213 260 9.64 463a32.9 32.9 0 1 0 46.5 46.5L260 306l204 204a32.9 32.9 0 0 0 46.5-46.5z"
  ]
}, zae = {
  prefix: "fak",
  iconName: "icon-expander-small-open",
  icon: [
    1110,
    512,
    [],
    "e012",
    "M546 538a76.6 76.6 0 0 1 -48.6-17.4l-469-384A76.8 76.8 0 1 1 126 17.3L546 362 967 17.3A76.8 76.8 0 1 1 1064 136l-469 384A76.6 76.6 0 0 1 546 538z"
  ]
}, Sae = {
  prefix: "fak",
  iconName: "icon-text-alignment",
  icon: [
    512,
    512,
    [],
    "e024",
    "M351.7 512H160c-4.5-9-6.4-18.9-6.1-29.1c-.3-9.9 1.6-19.5 5.8-28.5h34.6c12.8 1 24-8.3 25-21.1c0-1.3 0-2.6 0-3.8V85.1c1.6-13.4-8.3-25.9-21.8-27.2c-1.3 0-2.6-.3-3.8 0H136.3c-19.8-1.3-37.1 13.8-38.4 33.6c0 .6 0 1 0 1.6c-1.9 19.5-1.6 39 .6 58.6C88 157.4 76.5 160 64.6 160c-10.6 .6-20.8-2.2-29.4-8c-2.6-40-2.9-80.3-1-120.3c1-18.2 4.2-25 6.4-27.2C47 1 54.4-.3 61.8 .6h389.8c7.4-1 14.7 .3 21.4 3.5c1.9 1.9 5.1 7.7 6.1 26.6c1.9 40.3 1.9 80.6-.3 120.6c-9.9 5.8-21.1 8.3-32.3 8c-11.2 .3-22.1-2.2-32-7.4c1.9-19.8 2.2-39.7 1-59.2v-.6c-1-19.8-17.9-34.9-37.4-33.9h-57.3C307.2 57 295.4 66.6 293.8 80c-.3 1.9 0 3.5 0 5.4v344.3c-1 12.8 8.6 24 21.4 25c1.3 0 2.6 0 3.8 0h34.2c4.2 9 6.1 18.6 5.8 28.5c-1 9.6-2.9 19.5-7.4 28.8z"
  ]
}, Aae = {
  prefix: "fak",
  iconName: "icon-size-stout",
  icon: [
    237,
    512,
    [],
    "e017",
    "M119 190a41.4 41.4 0 1 0 -41.4-41.4A41.4 41.4 0 0 0 119 190zm0-68.5A27.2 27.2 0 1 1 91.5 148 27.2 27.2 0 0 1 119 121zM203 229a43.3 43.3 0 0 0 -31.8-28.8 85.5 85.5 0 0 0 -27.2 1.67 165 165 0 0 1 -25.3 2.66h-.185a168 168 0 0 1 -25.3-2.66 86.9 86.9 0 0 0 -27.5-1.67 43.3 43.3 0 0 0 -31.8 28.8 223 223 0 0 0 -9.93 68 237 237 0 0 0 4.85 44.6 22.3 22.3 0 0 0 37.5 10.1c-.415 21.9-.904 45.6-1.34 66.6l-.861 42.7a30.6 30.6 0 0 0 54.3 19.4A30.6 30.6 0 0 0 173 461c-.208-11.4-.538-27.2-.9-44.8-.419-20.4-.885-43.2-1.28-64.3a22.3 22.3 0 0 0 37.5-10.3 238 238 0 0 0 4.79-44.4A223 223 0 0 0 203 229zm-4.25 67.7a224 224 0 0 1 -4.41 41.4 8.08 8.08 0 0 1 -7.85 6.09 7.99 7.99 0 0 1 -7.88-7.03A76.2 76.2 0 0 0 186 305a161 161 0 0 0 -13.6-58 7.06 7.06 0 0 0 -9.54-2.82 7.13 7.13 0 0 0 -2.92 9.58A147 147 0 0 1 172 305a66.7 66.7 0 0 1 -12.5 38.1c-.731 1.12-1.33 2.03-1.74 2.74l-1 1.72 .039 1.98c.408 21.8 .9 45.6 1.34 66.9 .362 17.6 .685 33.4 .892 44.7a16.5 16.5 0 1 1 -33.1 0V350a7.09 7.09 0 1 0 -14.2 0V461a16.5 16.5 0 0 1 -33.1 .131l.862-42.5c.454-21.8 .962-46.6 1.38-69.2l.038-1.98-1-1.72c-.408-.708-1.01-1.62-1.74-2.74A66.7 66.7 0 0 1 65.4 305a147 147 0 0 1 11.9-51.3 7.09 7.09 0 0 0 -12.5-6.77A161 161 0 0 0 51.2 305a76.2 76.2 0 0 0 7.18 32.3 8.02 8.02 0 0 1 -15.7 1.12 223 223 0 0 1 -4.46-41.6 211 211 0 0 1 8.84-62.2 29.6 29.6 0 0 1 21.4-20.3 81.1 81.1 0 0 1 22.7 1.74 182 182 0 0 0 27.5 2.84h.215a178 178 0 0 0 27.5-2.84 79.5 79.5 0 0 1 22.4-1.74 29.6 29.6 0 0 1 21.4 20.3A211 211 0 0 1 199 297z"
  ]
}, Cae = {
  prefix: "fak",
  iconName: "icon-size-tall",
  icon: [
    237,
    512,
    [],
    "e018",
    "M118 103a41.4 41.4 0 1 0 -41.4-41.4A41.4 41.4 0 0 0 118 103zm0-68.5a27.2 27.2 0 1 1 -27.2 27.2A27.2 27.2 0 0 1 118 34.3zM189 282c-.035-3.16-.119-12.7-.223-25.1-.285-32.8-.754-87.6-1.04-97.4a55.8 55.8 0 0 0 -5.75-28.6A35 35 0 0 0 160 114a44.8 44.8 0 0 0 -22.4 1.84c-1.02 .277-1.95 .523-2.75 .715a95.1 95.1 0 0 1 -16.6 1.94 110 110 0 0 1 -16.5-1.94c-.808-.192-1.74-.438-2.76-.715a44.7 44.7 0 0 0 -22.4-1.84 35 35 0 0 0 -21.8 17.1 55.8 55.8 0 0 0 -5.75 28.6c-.288 9.82-.758 64.7-1.04 97.4-.104 12.4-.188 21.9-.223 25.1l-.004 .223V283A21.8 21.8 0 0 0 77.1 303L74.4 466a25.6 25.6 0 0 0 44.1 17.6 25.6 25.6 0 0 0 44.1-17.8l-2.62-163a21.8 21.8 0 0 0 29.1-20.5zm-21.8 7.85a7.64 7.64 0 0 1 -7.63-7.62q0-.196-.012-.392l-1.82-113a7.09 7.09 0 0 0 -7.08-6.98l-.119 .008a7.09 7.09 0 0 0 -6.97 7.2l4.77 297a11.4 11.4 0 0 1 -22.8 0V297a7.09 7.09 0 1 0 -14.2 0V466a11.4 11.4 0 0 1 -22.8 .046l4.77-297A7.09 7.09 0 0 0 86.4 162l-.119-.008a7.09 7.09 0 0 0 -7.08 6.98l-1.82 113c-.008 .146-.012 .3-.012 .446a7.63 7.63 0 0 1 -15.3 .092c.038-3.02 .119-12.6 .231-25.3 .281-32.7 .75-87.5 1.03-97.2a42.8 42.8 0 0 1 4.12-22.3 20.8 20.8 0 0 1 13-10.1 34.9 34.9 0 0 1 15 1.85c1.18 .315 2.25 .608 3.19 .823a101 101 0 0 0 19.9 2.32 110 110 0 0 0 19.7-2.32c.927-.215 2-.508 3.18-.823a35 35 0 0 1 15-1.85 20.8 20.8 0 0 1 13 10.1 42.8 42.8 0 0 1 4.12 22.3c.281 9.68 .75 64.4 1.03 97.2 .112 12.6 .192 22.3 .231 25.3A7.64 7.64 0 0 1 167 290z"
  ]
}, Pae = {
  prefix: "fak",
  iconName: "icon-zoom-out",
  icon: [
    512,
    512,
    [],
    "e01c",
    "M439.9 507.3c-16.3 0-30.3-4.7-41.9-18.6L230.4 321.2c-9.3-9.3-9.3-20.9 0-30.3s20.9-9.3 30.3 0l167.6 167.6c7 7 18.6 7 25.6 0s7-18.6 0-25.6L286.3 265.3c-9.3-9.3-9.3-20.9 0-30.3s20.9-9.3 30.3 0l167.6 167.6c23.3 23.3 23.3 62.8 0 86.1c-14 11.6-30.3 18.6-44.2 18.6l0 0zM172.2 360.7s0 0 0 0C74.5 356.1 0 276.9 0 181.5S81.5 0 181.5 0s181.5 81.5 181.5 181.5c0 2.3 0 4.7 0 9.3c-2.3 9.3-14 18.6-23.3 18.6c-11.6 0-20.9-9.3-20.9-20.9c0-2.3 0-4.7 0-7c0-76.8-62.8-139.6-139.6-139.6S39.6 104.7 39.6 181.5s58.2 135 132.7 137.3c11.6 0 20.9 9.3 20.9 20.9s-9.3 20.9-20.9 20.9zm65.2-165.2H121c-11.6 0-20.9-9.3-20.9-20.9s9.3-20.9 20.9-20.9h116.4c11.6 0 20.9 9.3 20.9 20.9s-9.3 20.9-20.9 20.9z"
  ]
}, Mae = {
  prefix: "fak",
  iconName: "icon-ciconfig-bar-check",
  icon: [
    512,
    512,
    [],
    "e009",
    "M256 0C115 0 0 115 0 256s115 256 256 256 256-115 256-256h0C512 115 397 0 256 0h0zM221 362c-5.46 0-10.6-2.05-14.3-6.14l-81.9-81.9c-7.85-7.85-7.85-20.8 0-29 7.85-7.85 20.8-7.85 29 0l66.6 66.6 138-156c7.51-8.53 20.5-9.22 29-1.71 8.53 7.51 9.22 20.5 1.71 29l-152 172c-3.75 4.1-9.22 6.83-14.7 6.83h-.683z"
  ]
}, Tae = {
  prefix: "fak",
  iconName: "icon-size-default",
  icon: [
    237,
    512,
    [],
    "e015",
    "M119 150a41.4 41.4 0 1 0 -41.4-41.4A41.4 41.4 0 0 0 119 150zm0-68.5a27.2 27.2 0 1 1 -27.2 27.2A27.2 27.2 0 0 1 119 81.4zM194 205a54.4 54.4 0 0 0 -7.26-29 35.1 35.1 0 0 0 -27.9-17.1 74.1 74.1 0 0 0 -17.8 2.31 107 107 0 0 1 -22.2 2.94 101 101 0 0 1 -22.3-2.93 73.6 73.6 0 0 0 -17.7-2.32 35.1 35.1 0 0 0 -27.9 17.1A54.5 54.5 0 0 0 43.4 205c-.608 12.7-1.95 94.6-2.01 98.2a22.8 22.8 0 0 0 31.4 21.3c-.8 47.6-1.69 101-2.33 140A27.6 27.6 0 0 0 119 483a27.6 27.6 0 0 0 48.1-18.5c-.715-44.1-1.43-86.4-2.15-129l-.181-10.8a22.7 22.7 0 0 0 8.48 1.67 23 23 0 0 0 22.9-23.1C196 300 194 218 194 205zM173 312a8.77 8.77 0 0 1 -8.75-8.76c0-.164-.083-.301-.092-.463L162 215a7.09 7.09 0 0 0 -7.08-6.98l-.115 .008a7.08 7.08 0 0 0 -6.97 7.2l2.02 121c.723 42.3 1.44 84.5 2.15 129a13.4 13.4 0 0 1 -26.8 0V319a7.09 7.09 0 1 0 -14.2 0v145a13.4 13.4 0 0 1 -26.8 .115c1.35-82.3 3.91-233 4.17-248l.016-1.1a7.08 7.08 0 0 0 -6.95-7.21l-.131-.008a7.09 7.09 0 0 0 -7.08 6.96v.008l-.008 .023c0 .146-.008 .446-.016 .885L73.1 303l.004 .069-.012 .054a8.76 8.76 0 0 1 -17.5 .115c.016-.854 1.39-85.2 1.99-97.6a41.3 41.3 0 0 1 5.03-22.1 21.4 21.4 0 0 1 16.5-10.6 59.7 59.7 0 0 1 14.2 2.02 108 108 0 0 0 25.3 3.24 119 119 0 0 0 25-3.25 58.3 58.3 0 0 1 14.4-2.02 21.3 21.3 0 0 1 16.5 10.6 41.2 41.2 0 0 1 5.03 22.1c.608 12.4 1.98 96.8 1.99 97.5A8.77 8.77 0 0 1 173 312z"
  ]
}, Iae = {
  prefix: "fak",
  iconName: "icon-arrow-circle-grey-left",
  icon: [
    512,
    512,
    [],
    "e004",
    "M256 0A256 256 0 1 0 256 512A256 256 0 1 0 256 0zM284 352a10.2 10.2 0 0 1 -7.48-3.26l-79.6-85.3a10.2 10.2 0 0 1 0-14l79.6-85.3a10.2 10.2 0 1 1 15 14L219 256l73.1 78.3a10.2 10.2 0 0 1 -7.48 17.2z"
  ]
}, Eae = {
  prefix: "fak",
  iconName: "customer-logos",
  icon: [
    649,
    512,
    [],
    "e02c",
    "M553.3 7.9c-6.1-5.5-13.7-8.2-22.2-7.9-8.2 .3-15.7 4.1-21.2 10.2l-200.4 226.3-96.3-96.3c-11.9-11.9-31.4-11.9-43.3 0s-11.9 31.4 0 43.3L289.5 303.1c5.8 5.8 13.7 8.9 21.8 8.9l.7 0 0 0c8.5 0 16.4-4.1 22.2-10.2L556.4 51.2c11.3-12.6 10.2-32.1-2.7-43.3zm61.1 253.3c-16.7 0-30 13.3-30 30l0 107.5c0 17.1-14.3 30.7-31.4 30.7l-461.8 0c-17.1 0-30.7-13.7-31.1-30.7l0-107.5c0-16.7-13.3-30-30-30s-30 13.3-30 30L0 399c.3 50.2 41 90.5 90.8 90.5l461.8 0c24.2 1 47.8-8.5 64.5-26.3 17.4-17.1 27.3-40.3 27.3-64.5l0-107.9c0-16.7-13.3-30-30-30z"
  ]
}, Oae = {
  prefix: "fak",
  iconName: "saved-designs",
  icon: [
    602,
    512,
    [],
    "e029",
    "M530.9 88.8l-236 0-74.1-72.8c-10.5-10.2-24.3-16-39-16L55.4 0C24.9 0 0 24.9 0 55.4l0 388c0 26.9 22 49 49 49l481.9 0c26.9 0 49-22 49-49l0-305.6c0-26.9-22-49-49-49zM40.1 55.4c0-8.5 6.9-15.4 15.4-15.4l126.7 0c4 0 8 1.6 10.9 4.5l45 44.3-197.9 0 0-33.4zM540 443.7c0 4.9-4 8.9-8.9 8.9L49 452.6c-4.9 0-8.9-4-8.9-8.9l0-314.8 490.9 0c4.9 0 8.9 4 8.9 8.9l0 305.6zM220.8 410.9c-3.3 0-6.5-1.1-9.1-2.9-4.9-3.6-7.1-9.3-6.2-15.1l11.8-69-50.1-49c-4.2-4.2-5.8-10.2-4-16 1.8-5.6 6.7-9.8 12.5-10.7l69.2-10 30.9-62.8c5.3-10.7 22.7-10.7 28 0l30.9 62.8 69.2 10c5.8 .9 10.7 4.9 12.5 10.7 1.8 5.6 .2 11.8-4 16l-50.1 49 11.8 69c.9 5.8-1.3 11.8-6.2 15.1-4.9 3.6-11.1 4-16.5 1.1l-62.1-32.5-62.1 32.5c-2.2 1.1-4.7 1.8-7.3 1.8zm69.2-67.7c2.4 0 4.9 .7 7.3 1.8l41.4 21.8-7.8-46.1c-.9-5.1 .9-10.2 4.5-13.8l33.4-32.5-46.3-6.7c-5.1-.7-9.6-4-11.8-8.5l-20.7-41.9-20.7 41.9c-2.2 4.7-6.7 7.8-11.8 8.5l-46.3 6.7 33.4 32.5c3.8 3.6 5.3 8.7 4.5 13.8l-7.8 46.1 41.4-21.8c2.2-1.1 4.7-1.8 7.3-1.8z"
  ]
}, Rae = {
  prefix: "fak",
  iconName: "icon-close-small",
  icon: [
    512,
    512,
    [],
    "e00d",
    "M256 12.8A243 243 0 1 1 12.8 256 243 243 0 0 1 256 12.8m0-12.8A256 256 0 1 0 512 256 256 256 0 0 0 256 0zM272 256 347 181a11.5 11.5 0 0 0 -16.3-16.3l-75.1 75.1L181 165A11.5 11.5 0 0 0 165 181l75 75-75 75.1A11.5 11.5 0 1 0 181 347l75.1-75.1L331 347A11.5 11.5 0 0 0 347 331z"
  ]
}, Lae = {
  prefix: "fak",
  iconName: "icon-ciconfig-archive",
  icon: [
    566,
    512,
    [],
    "e006",
    "M343 291h-123c-13.5 0-24.3-10.8-24.3-24.3s10.8-24.3 24.3-24.3h123c13.5 0 24.3 10.8 24.3 24.3s-10.8 24.3-24.3 24.3zM508 0H51.3C23 0 .053 22.9 .053 51.2v57.7c0 24.8 17.8 45.5 41.5 50.1V428c0 43.1 35 78.1 78.1 78.1h320c43.1 0 78.1-35 78.1-78.1V159c23.7-4.58 41.5-25.3 41.5-50.1V51.2c0-28.3-22.9-51.2-51.2-51.2zM48.6 51.2c0-1.35 1.08-2.69 2.69-2.69H508c1.35 0 2.69 1.08 2.69 2.69v57.7c0 1.35-1.08 2.69-2.69 2.69H51.3c-1.35 0-2.69-1.08-2.69-2.69V51.2zm391 407H120c-16.4 0-29.6-13.2-29.6-29.6V160h379V428c0 16.4-13.2 29.6-29.6 29.6z"
  ]
}, Dae = {
  prefix: "fak",
  iconName: "icon-ciconfig-areaonoff",
  icon: [
    512,
    512,
    [],
    "e007",
    "M251 321c-31.3 0-56.6-25.3-56.6-56.6s25.3-56.6 56.6-56.6 56.6 25.3 56.6 56.6-25.3 56.6-56.6 56.6zm0-80.8c-13.5 0-24.3 10.8-24.3 24.3s10.8 24.3 24.3 24.3 24.3-10.8 24.3-24.3-10.8-24.3-24.3-24.3zM251 384c-97 0-182-74.9-182-120s85.2-120 182-120 182 74.9 182 120-85.2 120-182 120zm0-208c-86 0-150 67.1-150 87.6s63.9 87.6 150 87.6 150-67.1 150-87.6-63.9-87.6-150-87.6zM21.6 178c-11.9 0-21.6-9.7-21.6-21.6V75.5C0 34 34 0 75.5 0h71.9c11.9 0 21.6 9.7 21.6 21.6s-9.7 21.6-21.6 21.6H75.5c-17.8 0-32.3 14.6-32.3 32.3v80.8c0 11.9-9.7 21.6-21.6 21.6zM147 501H75.5c-41.5 0-75.5-34-75.5-75.5v-53.9c0-11.9 9.7-21.6 21.6-21.6s21.6 9.7 21.6 21.6v53.9c0 17.8 14.6 32.3 32.3 32.3h71.9c11.9 0 21.6 9.7 21.6 21.6s-9.7 21.6-21.6 21.6zM426 501h-62.8c-11.9 0-21.6-9.7-21.6-21.6s9.7-21.6 21.6-21.6h62.8c17.8 0 32.3-14.6 32.3-32.3v-53.9c0-11.9 9.7-21.6 21.6-21.6s21.6 9.7 21.6 21.6v53.9c0 41.5-34 75.5-75.5 75.5zM480 178c-11.9 0-21.6-9.7-21.6-21.6V75.5c0-17.8-14.6-32.3-32.3-32.3h-62.8c-11.9 0-21.6-9.7-21.6-21.6s9.7-21.6 21.6-21.6h62.8c41.5 0 75.5 34 75.5 75.5v80.8c0 11.9-9.7 21.6-21.6 21.6z"
  ]
}, jae = {
  prefix: "fak",
  iconName: "icon-direkteinstickung",
  icon: [
    496,
    512,
    [],
    "e025",
    "M492.4 67.7c0-18.2-6.6-33-21.5-47.9S439.6 0 421.4 0c-33 1.7-57.8 29.7-59.5 31.4l-5 6.6c-19.8-9.9-62.8-26.4-112.3-18.2c-56.2 8.3-92.5 38-104.1 84.2c-6.6 21.5-11.6 77.6 56.2 135.4L3.6 483.9c-5 6.6-3.3 14.9 1.7 19.8c3.3 3.3 6.6 3.3 9.9 3.3s6.6-1.7 9.9-3.3l237.8-203.1c29.7 14.9 104.1 62.8 107.4 105.7c0 14.9-3.3 28.1-13.2 38c-21.5 19.8-64.4 29.7-120.6 26.4c-8.3 0-14.9 5-16.5 13.2s5 14.9 13.2 16.5c8.3 0 18.2 1.7 26.4 1.7c52.9 0 94.1-13.2 117.3-36.3c16.5-16.5 23.1-36.3 23.1-61.1c-3.3-57.8-82.6-107.4-112.3-123.9l150.3-128.8c5 16.5 3.3 36.3-3.3 54.5c-9.9 28.1-34.7 26.4-38 24.8c-8.3-1.7-14.9 5-16.5 13.2s5 14.9 13.2 16.5c1.7 0 5 0 8.3 0c18.2 0 47.9-8.3 62.8-44.6c11.6-29.7 9.9-59.5 0-85.9c3.3-6.6 26.4-31.4 28.1-62.8l0 0zM168.7 112.3C177 77.6 203.4 57.8 248 49.5c36.3-5 69.4 5 87.5 13.2L213.3 216.4c-52.9-46.2-49.5-87.5-44.6-104.1zM122.5 381.5l261-330.3s16.5-19.8 38-21.5c0 0 1.7 0 1.7 0c8.3 0 18.2 3.3 26.4 11.6s13.2 16.5 13.2 26.4c0 13.2-9.9 28.1-16.5 36.3c-5-6.6-9.9-13.2-16.5-18.2l1.7-3.3c6.6-6.6 5-14.9 0-21.5s-14.9-5-21.5 0l-28.1 28.1c-6.6 6.6-5 14.9 0 21.5c3.3 3.3 6.6 5 11.6 5s8.3-1.7 9.9-5l3.3-5c6.6 5 11.6 11.6 16.5 16.5L122.5 381.5z"
  ]
}, Nae = {
  prefix: "fak",
  iconName: "icon-pdf",
  icon: [
    443,
    512,
    [],
    "e01f",
    "M442.6 146.6L303 7c-4.7-4.7-9.3-7-14-7H70.2C30.7 0 .4 30.3 .4 69.8v370c0 37.2 30.3 69.8 69.8 69.8h309.5c37.2 0 69.8-30.3 69.8-69.8V160.6c-2.3-4.7-4.7-9.3-7-14zM309.9 72.1l67.5 69.8h-41.9c-14 0-25.6-11.6-25.6-25.6l0-44.2zm69.8 393.3H70.2c-14 0-27.9-11.6-27.9-27.9V69.8c0-14 11.6-27.9 27.9-27.9H268V114c0 37.2 30.3 67.5 67.5 69.8h69.8v256c0 14-11.6 25.6-25.6 25.6zm-256-211.8H77.2v132.7h25.6v-46.5h18.6c11.6 0 23.3-2.3 32.6-11.6c7-9.3 11.6-18.6 11.6-30.3s-4.7-23.3-11.6-32.6c-9.3-7-18.6-11.6-30.3-11.6zm11.6 58.2c-2.3 2.3-7 4.7-11.6 4.7H105.1v-41.9h18.6c4.7 0 9.3 2.3 11.6 7s4.7 9.3 4.7 16.3c0 4.7-2.3 11.6-4.7 14zm88.4-58.2H188.9v132.7h34.9c14 0 27.9-4.7 37.2-14c9.3-11.6 14-25.6 14-41.9v-20.9c0-14-4.7-30.3-14-39.6c-9.3-11.6-23.3-16.3-37.2-16.3zm25.6 79.1c0 9.3-2.3 16.3-4.7 23.3c-4.7 4.7-11.6 7-18.6 7h-9.3v-88.4h9.3c7 0 14 2.3 18.6 7c4.7 7 7 16.3 4.7 25.6l0 25.6zm51.2 53.5h25.6v-53.5h41.9v-23.3H326.2v-34.9h46.5v-23.3h-72.1v135z"
  ]
}, Vae = {
  prefix: "fak",
  iconName: "icon-expander-open",
  icon: [
    1024,
    512,
    [],
    "e010",
    "M507 502A46.1 46.1 0 0 1 476 490l-461-410A46.1 46.1 0 0 1 76.7 11.6L507 394 937 11.6A46.1 46.1 0 0 1 998 80.5l-461 410A46.1 46.1 0 0 1 507 502z"
  ]
}, Uae = {
  prefix: "fak",
  iconName: "icon-ciconfig-alert-check",
  icon: [
    512,
    512,
    [],
    "e019",
    "M256 0A256 256 0 1 0 256 512A256 256 0 1 0 256 0zM219 367c-5.55 0-11.1-2.35-15.1-6.19l-85.3-85.3c-8.32-8.32-8.32-21.8 0-30.1s21.8-8.32 30.1 0l69.3 69.3 144-162c7.89-8.75 21.3-9.6 30.1-1.71 8.75 7.89 9.6 21.3 1.71 30.1l-159 179c-3.84 4.48-9.39 7.04-15.4 7.25h-.64z"
  ]
};
const Fae = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  faCustomerLogos: Eae,
  faDownload: lae,
  faIconArrowCircleGreyLeft: Iae,
  faIconArrowCircleGreyRight: kae,
  faIconCiconfigAlertCheck: Uae,
  faIconCiconfigAlertWarning: _ae,
  faIconCiconfigArchive: Lae,
  faIconCiconfigAreaonoff: Dae,
  faIconCiconfigBarArrow: xae,
  faIconCiconfigBarCheck: Mae,
  faIconCiconfigItalic: uae,
  faIconCloseLarge: nae,
  faIconCloseMedium: bae,
  faIconCloseSmall: Rae,
  faIconDesignDatabase: hae,
  faIconDesignLogo: Joe,
  faIconDesignText: rae,
  faIconDirekteinstickung: jae,
  faIconEasytransfer: sae,
  faIconEdit: mae,
  faIconExpanderClos: tae,
  faIconExpanderOpen: Vae,
  faIconExpanderSmallClose: iae,
  faIconExpanderSmallOpen: zae,
  faIconInfo: Yoe,
  faIconPdf: Nae,
  faIconRemove: oae,
  faIconSave: yae,
  faIconSizeDefault: Tae,
  faIconSizeSmall: fae,
  faIconSizeStout: Aae,
  faIconSizeTall: Cae,
  faIconTextAlignment: Sae,
  faIconX: $ae,
  faIconZoomIn: vae,
  faIconZoomOut: Pae,
  faImage: wae,
  faImages: dae,
  faResize: pae,
  faSavedDesigns: Oae,
  faSize: cae,
  faSmake: gae,
  faTshirtColor: eae,
  faTshirtSize: Qoe,
  faUpload: aae
}, Symbol.toStringTag, { value: "Module" }));
S_.autoAddCss = !1;
A_.add(
  Fae,
  Foe,
  Goe,
  qoe,
  Coe,
  ed,
  Yu,
  Ioe,
  Moe,
  Hoe,
  Woe,
  Uoe,
  td,
  Voe,
  Koe,
  Xoe,
  Poe,
  Eoe,
  nd,
  Ooe,
  Roe,
  Toe,
  Doe,
  joe,
  Yu,
  nd,
  td,
  ed,
  Boe,
  Noe,
  Aoe
);
const Bae = tf(o9, {
  configureApp: (t) => {
    t.use(_f, {
      enableDevtoolsV6Plugin: !0
    }), t.use(ff());
    const e = qf({
      fallbackLocale: "en",
      legacy: !1,
      messages: { cs: dA, da: gM, de: $E, en: TL, fr: jN, hu: HF, it: JH, nl: aK, pl: pJ, sk: kte, sv: Soe }
    });
    t.use(e), t.provide(Hf, e), t.component("FontAwesomeIcon", is), t.use(Gb), my((n) => {
      console.debug("Endpoint Validation error", n);
    });
  },
  shadowRoot: !1
});
customElements.define("designer-strauss", Bae);
export {
  Rt as FeatureFlags
};
//# sourceMappingURL=index.js.map
